(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["rpBetslip"] = factory();
	else
		root["rpBetslip"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/betslip-ui/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 694);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(388);
} else {
  module.exports = require('./cjs/react.development.js');
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(360)();
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
	return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(236)) === 'object' && __webpack_require__(236)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _splice = __webpack_require__(452);

var _splice2 = _interopRequireDefault(_splice);

var _getIn = __webpack_require__(449);

var _getIn2 = _interopRequireDefault(_getIn);

var _setIn = __webpack_require__(451);

var _setIn2 = _interopRequireDefault(_setIn);

var _deepEqual = __webpack_require__(447);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _deleteIn = __webpack_require__(448);

var _deleteIn2 = _interopRequireDefault(_deleteIn);

var _keys = __webpack_require__(450);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: _getIn2.default,
  setIn: _setIn2.default,
  deepEqual: _deepEqual2.default,
  deleteIn: _deleteIn2.default,
  fromJS: function fromJS(value) {
    return value;
  },
  keys: _keys2.default,
  size: function size(array) {
    return array ? array.length : 0;
  },
  splice: _splice2.default,
  toJS: function toJS(value) {
    return value;
  }
};

exports.default = structure;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;

var _Provider = __webpack_require__(364);

var _Provider2 = _interopRequireDefault(_Provider);

var _connectAdvanced = __webpack_require__(166);

var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);

var _connect = __webpack_require__(365);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Provider = _Provider2.default;
exports.createProvider = _Provider.createProvider;
exports.connectAdvanced = _connectAdvanced2.default;
exports.connect = _connect2.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.constants = exports.selectors = exports.actions = exports.reducer = undefined;

var _bookmakersList = __webpack_require__(508);

var _bookmakersList2 = _interopRequireDefault(_bookmakersList);

var _bookmakersList3 = __webpack_require__(56);

var actions = _interopRequireWildcard(_bookmakersList3);

var _bookmakersList4 = __webpack_require__(509);

var selectors = _interopRequireWildcard(_bookmakersList4);

var _bookmakersList5 = __webpack_require__(123);

var constants = _interopRequireWildcard(_bookmakersList5);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _bookmakersList2.default;
exports.actions = actions;
exports.selectors = selectors;
exports.constants = constants;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectors = exports.actions = exports.reducer = undefined;

var _bookmakersInfo = __webpack_require__(205);

var _bookmakersInfo2 = _interopRequireDefault(_bookmakersInfo);

var _bookmakersInfo3 = __webpack_require__(33);

var actions = _interopRequireWildcard(_bookmakersInfo3);

var _bookmakersInfo4 = __webpack_require__(206);

var selectors = _interopRequireWildcard(_bookmakersInfo4);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _bookmakersInfo2.default;
exports.actions = actions;
exports.selectors = selectors;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SvgIcon = __webpack_require__(624);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SvgIcon).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;

var _BrowserRouter2 = __webpack_require__(373);

var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);

var _HashRouter2 = __webpack_require__(374);

var _HashRouter3 = _interopRequireDefault(_HashRouter2);

var _Link2 = __webpack_require__(170);

var _Link3 = _interopRequireDefault(_Link2);

var _MemoryRouter2 = __webpack_require__(375);

var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);

var _NavLink2 = __webpack_require__(376);

var _NavLink3 = _interopRequireDefault(_NavLink2);

var _Prompt2 = __webpack_require__(377);

var _Prompt3 = _interopRequireDefault(_Prompt2);

var _Redirect2 = __webpack_require__(378);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(171);

var _Route3 = _interopRequireDefault(_Route2);

var _Router2 = __webpack_require__(113);

var _Router3 = _interopRequireDefault(_Router2);

var _StaticRouter2 = __webpack_require__(379);

var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);

var _Switch2 = __webpack_require__(380);

var _Switch3 = _interopRequireDefault(_Switch2);

var _generatePath2 = __webpack_require__(381);

var _generatePath3 = _interopRequireDefault(_generatePath2);

var _matchPath2 = __webpack_require__(382);

var _matchPath3 = _interopRequireDefault(_matchPath2);

var _withRouter2 = __webpack_require__(383);

var _withRouter3 = _interopRequireDefault(_withRouter2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.BrowserRouter = _BrowserRouter3.default;
exports.HashRouter = _HashRouter3.default;
exports.Link = _Link3.default;
exports.MemoryRouter = _MemoryRouter3.default;
exports.NavLink = _NavLink3.default;
exports.Prompt = _Prompt3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;
exports.Router = _Router3.default;
exports.StaticRouter = _StaticRouter3.default;
exports.Switch = _Switch3.default;
exports.generatePath = _generatePath3.default;
exports.matchPath = _matchPath3.default;
exports.withRouter = _withRouter3.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Line = function Line(_ref) {
    var children = _ref.children,
        className = _ref.className;
    return _jsx('span', {
        className: (0, _classnames2.default)('bs-gamblingCompliance__line', _defineProperty({}, className, className !== null))
    }, void 0, children);
};

Line.defaultProps = {
    className: null
};

exports.default = Line;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectors = exports.default = undefined;

var _UserInfo = __webpack_require__(629);

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _userInfo = __webpack_require__(532);

var selectors = _interopRequireWildcard(_userInfo);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _UserInfo2.default;
exports.selectors = selectors;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bet365 = exports.bet365 = {
    rules: 'https://help.bet365.com/en/rules',
    termsAndConditions: 'https://help.bet365.com/en/terms-and-conditions'
};

var coral = exports.coral = {
    termsAndConditions: 'https://coral-eng.custhelp.com/app/answers/detail/a_id/2130',
    responsibleGambling: 'http://responsiblegambling.coral.co.uk/',
    licenseUK: 'https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/39071',
    licenseGI: 'https://www.gibraltar.gov.gi/new/remote-gambling',
    tscs: 'https://help.coral.co.uk/en/general-information/' + 'legal-matters/terms-and-conditions',
    website: 'https://coral.co.uk',
    gamblingCommission: 'https://www.gamblingcommission.gov.uk/public-register/' + 'business/detail/54743',
    gibraltar: 'https://www.gibraltar.gov.gi/finance-gaming-and-regulations/remote-gambling'
};

var williamhill = exports.williamhill = {
    rules: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2063',
    license: 'https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/39225',
    responsibleGambling: 'https://williamhill-lang.custhelp.com/app/answers/' + 'detail/a_id/2733/kw/responsible%20gambling',
    underage: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2960'
};

var ladbrokes = exports.ladbrokes = {
    rules: 'http://helpcentre.ladbrokes.com/app/answers/detail/a_id/283',
    licenseUK: 'https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/1611',
    licenseGI: 'https://www.gibraltar.gov.gi/new/remote-gambling',
    underage: 'http://media.ladbrokes.com/generic/images/siteImages/footerIcons_various/18.gif',
    tscs: 'https://help.ladbrokes.com/en/general-information/' + 'legal-matters/terms-and-conditions',
    website: 'https://Ladbrokes.com',
    gamblingCommission: 'https://www.gamblingcommission.gov.uk/public-register/' + 'business/detail/54743',
    gibraltar: 'https://www.gibraltar.gov.gi/finance-gaming-and-regulations/remote-gambling'
};

var paddypower = exports.paddypower = {
    mga: 'https://www.authorisation.mga.org.mt/verification.aspx?' + 'lang=en&company=4f2ce9bc-6584-440c-8643-9314defffd0e',
    gamCommission: 'http://www.gamblingcommission.gov.uk/',
    gamingAuthority: 'https://www.mga.org.mt/',
    license: 'https://www.paddypower.com/aboutUs/Regulatory.Information/',
    gamingCommission: 'https://secure.gamblingcommission.gov.uk/' + 'PublicRegister/Search/Detail/39439',
    terms: 'https://www.paddypower.com/en/aboutUs/Terms.and.Conditions/',
    responsibleGambling: 'http://responsiblegaming.paddypower.com/',
    underage: 'https://support.paddypower.com/app/answers/detail/a_id/70'
};

var betfair = exports.betfair = {
    mga: 'https://www.authorisation.mga.org.mt/verification.aspx?' + 'lang=en&company=4f2ce9bc-6584-440c-8643-9314defffd0e',
    gamCommission: 'http://www.gamblingcommission.gov.uk/',
    gamingAuthority: 'https://www.mga.org.mt/',
    license: 'https://www.betfair.com/aboutUs/Regulatory.Information/',
    gamingCommission: 'https://secure.gamblingcommission.gov.uk/' + 'PublicRegister/Search/Detail/39439',
    terms: 'https://www.betfair.com/en/aboutUs/Terms.and.Conditions/',
    responsibleGambling: 'http://responsiblegaming.betfair.com/',
    underage: 'http://content.betfair.com/misc/?product=portal&sWhichKey=gamCare&' + 'locale=en_GB&region=GBR&brand=betfair&entrydomain=betfair.com'
};

var common = exports.common = {
    gamaware: 'https://www.begambleaware.org/',
    gamcare: 'http://www.gamcare.org.uk/',
    gamtherapy: 'https://www.gamblingtherapy.org/',
    gamstop: 'https://www.gamstop.co.uk/',
    funstops: 'http://www.whenthefunstops.co.uk/',
    ibas: 'https://www.ibas-uk.com/',
    raig: 'https://www.raig.org/'
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var bind = __webpack_require__(139);
var isBuffer = __webpack_require__(259);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectors = exports.default = undefined;

var _TransitionRouter = __webpack_require__(628);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_TransitionRouter).default;
    }
});

var _transitionRouter = __webpack_require__(218);

var selectors = _interopRequireWildcard(_transitionRouter);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.selectors = selectors;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(_ref) {
    var text = _ref.text,
        href = _ref.href,
        className = _ref.className;
    return _jsx('a', {
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: (0, _classnames2.default)('bs-gamblingCompliance__link', className)
    }, void 0, text);
};

Link.defaultProps = {
    className: null
};

exports.default = Link;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _freeGlobal = __webpack_require__(151);

var _freeGlobal2 = _interopRequireDefault(_freeGlobal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal2.default || freeSelf || Function('return this')();

exports.default = root;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

exports.default = isArray;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectors = exports.actions = exports.reducer = undefined;

var _bet = __webpack_require__(504);

var _bet2 = _interopRequireDefault(_bet);

var _bet3 = __webpack_require__(203);

var actions = _interopRequireWildcard(_bet3);

var _bet4 = __webpack_require__(204);

var selectors = _interopRequireWildcard(_bet4);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _bet2.default;
exports.actions = actions;
exports.selectors = selectors;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _apiTransformers = __webpack_require__(533);

var _apiErrors = __webpack_require__(22);

var _localStorage = __webpack_require__(62);

var _cookie = __webpack_require__(23);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var API_VERSIONS = {
    ONE: '1.0',
    THREE: '3.0'
};

var TEMPLATES = {
    BET_HISTORY: 'bet-history/%bookie%',
    EXTERNAL_BET_HISTORY: 'bet-history/%bookie%',
    EXTERNAL_ACCOUNT: 'deposit/%bookie%',
    CUSTOMER_STATUS: 'customer-status',
    USER_INFO: 'customer/%bookie%',
    LOGIN: 'log-in/%bookie%',
    LOGOUT: 'log-in/%bookie%',
    EXTERNAL_LOGOUT: 'log-out/%bookie%',
    AUTH_INFO: 'log-in/%bookie%',
    APP_CONFIG: 'api/stubs/bookmaker-offers-tier-one/',
    TOP_UP: 'deposit/%bookie%',
    CARD_DETAILS: 'deposit/%bookie%',
    PLACE_BET: 'bets/%bookie%',
    BUILD_BETS: 'bet-selections/%bookie%',
    BUILD_MULTIPLES: 'bet-selections/%bookie%' // Should be swapped out for speculation endpoint
};

var getRequestConfig = function getRequestConfig() {
    var config = {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Client-Id': 'web'
        }
    };

    switch ((0, _localStorage.isLocalStorageAvailable)()) {
        case true:
            if (window.localStorage.getItem('auth-token')) {
                config.headers['auth-token'] = window.localStorage.getItem('auth-token');
            }
            break;
        case false:
            if ((0, _cookie.getCookie)('auth-token')) {
                config.headers['auth-token'] = (0, _cookie.getCookie)('auth-token');
            }
            break;

        // no default
    }

    return config;
};

/**
 * Configure API hosts based on document attributes and location
 *
 * NOTE: Contains fallbacks:
 * - V1 will fallback to ''
 * - V3 will fallback to `https://betslip-api.racingpost.com/v3`
 *
 * Normally both API attributes are required, but in tests they are often undefined.
 *
 * @return {Object} { v1: 'example.com/api', v3: 'example.com/api/v3/' }
 */
var getApiUrls = function getApiUrls() {
    var API_V1_ATTR = document.querySelector('[data-betslip-api-url]');
    var API_V1_FALLBACK = '';
    var apiV1Url = API_V1_ATTR ? API_V1_ATTR.getAttribute('data-betslip-api-url') : API_V1_FALLBACK;
    var apiV3Url = void 0;
    var bookmakerStubsData = 'https://' + window.location.hostname;

    if (window.location.hostname.indexOf('dev.racingpost') !== -1) {
        apiV3Url = 'https://uat-betslip-api.racingpost.com/v3';
    } else if (window.location.hostname.indexOf('test1.racingpost') !== -1) {
        apiV3Url = 'https://uat-betslip-api.racingpost.com/v3';
    } else if (window.location.hostname.indexOf('uat.racingpost') !== -1) {
        apiV3Url = 'https://uat-betslip-api.racingpost.com/v3';
    } else {
        apiV3Url = 'https://betslip-api.racingpost.com/v3';
    }

    return {
        v1: apiV1Url,
        v3: apiV3Url,
        bookmakersData: bookmakerStubsData
    };
};

var generateBookieEndpoint = function generateBookieEndpoint(apiVersion, template, bookie) {
    var API_URLS = getApiUrls();
    var host = void 0;
    switch (apiVersion) {
        case API_VERSIONS.ONE:
            host = API_URLS.v1;
            break;
        case API_VERSIONS.THREE:
            host = API_URLS.v3;
            break;
        default:
            host = API_URLS.v3;
    }
    var path = template.replace('%bookie%', bookie);

    return host + '/' + path;
};

var autoLogout = function autoLogout(error, dispatch, onUnauthorized) {
    if ((0, _apiErrors.isUnauthorized)(error)) {
        dispatch(onUnauthorized);
    }

    return Promise.reject(error);
};

// Requests

var loadAppConfig = function loadAppConfig() {
    var API_URLS = getApiUrls();
    var endpoint = API_URLS.bookmakersData + '/' + TEMPLATES.APP_CONFIG;

    return _axios2.default.get(endpoint);
};

var login = function login(bookie, body) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.LOGIN, bookie);

    return _axios2.default.post(endpoint, body, getRequestConfig());
};

var logout = function logout(bookie) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.LOGOUT, bookie);

    return _axios2.default.delete(endpoint, getRequestConfig());
};

var externalLogout = function externalLogout(bookie) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.EXTERNAL_LOGOUT, bookie);

    return _axios2.default.get(endpoint, getRequestConfig());
};

var loadBookmakerLoginInfo = function loadBookmakerLoginInfo(bookie) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.AUTH_INFO, bookie);

    return _axios2.default.get(endpoint, getRequestConfig());
};

var getExternalAccountUrl = function getExternalAccountUrl(bookie) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.EXTERNAL_ACCOUNT, bookie);

    return _axios2.default.get(endpoint, getRequestConfig());
};

var getBetHistory = function getBetHistory(bookie, requestParams) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.BET_HISTORY, bookie);
    var config = getRequestConfig();

    return _axios2.default.get(endpoint, _extends({}, config, {
        params: requestParams
    }));
};

var getExternalBetHistoryUrl = function getExternalBetHistoryUrl(bookie) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.EXTERNAL_BET_HISTORY, bookie);

    return _axios2.default.get(endpoint, getRequestConfig());
};

var getUserInfo = function getUserInfo(bookie) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.USER_INFO, bookie);

    return _axios2.default.get(endpoint, getRequestConfig());
};

var getCustomerStatus = function getCustomerStatus() {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.CUSTOMER_STATUS);

    return _axios2.default.get(endpoint, getRequestConfig());
};

var getCardDetails = function getCardDetails(bookie) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.CARD_DETAILS, bookie);

    return _axios2.default.get(endpoint, getRequestConfig());
};

var topUp = function topUp(bookie, body) {
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.TOP_UP, bookie);

    return _axios2.default.post(endpoint, body, getRequestConfig());
};

var buildBetsSource = _axios.CancelToken.source();

var buildBets = function buildBets(bookie, selectedBets, dispatch, onUnauthorized) {
    var body = (0, _apiTransformers.createBuildBetRequest)(selectedBets);
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.BUILD_BETS, bookie);
    var config = getRequestConfig();

    buildBetsSource.cancel();
    buildBetsSource = _axios.CancelToken.source();

    return _axios2.default.post(endpoint, body, _extends({}, config, {
        cancelToken: buildBetsSource.token
    })).then(function (response) {
        return Promise.resolve(response);
    }).catch(function (error) {
        if (_axios2.default.isCancel(error) === false) {
            return autoLogout(error, dispatch, onUnauthorized);
        }
        return Promise.reject(error);
    });
};

var buildMultiplesSource = _axios.CancelToken.source();

var buildMultiples = function buildMultiples(bookie, selectedBets, dispatch, onUnauthorized) {
    var body = (0, _apiTransformers.createBuildBetRequest)(selectedBets);
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.BUILD_MULTIPLES, bookie);
    var config = getRequestConfig();

    buildMultiplesSource.cancel();
    buildMultiplesSource = _axios.CancelToken.source();

    return _axios2.default.post(endpoint, body, _extends({}, config, {
        cancelToken: buildMultiplesSource.token
    })).then(function (response) {
        return Promise.resolve(response);
    }).catch(function (error) {
        if (_axios2.default.isCancel(error) === false) {
            return autoLogout(error, dispatch, onUnauthorized);
        }
        return Promise.reject(error);
    });
};

var cancelBuildMultiples = function cancelBuildMultiples() {
    buildMultiplesSource.cancel();
};

var placeBet = function placeBet(bookie, selectedBets, stakedMultiples, selectedFreeBetId, dispatch, onUnauthorized) {
    var body = (0, _apiTransformers.createPlaceBetRequest)(selectedBets, stakedMultiples, selectedFreeBetId);
    var endpoint = generateBookieEndpoint(API_VERSIONS.THREE, TEMPLATES.PLACE_BET, bookie);

    return _axios2.default.post(endpoint, body, getRequestConfig()).then(function (response) {
        return Promise.resolve(response);
    }).catch(function (error) {
        return autoLogout(error, dispatch, onUnauthorized);
    });
};

var ApiClient = {
    // API V1
    loadAppConfig: loadAppConfig,
    login: login,
    logout: logout,
    externalLogout: externalLogout,
    loadBookmakerLoginInfo: loadBookmakerLoginInfo,
    getExternalAccountUrl: getExternalAccountUrl,
    getBetHistory: getBetHistory,
    getExternalBetHistoryUrl: getExternalBetHistoryUrl,
    getCustomerStatus: getCustomerStatus,
    getUserInfo: getUserInfo,
    getCardDetails: getCardDetails,
    topUp: topUp,

    // API Betting
    buildBets: buildBets,
    buildMultiples: buildMultiples,
    cancelBuildMultiples: cancelBuildMultiples,
    placeBet: placeBet,

    // Other
    getApiUrls: getApiUrls
};

exports.default = ApiClient;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// 5XX
var isFatal = function isFatal(status) {
    return !!status.toString().match(/5(\d{2})/);
};

var isUnauthorized = exports.isUnauthorized = function isUnauthorized(error) {
    return error.response && error.response.status === 401;
};

var isUnknownError = exports.isUnknownError = function isUnknownError(error) {
    return !error || !error.response || error.response && isFatal(error.response.status);
};

// NOTE: We only store "handled" errors here, which consists of
// 400 Bad Request responses. For 5XX errors, unknown errors are thrown.
var ERROR_CODES = exports.ERROR_CODES = {
    // Generic errors
    VALIDATION_ERROR: 'validation-error',
    INVALID_SELECTION: 'invalid-selection',
    LIVE_PRICE_UNAVAILABLE: 'live-price-unavailable',
    INVALID_FREE_BET: 'invalid-free-bet',
    BOG_UNAVAILABLE: 'best-odds-guaranteed-unavailable',

    // Bet-specific errors
    BETTING_SUSPENDED: 'betting-suspended',
    PRICE_CHANGED: 'price-changed',
    STAKE_TOO_LOW: 'stake-too-low',
    STAKE_TOO_HIGH: 'stake-too-high',
    STARTING_PRICE_UNAVAILABLE: 'start-price-unavailable',

    // Other errors
    INSUFFICIENT_FUNDS: 'insufficient-funds'

    // Note that generic error messages live with the globalModal
};var ERROR_MESSAGES = exports.ERROR_MESSAGES = {
    INSUFFICIENT_FUNDS: 'You have insufficient funds',

    // Bet-specific errors
    BETTING_SUSPENDED: 'Betting is suspended on this event',
    PRICE_CHANGED: 'Price has changed from %OLD% to %NEW%',
    PRICE_CHANGED_SP: 'Live odds now available',
    STAKE_TOO_LOW: 'The minimum stake for this bet is %PRICE%',
    STAKE_TOO_HIGH: 'The maximum stake for this bet is %PRICE%'
};

var isGenericError = exports.isGenericError = function isGenericError(body) {
    if (!body.errors || body.errors.length === 0) {
        return true;
    }

    return body.errors.some(function (error) {
        return error.code === ERROR_CODES.VALIDATION_ERROR || error.code === ERROR_CODES.INVALID_SELECTION || error.code === ERROR_CODES.LIVE_PRICE_UNAVAILABLE || error.code === ERROR_CODES.INVALID_FREE_BET || error.code === ERROR_CODES.BOG_UNAVAILABLE;
    });
};

var isBogUnavailable = exports.isBogUnavailable = function isBogUnavailable(body) {
    if (!body.errors || body.errors.length === 0) {
        return false;
    }

    return body.errors.some(function (error) {
        return error.code === ERROR_CODES.BOG_UNAVAILABLE;
    });
};

// Reorders errors to put suspended errors last - avoids conflict issues
var getErrorsToFire = exports.getErrorsToFire = function getErrorsToFire(errors) {
    var nonSuspendedErrors = errors.filter(function (error) {
        return error.code !== ERROR_CODES.BETTING_SUSPENDED;
    });
    var suspendedErrors = errors.filter(function (error) {
        return error.code === ERROR_CODES.BETTING_SUSPENDED;
    });

    return nonSuspendedErrors.concat(suspendedErrors);
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.deleteCookie = deleteCookie;
function getCookie(key) {
    if (!key) {
        return null;
    }
    var escapedKey = encodeURIComponent(key).replace(/[-.+*]/g, '\\$&');
    var value = document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + escapedKey + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1');
    return decodeURIComponent(value);
}

function setCookie(cookie) {
    document.cookie = cookie;
}

function deleteCookie(key, domain) {
    document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=' + domain + '; path=/;';
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCurrentDate = exports.getCurrentDate = function getCurrentDate() {
  return new Date();
};

var getCurrentTime = exports.getCurrentTime = function getCurrentTime() {
  return getCurrentDate().getTime();
};

var getCurrentYear = exports.getCurrentYear = function getCurrentYear() {
  return getCurrentDate().getFullYear();
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'undefined' ? 'undefined' : _typeof(dep);
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if ((typeof selectors === 'undefined' ? 'undefined' : _typeof(selectors)) !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + (typeof selectors === 'undefined' ? 'undefined' : _typeof(selectors))));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Note that the _value_ of a price can also be 'SP', but here
// we are defining the price _type_.
var PRICE_TYPES = {
    SP: 'SP',
    ODDS: 'Odds'
};

exports.default = PRICE_TYPES;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

exports.default = isObject;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;

var _createStore = __webpack_require__(193);

var _createStore2 = _interopRequireDefault(_createStore);

var _combineReducers = __webpack_require__(469);

var _combineReducers2 = _interopRequireDefault(_combineReducers);

var _bindActionCreators = __webpack_require__(468);

var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);

var _applyMiddleware = __webpack_require__(467);

var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);

var _compose = __webpack_require__(192);

var _compose2 = _interopRequireDefault(_compose);

var _warning = __webpack_require__(194);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  (0, _warning2.default)('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}

exports.createStore = _createStore2.default;
exports.combineReducers = _combineReducers2.default;
exports.bindActionCreators = _bindActionCreators2.default;
exports.applyMiddleware = _applyMiddleware2.default;
exports.compose = _compose2.default;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reducer = exports.actions = undefined;

var _modals = __webpack_require__(226);

var actions = _interopRequireWildcard(_modals);

var _modals2 = __webpack_require__(555);

var _modals3 = _interopRequireDefault(_modals2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

exports.actions = actions;
exports.reducer = _modals3.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIsNative = __webpack_require__(279);

var _baseIsNative2 = _interopRequireDefault(_baseIsNative);

var _getValue = __webpack_require__(310);

var _getValue2 = _interopRequireDefault(_getValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = (0, _getValue2.default)(object, key);
  return (0, _baseIsNative2.default)(value) ? value : undefined;
}

exports.default = getNative;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

exports.default = isObjectLike;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEY_PREFIX = exports.KEY_PREFIX = 'persist:';
var FLUSH = exports.FLUSH = 'persist/FLUSH';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';
var PAUSE = exports.PAUSE = 'persist/PAUSE';
var PERSIST = exports.PERSIST = 'persist/PERSIST';
var PURGE = exports.PURGE = 'persist/PURGE';
var REGISTER = exports.REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = exports.DEFAULT_VERSION = -1;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectBookmaker = exports.clearAllMultiplesErrors = exports.clearMultiplesError = exports.setMultiplesError = exports.clearGenericError = exports.setGenericErrorOnBuild = exports.setGenericError = exports.clearAllErrors = exports.clearError = exports.setErrorOnBuild = exports.setError = exports.setBookmakersOrder = exports.removeUsername = exports.saveUsername = exports.toggleBalanceVisibility = exports.setSelectedBookmaker = exports.changeSelectionOrder = exports.cancelBuildMultiples = exports.buildMultiples = exports.buildBets = exports.restoreMultiplesEachWay = exports.restoreMultiplesStakes = exports.saveMultiplesEachWay = exports.saveMultiplesStakes = exports.removeAllBets = exports.setIsEditingStakeForMultiple = exports.setIsEachWayForMultiple = exports.setStakeForMultiple = exports.clearMultiples = exports.toggleMultiplesInclusion = exports.buildMultiplesRequest = exports.clearLockedStake = exports.setLockedStake = exports.setFreeBetMaximumStake = exports.setFreeBetMinimumStake = exports.setMaximumStake = exports.setMinimumStake = exports.clearUnusedBets = exports.setUnusedBets = exports.updateAllStartingPricesAvailability = exports.updateAllBetPrices = exports.updateBetPrice = exports.setAssociatedPriceChangeOnBuild = exports.setAssociatedPriceChange = exports.clearSuspendedBets = exports.setSuspendedBetOnBuild = exports.setSuspendedBet = exports.setPriceTypeForSelectedBet = exports.setIsEditingStake = exports.setIsEachWayForSelectedBet = exports.setStakeForSelectedBet = exports.deleteBet = exports.clearSelectedBets = exports.addSelectedBet = exports.buildBetRequest = exports.actionTypes = undefined;

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _modals = __webpack_require__(29);

var _login = __webpack_require__(47);

var _bet = __webpack_require__(20);

var _currentDate = __webpack_require__(24);

var _drawer = __webpack_require__(38);

var _freeBets = __webpack_require__(35);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _apiErrors = __webpack_require__(22);

var _updateAuthToken = __webpack_require__(49);

var _updateAuthToken2 = _interopRequireDefault(_updateAuthToken);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var MILISECONDS_IN_DAY = 86400000;

var actionTypes = exports.actionTypes = {
    SET_SELECTED_BOOKMAKER: 'SET_SELECTED_BOOKMAKER',
    SET_BOOKMAKERS_ORDER: 'SET_BOOKMAKERS_ORDER',
    ADD_SELECTED_BET: 'ADD_SELECTED_BET',
    CLEAR_SELECTED_BETS: 'CLEAR_SELECTED_BETS',
    DELETE_BET: 'DELETE_BET',
    SET_STAKE_FOR_SELECTED_BET: 'SET_STAKE_FOR_SELECTED_BET',
    SET_ISEACHWAY_FOR_SELECTED_BET: 'SET_ISEACHWAY_FOR_SELECTED_BET',
    SET_PRICE_TYPE_FOR_SELECTED_BET: 'SET_PRICE_TYPE_FOR_SELECTED_BET',
    TOGGLE_BALANCE_VISIBILITY: 'TOGGLE_BALANCE_VISIBILITY',
    SAVE_USERNAME: 'SAVE_USERNAME',
    REMOVE_USERNAME: 'REMOVE_USERNAME',
    SET_IS_EDITING_STAKE: 'SET_IS_EDITING_STAKE',
    SET_MINIMUM_STAKE: 'SET_MINIMUM_STAKE',
    SET_MAXIMUM_STAKE: 'SET_MAXIMUM_STAKE',
    SET_LOCKED_STAKE: 'SET_LOCKED_STAKE',
    CLEAR_LOCKED_STAKE: 'CLEAR_LOCKED_STAKE',

    // Build Bets
    BUILD_BET_REQUEST: 'BUILD_BET_REQUEST',
    ASSOCIATE_SINGLES: 'ASSOCIATE_SINGLES',

    // Multiples
    BUILD_MULTIPLES_REQUEST: 'BUILD_MULTIPLES_REQUEST',
    SET_MULTIPLES: 'SET_MULTIPLES',
    CLEAR_MULTIPLES: 'CLEAR_MULTIPLES',
    SET_STAKE_FOR_MULTIPLE: 'SET_STAKE_FOR_MULTIPLE',
    SET_IS_EACHWAY_FOR_MULTIPLE: 'SET_IS_EACHWAY_FOR_MULTIPLE',
    SET_IS_EDITING_STAKE_FOR_MULTIPLE: 'SET_IS_EDITING_STAKE_FOR_MULTIPLE',
    TOGGLE_MULTIPLES_INCLUSION: 'TOGGLE_MULTIPLES_INCLUSION',
    SET_MULTIPLES_ERROR: 'SET_MULTIPLES_ERROR',
    CLEAR_MULTIPLES_ERROR: 'CLEAR_MULTIPLES_ERROR',
    CLEAR_ALL_MULTIPLES_ERRORS: 'CLEAR_ALL_MULTIPLES_ERRORS',
    SAVE_MULTIPLES_STAKES: 'SAVE_MULTIPLES_STAKES',
    SAVE_MULTIPLES_EACHWAY: 'SAVE_MULTIPLES_EACHWAY',
    RESTORE_MULTIPLES_STAKES: 'RESTORE_MULTIPLES_STAKES',
    RESTORE_MULTIPLES_EACHWAY: 'RESTORE_MULTIPLES_EACHWAY',
    CHANGE_SELECTION_ORDER: 'CHANGE_SELECTION_ORDER',

    // Errors
    SET_ERROR: 'SET_ERROR',
    SET_ERROR_ON_BUILD: 'SET_ERROR_ON_BUILD',
    CLEAR_ERROR: 'CLEAR_ERROR',
    CLEAR_ALL_ERRORS: 'CLEAR_ALL_ERRORS',
    SET_SUSPENDED_BET: 'SET_SUSPENDED_BET',
    SET_SUSPENDED_BET_ON_BUILD: 'SET_SUSPENDED_BET_ON_BUILD',
    CLEAR_SUSPENDED_BETS: 'CLEAR_SUSPENDED_BETS',
    SET_PRICE_CHANGED: 'SET_PRICE_CHANGED',
    SET_PRICE_CHANGED_ON_BUILD: 'SET_PRICE_CHANGED_ON_BUILD',
    UPDATE_ALL_BET_PRICES: 'UPDATE_ALL_BET_PRICES',
    UPDATE_BET_PRICE: 'UPDATE_BET_PRICE',
    SET_GENERIC_ERROR: 'SET_GENERIC_ERROR',
    SET_GENERIC_ERROR_ON_BUILD: 'SET_GENERIC_ERROR_ON_BUILD',
    CLEAR_GENERIC_ERROR: 'CLEAR_GENERIC_ERROR',
    UPDATE_ALL_STARTING_PRICES_AVAILABILITY: 'UPDATE_ALL_STARTING_PRICES_AVAILABILITY',

    // Un-used Bets (Re-use Selection feature)
    SET_UNUSED_BETS: 'SET_UNUSED_BETS',
    CLEAR_UNUSED_BETS: 'CLEAR_UNUSED_BETS',

    // Free bets
    SET_FREE_BET_MINIMUM_STAKE: 'SET_FREE_BET_MINIMUM_STAKE',
    SET_FREE_BET_MAXIMUM_STAKE: 'SET_FREE_BET_MAXIMUM_STAKE'
};

// Singles...
// ------------------------------------------------
var buildBetRequest = exports.buildBetRequest = function buildBetRequest(isBuildingBet) {
    return {
        type: actionTypes.BUILD_BET_REQUEST,
        isBuildingBet: isBuildingBet
    };
};

var addSelectedBet = exports.addSelectedBet = function addSelectedBet(betInfo) {
    return {
        type: actionTypes.ADD_SELECTED_BET,
        betInfo: betInfo
    };
};

var clearSelectedBets = exports.clearSelectedBets = function clearSelectedBets() {
    return {
        type: actionTypes.CLEAR_SELECTED_BETS
    };
};

var deleteBet = exports.deleteBet = function deleteBet(outcomersId) {
    return {
        type: actionTypes.DELETE_BET,
        outcomersId: outcomersId
    };
};

var setStakeForSelectedBet = exports.setStakeForSelectedBet = function setStakeForSelectedBet(outcomersId, stake) {
    return {
        type: actionTypes.SET_STAKE_FOR_SELECTED_BET,
        outcomersId: outcomersId,
        stake: stake
    };
};

var setIsEachWayForSelectedBet = exports.setIsEachWayForSelectedBet = function setIsEachWayForSelectedBet(outcomersId, isEachWay) {
    return {
        type: actionTypes.SET_ISEACHWAY_FOR_SELECTED_BET,
        outcomersId: outcomersId,
        isEachWay: isEachWay
    };
};

var setIsEditingStake = exports.setIsEditingStake = function setIsEditingStake(outcomersId, isEditingStake) {
    return {
        type: actionTypes.SET_IS_EDITING_STAKE,
        outcomersId: outcomersId,
        isEditingStake: isEditingStake
    };
};

var setPriceTypeForSelectedBet = exports.setPriceTypeForSelectedBet = function setPriceTypeForSelectedBet(outcomersId, priceType) {
    return {
        type: actionTypes.SET_PRICE_TYPE_FOR_SELECTED_BET,
        outcomersId: outcomersId,
        priceType: priceType
    };
};

var setSuspendedBet = exports.setSuspendedBet = function setSuspendedBet(outcomersId, isSuspended) {
    return {
        type: actionTypes.SET_SUSPENDED_BET,
        outcomersId: outcomersId,
        isSuspended: isSuspended
    };
};

var setSuspendedBetOnBuild = exports.setSuspendedBetOnBuild = function setSuspendedBetOnBuild(outcomersId, isSuspended) {
    return {
        type: actionTypes.SET_SUSPENDED_BET_ON_BUILD,
        outcomersId: outcomersId,
        isSuspended: isSuspended
    };
};

var clearSuspendedBets = exports.clearSuspendedBets = function clearSuspendedBets() {
    return {
        type: actionTypes.CLEAR_SUSPENDED_BETS
    };
};

var setAssociatedPriceChange = exports.setAssociatedPriceChange = function setAssociatedPriceChange(outcomersId, fractionalPrice, decimalPrice) {
    return {
        type: actionTypes.SET_PRICE_CHANGED,
        outcomersId: outcomersId,
        fractionalPrice: fractionalPrice,
        decimalPrice: decimalPrice
    };
};

var setAssociatedPriceChangeOnBuild = exports.setAssociatedPriceChangeOnBuild = function setAssociatedPriceChangeOnBuild(outcomersId, fractionalPrice, decimalPrice) {
    return {
        type: actionTypes.SET_PRICE_CHANGED_ON_BUILD,
        outcomersId: outcomersId,
        fractionalPrice: fractionalPrice,
        decimalPrice: decimalPrice
    };
};

var updateBetPrice = exports.updateBetPrice = function updateBetPrice(outcomersId, fractionalPrice, decimalPrice) {
    return {
        type: actionTypes.UPDATE_BET_PRICE,
        outcomersId: outcomersId,
        fractionalPrice: fractionalPrice,
        decimalPrice: decimalPrice
    };
};

var updateAllBetPrices = exports.updateAllBetPrices = function updateAllBetPrices() {
    return {
        type: actionTypes.UPDATE_ALL_BET_PRICES
    };
};

var updateAllStartingPricesAvailability = exports.updateAllStartingPricesAvailability = function updateAllStartingPricesAvailability() {
    return {
        type: actionTypes.UPDATE_ALL_STARTING_PRICES_AVAILABILITY
    };
};

var setUnusedBets = exports.setUnusedBets = function setUnusedBets(unusedBets) {
    return {
        type: actionTypes.SET_UNUSED_BETS,
        unusedBets: unusedBets
    };
};

var clearUnusedBets = exports.clearUnusedBets = function clearUnusedBets() {
    return {
        type: actionTypes.CLEAR_UNUSED_BETS
    };
};

var setAssociatedBets = function setAssociatedBets(singles) {
    return {
        type: actionTypes.ASSOCIATE_SINGLES,
        singles: singles
    };
};

var setMinimumStake = exports.setMinimumStake = function setMinimumStake(outcomersId, minimumStake) {
    return {
        type: actionTypes.SET_MINIMUM_STAKE,
        outcomersId: outcomersId,
        minimumStake: minimumStake
    };
};

var setMaximumStake = exports.setMaximumStake = function setMaximumStake(outcomersId, maximumStake) {
    return {
        type: actionTypes.SET_MAXIMUM_STAKE,
        outcomersId: outcomersId,
        maximumStake: maximumStake
    };
};

var setFreeBetMinimumStake = exports.setFreeBetMinimumStake = function setFreeBetMinimumStake(outcomersId, minimumStake) {
    return {
        type: actionTypes.SET_FREE_BET_MINIMUM_STAKE,
        outcomersId: outcomersId,
        minimumStake: minimumStake
    };
};

var setFreeBetMaximumStake = exports.setFreeBetMaximumStake = function setFreeBetMaximumStake(outcomersId, maximumStake) {
    return {
        type: actionTypes.SET_FREE_BET_MAXIMUM_STAKE,
        outcomersId: outcomersId,
        maximumStake: maximumStake
    };
};

var setLockedStake = exports.setLockedStake = function setLockedStake(outcomersId, stake) {
    return {
        type: actionTypes.SET_LOCKED_STAKE,
        outcomersId: outcomersId,
        stake: stake
    };
};

var clearLockedStake = exports.clearLockedStake = function clearLockedStake(outcomersId) {
    return {
        type: actionTypes.CLEAR_LOCKED_STAKE,
        outcomersId: outcomersId
    };
};

// Multiples...
// ------------------------------------------------

var buildMultiplesRequest = exports.buildMultiplesRequest = function buildMultiplesRequest(isBuildingMultiples) {
    return {
        type: actionTypes.BUILD_MULTIPLES_REQUEST,
        isBuildingMultiples: isBuildingMultiples
    };
};

var toggleMultiplesInclusion = exports.toggleMultiplesInclusion = function toggleMultiplesInclusion(outcomersId, include) {
    return {
        type: actionTypes.TOGGLE_MULTIPLES_INCLUSION,
        outcomersId: outcomersId,
        include: include
    };
};

var clearMultiples = exports.clearMultiples = function clearMultiples() {
    return {
        type: actionTypes.CLEAR_MULTIPLES
    };
};

var setStakeForMultiple = exports.setStakeForMultiple = function setStakeForMultiple(optionId, stake) {
    return {
        type: actionTypes.SET_STAKE_FOR_MULTIPLE,
        optionId: optionId,
        stake: stake
    };
};

var setIsEachWayForMultiple = exports.setIsEachWayForMultiple = function setIsEachWayForMultiple(optionId, isEachWay) {
    return {
        type: actionTypes.SET_IS_EACHWAY_FOR_MULTIPLE,
        optionId: optionId,
        isEachWay: isEachWay
    };
};

var setIsEditingStakeForMultiple = exports.setIsEditingStakeForMultiple = function setIsEditingStakeForMultiple(optionId, isEditingStake) {
    return {
        type: actionTypes.SET_IS_EDITING_STAKE_FOR_MULTIPLE,
        optionId: optionId,
        isEditingStake: isEditingStake
    };
};

var removeAllBets = exports.removeAllBets = function removeAllBets() {
    return function (dispatch) {
        dispatch(clearSelectedBets());
        dispatch(clearMultiples());
        dispatch(_bet.actions.setBetObstruction(_bet.actions.betObstructions.NONE));
    };
};

var setMultiples = function setMultiples(multiples) {
    return {
        type: actionTypes.SET_MULTIPLES,
        multiples: multiples
    };
};

var saveMultiplesStakes = exports.saveMultiplesStakes = function saveMultiplesStakes() {
    return {
        type: actionTypes.SAVE_MULTIPLES_STAKES
    };
};

var saveMultiplesEachWay = exports.saveMultiplesEachWay = function saveMultiplesEachWay() {
    return {
        type: actionTypes.SAVE_MULTIPLES_EACHWAY
    };
};

var restoreMultiplesStakes = exports.restoreMultiplesStakes = function restoreMultiplesStakes() {
    return {
        type: actionTypes.RESTORE_MULTIPLES_STAKES
    };
};

var restoreMultiplesEachWay = exports.restoreMultiplesEachWay = function restoreMultiplesEachWay() {
    return {
        type: actionTypes.RESTORE_MULTIPLES_EACHWAY
    };
};

var reconcileBetOptions = function reconcileBetOptions(options) {
    return function (dispatch) {
        var singles = options.reduce(function (singlesOptions, option) {
            if (option.attributes.betType === 'single') {
                singlesOptions.push({
                    optionId: option.id,
                    outcomersId: option.attributes.betSelections[0].selectionId,
                    eventId: option.attributes.betSelections[0].eventId,
                    marketId: option.attributes.betSelections[0].marketId,
                    minStake: option.attributes.minStake,
                    maxStake: option.attributes.maxStake,
                    numberLines: option.attributes.numberLines
                });
            }
            return singlesOptions;
        }, []);

        if (singles.length) {
            dispatch(setAssociatedBets(singles));
        }

        dispatch(buildBetRequest(false));
    };
};

var reconcileMultiplesOptions = function reconcileMultiplesOptions(options) {
    return function (dispatch) {
        var multiples = options.reduce(function (multiplesOptions, option) {
            if (option.attributes.betType !== 'single') {
                multiplesOptions.push({
                    optionId: option.id,
                    betType: option.attributes.betType,
                    minStake: option.attributes.minStake,
                    maxStake: option.attributes.maxStake,
                    numberLines: option.attributes.numberLines,
                    betSelections: option.attributes.betSelections
                });
            }
            return multiplesOptions;
        }, []);

        if (multiples.length) {
            dispatch(setMultiples(multiples));
            dispatch(restoreMultiplesStakes());
            dispatch(restoreMultiplesEachWay());
        }

        dispatch(buildMultiplesRequest(false));
    };
};

var buildBets = exports.buildBets = function buildBets(apiName, selectedBets, feed, isExternalLogout, currencySign) {
    return function (dispatch) {
        var onUnauthorized = (0, _login.requestLogout)(apiName, feed, isExternalLogout);

        return _apiClient2.default.buildBets(apiName, selectedBets, dispatch, onUnauthorized).then(function (response) {
            var options = response.data.data;
            (0, _updateAuthToken2.default)(response.headers);
            dispatch(reconcileBetOptions(options));
            var freeBets = response.data.meta.freeBets;
            dispatch(_freeBets.actions.setFreeBets(freeBets));
        }).catch(function (error) {
            // Don't proceed if it was a cancelled request
            if (_axios2.default.isCancel(error)) {
                return Promise.resolve();
            }

            dispatch(buildBetRequest(false));

            if ((0, _apiErrors.isUnknownError)(error)) {
                return Promise.resolve();
            }

            var body = error.response.data;

            if ((0, _apiErrors.isGenericError)(body)) {
                return Promise.resolve();
            }

            // Logically determine which errors to fire & fire them
            var errorsToFire = (0, _apiErrors.getErrorsToFire)(body.errors);
            errorsToFire.map(function (errorToFire) {
                return _bet.actions.fireError(dispatch, 'BUILD', errorToFire, currencySign);
            });

            // Update CTA obstruction according to errors that were fired
            var errorCodes = errorsToFire.map(function (errorToFire) {
                return errorToFire.code;
            });
            dispatch(_bet.actions.updateObstructions(errorCodes));

            return Promise.resolve();
        });
    };
};

var buildMultiples = exports.buildMultiples = function buildMultiples(apiName, selectedBets, feed, isExternalLogout, currencySign) {
    return function (dispatch) {
        var onUnauthorized = (0, _login.requestLogout)(apiName, feed, isExternalLogout);

        return _apiClient2.default.buildMultiples(apiName, selectedBets, dispatch, onUnauthorized).then(function (response) {
            (0, _updateAuthToken2.default)(response.headers);
            var options = response.data.data;
            dispatch(reconcileMultiplesOptions(options));
        }).catch(function (error) {
            // Don't proceed if it was a cancelled request
            if (_axios2.default.isCancel(error)) {
                return Promise.resolve();
            }

            dispatch(buildMultiplesRequest(false));

            var body = error.response.data;

            if ((0, _apiErrors.isGenericError)(body)) {
                return Promise.resolve();
            }

            // Logically determine which errors to fire & fire them
            var errorsToFire = (0, _apiErrors.getErrorsToFire)(body.errors);
            errorsToFire.map(function (errorToFire) {
                return _bet.actions.fireError(dispatch, 'BUILD', errorToFire, currencySign);
            });

            // Update CTA obstruction according to errors that were fired
            var errorCodes = errorsToFire.map(function (errorToFire) {
                return errorToFire.code;
            });
            dispatch(_bet.actions.updateObstructions(errorCodes));

            return Promise.resolve();
        });
    };
};

var cancelBuildMultiples = exports.cancelBuildMultiples = function cancelBuildMultiples() {
    return function (dispatch) {
        _apiClient2.default.cancelBuildMultiples();
        dispatch(buildMultiplesRequest(false));
    };
};

var changeSelectionOrder = exports.changeSelectionOrder = function changeSelectionOrder(optionId, selectionId, index) {
    return {
        type: actionTypes.CHANGE_SELECTION_ORDER,
        optionId: optionId,
        selectionId: selectionId,
        index: index
    };
};

// Bookmaker...
// ------------------------------------------------
var setSelectedBookmaker = exports.setSelectedBookmaker = function setSelectedBookmaker(feed) {
    return {
        type: actionTypes.SET_SELECTED_BOOKMAKER,
        feed: feed
    };
};

var toggleBalanceVisibility = exports.toggleBalanceVisibility = function toggleBalanceVisibility(feed) {
    return {
        type: actionTypes.TOGGLE_BALANCE_VISIBILITY,
        feed: feed
    };
};

var saveUsername = exports.saveUsername = function saveUsername(feed, username) {
    return {
        type: actionTypes.SAVE_USERNAME,
        feed: feed,
        username: username
    };
};

var removeUsername = exports.removeUsername = function removeUsername(feed) {
    return {
        type: actionTypes.REMOVE_USERNAME,
        feed: feed
    };
};

var setBookmakersOrder = exports.setBookmakersOrder = function setBookmakersOrder(sortingFunction, bookmakersList) {
    return {
        type: actionTypes.SET_BOOKMAKERS_ORDER,
        bookmakersOrder: bookmakersList.map(function (_ref) {
            var feed = _ref.feed;
            return feed;
        }).sort(sortingFunction),
        orderExpiration: (0, _currentDate.getCurrentTime)() + MILISECONDS_IN_DAY
    };
};

var setError = exports.setError = function setError(outcomersId, errorId, message) {
    return {
        type: actionTypes.SET_ERROR,
        outcomersId: outcomersId,
        error: {
            errorId: errorId,
            message: message
        }
    };
};

var setErrorOnBuild = exports.setErrorOnBuild = function setErrorOnBuild(outcomersId, errorId, message) {
    return {
        type: actionTypes.SET_ERROR_ON_BUILD,
        outcomersId: outcomersId,
        error: {
            errorId: errorId,
            message: message
        }
    };
};

var clearError = exports.clearError = function clearError(outcomersId) {
    return {
        type: actionTypes.CLEAR_ERROR,
        outcomersId: outcomersId
    };
};

var clearAllErrors = exports.clearAllErrors = function clearAllErrors() {
    return {
        type: actionTypes.CLEAR_ALL_ERRORS
    };
};

var setGenericError = exports.setGenericError = function setGenericError(errorId, message) {
    return {
        type: actionTypes.SET_GENERIC_ERROR,
        error: {
            errorId: errorId,
            message: message
        }
    };
};

var setGenericErrorOnBuild = exports.setGenericErrorOnBuild = function setGenericErrorOnBuild(errorId, message) {
    return {
        type: actionTypes.SET_GENERIC_ERROR_ON_BUILD,
        error: {
            errorId: errorId,
            message: message
        }
    };
};

var clearGenericError = exports.clearGenericError = function clearGenericError() {
    return {
        type: actionTypes.CLEAR_GENERIC_ERROR
    };
};

var setMultiplesError = exports.setMultiplesError = function setMultiplesError(optionId, errorId, message) {
    return {
        type: actionTypes.SET_MULTIPLES_ERROR,
        optionId: optionId,
        error: {
            errorId: errorId,
            message: message
        }
    };
};

var clearMultiplesError = exports.clearMultiplesError = function clearMultiplesError(optionId) {
    return {
        type: actionTypes.CLEAR_MULTIPLES_ERROR,
        optionId: optionId
    };
};

var clearAllMultiplesErrors = exports.clearAllMultiplesErrors = function clearAllMultiplesErrors() {
    return {
        type: actionTypes.CLEAR_ALL_MULTIPLES_ERRORS
    };
};

var selectBookmaker = exports.selectBookmaker = function selectBookmaker(feed, sortingFunction, bookmakersList) {
    var shouldShowModal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return function (dispatch) {
        if (shouldShowModal) {
            dispatch(_modals.actions.showSelectionInfoModal());
        }
        dispatch(setBookmakersOrder(sortingFunction, bookmakersList));
        dispatch(setSelectedBookmaker(feed));
        dispatch(clearSelectedBets());
        dispatch(clearMultiples());
        dispatch((0, _drawer.resetEmptyBetslip)());
        dispatch(_bet.actions.setBetObstruction(_bet.actions.betObstructions.NONE));
        dispatch(_bet.actions.clearPlacedBetDetails());
    };
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.reducer = exports.default = undefined;

var _ExternalAccount = __webpack_require__(134);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_ExternalAccount).default;
    }
});

var _externalAccount = __webpack_require__(514);

var _externalAccount2 = _interopRequireDefault(_externalAccount);

var _externalAccount3 = __webpack_require__(85);

var actions = _interopRequireWildcard(_externalAccount3);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _externalAccount2.default;
exports.actions = actions;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.reducer = undefined;

var _freeBets = __webpack_require__(517);

var _freeBets2 = _interopRequireDefault(_freeBets);

var _freeBets3 = __webpack_require__(214);

var actions = _interopRequireWildcard(_freeBets3);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _freeBets2.default;
exports.actions = actions;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.reducer = exports.LoginContainer = exports.default = undefined;

var _Login = __webpack_require__(610);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Login).default;
    }
});

var _login = __webpack_require__(527);

var _login2 = _interopRequireDefault(_login);

var _login3 = __webpack_require__(47);

var actions = _interopRequireWildcard(_login3);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.LoginContainer = _Login.LoginContainer;
exports.reducer = _login2.default;
exports.actions = actions;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectors = exports.actions = exports.reducer = undefined;

var _pageInfo = __webpack_require__(528);

var _pageInfo2 = _interopRequireDefault(_pageInfo);

var _pageInfo3 = __webpack_require__(216);

var actions = _interopRequireWildcard(_pageInfo3);

var _pageInfo4 = __webpack_require__(529);

var selectors = _interopRequireWildcard(_pageInfo4);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _pageInfo2.default;
exports.actions = actions;
exports.selectors = selectors;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.minimizeQuickslip = exports.clickOutsideBetslip = exports.resetQuickslip = exports.resetEmptyBetslip = exports.setQuickslipMode = exports.setThemeFromBookieName = exports.setTheme = exports.maximizeDrawer = exports.minimizeDrawer = exports.actionTypes = undefined;

var _bookmakers = __webpack_require__(84);

var _bookmakers2 = _interopRequireDefault(_bookmakers);

var _bookmakersInfo = __webpack_require__(6);

var _bet = __webpack_require__(20);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var bookmakers = (0, _bookmakers2.default)();

var actionTypes = exports.actionTypes = {
    MINIMIZE_DRAWER: 'MINIMIZE_DRAWER',
    MAXIMIZE_DRAWER: 'MAXIMIZE_DRAWER',
    SET_THEME: 'SET_THEME',
    SET_QUICKSLIP_MODE: 'SET_QUICKSLIP_MODE'
};

var minimizeDrawer = exports.minimizeDrawer = function minimizeDrawer() {
    return {
        type: actionTypes.MINIMIZE_DRAWER
    };
};

var maximizeDrawer = exports.maximizeDrawer = function maximizeDrawer() {
    return {
        type: actionTypes.MAXIMIZE_DRAWER
    };
};

var setTheme = exports.setTheme = function setTheme(theme) {
    return {
        type: actionTypes.SET_THEME,
        theme: theme
    };
};

var setThemeFromBookieName = exports.setThemeFromBookieName = function setThemeFromBookieName(bookieName) {
    return function (dispatch) {
        var bookmaker = bookmakers.find(function (bookie) {
            return bookie.feed === bookieName;
        });
        var theme = bookmaker !== undefined ? bookmaker.name : 'no-bookmaker';
        dispatch(setTheme(theme));
    };
};

var setQuickslipMode = exports.setQuickslipMode = function setQuickslipMode(enabled) {
    return {
        type: actionTypes.SET_QUICKSLIP_MODE,
        enabled: enabled
    };
};

var resetEmptyBetslip = exports.resetEmptyBetslip = function resetEmptyBetslip() {
    return function (dispatch) {
        dispatch(setQuickslipMode(true));
        dispatch(minimizeDrawer());
    };
};

var resetQuickslip = exports.resetQuickslip = function resetQuickslip() {
    return function (dispatch) {
        dispatch(_bookmakersInfo.actions.clearSelectedBets());
        dispatch(setQuickslipMode(true));
        dispatch(_bet.actions.setBetObstruction(_bet.actions.betObstructions.NONE));
        dispatch(_bookmakersInfo.actions.clearGenericError());
        dispatch(minimizeDrawer());
    };
};

var clickOutsideBetslip = exports.clickOutsideBetslip = function clickOutsideBetslip(isQuickslipMode, numberOfBets) {
    return function (dispatch) {
        // Note that for any outcome, the drawer will be minimized
        if (isQuickslipMode) {
            dispatch(resetQuickslip());
        } else {
            var action = numberOfBets === 0 ? resetEmptyBetslip() : minimizeDrawer();
            dispatch(action);
        }
    };
};

var minimizeQuickslip = exports.minimizeQuickslip = function minimizeQuickslip() {
    return function (dispatch) {
        dispatch(setQuickslipMode(false));
        dispatch(minimizeDrawer());
    };
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Line2.default, {
    className: 'commissionText'
}, void 0, 'If you click on a link on this site which takes you to a bookmaker or casino and you subsequently open an account, Racingpost may receive a commission.');

var CommissionText = function CommissionText() {
    return _ref;
};

exports.default = CommissionText;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(_ref) {
    var href = _ref.href,
        imageName = _ref.imageName;
    return _jsx('a', {
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: (0, _classnames2.default)('bs-gamblingCompliance__image', 'bs-gamblingCompliance__image_' + imageName)
    }, void 0);
};

Image.defaultProps = {
    href: null
};

exports.default = Image;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;

var _LocationUtils = __webpack_require__(66);

Object.defineProperty(exports, 'createLocation', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.createLocation;
  }
});
Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _PathUtils = __webpack_require__(50);

Object.defineProperty(exports, 'parsePath', {
  enumerable: true,
  get: function get() {
    return _PathUtils.parsePath;
  }
});
Object.defineProperty(exports, 'createPath', {
  enumerable: true,
  get: function get() {
    return _PathUtils.createPath;
  }
});

var _createBrowserHistory2 = __webpack_require__(256);

var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);

var _createHashHistory2 = __webpack_require__(257);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(258);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.createBrowserHistory = _createBrowserHistory3.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Symbol2 = __webpack_require__(68);

var _Symbol3 = _interopRequireDefault(_Symbol2);

var _getRawTag = __webpack_require__(307);

var _getRawTag2 = _interopRequireDefault(_getRawTag);

var _objectToString = __webpack_require__(336);

var _objectToString2 = _interopRequireDefault(_objectToString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTag2.default)(value) : (0, _objectToString2.default)(value);
}

exports.default = baseGetTag;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var _Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function (string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actions = exports.actionTypes = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.formPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.propTypes = exports.SubmissionError = exports.FormSection = exports.Form = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = undefined;

var _defaultShouldAsyncValidate = __webpack_require__(182);

Object.defineProperty(exports, 'defaultShouldAsyncValidate', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_defaultShouldAsyncValidate).default;
    }
});

var _defaultShouldValidate = __webpack_require__(183);

Object.defineProperty(exports, 'defaultShouldValidate', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_defaultShouldValidate).default;
    }
});

var _Form = __webpack_require__(395);

Object.defineProperty(exports, 'Form', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Form).default;
    }
});

var _FormSection = __webpack_require__(396);

Object.defineProperty(exports, 'FormSection', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_FormSection).default;
    }
});

var _SubmissionError = __webpack_require__(179);

Object.defineProperty(exports, 'SubmissionError', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_SubmissionError).default;
    }
});

var _propTypes = __webpack_require__(431);

Object.defineProperty(exports, 'propTypes', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_propTypes).default;
    }
});
Object.defineProperty(exports, 'fieldInputPropTypes', {
    enumerable: true,
    get: function get() {
        return _propTypes.fieldInputPropTypes;
    }
});
Object.defineProperty(exports, 'fieldMetaPropTypes', {
    enumerable: true,
    get: function get() {
        return _propTypes.fieldMetaPropTypes;
    }
});
Object.defineProperty(exports, 'fieldPropTypes', {
    enumerable: true,
    get: function get() {
        return _propTypes.fieldPropTypes;
    }
});
Object.defineProperty(exports, 'formPropTypes', {
    enumerable: true,
    get: function get() {
        return _propTypes.formPropTypes;
    }
});

var _Field = __webpack_require__(392);

Object.defineProperty(exports, 'Field', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Field).default;
    }
});

var _Fields = __webpack_require__(394);

Object.defineProperty(exports, 'Fields', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Fields).default;
    }
});

var _FieldArray = __webpack_require__(393);

Object.defineProperty(exports, 'FieldArray', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_FieldArray).default;
    }
});

var _formValueSelector = __webpack_require__(410);

Object.defineProperty(exports, 'formValueSelector', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_formValueSelector).default;
    }
});

var _formValues = __webpack_require__(411);

Object.defineProperty(exports, 'formValues', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_formValues).default;
    }
});

var _getFormNames = __webpack_require__(416);

Object.defineProperty(exports, 'getFormNames', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormNames).default;
    }
});

var _getFormValues = __webpack_require__(420);

Object.defineProperty(exports, 'getFormValues', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormValues).default;
    }
});

var _getFormInitialValues = __webpack_require__(414);

Object.defineProperty(exports, 'getFormInitialValues', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormInitialValues).default;
    }
});

var _getFormSyncErrors = __webpack_require__(418);

Object.defineProperty(exports, 'getFormSyncErrors', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormSyncErrors).default;
    }
});

var _getFormMeta = __webpack_require__(415);

Object.defineProperty(exports, 'getFormMeta', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormMeta).default;
    }
});

var _getFormAsyncErrors = __webpack_require__(413);

Object.defineProperty(exports, 'getFormAsyncErrors', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormAsyncErrors).default;
    }
});

var _getFormSyncWarnings = __webpack_require__(419);

Object.defineProperty(exports, 'getFormSyncWarnings', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormSyncWarnings).default;
    }
});

var _getFormSubmitErrors = __webpack_require__(417);

Object.defineProperty(exports, 'getFormSubmitErrors', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getFormSubmitErrors).default;
    }
});

var _isDirty = __webpack_require__(425);

Object.defineProperty(exports, 'isDirty', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_isDirty).default;
    }
});

var _isInvalid = __webpack_require__(426);

Object.defineProperty(exports, 'isInvalid', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_isInvalid).default;
    }
});

var _isPristine = __webpack_require__(427);

Object.defineProperty(exports, 'isPristine', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_isPristine).default;
    }
});

var _isValid = __webpack_require__(430);

Object.defineProperty(exports, 'isValid', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_isValid).default;
    }
});

var _isSubmitting = __webpack_require__(429);

Object.defineProperty(exports, 'isSubmitting', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_isSubmitting).default;
    }
});

var _hasSubmitSucceeded = __webpack_require__(424);

Object.defineProperty(exports, 'hasSubmitSucceeded', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_hasSubmitSucceeded).default;
    }
});

var _hasSubmitFailed = __webpack_require__(423);

Object.defineProperty(exports, 'hasSubmitFailed', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_hasSubmitFailed).default;
    }
});

var _reduxForm = __webpack_require__(433);

Object.defineProperty(exports, 'reduxForm', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_reduxForm).default;
    }
});

var _reducer = __webpack_require__(432);

Object.defineProperty(exports, 'reducer', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_reducer).default;
    }
});

var _values = __webpack_require__(455);

Object.defineProperty(exports, 'values', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_values).default;
    }
});

var _actions2 = __webpack_require__(180);

var _actions = _interopRequireWildcard(_actions2);

var _actionTypes2 = __webpack_require__(117);

var _actionTypes = _interopRequireWildcard(_actionTypes2);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var actionTypes = exports.actionTypes = _actionTypes;
var actions = exports.actions = _actions;
var arrayInsert = _actions.arrayInsert,
    arrayMove = _actions.arrayMove,
    arrayPop = _actions.arrayPop,
    arrayPush = _actions.arrayPush,
    arrayRemove = _actions.arrayRemove,
    arrayRemoveAll = _actions.arrayRemoveAll,
    arrayShift = _actions.arrayShift,
    arraySplice = _actions.arraySplice,
    arraySwap = _actions.arraySwap,
    arrayUnshift = _actions.arrayUnshift,
    autofill = _actions.autofill,
    blur = _actions.blur,
    change = _actions.change,
    clearSubmitErrors = _actions.clearSubmitErrors,
    destroy = _actions.destroy,
    focus = _actions.focus,
    initialize = _actions.initialize,
    registerField = _actions.registerField,
    reset = _actions.reset,
    setSubmitFailed = _actions.setSubmitFailed,
    setSubmitSucceeded = _actions.setSubmitSucceeded,
    startAsyncValidation = _actions.startAsyncValidation,
    startSubmit = _actions.startSubmit,
    stopAsyncValidation = _actions.stopAsyncValidation,
    stopSubmit = _actions.stopSubmit,
    submit = _actions.submit,
    touch = _actions.touch,
    unregisterField = _actions.unregisterField,
    untouch = _actions.untouch;
exports.arrayInsert = arrayInsert;
exports.arrayMove = arrayMove;
exports.arrayPop = arrayPop;
exports.arrayPush = arrayPush;
exports.arrayRemove = arrayRemove;
exports.arrayRemoveAll = arrayRemoveAll;
exports.arrayShift = arrayShift;
exports.arraySplice = arraySplice;
exports.arraySwap = arraySwap;
exports.arrayUnshift = arrayUnshift;
exports.autofill = autofill;
exports.blur = blur;
exports.change = change;
exports.clearSubmitErrors = clearSubmitErrors;
exports.destroy = destroy;
exports.focus = focus;
exports.initialize = initialize;
exports.registerField = registerField;
exports.reset = reset;
exports.setSubmitFailed = setSubmitFailed;
exports.setSubmitSucceeded = setSubmitSucceeded;
exports.startAsyncValidation = startAsyncValidation;
exports.startSubmit = startSubmit;
exports.stopAsyncValidation = stopAsyncValidation;
exports.stopSubmit = stopSubmit;
exports.submit = submit;
exports.touch = touch;
exports.unregisterField = unregisterField;
exports.untouch = untouch;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ColorSkinWrapper = __webpack_require__(585);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorSkinWrapper).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getShortGamblingCompliance = exports.getGamblingCompliance = undefined;

var _Bet = __webpack_require__(518);

var _Coral = __webpack_require__(520);

var _Ladbrokes = __webpack_require__(521);

var _PaddyPower = __webpack_require__(522);

var _Betfair = __webpack_require__(519);

var _WilliamHill = __webpack_require__(524);

var _Skybet = __webpack_require__(523);

var getGamblingCompliance = function getGamblingCompliance(feed) {
    switch (feed) {
        case 'BET365':
            return (0, _Bet.fullGamblingCompliance)();
        case 'CORAL':
            return (0, _Coral.fullGamblingCompliance)();
        case 'LADB':
            return (0, _Ladbrokes.fullGamblingCompliance)();
        case 'PPWR':
            return (0, _PaddyPower.fullGamblingCompliance)();
        case 'BETFAIR':
            return (0, _Betfair.fullGamblingCompliance)();
        case 'WH_OXI':
            return (0, _WilliamHill.fullGamblingCompliance)();
        case 'SURREY':
            return (0, _Skybet.fullGamblingCompliance)();
        default:
            return (0, _WilliamHill.fullGamblingCompliance)();
    }
};

var getShortGamblingCompliance = function getShortGamblingCompliance(feed) {
    switch (feed) {
        case 'BET365':
            return (0, _Bet.shortGamblingCompliance)();
        case 'CORAL':
            return (0, _Coral.shortGamblingCompliance)();
        case 'LADB':
            return (0, _Ladbrokes.shortGamblingCompliance)();
        case 'PPWR':
            return (0, _PaddyPower.shortGamblingCompliance)();
        case 'BETFAIR':
            return (0, _Betfair.shortGamblingCompliance)();
        case 'WH_OXI':
            return (0, _WilliamHill.shortGamblingCompliance)();
        case 'SURREY':
            return (0, _Skybet.shortGamblingCompliance)();
        default:
            return (0, _WilliamHill.shortGamblingCompliance)();
    }
};

exports.getGamblingCompliance = getGamblingCompliance;
exports.getShortGamblingCompliance = getShortGamblingCompliance;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showGdprPopup = exports.loadBookmakerLoginInfo = exports.requestLogout = exports.requestLogin = exports.loginClearError = exports.loginFailure = exports.loginSuccess = exports.actionTypes = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

var _bookmakers = __webpack_require__(84);

var _bookmakers2 = _interopRequireDefault(_bookmakers);

var _bookmakersList = __webpack_require__(5);

var _executeInWindow = __webpack_require__(536);

var _executeInWindow2 = _interopRequireDefault(_executeInWindow);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _updateAuthToken = __webpack_require__(49);

var _updateAuthToken2 = _interopRequireDefault(_updateAuthToken);

var _loginCookies = __webpack_require__(90);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var bookmakers = (0, _bookmakers2.default)();

var actionTypes = exports.actionTypes = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGIN_CLEAR_ERROR: 'LOGIN_CLEAR_ERROR',
    REQUEST_BOOKMAKER_LOGIN_INFO: 'REQUEST_BOOKMAKER_LOGIN_INFO',
    REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS: 'REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS',
    REQUEST_BOOKMAKER_LOGIN_INFO_ERROR: 'REQUEST_BOOKMAKER_LOGIN_INFO_ERROR',
    SHOW_GDPR_POPUP: 'SHOW_GDPR_POPUP'
};

var loginSuccess = exports.loginSuccess = function loginSuccess() {
    return {
        type: actionTypes.LOGIN_SUCCESS
    };
};

var loginFailure = exports.loginFailure = function loginFailure(isIncorrectCredentials) {
    return {
        type: actionTypes.LOGIN_FAILURE,
        isIncorrectCredentials: isIncorrectCredentials
    };
};

var loginClearError = exports.loginClearError = function loginClearError() {
    return {
        type: actionTypes.LOGIN_CLEAR_ERROR
    };
};

var requestLogin = exports.requestLogin = function requestLogin(bookie, feed, formData) {
    return function (dispatch) {
        dispatch({ type: actionTypes.LOGIN_REQUEST });

        var username = formData.username,
            password = formData.password;

        var body = {
            username: username,
            password: password
        };

        function login() {
            return _apiClient2.default.login(bookie, body).then(function (res) {
                (0, _updateAuthToken2.default)(res.headers);
                if (res.status === 200 && res.data && res.data.data && res.data.data.attributes && res.data.data.attributes.success) {
                    return res.data.data.attributes;
                }
                return Promise.reject(res);
            }).catch(function (err) {
                var errors = (0, _lodash2.default)(err, 'response.data.errors', []);
                var isIncorrectCredentials = errors.filter(function (e) {
                    return e.code === '401' || e.detail.indexOf('(code: 10071)') !== -1;
                }).length > 0;
                dispatch(loginFailure(isIncorrectCredentials));
                return Promise.reject(err);
            });
        }

        return login().catch(function (err) {
            return Promise.reject(_extends({}, err, { retry: login }));
        });
    };
};

var requestLogout = exports.requestLogout = function requestLogout(bookie, feed, isExternalLogout) {
    return function (dispatch) {
        var logout = isExternalLogout ? (0, _executeInWindow2.default)(_apiClient2.default.externalLogout(bookie)) : _apiClient2.default.logout(bookie);
        var logoutBookmaker = bookmakers.find(function (bookmaker) {
            return bookmaker.feed === feed;
        });

        return logout.then(function (res) {
            (0, _updateAuthToken2.default)(res.headers);
            if (res.status === 200 && res.data && res.data.data && res.data.data.attributes && res.data.data.attributes.success) {
                (0, _loginCookies.deleteLoginCookie)(logoutBookmaker.cookieName);
                return dispatch(_bookmakersList.actions.setLoggedOut(feed));
            }
            return Promise.reject(new Error('Invalid JSON response'));
        }).then(function (result) {
            var loggedOutEvent = new CustomEvent('BETSLIP.BOOKMAKER.LOGGED_OUT', {
                detail: {}
            });
            document.dispatchEvent(loggedOutEvent);
            return result;
        }).catch(function (err) {
            var errorCodes = (0, _lodash2.default)(err, 'response.data.errors', []);
            var isUserNotLoggedIn = errorCodes.filter(function (e) {
                return e.code === '401';
            }).length > 0;
            var isLogoutError = errorCodes.filter(function (e) {
                return e.code === '400';
            }).length > 0;

            if (isUserNotLoggedIn || isLogoutError) {
                (0, _loginCookies.deleteLoginCookie)(logoutBookmaker.cookieName);
                return dispatch(_bookmakersList.actions.setLoggedOut(feed));
            }
            return Promise.reject(err);
        });
    };
};

var requestBookmakerInfo = function requestBookmakerInfo() {
    return {
        type: actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO
    };
};

var receiveBookmakerInfoSuccess = function receiveBookmakerInfoSuccess() {
    return {
        type: actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS
    };
};

var receiveBookmakerInfoError = function receiveBookmakerInfoError() {
    return {
        type: actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_ERROR
    };
};

var loadBookmakerLoginInfo = exports.loadBookmakerLoginInfo = function loadBookmakerLoginInfo(bookmaker, feed) {
    return function (dispatch) {
        dispatch(requestBookmakerInfo());

        return _apiClient2.default.loadBookmakerLoginInfo(bookmaker).then(function (res) {
            (0, _updateAuthToken2.default)(res.headers);
            if (res.status !== 200 || !res.data || !res.data.data || !res.data.data.attributes) {
                return Promise.reject(new Error(res.data));
            }
            var auth = {
                authUrl: res.data.data.attributes.bookmaker_url
            };

            return auth;
        }).then(function (data) {
            dispatch(receiveBookmakerInfoSuccess());
            dispatch(_bookmakersList.actions.setAuthInfo(feed, data));
        }).catch(function () {
            dispatch(receiveBookmakerInfoError());
            dispatch(_bookmakersList.actions.setAuthInfo(feed, {
                isError: true
            }));
        });
    };
};

var showGdprPopup = exports.showGdprPopup = function showGdprPopup(url) {
    return {
        type: actionTypes.SHOW_GDPR_POPUP,
        url: url
    };
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateStake = calculateStake;
exports.calculateSingleStake = calculateSingleStake;
exports.calculateMultipleStake = calculateMultipleStake;
exports.calculateTotalStake = calculateTotalStake;
exports.calculateMoneyBreakdown = calculateMoneyBreakdown;
exports.isEmptyStake = isEmptyStake;
/**
 * Calculate estimated total stake
 * @param {Number} stake - stake for race
 * @param {Object} config - configuration object
 * @param {Boolean} [config.isEachWay] - flag that shows whether eachWay bet present or not
 */
function calculateStake(stake) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (Number.isNaN(stake)) {
        return 0;
    }
    var isEachWay = config.isEachWay,
        numberLines = config.numberLines;

    var totalStake = isEachWay ? 2 * stake : stake;
    if (numberLines) {
        totalStake *= numberLines;
    }

    return totalStake;
}

function calculateSingleStake(bet) {
    if (!bet.stake) {
        return 0;
    }

    var parsedStake = parseFloat(bet.stake);
    var calculatedStake = calculateStake(parsedStake, {
        isEachWay: bet.isEachWay
    });

    return calculatedStake;
}

function calculateMultipleStake(multiple) {
    if (!multiple.stakeValue) {
        return 0;
    }

    var parsedStake = parseFloat(multiple.stakeValue);
    var calculatedStake = calculateStake(parsedStake, {
        isEachWay: multiple.isEachWay,
        numberLines: multiple.numberLines
    });

    return calculatedStake;
}

function calculateTotalStake(selectedBets, multiples) {
    var singlesTotal = selectedBets.reduce(function (runningTotal, bet) {
        return runningTotal + calculateSingleStake(bet);
    }, 0);

    var multiplesTotal = multiples.length === 0 ? 0 : multiples.reduce(function (runningTotal, multiple) {
        return runningTotal + calculateMultipleStake(multiple);
    }, 0);

    return (singlesTotal + multiplesTotal).toFixed(2);
}

/**
 * Calculates a breakdown of free money / user money.
 *
 * @param  {Number} stake e.g. 5
 * @param  {Object} bet - typical selection that you'd see in selectedBets
 * @param  {[type]} freeBetAmount e.g. 2
 *
 * @return {Object} e.g. { userStake: 3, freeStake 2 }
 */
function calculateMoneyBreakdown(stake, bet, freeBetAmount) {
    // Double the base stake when EW
    var totalStake = bet.isEachWay ? stake * 2 : stake;

    // Calculate the split
    var freeStake = freeBetAmount >= totalStake ? totalStake : freeBetAmount;
    var userStake = freeStake >= totalStake ? 0 : totalStake - freeStake;

    return {
        userStake: userStake,
        freeStake: freeStake
    };
}

function isEmptyStake(stake) {
    return stake === '' || parseFloat(stake) === 0;
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = updateAuthToken;

var _cookie = __webpack_require__(23);

var _localStorage = __webpack_require__(62);

function updateAuthToken(headers) {
    if (headers && headers['auth-token']) {
        switch ((0, _localStorage.isLocalStorageAvailable)()) {
            case true:
                if (headers['auth-token'] !== window.localStorage.getItem('auth-token')) {
                    window.localStorage.setItem('auth-token', headers['auth-token']);
                }
                break;
            case false:
                if (headers['auth-token'] !== (0, _cookie.getCookie)('auth-token')) {
                    var date = new Date();

                    date.setDate(date.getDate() + 1);
                    (0, _cookie.setCookie)('auth-token=' + headers['auth-token'] + '; ' + ('domain=.' + location.host.split('.').slice(1).join('.') + '; ') + 'path=/; ' + ('expires=' + date.toUTCString()));
                }
                break;

            // no default
        }
    }
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isSymbol = __webpack_require__(75);

var _isSymbol2 = _interopRequireDefault(_isSymbol);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || (0, _isSymbol2.default)(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

exports.default = toKey;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

exports.default = eq;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatName;
function formatName(context, name) {
  var sectionPrefix = context._reduxForm.sectionPrefix;

  return !sectionPrefix ? name : sectionPrefix + "." + name;
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logToAnalyticsDiscardSlipButtonClick = exports.logToAnalyticsCancelBetClick = exports.logToAnalyticsRemoveSelectionClick = exports.logToAnalyticsQuickStakeButtonsClick = exports.logToAnalyticsBookmakerOpenAccount = exports.logToAnalyticsBookmakerLoginFailure = exports.logToAnalyticsBookmakerLoginSuccess = exports.logToAnalyticsBookmakerLogin = exports.logToAnalyticsBuildError = exports.logToAnalyticsBetError = exports.logToAnalyticsBetSuccess = exports.findAnalytics = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _cookie = __webpack_require__(23);

var _currentDate = __webpack_require__(24);

var _userInfo = __webpack_require__(11);

var _bookmakersList = __webpack_require__(5);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var BET_EXEPTIONS = {
    'betting-suspended': 'Market Suspended ',
    'price-changed': 'Price Change',
    'insufficient-funds': 'Insufficient Funds',
    'general-error': 'General Error'
};

var chooseYourBookiePosition = null;

var onOpenBookmakerLogin = function onOpenBookmakerLogin(_ref) {
    var position = _ref.detail.position;

    chooseYourBookiePosition = position;
};

var initChooseYourBookiePositionListener = function initChooseYourBookiePositionListener() {
    document.addEventListener('BETSLIP.BOOKMAKER.LOGIN', onOpenBookmakerLogin, false);
};

initChooseYourBookiePositionListener();

var getRPFields = function getRPFields() {
    var cookie = (0, _cookie.getCookie)('RDSS');
    if (!cookie) {
        return {};
    }
    try {
        var rpFields = JSON.parse(cookie);
        return {
            email: rpFields.rp_email,
            package: rpFields.rp_package
        };
    } catch (ex) {
        return {};
    }
};

var findAnalytics = exports.findAnalytics = function findAnalytics() {
    if (!window.SegmentIO) {
        return null;
    }
    if (window.SegmentIO.default) {
        return window.SegmentIO.default.getInstance();
    }
    if (window.SegmentIO.getInstance) {
        return window.SegmentIO.getInstance();
    }

    return window.SegmentIO;
};

// Fires 2 events: Place Bet (success), then Bet Receipt
var logToAnalyticsBetSuccess = exports.logToAnalyticsBetSuccess = function logToAnalyticsBetSuccess(action, store, analytics) {
    var _extends2;

    var state = store.getState();
    var bookmakerSelector = function bookmakerSelector() {
        return action.placedBetDetails.bets[0].bets[0].feed;
    };
    var userInfo = _userInfo.selectors.createUserInfoSelector(bookmakerSelector)(state);
    var bookmakerInfo = _bookmakersList.selectors.createBookmakerInfoSelector(bookmakerSelector)(state);
    var rpFields = getRPFields();
    var placeBetConfig = _extends({}, rpFields, (_extends2 = {}, _defineProperty(_extends2, analytics.TRAIT_BOOKMAKER, bookmakerInfo.analyticsName), _defineProperty(_extends2, analytics.TRAIT_BOOKMAKER_USERNAME, userInfo.name), _defineProperty(_extends2, analytics.TRAIT_API_OUTCOME, 'Bets Placed'), _extends2));

    // Generate n receipts
    var receipts = action.placedBetDetails.bets.map(function (receipt) {
        var _analytics$TRAIT_RECE, _ref3;

        var receiptId = receipt.receiptId,
            betType = receipt.betType,
            stakePerLine = receipt.stakePerLine,
            numberLines = receipt.numberLines,
            potentialReturns = receipt.potentialReturns;

        var selections = receipt.bets.map(function (selection) {
            var _ref2;

            return _ref2 = {}, _defineProperty(_ref2, analytics.TRAIT_HORSE_NAME, selection.horseName), _defineProperty(_ref2, analytics.TRAIT_RACE_DATE, selection.raceDate), _defineProperty(_ref2, analytics.TRAIT_RACECOURSE, selection.courseName), _defineProperty(_ref2, analytics.TRAIT_TIME_OF_EVENT, selection.raceTime), _defineProperty(_ref2, analytics.TRAIT_WIN_EW, selection.isEachWay ? 'Each Way' : 'Win'), _defineProperty(_ref2, analytics.TRAIT_ODDS, selection.priceType), _ref2;
        });
        var selectionsAsObject = {}; // RP say that "arrays cause issues"
        selections.map(function (selection, index) {
            selectionsAsObject[index + 1] = selection;
            return undefined;
        });

        // Note that the 'Combined' type is not supported by v2 API
        // i.e. all singles and multiples get their own receipts
        var betReceiptType = betType === 'single' ? 'Single' : 'Multiple';

        return _ref3 = {}, _defineProperty(_ref3, analytics.TRAIT_RECEIPT, (_analytics$TRAIT_RECE = {}, _defineProperty(_analytics$TRAIT_RECE, analytics.TRAIT_RECEIPT_ID, receiptId), _defineProperty(_analytics$TRAIT_RECE, analytics.TRAIT_RECEIPT_TYPE, betReceiptType), _defineProperty(_analytics$TRAIT_RECE, analytics.TRAIT_BET_TYPE, betType), _defineProperty(_analytics$TRAIT_RECE, analytics.TRAIT_SELECTIONS, selectionsAsObject), _defineProperty(_analytics$TRAIT_RECE, analytics.TRAIT_STAKE, stakePerLine * numberLines), _defineProperty(_analytics$TRAIT_RECE, analytics.TRAIT_REVENUE, potentialReturns), _defineProperty(_analytics$TRAIT_RECE, analytics.TRAIT_BET_COUNT, receipt.bets.length.toString()), _analytics$TRAIT_RECE)), _defineProperty(_ref3, analytics.TRAIT_BET_DATE, (0, _currentDate.getCurrentDate)()), _defineProperty(_ref3, analytics.TRAIT_BOOKMAKER, bookmakerInfo.analyticsName), _defineProperty(_ref3, analytics.TRAIT_CURRENCY, bookmakerInfo.userInfo.currency), _ref3;
    });

    return analytics.identify(undefined, placeBetConfig).then(function () {
        return analytics.trackPlaceBet(_extends({}, placeBetConfig));
    }).then(function () {
        var receiptEvents = receipts.map(function (receipt) {
            return analytics.trackBetReceipt(receipt);
        });

        Promise.all(receiptEvents).then(function () {
            Promise.resolve();
        });
    });
};

var logToAnalyticsBetError = exports.logToAnalyticsBetError = function logToAnalyticsBetError(action, store, analytics) {
    var _extends3;

    var state = store.getState();
    var selectedBet = state.bookmakersInfo.selectedBets[0];
    var bookmakerSelector = function bookmakerSelector() {
        return selectedBet.feed;
    };
    var userInfo = _userInfo.selectors.createUserInfoSelector(bookmakerSelector)(state);
    var bookmakerInfo = _bookmakersList.selectors.createBookmakerInfoSelector(bookmakerSelector)(state);
    var rpFields = getRPFields();
    var outcome = BET_EXEPTIONS[action.error.errorId] || BET_EXEPTIONS['general-error'];
    var config = _extends({}, rpFields, (_extends3 = {}, _defineProperty(_extends3, analytics.TRAIT_BOOKMAKER, bookmakerInfo.analyticsName), _defineProperty(_extends3, analytics.TRAIT_BOOKMAKER_USERNAME, userInfo.name), _defineProperty(_extends3, analytics.TRAIT_API_OUTCOME, outcome), _extends3));

    return analytics.identify(undefined, config).then(function () {
        return analytics.trackPlaceBet(_extends({}, config));
    });
};

var logToAnalyticsBuildError = exports.logToAnalyticsBuildError = function logToAnalyticsBuildError(action, store, analytics) {
    var _extends4;

    var state = store.getState();
    var selectedBet = state.bookmakersInfo.selectedBets[0];
    var bookmakerSelector = function bookmakerSelector() {
        return selectedBet.feed;
    };
    var userInfo = _userInfo.selectors.createUserInfoSelector(bookmakerSelector)(state);
    var bookmakerInfo = _bookmakersList.selectors.createBookmakerInfoSelector(bookmakerSelector)(state);
    var rpFields = getRPFields();
    var outcome = BET_EXEPTIONS[action.error.errorId] || BET_EXEPTIONS['general-error'];
    var config = _extends({}, rpFields, (_extends4 = {}, _defineProperty(_extends4, analytics.TRAIT_BOOKMAKER, bookmakerInfo.analyticsName), _defineProperty(_extends4, analytics.TRAIT_BOOKMAKER_USERNAME, userInfo.name), _defineProperty(_extends4, analytics.TRAIT_API_OUTCOME, outcome), _extends4));

    return analytics.identify(undefined, config).then(function () {
        return analytics.trackBetslipErrorMessage(_extends({}, config));
    });
};

var logToAnalyticsBookmakerLogin = exports.logToAnalyticsBookmakerLogin = function logToAnalyticsBookmakerLogin(action, store, analytics) {
    var _extends5;

    var feed = action.feed;

    var rpFields = getRPFields();
    var state = store.getState();
    var bookmakerSelector = function bookmakerSelector() {
        return feed;
    };
    var bookmakerInfo = _bookmakersList.selectors.createBookmakerInfoSelector(bookmakerSelector)(state);
    var position = chooseYourBookiePosition;
    chooseYourBookiePosition = null;
    var config = _extends({}, rpFields, (_extends5 = {}, _defineProperty(_extends5, analytics.TRAIT_BOOKMAKER, bookmakerInfo.analyticsName), _defineProperty(_extends5, analytics.TRAIT_LOCATION, position ? 'Choose Your Bookie' : 'Accounts Screen'), _extends5));
    if (position) {
        config[analytics.TRAIT_POSITION] = parseInt(position, 10);
    }
    analytics.identify(undefined, config).then(function () {
        analytics.trackBookmakerLogin(_extends({}, config));
    });
};

var logToAnalyticsBookmakerLoginSuccess = exports.logToAnalyticsBookmakerLoginSuccess = function logToAnalyticsBookmakerLoginSuccess(action, store, analytics) {
    var feed = action.feed;

    var rpFields = getRPFields();
    var state = store.getState();
    var bookmakerSelector = function bookmakerSelector() {
        return feed;
    };
    var bookmakerInfo = _bookmakersList.selectors.createBookmakerInfoSelector(bookmakerSelector)(state);
    var config = _extends({}, rpFields, _defineProperty({}, analytics.TRAIT_BOOKMAKER, bookmakerInfo.analyticsName));
    analytics.identify(undefined, config).then(function () {
        analytics.trackBookmakerLoginSuccess(_extends({}, config));
    });
};

var logToAnalyticsBookmakerLoginFailure = exports.logToAnalyticsBookmakerLoginFailure = function logToAnalyticsBookmakerLoginFailure(action, store, analytics) {
    var _extends7;

    var feed = action.feed,
        err = action.err;

    var rpFields = getRPFields();

    var state = store.getState();

    var bookmakerSelector = function bookmakerSelector() {
        return feed;
    };
    var bookmakerInfo = _bookmakersList.selectors.createBookmakerInfoSelector(bookmakerSelector)(state);
    var config = _extends({}, rpFields, (_extends7 = {}, _defineProperty(_extends7, analytics.TRAIT_BOOKMAKER, bookmakerInfo.analyticsName), _defineProperty(_extends7, analytics.TRAIT_ERROR, err), _extends7));
    analytics.identify(undefined, config).then(function () {
        analytics.trackBookmakerLoginFailure(_extends({}, config));
    });
};

var logToAnalyticsBookmakerOpenAccount = exports.logToAnalyticsBookmakerOpenAccount = function logToAnalyticsBookmakerOpenAccount(analyticsName, analytics) {
    var _extends8;

    var isFromBetslip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var rpFields = getRPFields();

    var config = _extends({}, rpFields, (_extends8 = {}, _defineProperty(_extends8, analytics.TRAIT_BOOKMAKER, analyticsName), _defineProperty(_extends8, analytics.TRAIT_LOCATION, isFromBetslip ? 'Bet slip' : 'Accounts Screen'), _extends8));
    return analytics.identify(undefined, config).then(function () {
        analytics.trackOpenAccount(_extends({}, config));
    });
};

var logToAnalyticsQuickStakeButtonsClick = exports.logToAnalyticsQuickStakeButtonsClick = function logToAnalyticsQuickStakeButtonsClick(bookmakerName, betslipID, horseName, fractionalPrice, stake, raceId, courseName, raceTime, raceDate, analytics) {
    var _config;

    var config = (_config = {}, _defineProperty(_config, analytics.TRAIT_BOOKMAKER, bookmakerName), _defineProperty(_config, analytics.TRAIT_BETSLIP_ID, betslipID), _defineProperty(_config, analytics.TRAIT_HORSE_NAME, horseName), _defineProperty(_config, analytics.TRAIT_ODDS, fractionalPrice), _defineProperty(_config, analytics.TRAIT_STAKE, stake), _defineProperty(_config, analytics.TRAIT_RACE_ID, raceId), _defineProperty(_config, analytics.TRAIT_RACECOURSE, courseName), _defineProperty(_config, analytics.TRAIT_RACE_DATE, raceDate), _defineProperty(_config, analytics.TRAIT_RACE_TIME, raceTime), _config);

    return analytics.identify(undefined, config).then(function () {
        analytics.trackQuickStakeButtonsClick(_extends({}, config));
    });
};

var logToAnalyticsRemoveSelectionClick = exports.logToAnalyticsRemoveSelectionClick = function logToAnalyticsRemoveSelectionClick(betslipID, analytics) {
    var config = _defineProperty({}, analytics.TRAIT_BETSLIP_ID, betslipID);

    return analytics.identify(undefined, config).then(function () {
        analytics.trackRemoveSelectionButtonClick(_extends({}, config));
    });
};

var logToAnalyticsCancelBetClick = exports.logToAnalyticsCancelBetClick = function logToAnalyticsCancelBetClick(bookmakerName, betslipID, selectedBet, analytics) {
    var _config3;

    var config = (_config3 = {}, _defineProperty(_config3, analytics.TRAIT_BOOKMAKER, bookmakerName), _defineProperty(_config3, analytics.TRAIT_BETSLIP_ID, betslipID), _defineProperty(_config3, analytics.TRAIT_HORSE_NAME, selectedBet.horseName), _defineProperty(_config3, analytics.TRAIT_RACE_ID, selectedBet.raceId), _defineProperty(_config3, analytics.TRAIT_RACECOURSE, selectedBet.courseName), _defineProperty(_config3, analytics.TRAIT_RACE_DATE, selectedBet.raceDate), _defineProperty(_config3, analytics.TRAIT_RACE_TIME, selectedBet.raceTime), _config3);

    return analytics.identify(undefined, config).then(function () {
        analytics.trackCancelBetButtonClick(_extends({}, config));
    });
};

var logToAnalyticsDiscardSlipButtonClick = exports.logToAnalyticsDiscardSlipButtonClick = function logToAnalyticsDiscardSlipButtonClick(betslipID, analytics) {
    var config = _defineProperty({}, analytics.TRAIT_BETSLIP_ID, betslipID);

    return analytics.identify(undefined, config).then(function () {
        analytics.trackDiscardSlipButtonClick(_extends({}, config));
    });
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearExternalBetHistoryData = exports.getExternalBetHistoryUrl = exports.toggleIsSettled = exports.getBetHistory = exports.betHistoryPageChange = exports.clearBetHistory = exports.actionTypes = undefined;

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

var _betHistory = __webpack_require__(81);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _formatBetHistory = __webpack_require__(537);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var actionTypes = exports.actionTypes = {
    CLEAR_BET_HISTORY: 'CLEAR_BET_HISTORY',
    BET_HISTORY_REQUESTED: 'BET_HISTORY_REQUESTED',
    BET_HISTORY_RECEIVED: 'BET_HISTORY_RECEIVED',
    BET_HISTORY_PAGE_CHANGE: 'BET_HISTORY_PAGE_CHANGE',
    TOGGLE_IS_SETTLED: 'TOGGLE_IS_SETTLED',
    SET_BET_HISTORY_ERROR: 'SET_BET_HISTORY_ERROR',
    SET_EXTERNAL_BET_HISTORY_URL: 'SET_EXTERNAL_BET_HISTORY_URL',
    SET_EXTERNAL_BET_HISTORY_ERROR: 'SET_EXTERNAL_BET_HISTORY_ERROR',
    CLEAR_EXTERNAL_BET_HISTORY_DATA: 'CLEAR_EXTERNAL_BET_HISTORY_DATA'
};
// import { BET_HISTORY_MAX_REQUEST_LENGTH } from './betHistory.constants';
var clearBetHistory = exports.clearBetHistory = function clearBetHistory() {
    return {
        type: actionTypes.CLEAR_BET_HISTORY
    };
};

var betHistoryPageChange = exports.betHistoryPageChange = function betHistoryPageChange(page) {
    return {
        type: actionTypes.BET_HISTORY_PAGE_CHANGE,
        page: page
    };
};

var betHistoryRequested = function betHistoryRequested(params) {
    return {
        type: actionTypes.BET_HISTORY_REQUESTED,
        params: params
    };
};

var betHistoryReceived = function betHistoryReceived(betHistory, params) {
    return {
        type: actionTypes.BET_HISTORY_RECEIVED,
        betHistory: betHistory,
        params: params
    };
};

var setBetHistoryError = function setBetHistoryError(errorInfo, params) {
    return {
        type: actionTypes.SET_BET_HISTORY_ERROR,
        errorInfo: errorInfo,
        params: params
    };
};

var getBetHistory = exports.getBetHistory = function getBetHistory(bookmaker, isSettled) {
    return function (dispatch) {
        var params = { isSettled: isSettled };

        var requestParams = {
            settled: isSettled ? 'y' : 'n',
            lastNumber: _betHistory.BET_HISTORY_MAX_REQUEST_LENGTH
        };
        dispatch(betHistoryRequested(params));

        return _apiClient2.default.getBetHistory(bookmaker, requestParams).then(function (res) {
            var bets = (0, _lodash2.default)(res, 'data.data', []);
            var formatedBets = (0, _formatBetHistory.formatBetHistoryBets)(bets);

            dispatch(betHistoryReceived(formatedBets, params));
            return formatedBets;
        }).catch(function (err) {
            var errors = (0, _lodash2.default)(err, 'response.data.errors', []);
            var formatedErrors = (0, _formatBetHistory.formatBetHistoryErrors)(errors);

            dispatch(setBetHistoryError(formatedErrors, params));
            return Promise.reject(formatedErrors);
        });
    };
};

var toggleIsSettled = exports.toggleIsSettled = function toggleIsSettled() {
    return {
        type: actionTypes.TOGGLE_IS_SETTLED
    };
};

var setExternalBetHistoryUrl = function setExternalBetHistoryUrl(externalBetHistoryUrl) {
    return {
        type: actionTypes.SET_EXTERNAL_BET_HISTORY_URL,
        externalBetHistoryUrl: externalBetHistoryUrl
    };
};

var setIsExternalBetHistoryError = function setIsExternalBetHistoryError() {
    return {
        type: actionTypes.SET_EXTERNAL_BET_HISTORY_ERROR
    };
};

var getExternalBetHistoryUrl = exports.getExternalBetHistoryUrl = function getExternalBetHistoryUrl(bookie) {
    return function (dispatch) {
        return _apiClient2.default.getExternalBetHistoryUrl(bookie).then(function (response) {
            return dispatch(setExternalBetHistoryUrl((0, _lodash2.default)(response, 'data.meta.bookmaker_url', null)));
        }).catch(function () {
            return dispatch(setIsExternalBetHistoryError());
        });
    };
};

var clearExternalBetHistoryData = exports.clearExternalBetHistoryData = function clearExternalBetHistoryData() {
    return {
        type: actionTypes.CLEAR_EXTERNAL_BET_HISTORY_DATA
    };
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializeLoggedInBookmakers = exports.getUserInfo = exports.setAuthInfo = exports.setLoggedOut = exports.clearJustLoggedInBookmaker = exports.setLogInFailure = exports.setLogInSuccess = exports.setLogIn = exports.actionTypes = undefined;

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _updateAuthToken = __webpack_require__(49);

var _updateAuthToken2 = _interopRequireDefault(_updateAuthToken);

var _loginCookies = __webpack_require__(90);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var actionTypes = exports.actionTypes = {
    SET_AUTH_INFO: 'SET_AUTH_INFO',
    GET_LOGGEDIN_BOOKMAKERS: 'GET_LOGGEDIN_BOOKMAKERS',
    SET_LOGGEDIN_BOOKMAKERS: 'SET_LOGGEDIN_BOOKMAKERS',
    SET_LOGIN: 'SET_LOGIN',
    SET_LOGIN_SUCCESS: 'SET_LOGIN_SUCCESS',
    SET_LOGIN_FAILURE: 'SET_LOGIN_FAILURE',
    CLEAR_JUST_LOGGEDIN: 'CLEAR_JUST_LOGGEDIN',
    SET_LOGGEDOUT: 'SET_LOGGEDOUT',
    POPULATE_BOOKMAKERS_WITH_DATASOURCE: 'POPULATE_BOOKMAKERS_WITH_DATASOURCE',
    USER_INFO_REQUESTING: 'USER_INFO_REQUESTING',
    SET_USER_INFO: 'SET_USER_INFO',
    SET_USER_INFO_ERROR: 'SET_USER_INFO_ERROR'
};

var getLoggedInBookmakers = function getLoggedInBookmakers() {
    return {
        type: actionTypes.GET_LOGGEDIN_BOOKMAKERS
    };
};

var setLoggedInBookmakers = function setLoggedInBookmakers(feeds) {
    return {
        type: actionTypes.SET_LOGGEDIN_BOOKMAKERS,
        feeds: feeds
    };
};

var setLogIn = exports.setLogIn = function setLogIn(feed) {
    return {
        type: actionTypes.SET_LOGIN,
        feed: feed
    };
};

var setLogInSuccess = exports.setLogInSuccess = function setLogInSuccess(feed) {
    return {
        type: actionTypes.SET_LOGIN_SUCCESS,
        feed: feed
    };
};
var setLogInFailure = exports.setLogInFailure = function setLogInFailure(feed, err) {
    return {
        type: actionTypes.SET_LOGIN_FAILURE,
        feed: feed,
        err: err
    };
};

var clearJustLoggedInBookmaker = exports.clearJustLoggedInBookmaker = function clearJustLoggedInBookmaker() {
    return {
        type: actionTypes.CLEAR_JUST_LOGGEDIN
    };
};

var setLoggedOut = exports.setLoggedOut = function setLoggedOut(feed) {
    return {
        type: actionTypes.SET_LOGGEDOUT,
        feed: feed
    };
};

var setAuthInfo = exports.setAuthInfo = function setAuthInfo(feed, info) {
    return {
        type: actionTypes.SET_AUTH_INFO,
        feed: feed,
        info: info
    };
};

var setUserInfoRequesting = function setUserInfoRequesting(feed) {
    return {
        type: actionTypes.USER_INFO_REQUESTING,
        feed: feed
    };
};

var setUserInfo = function setUserInfo(feed, data) {
    return {
        type: actionTypes.SET_USER_INFO,
        feed: feed,
        data: data
    };
};

var setUserInfoError = function setUserInfoError(feed, error) {
    return {
        type: actionTypes.SET_USER_INFO_ERROR,
        feed: feed,
        error: error
    };
};

/**
 * @param  {String} bookie e.g. 'ladbrokes'
 * @param  {String} feed   e.g. 'LADB'
 */
var getUserInfo = exports.getUserInfo = function getUserInfo(bookie, feed) {
    return function (dispatch) {
        dispatch(setUserInfoRequesting(feed));

        var CURRENCY_TO_SIGN_DICTIONARY = {
            GBP: "£",
            EUR: "€",
            USD: "$"
        };

        return _apiClient2.default.getUserInfo(bookie).then(function (res) {
            (0, _updateAuthToken2.default)(res.headers);
            if (!res.data || !res.data.data || !res.data.data[0] || !res.data.data[0].attributes || res.status !== 200) {
                return Promise.reject(res);
            }
            return res.data.data[0].attributes;
        }).then(function (data) {
            var userInfo = {
                userName: data.username,
                balance: parseFloat(data.account_balance.split(',').join('')),
                currency: data.account_currency,
                currencySign: CURRENCY_TO_SIGN_DICTIONARY[data.account_currency],
                freeBetBalance: data.free_bet_balance,
                freeBets: data.free_bets
            };
            dispatch(setUserInfo(feed, userInfo));
        }).catch(function (errorInfo) {
            var data = (0, _lodash2.default)(errorInfo, 'response.data', {});
            dispatch(setUserInfoError(feed, data.data || data));
            return Promise.reject(errorInfo);
        });
    };
};

var getUserBookmakerInfo = function getUserBookmakerInfo() {
    var bookmakerInfoString = window.localStorage.getItem('userAccountsInfo');

    if (!bookmakerInfoString) return null;

    var bookmakersInfo = JSON.parse(bookmakerInfoString);

    return bookmakersInfo;
};

var setBookmakersInfoLoginStatus = function setBookmakersInfoLoginStatus(bookmakerApiNames) {
    var bookmakersInfo = getUserBookmakerInfo();
    if (!bookmakersInfo) return;

    Object.keys(bookmakersInfo).forEach(function (key) {
        var bookmakerInfo = bookmakersInfo[key];
        var isLoggedIn = bookmakerApiNames.indexOf(bookmakerInfo.apiName) !== -1;
        bookmakerInfo.isLoggedIn = isLoggedIn;
    });

    window.localStorage.setItem('userAccountsInfo', JSON.stringify(bookmakersInfo));
};

var initializeLoggedInBookmakers = exports.initializeLoggedInBookmakers = function initializeLoggedInBookmakers(bookmakers) {
    return function (dispatch) {
        dispatch(getLoggedInBookmakers());

        return _apiClient2.default.getCustomerStatus().then(function (res) {
            (0, _updateAuthToken2.default)(res.headers);
            if (!res.data || !res.data.data || res.status !== 200) {
                return Promise.reject(res);
            }
            var loggedInBookmakers = res.data.data.filter(function (item) {
                return item.attributes && item.attributes.active_session;
            });
            var bookmakerApiNames = loggedInBookmakers.map(function (item) {
                return item.id;
            });
            var fullFeeds = [];

            setBookmakersInfoLoginStatus(bookmakerApiNames);

            bookmakers.forEach(function (bookmaker) {
                if (bookmakerApiNames.find(function (item) {
                    return item === bookmaker.apiName;
                })) {
                    fullFeeds.push({
                        feed: bookmaker.feed,
                        apiName: bookmaker.apiName
                    });
                    (0, _loginCookies.setLoginCookie)(bookmaker.cookieName, bookmaker.loginDuration);
                } else {
                    (0, _loginCookies.deleteLoginCookie)(bookmaker.cookieName);
                }
            });

            var partialFeeds = fullFeeds.map(function (item) {
                return item.feed;
            });

            dispatch(setLoggedInBookmakers(partialFeeds));

            return fullFeeds;
        }).then(function (data) {
            data.map(function (_ref) {
                var feed = _ref.feed,
                    apiName = _ref.apiName;
                return dispatch(getUserInfo(apiName, feed));
            });
        }).catch(function (errorInfo) {
            return Promise.reject(errorInfo);
        });
    };
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ErrorBanner = __webpack_require__(589);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ErrorBanner).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalPortal = exports.Modal = undefined;

var _Modal = __webpack_require__(230);

var _Modal2 = _interopRequireDefault(_Modal);

var _ModalPortal = __webpack_require__(616);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Modal = _Modal2.default;
exports.ModalPortal = _ModalPortal2.default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.reducer = exports.default = undefined;

var _TopUp = __webpack_require__(625);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_TopUp).default;
    }
});

var _topUp = __webpack_require__(530);

var _topUp2 = _interopRequireDefault(_topUp);

var _topUp3 = __webpack_require__(217);

var actions = _interopRequireWildcard(_topUp3);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _topUp2.default;
exports.actions = actions;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cleanStakeInput;
function cleanStakeInput(stake) {
    return stake.replace(/[^0-9.]/g, '').replace(/^\./, '0.');
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var pad = function pad(num) {
    return num < 10 ? '0' + num : num;
};

var time12h = function time12h(hr, mn) {
    var amStr = 'am';
    var pmStr = 'pm';

    if (hr === 0) {
        return '12.' + pad(mn) + ' ' + amStr;
    }
    if (hr < 12) {
        return hr + '.' + pad(mn) + ' ' + amStr;
    }
    if (hr === 12) {
        return '12.' + pad(mn) + ' ' + pmStr;
    }
    return hr - 12 + '.' + pad(mn) + ' ' + pmStr;
};

var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

var formatTime = exports.formatTime = function formatTime(date, UTC) {
    var d = date instanceof Date ? date : new Date(date);
    return UTC ? time12h(d.getUTCHours(), d.getUTCMinutes()) : time12h(d.getHours(), d.getMinutes());
};

var formatTime24h = exports.formatTime24h = function formatTime24h(date, UTC) {
    var d = date instanceof Date ? date : new Date(date);
    return UTC ? d.getUTCHours() + '.' + pad(d.getUTCMinutes()) : d.getHours() + '.' + pad(d.getMinutes());
};

var formatDate = exports.formatDate = function formatDate(date, UTC) {
    var d = date instanceof Date ? date : new Date(date);
    return UTC ? pad(d.getUTCDate()) + ' ' + monthNames[d.getUTCMonth()] + ' ' + d.getUTCFullYear() : pad(d.getDate()) + ' ' + monthNames[d.getMonth()] + ' ' + d.getFullYear();
};

var formatDateTime24h = exports.formatDateTime24h = function formatDateTime24h(date, UTC) {
    return formatTime24h(date, UTC) + ', ' + formatDate(date, UTC);
};

var formatDateTimeBetslip = exports.formatDateTimeBetslip = function formatDateTimeBetslip(date, UTC) {
    return formatTime24h(date, UTC) + ' on ' + formatDate(date, UTC);
};

var formatDateTime = exports.formatDateTime = function formatDateTime(date, UTC) {
    return formatTime(date, UTC) + ', ' + formatDate(date, UTC);
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getLocalStorage = exports.getLocalStorage = function getLocalStorage(key) {
    if (!window) {
        return null;
    }

    var item = window.localStorage.getItem(key);

    if (item === undefined || item === null) {
        return null;
    }

    return JSON.parse(item);
};

var setLocalStorage = exports.setLocalStorage = function setLocalStorage(key, obj) {
    window.localStorage.setItem(key, JSON.stringify(obj));
};

var isLocalStorageAvailable = exports.isLocalStorageAvailable = function isLocalStorageAvailable() {
    if (window.localStorage) {
        try {
            window.localStorage.setItem('test', 'test');
            window.localStorage.removeItem('test');

            return true;
        } catch (error) {
            return false;
        }
    } else {
        return false;
    }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLevel = undefined;
exports.create = create;

var _loglevel = __webpack_require__(358);

var _loglevel2 = _interopRequireDefault(_loglevel);

var _currentDate = __webpack_require__(24);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

_loglevel2.default.setLevel('warn'); // set a default level
var methods = ['trace', 'debug', 'info', 'warn', 'error'];

function log(level, prefix) {
    var logLevel = level.toUpperCase();
    return function (msg) {
        _loglevel2.default[level]((0, _currentDate.getCurrentDate)() + '|' + logLevel + '|' + prefix + '|' + msg);
    };
}

function create(classname) {
    return methods.reduce(function (aggr, method) {
        return Object.assign(_defineProperty({}, method, log(method, classname)), aggr);
    }, {});
}

var setLevel = exports.setLevel = _loglevel2.default.setLevel;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _specialCombos;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var forecastMultiples = exports.forecastMultiples = ['straight-forecast', 'reverse-forecast', 'combination-forecast', 'straight-tricast', 'combination-tricast'];

var specialMultiples = exports.specialMultiples = {
    TRIXIE: 'trixie',
    PATENT: 'patent',
    YANKEE: 'yankee',
    LUCKY_15: 'lucky-15',
    CANADIAN: 'canadian',
    LUCKY_31: 'lucky-31',
    HEINZ: 'heinz',
    LUCKY_63: 'lucky-63',
    SUPER_HEINZ: 'super-heinz',
    GOLIATH: 'goliath'
};

var betSizes = {
    SINGLE: 1,
    DOUBLE: 2,
    TREBLE: 3,
    FOUR_FOLD: 4,
    FIVE_FOLD: 5,
    SIX_FOLD: 6,
    SEVEN_FOLD: 7,
    EIGHT_FOLD: 8
};

var specialCombos = exports.specialCombos = (_specialCombos = {}, _defineProperty(_specialCombos, specialMultiples.TRIXIE, [betSizes.DOUBLE, betSizes.TREBLE]), _defineProperty(_specialCombos, specialMultiples.PATENT, [betSizes.SINGLE, betSizes.DOUBLE, betSizes.TREBLE]), _defineProperty(_specialCombos, specialMultiples.YANKEE, [betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD]), _defineProperty(_specialCombos, specialMultiples.LUCKY_15, [betSizes.SINGLE, betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD]), _defineProperty(_specialCombos, specialMultiples.CANADIAN, [betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD, betSizes.FIVE_FOLD]), _defineProperty(_specialCombos, specialMultiples.LUCKY_31, [betSizes.SINGLE, betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD, betSizes.FIVE_FOLD]), _defineProperty(_specialCombos, specialMultiples.HEINZ, [betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD, betSizes.FIVE_FOLD, betSizes.SIX_FOLD]), _defineProperty(_specialCombos, specialMultiples.LUCKY_63, [betSizes.SINGLE, betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD, betSizes.FIVE_FOLD, betSizes.SIX_FOLD]), _defineProperty(_specialCombos, specialMultiples.SUPER_HEINZ, [betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD, betSizes.FIVE_FOLD, betSizes.SIX_FOLD, betSizes.SEVEN_FOLD]), _defineProperty(_specialCombos, specialMultiples.GOLIATH, [betSizes.DOUBLE, betSizes.TREBLE, betSizes.FOUR_FOLD, betSizes.FIVE_FOLD, betSizes.SIX_FOLD, betSizes.SEVEN_FOLD, betSizes.EIGHT_FOLD]), _specialCombos);

/* eslint max-len: 0 */
var multiplesInfo = exports.multiplesInfo = {
    double: {
        formTitle: 'Double',
        title: 'Doubles',
        body: 'A Double consists of 1 bet involving 2 selections from different races.\n\n        Both must be successful to get a return.'
    },
    treble: {
        formTitle: 'Treble',
        title: 'Trebles',
        body: 'A Treble consists of 1 bet involving 3 selections from different races.\n\n        All must be successful to get a return.'
    },
    trixie: {
        formTitle: 'Trixie',
        title: 'Trixies',
        body: 'A Trixie consists of 4 bets involving 3 selections from different races.\n\n        \u201C3 Double bets & 1 Treble bet.\u201D\n\n        A minimum of 2 successful selections will guarantee a return.'
    },
    patent: {
        formTitle: 'Patent',
        title: 'Patents',
        body: 'A Patent consists of 7 bets involving 3 selections from different races.\n\n        \u201C3 Single bets, 3 Double bets & 1 Treble bet.\u201D\n\n        Just one successful selection will guarantee a return.'
    },
    yankee: {
        formTitle: 'Yankee',
        title: 'Yankee',
        body: 'A Yankee consists of 11 bets involving 4 selections from different races.\n\n        "6 Double bets, 4 Treble bets & 1 Fourfold Accumulator bet."\n\n        A minimum of 2 successful selections will guarantee a return.'
    },
    'lucky-15': {
        formTitle: 'Lucky 15',
        title: 'Lucky 15',
        body: 'A Lucky 15 consists of 15 bets involving 4 selections from different races.\n\n        "4 Single bets, 6 Double bets, 4 Treble bets, & 1 Fourfold Accumulator bet."\n\n        Just one successful selection will guarantee a return.'
    },
    canadian: {
        formTitle: 'Canadian',
        title: 'Canadian',
        body: 'A Canadian consists of 26 bets involving 5 selections from different races.\n\n        "10 Double bets, 10 Treble bets, 5 Fourfold Accumulators & 1 Fivefold Accumulator."\n\n        A minimum of 2 successful selections will guarantee a return.'
    },
    'lucky-31': {
        formTitle: 'Lucky 31',
        title: 'Lucky 31',
        body: 'A Lucky 31 consists of 31 bets involving 5 selections from different races.\n\n        "5 Single bets, 10 Double bets, 10 Treble bets, 5 Fourfold Accumulators & 1 Fivefold Accumulator."\n\n        Just one successful selection will guarantee a return.'
    },
    heinz: {
        formTitle: 'Heinz',
        title: 'Heinz',
        body: 'A Heinz consists of 57 bets involving 6 selections from different races.\n\n        "15 Double bets, 20 Treble bets, 15 Fourfold Accumulators, 6 Fivefold Accumulators & 1 Sixfold Accumulator."\n\n        A minimum of 2 successful selections will guarantee a return.'
    },
    'lucky-63': {
        formTitle: 'Lucky 63',
        title: 'Lucky 63',
        body: 'A Lucky 63 consists of 63 bets involving 6 selections from different races.\n\n        "6 Single bets, 15 Double bets, 20 Treble bets, 15 Fourfold Accumulators, 6 Fivefold Accumulators & 1 Sixfold Accumulator."\n\n        Just one successful selection will guarantee a return.'
    },
    'super-heinz': {
        formTitle: 'Super Heinz',
        title: 'Super Heinz',
        body: 'A Super Heniz consists of 120 bets involving 7 selections from different races.\n\n        "21 Double bets, 35 Treble bets, 35 Fourfold Accumulators, 21 Fivefold Accumulators, 7 Sixfold Accumulators & 1 Sevenfold Accumulator."\n\n        A minimum of 2 successful selections will guarantee a return.'
    },
    goliath: {
        formTitle: 'Goliath',
        title: 'Goliath',
        body: 'A Goliath consists of 247 bets involving 8 selections from different races.\n\n        "28 Double bets, 56 Treble bets, 70 Fourfold Accumulators, 56 Fivefold Accumulators, 28 Sixfold Accumulators, 8 Sevenfold Accumulators & 1 Eightfold Accumulator."\n\n        A minimum of 2 successful selections will guarantee a return.'
    },
    accumulator: {
        formTitle: 'Accumulator',
        title: 'Accumulator',
        body: 'An Accumulator consists of 1 bet involving 4 or more selections from different races.\n\n        All selections must be successful to guarantee a return.'
    },
    'straight-forecast': {
        formTitle: 'Forecast',
        title: 'Forecast',
        body: 'A Forecast consists of 2 selections from the same race and asks you to predict who will finish 1st and 2nd in that order.\n\n        You can order your forecast by tapping the arrows next to your selections.'
    },
    'combination-forecast': {
        formTitle: 'Combi Forecast',
        title: 'Combi Forecast',
        body: 'A Combi Forecast consists of 3 or more selections from the same race this bet is made up a multiple separate bets these are a combination of all selected horses finishing 1st and 2nd.'
    },
    'reverse-forecast': {
        formTitle: 'Reverse Forecast',
        title: 'Reverse Forecast',
        body: 'A Reverse Forecast consists of 2 selections from the same race this bet is made up a 2 separate bets these are a combination of either horse finishing 1st and 2nd.'
    },
    'straight-tricast': {
        formTitle: 'Tricast',
        title: 'Tricast',
        body: 'A Tricast consists of 3 selections from the same race and asks you to predict who will finish 1st, 2nd and 3rd in that order.\n\n        You can order your forecast by tapping the arrows next to your selections.'
    },
    'combination-tricast': {
        formTitle: 'Combi Tricast',
        title: 'Combi Tricast',
        body: 'A Combi Tricast consists of 3 or more selections from the same race this bet is made up a multiple separate bets these are a combination of all selected horses finishing 1st, 2nd and 3rd.'
    }
};

var accaNames = exports.accaNames = {
    'accumulator-4': 'Fourfold Accumulator',
    'accumulator-5': 'Fivefold Accumulator',
    'accumulator-6': 'Sixfold Accumulator',
    'accumulator-7': 'Sevenfold Accumulator',
    'accumulator-8': 'Eightfold Accumulator',
    'accumulator-9': 'Ninefold Accumulator',
    'accumulator-10': 'Tenfold Accumulator',
    'accumulator-11': 'Accumulator',
    'accumulator-12': 'Accumulator',
    'accumulator-13': 'Accumulator',
    'accumulator-14': 'Accumulator',
    'accumulator-15': 'Accumulator',
    'accumulator-16': 'Accumulator',
    'accumulator-17': 'Accumulator',
    'accumulator-18': 'Accumulator',
    'accumulator-19': 'Accumulator',
    'accumulator-20': 'Accumulator',
    'accumulator-21': 'Accumulator',
    'accumulator-22': 'Accumulator',
    'accumulator-23': 'Accumulator',
    'accumulator-24': 'Accumulator'
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(14);
var normalizeHeaderName = __webpack_require__(252);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(135);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(135);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(359)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationsAreEqual = exports.createLocation = undefined;

var _resolvePathname = __webpack_require__(470);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(478);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(50);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _listCacheClear = __webpack_require__(321);

var _listCacheClear2 = _interopRequireDefault(_listCacheClear);

var _listCacheDelete = __webpack_require__(322);

var _listCacheDelete2 = _interopRequireDefault(_listCacheDelete);

var _listCacheGet = __webpack_require__(323);

var _listCacheGet2 = _interopRequireDefault(_listCacheGet);

var _listCacheHas = __webpack_require__(324);

var _listCacheHas2 = _interopRequireDefault(_listCacheHas);

var _listCacheSet = __webpack_require__(325);

var _listCacheSet2 = _interopRequireDefault(_listCacheSet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear2.default;
ListCache.prototype['delete'] = _listCacheDelete2.default;
ListCache.prototype.get = _listCacheGet2.default;
ListCache.prototype.has = _listCacheHas2.default;
ListCache.prototype.set = _listCacheSet2.default;

exports.default = ListCache;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Built-in value references. */
var _Symbol = _root2.default.Symbol;

exports.default = _Symbol;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eq = __webpack_require__(52);

var _eq2 = _interopRequireDefault(_eq);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if ((0, _eq2.default)(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

exports.default = assocIndexOf;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(149);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty2.default) {
    (0, _defineProperty2.default)(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

exports.default = baseAssignValue;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isKeyable = __webpack_require__(319);

var _isKeyable2 = _interopRequireDefault(_isKeyable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return (0, _isKeyable2.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

exports.default = getMapData;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNative = __webpack_require__(30);

var _getNative2 = _interopRequireDefault(_getNative);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references that are verified to be native. */
var nativeCreate = (0, _getNative2.default)(Object, 'create');

exports.default = nativeCreate;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction = __webpack_require__(106);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isLength = __webpack_require__(107);

var _isLength2 = _interopRequireDefault(_isLength);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && (0, _isLength2.default)(value.length) && !(0, _isFunction2.default)(value);
}

exports.default = isArrayLike;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseGetTag = __webpack_require__(42);

var _baseGetTag2 = _interopRequireDefault(_baseGetTag);

var _getPrototype = __webpack_require__(152);

var _getPrototype2 = _interopRequireDefault(_getPrototype);

var _isObjectLike = __webpack_require__(31);

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!(0, _isObjectLike2.default)(value) || (0, _baseGetTag2.default)(value) != objectTag) {
    return false;
  }
  var proto = (0, _getPrototype2.default)(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

exports.default = isPlainObject;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _baseGetTag = __webpack_require__(42);

var _baseGetTag2 = _interopRequireDefault(_baseGetTag);

var _isObjectLike = __webpack_require__(31);

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || (0, _isObjectLike2.default)(value) && (0, _baseGetTag2.default)(value) == symbolTag;
}

exports.default = isSymbol;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayMap = __webpack_require__(143);

var _arrayMap2 = _interopRequireDefault(_arrayMap);

var _copyArray = __webpack_require__(148);

var _copyArray2 = _interopRequireDefault(_copyArray);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isSymbol = __webpack_require__(75);

var _isSymbol2 = _interopRequireDefault(_isSymbol);

var _stringToPath = __webpack_require__(157);

var _stringToPath2 = _interopRequireDefault(_stringToPath);

var _toKey = __webpack_require__(51);

var _toKey2 = _interopRequireDefault(_toKey);

var _toString = __webpack_require__(162);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if ((0, _isArray2.default)(value)) {
    return (0, _arrayMap2.default)(value, _toKey2.default);
  }
  return (0, _isSymbol2.default)(value) ? [value] : (0, _copyArray2.default)((0, _stringToPath2.default)((0, _toString2.default)(value)));
}

exports.default = toPath;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;

    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? _react2.default.Children.only(children) : null;
  };

  return Router;
}(_react2.default.Component);

Router.propTypes = {
  history: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node
};
Router.contextTypes = {
  router: _propTypes2.default.object
};
Router.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};

exports.default = Router;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pathToRegexp = __webpack_require__(165);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

exports.default = matchPath;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
	return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var BET_HISTORY_PAGE_LENGTH = exports.BET_HISTORY_PAGE_LENGTH = 25;
var BET_HISTORY_MAX_PAGES_COUNT = exports.BET_HISTORY_MAX_PAGES_COUNT = 1;
var BET_HISTORY_MAX_REQUEST_LENGTH = exports.BET_HISTORY_MAX_REQUEST_LENGTH = BET_HISTORY_MAX_PAGES_COUNT * BET_HISTORY_PAGE_LENGTH + 1;
var BET_HISTORY_REDIRECT_CONFIG = exports.BET_HISTORY_REDIRECT_CONFIG = {
    paddypower: {
        text: 'To view full bet history visit',
        link: 'www.paddypower.com'
    },
    betfair: {
        text: 'To view full bet history visit',
        link: 'www.betfair.com'
    },
    williamhill: {
        text: 'To view full bet history visit',
        link: 'www.williamhill.com'
    },
    bet365: {
        text: 'To view full bet history visit',
        link: 'www.bet365.com'
    },
    ladbrokes: {
        text: 'To view full bet history visit',
        link: 'www.ladbrokes.com'
    },
    coral: {
        text: 'To view full bet history visit',
        link: 'www.coral.co.uk'
    }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var BET_HISTORY_PAGE_LENGTH = exports.BET_HISTORY_PAGE_LENGTH = 5;
var BET_HISTORY_MAX_PAGES_COUNT = exports.BET_HISTORY_MAX_PAGES_COUNT = 5;
var BET_HISTORY_MAX_REQUEST_LENGTH = exports.BET_HISTORY_MAX_REQUEST_LENGTH = BET_HISTORY_MAX_PAGES_COUNT * BET_HISTORY_PAGE_LENGTH + 1;
var BET_HISTORY_REDIRECT_CONFIG = exports.BET_HISTORY_REDIRECT_CONFIG = {
    paddypower: {
        text: 'To view full bet history visit',
        link: 'www.paddypower.com'
    },
    betfair: {
        text: 'To view full bet history visit',
        link: 'www.betfair.com'
    },
    williamhill: {
        text: 'To view full bet history visit',
        link: 'www.williamhill.com'
    },
    bet365: {
        text: 'To view full bet history visit',
        link: 'www.bet365.com'
    },
    ladbrokes: {
        text: 'To view full bet history visit',
        link: 'www.ladbrokes.com'
    },
    coral: {
        text: 'To view full bet history visit',
        link: 'www.coral.co.uk'
    }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BookmakerLink = __webpack_require__(583);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BookmakerLink).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getBookmakersConfig;

var _bookmakers = __webpack_require__(129);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
} /*
   * Configuration object for bookmaker.
   * @typedef {Object} BookmakerConfiguration
   * @property {string} name - prettified (readable) bookmaker name used in CSS-class naming
   * @property {string} apiName - bookmaker name used in API calls
   * @property {string} feed - unique bookmaker name, used for identifying bookmaker.
   * Also used as bookmaker name in diffusion topics creation.
   * @property {string} dynamicDataKey - bookmaker name, used for identifying bookmaker in bookmakers
   * dynamic data "/stubsapi/config" which contains dynamic info from bookmaker
   * (registration offer, promo code, etc.)
   * @property {string} displayName - string, which displayed to users as bookmaker name.
   * Used in 2 modals: during selection current bookmaker to show which bookmaker will be used for
   * all prices and after login in not current bookmaker, to help user use prices for this bookmaker
   * @property {string} analyticsName - bookmaker name which sends to analytics (segmentIO)
   * to track user actions
   * @property {boolean} availableOnPhone - flag which describes whether or not bookmaker
   * is available on mobile phone devices
   * @property {string} cookieName - cookie name set on bookmaker login
   * @property {object} theme - theme configuration for bookmaker
   * @property {string} theme.clearBetIconName - icon name for clearing bet
   * @property {string} theme.clearStakeIconName - icon name for clearing bet stake
   * @property {string} theme.spinnerIconName - icon name for spinner
   * @property {string} theme.checkboxIconType - icon type for checkbox
   * @property {string} loginType - type of bookmaker login. One of: 'form', 'iframe', 'window'
   * @property {boolean} isTopUpIntegrated - describes if bookmakers account can be topuped
   * with betslip API
   * @property {boolean} isExternalBetHistory - describes if bookmaker provides external url
   * for account bet history page
   * @property {boolean} hasLogoOnAccountHeader - describes if bookmaker has its logo in
   * account iframe
   * @property {boolean} isExternalAccount - describes if bookmaker provides iframe for account page,
   * which includes account info and bet history functionality
   * @property {boolean} isExternalLogout - describes if bookmaker provides external logout url,
   * @property {boolean} accountType - type of bookmaker account. One of: 'form', 'iframe', 'window'
   * @property {boolean} hasAccountTabs - describes if bookmaker provides integrated account tabs
   * @property {boolean} freeBetsEnabled - describes if free bets enabled for bookmaker
   * @property {boolean} containsTermsInLoginIframe - describes if bookmaker contains terms
   * and conditions in login iframe
   * @property {boolean} containsTermsInTopUpIframe - describes if bookmaker contains terms
   * and conditions intopupiframe
   */

var coral = _bookmakers.bookmakerNames.coral,
    ladbrokes = _bookmakers.bookmakerNames.ladbrokes,
    bet365 = _bookmakers.bookmakerNames.bet365,
    betfair = _bookmakers.bookmakerNames.betfair,
    paddyPower = _bookmakers.bookmakerNames.paddyPower,
    skybet = _bookmakers.bookmakerNames.skybet,
    williamHill = _bookmakers.bookmakerNames.williamHill;

function generateConfig(cookieNames) {
    return [{
        name: coral,
        apiName: 'coral',
        feed: 'CORAL',
        dynamicDataKey: 'coral',
        displayName: 'Coral',
        analyticsName: 'Coral',
        availableOnPhone: true,
        cookieName: cookieNames.coral,
        theme: {
            clearBetIconName: 'clear-bet',
            clearStakeIconName: 'clear-stake',
            spinnerIconName: 'spinner',
            checkboxIconType: 'color'
        },
        loginType: 'iframe',
        loginDuration: 3600,
        isTopUpIntegrated: true,
        isExternalBetHistory: false,
        hasLogoOnAccountHeader: true,
        isExternalAccount: true,
        isExternalLogout: false,
        accountType: 'iframe',
        hasAccountTabs: true,
        freeBetsEnabled: true,
        topUpBookmakerName: 'www.coral.co.uk',
        topUpBookmakerUrl: 'https://www.coral.co.uk'
    }, {
        name: ladbrokes,
        apiName: 'ladbrokes',
        dynamicDataKey: 'ladbrokes',
        feed: 'LADB',
        displayName: 'Ladbrokes',
        analyticsName: 'Ladbrokes',
        availableOnPhone: true,
        cookieName: cookieNames.ladbrokes,
        theme: {
            clearBetIconName: 'clear-bet',
            clearStakeIconName: 'clear-stake',
            spinnerIconName: 'spinner',
            checkboxIconType: 'color'
        },
        loginType: 'iframe',
        loginDuration: 3600,
        containsTermsInLoginIframe: true,
        isTopUpIntegrated: true,
        isExternalBetHistory: false,
        hasLogoOnAccountHeader: false,
        isExternalAccount: true,
        isExternalLogout: false,
        accountType: 'iframe',
        hasAccountTabs: true,
        containsTermsInTopUpIframe: true,
        freeBetsEnabled: true
    }, {
        name: paddyPower,
        apiName: 'paddypower',
        dynamicDataKey: 'paddypower',
        feed: 'PPWR',
        displayName: 'Paddy Power',
        analyticsName: 'Paddy Power',
        availableOnPhone: true,
        cookieName: cookieNames.paddyPower,
        theme: {
            clearBetIconName: 'clear-bet',
            clearStakeIconName: 'clear-stake',
            spinnerIconName: 'spinner',
            checkboxIconType: 'color'
        },
        loginType: 'window',
        loginDuration: 28800,
        isTopUpIntegrated: true,
        isExternalBetHistory: false,
        hasLogoOnAccountHeader: true,
        isExternalAccount: false,
        isExternalLogout: true,
        accountType: 'form',
        hasAccountTabs: true,
        freeBetsEnabled: true
    }, {
        name: betfair,
        apiName: 'betfair',
        dynamicDataKey: 'betfair',
        feed: 'BETFAIR',
        displayName: 'Betfair',
        analyticsName: 'Betfair',
        availableOnPhone: true,
        cookieName: cookieNames.betfair,
        theme: {
            clearBetIconName: 'clear-bet',
            clearStakeIconName: 'clear-stake',
            spinnerIconName: 'spinner',
            checkboxIconType: 'color'
        },
        loginType: 'window',
        loginDuration: 28800,
        isTopUpIntegrated: true,
        isExternalBetHistory: false,
        hasLogoOnAccountHeader: true,
        isExternalAccount: false,
        isExternalLogout: true,
        accountType: 'form',
        hasAccountTabs: true,
        freeBetsEnabled: true
    }, {
        name: williamHill,
        apiName: 'williamhill',
        dynamicDataKey: 'williamHill',
        feed: 'WH_OXI',
        displayName: 'William Hill',
        analyticsName: 'William Hill',
        availableOnPhone: true,
        cookieName: cookieNames.williamHill,
        theme: {
            clearBetIconName: 'clear-bet',
            clearStakeIconName: 'clear-stake',
            spinnerIconName: 'spinner',
            checkboxIconType: 'color'
        },
        loginType: 'form',
        loginDuration: 28800,
        containsTermsInLoginIframe: true,
        isTopUpIntegrated: true,
        isExternalBetHistory: false,
        hasLogoOnAccountHeader: true,
        isExternalAccount: false,
        isExternalLogout: false,
        accountType: 'form',
        hasAccountTabs: true,
        freeBetsEnabled: true,
        topUpBookmakerName: 'www.williamhill.com',
        topUpBookmakerUrl: 'http://www.williamhill.com'
    }, {
        name: bet365,
        apiName: 'bet365',
        dynamicDataKey: 'bet365',
        feed: 'BET365',
        displayName: 'Bet365',
        analyticsName: 'bet365',
        availableOnPhone: true,
        cookieName: cookieNames.bet365,
        theme: {
            clearBetIconName: 'clear-bet-reverse',
            clearStakeIconName: 'clear-stake-reverse',
            spinnerIconName: 'spinner-reverse',
            checkboxIconType: 'color-reverse'
        },
        loginType: 'iframe',
        loginDuration: 3600,
        isTopUpIntegrated: true,
        isExternalBetHistory: false,
        hasLogoOnAccountHeader: true,
        isExternalAccount: false,
        isExternalLogout: false,
        accountType: 'form',
        hasAccountTabs: true,
        freeBetsEnabled: false,
        topUpBookmakerName: 'www.bet365.com',
        topUpBookmakerUrl: 'https://www.bet365.com'
    }, {
        name: skybet,
        apiName: 'skybet',
        feed: 'SURREY',
        dynamicDataKey: 'skybet',
        displayName: 'Sky Bet',
        analyticsName: 'SkyBet',
        availableOnPhone: true,
        cookieName: cookieNames.skybet,
        theme: {
            clearBetIconName: 'clear-bet',
            clearStakeIconName: 'clear-stake',
            spinnerIconName: 'spinner',
            checkboxIconType: 'color'
        },
        loginType: 'window',
        loginDuration: 3600,
        isTopUpIntegrated: false,
        isExternalBetHistory: true,
        hasLogoOnAccountHeader: true,
        isExternalAccount: true,
        isExternalLogout: true,
        accountType: 'window',
        hasAccountTabs: false,
        freeBetsEnabled: true
    }];
}

function getBookmakersConfig() {
    var _cookieNames;

    var cookieNames = (_cookieNames = {}, _defineProperty(_cookieNames, coral, 'c-c'), _defineProperty(_cookieNames, ladbrokes, 'lb-c'), _defineProperty(_cookieNames, paddyPower, 'pp-c'), _defineProperty(_cookieNames, williamHill, 'wh-c'), _defineProperty(_cookieNames, bet365, 'bet365-c'), _defineProperty(_cookieNames, betfair, 'bf-c'), _defineProperty(_cookieNames, skybet, 'sb-c'), _cookieNames);

    if (false) {
        var _cookieNames2;

        cookieNames = (_cookieNames2 = {}, _defineProperty(_cookieNames2, coral, 'coral-auth'), _defineProperty(_cookieNames2, ladbrokes, 'ladbrokes-auth'), _defineProperty(_cookieNames2, paddyPower, 'paddypower-auth'), _defineProperty(_cookieNames2, williamHill, 'wh-c'), _defineProperty(_cookieNames2, bet365, 'bet365-auth'), _defineProperty(_cookieNames2, betfair, 'betfair-auth'), _defineProperty(_cookieNames2, skybet, 'skybet-auth'), _cookieNames2);
    }

    return generateConfig(cookieNames);
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearExternalAccountData = exports.getExternalAccountUrl = exports.setIsExternalAccountError = exports.setExternalAccountUrl = exports.actionTypes = undefined;

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _updateAuthToken = __webpack_require__(49);

var _updateAuthToken2 = _interopRequireDefault(_updateAuthToken);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var actionTypes = exports.actionTypes = {
    SET_EXTERNAL_ACCOUNT_URL: 'SET_EXTERNAL_ACCOUNT_URL',
    SET_EXTERNAL_ACCOUNT_ERROR: 'SET_EXTERNAL_ACCOUNT_ERROR',
    CLEAR_EXTERNAL_ACCOUNT_DATA: 'CLEAR_EXTERNAL_ACCOUNT_DATA'
};

var setExternalAccountUrl = exports.setExternalAccountUrl = function setExternalAccountUrl(externalAccountUrl) {
    return {
        type: actionTypes.SET_EXTERNAL_ACCOUNT_URL,
        externalAccountUrl: externalAccountUrl
    };
};

var setIsExternalAccountError = exports.setIsExternalAccountError = function setIsExternalAccountError() {
    return {
        type: actionTypes.SET_EXTERNAL_ACCOUNT_ERROR
    };
};

var getExternalAccountUrl = exports.getExternalAccountUrl = function getExternalAccountUrl(bookie) {
    return function (dispatch) {
        return _apiClient2.default.getExternalAccountUrl(bookie).then(function (res) {
            (0, _updateAuthToken2.default)(res.headers);
            if (res.status === 200 && res.data && res.data.data && res.data.data[0] && res.data.data[0].attributes) {
                return dispatch(setExternalAccountUrl(res.data.data[0].attributes.bookmaker_url));
            }
            return Promise.reject(res);
        }).catch(function () {
            return dispatch(setIsExternalAccountError());
        });
    };
};

var clearExternalAccountData = exports.clearExternalAccountData = function clearExternalAccountData() {
    return {
        type: actionTypes.CLEAR_EXTERNAL_ACCOUNT_DATA
    };
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _PageHeader = __webpack_require__(618);

var _PageHeader2 = _interopRequireDefault(_PageHeader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _PageHeader2.default;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return 0.5 - Math.random();
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateReturn = calculateReturn;
exports.getTotalEstimatedReturnText = getTotalEstimatedReturnText;
exports.getSingleEstimatedReturnText = getSingleEstimatedReturnText;
exports.getMultipleEstimatedReturnText = getMultipleEstimatedReturnText;

var _parseFraction = __webpack_require__(132);

var _parseFraction2 = _interopRequireDefault(_parseFraction);

var _multiplesReturns = __webpack_require__(220);

var _formFormatters = __webpack_require__(130);

var _formFormatters2 = _interopRequireDefault(_formFormatters);

var _formatReturns = __webpack_require__(89);

var _formatReturns2 = _interopRequireDefault(_formatReturns);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function singleIsSp(priceType, isSpOnly) {
    return priceType === _priceTypes2.default.SP || isSpOnly === true;
}

function stakeIsValid(stake) {
    var parsedStake = parseFloat(stake, 10);
    return !isNaN(parsedStake) && parsedStake > 0;
}

/**
 * Calculate estimated return
 *
 * @param {Number} stake - stake for race
 * @param {String} fractionalPrice - representation of fractiolnal price, e.g. 'Evs', '1/2', '1/4'
 * @param {String} ewFractional - representation of eachWay fractional value
 * for each way bet. Should be empty if do not need to calculate each way stake.
 * @param {Boolean} placeOnly - return just the place returns for an EW bet
 *
 * @return {Number} - estimated return
 */
function calculateReturn(stake, fractionalPrice, ewFractional, placeOnly) {
    var parsedFractional = fractionalPrice === 'Evs' ? 1 : (0, _parseFraction2.default)(fractionalPrice);
    var result = parsedFractional * stake + stake;
    if (ewFractional) {
        var parsedEWFractional = (0, _parseFraction2.default)(ewFractional);
        var placeReturns = parsedFractional * stake * parsedEWFractional + stake;
        if (placeOnly) {
            return placeReturns;
        }
        result += placeReturns;
    }
    return result;
}

/**
 * Calculate the returns for a single bet
 *
 * @param  {Object} bet (from selectedBets)
 *
 * @return {Number}
 */
function getReturnsForSingle(bet) {
    var stake = bet.stake,
        isEachWay = bet.isEachWay,
        fractionalPrice = bet.fractionalPrice,
        eachWayFraction = bet.eachWayFraction,
        priceType = bet.priceType,
        isSpOnly = bet.isSpOnly;

    // Any SP singles with no stake should be skipped
    // (Note that SP singles with a stake will be caught above)

    if (singleIsSp(priceType, isSpOnly)) {
        return 0;
    }

    // Assume that all remaining cases are an Odds price
    var parsedStake = Number.parseFloat(stake) || 0;
    var betReturn = calculateReturn(parsedStake, fractionalPrice, isEachWay && eachWayFraction);

    return betReturn;
}

/**
 * Calculate the total returns for all single selections in the
 * user's betslip.
 *
 * @param  {Array} selectedBets
 *
 * @return {Number}
 */
function getReturnsForSingles(selectedBets) {
    if (selectedBets.length === 0) {
        return 0;
    }

    return selectedBets.reduce(function (runningTotal, bet) {
        var betReturn = getReturnsForSingle(bet);
        return runningTotal + betReturn;
    }, 0);
}

/**
 * Cap returns at 2m, apply local formatting
 *
 * @param  {Number returns
 * @param  {String} currencySign
 *
 * @return {String}
 */
function postProcessReturns(returns, currencySign) {
    var MAX_RETURNS = 10000000; // Oh boy!
    var total = returns > MAX_RETURNS ? MAX_RETURNS : returns;
    var formattedReturns = (0, _formatReturns2.default)(total);
    var currencyFormattedReturns = (0, _formFormatters2.default)(currencySign)(formattedReturns);

    return currencyFormattedReturns;
}

var determineTotalReturns = function determineTotalReturns(summed, freeBetIsSelected, freeBetAmount, selectedBets, multiples) {
    // If free bet is not selected, or should not be selected, skip this
    if (!freeBetIsSelected || !freeBetAmount || selectedBets.length !== 1 || multiples.length > 0) {
        return summed;
    }

    // If we are in a free bet scenario, subtract the free bet amount
    var total = summed;
    var bet = selectedBets[0];
    var stake = parseFloat(bet.stake, 10); // can be NaN (no stake)

    if (isNaN(stake)) {
        return summed;
    }

    // Double the base stake when EW
    var totalStake = bet.isEachWay ? stake * 2 : stake;

    // Subtract the free stake from the total
    var freeStake = freeBetAmount >= totalStake ? totalStake : freeBetAmount;

    total -= freeStake;

    return total;
};

/**
 * Calculates the estimated returns for ALL bets and formats it.
 * Includes single bets, multiples and forecast bets.
 *
 * Note that use of Each Way (EW) and Starting Price (SP) are important
 * and in scenarios where we cannot calculate the returns on the client,
 * we display "N/A".
 *
 * @param  {Array} selectedBets (contains diffusion EW data)
 * @param  {Array} multiples (contains backend multiples data)
 * @param  {String} currencySign
 * @param  {Boolean} freeBetIsSelected
 * @param  {Number} freeBetAmount
 *
 * @return {String} e.g. '£22.50'
 */
function getTotalEstimatedReturnText(selectedBets, multiples, currencySign, freeBetIsSelected, freeBetAmount) {
    // Always display 'N/A' if any staked SP bets are detected
    var stakedSpSingles = selectedBets.some(function (bet) {
        var priceType = bet.priceType,
            isSpOnly = bet.isSpOnly,
            stake = bet.stake;

        return singleIsSp(priceType, isSpOnly) && stakeIsValid(stake);
    });

    if (stakedSpSingles) {
        return 'N/A';
    }

    var includedSelectedBets = selectedBets.filter(function (bet) {
        return bet.includeInMultiples;
    });
    var spMultiplesSelection = includedSelectedBets.find(function (bet) {
        return singleIsSp(bet.priceType, bet.isSpOnly);
    });

    // stakedSpMultiples or stakedForecasts = N/A
    var stakedMultiplesWithNoReturn = multiples.some(function (multiple) {
        var betType = multiple.betType,
            stakeValue = multiple.stakeValue;

        var hasValidStake = stakeIsValid(stakeValue);
        var isStakedWithSp = hasValidStake && spMultiplesSelection;
        var isStakedForecast = hasValidStake && (0, _multiplesReturns.isForecastMultiple)(betType);
        return isStakedWithSp || isStakedForecast;
    });

    if (stakedMultiplesWithNoReturn) {
        return 'N/A';
    }

    // Otherwise, calculate the returns for all singles & multiples
    // Plus, take into account free bets
    var singlesTotal = getReturnsForSingles(selectedBets);
    var multiplesTotal = (0, _multiplesReturns.getReturnsForMultiples)(includedSelectedBets, multiples);
    var summed = singlesTotal + multiplesTotal;
    var total = determineTotalReturns(summed, freeBetIsSelected, freeBetAmount, selectedBets, multiples);

    return postProcessReturns(total, currencySign);
}

/**
 * Gets the estimated returns text for any single bet.
 *
 * @param  {Object} bet (from selectedBets)
 * @param  {String} currencySign
 *
 * @return {String} e.g. '£25.53' or 'N/A'
 */
function getSingleEstimatedReturnText(bet, currencySign) {
    var priceType = bet.priceType,
        isSpOnly = bet.isSpOnly,
        stake = bet.stake;

    var isSp = singleIsSp(priceType, isSpOnly);
    var hasValidStake = stakeIsValid(stake);

    if (isSp && hasValidStake) {
        return 'N/A';
    }

    var total = getReturnsForSingle(bet);

    return postProcessReturns(total, currencySign);
}

/**
 * Gets the estimated returns text for any multiple bet.
 *
 * @param  {Array} selectedBets
 * @param  {Object} multiple (from build bets)
 * @param  {String} currencySign
 *
 * @return {String} e.g. '£25.53' or 'N/A'
 */
function getMultipleEstimatedReturnText(selectedBets, multiple, currencySign) {
    var total = (0, _multiplesReturns.getReturnsForMultiple)(selectedBets, multiple);

    // If any SP is selected in the multiple's corresponding selections, return N/A
    var spBet = selectedBets.find(function (bet) {
        return bet.includeInMultiples && singleIsSp(bet.priceType, bet.isSpOnly);
    });
    if (spBet) {
        return 'N/A';
    }

    return postProcessReturns(total, currencySign);
}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _roundHalfDown = __webpack_require__(221);

var _roundHalfDown2 = _interopRequireDefault(_roundHalfDown);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (x) {
  return (0, _roundHalfDown2.default)(x).toFixed(2);
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLoginCookie = setLoginCookie;
exports.deleteLoginCookie = deleteLoginCookie;

var _cookie = __webpack_require__(23);

function setLoginCookie(cookieName, duration) {
    if (!(0, _cookie.getCookie)(cookieName)) {
        var date = new Date();

        date.setSeconds(duration);
        (0, _cookie.setCookie)(cookieName + '=' + cookieName + '; ' + ('domain=.' + location.host.split('.').slice(1).join('.') + '; ') + 'path=/; ' + ('expires=' + date.toUTCString()));
    }
}

function deleteLoginCookie(cookieName) {
    if ((0, _cookie.getCookie)(cookieName)) {
        (0, _cookie.deleteCookie)(cookieName, location.host.split('.').slice(1).join('.'));
    }
}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(238);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNative = __webpack_require__(30);

var _getNative2 = _interopRequireDefault(_getNative);

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references that are verified to be native. */
var Map = (0, _getNative2.default)(_root2.default, 'Map');

exports.default = Map;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapCacheClear = __webpack_require__(326);

var _mapCacheClear2 = _interopRequireDefault(_mapCacheClear);

var _mapCacheDelete = __webpack_require__(327);

var _mapCacheDelete2 = _interopRequireDefault(_mapCacheDelete);

var _mapCacheGet = __webpack_require__(328);

var _mapCacheGet2 = _interopRequireDefault(_mapCacheGet);

var _mapCacheHas = __webpack_require__(329);

var _mapCacheHas2 = _interopRequireDefault(_mapCacheHas);

var _mapCacheSet = __webpack_require__(330);

var _mapCacheSet2 = _interopRequireDefault(_mapCacheSet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear2.default;
MapCache.prototype['delete'] = _mapCacheDelete2.default;
MapCache.prototype.get = _mapCacheGet2.default;
MapCache.prototype.has = _mapCacheHas2.default;
MapCache.prototype.set = _mapCacheSet2.default;

exports.default = MapCache;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListCache = __webpack_require__(67);

var _ListCache2 = _interopRequireDefault(_ListCache);

var _stackClear = __webpack_require__(343);

var _stackClear2 = _interopRequireDefault(_stackClear);

var _stackDelete = __webpack_require__(344);

var _stackDelete2 = _interopRequireDefault(_stackDelete);

var _stackGet = __webpack_require__(345);

var _stackGet2 = _interopRequireDefault(_stackGet);

var _stackHas = __webpack_require__(346);

var _stackHas2 = _interopRequireDefault(_stackHas);

var _stackSet = __webpack_require__(347);

var _stackSet2 = _interopRequireDefault(_stackSet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache2.default(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear2.default;
Stack.prototype['delete'] = _stackDelete2.default;
Stack.prototype.get = _stackGet2.default;
Stack.prototype.has = _stackHas2.default;
Stack.prototype.set = _stackSet2.default;

exports.default = Stack;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIsEqualDeep = __webpack_require__(277);

var _baseIsEqualDeep2 = _interopRequireDefault(_baseIsEqualDeep);

var _isObjectLike = __webpack_require__(31);

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !(0, _isObjectLike2.default)(value) && !(0, _isObjectLike2.default)(other)) {
    return value !== value && other !== other;
  }
  return (0, _baseIsEqualDeep2.default)(value, other, bitmask, customizer, baseIsEqual, stack);
}

exports.default = baseIsEqual;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

exports.default = isIndex;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isSymbol = __webpack_require__(75);

var _isSymbol2 = _interopRequireDefault(_isSymbol);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if ((0, _isArray2.default)(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, _isSymbol2.default)(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

exports.default = isKey;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

exports.default = isPrototype;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

exports.default = identity;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIsArguments = __webpack_require__(276);

var _baseIsArguments2 = _interopRequireDefault(_baseIsArguments);

var _isObjectLike = __webpack_require__(31);

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = (0, _baseIsArguments2.default)(function () {
  return arguments;
}()) ? _baseIsArguments2.default : function (value) {
  return (0, _isObjectLike2.default)(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

exports.default = isArguments;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

var _stubFalse = __webpack_require__(356);

var _stubFalse2 = _interopRequireDefault(_stubFalse);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root2.default.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || _stubFalse2.default;

exports.default = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)(module)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseGetTag = __webpack_require__(42);

var _baseGetTag2 = _interopRequireDefault(_baseGetTag);

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!(0, _isObject2.default)(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = (0, _baseGetTag2.default)(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

exports.default = isFunction;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

exports.default = isLength;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIsTypedArray = __webpack_require__(280);

var _baseIsTypedArray2 = _interopRequireDefault(_baseIsTypedArray);

var _baseUnary = __webpack_require__(294);

var _baseUnary2 = _interopRequireDefault(_baseUnary);

var _nodeUtil = __webpack_require__(335);

var _nodeUtil2 = _interopRequireDefault(_nodeUtil);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil2.default && _nodeUtil2.default.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? (0, _baseUnary2.default)(nodeIsTypedArray) : _baseIsTypedArray2.default;

exports.default = isTypedArray;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayLikeKeys = __webpack_require__(142);

var _arrayLikeKeys2 = _interopRequireDefault(_arrayLikeKeys);

var _baseKeys = __webpack_require__(282);

var _baseKeys2 = _interopRequireDefault(_baseKeys);

var _isArrayLike = __webpack_require__(73);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return (0, _isArrayLike2.default)(object) ? (0, _arrayLikeKeys2.default)(object) : (0, _baseKeys2.default)(object);
}

exports.default = keys;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = debounce;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(362);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Router = __webpack_require__(77);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matchPath = __webpack_require__(78);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isEmptyChildren = function isEmptyChildren(children) {
  return _react2.default.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? _react2.default.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);

    return null;
  };

  return Route;
}(_react2.default.Component);

Route.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.object.isRequired,
    route: _propTypes2.default.object.isRequired,
    staticContext: _propTypes2.default.object
  })
};
Route.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};

exports.default = Route;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pathToRegexp = __webpack_require__(165);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = _pathToRegexp2.default.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

exports.default = generatePath;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollTop = getScrollTop;
exports.getScrollLeft = getScrollLeft;
exports.getArrowSpacing = getArrowSpacing;
exports.getScrollParent = getScrollParent;
exports.noArrowDistance = exports.bodyPadding = exports.minArrowPadding = void 0;

/**
 * a handful of shared functions and constants
 */
var minArrowPadding = 5;
exports.minArrowPadding = minArrowPadding;
var bodyPadding = 10;
exports.bodyPadding = bodyPadding;
var noArrowDistance = 3;
/**
 * cross browser scroll positions
 */

exports.noArrowDistance = noArrowDistance;

function getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function getScrollLeft() {
  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
}

function getArrowSpacing(props) {
  var defaultArrowSpacing = props.arrow ? props.arrowSize : noArrowDistance;
  return typeof props.distance === 'number' ? props.distance : defaultArrowSpacing;
}
/**
 * get first ancestor that might scroll
 */

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var scrollParent = window;

  if (style.position !== 'fixed') {
    var parent = element.parentElement;

    while (parent) {
      var parentStyle = getComputedStyle(parent);

      if (/(auto|scroll)/.test(parentStyle.overflow + parentStyle.overflowY + parentStyle.overflowX)) {
        scrollParent = parent;
        parent = undefined;
      } else {
        parent = parent.parentElement;
      }
    }
  }

  return scrollParent;
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = exports.prefix = '@@redux-form/';

var ARRAY_INSERT = exports.ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = exports.ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = exports.ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = exports.ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = exports.ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = exports.ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = exports.ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = exports.ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = exports.AUTOFILL = prefix + 'AUTOFILL';
var BLUR = exports.BLUR = prefix + 'BLUR';
var CHANGE = exports.CHANGE = prefix + 'CHANGE';
var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = exports.CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = exports.DESTROY = prefix + 'DESTROY';
var FOCUS = exports.FOCUS = prefix + 'FOCUS';
var INITIALIZE = exports.INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = exports.REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = exports.RESET = prefix + 'RESET';
var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = exports.START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = exports.STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = exports.SUBMIT = prefix + 'SUBMIT';
var TOUCH = exports.TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = exports.UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasError = __webpack_require__(422);

var _hasError2 = _interopRequireDefault(_hasError);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = (0, _hasError2.default)(structure);
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var formState = getFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

exports.default = createIsValid;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _persistReducer = __webpack_require__(120);

Object.defineProperty(exports, 'persistReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_persistReducer).default;
  }
});

var _persistCombineReducers = __webpack_require__(459);

Object.defineProperty(exports, 'persistCombineReducers', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_persistCombineReducers).default;
  }
});

var _persistStore = __webpack_require__(460);

Object.defineProperty(exports, 'persistStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_persistStore).default;
  }
});

var _createMigrate = __webpack_require__(456);

Object.defineProperty(exports, 'createMigrate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createMigrate).default;
  }
});

var _createTransform = __webpack_require__(457);

Object.defineProperty(exports, 'createTransform', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createTransform).default;
  }
});

var _getStoredState = __webpack_require__(190);

Object.defineProperty(exports, 'getStoredState', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getStoredState).default;
  }
});

var _createPersistoid = __webpack_require__(189);

Object.defineProperty(exports, 'createPersistoid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createPersistoid).default;
  }
});

var _purgeStoredState = __webpack_require__(191);

Object.defineProperty(exports, 'purgeStoredState', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_purgeStoredState).default;
  }
});

var _constants = __webpack_require__(32);

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = persistReducer;

var _constants = __webpack_require__(32);

var _autoMergeLevel = __webpack_require__(461);

var _autoMergeLevel2 = _interopRequireDefault(_autoMergeLevel);

var _createPersistoid = __webpack_require__(189);

var _createPersistoid2 = _interopRequireDefault(_createPersistoid);

var _getStoredState = __webpack_require__(190);

var _getStoredState2 = _interopRequireDefault(_getStoredState);

var _purgeStoredState = __webpack_require__(191);

var _purgeStoredState2 = _interopRequireDefault(_purgeStoredState);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storageLocal from 'redux-persist/es/storage/local'");
  }

  var version = config.version !== undefined ? config.version : _constants.DEFAULT_VERSION;
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? _autoMergeLevel2.default : config.stateReconciler;
  var getStoredState = config.getStoredState || _getStoredState2.default;
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === _constants.PERSIST) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) console.error('redux-persist: rehydrate for "' + config.key + '" called after timeout.', payload, err);

        // only rehydrate if we are not already sealed
        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
      }, timeout);

      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = (0, _createPersistoid2.default)(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === _constants.PURGE) {
      _purge = true;
      action.result((0, _purgeStoredState2.default)(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === _constants.FLUSH) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === _constants.PAUSE) {
      _paused = true;
    } else if (action.type === _constants.REHYDRATE) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        // only reconcile state if stateReconciler and inboundState are both defined
        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
        return conditionalUpdate(_newState);
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // run base reducer:
    // is state modified ? return original : return updated
    var newState = baseReducer(restState, action);
    if (newState === restState) return state;else {
      newState._persist = _persist;
      return conditionalUpdate(newState);
    }
  };
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = exports.actionTypes = {
    SET_INITIALIZED: 'SET_INITIALIZED'
};

var setInitialized = exports.setInitialized = function setInitialized() {
    return {
        type: actionTypes.SET_INITIALIZED
    };
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = exports.actionTypes = {
    SET_REDIRECT_LOGIN_BOOKMAKER: 'SET_REDIRECT_LOGIN_BOOKMAKER',
    CLEAR_REDIRECT_LOGIN_BOOKMAKER: 'CLEAR_REDIRECT_LOGIN_BOOKMAKER'
};

var setRedirectLoginBookmaker = exports.setRedirectLoginBookmaker = function setRedirectLoginBookmaker(feed) {
    return {
        type: actionTypes.SET_REDIRECT_LOGIN_BOOKMAKER,
        feed: feed
    };
};

var clearRedirectLoginBookmaker = exports.clearRedirectLoginBookmaker = function clearRedirectLoginBookmaker() {
    return {
        type: actionTypes.CLEAR_REDIRECT_LOGIN_BOOKMAKER
    };
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var LOGIN_TYPE = exports.LOGIN_TYPE = {
    FORM: 'form',
    IFRAME: 'iframe',
    WINDOW: 'window'
};

var RECENT_BOOKMAKERS_MAP = exports.RECENT_BOOKMAKERS_MAP = {
    bet365: 'bet365',
    betfair: 'betfair',
    coral: 'coral',
    ladbrokes: 'ladbrokes',
    paddypower: 'paddypower',
    skybet: 'skybet',
    williamhill: 'williamhill'
};

var BOOKMAKERS_QUIZ = exports.BOOKMAKERS_QUIZ = ["sky_bet_quiz", "william_hill_quiz", "paddy_power_quiz", "betfair_quiz", "bet365_quiz", "ladbrokes_quiz", "coral_quiz", "tote_quiz"];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.reducer = undefined;

var _gdpr = __webpack_require__(525);

var _gdpr2 = _interopRequireDefault(_gdpr);

var _gdpr3 = __webpack_require__(215);

var actions = _interopRequireWildcard(_gdpr3);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _gdpr2.default;
exports.actions = actions;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GENERIC_ERROR = exports.GENERIC_ERROR = {
    title: 'There’s been a problem',
    body: 'Something went wrong, please try again',
    ctaTitle: 'OK'
};

var EACHWAY_UNAVAILABLE = exports.EACHWAY_UNAVAILABLE = {
    title: 'EW not available',
    body: 'Each Way is not available for this race',
    ctaTitle: 'OK'
};

var ENTER_STAKE = exports.ENTER_STAKE = {
    title: 'Please enter stake',
    body: 'You must enter at least one stake to place a bet',
    ctaTitle: 'OK'
};

var BOG_UNAVAILABLE = exports.BOG_UNAVAILABLE = {
    title: 'There’s been a problem',
    body: 'The best odds guarantee is not available for this selection, please try again later',
    ctaTitle: 'OK'
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NumericKeypad = __webpack_require__(617);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NumericKeypad).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = __webpack_require__(622);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spinner).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StakeField = __webpack_require__(623);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StakeField).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bookmakerNames = exports.bookmakerNames = {
    coral: 'coral',
    ladbrokes: 'ladbrokes',
    paddyPower: 'paddyPower',
    betfair: 'betfair',
    williamHill: 'williamHill',
    bet365: 'bet365',
    skybet: 'skybet',
    bestOdds: 'BestOdds',
    betfred: 'Betfred',
    boyleSports: 'BoyleSports',
    betVictor: 'BetVictor',
    tote: 'TOTE'
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (currencySign) {
    return function (value) {
        return "" + currencySign + value;
    };
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _roundHalfDown = __webpack_require__(221);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_roundHalfDown).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.default = parseFraction;
/**
 * Parse decimal fraction from 'numerator/denominator' fraction string
 * @param {String} fraction - 'numerator/denominator' string, e.g. '1/4', '4/1', '9/2',
 * @return {Number} decimal fraction, e.g. 0.25, 4.0, 4.5
 */
function parseFraction(frac) {
    var _ref = frac === 'Evs' ? ['1', '1'] : frac.split('/'),
        _ref2 = _slicedToArray(_ref, 2),
        numerator = _ref2[0],
        denominator = _ref2[1];

    return parseInt(numerator, 10) / parseInt(denominator, 10);
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reducer = exports.selectors = exports.actions = exports.default = undefined;

var _Drawer = __webpack_require__(630);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Drawer).default;
    }
});

var _drawer = __webpack_require__(38);

var actions = _interopRequireWildcard(_drawer);

var _drawer2 = __webpack_require__(225);

var selectors = _interopRequireWildcard(_drawer2);

var _drawer3 = __webpack_require__(224);

var _drawer4 = _interopRequireDefault(_drawer3);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.actions = actions;
exports.selectors = selectors;
exports.reducer = _drawer4.default;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(667);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var objectToCSV = function objectToCSV(obj) {
    var valueSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '=';
    var itemsSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    return Object.keys(obj).map(function (key) {
        return '' + key + valueSeparator + obj[key];
    }).join(itemsSeparator);
};

var flow = function flow() {
    for (var _len = arguments.length, actions = Array(_len), _key = 0; _key < _len; _key++) {
        actions[_key] = arguments[_key];
    }

    return function (value) {
        return actions.reduce(function (args, action) {
            return action(args);
        }, value);
    };
};

var getWindowPosition = function getWindowPosition(options, opener) {
    return {
        top: (opener.innerHeight - options.height) / 2 + opener.screenY,
        left: (opener.innerWidth - options.width) / 2 + opener.screenX
    };
};

var _ref3 = _jsx('span', {
    className: 'bs-externalAccount__error'
}, void 0, 'Please enable pop-ups in your web browser to view account');

var _ref5 = _jsx('span', {
    className: 'bs-externalAccount__error'
}, void 0, 'Unable to access account details');

var ExternalAccount = function (_Component) {
    _inherits(ExternalAccount, _Component);

    function ExternalAccount() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ExternalAccount);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExternalAccount.__proto__ || Object.getPrototypeOf(ExternalAccount)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (_ref2) {
            var _ref2$data = _ref2.data,
                event = _ref2$data.event,
                data = _ref2$data.data;
            var _this$props = _this.props,
                onExternalBackButtonClick = _this$props.onExternalBackButtonClick,
                onLogout = _this$props.onLogout,
                onServerError = _this$props.onServerError;


            if ((event === 'dashboard' || event === 'default') && data.success && onExternalBackButtonClick) {
                onExternalBackButtonClick();
            }
            if (event === 'log-out' && data.success && onLogout) {
                onLogout();
            }
            if (event === 'serverError' && onServerError) {
                onServerError();
            }
        }, _this.onIframeSetRef = function (node) {
            _this.iframe = node;
        }, _this.checkIfWindowOpened = function () {
            var onExternalBackButtonClick = _this.props.onExternalBackButtonClick;
            var newWindowInstance = _this.state.newWindowInstance;


            if (newWindowInstance && newWindowInstance.closed) {
                onExternalBackButtonClick();
            }
        }, _this.renderAccountInterface = function () {
            var _this$props2 = _this.props,
                externalAccountUrl = _this$props2.externalAccountUrl,
                type = _this$props2.type;


            if (type === 'window') {
                var newWindowInstance = _this.state.newWindowInstance;

                var windowNotOpened = !newWindowInstance || typeof newWindowInstance.closed === 'undefined';

                return windowNotOpened ? _ref3 : null;
            }

            return _jsx('div', {
                className: 'bs-externalAccount__wrapper'
            }, void 0, _react2.default.createElement('iframe', {
                ref: _this.onIframeSetRef,
                className: 'bs-iframeContainer',
                src: externalAccountUrl,
                title: 'accountInfo'
            }));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ExternalAccount, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var type = this.props.type;


            window.addEventListener('message', this.onMessage, false);

            if (type === 'window') {
                var _props = this.props,
                    width = _props.width,
                    height = _props.height,
                    externalAccountUrl = _props.externalAccountUrl,
                    windowName = _props.windowName;

                var position = getWindowPosition({ width: width, height: height }, window);
                var configurationString = objectToCSV(_extends({}, position, {
                    width: width,
                    height: height
                }));
                var newWindowInstance = window.open(externalAccountUrl, windowName, configurationString);

                if (newWindowInstance) {
                    newWindowInstance.focus();
                }
                var onTimerCheck = flow(this.checkIfWindowOpened);
                var timerIdentifier = setInterval(onTimerCheck, 100);
                this.setState({
                    newWindowInstance: newWindowInstance,
                    timerIdentifier: timerIdentifier
                });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref4) {
            var type = _ref4.type,
                newWidth = _ref4.width,
                newHeight = _ref4.height,
                newExternalAccountUrl = _ref4.externalAccountUrl;

            if (type === 'window') {
                var _state = this.state,
                    newWindowInstance = _state.newWindowInstance,
                    isExternalAccountError = _state.isExternalAccountError;

                if (newWindowInstance && !newWindowInstance.closed) {
                    var _props2 = this.props,
                        width = _props2.width,
                        height = _props2.height,
                        externalAccountUrl = _props2.externalAccountUrl;

                    if (!newExternalAccountUrl || isExternalAccountError) {
                        clearTimeout(this.state.timerIdentifier);
                        newWindowInstance.close();
                    }
                    if (externalAccountUrl !== newExternalAccountUrl) {
                        newWindowInstance.location.href = newExternalAccountUrl;
                    }
                    if (width !== newWidth || height !== newHeight) {
                        newWindowInstance.resizeTo(newWidth, newHeight);
                        newWindowInstance.focus();
                    }
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var type = this.props.type;


            window.removeEventListener('message', this.onMessage, false);

            if (type === 'window') {
                var newWindowInstance = this.state.newWindowInstance;


                clearTimeout(this.state.timerIdentifier);
                if (newWindowInstance && !newWindowInstance.closed) {
                    newWindowInstance.close();
                }
            } else {
                this.iframe.blur();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var isExternalAccountError = this.props.isExternalAccountError;

            return isExternalAccountError ? _ref5 : this.renderAccountInterface();
        }
    }]);

    return ExternalAccount;
}(_react.Component);

ExternalAccount.defaultProps = {
    width: 750,
    height: 575,
    type: 'iframe',
    windowName: '',
    externalAccountUrl: '',
    isExternalAccountError: false,
    onExternalBackButtonClick: null,
    onLogout: null,
    onServerError: null
};

exports.default = ExternalAccount;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);
var settle = __webpack_require__(244);
var buildURL = __webpack_require__(247);
var parseHeaders = __webpack_require__(253);
var isURLSameOrigin = __webpack_require__(251);
var createError = __webpack_require__(138);
var btoa = typeof window !== 'undefined' && window.btoa && window.btoa.bind(window) || __webpack_require__(246);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || request.readyState !== 4 && !xDomain) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(249);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(243);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Built-in value references. */
var Uint8Array = _root2.default.Uint8Array;

exports.default = Uint8Array;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseTimes = __webpack_require__(292);

var _baseTimes2 = _interopRequireDefault(_baseTimes);

var _isArguments = __webpack_require__(104);

var _isArguments2 = _interopRequireDefault(_isArguments);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isBuffer = __webpack_require__(105);

var _isBuffer2 = _interopRequireDefault(_isBuffer);

var _isIndex = __webpack_require__(100);

var _isIndex2 = _interopRequireDefault(_isIndex);

var _isTypedArray = __webpack_require__(108);

var _isTypedArray2 = _interopRequireDefault(_isTypedArray);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = (0, _isArray2.default)(value),
      isArg = !isArr && (0, _isArguments2.default)(value),
      isBuff = !isArr && !isArg && (0, _isBuffer2.default)(value),
      isType = !isArr && !isArg && !isBuff && (0, _isTypedArray2.default)(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? (0, _baseTimes2.default)(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    (0, _isIndex2.default)(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

exports.default = arrayLikeKeys;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

exports.default = arrayMap;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseAssignValue = __webpack_require__(70);

var _baseAssignValue2 = _interopRequireDefault(_baseAssignValue);

var _eq = __webpack_require__(52);

var _eq2 = _interopRequireDefault(_eq);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !(0, _eq2.default)(object[key], value) || value === undefined && !(key in object)) {
    (0, _baseAssignValue2.default)(object, key, value);
  }
}

exports.default = assignMergeValue;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBaseFor = __webpack_require__(302);

var _createBaseFor2 = _interopRequireDefault(_createBaseFor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = (0, _createBaseFor2.default)();

exports.default = baseFor;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _castPath = __webpack_require__(147);

var _castPath2 = _interopRequireDefault(_castPath);

var _toKey = __webpack_require__(51);

var _toKey2 = _interopRequireDefault(_toKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = (0, _castPath2.default)(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[(0, _toKey2.default)(path[index++])];
  }
  return index && index == length ? object : undefined;
}

exports.default = baseGet;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isKey = __webpack_require__(101);

var _isKey2 = _interopRequireDefault(_isKey);

var _stringToPath = __webpack_require__(157);

var _stringToPath2 = _interopRequireDefault(_stringToPath);

var _toString = __webpack_require__(162);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if ((0, _isArray2.default)(value)) {
    return value;
  }
  return (0, _isKey2.default)(value, object) ? [value] : (0, _stringToPath2.default)((0, _toString2.default)(value));
}

exports.default = castPath;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

exports.default = copyArray;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNative = __webpack_require__(30);

var _getNative2 = _interopRequireDefault(_getNative);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var defineProperty = function () {
  try {
    var func = (0, _getNative2.default)(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

exports.default = defineProperty;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SetCache = __webpack_require__(265);

var _SetCache2 = _interopRequireDefault(_SetCache);

var _arraySome = __webpack_require__(270);

var _arraySome2 = _interopRequireDefault(_arraySome);

var _cacheHas = __webpack_require__(295);

var _cacheHas2 = _interopRequireDefault(_cacheHas);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new _SetCache2.default() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!(0, _arraySome2.default)(other, function (othValue, othIndex) {
        if (!(0, _cacheHas2.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

exports.default = equalArrays;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

exports.default = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overArg = __webpack_require__(155);

var _overArg2 = _interopRequireDefault(_overArg);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Built-in value references. */
var getPrototype = (0, _overArg2.default)(Object.getPrototypeOf, Object);

exports.default = getPrototype;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !(0, _isObject2.default)(value);
}

exports.default = isStrictComparable;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

exports.default = matchesStrictComparable;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

exports.default = overArg;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

exports.default = safeGet;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memoizeCapped = __webpack_require__(332);

var _memoizeCapped2 = _interopRequireDefault(_memoizeCapped);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = (0, _memoizeCapped2.default)(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

exports.default = stringToPath;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

exports.default = toSource;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIsEqual = __webpack_require__(99);

var _baseIsEqual2 = _interopRequireDefault(_baseIsEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? (0, _baseIsEqual2.default)(value, other, undefined, customizer) : !!result;
}

exports.default = isEqualWith;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayLikeKeys = __webpack_require__(142);

var _arrayLikeKeys2 = _interopRequireDefault(_arrayLikeKeys);

var _baseKeysIn = __webpack_require__(283);

var _baseKeysIn2 = _interopRequireDefault(_baseKeysIn);

var _isArrayLike = __webpack_require__(73);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return (0, _isArrayLike2.default)(object) ? (0, _arrayLikeKeys2.default)(object, true) : (0, _baseKeysIn2.default)(object);
}

exports.default = keysIn;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseAssignValue = __webpack_require__(70);

var _baseAssignValue2 = _interopRequireDefault(_baseAssignValue);

var _baseForOwn = __webpack_require__(273);

var _baseForOwn2 = _interopRequireDefault(_baseForOwn);

var _baseIteratee = __webpack_require__(281);

var _baseIteratee2 = _interopRequireDefault(_baseIteratee);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = (0, _baseIteratee2.default)(iteratee, 3);

  (0, _baseForOwn2.default)(object, function (value, key, object) {
    (0, _baseAssignValue2.default)(result, key, iteratee(value, key, object));
  });
  return result;
}

exports.default = mapValues;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseToString = __webpack_require__(293);

var _baseToString2 = _interopRequireDefault(_baseToString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : (0, _baseToString2.default)(value);
}

exports.default = toString;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.3 2018-09-08*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/

(function (define, undefined) {
    define(function () {
        'use strict';

        var impl = {};

        impl.mobileDetectRules = {
            "phones": {
                "iPhone": "\\biPhone\\b|\\biPod\\b",
                "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
                "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
                "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
                "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
                "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
                "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
                "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)",
                "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
                "Asus": "Asus.*Galaxy|PadFone.*Mobile",
                "NokiaLumia": "Lumia [0-9]{3,4}",
                "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
                "Palm": "PalmSource|Palm",
                "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
                "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
                "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
                "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
                "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
                "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
                "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
                "Alcatel": "Alcatel",
                "Nintendo": "Nintendo (3DS|Switch)",
                "Amoi": "Amoi",
                "INQ": "INQ",
                "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
            },
            "tablets": {
                "iPad": "iPad|iPad.*Mobile",
                "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
                "GoogleTablet": "Android.*Pixel C",
                "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835",
                "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
                "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
                "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
                "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
                "BlackBerryTablet": "PlayBook|RIM Tablet",
                "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
                "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
                "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
                "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
                "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
                "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
                "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
                "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
                "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304F|TB-X304L|TB-8703F|Tab2A7-10F|TB2-X30L",
                "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
                "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
                "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
                "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
                "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
                "IRUTablet": "M702pro",
                "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
                "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
                "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
                "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
                "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
                "NokiaLumiaTablet": "Lumia 2520",
                "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
                "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
                "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
                "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
                "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
                "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
                "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
                "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
                "FlyTablet": "IQ310|Fly Vision",
                "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))|Maxwell.*Lite|Maxwell.*Plus",
                "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09",
                "NecTablet": "\\bN-06D|\\bN-08D",
                "PantechTablet": "Pantech.*P4100",
                "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
                "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
                "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
                "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
                "NabiTablet": "Android.*\\bNabi",
                "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
                "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
                "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
                "PlaystationTablet": "Playstation.*(Portable|Vita)",
                "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
                "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
                "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
                "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
                "GalapadTablet": "Android.*\\bG1\\b(?!\\))",
                "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
                "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
                "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
                "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
                "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
                "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
                "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
                "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
                "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
                "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
                "DPSTablet": "DPS Dream 9|DPS Dual 7",
                "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
                "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
                "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
                "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
                "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
                "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
                "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
                "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
                "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
                "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
                "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
                "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
                "iMobileTablet": "i-mobile i-note",
                "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
                "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
                "AMPETablet": "Android.* A78 ",
                "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
                "TecnoTablet": "TECNO P9|TECNO DP8D",
                "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
                "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
                "FX2Tablet": "FX2 PAD7|FX2 PAD10",
                "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
                "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
                "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
                "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
                "CaptivaTablet": "CAPTIVA PAD",
                "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
                "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
                "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
                "JaytechTablet": "TPC-PA762",
                "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
                "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
                "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
                "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
                "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
                "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
                "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
                "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
                "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
                "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
                "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
                "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
                "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
                "UbislateTablet": "UbiSlate[\\s]?7C",
                "PocketBookTablet": "Pocketbook",
                "KocasoTablet": "\\b(TB-1207)\\b",
                "HisenseTablet": "\\b(F5281|E2371)\\b",
                "Hudl": "Hudl HT7S3|Hudl 2",
                "TelstraTablet": "T-Hub2",
                "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
            },
            "oss": {
                "AndroidOS": "Android",
                "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
                "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
                "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
                "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
                "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
                "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
                "MeeGoOS": "MeeGo",
                "MaemoOS": "Maemo",
                "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
                "webOS": "webOS|hpwOS",
                "badaOS": "\\bBada\\b",
                "BREWOS": "BREW"
            },
            "uas": {
                "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
                "Dolfin": "\\bDolfin\\b",
                "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
                "Skyfire": "Skyfire",
                "Edge": "Mobile Safari\/[.0-9]* Edge",
                "IE": "IEMobile|MSIEMobile",
                "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
                "Bolt": "bolt",
                "TeaShark": "teashark",
                "Blazer": "Blazer",
                "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
                "WeChat": "\\bMicroMessenger\\b",
                "UCBrowser": "UC.*Browser|UCWEB",
                "baiduboxapp": "baiduboxapp",
                "baidubrowser": "baidubrowser",
                "DiigoBrowser": "DiigoBrowser",
                "Puffin": "Puffin",
                "Mercury": "\\bMercury\\b",
                "ObigoBrowser": "Obigo",
                "NetFront": "NF-Browser",
                "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
                "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
            },
            "props": {
                "Mobile": "Mobile\/[VER]",
                "Build": "Build\/[VER]",
                "Version": "Version\/[VER]",
                "VendorID": "VendorID\/[VER]",
                "iPad": "iPad.*CPU[a-z ]+[VER]",
                "iPhone": "iPhone.*CPU[a-z ]+[VER]",
                "iPod": "iPod.*CPU[a-z ]+[VER]",
                "Kindle": "Kindle\/[VER]",
                "Chrome": ["Chrome\/[VER]", "CriOS\/[VER]", "CrMo\/[VER]"],
                "Coast": ["Coast\/[VER]"],
                "Dolfin": "Dolfin\/[VER]",
                "Firefox": ["Firefox\/[VER]", "FxiOS\/[VER]"],
                "Fennec": "Fennec\/[VER]",
                "Edge": "Edge\/[VER]",
                "IE": ["IEMobile\/[VER];", "IEMobile [VER]", "MSIE [VER];", "Trident\/[0-9.]+;.*rv:[VER]"],
                "NetFront": "NetFront\/[VER]",
                "NokiaBrowser": "NokiaBrowser\/[VER]",
                "Opera": [" OPR\/[VER]", "Opera Mini\/[VER]", "Version\/[VER]"],
                "Opera Mini": "Opera Mini\/[VER]",
                "Opera Mobi": "Version\/[VER]",
                "UCBrowser": ["UCWEB[VER]", "UC.*Browser\/[VER]"],
                "MQQBrowser": "MQQBrowser\/[VER]",
                "MicroMessenger": "MicroMessenger\/[VER]",
                "baiduboxapp": "baiduboxapp\/[VER]",
                "baidubrowser": "baidubrowser\/[VER]",
                "SamsungBrowser": "SamsungBrowser\/[VER]",
                "Iron": "Iron\/[VER]",
                "Safari": ["Version\/[VER]", "Safari\/[VER]"],
                "Skyfire": "Skyfire\/[VER]",
                "Tizen": "Tizen\/[VER]",
                "Webkit": "webkit[ \/][VER]",
                "PaleMoon": "PaleMoon\/[VER]",
                "Gecko": "Gecko\/[VER]",
                "Trident": "Trident\/[VER]",
                "Presto": "Presto\/[VER]",
                "Goanna": "Goanna\/[VER]",
                "iOS": " \\bi?OS\\b [VER][ ;]{1}",
                "Android": "Android [VER]",
                "BlackBerry": ["BlackBerry[\\w]+\/[VER]", "BlackBerry.*Version\/[VER]", "Version\/[VER]"],
                "BREW": "BREW [VER]",
                "Java": "Java\/[VER]",
                "Windows Phone OS": ["Windows Phone OS [VER]", "Windows Phone [VER]"],
                "Windows Phone": "Windows Phone [VER]",
                "Windows CE": "Windows CE\/[VER]",
                "Windows NT": "Windows NT [VER]",
                "Symbian": ["SymbianOS\/[VER]", "Symbian\/[VER]"],
                "webOS": ["webOS\/[VER]", "hpwOS\/[VER];"]
            },
            "utils": {
                "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
                "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
                "DesktopMode": "WPDesktop",
                "TV": "SonyDTV|HbbTV",
                "WebKit": "(webkit)[ \/]([\\w.]+)",
                "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
                "Watch": "SM-V700"
            }
        };

        // following patterns come from http://detectmobilebrowsers.com/
        impl.detectMobileBrowsers = {
            fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            tabletPattern: /android|ipad|playbook|silk/i
        };

        var hasOwnProp = Object.prototype.hasOwnProperty,
            isArray;

        impl.FALLBACK_PHONE = 'UnknownPhone';
        impl.FALLBACK_TABLET = 'UnknownTablet';
        impl.FALLBACK_MOBILE = 'UnknownMobile';

        isArray = 'isArray' in Array ? Array.isArray : function (value) {
            return Object.prototype.toString.call(value) === '[object Array]';
        };

        function equalIC(a, b) {
            return a != null && b != null && a.toLowerCase() === b.toLowerCase();
        }

        function containsIC(array, value) {
            var valueLC,
                i,
                len = array.length;
            if (!len || !value) {
                return false;
            }
            valueLC = value.toLowerCase();
            for (i = 0; i < len; ++i) {
                if (valueLC === array[i].toLowerCase()) {
                    return true;
                }
            }
            return false;
        }

        function convertPropsToRegExp(object) {
            for (var key in object) {
                if (hasOwnProp.call(object, key)) {
                    object[key] = new RegExp(object[key], 'i');
                }
            }
        }

        function prepareUserAgent(userAgent) {
            return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
        }

        (function init() {
            var key,
                values,
                value,
                i,
                len,
                verPos,
                mobileDetectRules = impl.mobileDetectRules;
            for (key in mobileDetectRules.props) {
                if (hasOwnProp.call(mobileDetectRules.props, key)) {
                    values = mobileDetectRules.props[key];
                    if (!isArray(values)) {
                        values = [values];
                    }
                    len = values.length;
                    for (i = 0; i < len; ++i) {
                        value = values[i];
                        verPos = value.indexOf('[VER]');
                        if (verPos >= 0) {
                            value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                        }
                        values[i] = new RegExp(value, 'i');
                    }
                    mobileDetectRules.props[key] = values;
                }
            }
            convertPropsToRegExp(mobileDetectRules.oss);
            convertPropsToRegExp(mobileDetectRules.phones);
            convertPropsToRegExp(mobileDetectRules.tablets);
            convertPropsToRegExp(mobileDetectRules.uas);
            convertPropsToRegExp(mobileDetectRules.utils);

            // copy some patterns to oss0 which are tested first (see issue#15)
            mobileDetectRules.oss0 = {
                WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
                WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
            };
        })();

        /**
         * Test userAgent string against a set of rules and find the first matched key.
         * @param {Object} rules (key is String, value is RegExp)
         * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
         * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
         * @private
         */
        impl.findMatch = function (rules, userAgent) {
            for (var key in rules) {
                if (hasOwnProp.call(rules, key)) {
                    if (rules[key].test(userAgent)) {
                        return key;
                    }
                }
            }
            return null;
        };

        /**
         * Test userAgent string against a set of rules and return an array of matched keys.
         * @param {Object} rules (key is String, value is RegExp)
         * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
         * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
         * @private
         */
        impl.findMatches = function (rules, userAgent) {
            var result = [];
            for (var key in rules) {
                if (hasOwnProp.call(rules, key)) {
                    if (rules[key].test(userAgent)) {
                        result.push(key);
                    }
                }
            }
            return result;
        };

        /**
         * Check the version of the given property in the User-Agent.
         *
         * @param {String} propertyName
         * @param {String} userAgent
         * @return {String} version or <tt>null</tt> if version not found
         * @private
         */
        impl.getVersionStr = function (propertyName, userAgent) {
            var props = impl.mobileDetectRules.props,
                patterns,
                i,
                len,
                match;
            if (hasOwnProp.call(props, propertyName)) {
                patterns = props[propertyName];
                len = patterns.length;
                for (i = 0; i < len; ++i) {
                    match = patterns[i].exec(userAgent);
                    if (match !== null) {
                        return match[1];
                    }
                }
            }
            return null;
        };

        /**
         * Check the version of the given property in the User-Agent.
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} propertyName
         * @param {String} userAgent
         * @return {Number} version or <tt>NaN</tt> if version not found
         * @private
         */
        impl.getVersion = function (propertyName, userAgent) {
            var version = impl.getVersionStr(propertyName, userAgent);
            return version ? impl.prepareVersionNo(version) : NaN;
        };

        /**
         * Prepare the version number.
         *
         * @param {String} version
         * @return {Number} the version number as a floating number
         * @private
         */
        impl.prepareVersionNo = function (version) {
            var numbers;

            numbers = version.split(/[a-z._ \/\-]/i);
            if (numbers.length === 1) {
                version = numbers[0];
            }
            if (numbers.length > 1) {
                version = numbers[0] + '.';
                numbers.shift();
                version += numbers.join('');
            }
            return Number(version);
        };

        impl.isMobileFallback = function (userAgent) {
            return impl.detectMobileBrowsers.fullPattern.test(userAgent) || impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0, 4));
        };

        impl.isTabletFallback = function (userAgent) {
            return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
        };

        impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
            if (cache.mobile !== undefined) {
                return;
            }
            var phone, tablet, phoneSized;

            // first check for stronger tablet rules, then phone (see issue#5)
            tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
            if (tablet) {
                cache.mobile = cache.tablet = tablet;
                cache.phone = null;
                return; // unambiguously identified as tablet
            }

            phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
            if (phone) {
                cache.mobile = cache.phone = phone;
                cache.tablet = null;
                return; // unambiguously identified as phone
            }

            // our rules haven't found a match -> try more general fallback rules
            if (impl.isMobileFallback(userAgent)) {
                phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
                if (phoneSized === undefined) {
                    cache.mobile = impl.FALLBACK_MOBILE;
                    cache.tablet = cache.phone = null;
                } else if (phoneSized) {
                    cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                    cache.tablet = null;
                } else {
                    cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                    cache.phone = null;
                }
            } else if (impl.isTabletFallback(userAgent)) {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            } else {
                // not mobile at all!
                cache.mobile = cache.tablet = cache.phone = null;
            }
        };

        // t is a reference to a MobileDetect instance
        impl.mobileGrade = function (t) {
            // impl note:
            // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
            // When changes are made in Mobile_Detect.php, copy this method and replace:
            //     $this-> / t.
            //     self::MOBILE_GRADE_(.) / '$1'
            //     , self::VERSION_TYPE_FLOAT / (nothing)
            //     isIOS() / os('iOS')
            //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
            var $isMobile = t.mobile() !== null;

            if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad') >= 4.3 || t.os('iOS') && t.version('iPhone') >= 3.1 || t.os('iOS') && t.version('iPod') >= 3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            t.version('Android') > 2.1 && t.is('Webkit') ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS') >= 7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry') >= 6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            t.version('webOS') >= 1.4 && t.match('Palm|Pre|Pixi') ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            t.is('Firefox') && t.version('Firefox') >= 12 ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            t.is('Chrome') && t.is('AndroidOS') && t.version('Android') >= 4.0 ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            t.is('Skyfire') && t.version('Skyfire') >= 4.1 && t.is('AndroidOS') && t.version('Android') >= 2.3 ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            t.is('Opera') && t.version('Opera Mobi') > 11 && t.is('AndroidOS') ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada') >= 2.0 ||

            // UC Browser - Tested on Android 2.3 device
            (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android') >= 2.3 ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            t.match('Kindle Fire') || t.is('Kindle') && t.version('Kindle') >= 3.0 ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome') >= 11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari') >= 5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox') >= 4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE') >= 7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera') >= 10 && !$isMobile) {
                return 'A';
            }

            if (t.os('iOS') && t.version('iPad') < 4.3 || t.os('iOS') && t.version('iPhone') < 3.1 || t.os('iOS') && t.version('iPod') < 3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry') >= 5 && t.version('BlackBerry') < 6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            t.version('Opera Mini') >= 5.0 && t.version('Opera Mini') <= 6.5 && (t.version('Android') >= 2.3 || t.is('iOS')) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi') >= 11 && t.is('SymbianOS')) {
                return 'B';
            }

            if (
            // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry') < 5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile') <= 5.2) {
                return 'C';
            }

            //All older smartphone platforms and featurephones - Any device that doesn't support media queries
            //will receive the basic, C grade experience.
            return 'C';
        };

        impl.detectOS = function (ua) {
            return impl.findMatch(impl.mobileDetectRules.oss0, ua) || impl.findMatch(impl.mobileDetectRules.oss, ua);
        };

        impl.getDeviceSmallerSide = function () {
            return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
        };

        /**
         * Constructor for MobileDetect object.
         * <br>
         * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
         * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
         *     <strong>Find information how to download and install:</strong>
         *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
         * </div>
         *
         * @example <pre>
         *     var md = new MobileDetect(window.navigator.userAgent);
         *     if (md.mobile()) {
         *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
         *     }
         * </pre>
         *
         * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
         * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
         *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
         *        as phone.
         *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
         *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
         *        for Android</a>.<br>
         *        If you provide a value < 0, then this "fuzzy" check is disabled.
         * @constructor
         * @global
         */
        function MobileDetect(userAgent, maxPhoneWidth) {
            this.ua = prepareUserAgent(userAgent);
            this._cache = {};
            //600dp is typical 7" tablet minimum width
            this.maxPhoneWidth = maxPhoneWidth || 600;
        }

        MobileDetect.prototype = {
            constructor: MobileDetect,

            /**
             * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
             * <br>
             * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
             * <br>
             * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
             * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
             * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
             * <code>UnknownMobile</code> is returned.<br>
             * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
             * <br>
             * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
             * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
             * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
             * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
             * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
             * <br>
             * In most cases you will use the return value just as a boolean.
             *
             * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
             * @function MobileDetect#mobile
             */
            mobile: function mobile() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.mobile;
            },

            /**
             * Returns the detected phone type/family string or <tt>null</tt>.
             * <br>
             * The returned tablet (family or producer) is one of following keys:<br>
             * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
             * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
             * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
             * <br>
             * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
             * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
             * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
             * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
             * <br>
             * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
             * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
             * will return <code>UnknownMobile</code>.<br>
             * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
             * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
             * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
             * <br>
             * In most cases you will use the return value just as a boolean.
             *
             * @returns {String} the key of the phone family or producer, e.g. "iPhone"
             * @function MobileDetect#phone
             */
            phone: function phone() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.phone;
            },

            /**
             * Returns the detected tablet type/family string or <tt>null</tt>.
             * <br>
             * The returned tablet (family or producer) is one of following keys:<br>
             * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
             * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
             * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
             * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
             * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
             * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
             * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
             * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
             * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
             * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
             * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
             * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
             * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
             * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
             * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
             * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
             * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
             * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
             * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
             * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
             * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
             * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
             * GenericTablet</tt><br>
             * <br>
             * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
             * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
             * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
             * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
             * <br>
             * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
             * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
             * will return <code>UnknownMobile</code>.<br>
             * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
             * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
             * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
             * <br>
             * In most cases you will use the return value just as a boolean.
             *
             * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
             * @function MobileDetect#tablet
             */
            tablet: function tablet() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.tablet;
            },

            /**
             * Returns the (first) detected user-agent string or <tt>null</tt>.
             * <br>
             * The returned user-agent is one of following keys:<br>
             * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
             * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
             * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
             * <br>
             * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
             * cases where a mobile device pretends to be more than one particular browser. You can get the
             * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
             * providing one of the defined keys as first argument to {@link MobileDetect#is}.
             *
             * @returns {String} the key for the detected user-agent or <tt>null</tt>
             * @function MobileDetect#userAgent
             */
            userAgent: function userAgent() {
                if (this._cache.userAgent === undefined) {
                    this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
                }
                return this._cache.userAgent;
            },

            /**
             * Returns all detected user-agent strings.
             * <br>
             * The array is empty or contains one or more of following keys:<br>
             * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
             * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
             * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
             * <br>
             * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
             * cases where a mobile device pretends to be more than one particular browser. You can get the
             * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
             * providing one of the defined keys as first argument to {@link MobileDetect#is}.
             *
             * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
             * @function MobileDetect#userAgents
             */
            userAgents: function userAgents() {
                if (this._cache.userAgents === undefined) {
                    this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
                }
                return this._cache.userAgents;
            },

            /**
             * Returns the detected operating system string or <tt>null</tt>.
             * <br>
             * The operating system is one of following keys:<br>
             * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
             * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
             *
             * @returns {String} the key for the detected operating system.
             * @function MobileDetect#os
             */
            os: function os() {
                if (this._cache.os === undefined) {
                    this._cache.os = impl.detectOS(this.ua);
                }
                return this._cache.os;
            },

            /**
             * Get the version (as Number) of the given property in the User-Agent.
             * <br>
             * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
             *
             * @param {String} key a key defining a thing which has a version.<br>
             *        You can use one of following keys:<br>
             * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
             * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
             * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
             * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
             * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
             * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
             *
             * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
             *          Be careful when comparing this value with '==' operator!
             * @function MobileDetect#version
             */
            version: function version(key) {
                return impl.getVersion(key, this.ua);
            },

            /**
             * Get the version (as String) of the given property in the User-Agent.
             * <br>
             *
             * @param {String} key a key defining a thing which has a version.<br>
             *        You can use one of following keys:<br>
             * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
             * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
             * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
             * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
             * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
             * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
             *
             * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
             *
             * @function MobileDetect#versionStr
             */
            versionStr: function versionStr(key) {
                return impl.getVersionStr(key, this.ua);
            },

            /**
             * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
             *
             * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
             *        tablet family.<br>
             *        For a complete list of possible values, see {@link MobileDetect#userAgent},
             *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
             *        Additionally you have following keys:<br>
             * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
             *
             * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
             *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
             * @function MobileDetect#is
             */
            is: function is(key) {
                return containsIC(this.userAgents(), key) || equalIC(key, this.os()) || equalIC(key, this.phone()) || equalIC(key, this.tablet()) || containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
            },

            /**
             * Do a quick test against navigator::userAgent.
             *
             * @param {String|RegExp} pattern the pattern, either as String or RegExp
             *                        (a string will be converted to a case-insensitive RegExp).
             * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
             * @function MobileDetect#match
             */
            match: function match(pattern) {
                if (!(pattern instanceof RegExp)) {
                    pattern = new RegExp(pattern, 'i');
                }
                return pattern.test(this.ua);
            },

            /**
             * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
             * <br>
             * Obviously this method makes sense in browser environments only (not for Node.js)!
             * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
             *        The argument is optional and if not present or falsy, the value of the constructor is taken.
             * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
             *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
             *          Will always return <code>undefined</code> server-side.
             */
            isPhoneSized: function isPhoneSized(maxPhoneWidth) {
                return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
            },

            /**
             * Returns the mobile grade ('A', 'B', 'C').
             *
             * @returns {String} one of the mobile grades ('A', 'B', 'C').
             * @function MobileDetect#mobileGrade
             */
            mobileGrade: function mobileGrade() {
                if (this._cache.grade === undefined) {
                    this._cache.grade = impl.mobileGrade(this);
                }
                return this._cache.grade;
            }
        };

        // environment-dependent
        if (typeof window !== 'undefined' && window.screen) {
            MobileDetect.isPhoneSized = function (maxPhoneWidth) {
                return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
            };
        } else {
            MobileDetect.isPhoneSized = function () {};
        }

        // should not be replaced by a completely new object - just overwrite existing methods
        MobileDetect._impl = impl;

        MobileDetect.version = '1.4.3 2018-09-08';

        return MobileDetect;
    }); // end of call of define()
})(function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) {
            module.exports = factory();
        };
    } else if (true) {
        return __webpack_require__(693);
    } else if (typeof window !== 'undefined') {
        return function (factory) {
            window.MobileDetect = factory();
        };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
}());

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var isarray = __webpack_require__(260);

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options));
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (_typeof(tokens[i]) === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = connectAdvanced;

var _hoistNonReactStatics = __webpack_require__(94);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _Subscription = __webpack_require__(371);

var _Subscription2 = _interopRequireDefault(_Subscription);

var _PropTypes = __webpack_require__(168);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(_react.Component);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
exports.getDependsOnOwnProps = getDependsOnOwnProps;
exports.wrapMapToPropsFunc = wrapMapToPropsFunc;

var _verifyPlainObject = __webpack_require__(169);

var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = exports.subscriptionShape = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
  trySubscribe: _propTypes2.default.func.isRequired,
  tryUnsubscribe: _propTypes2.default.func.isRequired,
  notifyNestedSubs: _propTypes2.default.func.isRequired,
  isSubscribed: _propTypes2.default.func.isRequired
});

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = verifyPlainObject;

var _isPlainObject = __webpack_require__(74);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warning = __webpack_require__(112);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function verifyPlainObject(value, displayName, methodName) {
  if (!(0, _isPlainObject2.default)(value)) {
    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _history = __webpack_require__(41);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;

          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");

    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(_react2.default.Component);

Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired,
      createHref: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};

exports.default = Link;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Route = __webpack_require__(114);

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _history = __webpack_require__(41);

var _Router = __webpack_require__(77);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(_react2.default.Component);

exports.default = MemoryRouter;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(_react2.default.Component);

Prompt.propTypes = {
  when: _propTypes2.default.bool,
  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      block: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};

exports.default = Prompt;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _history = __webpack_require__(41);

var _generatePath = __webpack_require__(115);

var _generatePath2 = _interopRequireDefault(_generatePath);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = (0, _history.createLocation)(prevProps.to);
    var nextTo = (0, _history.createLocation)(this.props.to);

    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return (0, _generatePath2.default)(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(_react2.default.Component);

Redirect.propTypes = {
  computedMatch: _propTypes2.default.object, // private, from <Switch>
  push: _propTypes2.default.bool,
  from: _propTypes2.default.string,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired
    }).isRequired,
    staticContext: _propTypes2.default.object
  }).isRequired
};

exports.default = Redirect;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _history = __webpack_require__(41);

var _Router = __webpack_require__(77);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : (0, _history.createPath)(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, (0, _history.createLocation)(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, (0, _history.createLocation)(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, (0, _history.createLocation)(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(_react2.default.Component);

StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};

exports.default = StaticRouter;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _matchPath = __webpack_require__(78);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    _react2.default.Children.forEach(children, function (element) {
      if (match == null && _react2.default.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(_react2.default.Component);

Switch.contextTypes = {
  router: _propTypes2.default.shape({
    route: _propTypes2.default.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.object
};

exports.default = Switch;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;

var _MemoryRouter2 = __webpack_require__(172);

var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);

var _Prompt2 = __webpack_require__(173);

var _Prompt3 = _interopRequireDefault(_Prompt2);

var _Redirect2 = __webpack_require__(174);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(114);

var _Route3 = _interopRequireDefault(_Route2);

var _Router2 = __webpack_require__(77);

var _Router3 = _interopRequireDefault(_Router2);

var _StaticRouter2 = __webpack_require__(175);

var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);

var _Switch2 = __webpack_require__(176);

var _Switch3 = _interopRequireDefault(_Switch2);

var _generatePath2 = __webpack_require__(115);

var _generatePath3 = _interopRequireDefault(_generatePath2);

var _matchPath2 = __webpack_require__(78);

var _matchPath3 = _interopRequireDefault(_matchPath2);

var _withRouter2 = __webpack_require__(178);

var _withRouter3 = _interopRequireDefault(_withRouter2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.MemoryRouter = _MemoryRouter3.default;
exports.Prompt = _Prompt3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;
exports.Router = _Router3.default;
exports.StaticRouter = _StaticRouter3.default;
exports.Switch = _Switch3.default;
exports.generatePath = _generatePath3.default;
exports.matchPath = _matchPath3.default;
exports.withRouter = _withRouter3.default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(94);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Route = __webpack_require__(114);

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return _react2.default.createElement(_Route2.default, {
      children: function children(routeComponentProps) {
        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;

  return (0, _hoistNonReactStatics2.default)(C, Component);
};

exports.default = withRouter;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _es6Error = __webpack_require__(255);

var _es6Error2 = _interopRequireDefault(_es6Error);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(_es6Error2.default);

exports.default = SubmissionError;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSyncWarnings = exports.updateSyncErrors = exports.untouch = exports.unregisterField = exports.touch = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearAsyncError = exports.clearSubmitErrors = exports.clearSubmit = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = undefined;

var _actionTypes = __webpack_require__(117);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var arrayInsert = exports.arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: _actionTypes.ARRAY_INSERT,
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = exports.arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: _actionTypes.ARRAY_MOVE,
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = exports.arrayPop = function arrayPop(form, field) {
  return {
    type: _actionTypes.ARRAY_POP,
    meta: { form: form, field: field }
  };
};

var arrayPush = exports.arrayPush = function arrayPush(form, field, value) {
  return {
    type: _actionTypes.ARRAY_PUSH,
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = exports.arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: _actionTypes.ARRAY_REMOVE,
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = exports.arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: _actionTypes.ARRAY_REMOVE_ALL,
    meta: { form: form, field: field }
  };
};

var arrayShift = exports.arrayShift = function arrayShift(form, field) {
  return {
    type: _actionTypes.ARRAY_SHIFT,
    meta: { form: form, field: field }
  };
};

var arraySplice = exports.arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: _actionTypes.ARRAY_SPLICE,
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = exports.arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = exports.arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: _actionTypes.ARRAY_UNSHIFT,
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = exports.autofill = function autofill(form, field, value) {
  return {
    type: _actionTypes.AUTOFILL,
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = exports.blur = function blur(form, field, value, touch) {
  return {
    type: _actionTypes.BLUR,
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = exports.change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: _actionTypes.CHANGE,
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = exports.clearSubmit = function clearSubmit(form) {
  return { type: _actionTypes.CLEAR_SUBMIT, meta: { form: form } };
};

var clearSubmitErrors = exports.clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
    meta: { form: form }
  };
};

var clearAsyncError = exports.clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: _actionTypes.CLEAR_ASYNC_ERROR,
    meta: { form: form, field: field }
  };
};

var destroy = exports.destroy = function destroy() {
  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
    form[_key] = arguments[_key];
  }

  return { type: _actionTypes.DESTROY, meta: { form: form } };
};

var focus = exports.focus = function focus(form, field) {
  return { type: _actionTypes.FOCUS, meta: { form: form, field: field } };
};

var initialize = exports.initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: _actionTypes.INITIALIZE,
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = exports.registerField = function registerField(form, name, type) {
  return {
    type: _actionTypes.REGISTER_FIELD,
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = exports.reset = function reset(form) {
  return { type: _actionTypes.RESET, meta: { form: form } };
};

var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: _actionTypes.START_ASYNC_VALIDATION,
    meta: { form: form, field: field }
  };
};

var startSubmit = exports.startSubmit = function startSubmit(form) {
  return { type: _actionTypes.START_SUBMIT, meta: { form: form } };
};

var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(form, errors) {
  var action = {
    type: _actionTypes.STOP_ASYNC_VALIDATION,
    meta: { form: form },
    payload: errors
  };
  if (errors && Object.keys(errors).length) {
    action.error = true;
  }
  return action;
};

var stopSubmit = exports.stopSubmit = function stopSubmit(form, errors) {
  var action = {
    type: _actionTypes.STOP_SUBMIT,
    meta: { form: form },
    payload: errors
  };
  if (errors && Object.keys(errors).length) {
    action.error = true;
  }
  return action;
};

var submit = exports.submit = function submit(form) {
  return { type: _actionTypes.SUBMIT, meta: { form: form } };
};

var setSubmitFailed = exports.setSubmitFailed = function setSubmitFailed(form) {
  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    fields[_key2 - 1] = arguments[_key2];
  }

  return {
    type: _actionTypes.SET_SUBMIT_FAILED,
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = exports.setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    fields[_key3 - 1] = arguments[_key3];
  }

  return {
    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = exports.touch = function touch(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: _actionTypes.TOUCH,
    meta: { form: form, fields: fields }
  };
};

var unregisterField = exports.unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: _actionTypes.UNREGISTER_FIELD,
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = exports.untouch = function untouch(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: _actionTypes.UNTOUCH,
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = exports.updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: _actionTypes.UPDATE_SYNC_ERRORS,
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = exports.updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: _actionTypes.UPDATE_SYNC_WARNINGS,
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var processProps = function processProps(type, props, _value) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: value === _value,
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

exports.default = createFieldProps;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};

exports.default = defaultShouldAsyncValidate;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

exports.default = defaultShouldValidate;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

exports.default = isEvent;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getValue = __webpack_require__(408);

var _getValue2 = _interopRequireDefault(_getValue);

var _isReactNative = __webpack_require__(428);

var _isReactNative2 = _interopRequireDefault(_isReactNative);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = (0, _getValue2.default)(event, _isReactNative2.default

  // parse value if we have a parser
  );if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

exports.default = onChangeValue;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEvent = __webpack_require__(184);

var _isEvent2 = _interopRequireDefault(_isEvent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var silenceEvent = function silenceEvent(event) {
  var is = (0, _isEvent2.default)(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

exports.default = silenceEvent;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      var formState = getFormState(state);
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

exports.default = createIsPristine;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEqualWith2 = __webpack_require__(159);

var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  return !(0, _isEqualWith3.default)(instance.props, nextProps, customizer) || !(0, _isEqualWith3.default)(instance.state, nextState, customizer);
};

exports.default = shallowCompare;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPersistoid;

var _constants = __webpack_require__(32);

// @TODO remove once flow < 0.63 support is no longer required.

function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      var subState = state[key];
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);
    if (typeof endState !== 'undefined') stagedWrite(key, endState);
  }

  function stagedWrite(key, endState) {
    try {
      stagedState[key] = serialize(endState);
    } catch (err) {
      console.error('redux-persist/createPersistoid: error serializing state', err);
    }
    if (keysToProcess.length === 0) {
      // cleanup any removed keys just before write.
      Object.keys(stagedState).forEach(function (key) {
        if (lastState[key] === undefined) {
          delete stagedState[key];
        }
      });

      writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStoredState;

var _constants = __webpack_require__(32);

function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = purgeStoredState;

var _constants = __webpack_require__(32);

function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionTypes = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = createStore;

var _isPlainObject = __webpack_require__(74);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(473);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2.default)(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2.default] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2.default] = observable, _ref2;
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

module.exports = bytesToUuid;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.

var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.betPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// eslint-disable-next-line import/prefer-default-export
var betPropTypes = exports.betPropTypes = _propTypes2.default.shape({
    betType: _propTypes2.default.string.isRequired,
    receiptId: _propTypes2.default.string.isRequired,
    returns: _propTypes2.default.number,
    stake: _propTypes2.default.number.isRequired,
    totalStake: _propTypes2.default.number.isRequired,
    timeBetPlaced: _propTypes2.default.string.isRequired,
    win: _propTypes2.default.bool,
    selections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        eachWay: _propTypes2.default.bool.isRequired,
        eventName: _propTypes2.default.string.isRequired,
        odd: _propTypes2.default.string.isRequired,
        selectionName: _propTypes2.default.string.isRequired
    }))
});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.betPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// eslint-disable-next-line import/prefer-default-export
var betPropTypes = exports.betPropTypes = _propTypes2.default.shape({
    betType: _propTypes2.default.string.isRequired,
    receiptId: _propTypes2.default.string.isRequired,
    returns: _propTypes2.default.number,
    stake: _propTypes2.default.number.isRequired,
    totalStake: _propTypes2.default.number.isRequired,
    timeBetPlaced: _propTypes2.default.string.isRequired,
    win: _propTypes2.default.bool,
    selections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        eachWay: _propTypes2.default.bool.isRequired,
        eventName: _propTypes2.default.string.isRequired,
        odd: _propTypes2.default.string.isRequired,
        selectionName: _propTypes2.default.string.isRequired
    }))
});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.reducer = exports.default = undefined;

var _Account = __webpack_require__(227);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Account).default;
    }
});

var _accountPage = __webpack_require__(493);

var _accountPage2 = _interopRequireDefault(_accountPage);

var _accountPage3 = __webpack_require__(55);

var actions = _interopRequireWildcard(_accountPage3);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _accountPage2.default;
exports.actions = actions;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.redirectToLoginBookmakerSelector = exports.bookmakersSwitcherSelector = undefined;

var _reselect = __webpack_require__(25);

var bookmakersSwitcherSelector = exports.bookmakersSwitcherSelector = function bookmakersSwitcherSelector(_ref) {
    var bookmakersSwitcher = _ref.bookmakersSwitcher;
    return bookmakersSwitcher || {};
};

var redirectToLoginBookmakerSelector = exports.redirectToLoginBookmakerSelector = (0, _reselect.createSelector)(bookmakersSwitcherSelector, function (bookmakersSwitcher) {
    return bookmakersSwitcher.info && bookmakersSwitcher.info.redirectToLoginBookmaker || null;
});

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reducer = exports.default = undefined;

var _BookmakersPageSwitcher = __webpack_require__(561);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_BookmakersPageSwitcher).default;
    }
});

var _bookmakersSwitcher = __webpack_require__(498);

var _bookmakersSwitcher2 = _interopRequireDefault(_bookmakersSwitcher);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _bookmakersSwitcher2.default;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BestOddsGuaranteed = __webpack_require__(582);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BestOddsGuaranteed).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.placeBet = exports.fireError = exports.updateObstructions = exports.priceChanged = exports.betSuspended = exports.clearBetObstruction = exports.setBetObstruction = exports.clearPlacedBetDetails = exports.placeBetRequest = exports.betObstructions = exports.actionTypes = undefined;

var _bookmakersInfo = __webpack_require__(6);

var _login = __webpack_require__(47);

var _modals = __webpack_require__(29);

var _modalMessages = __webpack_require__(125);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _apiErrors = __webpack_require__(22);

var _convertFractionalPrice = __webpack_require__(535);

var _convertFractionalPrice2 = _interopRequireDefault(_convertFractionalPrice);

var _calculateStake = __webpack_require__(48);

var _updateAuthToken = __webpack_require__(49);

var _updateAuthToken2 = _interopRequireDefault(_updateAuthToken);

var _cookie = __webpack_require__(23);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var actionTypes = exports.actionTypes = {
    PLACE_BET_REQUEST: 'PLACE_BET_REQUEST',
    PLACE_BET_SUCCESS: 'PLACE_BET_SUCCESS',
    CLEAR_PLACED_BET_DETAILS: 'CLEAR_PLACED_BET_DETAILS',
    SET_BET_OBSTRUCTION: 'SET_BET_OBSTRUCTION',
    CLEAR_BET_OBSTRUCTION: 'CLEAR_BET_OBSTRUCTION'
};

var betObstructions = exports.betObstructions = {
    NONE: 'NONE',
    REMOVE: 'REMOVE',
    ACCEPT: 'ACCEPT',
    ACCEPT_AND_REMOVE: 'ACCEPT_AND_REMOVE'
};

var placeBetRequest = exports.placeBetRequest = function placeBetRequest(isPlacingBet) {
    return {
        type: actionTypes.PLACE_BET_REQUEST,
        isPlacingBet: isPlacingBet
    };
};

var placeBetSuccess = function placeBetSuccess(placedBetDetails) {
    return {
        type: actionTypes.PLACE_BET_SUCCESS,
        placedBetDetails: placedBetDetails
    };
};

var clearPlacedBetDetails = exports.clearPlacedBetDetails = function clearPlacedBetDetails() {
    return {
        type: actionTypes.CLEAR_PLACED_BET_DETAILS
    };
};

var setBetObstruction = exports.setBetObstruction = function setBetObstruction(obstruction) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.SET_BET_OBSTRUCTION,
            obstruction: obstruction
        });
    };
};

var clearBetObstruction = exports.clearBetObstruction = function clearBetObstruction() {
    return {
        type: actionTypes.CLEAR_BET_OBSTRUCTION
    };
};

var handlePlaceBetResponse = function handlePlaceBetResponse(placeBetResponse, selectedBets, multiples, freeBet) {
    return function (dispatch) {
        var receipts = placeBetResponse.data;
        var containsPending = receipts.some(function (receipt) {
            return receipt.attributes.status === 'pending';
        });
        var placedBetDetails = {
            containsPending: containsPending,
            freeBet: freeBet,
            bets: []
        };

        placedBetDetails.bets = receipts.map(function (receipt) {
            var id = receipt.id,
                attributes = receipt.attributes;
            var betId = attributes.betId,
                stakePerLine = attributes.stakePerLine,
                numberLines = attributes.numberLines,
                betType = attributes.betType,
                potentialReturns = attributes.potentialReturns,
                betSelections = attributes.betSelections;

            var placedBetSelections = betSelections.map(function (betSelection) {
                return selectedBets.find(function (selectedBet) {
                    return selectedBet.outcomersId === betSelection.selectionId;
                });
            });

            var placedMultiple = multiples.find(function (multiple) {
                return multiple.optionId === betId.toString();
            });

            return {
                bets: placedBetSelections,
                receiptId: id,
                betId: betId,
                stakePerLine: stakePerLine,
                betType: betType,
                potentialReturns: potentialReturns,
                multiple: placedMultiple,
                numberLines: numberLines
            };
        });

        dispatch(placeBetSuccess(placedBetDetails));
        dispatch(_bookmakersInfo.actions.clearSelectedBets());
        dispatch(_bookmakersInfo.actions.clearMultiples());
    };
};

var betSuspended = exports.betSuspended = function betSuspended(dispatch, origin, betError) {
    var meta = betError.meta;
    var outcomersId = meta.selection.selectionId.toString();

    if (origin === 'BET') {
        dispatch(_bookmakersInfo.actions.setSuspendedBet(outcomersId, true));
        dispatch(_bookmakersInfo.actions.setError(outcomersId, betError.code, _apiErrors.ERROR_MESSAGES.BETTING_SUSPENDED));
    } else {
        dispatch(_bookmakersInfo.actions.setSuspendedBetOnBuild(outcomersId, true));
        dispatch(_bookmakersInfo.actions.setErrorOnBuild(outcomersId, betError.code, _apiErrors.ERROR_MESSAGES.BETTING_SUSPENDED));
    }
};

var toTwoDecimalPlaces = function toTwoDecimalPlaces(number) {
    return parseFloat(Math.round(number * 100) / 100).toFixed(2);
};

var stakeTooLow = function stakeTooLow(dispatch, origin, betError, currencySign) {
    var meta = betError.meta;
    var minStake = toTwoDecimalPlaces(meta.minStake);
    var message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_LOW.replace('%PRICE%', '' + currencySign + minStake);

    if (meta.bet.betType === 'single') {
        var outcomersId = meta.bet.betSelections[0].selectionId.toString();
        if (origin === 'BET') {
            dispatch(_bookmakersInfo.actions.setError(outcomersId, betError.code, message));
        } else {
            dispatch(_bookmakersInfo.actions.setErrorOnBuild(outcomersId, betError.code, message));
        }
    } else {
        var optionId = meta.bet.id;
        dispatch(_bookmakersInfo.actions.setMultiplesError(optionId, betError.code, message));
    }
};

var stakeTooHigh = function stakeTooHigh(dispatch, origin, betError, currencySign) {
    var meta = betError.meta;
    var maxStake = toTwoDecimalPlaces(meta.maxStake);
    var message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_HIGH.replace('%PRICE%', '' + currencySign + maxStake);

    if (meta.bet.betType === 'single') {
        var outcomersId = meta.bet.betSelections[0].selectionId.toString();
        if (origin === 'BET') {
            dispatch(_bookmakersInfo.actions.setError(outcomersId, betError.code, message));
        } else {
            dispatch(_bookmakersInfo.actions.setErrorOnBuild(outcomersId, betError.code, message));
        }
    } else {
        var optionId = meta.bet.id;
        dispatch(_bookmakersInfo.actions.setMultiplesError(optionId, betError.code, message));
    }
};

/**
 * Deppending on the odds type, convert the price to decimal or fractional
 * 
 * @param {Boolean} isDecimalOdds 
 * @param {String} decimalPrice 
 * @param {String} fractionalPrice 
 * @returns price
 */
var convertPriceByOdds = function convertPriceByOdds(isDecimalOdds, decimalPrice, fractionalPrice) {
    var price = isDecimalOdds ? Number(decimalPrice).toFixed(2) : fractionalPrice;

    return price;
};

var priceChanged = exports.priceChanged = function priceChanged(dispatch, origin, betError) {
    var customizeSettings = (0, _cookie.getCookie)('customizeSettings');

    var userSettings = customizeSettings ? JSON.parse(customizeSettings) : { decimalOdds: false };

    var meta = betError.meta;
    var outcomersId = meta.selection.selectionId.toString();
    var newPriceNumerator = meta.priceNumerator;
    var newPriceDenominator = meta.priceDenominator;
    var newFractionalPrice = newPriceNumerator + '/' + newPriceDenominator;
    var newDecimalPrice = (0, _convertFractionalPrice2.default)(newFractionalPrice);
    var oldPriceNumerator = meta.selection.priceNumerator;
    var oldPriceDenominator = meta.selection.priceDenominator;

    var oldFractionalPrice = oldPriceNumerator + '/' + oldPriceDenominator;
    var oldDecimalPrice = (0, _convertFractionalPrice2.default)(oldFractionalPrice);

    if (newPriceNumerator !== oldPriceNumerator || newPriceDenominator !== oldPriceDenominator) {
        var message = void 0;
        if (meta.selection.priceNumerator === null) {
            dispatch(_bookmakersInfo.actions.updateBetPrice(outcomersId, newFractionalPrice, newDecimalPrice));
            message = _apiErrors.ERROR_MESSAGES.PRICE_CHANGED_SP;
        } else {
            message = _apiErrors.ERROR_MESSAGES.PRICE_CHANGED.replace('%OLD%', convertPriceByOdds(userSettings.decimalOdds, oldDecimalPrice, oldFractionalPrice)).replace('%NEW%', convertPriceByOdds(userSettings.decimalOdds, newDecimalPrice, newFractionalPrice));
        }

        // Attach new price to associated bet (to be accepted by cta)
        if (origin === 'BET') {
            dispatch(_bookmakersInfo.actions.setError(outcomersId, betError.code, message));
            dispatch(_bookmakersInfo.actions.setAssociatedPriceChange(outcomersId, newFractionalPrice, newDecimalPrice));
        } else {
            dispatch(_bookmakersInfo.actions.setErrorOnBuild(outcomersId, betError.code, message));
            dispatch(_bookmakersInfo.actions.setAssociatedPriceChangeOnBuild(outcomersId, newFractionalPrice, newDecimalPrice));
        }
    }
};

var insufficientFunds = function insufficientFunds(dispatch, origin, betError) {
    if (origin === 'BET') {
        dispatch(_bookmakersInfo.actions.setGenericError(betError.code, _apiErrors.ERROR_MESSAGES.INSUFFICIENT_FUNDS));
    } else {
        dispatch(_bookmakersInfo.actions.setGenericErrorOnBuild(betError.code, _apiErrors.ERROR_MESSAGES.INSUFFICIENT_FUNDS));
    }
};

var startingPriceUnavailable = function startingPriceUnavailable(dispatch, origin, betError) {
    var meta = betError.meta;
    var outcomersId = meta.bet.betSelections[0].selectionId.toString();

    if (origin === 'BET') {
        dispatch(_bookmakersInfo.actions.setError(outcomersId, betError.code, 'SP is no longer available for this race'));
    } else {
        dispatch(_bookmakersInfo.actions.setErrorOnBuild(outcomersId, betError.code, 'SP is no longer available for this race'));
    }
    dispatch(_bookmakersInfo.actions.updateAllStartingPricesAvailability());
};

var updateObstructions = exports.updateObstructions = function updateObstructions(errors) {
    return function (dispatch) {
        var isStartingPriceUnavailable = errors.includes(_apiErrors.ERROR_CODES.STARTING_PRICE_UNAVAILABLE);
        var isBetSuspended = errors.includes(_apiErrors.ERROR_CODES.BETTING_SUSPENDED);
        var isPriceChanged = errors.includes(_apiErrors.ERROR_CODES.PRICE_CHANGED);
        var priceAffected = isPriceChanged || isStartingPriceUnavailable;

        switch (true) {
            case isBetSuspended && priceAffected:
                dispatch(setBetObstruction(betObstructions.ACCEPT_AND_REMOVE));
                break;
            case priceAffected:
                dispatch(setBetObstruction(betObstructions.ACCEPT));
                break;
            case isBetSuspended:
                dispatch(setBetObstruction(betObstructions.REMOVE));
                break;
            default:
                dispatch(clearBetObstruction());
        }
    };
};

var fireError = exports.fireError = function fireError(dispatch, origin, betError, currencySign) {
    switch (betError.code) {
        case _apiErrors.ERROR_CODES.BETTING_SUSPENDED:
            betSuspended(dispatch, origin, betError);
            break;
        case _apiErrors.ERROR_CODES.STAKE_TOO_LOW:
            stakeTooLow(dispatch, origin, betError, currencySign);
            break;
        case _apiErrors.ERROR_CODES.STAKE_TOO_HIGH:
            stakeTooHigh(dispatch, origin, betError, currencySign);
            break;
        case _apiErrors.ERROR_CODES.PRICE_CHANGED:
            priceChanged(dispatch, origin, betError);
            break;
        case _apiErrors.ERROR_CODES.INSUFFICIENT_FUNDS:
            insufficientFunds(dispatch, origin, betError);
            break;
        case _apiErrors.ERROR_CODES.STARTING_PRICE_UNAVAILABLE:
            startingPriceUnavailable(dispatch, origin, betError);
            break;
        default:
    }
};

var placeBet = exports.placeBet = function placeBet(bookmaker, selectedBets, multiples, selectedFreeBet, feed, currencySign, isExternalLogout) {
    return function (dispatch) {
        // Flag that the place bet request has started (spinner starts)
        dispatch(placeBetRequest(true));

        // Clear any generic errors
        dispatch(_bookmakersInfo.actions.clearGenericError());

        // Clear all existing bet-specific errors
        selectedBets.forEach(function (selectedBet) {
            dispatch(_bookmakersInfo.actions.clearError(selectedBet.outcomersId.toString()));
        });

        var singlesWithEmptyStake = selectedBets.filter(function (bet) {
            return (0, _calculateStake.isEmptyStake)(bet.stake);
        });
        var multiplesWithEmptyStake = multiples.filter(function (multiple) {
            return (0, _calculateStake.isEmptyStake)(multiple.stakeValue);
        });
        var allSinglesEmpty = singlesWithEmptyStake.length === selectedBets.length;
        var allMultiplesEmpty = multiplesWithEmptyStake.length === multiples.length;
        if (allSinglesEmpty && allMultiplesEmpty) {
            // If all stakes are empty, throw a global modal
            dispatch(_modals.actions.setGlobalModal(_modalMessages.ENTER_STAKE));

            return Promise.reject();
        }

        // Set un-used bets so that they can be retrieved via Re-Use Selection
        var unusedBets = selectedBets.filter(function (bet) {
            return (0, _calculateStake.isEmptyStake)(bet.stake);
        });
        dispatch(_bookmakersInfo.actions.setUnusedBets(unusedBets));

        // Auto-logout if the user has been logged out from the bookmaker
        var onUnauthorized = (0, _login.requestLogout)(bookmaker, feed, isExternalLogout);

        // Filter _staked_ singles and multiples for placement
        var stakedMultiples = multiples.filter(function (multiple) {
            return !(0, _calculateStake.isEmptyStake)(multiple.stakeValue);
        });

        var selectedFreeBetId = selectedFreeBet ? selectedFreeBet.id : null;

        // Note that we still require un-staked singles
        return _apiClient2.default.placeBet(bookmaker, selectedBets, stakedMultiples, selectedFreeBetId, dispatch, onUnauthorized).then(function (responseBody) {
            (0, _updateAuthToken2.default)(responseBody.headers);
            dispatch(handlePlaceBetResponse(responseBody.data, selectedBets, stakedMultiples, selectedFreeBet));
        }).catch(function (error) {
            if ((0, _apiErrors.isUnknownError)(error)) {
                dispatch(_modals.actions.setGlobalModal(_modalMessages.GENERIC_ERROR));
                return Promise.reject();
            }

            var body = error.response.data;

            if ((0, _apiErrors.isGenericError)(body)) {
                var message = (0, _apiErrors.isBogUnavailable)(body) ? _modalMessages.BOG_UNAVAILABLE : _modalMessages.GENERIC_ERROR;
                dispatch(_modals.actions.setGlobalModal(message));
                return Promise.reject();
            }

            var errorsToFire = (0, _apiErrors.getErrorsToFire)(body.errors);
            errorsToFire.map(function (errorToFire) {
                return fireError(dispatch, 'BET', errorToFire, currencySign);
            });

            // Update CTA obstruction according to errors that were fired
            var errorCodes = errorsToFire.map(function (errorToFire) {
                return errorToFire.code;
            });
            dispatch(updateObstructions(errorCodes));

            return Promise.reject();
        });
    };
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.placedBetBookmakerSelector = exports.placedBetSelector = exports.betSelector = undefined;

var _reselect = __webpack_require__(25);

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var betSelector = exports.betSelector = function betSelector(_ref) {
    var bet = _ref.bet;
    return bet;
};

var placedBetSelector = exports.placedBetSelector = (0, _reselect.createSelector)(betSelector, function (_ref2) {
    var placedBetDetails = _ref2.placedBetDetails;
    return placedBetDetails || null;
});

var placedBetBookmakerSelector = exports.placedBetBookmakerSelector = (0, _reselect.createSelector)(placedBetSelector, function (placedBet) {
    return (0, _lodash2.default)(placedBet, 'bets[0].bets[0].feed', null);
});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _uuid = __webpack_require__(475);

var _bookmakersInfo = __webpack_require__(33);

var _bookmakersInfoBets = __webpack_require__(505);

var _bookmakersInfoBets2 = _interopRequireDefault(_bookmakersInfoBets);

var _bookmakersInfoMultiples = __webpack_require__(506);

var _bookmakersInfoMultiples2 = _interopRequireDefault(_bookmakersInfoMultiples);

var _freeBets = __webpack_require__(35);

var _updateBookmaker = __webpack_require__(507);

var _updateBookmaker2 = _interopRequireDefault(_updateBookmaker);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

var _localStorage = __webpack_require__(62);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var initialState = exports.initialState = {
    betslipID: null,
    bookmakersOrder: null,
    selectedBookmaker: null,
    selectedBets: [],
    multiples: [],
    multiplesStakes: [],
    multiplesEachWay: [],
    isBuildingBet: false,
    isBuildingMultiples: false,
    genericError: {
        errorId: null,
        message: null
    },
    unusedBets: [],
    previouslySelectedBookie: null
};

var associateSingles = function associateSingles(selectedBets, singles) {
    return selectedBets.map(function (selectedBet) {
        var associatedBet = singles.find(function (selection) {
            return selection.outcomersId === selectedBet.outcomersId;
        });
        return _extends({}, selectedBet, {
            associatedBet: {
                optionId: associatedBet.optionId,
                minStake: associatedBet.minStake,
                maxStake: associatedBet.maxStake,
                numberLines: associatedBet.numberLines
            }
        });
    });
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var betAlreadyAdded = void 0;
    var selectedBets = void 0;
    var betslipID = void 0;

    switch (action.type) {
        case _bookmakersInfo.actionTypes.SET_BOOKMAKERS_ORDER:
            return _extends({}, state, {
                bookmakersOrder: action.bookmakersOrder,
                orderExpiration: action.orderExpiration

                // eslint-disable-next-line no-case-declarations
            });case _bookmakersInfo.actionTypes.SET_SELECTED_BOOKMAKER:
            var previouslySelectedBookie = state.selectedBookmaker;

            if ((0, _localStorage.isLocalStorageAvailable)() && action.feed) {
                var selectedBookmakerFeed = action.feed === "PPWR" ? "PADDYPOWER" : action.feed;
                (0, _localStorage.setLocalStorage)('selectedBookmaker', selectedBookmakerFeed);
            }

            return _extends({}, state, {
                previouslySelectedBookie: previouslySelectedBookie,
                selectedBookmaker: action.feed
            });

        case _bookmakersInfo.actionTypes.ADD_SELECTED_BET:

            betAlreadyAdded = state.selectedBets.filter(function (bet) {
                return bet.outcomersId === action.betInfo.outcomersId;
            }).length > 0;

            // Maximum 10 bets
            if (betAlreadyAdded || state.selectedBets.length === 10) {
                return state;
            }

            if (state.selectedBets.length === 0) {
                betslipID = '' + (0, _uuid.v4)();
            }

            return _extends({}, state, {
                selectedBets: [].concat(_toConsumableArray(state.selectedBets), [(0, _bookmakersInfoBets2.default)(undefined, action)]),
                betslipID: state.selectedBets.length !== 0 ? state.betslipID : betslipID
            });

        case _bookmakersInfo.actionTypes.DELETE_BET:
            // Retain all bets other than the target we are deleting
            selectedBets = state.selectedBets.filter(function (bet) {
                return bet.outcomersId !== action.outcomersId;
            });

            return _extends({}, state, {
                selectedBets: selectedBets,
                betslipID: selectedBets.length === 0 ? null : state.betslipID
            });

        case _bookmakersInfo.actionTypes.CLEAR_SELECTED_BETS:
            return _extends({}, state, {
                selectedBets: [],
                betslipID: null
            });

        case _bookmakersInfo.actionTypes.CLEAR_SUSPENDED_BETS:
            selectedBets = state.selectedBets.filter(function (bet) {
                return bet.isSuspended === false;
            });

            return _extends({}, state, {
                selectedBets: selectedBets,
                betslipID: selectedBets.length === 0 ? null : state.betslipID

                // Selected Bets
            });case _bookmakersInfo.actionTypes.SET_STAKE_FOR_SELECTED_BET:
        case _bookmakersInfo.actionTypes.SET_ISEACHWAY_FOR_SELECTED_BET:
        case _bookmakersInfo.actionTypes.SET_PRICE_TYPE_FOR_SELECTED_BET:
        case _bookmakersInfo.actionTypes.SET_ERROR:
        case _bookmakersInfo.actionTypes.SET_ERROR_ON_BUILD:
        case _bookmakersInfo.actionTypes.CLEAR_ERROR:
        case _bookmakersInfo.actionTypes.CLEAR_ALL_ERRORS:
        case _bookmakersInfo.actionTypes.SET_SUSPENDED_BET:
        case _bookmakersInfo.actionTypes.SET_SUSPENDED_BET_ON_BUILD:
        case _bookmakersInfo.actionTypes.SET_PRICE_CHANGED:
        case _bookmakersInfo.actionTypes.SET_PRICE_CHANGED_ON_BUILD:
        case _bookmakersInfo.actionTypes.UPDATE_ALL_BET_PRICES:
        case _bookmakersInfo.actionTypes.UPDATE_BET_PRICE:
        case _bookmakersInfo.actionTypes.UPDATE_ALL_STARTING_PRICES_AVAILABILITY:
        case _bookmakersInfo.actionTypes.TOGGLE_MULTIPLES_INCLUSION:
        case _bookmakersInfo.actionTypes.SET_MINIMUM_STAKE:
        case _bookmakersInfo.actionTypes.SET_MAXIMUM_STAKE:
        case _bookmakersInfo.actionTypes.SET_FREE_BET_MINIMUM_STAKE:
        case _bookmakersInfo.actionTypes.SET_FREE_BET_MAXIMUM_STAKE:
        case _bookmakersInfo.actionTypes.SET_LOCKED_STAKE:
        case _bookmakersInfo.actionTypes.CLEAR_LOCKED_STAKE:
        case _freeBets.actions.actionTypes.FREE_BETS_CLEAR:
            {
                var updatedSingleBets = state.selectedBets.map(function (bet) {
                    return (0, _bookmakersInfoBets2.default)(bet, action);
                });

                return _extends({}, state, {
                    selectedBets: updatedSingleBets
                });
            }

        // Multiples
        case _bookmakersInfo.actionTypes.SET_MULTIPLES:
            {
                var updatedMultiples = action.multiples.map(function (multiple) {
                    return (0, _bookmakersInfoMultiples2.default)(state, multiple, action);
                });

                return _extends({}, state, {
                    multiples: updatedMultiples
                });
            }

        case _bookmakersInfo.actionTypes.SAVE_MULTIPLES_STAKES:
            {
                var multiplesStakes = state.multiples.map(function (multiple) {
                    return {
                        optionId: multiple.optionId,
                        stake: multiple.stakeValue
                    };
                });

                return _extends({}, state, {
                    multiplesStakes: multiplesStakes
                });
            }

        case _bookmakersInfo.actionTypes.SAVE_MULTIPLES_EACHWAY:
            {
                var multiplesEachWay = state.multiples.map(function (multiple) {
                    return {
                        optionId: multiple.optionId,
                        isEachWay: multiple.isEachWay
                    };
                });

                return _extends({}, state, {
                    multiplesEachWay: multiplesEachWay
                });
            }

        case _bookmakersInfo.actionTypes.SET_STAKE_FOR_MULTIPLE:
        case _bookmakersInfo.actionTypes.SET_IS_EACHWAY_FOR_MULTIPLE:
        case _bookmakersInfo.actionTypes.SET_IS_EDITING_STAKE_FOR_MULTIPLE:
        case _bookmakersInfo.actionTypes.SET_MULTIPLES_ERROR:
        case _bookmakersInfo.actionTypes.CLEAR_MULTIPLES_ERROR:
        case _bookmakersInfo.actionTypes.CLEAR_ALL_MULTIPLES_ERRORS:
        case _bookmakersInfo.actionTypes.CHANGE_SELECTION_ORDER:
        case _bookmakersInfo.actionTypes.RESTORE_MULTIPLES_STAKES:
        case _bookmakersInfo.actionTypes.RESTORE_MULTIPLES_EACHWAY:
            {
                var _updatedMultiples = state.multiples.map(function (multiple) {
                    return (0, _bookmakersInfoMultiples2.default)(state, multiple, action);
                });

                return _extends({}, state, {
                    multiples: _updatedMultiples
                });
            }

        case _bookmakersInfo.actionTypes.BUILD_MULTIPLES_REQUEST:
            {
                return _extends({}, state, {
                    isBuildingMultiples: action.isBuildingMultiples
                });
            }

        case _bookmakersInfo.actionTypes.CLEAR_MULTIPLES:
            {
                return _extends({}, state, {
                    multiples: []
                });
            }

        case _bookmakersInfo.actionTypes.BUILD_BET_REQUEST:
            {
                return _extends({}, state, {
                    isBuildingBet: action.isBuildingBet
                });
            }

        case _bookmakersInfo.actionTypes.ASSOCIATE_SINGLES:
            {
                var associatedSingles = associateSingles(state.selectedBets, action.singles);

                return _extends({}, state, {
                    selectedBets: associatedSingles
                });
            }

        case _bookmakersInfo.actionTypes.TOGGLE_BALANCE_VISIBILITY:
        case _bookmakersInfo.actionTypes.REMOVE_USERNAME:
        case _bookmakersInfo.actionTypes.SAVE_USERNAME:
            {
                return _extends({}, state, _defineProperty({}, action.feed, (0, _updateBookmaker2.default)(state[action.feed], action)));
            }

        case _bookmakersInfo.actionTypes.SET_IS_EDITING_STAKE:
            return _extends({}, state, {
                selectedBets: state.selectedBets.map(function (bet) {
                    return (0, _bookmakersInfoBets2.default)(bet, action);
                })
            });

        case _bookmakersInfo.actionTypes.SET_GENERIC_ERROR:
        case _bookmakersInfo.actionTypes.SET_GENERIC_ERROR_ON_BUILD:
            return _extends({}, state, {
                genericError: action.error
            });

        case _bookmakersInfo.actionTypes.CLEAR_GENERIC_ERROR:
            return _extends({}, state, {
                genericError: {
                    errorId: null,
                    message: null
                }
            });

        case _bookmakersInfo.actionTypes.SET_UNUSED_BETS:
            return _extends({}, state, {
                unusedBets: action.unusedBets.map(function (bet) {
                    return _extends({}, bet, {
                        stake: '',
                        isEachWay: false,
                        priceType: bet.isSpOnly ? _priceTypes2.default.SP : _priceTypes2.default.ODDS
                    });
                })
            });

        case _bookmakersInfo.actionTypes.CLEAR_UNUSED_BETS:
            return _extends({}, state, {
                unusedBets: []
            });

        default:
            return state;
    }
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usernameSelector = exports.betBookmakerSelector = exports.selectedBetSelector = exports.selectedBookmakerSelector = exports.bookmakersInfoSelector = undefined;

var _reselect = __webpack_require__(25);

var _transitionRouter = __webpack_require__(218);

var bookmakersInfoSelector = exports.bookmakersInfoSelector = function bookmakersInfoSelector(_ref) {
    var bookmakersInfo = _ref.bookmakersInfo;
    return bookmakersInfo;
};

var selectedBookmakerSelector = exports.selectedBookmakerSelector = (0, _reselect.createSelector)(bookmakersInfoSelector, function (_ref2) {
    var selectedBookmaker = _ref2.selectedBookmaker;
    return selectedBookmaker;
});

var selectedBetSelector = exports.selectedBetSelector = (0, _reselect.createSelector)(bookmakersInfoSelector, function (_ref3) {
    var selectedBets = _ref3.selectedBets;
    return selectedBets;
});

var betBookmakerSelector = exports.betBookmakerSelector = (0, _reselect.createSelector)(selectedBetSelector, function (selectedBets) {
    return selectedBets.length && selectedBets[0].feed || null;
});

var usernameSelector = exports.usernameSelector = (0, _reselect.createSelector)([bookmakersInfoSelector, _transitionRouter.feedSelector], function (bookmakersInfo, feed) {
    return bookmakersInfo[feed] && bookmakersInfo[feed].username ? bookmakersInfo[feed].username : '';
});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = exports.actionTypes = {
    SET_CURRENT_ACTIVE_POPOVER: 'SET_CURRENT_ACTIVE_POPOVER',
    CLOSE_CURRENT_ACTIVE_POPOVER: 'CLOSE_CURRENT_ACTIVE_POPOVER'
};

var setActivePopoverWithTypeAndFeed = exports.setActivePopoverWithTypeAndFeed = function setActivePopoverWithTypeAndFeed(modalType, feed) {
    return {
        type: actionTypes.SET_CURRENT_ACTIVE_POPOVER,
        activePopoverType: modalType,
        activePopoverFeed: feed
    };
};

var closeCurrentPopover = exports.closeCurrentPopover = function closeCurrentPopover() {
    return {
        type: actionTypes.CLOSE_CURRENT_ACTIVE_POPOVER
    };
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.constants = exports.actions = exports.reducer = undefined;

var _bookmakersButtonsPopovers = __webpack_require__(512);

var _bookmakersButtonsPopovers2 = _interopRequireDefault(_bookmakersButtonsPopovers);

var _bookmakersButtonsPopovers3 = __webpack_require__(207);

var actions = _interopRequireWildcard(_bookmakersButtonsPopovers3);

var _bookmakersButtonsPopovers4 = __webpack_require__(511);

var constants = _interopRequireWildcard(_bookmakersButtonsPopovers4);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.reducer = _bookmakersButtonsPopovers2.default;
exports.actions = actions;
exports.constants = constants;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReduxFormCheckbox = exports.Checkbox = undefined;

var _Checkbox = __webpack_require__(229);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _ReduxFormCheckbox = __webpack_require__(584);

var _ReduxFormCheckbox2 = _interopRequireDefault(_ReduxFormCheckbox);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Checkbox = _Checkbox2.default;
exports.ReduxFormCheckbox = _ReduxFormCheckbox2.default;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CssSpinner = __webpack_require__(586);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CssSpinner).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Deposit = __webpack_require__(587);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Deposit).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EachWay = __webpack_require__(588);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EachWay).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgottenPassword = __webpack_require__(592);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ForgottenPassword).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = exports.actionTypes = {
    SET_FREE_BETS: 'SET_FREE_BETS',
    CLEAR_FREE_BETS: 'CLEAR_FREE_BETS',
    SELECT_FREE_BET: 'SELECT_FREE_BET',
    CLEAR_FREE_BET: 'CLEAR_FREE_BET'
};

var clearFreeBets = exports.clearFreeBets = function clearFreeBets() {
    return {
        type: actionTypes.CLEAR_FREE_BETS
    };
};

var setFreeBets = exports.setFreeBets = function setFreeBets(list) {
    return {
        type: actionTypes.SET_FREE_BETS,
        list: list
    };
};

var selectFreeBet = exports.selectFreeBet = function selectFreeBet(freeBetId) {
    return {
        type: actionTypes.SELECT_FREE_BET,
        freeBetId: freeBetId
    };
};

var clearFreeBet = exports.clearFreeBet = function clearFreeBet() {
    return {
        type: actionTypes.CLEAR_FREE_BET
    };
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = exports.actionTypes = {
    SHOW_GDPR_POPUP: 'SHOW_GDPR_POPUP',
    CLOSE_GDPR_POPUP: 'CLOSE_GDPR_POPUP'
};

var showGdprPopup = exports.showGdprPopup = function showGdprPopup(url) {
    return {
        type: actionTypes.SHOW_GDPR_POPUP,
        url: url
    };
};

var closeGdprPopup = exports.closeGdprPopup = function closeGdprPopup() {
    return {
        type: actionTypes.CLOSE_GDPR_POPUP
    };
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadAppConfig = exports.closeBookmakerSwitcherPopover = exports.openBookmakerSwitcherPopover = exports.appConfigReceived = exports.setApiUrl = exports.setDeviceType = exports.setUseDecimalOdds = exports.actionTypes = undefined;

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var actionTypes = exports.actionTypes = {
    SET_DEVICE_TYPE: "SET_DEVICE_TYPE",
    SET_API_URL: "SET_API_URL",
    APP_CONFIG_RECEIVED: "APP_CONFIG_RECEIVED",
    USE_DECIMAL_ODDS: "USE_DECIMAL_ODDS",
    OPEN_BOOKMAKER_SWITCHER_POPOVER: "OPEN_BOOKMAKER_SWITCHER_POPOVER",
    CLOSE_BOOKMAKER_SWITCHER_POPOVER: "CLOSE_BOOKMAKER_SWITCHER_POPOVER"
};

var setUseDecimalOdds = exports.setUseDecimalOdds = function setUseDecimalOdds(useDecimalOdds) {
    return {
        type: actionTypes.USE_DECIMAL_ODDS,
        useDecimalOdds: useDecimalOdds
    };
};

var setDeviceType = exports.setDeviceType = function setDeviceType(isPhone, isTablet) {
    return {
        type: actionTypes.SET_DEVICE_TYPE,
        isPhone: isPhone,
        isTablet: isTablet
    };
};

var setApiUrl = exports.setApiUrl = function setApiUrl(apiUrl, apiV3Url) {
    return {
        type: actionTypes.SET_API_URL,
        apiUrl: apiUrl,
        apiV3Url: apiV3Url
    };
};

var appConfigReceived = exports.appConfigReceived = function appConfigReceived(config, isPhone) {
    return {
        type: actionTypes.APP_CONFIG_RECEIVED,
        isPhone: isPhone,
        config: config
    };
};

var openBookmakerSwitcherPopover = exports.openBookmakerSwitcherPopover = function openBookmakerSwitcherPopover() {
    return {
        type: actionTypes.OPEN_BOOKMAKER_SWITCHER_POPOVER
    };
};

var closeBookmakerSwitcherPopover = exports.closeBookmakerSwitcherPopover = function closeBookmakerSwitcherPopover() {
    return {
        type: actionTypes.CLOSE_BOOKMAKER_SWITCHER_POPOVER
    };
};

var loadAppConfig = exports.loadAppConfig = function loadAppConfig(isPhone) {
    return function (dispatch) {
        return _apiClient2.default.loadAppConfig().then(function (data) {
            dispatch(appConfigReceived(data, isPhone));
        }).catch(function (err) {
            console.error("An error occured", err);
        });
    };
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.topUpAccountBalance = exports.getCardDetails = exports.setCardDetailsError = exports.cardDetailsReceived = exports.hideTopUpModal = exports.showTopUpModal = exports.actionTypes = undefined;

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _updateAuthToken = __webpack_require__(49);

var _updateAuthToken2 = _interopRequireDefault(_updateAuthToken);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var actionTypes = exports.actionTypes = {
    SHOW_TOP_UP_MODAL: 'SHOW_TOP_UP_MODAL',
    HIDE_TOP_UP_MODAL: 'HIDE_TOP_UP_MODAL',
    CARD_DETAILS_RECEIVED: 'CARD_DETAILS_RECEIVED',
    CARD_DETAILS_ERROR: 'CARD_DETAILS_ERROR',
    TOP_UP_FAIL: 'TOP_UP_FAIL'
};

var showTopUpModal = exports.showTopUpModal = function showTopUpModal() {
    return {
        type: actionTypes.SHOW_TOP_UP_MODAL
    };
};

var hideTopUpModal = exports.hideTopUpModal = function hideTopUpModal() {
    return {
        type: actionTypes.HIDE_TOP_UP_MODAL
    };
};

var topUpFail = function topUpFail(errorInfo) {
    return {
        type: actionTypes.TOP_UP_FAIL,
        errorInfo: errorInfo
    };
};

var cardDetailsReceived = exports.cardDetailsReceived = function cardDetailsReceived(cardDetails) {
    return {
        type: actionTypes.CARD_DETAILS_RECEIVED,
        cardDetails: cardDetails
    };
};

var setCardDetailsError = exports.setCardDetailsError = function setCardDetailsError() {
    return {
        type: actionTypes.CARD_DETAILS_ERROR
    };
};

var getCardDetails = exports.getCardDetails = function getCardDetails(bookie) {
    return function (dispatch) {
        return _apiClient2.default.getCardDetails(bookie).then(function (res) {
            (0, _updateAuthToken2.default)(res.headers);
            if (res.status === 200 && res.data && res.data.data) {
                var cardData = res.data.data.filter(function (card) {
                    return card.type === 'card-info';
                })[0] || {};

                if (cardData.attributes) {
                    var formattedCardData = {
                        cardId: cardData.id,
                        cardNumber: '**** ' + cardData.attributes.card_number,
                        cleanCardNumber: cardData.attributes.card_number,
                        cardType: cardData.attributes.card_type,
                        maxDepositAmount: cardData.attributes.max_deposit_amount,
                        minDepositAmount: cardData.attributes.min_deposit_amount
                    };

                    return dispatch(cardDetailsReceived(formattedCardData));
                }
            }
            return Promise.reject();
        }).catch(function () {
            return dispatch(setCardDetailsError());
        });
    };
};

var topUpAccountBalance = exports.topUpAccountBalance = function topUpAccountBalance(bookie, cv2, amount, cardId) {
    return function (dispatch) {
        var body = {
            cv2: cv2,
            amount: Math.round(parseFloat(amount) * 100) / 100,
            card_number: cardId
        };

        return _apiClient2.default.topUp(bookie, body).then(function (res) {
            (0, _updateAuthToken2.default)(res.headers);
            if (res.status === 200 && res.data && res.data.data && res.data.data.attributes && res.data.data.attributes.success) {
                return dispatch(showTopUpModal());
            }
            return Promise.reject(res);
        }).catch(function (err) {
            dispatch(topUpFail((0, _lodash2.default)(err, 'response.data.errors[0]', {})));
            return Promise.reject(err);
        });
    };
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var feedSelector = exports.feedSelector = function feedSelector(state, props) {
  return props.match.params.feed;
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (betSelections, selectedBets) {
    return betSelections.map(function (bet) {
        return selectedBets.find(function (selectedBet) {
            return selectedBet.outcomersId === bet.selectionId && selectedBet.eventId === bet.eventId;
        });
    });
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isForecastMultiple = isForecastMultiple;
exports.getReturnsForMultiple = getReturnsForMultiple;
exports.getReturnsForMultiples = getReturnsForMultiples;

var _multiples = __webpack_require__(64);

var _estimatedReturn = __webpack_require__(88);

function isForecastMultiple(betType) {
    return !!_multiples.forecastMultiples.find(function (name) {
        return name === betType;
    });
}

function isSpecialMultiple(betType) {
    return !!Object.values(_multiples.specialMultiples).find(function (special) {
        return special === betType;
    });
}

function getDynamicComboLength(betType) {
    if (betType === 'double') {
        return 2;
    }

    if (betType === 'treble') {
        return 3;
    }

    // All other cases should be `accumulator-${n}`
    var num = betType.replace(/^\D+/g, '');

    return parseInt(num, 10);
}

function getBestPricesByEvent(selectedBets) {
    // Reduce selectedBets to 1 horse per race, picking the longest
    // possible price
    var races = selectedBets.map(function (selectedBet) {
        return selectedBet.eventId + '-' + selectedBet.meetingId;
    });
    var uniqueRaces = Array.from(new Set(races));
    var bestPriced = uniqueRaces.map(function (hybridRaceId) {
        var prices = selectedBets.filter(function (bet) {
            return bet.eventId + '-' + bet.meetingId === hybridRaceId;
        });
        return prices.reduce(function (a, b) {
            return a.decimalPrice >= b.decimalPrice ? a : b;
        });
    });

    // best price per race
    return bestPriced.map(function (bet) {
        return {
            hybridRaceId: bet.eventId + '-' + bet.meetingId,
            decimalPrice: bet.decimalPrice,
            fractionalPrice: bet.fractionalPrice,
            eachWayFraction: bet.eachWayFraction
        };
    });
}

/**
 * Generates all combinations of `comboLength` inside an array of bet objects.
 *
 * For example, it can fetch all doubles accross 8 horses, one component
 * of a goliath bet.
 *
 * @param  {Array<Object>} bets e.g. [{ a: 1 }, { b: 2 }, { c: 3 }]
 * @param  {Number} comboLength e.g. 2
 *
 * @return {Array} e.g. [
 *                          [{ a: 1 }, { b: 2 }],
 *                          [{ a: 2 }, { b: 3 }],
 *                          [{ a: 1 }, { b: 3 }],
 *                      ]
 */
function getBetCombinations(bets, comboLength) {
    var numberOfBets = bets.length;
    var combinations = [];

    var comboIsPossible = function comboIsPossible(i, end, currentIndex) {
        var beforeEnd = i <= end;
        var belowComboLimit = end - i + 1 >= comboLength - currentIndex;

        return beforeEnd && belowComboLimit;
    };

    var getCombination = function getCombination(currentIndex, start, end, currentCombo) {
        if (currentIndex === comboLength) {
            var combination = [];
            for (var j = 0; j < comboLength; j += 1) {
                combination.push(currentCombo[j]);
            }

            combinations.push(combination);
        }

        var newCombo = currentCombo.slice(0, currentCombo.length);
        for (var i = start; comboIsPossible(i, end, currentIndex); i += 1) {
            newCombo[currentIndex] = bets[i];
            // NOTE - recursion
            getCombination(currentIndex + 1, i + 1, end, newCombo);
        }
    };

    var currentCombo = [comboLength];
    var start = 0;
    var end = numberOfBets - 1;
    var startingIndex = 0;
    getCombination(startingIndex, start, end, currentCombo);

    // Don't allow combinations where horses are in the same race
    combinations = combinations.filter(function (selections) {
        var races = selections.map(function (selection) {
            return selection.hybridRaceId;
        });
        var uniqueRaces = Array.from(new Set(races));

        return uniqueRaces.length === selections.length;
    });

    return combinations;
}

/**
 * Calculates the total of a [non-EW], straight multiple.
 * By "straight", we mean all odds are accumalated.
 *
 * @param  {Array} selectedBets
 * @param  {Number} parsedStake
 * @param  {Object} multiple
 *
 * @return {Number} e.g. 112.4
 */
function getReturnsForStraight(parsedStake, selectionsData) {
    var stake = parsedStake;

    var returns = selectionsData.reduce(function (subTotal, selectionData) {
        var fractionalPrice = selectionData.fractionalPrice;

        var betReturn = (0, _estimatedReturn.calculateReturn)(stake, fractionalPrice, false);
        stake = betReturn;

        return betReturn;
    }, 0);

    return returns;
}

/**
 * Calculates the total of an EW straight multiple, such as a double.
 *
 * The business rule for the returns of a bet like this is:
 *   1. Accumalate the potential WIN returns, using each bet winnings as
 *      the stake for the next bet
 *   2. Accumalate the potential PLACE returns, using each bet winnings
 *      as the stake for the next bet
 *   3. Sum these 2 values together
 *
 * @param  {Array} selectedBets
 * @param  {Number} parsedStake
 * @param  {Object} multiple
 *
 * @return {Number} e.g. 112.4
 */
function getReturnsForStraightEw(parsedStake, selectionsData) {
    // 1. Accumalate win outcomes
    var accumalatedWinReturns = getReturnsForStraight(parsedStake, selectionsData);

    // 2. Accumalate place outcomes
    var placeStake = parsedStake;
    var accumalatedPlaceReturns = selectionsData.reduce(function (runningTotal, selectionData) {
        var fractionalPrice = selectionData.fractionalPrice,
            eachWayFraction = selectionData.eachWayFraction;

        var placeReturn = (0, _estimatedReturn.calculateReturn)(placeStake, fractionalPrice, eachWayFraction, true);

        placeStake = placeReturn;

        return placeReturn;
    }, 0);

    // 3. Sum the accumalated win returns & accumalated place returns
    return accumalatedWinReturns + accumalatedPlaceReturns;
}

/**
 * Calculates the estimated returns for 1 multiple bet.
 * This could be a straight multiple like a double, a complex
 * multiple or even a forecast (forecast is always 0 as we show N/A)
 *
 * @param  {Array} selectedBets
 * @param  {Object} multiple - build bet data
 *
 * @return {Number} e.g. 112.4
 */
function getReturnsForMultiple(selectedBets, multiple) {
    // Note that EW is at the multiple level here
    var stakeValue = multiple.stakeValue,
        betType = multiple.betType,
        isEachWay = multiple.isEachWay;

    var parsedStake = Number.parseFloat(stakeValue) || 0;

    // Do not include any forecast bets
    if (isForecastMultiple(betType)) {
        return 0;
    }

    // Account for special multiples
    // e.g. trixie, lucky-15, goliath, etc
    if (isSpecialMultiple(betType)) {
        var multipleCombos = _multiples.specialCombos[betType];
        var singlesPrices = selectedBets.map(function (bet) {
            return {
                hybridRaceId: bet.eventId + '-' + bet.meetingId,
                decimalPrice: bet.decimalPrice,
                fractionalPrice: bet.fractionalPrice,
                eachWayFraction: bet.eachWayFraction
            };
        });

        var specialReturns = multipleCombos.reduce(function (returns, comboLength) {
            var combos = getBetCombinations(singlesPrices, comboLength);
            combos.forEach(function (combo) {
                var subReturns = isEachWay ? getReturnsForStraightEw(parsedStake, combo) : getReturnsForStraight(parsedStake, combo);
                returns.push(subReturns);
            });
            return returns;
        }, []);

        var summedSpecialReturns = specialReturns.length ? specialReturns.reduce(function (a, b) {
            return a + b;
        }) : 0;

        return summedSpecialReturns;
    }

    var comboLength = getDynamicComboLength(betType);
    var betPrices = getBestPricesByEvent(selectedBets);
    var combos = getBetCombinations(betPrices, comboLength);
    var dynamicReturns = combos.map(function (combo) {
        var subReturns = isEachWay ? getReturnsForStraightEw(parsedStake, combo) : getReturnsForStraight(parsedStake, combo);

        return subReturns;
    });

    var summedDynamicReturns = dynamicReturns.length ? dynamicReturns.reduce(function (a, b) {
        return a + b;
    }) : 0;

    return summedDynamicReturns;
}

/**
 * Calculates the returns for all multiples (or a
 * subset, if that was to be required).
 *
 * @param  {Array} selectedBets
 * @param  {Array} multiples
 *
 * @return {Number} e.g. 112.4
 */
function getReturnsForMultiples(selectedBets, multiples) {
    if (multiples.length === 0) {
        return 0;
    }

    return multiples.reduce(function (runningTotal, multiple) {
        var multipleReturns = getReturnsForMultiple(selectedBets, multiple);

        // Add together all totals of all multiples
        return runningTotal + multipleReturns;
    }, 0);
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var flow = function flow() {
    for (var _len = arguments.length, actions = Array(_len), _key = 0; _key < _len; _key++) {
        actions[_key] = arguments[_key];
    }

    return function (value) {
        return actions.reduce(function (args, action) {
            return action(args);
        }, value);
    };
};

/**
 * Rounds a float to 2 digits after a decimal point, "half-down".
 * @param {string|number} float - a string represetation of a float, or a float number
 * @returns {number} - a float rounded to 2 digits after a decimal point.
 */
var roundHalfDown = flow(parseFloat,
// round "half-down": 2.2250 -> 2.22
function (x) {
    return x * 100 - 0.1;
}, Math.round, function (x) {
    return x / 100;
});

exports.default = roundHalfDown;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localStorage = __webpack_require__(62);

var _bookmakersList = __webpack_require__(123);

var updateUserAccountsInfoStorage = function updateUserAccountsInfoStorage(bookmaker, isLoggedIn) {
    if ((0, _localStorage.isLocalStorageAvailable)()) {
        var userAccountsInfo = (0, _localStorage.getLocalStorage)("userAccountsInfo") || {};
        var recentBookmakers = (0, _localStorage.getLocalStorage)("recentBookmakers") || {};
        var apiName = bookmaker.apiName,
            feed = bookmaker.feed,
            isExternalLogout = bookmaker.isExternalLogout,
            userInfo = bookmaker.userInfo;

        var balance = userInfo && userInfo.balance;
        var recentBookmaker = _bookmakersList.RECENT_BOOKMAKERS_MAP[bookmaker.apiName];
        recentBookmakers[recentBookmaker] = true;

        if (!userAccountsInfo[feed]) {
            userAccountsInfo[feed] = {};
        }

        userAccountsInfo[feed] = {
            balance: isNaN(balance) ? userAccountsInfo[feed].balance : balance,
            isLoggedIn: isLoggedIn,
            apiName: apiName,
            feed: feed,
            isExternalLogout: isExternalLogout
        };

        (0, _localStorage.setLocalStorage)("userAccountsInfo", userAccountsInfo);
        (0, _localStorage.setLocalStorage)("recentBookmakers", recentBookmakers);
    }
};

exports.default = updateUserAccountsInfoStorage;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FreeBetsContainer = __webpack_require__(646);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FreeBetsContainer).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _drawer = __webpack_require__(38);

var initialState = exports.initialState = {
    isDrawerMinimized: true,
    theme: 'no-bookmaker',
    isQuickslipMode: true
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _drawer.actionTypes.MINIMIZE_DRAWER:
            return _extends({}, state, {
                isDrawerMinimized: true
            });
        case _drawer.actionTypes.MAXIMIZE_DRAWER:
            return _extends({}, state, {
                isDrawerMinimized: false
            });
        case _drawer.actionTypes.SET_THEME:
            return _extends({}, state, {
                theme: action.theme
            });
        case _drawer.actionTypes.SET_QUICKSLIP_MODE:
            return _extends({}, state, {
                isQuickslipMode: action.enabled
            });
        default:
            return state;
    }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.drawerBookmakerSelector = exports.drawerInfoSelector = undefined;

var _reselect = __webpack_require__(25);

var _bet = __webpack_require__(204);

var _bookmakersInfo = __webpack_require__(206);

var drawerInfoSelector = exports.drawerInfoSelector = function drawerInfoSelector(_ref) {
    var drawerInfo = _ref.drawerInfo;
    return drawerInfo;
};

var drawerBookmakerSelector = exports.drawerBookmakerSelector = (0, _reselect.createSelector)([_bet.placedBetBookmakerSelector, _bookmakersInfo.betBookmakerSelector], function (placedBetFeed, betFeed) {
    return placedBetFeed || betFeed;
});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = exports.actionTypes = {
    SHOW_SELECTION_INFO_MODAL: 'SHOW_SELECTION_INFO_MODAL',
    HIDE_SELECTION_INFO_MODAL: 'HIDE_SELECTION_INFO_MODAL',
    SET_GLOBAL_MODAL: 'SET_GLOBAL_MODAL',
    CLEAR_GLOBAL_MODAL: 'CLEAR_GLOBAL_MODAL'
};

var showSelectionInfoModal = exports.showSelectionInfoModal = function showSelectionInfoModal() {
    return {
        type: actionTypes.SHOW_SELECTION_INFO_MODAL
    };
};

var hideSelectionInfoModal = exports.hideSelectionInfoModal = function hideSelectionInfoModal() {
    return {
        type: actionTypes.HIDE_SELECTION_INFO_MODAL
    };
};

var setGlobalModal = exports.setGlobalModal = function setGlobalModal(_ref) {
    var title = _ref.title,
        body = _ref.body,
        ctaTitle = _ref.ctaTitle;
    return {
        type: actionTypes.SET_GLOBAL_MODAL,
        title: title,
        body: body,
        ctaTitle: ctaTitle
    };
};

var clearGlobalModal = exports.clearGlobalModal = function clearGlobalModal() {
    return {
        type: actionTypes.CLEAR_GLOBAL_MODAL
    };
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Account = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(8);

var _reactRedux = __webpack_require__(4);

__webpack_require__(233);

var _pageHeader = __webpack_require__(86);

var _pageHeader2 = _interopRequireDefault(_pageHeader);

var _colorSkinWrapper = __webpack_require__(45);

var _colorSkinWrapper2 = _interopRequireDefault(_colorSkinWrapper);

var _bookmakersInfo = __webpack_require__(6);

var _transitionRouter = __webpack_require__(16);

var _bookmakersList = __webpack_require__(5);

var _userInfo = __webpack_require__(11);

var _userInfo2 = _interopRequireDefault(_userInfo);

var _externalAccount = __webpack_require__(34);

var _Tabs = __webpack_require__(563);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _betHistory = __webpack_require__(497);

var _betHistory2 = _interopRequireDefault(_betHistory);

var _accountInfo = __webpack_require__(495);

var _accountInfo2 = _interopRequireDefault(_accountInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/account/info",
	component: _accountInfo2.default
});

var _ref3 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/account/bethistory",
	component: _betHistory2.default
});

var Account = exports.Account = function Account(_ref) {
	var name = _ref.name,
	    feed = _ref.feed,
	    userInfo = _ref.userInfo,
	    showBalance = _ref.showBalance,
	    hasAccountTabs = _ref.hasAccountTabs,
	    hasLogoOnAccountHeader = _ref.hasLogoOnAccountHeader,
	    toggleBalanceVisibility = _ref.toggleBalanceVisibility;
	return _jsx(_colorSkinWrapper2.default, {
		bookmakerName: name,
		className: "bs-popover__content\n                            bs-switchBookmakers__content\n                            bs-horizontalSlider__element"
	}, void 0, _jsx(_pageHeader2.default, {
		hideLogo: !hasLogoOnAccountHeader,
		backLinkUrl: "/"
	}, void 0, _react2.default.createElement(_userInfo2.default, _extends({}, userInfo, {
		showBalance: showBalance,
		toggleBalanceVisibility: toggleBalanceVisibility,
		selectedBookmakerFeed: feed
	}))), hasAccountTabs && _jsx(_Tabs2.default, {
		feed: feed
	}), _ref2, _ref3);
};

Account.defaultProps = {
	hasLogoOnAccountHeader: false,
	hasAccountTabs: true,
	apiName: ""
};

var userInfoSelector = _userInfo.selectors.createUserInfoSelector(_transitionRouter.selectors.feedSelector);

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var showBalanceSelector = _userInfo.selectors.createShowBalanceSelector(_transitionRouter.selectors.feedSelector);

var mapStateToProps = function mapStateToProps(state, props) {
	return _extends({}, bookmakerInfoSelector(state, props), {
		feed: _transitionRouter.selectors.feedSelector(state, props),
		userInfo: userInfoSelector(state, props),
		showBalance: showBalanceSelector(state, props)
	});
};

var mapDispatchToProps = {
	toggleBalanceVisibility: _bookmakersInfo.actions.toggleBalanceVisibility,
	clearExternalAccountData: _externalAccount.actions.clearExternalAccountData,
	setLoggedOut: _bookmakersList.actions.setLoggedOut,
	getUserInfo: _bookmakersList.actions.getUserInfo
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Account);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('svg', {
	width: '86',
	height: '40',
	viewBox: '0 0 86 40',
	fill: 'none',
	xmlns: 'http://www.w3.org/2000/svg'
}, void 0, _jsx('g', {
	clipPath: 'url(#clip0_2051_4898)'
}, void 0, _jsx('rect', {
	width: '86',
	height: '40',
	rx: '4',
	fill: 'white'
}), _jsx('path', {
	d: 'M4.76228 0.476562H79.048C81.4289 0.476562 83.3337 2.38132 83.3337 4.76228V35.2385C83.3337 37.6194 81.4289 39.5242 79.048 39.5242H4.76228C2.38132 39.5242 0.476562 37.6194 0.476562 35.2385V4.76228C0.476562 2.38132 2.38132 0.476562 4.76228 0.476562Z',
	fill: 'white'
}), _jsx('path', {
	d: 'M71.8088 10.4766H40.285C39.6183 10.4766 39.0469  11.048 39.0469 11.7147V28.1908C39.0469 28.8575 39.6183 29.4289 40.285 29.4289H71.8088C72.4754 29.4289 73.0469 28.8575 73.0469 28.1908V11.7147C73.0469 11.048 72.4754 10.4766 71.8088 10.4766Z',
	fill: 'url(#paint0_linear_2051_4898)'
}), _jsx('path', {
	opacity: '0.4',
	d: 'M39.904 19.9051C39.904 19.9051 39.904 19.9051 39.9993 19.9051C43.8088 19.8099 72.0945 18.7623 72.0945 18.7623C72.5707 18.7623 73.0469 18.3813 73.0469 17.8099V11.7147C73.0469 11.048 72.4754 10.4766 71.8088 10.4766H40.285C39.6183 10.4766 39.0469 11.048 39.0469 11.7147V20.9528C39.0469 20.8575 39.0469 20.0004 39.904 19.9051Z',
	fill: 'url(#paint1_linear_2051_4898)'
}), _jsx('path', {
	d: 'M27.6179 28.1901C27.8084 28.2853 28.2846 28.4758 28.856 28.4758C29.8084 28.4758 30.3798 28.0949 30.7608 27.2377L36.1894 15.333C35.9989 15.2377 35.4275 15.0472 35.0465 15.0472C34.3798 15.0472 33.4275 15.1425 32.856 16.5711L31.1417 20.6663L27.8084 15.1425C27.6179 15.0472 27.0465 14.952 26.6656 14.952C25.4275 14.952 24.7608 15.4282 24.0941 16.0949L20.7608 19.7139L23.4275 23.9044C23.9036 24.6663 24.5703 25.0472 25.6179 25.0472C26.2846 25.0472 26.856 24.8568 27.1417 24.7615L23.9036 19.9996L26.1894 17.6187L29.9036 23.4282L27.6179 28.1901ZM20.5703 23.6187C20.5703 24.4758 20.1894 25.0472 18.4751 25.0472C18.2846 25.0472 18.0941 25.0472 17.9036 24.952V13.333C17.9036 12.4758 18.1894 11.5234 19.9036 11.5234C20.0941 11.5234 20.3798 11.5234 20.5703 11.6187V23.6187ZM17.0465 21.9044C17.0465 23.5234 15.9989 24.7615 13.8084 24.952C12.2846 25.1425 9.90365 24.952 8.85603 24.7615C8.85603 24.5711 8.76079 24.3806 8.76079 24.1901C8.76079 22.7615 9.52269 22.4758 10.2846 22.4758C11.0465 22.4758 12.1894 22.5711 13.1417 22.5711C14.0941 22.5711 14.3798 22.1901 14.3798 21.9044C14.3798 21.5234 13.9989 21.333 13.237 21.1425L11.1417 20.7615C9.52269 20.5711 8.57031 19.333 8.57031 18.0949C8.57031 16.5711 9.61793 15.333 11.8084 15.0472C13.4275 14.8568 15.3322 15.0472 16.4751 15.2377C16.4751 15.4282 16.5703 15.6187 16.5703 15.8092C16.5703 17.2377 15.8084 17.5234 15.0465 17.5234C14.4751 17.5234 13.6179 17.4282 12.6656 17.4282C11.7132 17.4282 11.237 17.7139 11.237 18.0949C11.237 18.4758 11.6179 18.5711 12.2846 18.6663L14.2846 19.0472C16.1894 19.333 17.0465 20.4758 17.0465 21.9044Z',
	fill: 'url(#paint2_linear_2051_4898)'
}), _jsx('path', {
	opacity: '0.25',
	d: 'M36.1894 15.333L34.2846 19.7139C34.1894 19.8092 33.9989 20.1901 33.4275 20.1901C33.3322 20.1901 31.6179 20.2853 31.6179 20.2853C31.3322 20.2853 31.1417 20.5711 31.1417 20.5711L32.856 16.5711C33.4275 15.1425 34.3798 15.0472 35.0465 15.0472C35.4275 15.0472 35.9036 15.1425 36.1894 15.333ZM31.0465 20.4758L27.7132 15.1425C27.5227 15.0472 26.9513 14.952 26.5703 14.952C25.3322 14.952 24.6656 15.4282 23.9989 16.0949L20.6656 19.7139L20.9513 20.0949C21.0465 20.2853 21.3322 20.4758 21.7132 20.4758C21.9036 20.4758 23.4275 20.3806 23.6179 20.3806C23.9989 20.3806 24.2846 20.5711 24.4751 20.7615L23.9036 19.9996L26.1894 17.6187L27.7132 19.9996C27.9989 20.3806 28.3798 20.3806 28.4751 20.3806C28.5703 20.3806 30.5703 20.2853 30.6656 20.2853C30.7608 20.1901 30.9513 20.2853 31.0465 20.4758ZM19.9989 11.5234C18.2846 11.5234 17.9989 12.4758 17.9989 13.333V21.333C17.9989 21.0472 18.2846 20.6663 18.6656 20.6663C18.9513 20.6663 19.7132 20.6663 19.9989 20.6663C20.2846 20.6663 20.6656 20.4758 20.6656 19.9996V11.7139C20.3798 11.6187 20.1894 11.5234 19.9989 11.5234ZM14.1894 18.952L12.1894 18.5711C11.5227 18.4758 11.1417 18.2853 11.1417 17.9044C11.1417 17.6187 11.5227 17.333 12.5703 17.333C13.5227 17.333 14.4751 17.4282 14.9513 17.4282C15.7132 17.4282 16.3798 17.1425 16.3798 15.7139C16.3798 15.5234 16.3798 15.333 16.2846 15.1425C15.237 15.0472 13.237 14.8568 11.6179 14.952C9.61793 15.2377 8.57031 16.5711 8.57031 18.0949C8.57031 18.8568 8.95127 19.6187 9.61793 20.1901C10.0941 20.4758 10.6656 20.6663 11.237 20.7615C11.7132 20.8568 12.6656 20.952 13.4275 20.8568C13.6179 20.8568 15.4275 20.7615 15.8084 20.7615C16.6656 20.7615 17.1417 21.5234 17.1417 22.2853C17.1417 22.1901 17.1417 22.0949 17.1417 21.9996C17.0465 20.4758 16.1894 19.333 14.1894 18.952Z',
	fill: 'url(#paint3_linear_2051_4898)'
}), _jsx('path', {
	d: 'M52.0007 20.0971C52.0007 23.0495 49.9055 24.7638 47.715 24.7638C46.3817 24.7638 45.2388 24.0971 44.5722 23.24V24.0971C44.5722 24.4781 44.3817 24.6685 43.715 24.6685C43.4293 24.6685 43.1436 24.6685 42.9531 24.5733V12.9542C42.9531 12.5733 43.1436 12.3828 43.8103 12.3828C44.096 12.3828 44.3817 12.3828 44.5722 12.4781V16.9542C45.2388 16.0019 46.2865 15.4304 47.715 15.4304C50.0007 15.4304 52.0007 17.1447 52.0007 20.0971ZM50.4769 20.0971C50.4769 18.0971 49.1436 16.7638 47.4293 16.7638C46.2865 16.7638 45.1436 17.4304 44.5722 18.4781V21.7161C45.0484 22.7638 46.1912 23.4304 47.4293 23.4304C49.1436 23.4304 50.4769 22.0971 50.4769 20.0971ZM62.0007 20.6685H55.0484C55.2388 22.3828 56.4769 23.3352 58.1912 23.3352C58.9531 23.3352 59.5246 23.24 60.096 23.0495C60.4769 22.9542 60.6674 22.859 60.8579 22.859C61.3341 22.859 61.5246 23.24 61.5246 24.0019C60.6674 24.3828 59.5246 24.7638 58.1912 24.7638C55.3341 24.7638 53.5246 22.859 53.5246 20.0971C53.5246 17.4304 55.5246 15.4304 58.0007 15.4304C60.7627 15.4304 62.096 17.5257 62.096 19.7161C62.096 20.0019 62.0007 20.3828 62.0007 20.6685ZM55.0484 19.5257H60.5722C60.4769 18.0019 59.5246 16.7638 57.9055 16.7638C56.5722 16.7638 55.2388 17.7161 55.0484 19.5257ZM69.3341 24.1923C68.5722 24.5733 67.6198 24.7638 66.7626 24.7638C64.9531 24.7638 63.9055 23.7161 63.9055 22.0019V14.2876C63.9055 13.9066 64.096 13.6209 64.7626 13.6209C65.0484 13.6209 65.3341 13.7161 65.5246 13.7161V15.6209H69.0484C69.0484 15.7161 69.1436 16.0019 69.1436 16.2876C69.1436 16.859 68.9531 17.0495 68.5722 17.0495H65.6198V21.9066C65.6198 22.9542 66.096 23.4304 67.0484 23.4304C68.0007 23.4304 68.4769 23.0495 68.8579 23.0495C69.2388 23.0495 69.4293 23.4304 69.3341 24.1923Z',
	fill: 'white'
}), _jsx('path', {
	d: 'M81.1136 40H4.88636C2.15 40 0 37.9048 0 35.2381V4.7619C0 2.09524 2.15 0 4.88636 0H81.1136C83.85 0 86 2.09524 86 4.7619V35.2381C86 37.9048 83.85 40 81.1136 40ZM4.88636 0.952381C2.73636 0.952381 0.977273 2.66667 0.977273 4.7619V35.2381C0.977273 37.3333 2.73636 39.0476 4.88636 39.0476H81.1136C83.2636 39.0476 85.0227 37.3333 85.0227 35.2381V4.7619C85.0227 2.66667 83.2636 0.952381 81.1136 0.952381H4.88636Z',
	fill: '#ECEBEB'
})), _jsx('defs', {}, void 0, _jsx('linearGradient', {
	id: 'paint0_linear_2051_4898',
	x1: '56.0339',
	y1: '29.5242',
	x2: '56.0339',
	y2: '10.4766',
	gradientUnits: 'userSpaceOnUse'
}, void 0, _jsx('stop', {
	offset: '0.4',
	stopColor: '#FF0000'
}), _jsx('stop', {
	offset: '1',
	stopColor: '#D42321'
})), _jsx('linearGradient', {
	id: 'paint1_linear_2051_4898',
	x1: '56.1512',
	y1: '19.6632',
	x2: '55.8198',
	y2: '10.1774',
	gradientUnits: 'userSpaceOnUse'
}, void 0, _jsx('stop', {
	stopColor: 'white'
}), _jsx('stop', {
	offset: '1',
	stopColor: 'white',
	stopOpacity: '0.25'
})), _jsx('linearGradient', {
	id: 'paint2_linear_2051_4898',
	x1: '22.356',
	y1: '11.5695',
	x2: '22.356',
	y2: '28.4272',
	gradientUnits: 'userSpaceOnUse'
}, void 0, _jsx('stop', {
	stopColor: '#002A91'
}), _jsx('stop', {
	offset: '0.8',
	stopColor: '#002672'
})), _jsx('linearGradient', {
	id: 'paint3_linear_2051_4898',
	x1: '22.4881',
	y1: '20.5009',
	x2: '22.2654',
	y2: '14.1213',
	gradientUnits: 'userSpaceOnUse'
}, void 0, _jsx('stop', {
	stopColor: 'white'
}), _jsx('stop', {
	offset: '1',
	stopColor: 'white',
	stopOpacity: '0.25'
})), _jsx('clipPath', {
	id: 'clip0_2051_4898'
}, void 0, _jsx('rect', {
	width: '86',
	height: '40',
	rx: '4',
	fill: 'white'
}))));

var SkybetLogo = function SkybetLogo() {
	return _ref;
};

exports.default = SkybetLogo;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
    _inherits(Checkbox, _Component);

    function Checkbox(props) {
        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

        _this.onCheckChanged = _this.onCheckChanged.bind(_this);
        return _this;
    }

    _createClass(Checkbox, [{
        key: 'onCheckChanged',
        value: function onCheckChanged() {
            var _props = this.props,
                onSelect = _props.onSelect,
                name = _props.name;

            onSelect(name);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                name = _props2.name,
                checked = _props2.checked,
                className = _props2.className,
                iconType = _props2.iconType,
                iconSize = _props2.iconSize,
                children = _props2.children,
                tabIndex = _props2.tabIndex;

            var iconName = 'checkbox-' + iconType + '-' + iconSize;
            var checkedIconName = iconName + '-active';
            return _jsx('div', {
                className: (0, _classnames2.default)('bs-checkbox', className, _defineProperty({}, className + '_checked', checked))
            }, void 0, _jsx('div', {
                className: 'bs-checkbox__icon'
            }, void 0, _jsx('input', {
                className: 'bs-checkbox__input',
                name: name,
                id: name,
                type: 'checkbox',
                checked: checked,
                onChange: this.onCheckChanged,
                tabIndex: tabIndex
            }), _jsx(_svgIcon2.default, {
                iconName: checkedIconName,
                size: iconSize,
                className: (0, _classnames2.default)('bs-checkbox__image', { 'bs-hidden': !checked })
            }), _jsx(_svgIcon2.default, {
                iconName: iconName,
                size: iconSize,
                className: (0, _classnames2.default)('bs-checkbox__image', { 'bs-hidden': checked })
            })), children ? _jsx('label', {
                className: 'bs-checkbox__label',
                htmlFor: name
            }, void 0, children) : null);
        }
    }]);

    return Checkbox;
}(_react.Component);

Checkbox.defaultProps = {
    checked: false,
    children: null,
    tabIndex: 0
};
exports.default = Checkbox;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(673);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_svgIcon2.default, {
    iconName: 'cross',
    size: 'Medium',
    className: 'bs-modal__closeIcon'
});

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal(props) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

        _this.onModalClick = _this.onModalClick.bind(_this);
        return _this;
    }

    // eslint-disable-next-line class-methods-use-this


    _createClass(Modal, [{
        key: 'onModalClick',
        value: function onModalClick(event) {
            event.stopPropagation();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                visible = _props.visible,
                children = _props.children,
                onClose = _props.onClose,
                onOverlayClick = _props.onOverlayClick,
                borderless = _props.borderless;

            return visible ? _jsx('div', {
                role: 'button',
                tabIndex: 0,
                onClick: onOverlayClick,
                className: 'bs-overlay bs-overlay_modal'
            }, void 0, _jsx('div', {
                className: 'bs-overlay__container'
            }, void 0, _jsx('div', {
                role: 'button',
                tabIndex: 0,
                className: (0, _classnames2.default)('bs-modal', { 'bs-modal_borderless': borderless }),
                onClick: this.onModalClick
            }, void 0, onClose ? _jsx('span', {
                role: 'button',
                tabIndex: 0,
                onClick: onClose,
                className: 'bs-modal__closeBtn'
            }, void 0, _ref) : null, _jsx('div', {
                className: 'bs-modal__canvas'
            }, void 0, children)))) : null;
        }
    }]);

    return Modal;
}(_react.Component);

Modal.defaultProps = {
    visible: false,
    children: null,
    onOverlayClick: null,
    onClose: null,
    borderless: false
};
exports.default = Modal;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

exports.default = topUpErrors;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorCodesContainingMessageList = ['9003'];

/**
 * Generate error config by server error.
 * @param {Object} errors server errors.
 * @param {String} [errors.9003.message] incorrect card details error message.
 * @param {String} bookmakerFeed bookmaker name.
 * @return {Object} client top up error message.
 */

var _ref = _jsx('span', {}, void 0, 'Payment authentication required. Please go to ', _jsx('a', {
    rel: 'noopener noreferrer',
    target: '_blank',
    href: 'https://www.bet365.com/#/HO/'
}, void 0, 'bet365.com'), '\xA0 to attempt your deposit.');

function topUpErrors(errors) {
    var bookmakerFeed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var errorCodes = Object.keys(errors);
    var errorCode = errorCodes.pop();

    if (bookmakerFeed === 'BET365') {
        var errorMessageDetail = (0, _lodash2.default)(errors, '[' + errorCode + ']', '');

        var errExMsg = 'RacingPost\\BetSlip\\Http\\Exception\\UnauthorisedException: ';
        var errPaymentAuthMsg = 'Payment authentication required. ';
        var errGoBackMsg = 'Please go to bet365.com to attempt your deposit.';
        var targetErrMsg = errExMsg + errPaymentAuthMsg + errGoBackMsg;

        var isError401 = errors.code ? errors.code.toLowerCase() === 'unauthorized' : false;

        if (errorMessageDetail === targetErrMsg || isError401) {
            return _ref;
        }
    }

    if (errorCodesContainingMessageList.indexOf(errorCode) !== -1) {
        return (0, _lodash2.default)(errors, '[' + errorCode + '].message', '');
    }

    return 'Payment authorisation failed. Please check your details and try again';
}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(556);

var _logger = __webpack_require__(63);

exports.default = {
    setLevel: _logger.setLevel
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);
var bind = __webpack_require__(139);
var Axios = __webpack_require__(240);
var defaults = __webpack_require__(65);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(136);
axios.CancelToken = __webpack_require__(239);
axios.isCancel = __webpack_require__(137);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(254);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(136);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(65);
var utils = __webpack_require__(14);
var InterceptorManager = __webpack_require__(241);
var dispatchRequest = __webpack_require__(242);
var isAbsoluteURL = __webpack_require__(250);
var combineURLs = __webpack_require__(248);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);
var transformData = __webpack_require__(245);
var isCancel = __webpack_require__(137);
var defaults = __webpack_require__(65);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(138);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error();
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
  // initialize result and counter
  var block, charCode, idx = 0, map = chars;
  // if the next str index does not exist:
  //   change the mapping table to "="
  //   check if d has no fractional digits
  str.charAt(idx | 0) || (map = '=', idx % 1);
  // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
  output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

exports.default = ExtendableError;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(66);

var _PathUtils = __webpack_require__(50);

var _createTransitionManager = __webpack_require__(93);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(140);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;

    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(66);

var _PathUtils = __webpack_require__(50);

var _createTransitionManager = __webpack_require__(93);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(140);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(50);

var _LocationUtils = __webpack_require__(66);

var _createTransitionManager = __webpack_require__(93);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually

module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNative = __webpack_require__(30);

var _getNative2 = _interopRequireDefault(_getNative);

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references that are verified to be native. */
var DataView = (0, _getNative2.default)(_root2.default, 'DataView');

exports.default = DataView;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hashClear = __webpack_require__(312);

var _hashClear2 = _interopRequireDefault(_hashClear);

var _hashDelete = __webpack_require__(313);

var _hashDelete2 = _interopRequireDefault(_hashDelete);

var _hashGet = __webpack_require__(314);

var _hashGet2 = _interopRequireDefault(_hashGet);

var _hashHas = __webpack_require__(315);

var _hashHas2 = _interopRequireDefault(_hashHas);

var _hashSet = __webpack_require__(316);

var _hashSet2 = _interopRequireDefault(_hashSet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear2.default;
Hash.prototype['delete'] = _hashDelete2.default;
Hash.prototype.get = _hashGet2.default;
Hash.prototype.has = _hashHas2.default;
Hash.prototype.set = _hashSet2.default;

exports.default = Hash;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNative = __webpack_require__(30);

var _getNative2 = _interopRequireDefault(_getNative);

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references that are verified to be native. */
var Promise = (0, _getNative2.default)(_root2.default, 'Promise');

exports.default = Promise;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNative = __webpack_require__(30);

var _getNative2 = _interopRequireDefault(_getNative);

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references that are verified to be native. */
var Set = (0, _getNative2.default)(_root2.default, 'Set');

exports.default = Set;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MapCache = __webpack_require__(97);

var _MapCache2 = _interopRequireDefault(_MapCache);

var _setCacheAdd = __webpack_require__(338);

var _setCacheAdd2 = _interopRequireDefault(_setCacheAdd);

var _setCacheHas = __webpack_require__(339);

var _setCacheHas2 = _interopRequireDefault(_setCacheHas);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache2.default();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd2.default;
SetCache.prototype.has = _setCacheHas2.default;

exports.default = SetCache;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNative = __webpack_require__(30);

var _getNative2 = _interopRequireDefault(_getNative);

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references that are verified to be native. */
var WeakMap = (0, _getNative2.default)(_root2.default, 'WeakMap');

exports.default = WeakMap;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

exports.default = apply;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

exports.default = arrayFilter;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

exports.default = arrayPush;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

exports.default = arraySome;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseAssignValue = __webpack_require__(70);

var _baseAssignValue2 = _interopRequireDefault(_baseAssignValue);

var _eq = __webpack_require__(52);

var _eq2 = _interopRequireDefault(_eq);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && (0, _eq2.default)(objValue, value)) || value === undefined && !(key in object)) {
    (0, _baseAssignValue2.default)(object, key, value);
  }
}

exports.default = assignValue;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!(0, _isObject2.default)(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

exports.default = baseCreate;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseFor = __webpack_require__(145);

var _baseFor2 = _interopRequireDefault(_baseFor);

var _keys = __webpack_require__(109);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && (0, _baseFor2.default)(object, iteratee, _keys2.default);
}

exports.default = baseForOwn;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayPush = __webpack_require__(269);

var _arrayPush2 = _interopRequireDefault(_arrayPush);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return (0, _isArray2.default)(object) ? result : (0, _arrayPush2.default)(result, symbolsFunc(object));
}

exports.default = baseGetAllKeys;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

exports.default = baseHasIn;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseGetTag = __webpack_require__(42);

var _baseGetTag2 = _interopRequireDefault(_baseGetTag);

var _isObjectLike = __webpack_require__(31);

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return (0, _isObjectLike2.default)(value) && (0, _baseGetTag2.default)(value) == argsTag;
}

exports.default = baseIsArguments;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Stack = __webpack_require__(98);

var _Stack2 = _interopRequireDefault(_Stack);

var _equalArrays = __webpack_require__(150);

var _equalArrays2 = _interopRequireDefault(_equalArrays);

var _equalByTag = __webpack_require__(303);

var _equalByTag2 = _interopRequireDefault(_equalByTag);

var _equalObjects = __webpack_require__(304);

var _equalObjects2 = _interopRequireDefault(_equalObjects);

var _getTag = __webpack_require__(309);

var _getTag2 = _interopRequireDefault(_getTag);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isBuffer = __webpack_require__(105);

var _isBuffer2 = _interopRequireDefault(_isBuffer);

var _isTypedArray = __webpack_require__(108);

var _isTypedArray2 = _interopRequireDefault(_isTypedArray);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = (0, _isArray2.default)(object),
      othIsArr = (0, _isArray2.default)(other),
      objTag = objIsArr ? arrayTag : (0, _getTag2.default)(object),
      othTag = othIsArr ? arrayTag : (0, _getTag2.default)(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && (0, _isBuffer2.default)(object)) {
    if (!(0, _isBuffer2.default)(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack2.default());
    return objIsArr || (0, _isTypedArray2.default)(object) ? (0, _equalArrays2.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, _equalByTag2.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack2.default());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack2.default());
  return (0, _equalObjects2.default)(object, other, bitmask, customizer, equalFunc, stack);
}

exports.default = baseIsEqualDeep;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Stack = __webpack_require__(98);

var _Stack2 = _interopRequireDefault(_Stack);

var _baseIsEqual = __webpack_require__(99);

var _baseIsEqual2 = _interopRequireDefault(_baseIsEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack2.default();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? (0, _baseIsEqual2.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

exports.default = baseIsMatch;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction = __webpack_require__(106);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isMasked = __webpack_require__(320);

var _isMasked2 = _interopRequireDefault(_isMasked);

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

var _toSource = __webpack_require__(158);

var _toSource2 = _interopRequireDefault(_toSource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!(0, _isObject2.default)(value) || (0, _isMasked2.default)(value)) {
    return false;
  }
  var pattern = (0, _isFunction2.default)(value) ? reIsNative : reIsHostCtor;
  return pattern.test((0, _toSource2.default)(value));
}

exports.default = baseIsNative;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseGetTag = __webpack_require__(42);

var _baseGetTag2 = _interopRequireDefault(_baseGetTag);

var _isLength = __webpack_require__(107);

var _isLength2 = _interopRequireDefault(_isLength);

var _isObjectLike = __webpack_require__(31);

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return (0, _isObjectLike2.default)(value) && (0, _isLength2.default)(value.length) && !!typedArrayTags[(0, _baseGetTag2.default)(value)];
}

exports.default = baseIsTypedArray;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _baseMatches = __webpack_require__(284);

var _baseMatches2 = _interopRequireDefault(_baseMatches);

var _baseMatchesProperty = __webpack_require__(285);

var _baseMatchesProperty2 = _interopRequireDefault(_baseMatchesProperty);

var _identity = __webpack_require__(103);

var _identity2 = _interopRequireDefault(_identity);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _property = __webpack_require__(354);

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return _identity2.default;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
    return (0, _isArray2.default)(value) ? (0, _baseMatchesProperty2.default)(value[0], value[1]) : (0, _baseMatches2.default)(value);
  }
  return (0, _property2.default)(value);
}

exports.default = baseIteratee;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPrototype = __webpack_require__(102);

var _isPrototype2 = _interopRequireDefault(_isPrototype);

var _nativeKeys = __webpack_require__(333);

var _nativeKeys2 = _interopRequireDefault(_nativeKeys);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!(0, _isPrototype2.default)(object)) {
    return (0, _nativeKeys2.default)(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

exports.default = baseKeys;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

var _isPrototype = __webpack_require__(102);

var _isPrototype2 = _interopRequireDefault(_isPrototype);

var _nativeKeysIn = __webpack_require__(334);

var _nativeKeysIn2 = _interopRequireDefault(_nativeKeysIn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!(0, _isObject2.default)(object)) {
    return (0, _nativeKeysIn2.default)(object);
  }
  var isProto = (0, _isPrototype2.default)(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

exports.default = baseKeysIn;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIsMatch = __webpack_require__(278);

var _baseIsMatch2 = _interopRequireDefault(_baseIsMatch);

var _getMatchData = __webpack_require__(306);

var _getMatchData2 = _interopRequireDefault(_getMatchData);

var _matchesStrictComparable = __webpack_require__(154);

var _matchesStrictComparable2 = _interopRequireDefault(_matchesStrictComparable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = (0, _getMatchData2.default)(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return (0, _matchesStrictComparable2.default)(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || (0, _baseIsMatch2.default)(object, source, matchData);
  };
}

exports.default = baseMatches;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIsEqual = __webpack_require__(99);

var _baseIsEqual2 = _interopRequireDefault(_baseIsEqual);

var _get = __webpack_require__(349);

var _get2 = _interopRequireDefault(_get);

var _hasIn = __webpack_require__(350);

var _hasIn2 = _interopRequireDefault(_hasIn);

var _isKey = __webpack_require__(101);

var _isKey2 = _interopRequireDefault(_isKey);

var _isStrictComparable = __webpack_require__(153);

var _isStrictComparable2 = _interopRequireDefault(_isStrictComparable);

var _matchesStrictComparable = __webpack_require__(154);

var _matchesStrictComparable2 = _interopRequireDefault(_matchesStrictComparable);

var _toKey = __webpack_require__(51);

var _toKey2 = _interopRequireDefault(_toKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if ((0, _isKey2.default)(path) && (0, _isStrictComparable2.default)(srcValue)) {
    return (0, _matchesStrictComparable2.default)((0, _toKey2.default)(path), srcValue);
  }
  return function (object) {
    var objValue = (0, _get2.default)(object, path);
    return objValue === undefined && objValue === srcValue ? (0, _hasIn2.default)(object, path) : (0, _baseIsEqual2.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

exports.default = baseMatchesProperty;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Stack = __webpack_require__(98);

var _Stack2 = _interopRequireDefault(_Stack);

var _assignMergeValue = __webpack_require__(144);

var _assignMergeValue2 = _interopRequireDefault(_assignMergeValue);

var _baseFor = __webpack_require__(145);

var _baseFor2 = _interopRequireDefault(_baseFor);

var _baseMergeDeep = __webpack_require__(287);

var _baseMergeDeep2 = _interopRequireDefault(_baseMergeDeep);

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

var _keysIn = __webpack_require__(160);

var _keysIn2 = _interopRequireDefault(_keysIn);

var _safeGet = __webpack_require__(156);

var _safeGet2 = _interopRequireDefault(_safeGet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  (0, _baseFor2.default)(source, function (srcValue, key) {
    if ((0, _isObject2.default)(srcValue)) {
      stack || (stack = new _Stack2.default());
      (0, _baseMergeDeep2.default)(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer((0, _safeGet2.default)(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      (0, _assignMergeValue2.default)(object, key, newValue);
    }
  }, _keysIn2.default);
}

exports.default = baseMerge;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assignMergeValue = __webpack_require__(144);

var _assignMergeValue2 = _interopRequireDefault(_assignMergeValue);

var _cloneBuffer = __webpack_require__(297);

var _cloneBuffer2 = _interopRequireDefault(_cloneBuffer);

var _cloneTypedArray = __webpack_require__(298);

var _cloneTypedArray2 = _interopRequireDefault(_cloneTypedArray);

var _copyArray = __webpack_require__(148);

var _copyArray2 = _interopRequireDefault(_copyArray);

var _initCloneObject = __webpack_require__(317);

var _initCloneObject2 = _interopRequireDefault(_initCloneObject);

var _isArguments = __webpack_require__(104);

var _isArguments2 = _interopRequireDefault(_isArguments);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isArrayLikeObject = __webpack_require__(351);

var _isArrayLikeObject2 = _interopRequireDefault(_isArrayLikeObject);

var _isBuffer = __webpack_require__(105);

var _isBuffer2 = _interopRequireDefault(_isBuffer);

var _isFunction = __webpack_require__(106);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

var _isPlainObject = __webpack_require__(74);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isTypedArray = __webpack_require__(108);

var _isTypedArray2 = _interopRequireDefault(_isTypedArray);

var _safeGet = __webpack_require__(156);

var _safeGet2 = _interopRequireDefault(_safeGet);

var _toPlainObject = __webpack_require__(357);

var _toPlainObject2 = _interopRequireDefault(_toPlainObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = (0, _safeGet2.default)(object, key),
      srcValue = (0, _safeGet2.default)(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    (0, _assignMergeValue2.default)(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = (0, _isArray2.default)(srcValue),
        isBuff = !isArr && (0, _isBuffer2.default)(srcValue),
        isTyped = !isArr && !isBuff && (0, _isTypedArray2.default)(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if ((0, _isArray2.default)(objValue)) {
        newValue = objValue;
      } else if ((0, _isArrayLikeObject2.default)(objValue)) {
        newValue = (0, _copyArray2.default)(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = (0, _cloneBuffer2.default)(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = (0, _cloneTypedArray2.default)(srcValue, true);
      } else {
        newValue = [];
      }
    } else if ((0, _isPlainObject2.default)(srcValue) || (0, _isArguments2.default)(srcValue)) {
      newValue = objValue;
      if ((0, _isArguments2.default)(objValue)) {
        newValue = (0, _toPlainObject2.default)(objValue);
      } else if (!(0, _isObject2.default)(objValue) || (0, _isFunction2.default)(objValue)) {
        newValue = (0, _initCloneObject2.default)(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  (0, _assignMergeValue2.default)(object, key, newValue);
}

exports.default = baseMergeDeep;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

exports.default = baseProperty;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseGet = __webpack_require__(146);

var _baseGet2 = _interopRequireDefault(_baseGet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return (0, _baseGet2.default)(object, path);
  };
}

exports.default = basePropertyDeep;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _identity = __webpack_require__(103);

var _identity2 = _interopRequireDefault(_identity);

var _overRest = __webpack_require__(337);

var _overRest2 = _interopRequireDefault(_overRest);

var _setToString = __webpack_require__(341);

var _setToString2 = _interopRequireDefault(_setToString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return (0, _setToString2.default)((0, _overRest2.default)(func, start, _identity2.default), func + '');
}

exports.default = baseRest;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constant = __webpack_require__(348);

var _constant2 = _interopRequireDefault(_constant);

var _defineProperty = __webpack_require__(149);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _identity = __webpack_require__(103);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty2.default ? _identity2.default : function (func, string) {
  return (0, _defineProperty2.default)(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': (0, _constant2.default)(string),
    'writable': true
  });
};

exports.default = baseSetToString;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

exports.default = baseTimes;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Symbol2 = __webpack_require__(68);

var _Symbol3 = _interopRequireDefault(_Symbol2);

var _arrayMap = __webpack_require__(143);

var _arrayMap2 = _interopRequireDefault(_arrayMap);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isSymbol = __webpack_require__(75);

var _isSymbol2 = _interopRequireDefault(_isSymbol);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol3.default ? _Symbol3.default.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if ((0, _isArray2.default)(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMap2.default)(value, baseToString) + '';
  }
  if ((0, _isSymbol2.default)(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

exports.default = baseToString;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

exports.default = baseUnary;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

exports.default = cacheHas;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Uint8Array = __webpack_require__(141);

var _Uint8Array2 = _interopRequireDefault(_Uint8Array);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array2.default(result).set(new _Uint8Array2.default(arrayBuffer));
  return result;
}

exports.default = cloneArrayBuffer;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root2.default.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

exports.default = cloneBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)(module)))

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cloneArrayBuffer = __webpack_require__(296);

var _cloneArrayBuffer2 = _interopRequireDefault(_cloneArrayBuffer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? (0, _cloneArrayBuffer2.default)(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

exports.default = cloneTypedArray;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assignValue = __webpack_require__(271);

var _assignValue2 = _interopRequireDefault(_assignValue);

var _baseAssignValue = __webpack_require__(70);

var _baseAssignValue2 = _interopRequireDefault(_baseAssignValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      (0, _baseAssignValue2.default)(object, key, newValue);
    } else {
      (0, _assignValue2.default)(object, key, newValue);
    }
  }
  return object;
}

exports.default = copyObject;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(18);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to detect overreaching core-js shims. */
var coreJsData = _root2.default['__core-js_shared__'];

exports.default = coreJsData;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseRest = __webpack_require__(290);

var _baseRest2 = _interopRequireDefault(_baseRest);

var _isIterateeCall = __webpack_require__(318);

var _isIterateeCall2 = _interopRequireDefault(_isIterateeCall);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return (0, _baseRest2.default)(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && (0, _isIterateeCall2.default)(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

exports.default = createAssigner;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

exports.default = createBaseFor;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Symbol2 = __webpack_require__(68);

var _Symbol3 = _interopRequireDefault(_Symbol2);

var _Uint8Array = __webpack_require__(141);

var _Uint8Array2 = _interopRequireDefault(_Uint8Array);

var _eq = __webpack_require__(52);

var _eq2 = _interopRequireDefault(_eq);

var _equalArrays = __webpack_require__(150);

var _equalArrays2 = _interopRequireDefault(_equalArrays);

var _mapToArray = __webpack_require__(331);

var _mapToArray2 = _interopRequireDefault(_mapToArray);

var _setToArray = __webpack_require__(340);

var _setToArray2 = _interopRequireDefault(_setToArray);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol3.default ? _Symbol3.default.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new _Uint8Array2.default(object), new _Uint8Array2.default(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return (0, _eq2.default)(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = _mapToArray2.default;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray2.default);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = (0, _equalArrays2.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

exports.default = equalByTag;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAllKeys = __webpack_require__(305);

var _getAllKeys2 = _interopRequireDefault(_getAllKeys);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = (0, _getAllKeys2.default)(object),
      objLength = objProps.length,
      othProps = (0, _getAllKeys2.default)(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

exports.default = equalObjects;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseGetAllKeys = __webpack_require__(274);

var _baseGetAllKeys2 = _interopRequireDefault(_baseGetAllKeys);

var _getSymbols = __webpack_require__(308);

var _getSymbols2 = _interopRequireDefault(_getSymbols);

var _keys = __webpack_require__(109);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return (0, _baseGetAllKeys2.default)(object, _keys2.default, _getSymbols2.default);
}

exports.default = getAllKeys;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isStrictComparable = __webpack_require__(153);

var _isStrictComparable2 = _interopRequireDefault(_isStrictComparable);

var _keys = __webpack_require__(109);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = (0, _keys2.default)(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, (0, _isStrictComparable2.default)(value)];
  }
  return result;
}

exports.default = getMatchData;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Symbol2 = __webpack_require__(68);

var _Symbol3 = _interopRequireDefault(_Symbol2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

exports.default = getRawTag;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayFilter = __webpack_require__(268);

var _arrayFilter2 = _interopRequireDefault(_arrayFilter);

var _stubArray = __webpack_require__(355);

var _stubArray2 = _interopRequireDefault(_stubArray);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? _stubArray2.default : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return (0, _arrayFilter2.default)(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

exports.default = getSymbols;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DataView = __webpack_require__(261);

var _DataView2 = _interopRequireDefault(_DataView);

var _Map = __webpack_require__(96);

var _Map2 = _interopRequireDefault(_Map);

var _Promise = __webpack_require__(263);

var _Promise2 = _interopRequireDefault(_Promise);

var _Set = __webpack_require__(264);

var _Set2 = _interopRequireDefault(_Set);

var _WeakMap = __webpack_require__(266);

var _WeakMap2 = _interopRequireDefault(_WeakMap);

var _baseGetTag = __webpack_require__(42);

var _baseGetTag2 = _interopRequireDefault(_baseGetTag);

var _toSource = __webpack_require__(158);

var _toSource2 = _interopRequireDefault(_toSource);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = (0, _toSource2.default)(_DataView2.default),
    mapCtorString = (0, _toSource2.default)(_Map2.default),
    promiseCtorString = (0, _toSource2.default)(_Promise2.default),
    setCtorString = (0, _toSource2.default)(_Set2.default),
    weakMapCtorString = (0, _toSource2.default)(_WeakMap2.default);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag2.default;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (_DataView2.default && getTag(new _DataView2.default(new ArrayBuffer(1))) != dataViewTag || _Map2.default && getTag(new _Map2.default()) != mapTag || _Promise2.default && getTag(_Promise2.default.resolve()) != promiseTag || _Set2.default && getTag(new _Set2.default()) != setTag || _WeakMap2.default && getTag(new _WeakMap2.default()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = (0, _baseGetTag2.default)(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? (0, _toSource2.default)(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

exports.default = getTag;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

exports.default = getValue;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _castPath = __webpack_require__(147);

var _castPath2 = _interopRequireDefault(_castPath);

var _isArguments = __webpack_require__(104);

var _isArguments2 = _interopRequireDefault(_isArguments);

var _isArray = __webpack_require__(19);

var _isArray2 = _interopRequireDefault(_isArray);

var _isIndex = __webpack_require__(100);

var _isIndex2 = _interopRequireDefault(_isIndex);

var _isLength = __webpack_require__(107);

var _isLength2 = _interopRequireDefault(_isLength);

var _toKey = __webpack_require__(51);

var _toKey2 = _interopRequireDefault(_toKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = (0, _castPath2.default)(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = (0, _toKey2.default)(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && (0, _isLength2.default)(length) && (0, _isIndex2.default)(key, length) && ((0, _isArray2.default)(object) || (0, _isArguments2.default)(object));
}

exports.default = hasPath;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nativeCreate = __webpack_require__(72);

var _nativeCreate2 = _interopRequireDefault(_nativeCreate);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate2.default ? (0, _nativeCreate2.default)(null) : {};
  this.size = 0;
}

exports.default = hashClear;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

exports.default = hashDelete;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nativeCreate = __webpack_require__(72);

var _nativeCreate2 = _interopRequireDefault(_nativeCreate);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate2.default) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

exports.default = hashGet;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nativeCreate = __webpack_require__(72);

var _nativeCreate2 = _interopRequireDefault(_nativeCreate);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate2.default ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

exports.default = hashHas;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nativeCreate = __webpack_require__(72);

var _nativeCreate2 = _interopRequireDefault(_nativeCreate);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate2.default && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

exports.default = hashSet;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseCreate = __webpack_require__(272);

var _baseCreate2 = _interopRequireDefault(_baseCreate);

var _getPrototype = __webpack_require__(152);

var _getPrototype2 = _interopRequireDefault(_getPrototype);

var _isPrototype = __webpack_require__(102);

var _isPrototype2 = _interopRequireDefault(_isPrototype);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !(0, _isPrototype2.default)(object) ? (0, _baseCreate2.default)((0, _getPrototype2.default)(object)) : {};
}

exports.default = initCloneObject;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _eq = __webpack_require__(52);

var _eq2 = _interopRequireDefault(_eq);

var _isArrayLike = __webpack_require__(73);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _isIndex = __webpack_require__(100);

var _isIndex2 = _interopRequireDefault(_isIndex);

var _isObject = __webpack_require__(27);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!(0, _isObject2.default)(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? (0, _isArrayLike2.default)(object) && (0, _isIndex2.default)(index, object.length) : type == 'string' && index in object) {
    return (0, _eq2.default)(object[index], value);
  }
  return false;
}

exports.default = isIterateeCall;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

exports.default = isKeyable;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coreJsData = __webpack_require__(300);

var _coreJsData2 = _interopRequireDefault(_coreJsData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData2.default && _coreJsData2.default.keys && _coreJsData2.default.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

exports.default = isMasked;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

exports.default = listCacheClear;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assocIndexOf = __webpack_require__(69);

var _assocIndexOf2 = _interopRequireDefault(_assocIndexOf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = (0, _assocIndexOf2.default)(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

exports.default = listCacheDelete;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assocIndexOf = __webpack_require__(69);

var _assocIndexOf2 = _interopRequireDefault(_assocIndexOf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = (0, _assocIndexOf2.default)(data, key);

  return index < 0 ? undefined : data[index][1];
}

exports.default = listCacheGet;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assocIndexOf = __webpack_require__(69);

var _assocIndexOf2 = _interopRequireDefault(_assocIndexOf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return (0, _assocIndexOf2.default)(this.__data__, key) > -1;
}

exports.default = listCacheHas;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assocIndexOf = __webpack_require__(69);

var _assocIndexOf2 = _interopRequireDefault(_assocIndexOf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = (0, _assocIndexOf2.default)(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

exports.default = listCacheSet;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hash = __webpack_require__(262);

var _Hash2 = _interopRequireDefault(_Hash);

var _ListCache = __webpack_require__(67);

var _ListCache2 = _interopRequireDefault(_ListCache);

var _Map = __webpack_require__(96);

var _Map2 = _interopRequireDefault(_Map);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash2.default(),
    'map': new (_Map2.default || _ListCache2.default)(),
    'string': new _Hash2.default()
  };
}

exports.default = mapCacheClear;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMapData = __webpack_require__(71);

var _getMapData2 = _interopRequireDefault(_getMapData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = (0, _getMapData2.default)(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

exports.default = mapCacheDelete;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMapData = __webpack_require__(71);

var _getMapData2 = _interopRequireDefault(_getMapData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return (0, _getMapData2.default)(this, key).get(key);
}

exports.default = mapCacheGet;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMapData = __webpack_require__(71);

var _getMapData2 = _interopRequireDefault(_getMapData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return (0, _getMapData2.default)(this, key).has(key);
}

exports.default = mapCacheHas;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMapData = __webpack_require__(71);

var _getMapData2 = _interopRequireDefault(_getMapData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = (0, _getMapData2.default)(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

exports.default = mapCacheSet;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

exports.default = mapToArray;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memoize = __webpack_require__(352);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = (0, _memoize2.default)(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

exports.default = memoizeCapped;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overArg = __webpack_require__(155);

var _overArg2 = _interopRequireDefault(_overArg);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = (0, _overArg2.default)(Object.keys, Object);

exports.default = nativeKeys;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

exports.default = nativeKeysIn;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _freeGlobal = __webpack_require__(151);

var _freeGlobal2 = _interopRequireDefault(_freeGlobal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal2.default.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

exports.default = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)(module)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

exports.default = objectToString;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apply = __webpack_require__(267);

var _apply2 = _interopRequireDefault(_apply);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return (0, _apply2.default)(func, this, otherArgs);
  };
}

exports.default = overRest;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

exports.default = setCacheAdd;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

exports.default = setCacheHas;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

exports.default = setToArray;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseSetToString = __webpack_require__(291);

var _baseSetToString2 = _interopRequireDefault(_baseSetToString);

var _shortOut = __webpack_require__(342);

var _shortOut2 = _interopRequireDefault(_shortOut);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = (0, _shortOut2.default)(_baseSetToString2.default);

exports.default = setToString;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

exports.default = shortOut;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListCache = __webpack_require__(67);

var _ListCache2 = _interopRequireDefault(_ListCache);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache2.default();
  this.size = 0;
}

exports.default = stackClear;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

exports.default = stackDelete;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

exports.default = stackGet;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

exports.default = stackHas;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListCache = __webpack_require__(67);

var _ListCache2 = _interopRequireDefault(_ListCache);

var _Map = __webpack_require__(96);

var _Map2 = _interopRequireDefault(_Map);

var _MapCache = __webpack_require__(97);

var _MapCache2 = _interopRequireDefault(_MapCache);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache2.default) {
    var pairs = data.__data__;
    if (!_Map2.default || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache2.default(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

exports.default = stackSet;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

exports.default = constant;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseGet = __webpack_require__(146);

var _baseGet2 = _interopRequireDefault(_baseGet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : (0, _baseGet2.default)(object, path);
  return result === undefined ? defaultValue : result;
}

exports.default = get;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseHasIn = __webpack_require__(275);

var _baseHasIn2 = _interopRequireDefault(_baseHasIn);

var _hasPath = __webpack_require__(311);

var _hasPath2 = _interopRequireDefault(_hasPath);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && (0, _hasPath2.default)(object, path, _baseHasIn2.default);
}

exports.default = hasIn;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isArrayLike = __webpack_require__(73);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _isObjectLike = __webpack_require__(31);

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return (0, _isObjectLike2.default)(value) && (0, _isArrayLike2.default)(value);
}

exports.default = isArrayLikeObject;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MapCache = __webpack_require__(97);

var _MapCache2 = _interopRequireDefault(_MapCache);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache2.default)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache2.default;

exports.default = memoize;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseMerge = __webpack_require__(286);

var _baseMerge2 = _interopRequireDefault(_baseMerge);

var _createAssigner = __webpack_require__(301);

var _createAssigner2 = _interopRequireDefault(_createAssigner);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = (0, _createAssigner2.default)(function (object, source, srcIndex) {
  (0, _baseMerge2.default)(object, source, srcIndex);
});

exports.default = merge;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseProperty = __webpack_require__(288);

var _baseProperty2 = _interopRequireDefault(_baseProperty);

var _basePropertyDeep = __webpack_require__(289);

var _basePropertyDeep2 = _interopRequireDefault(_basePropertyDeep);

var _isKey = __webpack_require__(101);

var _isKey2 = _interopRequireDefault(_isKey);

var _toKey = __webpack_require__(51);

var _toKey2 = _interopRequireDefault(_toKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return (0, _isKey2.default)(path) ? (0, _baseProperty2.default)((0, _toKey2.default)(path)) : (0, _basePropertyDeep2.default)(path);
}

exports.default = property;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

exports.default = stubArray;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

exports.default = stubFalse;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _copyObject = __webpack_require__(299);

var _copyObject2 = _interopRequireDefault(_copyObject);

var _keysIn = __webpack_require__(160);

var _keysIn2 = _interopRequireDefault(_keysIn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return (0, _copyObject2.default)(value, (0, _keysIn2.default)(value));
}

exports.default = toPlainObject;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";

    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
})(undefined, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size

    var noop = function noop() {};
    var undefinedType = "undefined";

    var logMethods = ["trace", "debug", "info", "warn", "error"];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function () {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if ((typeof console === 'undefined' ? 'undefined' : _typeof(console)) === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if ((typeof console === 'undefined' ? 'undefined' : _typeof(console)) !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
        var self = this;
        var currentLevel;
        var storageKey = "loglevel";
        if (name) {
            storageKey += ":" + name;
        }

        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

            if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === undefinedType) return;

            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}

            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }

        function getPersistedLevel() {
            var storedLevel;

            if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === undefinedType) return;

            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}

            // Fallback to cookies if local storage gives us nothing
            if ((typeof storedLevel === 'undefined' ? 'undefined' : _typeof(storedLevel)) === undefinedType) {
                try {
                    var cookie = window.document.cookie;
                    var location = cookie.indexOf(encodeURIComponent(storageKey) + "=");
                    if (location !== -1) {
                        storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                    }
                } catch (ignore) {}
            }

            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) {
                storedLevel = undefined;
            }

            return storedLevel;
        }

        /*
         *
         * Public logger API - see https://github.com/pimterry/loglevel for details
         *
         */

        self.name = name;

        self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
            "ERROR": 4, "SILENT": 5 };

        self.methodFactory = factory || defaultMethodFactory;

        self.getLevel = function () {
            return currentLevel;
        };

        self.setLevel = function (level, persist) {
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
                level = self.levels[level.toUpperCase()];
            }
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
                currentLevel = level;
                if (persist !== false) {
                    // defaults to true
                    persistLevelIfPossible(level);
                }
                replaceLoggingMethods.call(self, level, name);
                if ((typeof console === 'undefined' ? 'undefined' : _typeof(console)) === undefinedType && level < self.levels.SILENT) {
                    return "No console available for logging";
                }
            } else {
                throw "log.setLevel() called with invalid level: " + level;
            }
        };

        self.setDefaultLevel = function (level) {
            if (!getPersistedLevel()) {
                self.setLevel(level, false);
            }
        };

        self.enableAll = function (persist) {
            self.setLevel(self.levels.TRACE, persist);
        };

        self.disableAll = function (persist) {
            self.setLevel(self.levels.SILENT, persist);
        };

        // Initialize with the right level
        var initialLevel = getPersistedLevel();
        if (initialLevel == null) {
            initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
        }
        self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
            throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
            logger = _loggersByName[name] = new Logger(name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function () {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefinedType && window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser

var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(361);

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var aa = __webpack_require__(0),
    n = __webpack_require__(164),
    r = __webpack_require__(472);function u(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}if (!aa) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);try {
    b.apply(c, l);
  } catch (m) {
    this.onError(m);
  }
}var da = !1,
    ea = null,
    fa = !1,
    ha = null,
    ia = { onError: function onError(a) {
    da = !0;ea = a;
  } };function ja(a, b, c, d, e, f, g, h, k) {
  da = !1;ea = null;ba.apply(ia, arguments);
}function ka(a, b, c, d, e, f, g, h, k) {
  ja.apply(this, arguments);if (da) {
    if (da) {
      var l = ea;da = !1;ea = null;
    } else throw Error(u(198));fa || (fa = !0, ha = l);
  }
}var la = null,
    ma = null,
    na = null;
function oa(a, b, c) {
  var d = a.type || "unknown-event";a.currentTarget = na(c);ka(d, b, void 0, a);a.currentTarget = null;
}var pa = null,
    qa = {};
function ra() {
  if (pa) for (var a in qa) {
    var b = qa[a],
        c = pa.indexOf(a);if (!(-1 < c)) throw Error(u(96, a));if (!sa[c]) {
      if (!b.extractEvents) throw Error(u(97, a));sa[c] = b;c = b.eventTypes;for (var d in c) {
        var e = void 0;var f = c[d],
            g = b,
            h = d;if (ta.hasOwnProperty(h)) throw Error(u(99, h));ta[h] = f;var k = f.phasedRegistrationNames;if (k) {
          for (e in k) {
            k.hasOwnProperty(e) && ua(k[e], g, h);
          }e = !0;
        } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;if (!e) throw Error(u(98, d, a));
      }
    }
  }
}
function ua(a, b, c) {
  if (va[a]) throw Error(u(100, a));va[a] = b;wa[a] = b.eventTypes[c].dependencies;
}var sa = [],
    ta = {},
    va = {},
    wa = {};function xa(a) {
  var b = !1,
      c;for (c in a) {
    if (a.hasOwnProperty(c)) {
      var d = a[c];if (!qa.hasOwnProperty(c) || qa[c] !== d) {
        if (qa[c]) throw Error(u(102, c));qa[c] = d;b = !0;
      }
    }
  }b && ra();
}var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
    za = null,
    Aa = null,
    Ba = null;
function Ca(a) {
  if (a = ma(a)) {
    if ("function" !== typeof za) throw Error(u(280));var b = a.stateNode;b && (b = la(b), za(a.stateNode, a.type, b));
  }
}function Da(a) {
  Aa ? Ba ? Ba.push(a) : Ba = [a] : Aa = a;
}function Ea() {
  if (Aa) {
    var a = Aa,
        b = Ba;Ba = Aa = null;Ca(a);if (b) for (a = 0; a < b.length; a++) {
      Ca(b[a]);
    }
  }
}function Fa(a, b) {
  return a(b);
}function Ga(a, b, c, d, e) {
  return a(b, c, d, e);
}function Ha() {}var Ia = Fa,
    Ja = !1,
    Ka = !1;function La() {
  if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
  if (Ka) return a(b, c);Ka = !0;try {
    return Ia(a, b, c);
  } finally {
    Ka = !1, La();
  }
}var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    Oa = Object.prototype.hasOwnProperty,
    Pa = {},
    Qa = {};
function Ra(a) {
  if (Oa.call(Qa, a)) return !0;if (Oa.call(Pa, a)) return !1;if (Na.test(a)) return Qa[a] = !0;Pa[a] = !0;return !1;
}function Sa(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {case "function":case "symbol":
      return !0;case "boolean":
      if (d) return !1;if (null !== c) return !c.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
      return !1;}
}
function Ta(a, b, c, d) {
  if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;if (d) return !1;if (null !== c) switch (c.type) {case 3:
      return !b;case 4:
      return !1 === b;case 5:
      return isNaN(b);case 6:
      return isNaN(b) || 1 > b;}return !1;
}function v(a, b, c, d, e, f) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = d;this.attributeNamespace = e;this.mustUseProperty = c;this.propertyName = a;this.type = b;this.sanitizeURL = f;
}var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  C[a] = new v(a, 0, !1, a, null, !1);
});[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];C[b] = new v(b, 1, !1, a[1], null, !1);
});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  C[a] = new v(a, 2, !1, a, null, !1);
});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  C[a] = new v(a, 3, !0, a, null, !1);
});["capture", "download"].forEach(function (a) {
  C[a] = new v(a, 4, !1, a, null, !1);
});["cols", "rows", "size", "span"].forEach(function (a) {
  C[a] = new v(a, 6, !1, a, null, !1);
});["rowSpan", "start"].forEach(function (a) {
  C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});var Ua = /[\-:]([a-z])/g;function Va(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(Ua, Va);C[b] = new v(b, 1, !1, a, null, !1);
});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(Ua, Va);C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(Ua, Va);C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});["tabIndex", "crossOrigin"].forEach(function (a) {
  C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);["src", "href", "action", "formAction"].forEach(function (a) {
  C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});var Wa = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = { current: null });Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = { suspense: null });
function Xa(a, b, c, d) {
  var e = C.hasOwnProperty(b) ? C[b] : null;var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/,
    E = "function" === typeof Symbol && Symbol.for,
    Za = E ? Symbol.for("react.element") : 60103,
    $a = E ? Symbol.for("react.portal") : 60106,
    ab = E ? Symbol.for("react.fragment") : 60107,
    bb = E ? Symbol.for("react.strict_mode") : 60108,
    cb = E ? Symbol.for("react.profiler") : 60114,
    db = E ? Symbol.for("react.provider") : 60109,
    eb = E ? Symbol.for("react.context") : 60110,
    fb = E ? Symbol.for("react.concurrent_mode") : 60111,
    gb = E ? Symbol.for("react.forward_ref") : 60112,
    hb = E ? Symbol.for("react.suspense") : 60113,
    ib = E ? Symbol.for("react.suspense_list") : 60120,
    jb = E ? Symbol.for("react.memo") : 60115,
    kb = E ? Symbol.for("react.lazy") : 60116,
    lb = E ? Symbol.for("react.block") : 60121,
    mb = "function" === typeof Symbol && Symbol.iterator;function nb(a) {
  if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) return null;a = mb && a[mb] || a["@@iterator"];return "function" === typeof a ? a : null;
}function ob(a) {
  if (-1 === a._status) {
    a._status = 0;var b = a._ctor;b = b();a._result = b;b.then(function (b) {
      0 === a._status && (b = b.default, a._status = 1, a._result = b);
    }, function (b) {
      0 === a._status && (a._status = 2, a._result = b);
    });
  }
}
function pb(a) {
  if (null == a) return null;if ("function" === typeof a) return a.displayName || a.name || null;if ("string" === typeof a) return a;switch (a) {case ab:
      return "Fragment";case $a:
      return "Portal";case cb:
      return "Profiler";case bb:
      return "StrictMode";case hb:
      return "Suspense";case ib:
      return "SuspenseList";}if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a))) switch (a.$$typeof) {case eb:
      return "Context.Consumer";case db:
      return "Context.Provider";case gb:
      var b = a.render;b = b.displayName || b.name || "";return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");case jb:
      return pb(a.type);case lb:
      return pb(a.render);case kb:
      if (a = 1 === a._status ? a._result : null) return pb(a);}return null;
}function qb(a) {
  var b = "";do {
    a: switch (a.tag) {case 3:case 4:case 6:case 7:case 10:case 9:
        var c = "";break a;default:
        var d = a._debugOwner,
            e = a._debugSource,
            f = pb(a.type);c = null;d && (c = pb(d.type));d = f;f = "";e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");c = "\n    in " + (d || "Unknown") + f;}b += c;a = a.return;
  } while (a);return b;
}
function rb(a) {
  switch (typeof a === "undefined" ? "undefined" : _typeof(a)) {case "boolean":case "number":case "object":case "string":case "undefined":
      return a;default:
      return "";}
}function sb(a) {
  var b = a.type;return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
  var b = sb(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
        f = c.set;Object.defineProperty(a, b, { configurable: !0, get: function get() {
        return e.call(this);
      }, set: function set(a) {
        d = "" + a;f.call(this, a);
      } });Object.defineProperty(a, b, { enumerable: c.enumerable });return { getValue: function getValue() {
        return d;
      }, setValue: function setValue(a) {
        d = "" + a;
      }, stopTracking: function stopTracking() {
        a._valueTracker = null;delete a[b];
      } };
  }
}function xb(a) {
  a._valueTracker || (a._valueTracker = tb(a));
}function yb(a) {
  if (!a) return !1;var b = a._valueTracker;if (!b) return !0;var c = b.getValue();var d = "";a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);a = d;return a !== c ? (b.setValue(a), !0) : !1;
}function zb(a, b) {
  var c = b.checked;return n({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}
function Ab(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;c = rb(null != b.value ? b.value : c);a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}function Bb(a, b) {
  b = b.checked;null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
  Bb(a, b);var c = rb(b.value),
      d = b.type;if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");return;
  }b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;b = "" + a._wrapperState.initialValue;c || b === a.value || (a.value = b);a.defaultValue = b;
  }c = a.name;"" !== c && (a.name = "");a.defaultChecked = !!a._wrapperState.initialChecked;"" !== c && (a.name = c);
}
function Db(a, b, c) {
  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}function Fb(a) {
  var b = "";aa.Children.forEach(a, function (a) {
    null != a && (b += a);
  });return b;
}function Gb(a, b) {
  a = n({ children: void 0 }, b);if (b = Fb(b.children)) a.children = b;return a;
}
function Hb(a, b, c, d) {
  a = a.options;if (b) {
    b = {};for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + rb(c);b = null;for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;d && (a[e].defaultSelected = !0);return;
      }null !== b || a[e].disabled || (b = a[e]);
    }null !== b && (b.selected = !0);
  }
}
function Ib(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(u(91));return n({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}function Jb(a, b) {
  var c = b.value;if (null == c) {
    c = b.children;b = b.defaultValue;if (null != c) {
      if (null != b) throw Error(u(92));if (Array.isArray(c)) {
        if (!(1 >= c.length)) throw Error(u(93));c = c[0];
      }b = c;
    }null == b && (b = "");c = b;
  }a._wrapperState = { initialValue: rb(c) };
}
function Kb(a, b) {
  var c = rb(b.value),
      d = rb(b.defaultValue);null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));null != d && (a.defaultValue = "" + d);
}function Lb(a) {
  var b = a.textContent;b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}var Mb = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function Nb(a) {
  switch (a) {case "svg":
      return "http://www.w3.org/2000/svg";case "math":
      return "http://www.w3.org/1998/Math/MathML";default:
      return "http://www.w3.org/1999/xhtml";}
}function Ob(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb,
    Qb = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;else {
    Pb = Pb || document.createElement("div");Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";for (b = Pb.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});
function Rb(a, b) {
  if (b) {
    var c = a.firstChild;if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;return;
    }
  }a.textContent = b;
}function Sb(a, b) {
  var c = {};c[a.toLowerCase()] = b.toLowerCase();c["Webkit" + a] = "webkit" + b;c["Moz" + a] = "moz" + b;return c;
}var Tb = { animationend: Sb("Animation", "AnimationEnd"), animationiteration: Sb("Animation", "AnimationIteration"), animationstart: Sb("Animation", "AnimationStart"), transitionend: Sb("Transition", "TransitionEnd") },
    Ub = {},
    Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);function Wb(a) {
  if (Ub[a]) return Ub[a];if (!Tb[a]) return a;var b = Tb[a],
      c;for (c in b) {
    if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
  }return a;
}
var Xb = Wb("animationend"),
    Yb = Wb("animationiteration"),
    Zb = Wb("animationstart"),
    $b = Wb("transitionend"),
    ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    bc = new ("function" === typeof WeakMap ? WeakMap : Map)();function cc(a) {
  var b = bc.get(a);void 0 === b && (b = new Map(), bc.set(a, b));return b;
}
function dc(a) {
  var b = a,
      c = a;if (a.alternate) for (; b.return;) {
    b = b.return;
  } else {
    a = b;do {
      b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
    } while (a);
  }return 3 === b.tag ? c : null;
}function ec(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;null === b && (a = a.alternate, null !== a && (b = a.memoizedState));if (null !== b) return b.dehydrated;
  }return null;
}function fc(a) {
  if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
  var b = a.alternate;if (!b) {
    b = dc(a);if (null === b) throw Error(u(188));return b !== a ? null : a;
  }for (var c = a, d = b;;) {
    var e = c.return;if (null === e) break;var f = e.alternate;if (null === f) {
      d = e.return;if (null !== d) {
        c = d;continue;
      }break;
    }if (e.child === f.child) {
      for (f = e.child; f;) {
        if (f === c) return fc(e), a;if (f === d) return fc(e), b;f = f.sibling;
      }throw Error(u(188));
    }if (c.return !== d.return) c = e, d = f;else {
      for (var g = !1, h = e.child; h;) {
        if (h === c) {
          g = !0;c = e;d = f;break;
        }if (h === d) {
          g = !0;d = e;c = f;break;
        }h = h.sibling;
      }if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;c = f;d = e;break;
          }if (h === d) {
            g = !0;d = f;c = e;break;
          }h = h.sibling;
        }if (!g) throw Error(u(189));
      }
    }if (c.alternate !== d) throw Error(u(190));
  }if (3 !== c.tag) throw Error(u(188));return c.stateNode.current === c ? a : b;
}function hc(a) {
  a = gc(a);if (!a) return null;for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;if (b.child) b.child.return = b, b = b.child;else {
      if (b === a) break;for (; !b.sibling;) {
        if (!b.return || b.return === a) return null;b = b.return;
      }b.sibling.return = b.return;b = b.sibling;
    }
  }return null;
}
function ic(a, b) {
  if (null == b) throw Error(u(30));if (null == a) return b;if (Array.isArray(a)) {
    if (Array.isArray(b)) return a.push.apply(a, b), a;a.push(b);return a;
  }return Array.isArray(b) ? [a].concat(b) : [a, b];
}function jc(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}var kc = null;
function lc(a) {
  if (a) {
    var b = a._dispatchListeners,
        c = a._dispatchInstances;if (Array.isArray(b)) for (var d = 0; d < b.length && !a.isPropagationStopped(); d++) {
      oa(a, b[d], c[d]);
    } else b && oa(a, b, c);a._dispatchListeners = null;a._dispatchInstances = null;a.isPersistent() || a.constructor.release(a);
  }
}function mc(a) {
  null !== a && (kc = ic(kc, a));a = kc;kc = null;if (a) {
    jc(a, lc);if (kc) throw Error(u(95));if (fa) throw a = ha, fa = !1, ha = null, a;
  }
}
function nc(a) {
  a = a.target || a.srcElement || window;a.correspondingUseElement && (a = a.correspondingUseElement);return 3 === a.nodeType ? a.parentNode : a;
}function oc(a) {
  if (!ya) return !1;a = "on" + a;var b = a in document;b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);return b;
}var pc = [];function qc(a) {
  a.topLevelType = null;a.nativeEvent = null;a.targetInst = null;a.ancestors.length = 0;10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
  if (pc.length) {
    var e = pc.pop();e.topLevelType = a;e.eventSystemFlags = d;e.nativeEvent = b;e.targetInst = c;return e;
  }return { topLevelType: a, eventSystemFlags: d, nativeEvent: b, targetInst: c, ancestors: [] };
}
function sc(a) {
  var b = a.targetInst,
      c = b;do {
    if (!c) {
      a.ancestors.push(c);break;
    }var d = c;if (3 === d.tag) d = d.stateNode.containerInfo;else {
      for (; d.return;) {
        d = d.return;
      }d = 3 !== d.tag ? null : d.stateNode.containerInfo;
    }if (!d) break;b = c.tag;5 !== b && 6 !== b || a.ancestors.push(c);c = tc(d);
  } while (c);for (c = 0; c < a.ancestors.length; c++) {
    b = a.ancestors[c];var e = nc(a.nativeEvent);d = a.topLevelType;var f = a.nativeEvent,
        g = a.eventSystemFlags;0 === c && (g |= 64);for (var h = null, k = 0; k < sa.length; k++) {
      var l = sa[k];l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
    }mc(h);
  }
}function uc(a, b, c) {
  if (!c.has(a)) {
    switch (a) {case "scroll":
        vc(b, "scroll", !0);break;case "focus":case "blur":
        vc(b, "focus", !0);vc(b, "blur", !0);c.set("blur", null);c.set("focus", null);break;case "cancel":case "close":
        oc(a) && vc(b, a, !0);break;case "invalid":case "submit":case "reset":
        break;default:
        -1 === ac.indexOf(a) && F(a, b);}c.set(a, null);
  }
}
var wc,
    xc,
    yc,
    zc = !1,
    Ac = [],
    Bc = null,
    Cc = null,
    Dc = null,
    Ec = new Map(),
    Fc = new Map(),
    Gc = [],
    Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
    Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
  var c = cc(b);Hc.forEach(function (a) {
    uc(a, b, c);
  });Ic.forEach(function (a) {
    uc(a, b, c);
  });
}function Kc(a, b, c, d, e) {
  return { blockedOn: a, topLevelType: b, eventSystemFlags: c | 32, nativeEvent: e, container: d };
}
function Lc(a, b) {
  switch (a) {case "focus":case "blur":
      Bc = null;break;case "dragenter":case "dragleave":
      Cc = null;break;case "mouseover":case "mouseout":
      Dc = null;break;case "pointerover":case "pointerout":
      Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":
      Fc.delete(b.pointerId);}
}function Mc(a, b, c, d, e, f) {
  if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;a.eventSystemFlags |= d;return a;
}
function Oc(a, b, c, d, e) {
  switch (b) {case "focus":
      return Bc = Mc(Bc, a, b, c, d, e), !0;case "dragenter":
      return Cc = Mc(Cc, a, b, c, d, e), !0;case "mouseover":
      return Dc = Mc(Dc, a, b, c, d, e), !0;case "pointerover":
      var f = e.pointerId;Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));return !0;case "gotpointercapture":
      return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;}return !1;
}
function Pc(a) {
  var b = tc(a.target);if (null !== b) {
    var c = dc(b);if (null !== c) if (b = c.tag, 13 === b) {
      if (b = ec(c), null !== b) {
        a.blockedOn = b;r.unstable_runWithPriority(a.priority, function () {
          yc(c);
        });return;
      }
    } else if (3 === b && c.stateNode.hydrate) {
      a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;return;
    }
  }a.blockedOn = null;
}function Qc(a) {
  if (null !== a.blockedOn) return !1;var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);if (null !== b) {
    var c = Nc(b);null !== c && xc(c);a.blockedOn = b;return !1;
  }return !0;
}
function Sc(a, b, c) {
  Qc(a) && c.delete(b);
}function Tc() {
  for (zc = !1; 0 < Ac.length;) {
    var a = Ac[0];if (null !== a.blockedOn) {
      a = Nc(a.blockedOn);null !== a && wc(a);break;
    }var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);null !== b ? a.blockedOn = b : Ac.shift();
  }null !== Bc && Qc(Bc) && (Bc = null);null !== Cc && Qc(Cc) && (Cc = null);null !== Dc && Qc(Dc) && (Dc = null);Ec.forEach(Sc);Fc.forEach(Sc);
}function Uc(a, b) {
  a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Tc)));
}
function Vc(a) {
  function b(b) {
    return Uc(b, a);
  }if (0 < Ac.length) {
    Uc(Ac[0], a);for (var c = 1; c < Ac.length; c++) {
      var d = Ac[c];d.blockedOn === a && (d.blockedOn = null);
    }
  }null !== Bc && Uc(Bc, a);null !== Cc && Uc(Cc, a);null !== Dc && Uc(Dc, a);Ec.forEach(b);Fc.forEach(b);for (c = 0; c < Gc.length; c++) {
    d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
  }for (; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);) {
    Pc(c), null === c.blockedOn && Gc.shift();
  }
}
var Wc = {},
    Yc = new Map(),
    Zc = new Map(),
    $c = ["abort", "abort", Xb, "animationEnd", Yb, "animationIteration", Zb, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", $b, "transitionEnd", "waiting", "waiting"];function ad(a, b) {
  for (var c = 0; c < a.length; c += 2) {
    var d = a[c],
        e = a[c + 1],
        f = "on" + (e[0].toUpperCase() + e.slice(1));f = { phasedRegistrationNames: { bubbled: f, captured: f + "Capture" }, dependencies: [d], eventPriority: b };Zc.set(d, b);Yc.set(d, f);Wc[e] = f;
  }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);ad($c, 2);for (var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++) {
  Zc.set(bd[cd], 0);
}var dd = r.unstable_UserBlockingPriority,
    ed = r.unstable_runWithPriority,
    fd = !0;function F(a, b) {
  vc(b, a, !1);
}function vc(a, b, c) {
  var d = Zc.get(b);switch (void 0 === d ? 2 : d) {case 0:
      d = gd.bind(null, b, 1, a);break;case 1:
      d = hd.bind(null, b, 1, a);break;default:
      d = id.bind(null, b, 1, a);}c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}function gd(a, b, c, d) {
  Ja || Ha();var e = id,
      f = Ja;Ja = !0;try {
    Ga(e, a, b, c, d);
  } finally {
    (Ja = f) || La();
  }
}function hd(a, b, c, d) {
  ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
  if (fd) if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);else {
    var e = Rc(a, b, c, d);if (null === e) Lc(a, d);else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);else if (!Oc(e, a, b, c, d)) {
      Lc(a, d);a = rc(a, d, null, b);try {
        Ma(sc, a);
      } finally {
        qc(a);
      }
    }
  }
}
function Rc(a, b, c, d) {
  c = nc(d);c = tc(c);if (null !== c) {
    var e = dc(c);if (null === e) c = null;else {
      var f = e.tag;if (13 === f) {
        c = ec(e);if (null !== c) return c;c = null;
      } else if (3 === f) {
        if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;c = null;
      } else e !== c && (c = null);
    }
  }a = rc(a, d, c, b);try {
    Ma(sc, a);
  } finally {
    qc(a);
  }return null;
}
var jd = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridArea: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0,
  floodOpacity: !0, stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
    kd = ["Webkit", "ms", "Moz", "O"];Object.keys(jd).forEach(function (a) {
  kd.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);jd[b] = jd[a];
  });
});function ld(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
  a = a.style;for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"),
          e = ld(c, b[c], d);"float" === c && (c = "cssFloat");d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}var nd = n({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function od(a, b) {
  if (b) {
    if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(u(60));if (!("object" === _typeof(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
    }if (null != b.style && "object" !== _typeof(b.style)) throw Error(u(62, ""));
  }
}
function pd(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;switch (a) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
      return !1;default:
      return !0;}
}var qd = Mb.html;function rd(a, b) {
  a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;var c = cc(a);b = wa[b];for (var d = 0; d < b.length; d++) {
    uc(b[d], a, c);
  }
}function sd() {}
function td(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);if ("undefined" === typeof a) return null;try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}function ud(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }return a;
}function vd(a, b) {
  var c = ud(a);a = 0;for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;if (a <= b && d >= b) return { node: c, offset: b - a };a = d;
    }a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;break a;
        }c = c.parentNode;
      }c = void 0;
    }c = ud(c);
  }
}
function wd(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}function xd() {
  for (var a = window, b = td(); b instanceof a.HTMLIFrameElement;) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = !1;
    }if (c) a = b.contentWindow;else break;b = td(a.document);
  }return b;
}
function yd(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}var zd = "$",
    Ad = "/$",
    Bd = "$?",
    Cd = "$!",
    Dd = null,
    Ed = null;function Fd(a, b) {
  switch (a) {case "button":case "input":case "select":case "textarea":
      return !!b.autoFocus;}return !1;
}
function Gd(a, b) {
  return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === _typeof(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}var Hd = "function" === typeof setTimeout ? setTimeout : void 0,
    Id = "function" === typeof clearTimeout ? clearTimeout : void 0;function Jd(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;if (1 === b || 3 === b) break;
  }return a;
}
function Kd(a) {
  a = a.previousSibling;for (var b = 0; a;) {
    if (8 === a.nodeType) {
      var c = a.data;if (c === zd || c === Cd || c === Bd) {
        if (0 === b) return a;b--;
      } else c === Ad && b++;
    }a = a.previousSibling;
  }return null;
}var Ld = Math.random().toString(36).slice(2),
    Md = "__reactInternalInstance$" + Ld,
    Nd = "__reactEventHandlers$" + Ld,
    Od = "__reactContainere$" + Ld;
function tc(a) {
  var b = a[Md];if (b) return b;for (var c = a.parentNode; c;) {
    if (b = c[Od] || c[Md]) {
      c = b.alternate;if (null !== b.child || null !== c && null !== c.child) for (a = Kd(a); null !== a;) {
        if (c = a[Md]) return c;a = Kd(a);
      }return b;
    }a = c;c = a.parentNode;
  }return null;
}function Nc(a) {
  a = a[Md] || a[Od];return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}function Pd(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;throw Error(u(33));
}function Qd(a) {
  return a[Nd] || null;
}
function Rd(a) {
  do {
    a = a.return;
  } while (a && 5 !== a.tag);return a ? a : null;
}
function Sd(a, b) {
  var c = a.stateNode;if (!c) return null;var d = la(c);if (!d) return null;c = d[b];a: switch (b) {case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));a = !d;break a;default:
      a = !1;}if (a) return null;if (c && "function" !== typeof c) throw Error(u(231, b, typeof c === "undefined" ? "undefined" : _typeof(c)));return c;
}function Td(a, b, c) {
  if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}function Ud(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    for (var b = a._targetInst, c = []; b;) {
      c.push(b), b = Rd(b);
    }for (b = c.length; 0 < b--;) {
      Td(c[b], "captured", a);
    }for (b = 0; b < c.length; b++) {
      Td(c[b], "bubbled", a);
    }
  }
}
function Vd(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}function Wd(a) {
  a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}function Xd(a) {
  jc(a, Ud);
}var Yd = null,
    Zd = null,
    $d = null;
function ae() {
  if ($d) return $d;var a,
      b = Zd,
      c = b.length,
      d,
      e = "value" in Yd ? Yd.value : Yd.textContent,
      f = e.length;for (a = 0; a < c && b[a] === e[a]; a++) {}var g = c - a;for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {}return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}function be() {
  return !0;
}function ce() {
  return !1;
}
function G(a, b, c, d) {
  this.dispatchConfig = a;this._targetInst = b;this.nativeEvent = c;a = this.constructor.Interface;for (var e in a) {
    a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
  }this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;this.isPropagationStopped = ce;return this;
}
n(G.prototype, { preventDefault: function preventDefault() {
    this.defaultPrevented = !0;var a = this.nativeEvent;a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
  }, stopPropagation: function stopPropagation() {
    var a = this.nativeEvent;a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
  }, persist: function persist() {
    this.isPersistent = be;
  }, isPersistent: ce, destructor: function destructor() {
    var a = this.constructor.Interface,
        b;for (b in a) {
      this[b] = null;
    }this.nativeEvent = this._targetInst = this.dispatchConfig = null;this.isPropagationStopped = this.isDefaultPrevented = ce;this._dispatchInstances = this._dispatchListeners = null;
  } });G.Interface = { type: null, target: null, currentTarget: function currentTarget() {
    return null;
  }, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: null, isTrusted: null };
G.extend = function (a) {
  function b() {}function c() {
    return d.apply(this, arguments);
  }var d = this;b.prototype = d.prototype;var e = new b();n(e, c.prototype);c.prototype = e;c.prototype.constructor = c;c.Interface = n({}, d.Interface, a);c.extend = d.extend;de(c);return c;
};de(G);function ee(a, b, c, d) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();this.call(e, a, b, c, d);return e;
  }return new this(a, b, c, d);
}
function fe(a) {
  if (!(a instanceof this)) throw Error(u(279));a.destructor();10 > this.eventPool.length && this.eventPool.push(a);
}function de(a) {
  a.eventPool = [];a.getPooled = ee;a.release = fe;
}var ge = G.extend({ data: null }),
    he = G.extend({ data: null }),
    ie = [9, 13, 27, 32],
    je = ya && "CompositionEvent" in window,
    ke = null;ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke,
    me = ya && (!je || ke && 8 < ke && 11 >= ke),
    ne = String.fromCharCode(32),
    oe = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart",
      captured: "onCompositionStartCapture" }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } },
    pe = !1;
function qe(a, b) {
  switch (a) {case "keyup":
      return -1 !== ie.indexOf(b.keyCode);case "keydown":
      return 229 !== b.keyCode;case "keypress":case "mousedown":case "blur":
      return !0;default:
      return !1;}
}function re(a) {
  a = a.detail;return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && "data" in a ? a.data : null;
}var se = !1;function te(a, b) {
  switch (a) {case "compositionend":
      return re(b);case "keypress":
      if (32 !== b.which) return null;pe = !0;return ne;case "textInput":
      return a = b.data, a === ne && pe ? null : a;default:
      return null;}
}
function ue(a, b) {
  if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;switch (a) {case "paste":
      return null;case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;if (b.which) return String.fromCharCode(b.which);
      }return null;case "compositionend":
      return me && "ko" !== b.locale ? null : b.data;default:
      return null;}
}
var ve = { eventTypes: oe, extractEvents: function extractEvents(a, b, c, d) {
    var e;if (je) b: {
      switch (a) {case "compositionstart":
          var f = oe.compositionStart;break b;case "compositionend":
          f = oe.compositionEnd;break b;case "compositionupdate":
          f = oe.compositionUpdate;break b;}f = void 0;
    } else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;(a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;return null === e ? b : null === b ? e : [e, b];
  } },
    we = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };function xe(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };function ze(a, b, c) {
  a = G.getPooled(ye.change, a, b, c);a.type = "change";Da(c);Xd(a);return a;
}var Ae = null,
    Be = null;function Ce(a) {
  mc(a);
}function De(a) {
  var b = Pd(a);if (yb(b)) return a;
}function Ee(a, b) {
  if ("change" === a) return b;
}var Fe = !1;ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
  Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}function He(a) {
  if ("value" === a.propertyName && De(Be)) if (a = ze(Be, a, nc(a)), Ja) mc(a);else {
    Ja = !0;try {
      Fa(Ce, a);
    } finally {
      Ja = !1, La();
    }
  }
}function Ie(a, b, c) {
  "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}function Je(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}function Ke(a, b) {
  if ("click" === a) return De(b);
}function Le(a, b) {
  if ("input" === a || "change" === a) return De(b);
}
var Me = { eventTypes: ye, _isInputEventSupported: Fe, extractEvents: function extractEvents(a, b, c, d) {
    var e = b ? Pd(b) : window,
        f = e.nodeName && e.nodeName.toLowerCase();if ("select" === f || "input" === f && "file" === e.type) var g = Ee;else if (xe(e)) {
      if (Fe) g = Le;else {
        g = Je;var h = Ie;
      }
    } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);if (g && (g = g(a, b))) return ze(g, c, d);h && h(a, e, b);"blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
  } },
    Ne = G.extend({ view: null, detail: null }),
    Oe = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };function Pe(a) {
  var b = this.nativeEvent;return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}function Qe() {
  return Pe;
}
var Re = 0,
    Se = 0,
    Te = !1,
    Ue = !1,
    Ve = Ne.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Qe, button: null, buttons: null, relatedTarget: function relatedTarget(a) {
    return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
  }, movementX: function movementX(a) {
    if ("movementX" in a) return a.movementX;var b = Re;Re = a.screenX;return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
  }, movementY: function movementY(a) {
    if ("movementY" in a) return a.movementY;
    var b = Se;Se = a.screenY;return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
  } }),
    We = Ve.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }),
    Xe = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: { registrationName: "onPointerLeave",
    dependencies: ["pointerout", "pointerover"] } },
    Ye = { eventTypes: Xe, extractEvents: function extractEvents(a, b, c, d, e) {
    var f = "mouseover" === a || "pointerover" === a,
        g = "mouseout" === a || "pointerout" === a;if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;if (g) {
      if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
        var h = dc(b);if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
      }
    } else g = null;if (g === b) return null;if ("mouseout" === a || "mouseover" === a) {
      var k = Ve;var l = Xe.mouseLeave;var m = Xe.mouseEnter;var p = "mouse";
    } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";a = null == g ? f : Pd(g);f = null == b ? f : Pd(b);l = k.getPooled(l, g, c, d);l.type = p + "leave";l.target = a;l.relatedTarget = f;c = k.getPooled(m, b, c, d);c.type = p + "enter";c.target = f;c.relatedTarget = a;d = g;p = b;if (d && p) a: {
      k = d;m = p;g = 0;for (a = k; a; a = Rd(a)) {
        g++;
      }a = 0;for (b = m; b; b = Rd(b)) {
        a++;
      }for (; 0 < g - a;) {
        k = Rd(k), g--;
      }for (; 0 < a - g;) {
        m = Rd(m), a--;
      }for (; g--;) {
        if (k === m || k === m.alternate) break a;
        k = Rd(k);m = Rd(m);
      }k = null;
    } else k = null;m = k;for (k = []; d && d !== m;) {
      g = d.alternate;if (null !== g && g === m) break;k.push(d);d = Rd(d);
    }for (d = []; p && p !== m;) {
      g = p.alternate;if (null !== g && g === m) break;d.push(p);p = Rd(p);
    }for (p = 0; p < k.length; p++) {
      Vd(k[p], "bubbled", l);
    }for (p = d.length; 0 < p--;) {
      Vd(d[p], "captured", c);
    }return 0 === (e & 64) ? [l] : [l, c];
  } };function Ze(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}var $e = "function" === typeof Object.is ? Object.is : Ze,
    af = Object.prototype.hasOwnProperty;
function bf(a, b) {
  if ($e(a, b)) return !0;if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : _typeof(b)) || null === b) return !1;var c = Object.keys(a),
      d = Object.keys(b);if (c.length !== d.length) return !1;for (d = 0; d < c.length; d++) {
    if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
  }return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode,
    df = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } },
    ef = null,
    ff = null,
    gf = null,
    hf = !1;
function jf(a, b) {
  var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;if (hf || null == ef || ef !== td(c)) return null;c = ef;"selectionStart" in c && yd(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset });return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = { eventTypes: df, extractEvents: function extractEvents(a, b, c, d, e, f) {
    e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);if (!(f = !e)) {
      a: {
        e = cc(e);f = wa.onSelect;for (var g = 0; g < f.length; g++) {
          if (!e.has(f[g])) {
            e = !1;break a;
          }
        }e = !0;
      }f = !e;
    }if (f) return null;e = b ? Pd(b) : window;switch (a) {case "focus":
        if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;break;case "blur":
        gf = ff = ef = null;break;case "mousedown":
        hf = !0;break;case "contextmenu":case "mouseup":case "dragend":
        return hf = !1, jf(c, d);case "selectionchange":
        if (cf) break;
      case "keydown":case "keyup":
        return jf(c, d);}return null;
  } },
    lf = G.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),
    mf = G.extend({ clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }),
    nf = Ne.extend({ relatedTarget: null });function of(a) {
  var b = a.keyCode;"charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;10 === a && (a = 13);return 32 <= a || 13 === a ? a : 0;
}
var pf = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" },
    qf = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4",
  116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" },
    rf = Ne.extend({ key: function key(a) {
    if (a.key) {
      var b = pf[a.key] || a.key;if ("Unidentified" !== b) return b;
    }return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
  }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Qe, charCode: function charCode(a) {
    return "keypress" === a.type ? of(a) : 0;
  }, keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }, which: function which(a) {
    return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  } }),
    sf = Ve.extend({ dataTransfer: null }),
    tf = Ne.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Qe }),
    uf = G.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),
    vf = Ve.extend({ deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  }, deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  }, deltaZ: null, deltaMode: null }),
    wf = { eventTypes: Wc, extractEvents: function extractEvents(a, b, c, d) {
    var e = Yc.get(a);if (!e) return null;switch (a) {case "keypress":
        if (0 === of(c)) return null;case "keydown":case "keyup":
        a = rf;break;case "blur":case "focus":
        a = nf;break;case "click":
        if (2 === c.button) return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":
        a = Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":
        a = sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":
        a = tf;break;case Xb:case Yb:case Zb:
        a = lf;break;case $b:
        a = uf;break;case "scroll":
        a = Ne;break;case "wheel":
        a = vf;break;case "copy":case "cut":case "paste":
        a = mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":
        a = We;break;default:
        a = G;}b = a.getPooled(e, b, c, d);Xd(b);return b;
  } };if (pa) throw Error(u(101));pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf = Nc;la = Qd;ma = xf;na = Pd;xa({ SimpleEventPlugin: wf, EnterLeaveEventPlugin: Ye, ChangeEventPlugin: Me, SelectEventPlugin: kf, BeforeInputEventPlugin: ve });var yf = [],
    zf = -1;function H(a) {
  0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
  zf++;yf[zf] = a.current;a.current = b;
}var Af = {},
    J = { current: Af },
    K = { current: !1 },
    Bf = Af;function Cf(a, b) {
  var c = a.type.contextTypes;if (!c) return Af;var d = a.stateNode;if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;var e = {},
      f;for (f in c) {
    e[f] = b[f];
  }d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);return e;
}function L(a) {
  a = a.childContextTypes;return null !== a && void 0 !== a;
}
function Df() {
  H(K);H(J);
}function Ef(a, b, c) {
  if (J.current !== Af) throw Error(u(168));I(J, b);I(K, c);
}function Ff(a, b, c) {
  var d = a.stateNode;a = b.childContextTypes;if ("function" !== typeof d.getChildContext) return c;d = d.getChildContext();for (var e in d) {
    if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
  }return n({}, c, {}, d);
}function Gf(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;Bf = J.current;I(J, a);I(K, K.current);return !0;
}
function Hf(a, b, c) {
  var d = a.stateNode;if (!d) throw Error(u(169));c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);I(K, c);
}
var If = r.unstable_runWithPriority,
    Jf = r.unstable_scheduleCallback,
    Kf = r.unstable_cancelCallback,
    Lf = r.unstable_requestPaint,
    Mf = r.unstable_now,
    Nf = r.unstable_getCurrentPriorityLevel,
    Of = r.unstable_ImmediatePriority,
    Pf = r.unstable_UserBlockingPriority,
    Qf = r.unstable_NormalPriority,
    Rf = r.unstable_LowPriority,
    Sf = r.unstable_IdlePriority,
    Tf = {},
    Uf = r.unstable_shouldYield,
    Vf = void 0 !== Lf ? Lf : function () {},
    Wf = null,
    Xf = null,
    Yf = !1,
    Zf = Mf(),
    $f = 1E4 > Zf ? Mf : function () {
  return Mf() - Zf;
};
function ag() {
  switch (Nf()) {case Of:
      return 99;case Pf:
      return 98;case Qf:
      return 97;case Rf:
      return 96;case Sf:
      return 95;default:
      throw Error(u(332));}
}function bg(a) {
  switch (a) {case 99:
      return Of;case 98:
      return Pf;case 97:
      return Qf;case 96:
      return Rf;case 95:
      return Sf;default:
      throw Error(u(332));}
}function cg(a, b) {
  a = bg(a);return If(a, b);
}function dg(a, b, c) {
  a = bg(a);return Jf(a, b, c);
}function eg(a) {
  null === Wf ? (Wf = [a], Xf = Jf(Of, fg)) : Wf.push(a);return Tf;
}function gg() {
  if (null !== Xf) {
    var a = Xf;Xf = null;Kf(a);
  }fg();
}
function fg() {
  if (!Yf && null !== Wf) {
    Yf = !0;var a = 0;try {
      var b = Wf;cg(99, function () {
        for (; a < b.length; a++) {
          var c = b[a];do {
            c = c(!0);
          } while (null !== c);
        }
      });Wf = null;
    } catch (c) {
      throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
    } finally {
      Yf = !1;
    }
  }
}function hg(a, b, c) {
  c /= 10;return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}function ig(a, b) {
  if (a && a.defaultProps) {
    b = n({}, b);a = a.defaultProps;for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }
  }return b;
}var jg = { current: null },
    kg = null,
    lg = null,
    mg = null;function ng() {
  mg = lg = kg = null;
}
function og(a) {
  var b = jg.current;H(jg);a.type._context._currentValue = b;
}function pg(a, b) {
  for (; null !== a;) {
    var c = a.alternate;if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;else break;a = a.return;
  }
}function qg(a, b) {
  kg = a;mg = lg = null;a = a.dependencies;null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
  if (mg !== a && !1 !== b && 0 !== b) {
    if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;b = { context: a, observedBits: b, next: null };if (null === lg) {
      if (null === kg) throw Error(u(308));lg = b;kg.dependencies = { expirationTime: 0, firstContext: b, responders: null };
    } else lg = lg.next = b;
  }return a._currentValue;
}var tg = !1;function ug(a) {
  a.updateQueue = { baseState: a.memoizedState, baseQueue: null, shared: { pending: null }, effects: null };
}
function vg(a, b) {
  a = a.updateQueue;b.updateQueue === a && (b.updateQueue = { baseState: a.baseState, baseQueue: a.baseQueue, shared: a.shared, effects: a.effects });
}function wg(a, b) {
  a = { expirationTime: a, suspenseConfig: b, tag: 0, payload: null, callback: null, next: null };return a.next = a;
}function xg(a, b) {
  a = a.updateQueue;if (null !== a) {
    a = a.shared;var c = a.pending;null === c ? b.next = b : (b.next = c.next, c.next = b);a.pending = b;
  }
}
function yg(a, b) {
  var c = a.alternate;null !== c && vg(c, a);a = a.updateQueue;c = a.baseQueue;null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
  var e = a.updateQueue;tg = !1;var f = e.baseQueue,
      g = e.shared.pending;if (null !== g) {
    if (null !== f) {
      var h = f.next;f.next = g.next;g.next = h;
    }f = g;e.shared.pending = null;h = a.alternate;null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
  }if (null !== f) {
    h = f.next;var k = e.baseState,
        l = 0,
        m = null,
        p = null,
        x = null;if (null !== h) {
      var z = h;do {
        g = z.expirationTime;if (g < d) {
          var ca = { expirationTime: z.expirationTime, suspenseConfig: z.suspenseConfig, tag: z.tag, payload: z.payload, callback: z.callback, next: null };null === x ? (p = x = ca, m = k) : x = x.next = ca;g > l && (l = g);
        } else {
          null !== x && (x = x.next = { expirationTime: 1073741823, suspenseConfig: z.suspenseConfig, tag: z.tag, payload: z.payload, callback: z.callback, next: null });Ag(g, z.suspenseConfig);a: {
            var D = a,
                t = z;g = b;ca = c;switch (t.tag) {case 1:
                D = t.payload;if ("function" === typeof D) {
                  k = D.call(ca, k, g);break a;
                }k = D;break a;case 3:
                D.effectTag = D.effectTag & -4097 | 64;case 0:
                D = t.payload;g = "function" === typeof D ? D.call(ca, k, g) : D;if (null === g || void 0 === g) break a;k = n({}, k, g);break a;case 2:
                tg = !0;}
          }null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [z] : g.push(z));
        }z = z.next;if (null === z || z === h) if (g = e.shared.pending, null === g) break;else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
      } while (1);
    }null === x ? m = k : x.next = p;e.baseState = m;e.baseQueue = x;Bg(l);a.expirationTime = l;a.memoizedState = k;
  }
}
function Cg(a, b, c) {
  a = b.effects;b.effects = null;if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b],
        e = d.callback;if (null !== e) {
      d.callback = null;d = e;e = c;if ("function" !== typeof d) throw Error(u(191, d));d.call(e);
    }
  }
}var Dg = Wa.ReactCurrentBatchConfig,
    Eg = new aa.Component().refs;function Fg(a, b, c, d) {
  b = a.memoizedState;c = c(d, b);c = null === c || void 0 === c ? b : n({}, b, c);a.memoizedState = c;0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = { isMounted: function isMounted(a) {
    return (a = a._reactInternalFiber) ? dc(a) === a : !1;
  }, enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternalFiber;var d = Gg(),
        e = Dg.suspense;d = Hg(d, a, e);e = wg(d, e);e.payload = b;void 0 !== c && null !== c && (e.callback = c);xg(a, e);Ig(a, d);
  }, enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternalFiber;var d = Gg(),
        e = Dg.suspense;d = Hg(d, a, e);e = wg(d, e);e.tag = 1;e.payload = b;void 0 !== c && null !== c && (e.callback = c);xg(a, e);Ig(a, d);
  }, enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternalFiber;var c = Gg(),
        d = Dg.suspense;
    c = Hg(c, a, d);d = wg(c, d);d.tag = 2;void 0 !== b && null !== b && (d.callback = b);xg(a, d);Ig(a, c);
  } };function Kg(a, b, c, d, e, f, g) {
  a = a.stateNode;return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
  var d = !1,
      e = Af;var f = b.contextType;"object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);b = new b(c, f);a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;b.updater = Jg;a.stateNode = b;b._reactInternalFiber = a;d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);return b;
}
function Mg(a, b, c, d) {
  a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
  var e = a.stateNode;e.props = c;e.state = a.memoizedState;e.refs = Eg;ug(a);var f = b.contextType;"object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));zg(a, c, e, d);e.state = a.memoizedState;f = b.getDerivedStateFromProps;"function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);"function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);"function" === typeof e.componentDidMount && (a.effectTag |= 4);
}var Og = Array.isArray;
function Pg(a, b, c) {
  a = c.ref;if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) {
    if (c._owner) {
      c = c._owner;if (c) {
        if (1 !== c.tag) throw Error(u(309));var d = c.stateNode;
      }if (!d) throw Error(u(147, a));var e = "" + a;if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;b = function b(a) {
        var b = d.refs;b === Eg && (b = d.refs = {});null === a ? delete b[e] : b[e] = a;
      };b._stringRef = e;return b;
    }if ("string" !== typeof a) throw Error(u(284));if (!c._owner) throw Error(u(290, a));
  }return a;
}
function Qg(a, b) {
  if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;
    }
  }function c(c, d) {
    if (!a) return null;for (; null !== d;) {
      b(c, d), d = d.sibling;
    }return null;
  }function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }return a;
  }function e(a, b) {
    a = Sg(a, b);a.index = 0;a.sibling = null;return a;
  }function f(b, c, d) {
    b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;b.effectTag = 2;return c;
  }function g(b) {
    a && null === b.alternate && (b.effectTag = 2);return b;
  }function h(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;b = e(b, c);b.return = a;return b;
  }function k(a, b, c, d) {
    if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;d = Ug(c.type, c.key, c.props, null, a.mode, d);d.ref = Pg(a, b, c);d.return = a;return d;
  }function l(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;b = e(b, c.children || []);b.return = a;return b;
  }function m(a, b, c, d, f) {
    if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;b = e(b, c);b.return = a;return b;
  }function p(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) {
      switch (b.$$typeof) {case Za:
          return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;case $a:
          return b = Vg(b, a.mode, c), b.return = a, b;}if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;Qg(a, b);
    }return null;
  }function x(a, b, c, d) {
    var e = null !== b ? b.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c) {
      switch (c.$$typeof) {case Za:
          return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;case $a:
          return c.key === e ? l(a, b, c, d) : null;}if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);Qg(a, c);
    }return null;
  }function z(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) {
      switch (d.$$typeof) {case Za:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);case $a:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);}if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);Qg(b, d);
    }return null;
  }function ca(e, g, h, k) {
    for (var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++) {
      m.index > y ? (A = m, m = null) : A = m.sibling;var q = x(e, m, h[y], k);if (null === q) {
        null === m && (m = A);break;
      }a && m && null === q.alternate && b(e, m);g = f(q, g, y);null === t ? l = q : t.sibling = q;t = q;m = A;
    }if (y === h.length) return c(e, m), l;if (null === m) {
      for (; y < h.length; y++) {
        m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
      }return l;
    }for (m = d(e, m); y < h.length; y++) {
      A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
    }a && m.forEach(function (a) {
      return b(e, a);
    });return l;
  }function D(e, g, h, l) {
    var k = nb(h);if ("function" !== typeof k) throw Error(u(150));h = k.call(h);
    if (null == h) throw Error(u(151));for (var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()) {
      t.index > y ? (A = t, t = null) : A = t.sibling;var D = x(e, t, q.value, l);if (null === D) {
        null === t && (t = A);break;
      }a && t && null === D.alternate && b(e, t);g = f(D, g, y);null === m ? k = D : m.sibling = D;m = D;t = A;
    }if (q.done) return c(e, t), k;if (null === t) {
      for (; !q.done; y++, q = h.next()) {
        q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
      }return k;
    }for (t = d(e, t); !q.done; y++, q = h.next()) {
      q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
    }a && t.forEach(function (a) {
      return b(e, a);
    });return k;
  }return function (a, d, f, h) {
    var k = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f && f.type === ab && null === f.key;k && (f = f.props.children);var l = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f;if (l) switch (f.$$typeof) {case Za:
        a: {
          l = f.key;for (k = d; null !== k;) {
            if (k.key === l) {
              switch (k.tag) {case 7:
                  if (f.type === ab) {
                    c(a, k.sibling);d = e(k, f.props.children);d.return = a;a = d;break a;
                  }break;default:
                  if (k.elementType === f.type) {
                    c(a, k.sibling);d = e(k, f.props);d.ref = Pg(a, k, f);d.return = a;a = d;break a;
                  }}c(a, k);break;
            } else b(a, k);k = k.sibling;
          }f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
        }return g(a);case $a:
        a: {
          for (k = f.key; null !== d;) {
            if (d.key === k) {
              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);d = e(d, f.children || []);d.return = a;a = d;break a;
              } else {
                c(a, d);break;
              }
            } else b(a, d);d = d.sibling;
          }d = Vg(f, a.mode, h);d.return = a;a = d;
        }return g(a);}if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);if (Og(f)) return ca(a, d, f, h);if (nb(f)) return D(a, d, f, h);l && Qg(a, f);if ("undefined" === typeof f && !k) switch (a.tag) {case 1:case 0:
        throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));}return c(a, d);
  };
}var Xg = Rg(!0),
    Yg = Rg(!1),
    Zg = {},
    $g = { current: Zg },
    ah = { current: Zg },
    bh = { current: Zg };
function ch(a) {
  if (a === Zg) throw Error(u(174));return a;
}function dh(a, b) {
  I(bh, b);I(ah, a);I($g, Zg);a = b.nodeType;switch (a) {case 9:case 11:
      b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");break;default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);}H($g);I($g, b);
}function eh() {
  H($g);H(ah);H(bh);
}function fh(a) {
  ch(bh.current);var b = ch($g.current);var c = Ob(b, a.type);b !== c && (I(ah, a), I($g, c));
}function gh(a) {
  ah.current === a && (H($g), H(ah));
}var M = { current: 0 };
function hh(a) {
  for (var b = a; null !== b;) {
    if (13 === b.tag) {
      var c = b.memoizedState;if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.effectTag & 64)) return b;
    } else if (null !== b.child) {
      b.child.return = b;b = b.child;continue;
    }if (b === a) break;for (; null === b.sibling;) {
      if (null === b.return || b.return === a) return null;b = b.return;
    }b.sibling.return = b.return;b = b.sibling;
  }return null;
}function ih(a, b) {
  return { responder: a, props: b };
}
var jh = Wa.ReactCurrentDispatcher,
    kh = Wa.ReactCurrentBatchConfig,
    lh = 0,
    N = null,
    O = null,
    P = null,
    mh = !1;function Q() {
  throw Error(u(321));
}function nh(a, b) {
  if (null === b) return !1;for (var c = 0; c < b.length && c < a.length; c++) {
    if (!$e(a[c], b[c])) return !1;
  }return !0;
}
function oh(a, b, c, d, e, f) {
  lh = f;N = b;b.memoizedState = null;b.updateQueue = null;b.expirationTime = 0;jh.current = null === a || null === a.memoizedState ? ph : qh;a = c(d, e);if (b.expirationTime === lh) {
    f = 0;do {
      b.expirationTime = 0;if (!(25 > f)) throw Error(u(301));f += 1;P = O = null;b.updateQueue = null;jh.current = rh;a = c(d, e);
    } while (b.expirationTime === lh);
  }jh.current = sh;b = null !== O && null !== O.next;lh = 0;P = O = N = null;mh = !1;if (b) throw Error(u(300));return a;
}
function th() {
  var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };null === P ? N.memoizedState = P = a : P = P.next = a;return P;
}function uh() {
  if (null === O) {
    var a = N.alternate;a = null !== a ? a.memoizedState : null;
  } else a = O.next;var b = null === P ? N.memoizedState : P.next;if (null !== b) P = b, O = a;else {
    if (null === a) throw Error(u(310));O = a;a = { memoizedState: O.memoizedState, baseState: O.baseState, baseQueue: O.baseQueue, queue: O.queue, next: null };null === P ? N.memoizedState = P = a : P = P.next = a;
  }return P;
}
function vh(a, b) {
  return "function" === typeof b ? b(a) : b;
}
function wh(a) {
  var b = uh(),
      c = b.queue;if (null === c) throw Error(u(311));c.lastRenderedReducer = a;var d = O,
      e = d.baseQueue,
      f = c.pending;if (null !== f) {
    if (null !== e) {
      var g = e.next;e.next = f.next;f.next = g;
    }d.baseQueue = e = f;c.pending = null;
  }if (null !== e) {
    e = e.next;d = d.baseState;var h = g = f = null,
        k = e;do {
      var l = k.expirationTime;if (l < lh) {
        var m = { expirationTime: k.expirationTime, suspenseConfig: k.suspenseConfig, action: k.action, eagerReducer: k.eagerReducer, eagerState: k.eagerState, next: null };null === h ? (g = h = m, f = d) : h = h.next = m;l > N.expirationTime && (N.expirationTime = l, Bg(l));
      } else null !== h && (h = h.next = { expirationTime: 1073741823, suspenseConfig: k.suspenseConfig, action: k.action, eagerReducer: k.eagerReducer, eagerState: k.eagerState, next: null }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);k = k.next;
    } while (null !== k && k !== e);null === h ? f = d : h.next = g;$e(d, b.memoizedState) || (rg = !0);b.memoizedState = d;b.baseState = f;b.baseQueue = h;c.lastRenderedState = d;
  }return [b.memoizedState, c.dispatch];
}
function xh(a) {
  var b = uh(),
      c = b.queue;if (null === c) throw Error(u(311));c.lastRenderedReducer = a;var d = c.dispatch,
      e = c.pending,
      f = b.memoizedState;if (null !== e) {
    c.pending = null;var g = e = e.next;do {
      f = a(f, g.action), g = g.next;
    } while (g !== e);$e(f, b.memoizedState) || (rg = !0);b.memoizedState = f;null === b.baseQueue && (b.baseState = f);c.lastRenderedState = f;
  }return [f, d];
}
function yh(a) {
  var b = th();"function" === typeof a && (a = a());b.memoizedState = b.baseState = a;a = b.queue = { pending: null, dispatch: null, lastRenderedReducer: vh, lastRenderedState: a };a = a.dispatch = zh.bind(null, N, a);return [b.memoizedState, a];
}function Ah(a, b, c, d) {
  a = { tag: a, create: b, destroy: c, deps: d, next: null };b = N.updateQueue;null === b ? (b = { lastEffect: null }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));return a;
}
function Bh() {
  return uh().memoizedState;
}function Ch(a, b, c, d) {
  var e = th();N.effectTag |= a;e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}function Dh(a, b, c, d) {
  var e = uh();d = void 0 === d ? null : d;var f = void 0;if (null !== O) {
    var g = O.memoizedState;f = g.destroy;if (null !== d && nh(d, g.deps)) {
      Ah(b, c, f, d);return;
    }
  }N.effectTag |= a;e.memoizedState = Ah(1 | b, c, f, d);
}function Eh(a, b) {
  return Ch(516, 4, a, b);
}function Fh(a, b) {
  return Dh(516, 4, a, b);
}function Gh(a, b) {
  return Dh(4, 2, a, b);
}
function Hh(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function () {
    b(null);
  };if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
    b.current = null;
  };
}function Ih(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;return Dh(4, 2, Hh.bind(null, b, a), c);
}function Jh() {}function Kh(a, b) {
  th().memoizedState = [a, void 0 === b ? null : b];return a;
}function Lh(a, b) {
  var c = uh();b = void 0 === b ? null : b;var d = c.memoizedState;if (null !== d && null !== b && nh(b, d[1])) return d[0];c.memoizedState = [a, b];return a;
}
function Mh(a, b) {
  var c = uh();b = void 0 === b ? null : b;var d = c.memoizedState;if (null !== d && null !== b && nh(b, d[1])) return d[0];a = a();c.memoizedState = [a, b];return a;
}function Nh(a, b, c) {
  var d = ag();cg(98 > d ? 98 : d, function () {
    a(!0);
  });cg(97 < d ? 97 : d, function () {
    var d = kh.suspense;kh.suspense = void 0 === b ? null : b;try {
      a(!1), c();
    } finally {
      kh.suspense = d;
    }
  });
}
function zh(a, b, c) {
  var d = Gg(),
      e = Dg.suspense;d = Hg(d, a, e);e = { expirationTime: d, suspenseConfig: e, action: c, eagerReducer: null, eagerState: null, next: null };var f = b.pending;null === f ? e.next = e : (e.next = f.next, f.next = e);b.pending = e;f = a.alternate;if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;else {
    if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
      var g = b.lastRenderedState,
          h = f(g, c);e.eagerReducer = f;e.eagerState = h;if ($e(h, g)) return;
    } catch (k) {} finally {}Ig(a, d);
  }
}
var sh = { readContext: sg, useCallback: Q, useContext: Q, useEffect: Q, useImperativeHandle: Q, useLayoutEffect: Q, useMemo: Q, useReducer: Q, useRef: Q, useState: Q, useDebugValue: Q, useResponder: Q, useDeferredValue: Q, useTransition: Q },
    ph = { readContext: sg, useCallback: Kh, useContext: sg, useEffect: Eh, useImperativeHandle: function useImperativeHandle(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;return Ch(4, 2, Hh.bind(null, b, a), c);
  }, useLayoutEffect: function useLayoutEffect(a, b) {
    return Ch(4, 2, a, b);
  }, useMemo: function useMemo(a, b) {
    var c = th();b = void 0 === b ? null : b;a = a();c.memoizedState = [a, b];return a;
  }, useReducer: function useReducer(a, b, c) {
    var d = th();b = void 0 !== c ? c(b) : b;d.memoizedState = d.baseState = b;a = d.queue = { pending: null, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };a = a.dispatch = zh.bind(null, N, a);return [d.memoizedState, a];
  }, useRef: function useRef(a) {
    var b = th();a = { current: a };return b.memoizedState = a;
  }, useState: yh, useDebugValue: Jh, useResponder: ih, useDeferredValue: function useDeferredValue(a, b) {
    var c = yh(a),
        d = c[0],
        e = c[1];Eh(function () {
      var c = kh.suspense;kh.suspense = void 0 === b ? null : b;try {
        e(a);
      } finally {
        kh.suspense = c;
      }
    }, [a, b]);return d;
  }, useTransition: function useTransition(a) {
    var b = yh(!1),
        c = b[0];b = b[1];return [Kh(Nh.bind(null, b, a), [b, a]), c];
  } },
    qh = { readContext: sg, useCallback: Lh, useContext: sg, useEffect: Fh, useImperativeHandle: Ih, useLayoutEffect: Gh, useMemo: Mh, useReducer: wh, useRef: Bh, useState: function useState() {
    return wh(vh);
  }, useDebugValue: Jh, useResponder: ih, useDeferredValue: function useDeferredValue(a, b) {
    var c = wh(vh),
        d = c[0],
        e = c[1];Fh(function () {
      var c = kh.suspense;kh.suspense = void 0 === b ? null : b;try {
        e(a);
      } finally {
        kh.suspense = c;
      }
    }, [a, b]);return d;
  }, useTransition: function useTransition(a) {
    var b = wh(vh),
        c = b[0];b = b[1];return [Lh(Nh.bind(null, b, a), [b, a]), c];
  } },
    rh = { readContext: sg, useCallback: Lh, useContext: sg, useEffect: Fh, useImperativeHandle: Ih, useLayoutEffect: Gh, useMemo: Mh, useReducer: xh, useRef: Bh, useState: function useState() {
    return xh(vh);
  }, useDebugValue: Jh, useResponder: ih, useDeferredValue: function useDeferredValue(a, b) {
    var c = xh(vh),
        d = c[0],
        e = c[1];Fh(function () {
      var c = kh.suspense;kh.suspense = void 0 === b ? null : b;try {
        e(a);
      } finally {
        kh.suspense = c;
      }
    }, [a, b]);return d;
  }, useTransition: function useTransition(a) {
    var b = xh(vh),
        c = b[0];b = b[1];return [Lh(Nh.bind(null, b, a), [b, a]), c];
  } },
    Oh = null,
    Ph = null,
    Qh = !1;function Rh(a, b) {
  var c = Sh(5, null, null, 0);c.elementType = "DELETED";c.type = "DELETED";c.stateNode = b;c.return = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
  switch (a.tag) {case 5:
      var c = a.type;b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;return null !== b ? (a.stateNode = b, !0) : !1;case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;case 13:
      return !1;default:
      return !1;}
}
function Uh(a) {
  if (Qh) {
    var b = Ph;if (b) {
      var c = b;if (!Th(a, b)) {
        b = Jd(c.nextSibling);if (!b || !Th(a, b)) {
          a.effectTag = a.effectTag & -1025 | 2;Qh = !1;Oh = a;return;
        }Rh(Oh, c);
      }Oh = a;Ph = Jd(b.firstChild);
    } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
  }
}function Vh(a) {
  for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
    a = a.return;
  }Oh = a;
}
function Wh(a) {
  if (a !== Oh) return !1;if (!Qh) return Vh(a), Qh = !0, !1;var b = a.type;if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for (b = Ph; b;) {
    Rh(a, b), b = Jd(b.nextSibling);
  }Vh(a);if (13 === a.tag) {
    a = a.memoizedState;a = null !== a ? a.dehydrated : null;if (!a) throw Error(u(317));a: {
      a = a.nextSibling;for (b = 0; a;) {
        if (8 === a.nodeType) {
          var c = a.data;if (c === Ad) {
            if (0 === b) {
              Ph = Jd(a.nextSibling);break a;
            }b--;
          } else c !== zd && c !== Cd && c !== Bd || b++;
        }a = a.nextSibling;
      }Ph = null;
    }
  } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;return !0;
}
function Xh() {
  Ph = Oh = null;Qh = !1;
}var Yh = Wa.ReactCurrentOwner,
    rg = !1;function R(a, b, c, d) {
  b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}function Zh(a, b, c, d, e) {
  c = c.render;var f = b.ref;qg(b, e);d = oh(a, b, c, d, f, e);if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);b.effectTag |= 1;R(a, b, d, e);return b.child;
}
function ai(a, b, c, d, e, f) {
  if (null === a) {
    var g = c.type;if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);a = Ug(c.type, null, d, null, b.mode, f);a.ref = b.ref;a.return = b;return b.child = a;
  }g = a.child;if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);b.effectTag |= 1;a = Sg(g, d);a.ref = b.ref;a.return = b;return b.child = a;
}
function ci(a, b, c, d, e, f) {
  return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}function ei(a, b) {
  var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}function di(a, b, c, d, e) {
  var f = L(c) ? Bf : J.current;f = Cf(b, f);qg(b, e);c = oh(a, b, c, d, f, e);if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);b.effectTag |= 1;R(a, b, c, e);return b.child;
}
function fi(a, b, c, d, e) {
  if (L(c)) {
    var f = !0;Gf(b);
  } else f = !1;qg(b, e);if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;else if (null === a) {
    var g = b.stateNode,
        h = b.memoizedProps;g.props = h;var k = g.context,
        l = c.contextType;"object" === (typeof l === "undefined" ? "undefined" : _typeof(l)) && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));var m = c.getDerivedStateFromProps,
        p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);tg = !1;var x = b.memoizedState;g.state = x;zg(b, d, g, e);k = b.memoizedState;h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
  } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === (typeof l === "undefined" ? "undefined" : _typeof(l)) && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
  ei(a, b);var g = 0 !== (b.effectTag & 64);if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);d = b.stateNode;Yh.current = b;var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();b.effectTag |= 1;null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);b.memoizedState = d.state;e && Hf(b, c, !0);return b.child;
}function hi(a) {
  var b = a.stateNode;b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);dh(a, b.containerInfo);
}
var ii = { dehydrated: null, retryTime: 0 };
function ji(a, b, c) {
  var d = b.mode,
      e = b.pendingProps,
      f = M.current,
      g = !1,
      h;(h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);I(M, f & 1);if (null === a) {
    void 0 !== e.fallback && Uh(b);if (g) {
      g = e.fallback;e = Wg(null, d, 0, null);e.return = b;if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) {
        a.return = e, a = a.sibling;
      }c = Wg(g, d, c, null);c.return = b;e.sibling = c;b.memoizedState = ii;b.child = e;return c;
    }d = e.children;b.memoizedState = null;return b.child = Yg(b, null, d, c);
  }if (null !== a.memoizedState) {
    a = a.child;d = a.sibling;if (g) {
      e = e.fallback;c = Sg(a, a.pendingProps);c.return = b;if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for (c.child = g; null !== g;) {
        g.return = c, g = g.sibling;
      }d = Sg(d, e);d.return = b;c.sibling = d;c.childExpirationTime = 0;b.memoizedState = ii;b.child = c;return d;
    }c = Xg(b, a.child, e.children, c);b.memoizedState = null;return b.child = c;
  }a = a.child;if (g) {
    g = e.fallback;e = Wg(null, d, 0, null);e.return = b;e.child = a;null !== a && (a.return = e);if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) {
      a.return = e, a = a.sibling;
    }c = Wg(g, d, c, null);c.return = b;e.sibling = c;c.effectTag |= 2;e.childExpirationTime = 0;b.memoizedState = ii;b.child = e;return c;
  }b.memoizedState = null;return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
  a.expirationTime < b && (a.expirationTime = b);var c = a.alternate;null !== c && c.expirationTime < b && (c.expirationTime = b);pg(a.return, b);
}function li(a, b, c, d, e, f) {
  var g = a.memoizedState;null === g ? a.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d, tail: c, tailExpiration: 0, tailMode: e, lastEffect: f } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
  var d = b.pendingProps,
      e = d.revealOrder,
      f = d.tail;R(a, b, d.children, c);d = M.current;if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;else {
    if (null !== a && 0 !== (a.effectTag & 64)) a: for (a = b.child; null !== a;) {
      if (13 === a.tag) null !== a.memoizedState && ki(a, c);else if (19 === a.tag) ki(a, c);else if (null !== a.child) {
        a.child.return = a;a = a.child;continue;
      }if (a === b) break a;for (; null === a.sibling;) {
        if (null === a.return || a.return === b) break a;a = a.return;
      }a.sibling.return = a.return;a = a.sibling;
    }d &= 1;
  }I(M, d);if (0 === (b.mode & 2)) b.memoizedState = null;else switch (e) {case "forwards":
      c = b.child;for (e = null; null !== c;) {
        a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
      }c = e;null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);li(b, !1, e, c, f, b.lastEffect);break;case "backwards":
      c = null;e = b.child;for (b.child = null; null !== e;) {
        a = e.alternate;if (null !== a && null === hh(a)) {
          b.child = e;break;
        }a = e.sibling;e.sibling = c;c = e;e = a;
      }li(b, !0, c, null, f, b.lastEffect);break;case "together":
      li(b, !1, null, null, void 0, b.lastEffect);break;default:
      b.memoizedState = null;}return b.child;
}
function $h(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);var d = b.expirationTime;0 !== d && Bg(d);if (b.childExpirationTime < c) return null;if (null !== a && b.child !== a.child) throw Error(u(153));if (null !== b.child) {
    a = b.child;c = Sg(a, a.pendingProps);b.child = c;for (c.return = b; null !== a.sibling;) {
      a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
    }c.sibling = null;
  }return b.child;
}var ni, oi, pi, qi;
ni = function ni(a, b) {
  for (var c = b.child; null !== c;) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
      c.child.return = c;c = c.child;continue;
    }if (c === b) break;for (; null === c.sibling;) {
      if (null === c.return || c.return === b) return;c = c.return;
    }c.sibling.return = c.return;c = c.sibling;
  }
};oi = function oi() {};
pi = function pi(a, b, c, d, e) {
  var f = a.memoizedProps;if (f !== d) {
    var g = b.stateNode;ch($g.current);a = null;switch (c) {case "input":
        f = zb(g, f);d = zb(g, d);a = [];break;case "option":
        f = Gb(g, f);d = Gb(g, d);a = [];break;case "select":
        f = n({}, f, { value: void 0 });d = n({}, d, { value: void 0 });a = [];break;case "textarea":
        f = Ib(g, f);d = Ib(g, d);a = [];break;default:
        "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);}od(c, d);var h, k;c = null;for (h in f) {
      if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) if ("style" === h) for (k in g = f[h], g) {
        g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
      } else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
    }for (h in d) {
      var l = d[h];g = null != f ? f[h] : void 0;if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) if ("style" === h) {
        if (g) {
          for (k in g) {
            !g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
          }for (k in l) {
            l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
          }
        } else c || (a || (a = []), a.push(h, c)), c = l;
      } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
    }c && (a = a || []).push("style", c);e = a;if (b.updateQueue = e) b.effectTag |= 4;
  }
};
qi = function qi(a, b, c, d) {
  c !== d && (b.effectTag |= 4);
};function ri(a, b) {
  switch (a.tailMode) {case "hidden":
      b = a.tail;for (var c = null; null !== b;) {
        null !== b.alternate && (c = b), b = b.sibling;
      }null === c ? a.tail = null : c.sibling = null;break;case "collapsed":
      c = a.tail;for (var d = null; null !== c;) {
        null !== c.alternate && (d = c), c = c.sibling;
      }null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;}
}
function si(a, b, c) {
  var d = b.pendingProps;switch (b.tag) {case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:
      return null;case 1:
      return L(b.type) && Df(), null;case 3:
      return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;case 5:
      gh(b);c = ch(bh.current);var e = b.type;if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);else {
        if (!d) {
          if (null === b.stateNode) throw Error(u(166));
          return null;
        }a = ch($g.current);if (Wh(b)) {
          d = b.stateNode;e = b.type;var f = b.memoizedProps;d[Md] = b;d[Nd] = f;switch (e) {case "iframe":case "object":case "embed":
              F("load", d);break;case "video":case "audio":
              for (a = 0; a < ac.length; a++) {
                F(ac[a], d);
              }break;case "source":
              F("error", d);break;case "img":case "image":case "link":
              F("error", d);F("load", d);break;case "form":
              F("reset", d);F("submit", d);break;case "details":
              F("toggle", d);break;case "input":
              Ab(d, f);F("invalid", d);rd(c, "onChange");break;case "select":
              d._wrapperState = { wasMultiple: !!f.multiple };F("invalid", d);rd(c, "onChange");break;case "textarea":
              Jb(d, f), F("invalid", d), rd(c, "onChange");}od(e, f);a = null;for (var g in f) {
            if (f.hasOwnProperty(g)) {
              var h = f[g];"children" === g ? "string" === typeof h ? d.textContent !== h && (a = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (a = ["children", "" + h]) : va.hasOwnProperty(g) && null != h && rd(c, g);
            }
          }switch (e) {case "input":
              xb(d);Eb(d, f, !0);break;case "textarea":
              xb(d);Lb(d);break;case "select":case "option":
              break;default:
              "function" === typeof f.onClick && (d.onclick = sd);}c = a;b.updateQueue = c;null !== c && (b.effectTag |= 4);
        } else {
          g = 9 === c.nodeType ? c : c.ownerDocument;a === qd && (a = Nb(e));a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, { is: d.is }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);a[Md] = b;a[Nd] = d;ni(a, b, !1, !1);b.stateNode = a;g = pd(e, d);switch (e) {case "iframe":case "object":case "embed":
              F("load", a);h = d;break;case "video":case "audio":
              for (h = 0; h < ac.length; h++) {
                F(ac[h], a);
              }h = d;break;case "source":
              F("error", a);h = d;break;case "img":case "image":case "link":
              F("error", a);F("load", a);h = d;break;case "form":
              F("reset", a);F("submit", a);h = d;break;case "details":
              F("toggle", a);h = d;break;case "input":
              Ab(a, d);h = zb(a, d);F("invalid", a);rd(c, "onChange");break;case "option":
              h = Gb(a, d);break;case "select":
              a._wrapperState = { wasMultiple: !!d.multiple };h = n({}, d, { value: void 0 });F("invalid", a);rd(c, "onChange");break;case "textarea":
              Jb(a, d);h = Ib(a, d);F("invalid", a);rd(c, "onChange");break;default:
              h = d;}od(e, h);var k = h;for (f in k) {
            if (k.hasOwnProperty(f)) {
              var l = k[f];"style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
            }
          }switch (e) {case "input":
              xb(a);Eb(a, d, !1);
              break;case "textarea":
              xb(a);Lb(a);break;case "option":
              null != d.value && a.setAttribute("value", "" + rb(d.value));break;case "select":
              a.multiple = !!d.multiple;c = d.value;null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);break;default:
              "function" === typeof h.onClick && (a.onclick = sd);}Fd(e, d) && (b.effectTag |= 4);
        }null !== b.ref && (b.effectTag |= 128);
      }return null;case 6:
      if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
        c = ch(bh.current);ch($g.current);Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
      }return null;case 13:
      H(M);d = b.memoizedState;if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;c = null !== d;d = !1;null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));if (c && !d && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);else {
        if (S === ti || S === ui) S = vi;0 !== wi && null !== T && (xi(T, U), yi(T, wi));
      }if (c || d) b.effectTag |= 4;return null;case 4:
      return eh(), oi(b), null;case 10:
      return og(b), null;case 17:
      return L(b.type) && Df(), null;case 19:
      H(M);d = b.memoizedState;if (null === d) return null;e = 0 !== (b.effectTag & 64);f = d.rendering;if (null === f) {
        if (e) ri(d, !1);else {
          if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for (f = b.child; null !== f;) {
            a = hh(f);if (null !== a) {
              b.effectTag |= 64;ri(d, !1);e = a.updateQueue;null !== e && (b.updateQueue = e, b.effectTag |= 4);null === d.lastEffect && (b.firstEffect = null);b.lastEffect = d.lastEffect;for (d = b.child; null !== d;) {
                e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : { expirationTime: f.expirationTime, firstContext: f.firstContext, responders: f.responders }), d = d.sibling;
              }I(M, M.current & 1 | 2);return b.child;
            }f = f.sibling;
          }
        }
      } else {
        if (!e) if (a = hh(f), null !== a) {
          if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
        } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
      }return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;}throw Error(u(156, b.tag));
}function zi(a) {
  switch (a.tag) {case 1:
      L(a.type) && Df();var b = a.effectTag;return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;case 3:
      eh();H(K);H(J);b = a.effectTag;if (0 !== (b & 64)) throw Error(u(285));a.effectTag = b & -4097 | 64;return a;case 5:
      return gh(a), null;case 13:
      return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;case 19:
      return H(M), null;case 4:
      return eh(), null;case 10:
      return og(a), null;default:
      return null;}
}function Ai(a, b) {
  return { value: a, source: b, stack: qb(b) };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;function Ci(a, b) {
  var c = b.source,
      d = b.stack;null === d && null !== c && (d = qb(c));null !== c && pb(c.type);b = b.value;null !== a && 1 === a.tag && pb(a.type);try {
    console.error(b);
  } catch (e) {
    setTimeout(function () {
      throw e;
    });
  }
}function Di(a, b) {
  try {
    b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
  } catch (c) {
    Ei(a, c);
  }
}function Fi(a) {
  var b = a.ref;if (null !== b) if ("function" === typeof b) try {
    b(null);
  } catch (c) {
    Ei(a, c);
  } else b.current = null;
}
function Gi(a, b) {
  switch (b.tag) {case 0:case 11:case 15:case 22:
      return;case 1:
      if (b.effectTag & 256 && null !== a) {
        var c = a.memoizedProps,
            d = a.memoizedState;a = b.stateNode;b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);a.__reactInternalSnapshotBeforeUpdate = b;
      }return;case 3:case 5:case 6:case 4:case 17:
      return;}throw Error(u(163));
}
function Hi(a, b) {
  b = b.updateQueue;b = null !== b ? b.lastEffect : null;if (null !== b) {
    var c = b = b.next;do {
      if ((c.tag & a) === a) {
        var d = c.destroy;c.destroy = void 0;void 0 !== d && d();
      }c = c.next;
    } while (c !== b);
  }
}function Ii(a, b) {
  b = b.updateQueue;b = null !== b ? b.lastEffect : null;if (null !== b) {
    var c = b = b.next;do {
      if ((c.tag & a) === a) {
        var d = c.create;c.destroy = d();
      }c = c.next;
    } while (c !== b);
  }
}
function Ji(a, b, c) {
  switch (c.tag) {case 0:case 11:case 15:case 22:
      Ii(3, c);return;case 1:
      a = c.stateNode;if (c.effectTag & 4) if (null === b) a.componentDidMount();else {
        var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
      }b = c.updateQueue;null !== b && Cg(c, b, a);return;case 3:
      b = c.updateQueue;if (null !== b) {
        a = null;if (null !== c.child) switch (c.child.tag) {case 5:
            a = c.child.stateNode;break;case 1:
            a = c.child.stateNode;}Cg(c, b, a);
      }return;
    case 5:
      a = c.stateNode;null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();return;case 6:
      return;case 4:
      return;case 12:
      return;case 13:
      null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));return;case 19:case 17:case 20:case 21:
      return;}throw Error(u(163));
}
function Ki(a, b, c) {
  "function" === typeof Li && Li(b);switch (b.tag) {case 0:case 11:case 14:case 15:case 22:
      a = b.updateQueue;if (null !== a && (a = a.lastEffect, null !== a)) {
        var d = a.next;cg(97 < c ? 97 : c, function () {
          var a = d;do {
            var c = a.destroy;if (void 0 !== c) {
              var g = b;try {
                c();
              } catch (h) {
                Ei(g, h);
              }
            }a = a.next;
          } while (a !== d);
        });
      }break;case 1:
      Fi(b);c = b.stateNode;"function" === typeof c.componentWillUnmount && Di(b, c);break;case 5:
      Fi(b);break;case 4:
      Mi(a, b, c);}
}
function Ni(a) {
  var b = a.alternate;a.return = null;a.child = null;a.memoizedState = null;a.updateQueue = null;a.dependencies = null;a.alternate = null;a.firstEffect = null;a.lastEffect = null;a.pendingProps = null;a.memoizedProps = null;a.stateNode = null;null !== b && Ni(b);
}function Oi(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
  a: {
    for (var b = a.return; null !== b;) {
      if (Oi(b)) {
        var c = b;break a;
      }b = b.return;
    }throw Error(u(160));
  }b = c.stateNode;switch (c.tag) {case 5:
      var d = !1;break;case 3:
      b = b.containerInfo;d = !0;break;case 4:
      b = b.containerInfo;d = !0;break;default:
      throw Error(u(161));}c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);a: b: for (c = a;;) {
    for (; null === c.sibling;) {
      if (null === c.return || Oi(c.return)) {
        c = null;break a;
      }c = c.return;
    }c.sibling.return = c.return;for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
      if (c.effectTag & 2) continue b;
      if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
    }if (!(c.effectTag & 2)) {
      c = c.stateNode;break a;
    }
  }d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
  var d = a.tag,
      e = 5 === d || 6 === d;if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));else if (4 !== d && (a = a.child, null !== a)) for (Qi(a, b, c), a = a.sibling; null !== a;) {
    Qi(a, b, c), a = a.sibling;
  }
}
function Ri(a, b, c) {
  var d = a.tag,
      e = 5 === d || 6 === d;if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (Ri(a, b, c), a = a.sibling; null !== a;) {
    Ri(a, b, c), a = a.sibling;
  }
}
function Mi(a, b, c) {
  for (var d = b, e = !1, f, g;;) {
    if (!e) {
      e = d.return;a: for (;;) {
        if (null === e) throw Error(u(160));f = e.stateNode;switch (e.tag) {case 5:
            g = !1;break a;case 3:
            f = f.containerInfo;g = !0;break a;case 4:
            f = f.containerInfo;g = !0;break a;}e = e.return;
      }e = !0;
    }if (5 === d.tag || 6 === d.tag) {
      a: for (var h = a, k = d, l = c, m = k;;) {
        if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;else {
          if (m === k) break a;for (; null === m.sibling;) {
            if (null === m.return || m.return === k) break a;m = m.return;
          }m.sibling.return = m.return;m = m.sibling;
        }
      }g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
    } else if (4 === d.tag) {
      if (null !== d.child) {
        f = d.stateNode.containerInfo;g = !0;d.child.return = d;d = d.child;continue;
      }
    } else if (Ki(a, d, c), null !== d.child) {
      d.child.return = d;d = d.child;continue;
    }if (d === b) break;for (; null === d.sibling;) {
      if (null === d.return || d.return === b) return;d = d.return;4 === d.tag && (e = !1);
    }d.sibling.return = d.return;d = d.sibling;
  }
}
function Si(a, b) {
  switch (b.tag) {case 0:case 11:case 14:case 15:case 22:
      Hi(3, b);return;case 1:
      return;case 5:
      var c = b.stateNode;if (null != c) {
        var d = b.memoizedProps,
            e = null !== a ? a.memoizedProps : d;a = b.type;var f = b.updateQueue;b.updateQueue = null;if (null !== f) {
          c[Nd] = d;"input" === a && "radio" === d.type && null != d.name && Bb(c, d);pd(a, e);b = pd(a, d);for (e = 0; e < f.length; e += 2) {
            var g = f[e],
                h = f[e + 1];"style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
          }switch (a) {case "input":
              Cb(c, d);break;
            case "textarea":
              Kb(c, d);break;case "select":
              b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));}
        }
      }return;case 6:
      if (null === b.stateNode) throw Error(u(162));b.stateNode.nodeValue = b.memoizedProps;return;case 3:
      b = b.stateNode;b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));return;case 12:
      return;case 13:
      c = b;null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());if (null !== c) a: for (a = c;;) {
        if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
          f = a.child.sibling;f.return = a;a = f;continue;
        } else if (null !== a.child) {
          a.child.return = a;a = a.child;continue;
        }if (a === c) break;for (; null === a.sibling;) {
          if (null === a.return || a.return === c) break a;a = a.return;
        }a.sibling.return = a.return;a = a.sibling;
      }Ui(b);return;case 19:
      Ui(b);return;case 17:
      return;}throw Error(u(163));
}function Ui(a) {
  var b = a.updateQueue;if (null !== b) {
    a.updateQueue = null;var c = a.stateNode;null === c && (c = a.stateNode = new Bi());b.forEach(function (b) {
      var d = Vi.bind(null, a, b);c.has(b) || (c.add(b), b.then(d, d));
    });
  }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;function Xi(a, b, c) {
  c = wg(c, null);c.tag = 3;c.payload = { element: null };var d = b.value;c.callback = function () {
    Yi || (Yi = !0, Zi = d);Ci(a, b);
  };return c;
}
function $i(a, b, c) {
  c = wg(c, null);c.tag = 3;var d = a.type.getDerivedStateFromError;if ("function" === typeof d) {
    var e = b.value;c.payload = function () {
      Ci(a, b);return d(e);
    };
  }var f = a.stateNode;null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
    "function" !== typeof d && (null === aj ? aj = new Set([this]) : aj.add(this), Ci(a, b));var c = b.stack;this.componentDidCatch(b.value, { componentStack: null !== c ? c : "" });
  });return c;
}
var bj = Math.ceil,
    cj = Wa.ReactCurrentDispatcher,
    dj = Wa.ReactCurrentOwner,
    V = 0,
    ej = 8,
    fj = 16,
    gj = 32,
    ti = 0,
    hj = 1,
    ij = 2,
    ui = 3,
    vi = 4,
    jj = 5,
    W = V,
    T = null,
    X = null,
    U = 0,
    S = ti,
    kj = null,
    lj = 1073741823,
    mj = 1073741823,
    nj = null,
    wi = 0,
    oj = !1,
    Ti = 0,
    pj = 500,
    Y = null,
    Yi = !1,
    Zi = null,
    aj = null,
    qj = !1,
    rj = null,
    sj = 90,
    tj = null,
    uj = 0,
    vj = null,
    wj = 0;function Gg() {
  return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
  b = b.mode;if (0 === (b & 2)) return 1073741823;var d = ag();if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;if ((W & fj) !== V) return U;if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);else switch (d) {case 99:
      a = 1073741823;break;case 98:
      a = hg(a, 150, 100);break;case 97:case 96:
      a = hg(a, 5E3, 250);break;case 95:
      a = 2;break;default:
      throw Error(u(326));}null !== T && a === U && --a;return a;
}
function Ig(a, b) {
  if (50 < uj) throw uj = 0, vj = null, Error(u(185));a = xj(a, b);if (null !== a) {
    var c = ag();1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);(W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([[a, b]]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
  }
}
function xj(a, b) {
  a.expirationTime < b && (a.expirationTime = b);var c = a.alternate;null !== c && c.expirationTime < b && (c.expirationTime = b);var d = a.return,
      e = null;if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {
    c = d.alternate;d.childExpirationTime < b && (d.childExpirationTime = b);null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);if (null === d.return && 3 === d.tag) {
      e = d.stateNode;break;
    }d = d.return;
  }null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));return e;
}
function zj(a) {
  var b = a.lastExpiredTime;if (0 !== b) return b;b = a.firstPendingTime;if (!Aj(a, b)) return b;var c = a.lastPingedTime;a = a.nextKnownPendingLevel;a = c > a ? c : a;return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
  if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));else {
    var b = zj(a),
        c = a.callbackNode;if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);else {
      var d = Gg();1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);if (null !== c) {
        var e = a.callbackPriority;if (a.callbackExpirationTime === b && e >= d) return;c !== Tf && Kf(c);
      }a.callbackExpirationTime = b;a.callbackPriority = d;b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), { timeout: 10 * (1073741821 - b) - $f() });a.callbackNode = b;
    }
  }
}
function Bj(a, b) {
  wj = 0;if (b) return b = Gg(), Cj(a, b), Z(a), null;var c = zj(a);if (0 !== c) {
    b = a.callbackNode;if ((W & (fj | gj)) !== V) throw Error(u(327));Dj();a === T && c === U || Ej(a, c);if (null !== X) {
      var d = W;W |= fj;var e = Fj();do {
        try {
          Gj();break;
        } catch (h) {
          Hj(a, h);
        }
      } while (1);ng();W = d;cj.current = e;if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;if (null === X) switch (e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d) {case ti:case hj:
          throw Error(u(345));case ij:
          Cj(a, 2 < c ? 2 : c);break;case ui:
          xi(a, c);d = a.lastSuspendedTime;
          c === d && (a.nextKnownPendingLevel = Ij(e));if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
            if (oj) {
              var f = a.lastPingedTime;if (0 === f || f >= c) {
                a.lastPingedTime = c;Ej(a, c);break;
              }
            }f = zj(a);if (0 !== f && f !== c) break;if (0 !== d && d !== c) {
              a.lastPingedTime = d;break;
            }a.timeoutHandle = Hd(Jj.bind(null, a), e);break;
          }Jj(a);break;case vi:
          xi(a, c);d = a.lastSuspendedTime;c === d && (a.nextKnownPendingLevel = Ij(e));if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
            a.lastPingedTime = c;Ej(a, c);break;
          }e = zj(a);if (0 !== e && e !== c) break;if (0 !== d && d !== c) {
            a.lastPingedTime = d;break;
          }1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));if (10 < d) {
            a.timeoutHandle = Hd(Jj.bind(null, a), d);break;
          }Jj(a);break;case jj:
          if (1073741823 !== lj && null !== nj) {
            f = lj;var g = nj;d = g.busyMinDurationMs | 0;0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);if (10 < d) {
              xi(a, c);a.timeoutHandle = Hd(Jj.bind(null, a), d);break;
            }
          }Jj(a);break;default:
          throw Error(u(329));}Z(a);if (a.callbackNode === b) return Bj.bind(null, a);
    }
  }return null;
}
function yj(a) {
  var b = a.lastExpiredTime;b = 0 !== b ? b : 1073741823;if ((W & (fj | gj)) !== V) throw Error(u(327));Dj();a === T && b === U || Ej(a, b);if (null !== X) {
    var c = W;W |= fj;var d = Fj();do {
      try {
        Kj();break;
      } catch (e) {
        Hj(a, e);
      }
    } while (1);ng();W = c;cj.current = d;if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;if (null !== X) throw Error(u(261));a.finishedWork = a.current.alternate;a.finishedExpirationTime = b;T = null;Jj(a);Z(a);
  }return null;
}function Lj() {
  if (null !== tj) {
    var a = tj;tj = null;a.forEach(function (a, c) {
      Cj(c, a);Z(c);
    });gg();
  }
}
function Mj(a, b) {
  var c = W;W |= 1;try {
    return a(b);
  } finally {
    W = c, W === V && gg();
  }
}function Nj(a, b) {
  var c = W;W &= -2;W |= ej;try {
    return a(b);
  } finally {
    W = c, W === V && gg();
  }
}
function Ej(a, b) {
  a.finishedWork = null;a.finishedExpirationTime = 0;var c = a.timeoutHandle;-1 !== c && (a.timeoutHandle = -1, Id(c));if (null !== X) for (c = X.return; null !== c;) {
    var d = c;switch (d.tag) {case 1:
        d = d.type.childContextTypes;null !== d && void 0 !== d && Df();break;case 3:
        eh();H(K);H(J);break;case 5:
        gh(d);break;case 4:
        eh();break;case 13:
        H(M);break;case 19:
        H(M);break;case 10:
        og(d);}c = c.return;
  }T = a;X = Sg(a.current, null);U = b;S = ti;kj = null;mj = lj = 1073741823;nj = null;wi = 0;oj = !1;
}
function Hj(a, b) {
  do {
    try {
      ng();jh.current = sh;if (mh) for (var c = N.memoizedState; null !== c;) {
        var d = c.queue;null !== d && (d.pending = null);c = c.next;
      }lh = 0;P = O = N = null;mh = !1;if (null === X || null === X.return) return S = hj, kj = b, X = null;a: {
        var e = a,
            f = X.return,
            g = X,
            h = b;b = U;g.effectTag |= 2048;g.firstEffect = g.lastEffect = null;if (null !== h && "object" === (typeof h === "undefined" ? "undefined" : _typeof(h)) && "function" === typeof h.then) {
          var k = h;if (0 === (g.mode & 2)) {
            var l = g.alternate;l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
          }var m = 0 !== (M.current & 1),
              p = f;do {
            var x;if (x = 13 === p.tag) {
              var z = p.memoizedState;if (null !== z) x = null !== z.dehydrated ? !0 : !1;else {
                var ca = p.memoizedProps;x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
              }
            }if (x) {
              var D = p.updateQueue;if (null === D) {
                var t = new Set();t.add(k);p.updateQueue = t;
              } else D.add(k);if (0 === (p.mode & 2)) {
                p.effectTag |= 64;g.effectTag &= -2981;if (1 === g.tag) if (null === g.alternate) g.tag = 17;else {
                  var y = wg(1073741823, null);y.tag = 2;xg(g, y);
                }g.expirationTime = 1073741823;
                break a;
              }h = void 0;g = b;var A = e.pingCache;null === A ? (A = e.pingCache = new Wi(), h = new Set(), A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set(), A.set(k, h)));if (!h.has(g)) {
                h.add(g);var q = Oj.bind(null, e, k, g);k.then(q, q);
              }p.effectTag |= 4096;p.expirationTime = b;break a;
            }p = p.return;
          } while (null !== p);h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
        }S !== jj && (S = ij);h = Ai(h, g);p = f;do {
          switch (p.tag) {case 3:
              k = h;p.effectTag |= 4096;p.expirationTime = b;var B = Xi(p, k, b);yg(p, B);break a;case 1:
              k = h;var w = p.type,
                  ub = p.stateNode;if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                p.effectTag |= 4096;p.expirationTime = b;var vb = $i(p, k, b);yg(p, vb);break a;
              }}p = p.return;
        } while (null !== p);
      }X = Pj(X);
    } catch (Xc) {
      b = Xc;continue;
    }break;
  } while (1);
}
function Fj() {
  var a = cj.current;cj.current = sh;return null === a ? sh : a;
}function Ag(a, b) {
  a < lj && 2 < a && (lj = a);null !== b && a < mj && 2 < a && (mj = a, nj = b);
}function Bg(a) {
  a > wi && (wi = a);
}function Kj() {
  for (; null !== X;) {
    X = Qj(X);
  }
}function Gj() {
  for (; null !== X && !Uf();) {
    X = Qj(X);
  }
}function Qj(a) {
  var b = Rj(a.alternate, a, U);a.memoizedProps = a.pendingProps;null === b && (b = Pj(a));dj.current = null;return b;
}
function Pj(a) {
  X = a;do {
    var b = X.alternate;a = X.return;if (0 === (X.effectTag & 2048)) {
      b = si(b, X, U);if (1 === U || 1 !== X.childExpirationTime) {
        for (var c = 0, d = X.child; null !== d;) {
          var e = d.expirationTime,
              f = d.childExpirationTime;e > c && (c = e);f > c && (c = f);d = d.sibling;
        }X.childExpirationTime = c;
      }if (null !== b) return b;null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
    } else {
      b = zi(X);if (null !== b) return b.effectTag &= 2047, b;null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
    }b = X.sibling;if (null !== b) return b;X = a;
  } while (null !== X);S === ti && (S = jj);return null;
}function Ij(a) {
  var b = a.expirationTime;a = a.childExpirationTime;return b > a ? b : a;
}function Jj(a) {
  var b = ag();cg(99, Sj.bind(null, a, b));return null;
}
function Sj(a, b) {
  do {
    Dj();
  } while (null !== rj);if ((W & (fj | gj)) !== V) throw Error(u(327));var c = a.finishedWork,
      d = a.finishedExpirationTime;if (null === c) return null;a.finishedWork = null;a.finishedExpirationTime = 0;if (c === a.current) throw Error(u(177));a.callbackNode = null;a.callbackExpirationTime = 0;a.callbackPriority = 90;a.nextKnownPendingLevel = 0;var e = Ij(c);a.firstPendingTime = e;d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);d <= a.lastPingedTime && (a.lastPingedTime = 0);d <= a.lastExpiredTime && (a.lastExpiredTime = 0);a === T && (X = T = null, U = 0);1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;if (null !== e) {
    var f = W;W |= gj;dj.current = null;Dd = fd;var g = xd();if (yd(g)) {
      if ("selectionStart" in g) var h = { start: g.selectionStart, end: g.selectionEnd };else a: {
        h = (h = g.ownerDocument) && h.defaultView || window;var k = h.getSelection && h.getSelection();if (k && 0 !== k.rangeCount) {
          h = k.anchorNode;var l = k.anchorOffset,
              m = k.focusNode;k = k.focusOffset;try {
            h.nodeType, m.nodeType;
          } catch (wb) {
            h = null;break a;
          }var p = 0,
              x = -1,
              z = -1,
              ca = 0,
              D = 0,
              t = g,
              y = null;b: for (;;) {
            for (var A;;) {
              t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);3 === t.nodeType && (p += t.nodeValue.length);if (null === (A = t.firstChild)) break;y = t;t = A;
            }for (;;) {
              if (t === g) break b;y === h && ++ca === l && (x = p);y === m && ++D === k && (z = p);if (null !== (A = t.nextSibling)) break;t = y;y = t.parentNode;
            }t = A;
          }h = -1 === x || -1 === z ? null : { start: x, end: z };
        } else h = null;
      }h = h || { start: 0, end: 0 };
    } else h = null;Ed = { activeElementDetached: null, focusedElem: g, selectionRange: h };fd = !1;Y = e;do {
      try {
        Tj();
      } catch (wb) {
        if (null === Y) throw Error(u(330));Ei(Y, wb);Y = Y.nextEffect;
      }
    } while (null !== Y);Y = e;do {
      try {
        for (g = a, h = b; null !== Y;) {
          var q = Y.effectTag;q & 16 && Rb(Y.stateNode, "");if (q & 128) {
            var B = Y.alternate;if (null !== B) {
              var w = B.ref;null !== w && ("function" === typeof w ? w(null) : w.current = null);
            }
          }switch (q & 1038) {case 2:
              Pi(Y);Y.effectTag &= -3;break;case 6:
              Pi(Y);Y.effectTag &= -3;Si(Y.alternate, Y);break;case 1024:
              Y.effectTag &= -1025;break;case 1028:
              Y.effectTag &= -1025;Si(Y.alternate, Y);break;case 4:
              Si(Y.alternate, Y);break;case 8:
              l = Y, Mi(g, l, h), Ni(l);}Y = Y.nextEffect;
        }
      } catch (wb) {
        if (null === Y) throw Error(u(330));Ei(Y, wb);Y = Y.nextEffect;
      }
    } while (null !== Y);w = Ed;B = xd();q = w.focusedElem;h = w.selectionRange;if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
      null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));B = [];for (w = q; w = w.parentNode;) {
        1 === w.nodeType && B.push({ element: w, left: w.scrollLeft,
          top: w.scrollTop });
      }"function" === typeof q.focus && q.focus();for (q = 0; q < B.length; q++) {
        w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
      }
    }fd = !!Dd;Ed = Dd = null;a.current = c;Y = e;do {
      try {
        for (q = a; null !== Y;) {
          var ub = Y.effectTag;ub & 36 && Ji(q, Y.alternate, Y);if (ub & 128) {
            B = void 0;var vb = Y.ref;if (null !== vb) {
              var Xc = Y.stateNode;switch (Y.tag) {case 5:
                  B = Xc;break;default:
                  B = Xc;}"function" === typeof vb ? vb(B) : vb.current = B;
            }
          }Y = Y.nextEffect;
        }
      } catch (wb) {
        if (null === Y) throw Error(u(330));Ei(Y, wb);Y = Y.nextEffect;
      }
    } while (null !== Y);Y = null;Vf();W = f;
  } else a.current = c;if (qj) qj = !1, rj = a, sj = b;else for (Y = e; null !== Y;) {
    b = Y.nextEffect, Y.nextEffect = null, Y = b;
  }b = a.firstPendingTime;0 === b && (aj = null);1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;"function" === typeof Uj && Uj(c.stateNode, d);Z(a);if (Yi) throw Yi = !1, a = Zi, Zi = null, a;if ((W & ej) !== V) return null;gg();return null;
}function Tj() {
  for (; null !== Y;) {
    var a = Y.effectTag;0 !== (a & 256) && Gi(Y.alternate, Y);0 === (a & 512) || qj || (qj = !0, dg(97, function () {
      Dj();return null;
    }));Y = Y.nextEffect;
  }
}
function Dj() {
  if (90 !== sj) {
    var a = 97 < sj ? 97 : sj;sj = 90;return cg(a, Vj);
  }
}function Vj() {
  if (null === rj) return !1;var a = rj;rj = null;if ((W & (fj | gj)) !== V) throw Error(u(331));var b = W;W |= gj;for (a = a.current.firstEffect; null !== a;) {
    try {
      var c = a;if (0 !== (c.effectTag & 512)) switch (c.tag) {case 0:case 11:case 15:case 22:
          Hi(5, c), Ii(5, c);}
    } catch (d) {
      if (null === a) throw Error(u(330));Ei(a, d);
    }c = a.nextEffect;a.nextEffect = null;a = c;
  }W = b;gg();return !0;
}
function Wj(a, b, c) {
  b = Ai(c, b);b = Xi(a, b, 1073741823);xg(a, b);a = xj(a, 1073741823);null !== a && Z(a);
}function Ei(a, b) {
  if (3 === a.tag) Wj(a, a, b);else for (var c = a.return; null !== c;) {
    if (3 === c.tag) {
      Wj(c, a, b);break;
    } else if (1 === c.tag) {
      var d = c.stateNode;if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
        a = Ai(b, a);a = $i(c, a, 1073741823);xg(c, a);c = xj(c, 1073741823);null !== c && Z(c);break;
      }
    }c = c.return;
  }
}
function Oj(a, b, c) {
  var d = a.pingCache;null !== d && d.delete(b);T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}function Vi(a, b) {
  var c = a.stateNode;null !== c && c.delete(b);b = 0;0 === b && (b = Gg(), b = Hg(b, a, null));a = xj(a, b);null !== a && Z(a);
}var Rj;
Rj = function Rj(a, b, c) {
  var d = b.expirationTime;if (null !== a) {
    var e = b.pendingProps;if (a.memoizedProps !== e || K.current) rg = !0;else {
      if (d < c) {
        rg = !1;switch (b.tag) {case 3:
            hi(b);Xh();break;case 5:
            fh(b);if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;break;case 1:
            L(b.type) && Gf(b);break;case 4:
            dh(b, b.stateNode.containerInfo);break;case 10:
            d = b.memoizedProps.value;e = b.type._context;I(jg, e._currentValue);e._currentValue = d;break;case 13:
            if (null !== b.memoizedState) {
              d = b.child.childExpirationTime;
              if (0 !== d && d >= c) return ji(a, b, c);I(M, M.current & 1);b = $h(a, b, c);return null !== b ? b.sibling : null;
            }I(M, M.current & 1);break;case 19:
            d = b.childExpirationTime >= c;if (0 !== (a.effectTag & 64)) {
              if (d) return mi(a, b, c);b.effectTag |= 64;
            }e = b.memoizedState;null !== e && (e.rendering = null, e.tail = null);I(M, M.current);if (!d) return null;}return $h(a, b, c);
      }rg = !1;
    }
  } else rg = !1;b.expirationTime = 0;switch (b.tag) {case 2:
      d = b.type;null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);a = b.pendingProps;e = Cf(b, J.current);qg(b, c);e = oh(null, b, d, a, e, c);b.effectTag |= 1;if ("object" === (typeof e === "undefined" ? "undefined" : _typeof(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
        b.tag = 1;b.memoizedState = null;b.updateQueue = null;if (L(d)) {
          var f = !0;Gf(b);
        } else f = !1;b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;ug(b);var g = d.getDerivedStateFromProps;"function" === typeof g && Fg(b, d, g, a);e.updater = Jg;b.stateNode = e;e._reactInternalFiber = b;Ng(b, d, a, c);b = gi(null, b, d, !0, f, c);
      } else b.tag = 0, R(null, b, e, c), b = b.child;return b;case 16:
      a: {
        e = b.elementType;null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);a = b.pendingProps;ob(e);if (1 !== e._status) throw e._result;e = e._result;b.type = e;f = b.tag = Xj(e);a = ig(e, a);switch (f) {case 0:
            b = di(null, b, e, a, c);break a;case 1:
            b = fi(null, b, e, a, c);break a;case 11:
            b = Zh(null, b, e, a, c);break a;case 14:
            b = ai(null, b, e, ig(e.type, a), d, c);break a;}throw Error(u(306, e, ""));
      }return b;case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
    case 3:
      hi(b);d = b.updateQueue;if (null === a || null === d) throw Error(u(282));d = b.pendingProps;e = b.memoizedState;e = null !== e ? e.element : null;vg(a, b);zg(b, d, null, c);d = b.memoizedState.element;if (d === e) Xh(), b = $h(a, b, c);else {
        if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;if (e) for (c = Yg(b, null, d, c), b.child = c; c;) {
          c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
        } else R(a, b, d, c), Xh();b = b.child;
      }return b;case 5:
      return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;case 6:
      return null === a && Uh(b), null;case 13:
      return ji(a, b, c);case 4:
      return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);case 7:
      return R(a, b, b.pendingProps, c), b.child;case 8:
      return R(a, b, b.pendingProps.children, c), b.child;case 12:
      return R(a, b, b.pendingProps.children, c), b.child;case 10:
      a: {
        d = b.type._context;e = b.pendingProps;g = b.memoizedProps;f = e.value;var h = b.type._context;I(jg, h._currentValue);h._currentValue = f;if (null !== g) if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
          if (g.children === e.children && !K.current) {
            b = $h(a, b, c);break a;
          }
        } else for (h = b.child, null !== h && (h.return = b); null !== h;) {
          var k = h.dependencies;if (null !== k) {
            g = h.child;for (var l = k.firstContext; null !== l;) {
              if (l.context === d && 0 !== (l.observedBits & f)) {
                1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));h.expirationTime < c && (h.expirationTime = c);l = h.alternate;null !== l && l.expirationTime < c && (l.expirationTime = c);pg(h.return, c);k.expirationTime < c && (k.expirationTime = c);break;
              }l = l.next;
            }
          } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;if (null !== g) g.return = h;else for (g = h; null !== g;) {
            if (g === b) {
              g = null;break;
            }h = g.sibling;if (null !== h) {
              h.return = g.return;g = h;break;
            }g = g.return;
          }h = g;
        }R(a, b, e.children, c);b = b.child;
      }return b;case 9:
      return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;case 14:
      return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);case 15:
      return ci(a, b, b.type, b.pendingProps, d, c);case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);case 19:
      return mi(a, b, c);}throw Error(u(156, b.tag));
};var Uj = null,
    Li = null;function Yj(a) {
  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {
    var c = b.inject(a);Uj = function Uj(a) {
      try {
        b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
      } catch (e) {}
    };Li = function Li(a) {
      try {
        b.onCommitFiberUnmount(c, a);
      } catch (e) {}
    };
  } catch (d) {}return !0;
}
function Zj(a, b, c, d) {
  this.tag = a;this.key = c;this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;this.index = 0;this.ref = null;this.pendingProps = b;this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.childExpirationTime = this.expirationTime = 0;this.alternate = null;
}function Sh(a, b, c, d) {
  return new Zj(a, b, c, d);
}
function bi(a) {
  a = a.prototype;return !(!a || !a.isReactComponent);
}function Xj(a) {
  if ("function" === typeof a) return bi(a) ? 1 : 0;if (void 0 !== a && null !== a) {
    a = a.$$typeof;if (a === gb) return 11;if (a === jb) return 14;
  }return 2;
}
function Sg(a, b) {
  var c = a.alternate;null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);c.childExpirationTime = a.childExpirationTime;c.expirationTime = a.expirationTime;c.child = a.child;c.memoizedProps = a.memoizedProps;c.memoizedState = a.memoizedState;c.updateQueue = a.updateQueue;b = a.dependencies;c.dependencies = null === b ? null : { expirationTime: b.expirationTime,
    firstContext: b.firstContext, responders: b.responders };c.sibling = a.sibling;c.index = a.index;c.ref = a.ref;return c;
}
function Ug(a, b, c, d, e, f) {
  var g = 2;d = a;if ("function" === typeof a) bi(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {case ab:
      return Wg(c.children, e, f, b);case fb:
      g = 8;e |= 7;break;case bb:
      g = 8;e |= 1;break;case cb:
      return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;case hb:
      return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;case ib:
      return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;default:
      if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) switch (a.$$typeof) {case db:
          g = 10;break a;case eb:
          g = 9;break a;case gb:
          g = 11;break a;case jb:
          g = 14;break a;case kb:
          g = 16;d = null;break a;case lb:
          g = 22;break a;}throw Error(u(130, null == a ? a : typeof a === "undefined" ? "undefined" : _typeof(a), ""));}b = Sh(g, c, b, e);b.elementType = a;b.type = d;b.expirationTime = f;return b;
}function Wg(a, b, c, d) {
  a = Sh(7, a, d, b);a.expirationTime = c;return a;
}function Tg(a, b, c) {
  a = Sh(6, a, null, b);a.expirationTime = c;return a;
}
function Vg(a, b, c) {
  b = Sh(4, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;
}
function ak(a, b, c) {
  this.tag = b;this.current = null;this.containerInfo = a;this.pingCache = this.pendingChildren = null;this.finishedExpirationTime = 0;this.finishedWork = null;this.timeoutHandle = -1;this.pendingContext = this.context = null;this.hydrate = c;this.callbackNode = null;this.callbackPriority = 90;this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
  var c = a.firstSuspendedTime;a = a.lastSuspendedTime;return 0 !== c && c >= b && a <= b;
}function xi(a, b) {
  var c = a.firstSuspendedTime,
      d = a.lastSuspendedTime;c < b && (a.firstSuspendedTime = b);if (d > b || 0 === c) a.lastSuspendedTime = b;b <= a.lastPingedTime && (a.lastPingedTime = 0);b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
  b > a.firstPendingTime && (a.firstPendingTime = b);var c = a.firstSuspendedTime;0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}function Cj(a, b) {
  var c = a.lastExpiredTime;if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
  var e = b.current,
      f = Gg(),
      g = Dg.suspense;f = Hg(f, e, g);a: if (c) {
    c = c._reactInternalFiber;b: {
      if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));var h = c;do {
        switch (h.tag) {case 3:
            h = h.stateNode.context;break b;case 1:
            if (L(h.type)) {
              h = h.stateNode.__reactInternalMemoizedMergedChildContext;break b;
            }}h = h.return;
      } while (null !== h);throw Error(u(171));
    }if (1 === c.tag) {
      var k = c.type;if (L(k)) {
        c = Ff(c, k, h);break a;
      }
    }c = h;
  } else c = Af;null === b.context ? b.context = c : b.pendingContext = c;b = wg(f, g);b.payload = { element: a };d = void 0 === d ? null : d;null !== d && (b.callback = d);xg(e, b);Ig(e, f);return f;
}function ck(a) {
  a = a.current;if (!a.child) return null;switch (a.child.tag) {case 5:
      return a.child.stateNode;default:
      return a.child.stateNode;}
}function dk(a, b) {
  a = a.memoizedState;null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}function ek(a, b) {
  dk(a, b);(a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
  c = null != c && !0 === c.hydrate;var d = new ak(a, b, c),
      e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);d.current = e;e.stateNode = d;ug(e);a[Od] = d.current;c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);this._internalRoot = d;
}fk.prototype.render = function (a) {
  bk(a, this._internalRoot, null, null);
};fk.prototype.unmount = function () {
  var a = this._internalRoot,
      b = a.containerInfo;bk(null, a, null, function () {
    b[Od] = null;
  });
};
function gk(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}function hk(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));if (!b) for (var c; c = a.lastChild;) {
    a.removeChild(c);
  }return new fk(a, 0, b ? { hydrate: !0 } : void 0);
}
function ik(a, b, c, d, e) {
  var f = c._reactRootContainer;if (f) {
    var g = f._internalRoot;if ("function" === typeof e) {
      var h = e;e = function e() {
        var a = ck(g);h.call(a);
      };
    }bk(b, g, a, e);
  } else {
    f = c._reactRootContainer = hk(c, d);g = f._internalRoot;if ("function" === typeof e) {
      var k = e;e = function e() {
        var a = ck(g);k.call(a);
      };
    }Nj(function () {
      bk(b, g, a, e);
    });
  }return ck(g);
}function jk(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;return { $$typeof: $a, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}
wc = function wc(a) {
  if (13 === a.tag) {
    var b = hg(Gg(), 150, 100);Ig(a, b);ek(a, b);
  }
};xc = function xc(a) {
  13 === a.tag && (Ig(a, 3), ek(a, 3));
};yc = function yc(a) {
  if (13 === a.tag) {
    var b = Gg();b = Hg(b, a, null);Ig(a, b);ek(a, b);
  }
};
za = function za(a, b, c) {
  switch (b) {case "input":
      Cb(a, c);b = c.name;if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) {
          c = c.parentNode;
        }c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');for (b = 0; b < c.length; b++) {
          var d = c[b];if (d !== a && d.form === a.form) {
            var e = Qd(d);if (!e) throw Error(u(90));yb(d);Cb(d, e);
          }
        }
      }break;case "textarea":
      Kb(a, c);break;case "select":
      b = c.value, null != b && Hb(a, !!c.multiple, b, !1);}
};Fa = Mj;
Ga = function Ga(a, b, c, d, e) {
  var f = W;W |= 4;try {
    return cg(98, a.bind(null, b, c, d, e));
  } finally {
    W = f, W === V && gg();
  }
};Ha = function Ha() {
  (W & (1 | fj | gj)) === V && (Lj(), Dj());
};Ia = function Ia(a, b) {
  var c = W;W |= 2;try {
    return a(b);
  } finally {
    W = c, W === V && gg();
  }
};function kk(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;if (!gk(b)) throw Error(u(200));return jk(a, b, null, c);
}var lk = { Events: [Nc, Pd, Qd, xa, ta, Xd, function (a) {
    jc(a, Wd);
  }, Da, Ea, id, mc, Dj, { current: !1 }] };
(function (a) {
  var b = a.findFiberByHostInstance;return Yj(n({}, a, { overrideHookState: null, overrideProps: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Wa.ReactCurrentDispatcher, findHostInstanceByFiber: function findHostInstanceByFiber(a) {
      a = hc(a);return null === a ? null : a.stateNode;
    }, findFiberByHostInstance: function findFiberByHostInstance(a) {
      return b ? b(a) : null;
    }, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null }));
})({ findFiberByHostInstance: tc, bundleType: 0, version: "16.14.0",
  rendererPackageName: "react-dom" });exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;exports.createPortal = kk;exports.findDOMNode = function (a) {
  if (null == a) return null;if (1 === a.nodeType) return a;var b = a._reactInternalFiber;if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(u(188));throw Error(u(268, Object.keys(a)));
  }a = hc(b);a = null === a ? null : a.stateNode;return a;
};
exports.flushSync = function (a, b) {
  if ((W & (fj | gj)) !== V) throw Error(u(187));var c = W;W |= 1;try {
    return cg(99, a.bind(null, b));
  } finally {
    W = c, gg();
  }
};exports.hydrate = function (a, b, c) {
  if (!gk(b)) throw Error(u(200));return ik(null, a, b, !0, c);
};exports.render = function (a, b, c) {
  if (!gk(b)) throw Error(u(200));return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function (a) {
  if (!gk(a)) throw Error(u(40));return a._reactRootContainer ? (Nj(function () {
    ik(null, null, a, !1, function () {
      a._reactRootContainer = null;a[Od] = null;
    });
  }), !0) : !1;
};exports.unstable_batchedUpdates = Mj;exports.unstable_createPortal = function (a, b) {
  return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function (a, b, c, d) {
  if (!gk(c)) throw Error(u(200));if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));return ik(a, b, c, !1, d);
};exports.version = "16.14.0";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(111);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState(overrideIsUnmounted) {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;

        var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;

        if (finalIsUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;

Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.createProvider = createProvider;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PropTypes = __webpack_require__(168);

var _warning = __webpack_require__(112);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return _react.Children.only(this.props.children);
    };

    return Provider;
  }(_react.Component);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: _PropTypes.storeShape.isRequired,
    children: _propTypes2.default.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);

  return Provider;
}

exports.default = createProvider();

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.createConnect = createConnect;

var _connectAdvanced = __webpack_require__(166);

var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);

var _shallowEqual = __webpack_require__(372);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _mapDispatchToProps = __webpack_require__(366);

var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

var _mapStateToProps = __webpack_require__(367);

var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

var _mergeProps = __webpack_require__(368);

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _selectorFactory = __webpack_require__(369);

var _selectorFactory2 = _interopRequireDefault(_selectorFactory);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

exports.default = createConnect();

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;

var _redux = __webpack_require__(28);

var _wrapMapToProps = __webpack_require__(167);

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && (typeof mapDispatchToProps === 'undefined' ? 'undefined' : _typeof(mapDispatchToProps)) === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
  }) : undefined;
}

exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;

var _wrapMapToProps = __webpack_require__(167);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
    return {};
  }) : undefined;
}

exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMergeProps = defaultMergeProps;
exports.wrapMergePropsFunc = wrapMergePropsFunc;
exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;

var _verifyPlainObject = __webpack_require__(169);

var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
exports.default = finalPropsSelectorFactory;

var _verifySubselectors = __webpack_require__(370);

var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = verifySubselectors;

var _warning = __webpack_require__(112);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();

exports.default = Subscription;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _history = __webpack_require__(41);

var _Router = __webpack_require__(113);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(_react2.default.Component);

exports.default = BrowserRouter;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _history = __webpack_require__(41);

var _Router = __webpack_require__(113);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(_react2.default.Component);

exports.default = HashRouter;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MemoryRouter = __webpack_require__(172);

var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Route = __webpack_require__(171);

var _Route2 = _interopRequireDefault(_Route);

var _Link = __webpack_require__(170);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return _react2.default.createElement(_Route2.default, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return _react2.default.createElement(_Link2.default, _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

exports.default = NavLink;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Prompt = __webpack_require__(173);

var _Prompt2 = _interopRequireDefault(_Prompt);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Redirect = __webpack_require__(174);

var _Redirect2 = _interopRequireDefault(_Redirect);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StaticRouter = __webpack_require__(175);

var _StaticRouter2 = _interopRequireDefault(_StaticRouter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__(176);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _generatePath = __webpack_require__(115);

var _generatePath2 = _interopRequireDefault(_generatePath);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _matchPath = __webpack_require__(78);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withRouter = __webpack_require__(178);

var _withRouter2 = _interopRequireDefault(_withRouter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isBrowser = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(111));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

var useCreatePortal = typeof _reactDom["default"].createPortal === 'function';
var isBrowser = typeof window !== 'undefined';
exports.isBrowser = isBrowser;

var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Portal).call(this, props));

    if (isBrowser) {
      _this.container = document.createElement('div');
      document.body.appendChild(_this.container);

      _this.renderLayer();
    }

    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!useCreatePortal) {
        _reactDom["default"].unmountComponentAtNode(this.container);
      }

      document.body.removeChild(this.container);
    }
  }, {
    key: "renderLayer",
    value: function renderLayer() {
      if (!useCreatePortal) {
        _reactDom["default"].unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (useCreatePortal) {
        return _reactDom["default"].createPortal(this.props.children, this.container);
      }

      return null;
    }
  }]);

  return Portal;
}(_react["default"].Component);

Portal.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = Portal;
exports["default"] = _default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDirection;

var _functions = __webpack_require__(116);

/**
 * Checks the intended tip direction and falls back if not enough space
 */
function checkLeftRightWidthSufficient(tip, target, distance, bodyPadding) {
  var targetRect = target.getBoundingClientRect();
  var deadSpace = Math.min(targetRect.left, document.documentElement.clientWidth - targetRect.right);
  return tip.offsetWidth + target.offsetWidth + distance + bodyPadding + deadSpace < document.documentElement.clientWidth;
}

function checkTargetSufficientlyVisible(target, tip, props) {
  var targetRect = target.getBoundingClientRect();
  var bottomOverhang = targetRect.bottom > window.innerHeight;
  var topOverhang = targetRect.top < 0; // if the target is taller than the viewport (and we know there's sufficient left/right width before this is called),
  // then go with the left/right direction as top/bottom will both be off screen

  if (topOverhang && bottomOverhang) {
    return true;
  } // if the target is bigger than the tip, we need to check if enough of the target is visible


  if (target.offsetHeight > tip.offsetHeight) {
    var halfTargetHeight = target.offsetHeight / 2;
    var arrowClearance = props.arrowSize + _functions.minArrowPadding;
    var bottomOverhangAmount = targetRect.bottom - window.innerHeight;
    var topOverhangAmount = -targetRect.top;
    var targetCenterToBottomOfWindow = halfTargetHeight - bottomOverhangAmount;
    var targetCenterToTopOfWindow = halfTargetHeight - topOverhangAmount;
    return targetCenterToBottomOfWindow >= arrowClearance && targetCenterToTopOfWindow >= arrowClearance;
  } // otherwise just check that the whole target is visible


  return !bottomOverhang && !topOverhang;
}

function checkForArrowOverhang(props, arrowStyles, bodyPadding) {
  var scrollLeft = (0, _functions.getScrollLeft)();
  var hasLeftClearance = arrowStyles.positionStyles.left - scrollLeft > bodyPadding;
  var hasRightClearance = arrowStyles.positionStyles.left + props.arrowSize * 2 < scrollLeft + document.documentElement.clientWidth - bodyPadding;
  return !hasLeftClearance || !hasRightClearance;
}

function getDirection(currentDirection, tip, target, props, bodyPadding, arrowStyles, recursive) {
  // can't switch until target is rendered
  if (!target) {
    return currentDirection;
  }

  var targetRect = target.getBoundingClientRect();
  var arrowSpacing = (0, _functions.getArrowSpacing)(props); // this is how much space is needed to display the tip above or below the target

  var heightOfTipWithArrow = tip.offsetHeight + arrowSpacing + bodyPadding;
  var spaceBelowTarget = window.innerHeight - targetRect.bottom;
  var spaceAboveTarget = targetRect.top;
  var hasSpaceBelow = spaceBelowTarget >= heightOfTipWithArrow;
  var hasSpaceAbove = spaceAboveTarget >= heightOfTipWithArrow;

  switch (currentDirection) {
    case 'right':
      // if the window is not wide enough try top (which falls back to down)
      if (!checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding) || !checkTargetSufficientlyVisible(target, tip, props)) {
        return getDirection('up', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (document.documentElement.clientWidth - targetRect.right < tip.offsetWidth + arrowSpacing + bodyPadding) {
        return 'left';
      }

      return 'right';

    case 'left':
      // if the window is not wide enough try top (which falls back to down)
      if (!checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding) || !checkTargetSufficientlyVisible(target, tip, props)) {
        return getDirection('up', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (targetRect.left < tip.offsetWidth + arrowSpacing + bodyPadding) {
        return 'right';
      }

      return 'left';

    case 'up':
      if (!recursive && arrowStyles && checkForArrowOverhang(props, arrowStyles, bodyPadding)) {
        return getDirection('left', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (!hasSpaceAbove) {
        if (hasSpaceBelow) {
          return 'down';
        }

        if (!recursive && checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding)) {
          return getDirection('right', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
        }
      }

      return 'up';

    case 'down':
    default:
      if (!recursive && arrowStyles && checkForArrowOverhang(props, arrowStyles, bodyPadding)) {
        return getDirection('right', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (!hasSpaceBelow) {
        // if there's no space below, but space above, switch to that direction
        if (hasSpaceAbove) {
          return 'up'; // if there's not space above or below, check if there would be space left or right
        }

        if (!recursive && checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding)) {
          return getDirection('right', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
        } // if there's no space in any direction, default to the original direction
      }

      return 'down';
  }
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Portal = _interopRequireWildcard(__webpack_require__(384));

var _position = _interopRequireDefault(__webpack_require__(387));

var _functions = __webpack_require__(116);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }newObj["default"] = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

// default colors
var defaultColor = '#fff';
var defaultBg = '#333';
var resizeThrottle = 100;
var resizeThreshold = 5;

var stopProp = function stopProp(e) {
  return e.stopPropagation();
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  _createClass(Tooltip, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      return _Portal.isBrowser && nextProps.isOpen ? {
        hasBeenShown: true
      } : null;
    }
  }]);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this));

    _defineProperty(_assertThisInitialized(_this), "debounceTimeout", false);

    _defineProperty(_assertThisInitialized(_this), "hoverTimeout", false);

    _this.state = {
      showTip: false,
      hasHover: false,
      ignoreShow: false,
      hasBeenShown: false
    };
    _this.showTip = _this.showTip.bind(_assertThisInitialized(_this));
    _this.hideTip = _this.hideTip.bind(_assertThisInitialized(_this));
    _this.checkHover = _this.checkHover.bind(_assertThisInitialized(_this));
    _this.toggleTip = _this.toggleTip.bind(_assertThisInitialized(_this));
    _this.startHover = _this.startHover.bind(_assertThisInitialized(_this));
    _this.endHover = _this.endHover.bind(_assertThisInitialized(_this));
    _this.listenResizeScroll = _this.listenResizeScroll.bind(_assertThisInitialized(_this));
    _this.handleResizeScroll = _this.handleResizeScroll.bind(_assertThisInitialized(_this));
    _this.bodyTouchStart = _this.bodyTouchStart.bind(_assertThisInitialized(_this));
    _this.bodyTouchEnd = _this.bodyTouchEnd.bind(_assertThisInitialized(_this));
    _this.targetTouchStart = _this.targetTouchStart.bind(_assertThisInitialized(_this));
    _this.targetTouchEnd = _this.targetTouchEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // if the isOpen prop is passed on first render we need to immediately trigger a second render,
      // because the tip ref is needed to calculate the position
      if (this.props.isOpen) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          isOpen: true
        });
      }

      this.scrollParent = (0, _functions.getScrollParent)(this.target);
      window.addEventListener('resize', this.listenResizeScroll);
      this.scrollParent.addEventListener('scroll', this.listenResizeScroll);
      window.addEventListener('touchstart', this.bodyTouchStart);
      window.addEventListener('touchEnd', this.bodyTouchEnd);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      // older versions of react won't leverage getDerivedStateFromProps, TODO: remove when < 16.3 support is dropped
      if (!this.state.hasBeenShown && this.props.isOpen) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          hasBeenShown: true
        });
        return setTimeout(this.showTip, 0);
      } // we need to render once to get refs in place, then we can make the calculations on a followup render
      // this only has to happen the first time the tip is shown, and allows us to not render every tip on the page with initial render.


      if (!prevState.hasBeenShown && this.state.hasBeenShown) {
        this.showTip();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.listenResizeScroll);
      this.scrollParent.removeEventListener('scroll', this.listenResizeScroll);
      window.removeEventListener('touchstart', this.bodyTouchStart);
      window.removeEventListener('touchEnd', this.bodyTouchEnd);
      clearTimeout(this.debounceTimeout);
      clearTimeout(this.hoverTimeout);
    }
  }, {
    key: "listenResizeScroll",
    value: function listenResizeScroll() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(this.handleResizeScroll, resizeThrottle);

      if (this.state.targetTouch) {
        this.setState({
          targetTouch: undefined
        });
      }
    }
  }, {
    key: "handleResizeScroll",
    value: function handleResizeScroll() {
      if (this.state.showTip) {
        // if we're showing the tip and the resize was actually a signifigant change, then setState to re-render and calculate position
        var clientWidth = Math.round(document.documentElement.clientWidth / resizeThreshold) * resizeThreshold;
        this.setState({
          clientWidth: clientWidth
        });
      }
    }
  }, {
    key: "targetTouchStart",
    value: function targetTouchStart() {
      this.setState({
        targetTouch: true
      });
    }
  }, {
    key: "targetTouchEnd",
    value: function targetTouchEnd() {
      if (this.state.targetTouch) {
        this.toggleTip();
      }
    }
  }, {
    key: "bodyTouchEnd",
    value: function bodyTouchEnd() {
      if (this.state.targetTouch) {
        this.setState({
          targetTouch: undefined
        });
      }
    }
  }, {
    key: "bodyTouchStart",
    value: function bodyTouchStart(e) {
      // if it's a controlled tip we don't want to auto-dismiss, otherwise we just ignore taps inside the tip
      if (!(this.target && this.target.contains(e.target)) && !(this.tip && this.tip.contains(e.target)) && !this.props.isOpen) {
        this.hideTip();
      }
    }
  }, {
    key: "toggleTip",
    value: function toggleTip() {
      this.state.showTip ? this.hideTip() : this.showTip();
    }
  }, {
    key: "showTip",
    value: function showTip() {
      var _this2 = this;

      if (!this.state.hasBeenShown) {
        // this will render once, then fire componentDidUpdate, which will show the tip
        return this.setState({
          hasBeenShown: true
        });
      }

      if (!this.state.showTip) {
        this.setState({
          showTip: true
        }, function () {
          if (typeof _this2.props.onToggle === 'function') {
            _this2.props.onToggle(_this2.state.showTip);
          }
        });
      }
    }
  }, {
    key: "hideTip",
    value: function hideTip() {
      var _this3 = this;

      this.setState({
        hasHover: false
      });

      if (this.state.showTip) {
        this.setState({
          showTip: false
        }, function () {
          if (typeof _this3.props.onToggle === 'function') {
            _this3.props.onToggle(_this3.state.showTip);
          }
        });
      }
    }
  }, {
    key: "startHover",
    value: function startHover() {
      if (!this.state.ignoreShow) {
        this.setState({
          hasHover: true
        });
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(this.checkHover, this.props.hoverDelay);
      }
    }
  }, {
    key: "endHover",
    value: function endHover() {
      this.setState({
        hasHover: false
      });
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(this.checkHover, this.props.mouseOutDelay || this.props.hoverDelay);
    }
  }, {
    key: "checkHover",
    value: function checkHover() {
      this.state.hasHover ? this.showTip() : this.hideTip();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          arrow = _this$props.arrow,
          arrowSize = _this$props.arrowSize,
          background = _this$props.background,
          className = _this$props.className,
          children = _this$props.children,
          color = _this$props.color,
          content = _this$props.content,
          direction = _this$props.direction,
          distance = _this$props.distance,
          eventOff = _this$props.eventOff,
          eventOn = _this$props.eventOn,
          eventToggle = _this$props.eventToggle,
          forceDirection = _this$props.forceDirection,
          isOpen = _this$props.isOpen,
          mouseOutDelay = _this$props.mouseOutDelay,
          padding = _this$props.padding,
          styles = _this$props.styles,
          TagName = _this$props.tagName,
          tipContentHover = _this$props.tipContentHover,
          tipContentClassName = _this$props.tipContentClassName,
          useDefaultStyles = _this$props.useDefaultStyles,
          useHover = _this$props.useHover,
          arrowContent = _this$props.arrowContent;
      var isControlledByProps = typeof isOpen !== 'undefined' && isOpen !== null;
      var showTip = isControlledByProps ? isOpen : this.state.showTip;

      var wrapperStyles = _objectSpread({
        position: 'relative'
      }, styles);

      var props = {
        style: wrapperStyles,
        ref: function ref(target) {
          _this4.target = target;
        },
        className: className
      };
      var portalProps = {
        // keep clicks on the tip from closing click controlled tips
        onClick: stopProp
      }; // event handling

      if (eventOff) {
        props[eventOff] = this.hideTip;
      }

      if (eventOn) {
        props[eventOn] = this.showTip;
      }

      if (eventToggle) {
        props[eventToggle] = this.toggleTip; // only use hover if they don't have a toggle event
      } else if (useHover && !isControlledByProps) {
        props.onMouseEnter = this.startHover;
        props.onMouseLeave = tipContentHover || mouseOutDelay ? this.endHover : this.hideTip;
        props.onTouchStart = this.targetTouchStart;
        props.onTouchEnd = this.targetTouchEnd;

        if (tipContentHover) {
          portalProps.onMouseEnter = this.startHover;
          portalProps.onMouseLeave = this.endHover;
          portalProps.onTouchStart = stopProp;
        }
      } // conditional rendering of tip


      var tipPortal;

      if (this.state.hasBeenShown) {
        var currentPositions = (0, _position["default"])(direction, forceDirection, this.tip, this.target, _objectSpread({}, this.state, {
          showTip: showTip
        }), {
          background: useDefaultStyles ? defaultBg : background,
          arrow: arrow,
          arrowSize: arrowSize,
          distance: distance
        });

        var tipStyles = _objectSpread({}, currentPositions.tip, {
          background: useDefaultStyles ? defaultBg : background,
          color: useDefaultStyles ? defaultColor : color,
          padding: padding,
          boxSizing: 'border-box',
          zIndex: this.props.zIndex,
          position: 'absolute',
          display: 'inline-block'
        });

        var arrowStyles = _objectSpread({}, currentPositions.arrow.positionStyles, arrowContent ? {} : currentPositions.arrow.borderStyles, {
          position: 'absolute',
          width: '0px',
          height: '0px',
          zIndex: this.props.zIndex + 1
        });

        tipPortal = _react["default"].createElement(_Portal["default"], null, _react["default"].createElement("div", _extends({}, portalProps, {
          className: typeof tipContentClassName !== 'undefined' ? tipContentClassName : className
        }), _react["default"].createElement("span", {
          className: "react-tooltip-lite",
          style: tipStyles,
          ref: function ref(tip) {
            _this4.tip = tip;
          }
        }, content), _react["default"].createElement("span", {
          className: "react-tooltip-lite-arrow react-tooltip-lite-".concat(currentPositions.realDirection, "-arrow"),
          style: arrowStyles
        }, arrowContent)));
      }

      return _react["default"].createElement(TagName, props, children, tipPortal);
    }
  }]);

  return Tooltip;
}(_react["default"].Component);

_defineProperty(Tooltip, "propTypes", {
  arrow: _propTypes["default"].bool,
  arrowSize: _propTypes["default"].number,
  background: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  content: _propTypes["default"].node.isRequired,
  direction: _propTypes["default"].string,
  distance: _propTypes["default"].number,
  eventOff: _propTypes["default"].string,
  eventOn: _propTypes["default"].string,
  eventToggle: _propTypes["default"].string,
  forceDirection: _propTypes["default"].bool,
  hoverDelay: _propTypes["default"].number,
  isOpen: _propTypes["default"].bool,
  mouseOutDelay: _propTypes["default"].number,
  padding: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  styles: _propTypes["default"].object,
  tagName: _propTypes["default"].string,
  tipContentHover: _propTypes["default"].bool,
  tipContentClassName: _propTypes["default"].string,
  useDefaultStyles: _propTypes["default"].bool,
  useHover: _propTypes["default"].bool,
  zIndex: _propTypes["default"].number,
  onToggle: _propTypes["default"].func,
  arrowContent: _propTypes["default"].node
});

_defineProperty(Tooltip, "defaultProps", {
  arrow: true,
  arrowSize: 10,
  background: '',
  className: '',
  color: '',
  direction: 'up',
  distance: undefined,
  eventOff: undefined,
  eventOn: undefined,
  eventToggle: undefined,
  forceDirection: false,
  hoverDelay: 200,
  isOpen: undefined,
  mouseOutDelay: undefined,
  padding: '10px',
  styles: {},
  tagName: 'div',
  tipContentHover: false,
  tipContentClassName: undefined,
  useDefaultStyles: false,
  useHover: true,
  zIndex: 1000,
  onToggle: undefined,
  arrowContent: null
});

var _default = Tooltip;
exports["default"] = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = positions;

var _getDirection = _interopRequireDefault(__webpack_require__(385));

var _functions = __webpack_require__(116);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * Sets tip max width safely for mobile
 */
function getTipMaxWidth() {
  return typeof document !== 'undefined' ? document.documentElement.clientWidth - _functions.bodyPadding * 2 : 1000;
}
/**
 * Parses align mode from direction if specified with hyphen, defaulting to middle if not -
 * e.g. 'left-start' is mode 'start' and 'left' would be the default of 'middle'
 */

function parseAlignMode(direction) {
  var directionArray = direction.split('-');

  if (directionArray.length > 1) {
    return directionArray[1];
  }

  return 'middle';
}
/**
 * Gets wrapper's left position for top/bottom tooltips as well as needed width restriction
 */

function getUpDownPosition(tip, target, state, direction, alignMode, props) {
  var left = -10000000;
  var top;
  var transform = state.showTip ? undefined : 'translateX(-10000000px)';
  var arrowSpacing = (0, _functions.getArrowSpacing)(props);

  if (tip) {
    // get wrapper left position
    var scrollLeft = (0, _functions.getScrollLeft)();
    var targetRect = target.getBoundingClientRect();
    var targetLeft = targetRect.left + scrollLeft;
    var halfTargetWidth = Math.round(target.offsetWidth / 2);
    var tipWidth = Math.min(getTipMaxWidth(), tip.offsetWidth);
    var arrowCenter = targetLeft + halfTargetWidth;
    var arrowLeft = arrowCenter - props.arrowSize;
    var arrowRight = arrowCenter + props.arrowSize;

    if (alignMode === 'start') {
      left = props.arrow ? Math.min(arrowLeft, targetLeft) : targetLeft;
    } else if (alignMode === 'end') {
      var rightWithArrow = Math.max(arrowRight, targetLeft + target.offsetWidth);
      var rightEdge = props.arrow ? rightWithArrow : targetLeft + target.offsetWidth;
      left = Math.max(rightEdge - tipWidth, _functions.bodyPadding + scrollLeft);
    } else {
      var centeredLeft = targetLeft + halfTargetWidth - Math.round(tipWidth / 2);
      var availableSpaceOnLeft = _functions.bodyPadding + scrollLeft;
      left = Math.max(centeredLeft, availableSpaceOnLeft);
    } // check for right overhang


    var rightOfTip = left + tipWidth;
    var rightOfScreen = scrollLeft + document.documentElement.clientWidth - _functions.bodyPadding;
    var rightOverhang = rightOfTip - rightOfScreen;

    if (rightOverhang > 0) {
      left -= rightOverhang;
    }

    if (direction === 'up') {
      top = targetRect.top + (0, _functions.getScrollTop)() - (tip.offsetHeight + arrowSpacing);
    } else {
      top = targetRect.bottom + (0, _functions.getScrollTop)() + arrowSpacing;
    }
  }

  return {
    left: left,
    top: top,
    transform: transform
  };
}
/**
 * gets top position for left/right arrows
 */

function getLeftRightPosition(tip, target, state, direction, alignMode, props) {
  var left = -10000000;
  var top = 0;
  var transform = state.showTip ? undefined : 'translateX(-10000000px)';
  var arrowSpacing = (0, _functions.getArrowSpacing)(props);
  var arrowPadding = props.arrow ? _functions.minArrowPadding : 0;

  if (tip) {
    var scrollTop = (0, _functions.getScrollTop)();
    var scrollLeft = (0, _functions.getScrollLeft)();
    var targetRect = target.getBoundingClientRect();
    var targetTop = targetRect.top + scrollTop;
    var halfTargetHeight = Math.round(target.offsetHeight / 2);
    var arrowTop = targetTop + halfTargetHeight - props.arrowSize;
    var arrowBottom = targetRect.top + scrollTop + halfTargetHeight + props.arrowSize; // TODO: handle close to edges better

    if (alignMode === 'start') {
      top = props.arrow ? Math.min(targetTop, arrowTop) : targetTop;
    } else if (alignMode === 'end') {
      var topForBottomAlign = targetRect.bottom + scrollTop - tip.offsetHeight;
      top = props.arrow ? Math.max(topForBottomAlign, arrowBottom - tip.offsetHeight) : topForBottomAlign;
    } else {
      // default to middle, but don't go below body
      var centeredTop = Math.max(targetTop + halfTargetHeight - Math.round(tip.offsetHeight / 2), _functions.bodyPadding + scrollTop); // make sure it doesn't go below the arrow

      top = Math.min(centeredTop, arrowTop - arrowPadding);
    } // check for bottom overhang


    var bottomOverhang = top - scrollTop + tip.offsetHeight + _functions.bodyPadding - window.innerHeight;

    if (bottomOverhang > 0) {
      // try to add the body padding below the tip, but don't offset too far from the arrow
      top = Math.max(top - bottomOverhang, arrowBottom + arrowPadding - tip.offsetHeight);
    }

    if (direction === 'right') {
      left = targetRect.right + arrowSpacing + scrollLeft;
    } else {
      left = targetRect.left - arrowSpacing - tip.offsetWidth + scrollLeft;
    }
  }

  return {
    left: left,
    top: top,
    transform: transform
  };
}
/**
 * sets the Arrow styles based on direction
 */

function getArrowStyles(target, tip, direction, state, props) {
  if (!target || !props.arrow) {
    return {
      positionStyles: {
        top: '0',
        left: '-10000000px'
      }
    };
  }

  var targetRect = target.getBoundingClientRect();
  var halfTargetHeight = Math.round(target.offsetHeight / 2);
  var halfTargetWidth = Math.round(target.offsetWidth / 2);
  var scrollTop = (0, _functions.getScrollTop)();
  var scrollLeft = (0, _functions.getScrollLeft)();
  var arrowSpacing = (0, _functions.getArrowSpacing)(props);
  var borderStyles = {};
  var positionStyles = {};

  switch (direction) {
    case 'right':
      borderStyles.borderTop = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderBottom = "".concat(props.arrowSize, "px solid transparent");

      if (props.background) {
        borderStyles.borderRight = "".concat(props.arrowSize, "px solid ").concat(props.background);
      } else {
        borderStyles.borderRightWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderRightStyle = 'solid';
      }

      positionStyles.top = state.showTip && tip ? targetRect.top + scrollTop + halfTargetHeight - props.arrowSize : '-10000000px';
      positionStyles.left = targetRect.right + scrollLeft + arrowSpacing - props.arrowSize;
      break;

    case 'left':
      borderStyles.borderTop = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderBottom = "".concat(props.arrowSize, "px solid transparent");

      if (props.background) {
        borderStyles.borderLeft = "".concat(props.arrowSize, "px solid ").concat(props.background);
      } else {
        borderStyles.borderLeftWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderLeftStyle = 'solid';
      }

      positionStyles.top = state.showTip && tip ? targetRect.top + scrollTop + halfTargetHeight - props.arrowSize : '-10000000px';
      positionStyles.left = targetRect.left + scrollLeft - arrowSpacing - 1;
      break;

    case 'up':
      borderStyles.borderLeft = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderRight = "".concat(props.arrowSize, "px solid transparent"); // if color is styled with css, we need everything except border-color, if styled with props, we add entire border rule

      if (props.background) {
        borderStyles.borderTop = "".concat(props.arrowSize, "px solid ").concat(props.background);
      } else {
        borderStyles.borderTopWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderTopStyle = 'solid';
      }

      positionStyles.left = state.showTip && tip ? targetRect.left + scrollLeft + halfTargetWidth - props.arrowSize : '-10000000px';
      positionStyles.top = targetRect.top + scrollTop - arrowSpacing;
      break;

    case 'down':
    default:
      borderStyles.borderLeft = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderRight = "".concat(props.arrowSize, "px solid transparent");

      if (props.background) {
        borderStyles.borderBottom = "10px solid ".concat(props.background);
      } else {
        borderStyles.borderBottomWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderBottomStyle = 'solid';
      }

      positionStyles.left = state.showTip && tip ? targetRect.left + scrollLeft + halfTargetWidth - props.arrowSize : '-10000000px';
      positionStyles.top = targetRect.bottom + scrollTop + arrowSpacing - props.arrowSize;
      break;
  }

  return {
    borderStyles: borderStyles,
    positionStyles: positionStyles
  };
}
/**
 * Returns the positions style rules
 */

function positions(direction, forceDirection, tip, target, state, props) {
  var alignMode = parseAlignMode(direction);
  var trimmedDirection = direction.split('-')[0];
  var realDirection = trimmedDirection;

  if (!forceDirection && tip) {
    var testArrowStyles = props.arrow && getArrowStyles(target, tip, trimmedDirection, state, props);
    realDirection = (0, _getDirection["default"])(trimmedDirection, tip, target, props, _functions.bodyPadding, testArrowStyles);
  }

  var maxWidth = getTipMaxWidth(); // force the tip to display the width we measured everything at when visible

  var width;

  if (tip) {
    // adding the exact width on the first render forces a bogus line break, so add 1px the first time
    var spacer = tip.style.width ? 0 : 1;
    width = Math.min(tip.offsetWidth, maxWidth) + spacer;
  }

  var tipPosition = realDirection === 'up' || realDirection === 'down' ? getUpDownPosition(tip, target, state, realDirection, alignMode, props) : getLeftRightPosition(tip, target, state, realDirection, alignMode, props);
  return {
    tip: _objectSpread({}, tipPosition, {
      maxWidth: maxWidth,
      width: width
    }),
    arrow: getArrowStyles(target, tip, realDirection, state, props),
    realDirection: realDirection
  };
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var l = __webpack_require__(164),
    n = "function" === typeof Symbol && Symbol.for,
    p = n ? Symbol.for("react.element") : 60103,
    q = n ? Symbol.for("react.portal") : 60106,
    r = n ? Symbol.for("react.fragment") : 60107,
    t = n ? Symbol.for("react.strict_mode") : 60108,
    u = n ? Symbol.for("react.profiler") : 60114,
    v = n ? Symbol.for("react.provider") : 60109,
    w = n ? Symbol.for("react.context") : 60110,
    x = n ? Symbol.for("react.forward_ref") : 60112,
    y = n ? Symbol.for("react.suspense") : 60113,
    z = n ? Symbol.for("react.memo") : 60115,
    A = n ? Symbol.for("react.lazy") : 60116,
    B = "function" === typeof Symbol && Symbol.iterator;function C(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var D = { isMounted: function isMounted() {
    return !1;
  }, enqueueForceUpdate: function enqueueForceUpdate() {}, enqueueReplaceState: function enqueueReplaceState() {}, enqueueSetState: function enqueueSetState() {} },
    E = {};function F(a, b, c) {
  this.props = a;this.context = b;this.refs = E;this.updater = c || D;
}F.prototype.isReactComponent = {};F.prototype.setState = function (a, b) {
  if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) && "function" !== typeof a && null != a) throw Error(C(85));this.updater.enqueueSetState(this, a, b, "setState");
};F.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function G() {}G.prototype = F.prototype;function H(a, b, c) {
  this.props = a;this.context = b;this.refs = E;this.updater = c || D;
}var I = H.prototype = new G();I.constructor = H;l(I, F.prototype);I.isPureReactComponent = !0;var J = { current: null },
    K = Object.prototype.hasOwnProperty,
    L = { key: !0, ref: !0, __self: !0, __source: !0 };
function M(a, b, c) {
  var e,
      d = {},
      g = null,
      k = null;if (null != b) for (e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b) {
    K.call(b, e) && !L.hasOwnProperty(e) && (d[e] = b[e]);
  }var f = arguments.length - 2;if (1 === f) d.children = c;else if (1 < f) {
    for (var h = Array(f), m = 0; m < f; m++) {
      h[m] = arguments[m + 2];
    }d.children = h;
  }if (a && a.defaultProps) for (e in f = a.defaultProps, f) {
    void 0 === d[e] && (d[e] = f[e]);
  }return { $$typeof: p, type: a, key: g, ref: k, props: d, _owner: J.current };
}
function N(a, b) {
  return { $$typeof: p, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
}function O(a) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === p;
}function escape(a) {
  var b = { "=": "=0", ":": "=2" };return "$" + ("" + a).replace(/[=:]/g, function (a) {
    return b[a];
  });
}var P = /\/+/g,
    Q = [];function R(a, b, c, e) {
  if (Q.length) {
    var d = Q.pop();d.result = a;d.keyPrefix = b;d.func = c;d.context = e;d.count = 0;return d;
  }return { result: a, keyPrefix: b, func: c, context: e, count: 0 };
}
function S(a) {
  a.result = null;a.keyPrefix = null;a.func = null;a.context = null;a.count = 0;10 > Q.length && Q.push(a);
}
function T(a, b, c, e) {
  var d = typeof a === "undefined" ? "undefined" : _typeof(a);if ("undefined" === d || "boolean" === d) a = null;var g = !1;if (null === a) g = !0;else switch (d) {case "string":case "number":
      g = !0;break;case "object":
      switch (a.$$typeof) {case p:case q:
          g = !0;}}if (g) return c(e, a, "" === b ? "." + U(a, 0) : b), 1;g = 0;b = "" === b ? "." : b + ":";if (Array.isArray(a)) for (var k = 0; k < a.length; k++) {
    d = a[k];var f = b + U(d, k);g += T(d, f, c, e);
  } else if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) ? f = null : (f = B && a[B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), k = 0; !(d = a.next()).done;) {
    d = d.value, f = b + U(d, k++), g += T(d, f, c, e);
  } else if ("object" === d) throw c = "" + a, Error(C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));return g;
}function V(a, b, c) {
  return null == a ? 0 : T(a, "", b, c);
}function U(a, b) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && null != a.key ? escape(a.key) : b.toString(36);
}function W(a, b) {
  a.func.call(a.context, b, a.count++);
}
function aa(a, b, c) {
  var e = a.result,
      d = a.keyPrefix;a = a.func.call(a.context, b, a.count++);Array.isArray(a) ? X(a, e, c, function (a) {
    return a;
  }) : null != a && (O(a) && (a = N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(P, "$&/") + "/") + c)), e.push(a));
}function X(a, b, c, e, d) {
  var g = "";null != c && (g = ("" + c).replace(P, "$&/") + "/");b = R(b, g, e, d);V(a, aa, b);S(b);
}var Y = { current: null };function Z() {
  var a = Y.current;if (null === a) throw Error(C(321));return a;
}
var ba = { ReactCurrentDispatcher: Y, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: J, IsSomeRendererActing: { current: !1 }, assign: l };exports.Children = { map: function map(a, b, c) {
    if (null == a) return a;var e = [];X(a, e, null, b, c);return e;
  }, forEach: function forEach(a, b, c) {
    if (null == a) return a;b = R(null, null, b, c);V(a, W, b);S(b);
  }, count: function count(a) {
    return V(a, function () {
      return null;
    }, null);
  }, toArray: function toArray(a) {
    var b = [];X(a, b, null, function (a) {
      return a;
    });return b;
  }, only: function only(a) {
    if (!O(a)) throw Error(C(143));return a;
  } };
exports.Component = F;exports.Fragment = r;exports.Profiler = u;exports.PureComponent = H;exports.StrictMode = t;exports.Suspense = y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ba;
exports.cloneElement = function (a, b, c) {
  if (null === a || void 0 === a) throw Error(C(267, a));var e = l({}, a.props),
      d = a.key,
      g = a.ref,
      k = a._owner;if (null != b) {
    void 0 !== b.ref && (g = b.ref, k = J.current);void 0 !== b.key && (d = "" + b.key);if (a.type && a.type.defaultProps) var f = a.type.defaultProps;for (h in b) {
      K.call(b, h) && !L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
  }var h = arguments.length - 2;if (1 === h) e.children = c;else if (1 < h) {
    f = Array(h);for (var m = 0; m < h; m++) {
      f[m] = arguments[m + 2];
    }e.children = f;
  }return { $$typeof: p, type: a.type,
    key: d, ref: g, props: e, _owner: k };
};exports.createContext = function (a, b) {
  void 0 === b && (b = null);a = { $$typeof: w, _calculateChangedBits: b, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null };a.Provider = { $$typeof: v, _context: a };return a.Consumer = a;
};exports.createElement = M;exports.createFactory = function (a) {
  var b = M.bind(null, a);b.type = a;return b;
};exports.createRef = function () {
  return { current: null };
};exports.forwardRef = function (a) {
  return { $$typeof: x, render: a };
};exports.isValidElement = O;
exports.lazy = function (a) {
  return { $$typeof: A, _ctor: a, _status: -1, _result: null };
};exports.memo = function (a, b) {
  return { $$typeof: z, type: a, compare: void 0 === b ? null : b };
};exports.useCallback = function (a, b) {
  return Z().useCallback(a, b);
};exports.useContext = function (a, b) {
  return Z().useContext(a, b);
};exports.useDebugValue = function () {};exports.useEffect = function (a, b) {
  return Z().useEffect(a, b);
};exports.useImperativeHandle = function (a, b, c) {
  return Z().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function (a, b) {
  return Z().useLayoutEffect(a, b);
};exports.useMemo = function (a, b) {
  return Z().useMemo(a, b);
};exports.useReducer = function (a, b, c) {
  return Z().useReducer(a, b, c);
};exports.useRef = function (a) {
  return Z().useRef(a);
};exports.useState = function (a) {
  return Z().useState(a);
};exports.version = "16.14.0";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _createFieldProps2 = __webpack_require__(181);

var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);

var _onChangeValue = __webpack_require__(185);

var _onChangeValue2 = _interopRequireDefault(_onChangeValue);

var _eventConsts = __webpack_require__(453);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(_ref) {
  var deepEqual = _ref.deepEqual,
      getIn = _ref.getIn,
      toJS = _ref.toJS;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = _plain2.default.getIn(syncErrors, name
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    );return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    );return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField(props) {
      _classCallCheck(this, ConnectedField);

      var _this = _possibleConstructorReturn(this, (ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call(this, props));

      _this.handleChange = _this.handleChange.bind(_this);
      _this.handleFocus = _this.handleFocus.bind(_this);
      _this.handleBlur = _this.handleBlur.bind(_this);
      _this.handleDragStart = _this.handleDragStart.bind(_this);
      _this.handleDrop = _this.handleDrop.bind(_this);
      return _this;
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        });
      }
    }, {
      key: 'isPristine',
      value: function isPristine() {
        return this.props.pristine;
      }
    }, {
      key: 'getValue',
      value: function getValue() {
        return this.props.value;
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.refs.renderedComponent;
      }
    }, {
      key: 'handleChange',
      value: function handleChange(event) {
        var _props = this.props,
            name = _props.name,
            dispatch = _props.dispatch,
            parse = _props.parse,
            normalize = _props.normalize,
            onChange = _props.onChange,
            _reduxForm = _props._reduxForm,
            previousValue = _props.value;

        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          onChange(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue);
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
        }
      }
    }, {
      key: 'handleFocus',
      value: function handleFocus(event) {
        var _props2 = this.props,
            name = _props2.name,
            dispatch = _props2.dispatch,
            onFocus = _props2.onFocus,
            _reduxForm = _props2._reduxForm;

        var defaultPrevented = false;
        if (onFocus) {
          onFocus(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }));
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }
    }, {
      key: 'handleBlur',
      value: function handleBlur(event) {
        var _props3 = this.props,
            name = _props3.name,
            dispatch = _props3.dispatch,
            parse = _props3.parse,
            normalize = _props3.normalize,
            onBlur = _props3.onBlur,
            _reduxForm = _props3._reduxForm,
            _value = _props3._value,
            previousValue = _props3.value;

        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize

          // for checkbox and radio, if the value property of checkbox or radio equals
          // the value passed by blur event, then fire blur action with previousValue.
        });if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          onBlur(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue);
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue)

          // call post-blur callback
          );if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue);
          }
        }
      }
    }, {
      key: 'handleDragStart',
      value: function handleDragStart(event) {
        var _props4 = this.props,
            onDragStart = _props4.onDragStart,
            value = _props4.value;

        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event);
        }
      }
    }, {
      key: 'handleDrop',
      value: function handleDrop(event) {
        var _props5 = this.props,
            name = _props5.name,
            dispatch = _props5.dispatch,
            onDrop = _props5.onDrop,
            _reduxForm = _props5._reduxForm,
            previousValue = _props5.value;

        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props6 = this.props,
            component = _props6.component,
            withRef = _props6.withRef,
            name = _props6.name,
            _reduxForm = _props6._reduxForm,
            normalize = _props6.normalize,
            onBlur = _props6.onBlur,
            onChange = _props6.onChange,
            onFocus = _props6.onFocus,
            onDragStart = _props6.onDragStart,
            onDrop = _props6.onDrop,
            rest = _objectWithoutProperties(_props6, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);

        var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = 'renderedComponent';
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return (0, _react.createElement)(component, _extends({}, input, custom));
        } else {
          return (0, _react.createElement)(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(_react.Component);

  ConnectedField.propTypes = {
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
    props: _propTypes2.default.object
  };

  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

exports.default = createConnectedField;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _mapValues2 = __webpack_require__(161);

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _redux = __webpack_require__(28);

var _createFieldArrayProps = __webpack_require__(400);

var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(_ref) {
  var deepEqual = _ref.deepEqual,
      getIn = _ref.getIn,
      size = _ref.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return _plain2.default.getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_Component) {
    _inherits(ConnectedFieldArray, _Component);

    function ConnectedFieldArray() {
      _classCallCheck(this, ConnectedFieldArray);

      var _this = _possibleConstructorReturn(this, (ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call(this));

      _this.getValue = _this.getValue.bind(_this);
      return _this;
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          if (thisValue.length !== nextValue.length || nextProps.rerenderOnEveryChange && thisValue.some(function (val) {
            return nextValue.every(function (next) {
              return !deepEqual(val, next);
            });
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.refs.renderedComponent;
      }
    }, {
      key: 'getValue',
      value: function getValue(index) {
        return this.props.value && getIn(this.props.value, index);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = (0, _createFieldArrayProps2.default)(getIn, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = 'renderedComponent';
        }
        return (0, _react.createElement)(component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(_react.Component);

  ConnectedFieldArray.propTypes = {
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
    props: _propTypes2.default.object,
    rerenderOnEveryChange: _propTypes2.default.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: _propTypes2.default.object
  };

  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return (0, _mapValues3.default)({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

exports.default = createConnectedFieldArray;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _createFieldProps2 = __webpack_require__(181);

var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

var _onChangeValue = __webpack_require__(185);

var _onChangeValue2 = _interopRequireDefault(_onChangeValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(_ref) {
  var deepEqual = _ref.deepEqual,
      getIn = _ref.getIn,
      toJS = _ref.toJS,
      size = _ref.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return _plain2.default.getIn(syncErrors, name + '._error') || _plain2.default.getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    );return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_Component) {
    _inherits(ConnectedFields, _Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.handleChange = _this.handleChange.bind(_this);
      _this.handleFocus = _this.handleFocus.bind(_this);
      _this.handleBlur = _this.handleBlur.bind(_this);

      _this.onChangeFns = props.names.reduce(function (acc, name) {
        acc[name] = function (event) {
          return _this.handleChange(name, event);
        };
        return acc;
      }, {});

      _this.onFocusFns = props.names.reduce(function (acc, name) {
        acc[name] = function () {
          return _this.handleFocus(name);
        };
        return acc;
      }, {});

      _this.onBlurFns = props.names.reduce(function (acc, name) {
        acc[name] = function (event) {
          return _this.handleBlur(name, event);
        };
        return acc;
      }, {});
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names is changed. The cached event handlers need to be updated
          this.onChangeFns = nextProps.names.reduce(function (acc, name) {
            acc[name] = function (event) {
              return _this2.handleChange(name, event);
            };
            return acc;
          }, {});

          this.onFocusFns = nextProps.names.reduce(function (acc, name) {
            acc[name] = function () {
              return _this2.handleFocus(name);
            };
            return acc;
          }, {});

          this.onBlurFns = nextProps.names.reduce(function (acc, name) {
            acc[name] = function (event) {
              return _this2.handleBlur(name, event);
            };
            return acc;
          }, {});
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        });
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return _plain2.default.setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.refs.renderedComponent;
      }
    }, {
      key: 'handleChange',
      value: function handleChange(name, event) {
        var _props = this.props,
            dispatch = _props.dispatch,
            parse = _props.parse,
            normalize = _props.normalize,
            _reduxForm = _props._reduxForm;

        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });

        dispatch(_reduxForm.change(name, value));
      }
    }, {
      key: 'handleFocus',
      value: function handleFocus(name) {
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            _reduxForm = _props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      }
    }, {
      key: 'handleBlur',
      value: function handleBlur(name, event) {
        var _props3 = this.props,
            dispatch = _props3.dispatch,
            parse = _props3.parse,
            normalize = _props3.normalize,
            _reduxForm = _props3._reduxForm;

        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize

          // dispatch blur action
        });dispatch(_reduxForm.blur(name, value)

        // call post-blur callback
        );if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props4 = this.props,
            component = _props4.component,
            withRef = _props4.withRef,
            _fields = _props4._fields,
            _reduxForm = _props4._reduxForm,
            rest = _objectWithoutProperties(_props4, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = 'renderedComponent';
        }

        return (0, _react.createElement)(component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(_react.Component);

  ConnectedFields.propTypes = {
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
    _fields: _propTypes2.default.object.isRequired,
    props: _propTypes2.default.object
  };

  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

exports.default = createConnectedFields;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createField = __webpack_require__(398);

var _createField2 = _interopRequireDefault(_createField);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createField2.default)(_plain2.default);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFieldArray = __webpack_require__(399);

var _createFieldArray2 = _interopRequireDefault(_createFieldArray);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createFieldArray2.default)(_plain2.default);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFields = __webpack_require__(401);

var _createFields2 = _interopRequireDefault(_createFields);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createFields2.default)(_plain2.default);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('form', this.props);
    }
  }]);

  return Form;
}(_react.Component);

Form.contextTypes = {
  _reduxForm: _propTypes2.default.object
};

exports.default = Form;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _prefixName = __webpack_require__(53);

var _prefixName2 = _interopRequireDefault(_prefixName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: (0, _prefixName2.default)(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (_react2.default.isValidElement(children)) {
        return children;
      }

      return (0, _react.createElement)(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(_react.Component);

FormSection.propTypes = {
  name: _propTypes2.default.string.isRequired,
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: _propTypes2.default.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: _propTypes2.default.object
};

exports.default = FormSection;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPromise = __webpack_require__(95);

var _isPromise2 = _interopRequireDefault(_isPromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!(0, _isPromise2.default)(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (errors && Object.keys(errors).length) {
        stop(errors);
        return errors;
      } else if (rejected) {
        stop();
        throw new Error('Asynchronous validation promise was rejected without errors.');
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

exports.default = asyncValidation;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _ConnectedField = __webpack_require__(389);

var _ConnectedField2 = _interopRequireDefault(_ConnectedField);

var _shallowCompare = __webpack_require__(188);

var _shallowCompare2 = _interopRequireDefault(_shallowCompare);

var _prefixName = __webpack_require__(53);

var _prefixName2 = _interopRequireDefault(_prefixName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var createField = function createField(_ref) {
  var deepEqual = _ref.deepEqual,
      getIn = _ref.getIn,
      setIn = _ref.setIn,
      toJS = _ref.toJS;

  var ConnectedField = (0, _ConnectedField2.default)({
    deepEqual: deepEqual,
    getIn: getIn,
    toJS: toJS
  });

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }

      _this.normalize = _this.normalize.bind(_this);
      return _this;
    }

    _createClass(Field, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return (0, _shallowCompare2.default)(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.name !== nextProps.name) {
          // unregister old name
          this.context._reduxForm.unregister(this.name
          // register new name
          );this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'Field');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'normalize',
      value: function normalize(name, value) {
        var normalize = this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = this.context._reduxForm.getValues();
        var previousValue = this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      }
    }, {
      key: 'render',
      value: function render() {
        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return (0, _prefixName2.default)(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isPristine();
      }
    }, {
      key: 'value',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(_react.Component);

  Field.propTypes = {
    name: _propTypes2.default.string.isRequired,
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
    format: _propTypes2.default.func,
    normalize: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onDragStart: _propTypes2.default.func,
    onDrop: _propTypes2.default.func,
    parse: _propTypes2.default.func,
    props: _propTypes2.default.object,
    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
    withRef: _propTypes2.default.bool
  };
  Field.contextTypes = {
    _reduxForm: _propTypes2.default.object
  };

  return Field;
};

exports.default = createField;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _ConnectedFieldArray = __webpack_require__(390);

var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);

var _prefixName = __webpack_require__(53);

var _prefixName2 = _interopRequireDefault(_prefixName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(_ref2) {
  var deepEqual = _ref2.deepEqual,
      getIn = _ref2.getIn,
      size = _ref2.size;

  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)({
    deepEqual: deepEqual,
    getIn: getIn,
    size: size
  });

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.name !== nextProps.name) {
          // unregister old name
          this.context._reduxForm.unregister(this.name
          // register new name
          );this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          syncError: this.syncError,
          syncWarning: this.syncWarning,
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return (0, _prefixName2.default)(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.refs.connected.getWrappedInstance().pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.refs.connected.getWrappedInstance().value;
      }
    }]);

    return FieldArray;
  }(_react.Component);

  FieldArray.propTypes = {
    name: _propTypes2.default.string.isRequired,
    component: _propTypes2.default.func.isRequired,
    props: _propTypes2.default.object,
    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
    withRef: _propTypes2.default.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: _propTypes2.default.object
  };

  return FieldArray;
};

exports.default = createFieldArray;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var createFieldArrayProps = function createFieldArrayProps(getIn, name, form, sectionPrefix, getValue, _ref) {
  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, length - 1);
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, 0);
      },
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};

exports.default = createFieldArrayProps;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _ConnectedFields = __webpack_require__(391);

var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);

var _shallowCompare = __webpack_require__(188);

var _shallowCompare2 = _interopRequireDefault(_shallowCompare);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

var _prefixName = __webpack_require__(53);

var _prefixName2 = _interopRequireDefault(_prefixName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(_ref) {
  var deepEqual = _ref.deepEqual,
      getIn = _ref.getIn,
      toJS = _ref.toJS,
      size = _ref.size;

  var ConnectedFields = (0, _ConnectedFields2.default)({
    deepEqual: deepEqual,
    getIn: getIn,
    toJS: toJS,
    size: size
  });

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return (0, _shallowCompare2.default)(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var error = validateNameProp(this.props.names);
        if (error) {
          throw error;
        }
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister((0, _prefixName2.default)(context, name));
          }
          // register new name
          );nextProps.names.forEach(function (name) {
            return register((0, _prefixName2.default)(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister((0, _prefixName2.default)(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return (0, _prefixName2.default)(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return (0, _prefixName2.default)(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(_react.Component);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
    format: _propTypes2.default.func,
    parse: _propTypes2.default.func,
    props: _propTypes2.default.object,
    withRef: _propTypes2.default.bool
  };
  Fields.contextTypes = {
    _reduxForm: _propTypes2.default.object
  };

  return Fields;
};

exports.default = createFields;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };

    (0, _invariant2.default)(form, 'Form value must be specified');
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      (0, _invariant2.default)(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(getFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(getFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
      }, {});
    };
  };
};

exports.default = createFormValueSelector;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _prefixName = __webpack_require__(53);

var _prefixName2 = _interopRequireDefault(_prefixName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var valuesMap = void 0;

    if (typeof args[0] === 'string') {
      valuesMap = args.map(function (k) {
        return { prop: k, path: k };
      });
    } else {
      var config = args[0];
      valuesMap = Object.keys(config).map(function (k) {
        return {
          prop: k,
          path: config[k]
        };
      });
    }
    if (!valuesMap.length) {
      throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...})');
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          var getValues = context._reduxForm.getValues;

          var formValuesSelector = function formValuesSelector(_) {
            // Yes, we're only using connect() for listening to updates
            var props = {};
            var values = getValues();
            valuesMap.forEach(function (_ref2) {
              var prop = _ref2.prop,
                  path = _ref2.path;
              return props[prop] = getIn(values, (0, _prefixName2.default)(context, path));
            });
            return props;
          };
          _this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
            return {};
          } // ignore dispatch
          )(Component);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'render',
          value: function render() {
            return _react2.default.createElement(this.Component, this.props);
          }
        }]);

        return FormValues;
      }(_react2.default.Component);

      FormValues.contextTypes = {
        _reduxForm: _propTypes2.default.object
      };
      return FormValues;
    };
  };
};

exports.default = createValues;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionTypes = __webpack_require__(117);

var _deleteInWithCleanUp = __webpack_require__(407);

var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
};

var createReducer = function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      splice = structure.splice;

  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = _plain2.default.getIn(slice, field);
    return existing || force ? setIn(state, key, _plain2.default.setIn(slice, field, _plain2.default.splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
    var _ref$meta = _ref.meta,
        field = _ref$meta.field,
        index = _ref$meta.index,
        payload = _ref.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        from = _ref2$meta.from,
        to = _ref2$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1) // remove
          );result = setIn(result, path, splice(getIn(result, path), to, 0, value) // insert
          );
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
    var field = _ref3.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
    var field = _ref4.meta.field,
        payload = _ref4.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
    var _ref5$meta = _ref5.meta,
        field = _ref5$meta.field,
        index = _ref5$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
    var field = _ref6.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
    var field = _ref7.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
    var _ref8$meta = _ref8.meta,
        field = _ref8$meta.field,
        index = _ref8$meta.index,
        removeNum = _ref8$meta.removeNum,
        payload = _ref8.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        indexA = _ref9$meta.indexA,
        indexB = _ref9$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
    var field = _ref10.meta.field,
        payload = _ref10.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
    var _ref12$meta = _ref12.meta,
        field = _ref12$meta.field,
        touch = _ref12$meta.touch,
        payload = _ref12.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT_ERRORS, function (state) {
    return deleteInWithCleanUp(state, 'submitErrors');
  }), _defineProperty(_behaviors, _actionTypes.CLEAR_ASYNC_ERROR, function (state, _ref14) {
    var field = _ref14.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref15) {
    var field = _ref15.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref16) {
    var payload = _ref16.payload,
        _ref16$meta = _ref16.meta,
        keepDirty = _ref16$meta.keepDirty,
        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');
    var newInitialValues = mapData;

    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        keys(registeredFields).forEach(function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }
        });

        keys(newInitialValues).forEach(function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref17) {
    var _ref17$payload = _ref17.payload,
        name = _ref17$payload.name,
        type = _ref17$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref18) {
    var field = _ref18.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref19) {
    var payload = _ref19.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'asyncErrors');
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref20) {
    var payload = _ref20.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = setIn(result, 'submitSucceeded', true);
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref21) {
    var fields = _ref21.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref22) {
    var fields = _ref22.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref23) {
    var _ref23$payload = _ref23.payload,
        name = _ref23$payload.name,
        destroyOnUnmount = _ref23$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    if (destroyOnUnmount) {
      result = deleteInWithCleanUp(result, 'syncErrors.' + name);
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
      result = deleteInWithCleanUp(result, 'syncWarnings.' + name);
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = keys(getIn(result, 'registeredFields')).some(function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref25) {
    var _ref25$payload = _ref25.payload,
        syncErrors = _ref25$payload.syncErrors,
        error = _ref25$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        syncWarnings = _ref26$payload.syncWarnings,
        warning = _ref26$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === _actionTypes.DESTROY) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function plugin(reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Object.keys(reducers).reduce(function (accumulator, key) {
          var previousState = getIn(accumulator, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
        }, _this(state, action));
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
};

exports.default = createReducer;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

var _merge4 = __webpack_require__(353);

var _merge5 = _interopRequireDefault(_merge4);

var _mapValues2 = __webpack_require__(161);

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _hoistNonReactStatics = __webpack_require__(94);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _isPromise = __webpack_require__(95);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _reactRedux = __webpack_require__(4);

var _redux = __webpack_require__(28);

var _actions = __webpack_require__(180);

var importedActions = _interopRequireWildcard(_actions);

var _asyncValidation = __webpack_require__(397);

var _asyncValidation2 = _interopRequireDefault(_asyncValidation);

var _defaultShouldAsyncValidate = __webpack_require__(182);

var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);

var _defaultShouldValidate = __webpack_require__(183);

var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);

var _silenceEvent = __webpack_require__(186);

var _silenceEvent2 = _interopRequireDefault(_silenceEvent);

var _silenceEvents = __webpack_require__(409);

var _silenceEvents2 = _interopRequireDefault(_silenceEvents);

var _generateValidator2 = __webpack_require__(412);

var _generateValidator3 = _interopRequireDefault(_generateValidator2);

var _handleSubmit = __webpack_require__(421);

var _handleSubmit2 = _interopRequireDefault(_handleSubmit);

var _isValid = __webpack_require__(118);

var _isValid2 = _interopRequireDefault(_isValid);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

var _getDisplayName = __webpack_require__(454);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object'

  // extract field-specific actions
  );
};
var arrayInsert = importedActions.arrayInsert,
    arrayMove = importedActions.arrayMove,
    arrayPop = importedActions.arrayPop,
    arrayPush = importedActions.arrayPush,
    arrayRemove = importedActions.arrayRemove,
    arrayRemoveAll = importedActions.arrayRemoveAll,
    arrayShift = importedActions.arrayShift,
    arraySplice = importedActions.arraySplice,
    arraySwap = importedActions.arraySwap,
    arrayUnshift = importedActions.arrayUnshift,
    blur = importedActions.blur,
    change = importedActions.change,
    focus = importedActions.focus,
    formActions = _objectWithoutProperties(importedActions, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(importedActions)), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = (0, _isValid2.default)(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
      shouldValidate: _defaultShouldValidate2.default,
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form(props) {
          _classCallCheck(this, Form);

          var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

          _this.submit = _this.submit.bind(_this);
          _this.reset = _this.reset.bind(_this);
          _this.asyncValidate = _this.asyncValidate.bind(_this);
          _this.getValues = _this.getValues.bind(_this);
          _this.register = _this.register.bind(_this);
          _this.unregister = _this.unregister.bind(_this);
          _this.submitCompleted = _this.submitCompleted.bind(_this);
          _this.submitFailed = _this.submitFailed.bind(_this);
          _this.fieldValidators = {};
          _this.lastFieldValidatorKeys = [];
          _this.fieldWarners = {};
          _this.lastFieldWarnerKeys = [];
          return _this;
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, keepDirty, {
                  lastInitialValues: this.props.initialValues
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(lastSyncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                validate = _props3.validate,
                values = _props3.values;

            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var shouldValidateResult = shouldValidate({
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              });

              if (shouldValidateResult) {
                var propsToValidate = initialRender ? this.props : nextProps;

                var _merge2 = (0, _merge5.default)(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props4 = this.props,
                warning = _props4.warning,
                syncWarnings = _props4.syncWarnings,
                updateSyncWarnings = _props4.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props5 = this.props,
                shouldValidate = _props5.shouldValidate,
                warn = _props5.warn,
                values = _props5.values;

            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var shouldWarnResult = shouldValidate({
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              });

              if (shouldWarnResult) {
                var propsToWarn = initialRender ? this.props : nextProps;

                var _merge3 = (0, _merge5.default)(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            this.initIfNeeded();
            this.validateIfNeeded();
            this.warnIfNeeded();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            if (nextProps.onChange) {
              if (!deepEqual(nextProps.values, this.props.values)) {
                nextProps.onChange(nextProps.values, nextProps.dispatch, nextProps);
              }
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _initialConfig$immuta = initialConfig.immutableProps,
                immutableProps = _initialConfig$immuta === undefined ? [] : _initialConfig$immuta;

            return Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            });
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props6 = this.props,
                destroyOnUnmount = _props6.destroyOnUnmount,
                destroy = _props6.destroy;

            if (destroyOnUnmount) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'getValues',
          value: function getValues() {
            return this.props.values;
          }
        }, {
          key: 'isValid',
          value: function isValid() {
            return this.props.valid;
          }
        }, {
          key: 'isPristine',
          value: function isPristine() {
            return this.props.pristine;
          }
        }, {
          key: 'register',
          value: function register(name, type, getValidator, getWarner) {
            this.props.registerField(name, type);
            if (getValidator) {
              this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              this.fieldWarners[name] = getWarner;
            }
          }
        }, {
          key: 'unregister',
          value: function unregister(name) {
            if (!this.destroyed) {
              if (this.props.destroyOnUnmount || this.props.forceUnregisterOnUnmount) {
                this.props.unregisterField(name);
                delete this.fieldValidators[name];
                delete this.fieldWarners[name];
              } else {
                this.props.unregisterField(name, false);
              }
            }
          }
        }, {
          key: 'getFieldList',
          value: function getFieldList(options) {
            var registeredFields = this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }
        }, {
          key: 'getValidators',
          value: function getValidators() {
            var _this4 = this;

            var validators = {};
            Object.keys(this.fieldValidators).forEach(function (name) {
              var validator = _this4.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }
        }, {
          key: 'generateValidator',
          value: function generateValidator() {
            var validators = this.getValidators();
            return Object.keys(validators).length ? (0, _generateValidator3.default)(validators, structure) : undefined;
          }
        }, {
          key: 'getWarners',
          value: function getWarners() {
            var _this5 = this;

            var warners = {};
            Object.keys(this.fieldWarners).forEach(function (name) {
              var warner = _this5.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }
        }, {
          key: 'generateWarner',
          value: function generateWarner() {
            var warners = this.getWarners();
            return Object.keys(warners).length ? (0, _generateValidator3.default)(warners, structure) : undefined;
          }
        }, {
          key: 'asyncValidate',
          value: function asyncValidate(name, value) {
            var _this6 = this;

            var _props7 = this.props,
                asyncBlurFields = _props7.asyncBlurFields,
                asyncErrors = _props7.asyncErrors,
                asyncValidate = _props7.asyncValidate,
                dispatch = _props7.dispatch,
                initialized = _props7.initialized,
                pristine = _props7.pristine,
                shouldAsyncValidate = _props7.shouldAsyncValidate,
                startAsyncValidation = _props7.startAsyncValidation,
                stopAsyncValidation = _props7.stopAsyncValidation,
                syncErrors = _props7.syncErrors,
                values = _props7.values;

            var submitting = !name;
            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
              if ((isBlurredField || submitting) && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : 'blur',
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return (0, _asyncValidation2.default)(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this6.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }
        }, {
          key: 'submitCompleted',
          value: function submitCompleted(result) {
            delete this.submitPromise;
            return result;
          }
        }, {
          key: 'submitFailed',
          value: function submitFailed(error) {
            delete this.submitPromise;
            throw error;
          }
        }, {
          key: 'listenToSubmit',
          value: function listenToSubmit(promise) {
            if (!(0, _isPromise2.default)(promise)) {
              return promise;
            }
            this.submitPromise = promise;
            return promise.then(this.submitCompleted, this.submitFailed);
          }
        }, {
          key: 'submit',
          value: function submit(submitOrEvent) {
            var _this7 = this;

            var _props8 = this.props,
                onSubmit = _props8.onSubmit,
                blur = _props8.blur,
                change = _props8.change,
                dispatch = _props8.dispatch;

            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (this.innerOnSubmit && this.innerOnSubmit !== this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return this.innerOnSubmit();
                } else {
                  return this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), _extends({}, this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), this.props.validExceptSubmit, this.asyncValidate, this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return (0, _silenceEvents2.default)(function () {
                return !_this7.submitPromise && _this7.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _extends({}, _this7.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this7.props.validExceptSubmit, _this7.asyncValidate, _this7.getFieldList({ excludeFieldArray: true })));
              });
            }
          }
        }, {
          key: 'reset',
          value: function reset() {
            this.props.reset();
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */

            var reduxFormProps = _extends({
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              propsToPass.ref = 'wrapped';
            }
            return (0, _react.createElement)(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(_react.Component);

      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: _propTypes2.default.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: _propTypes2.default.bool,
        forceUnregisterOnUnmount: _propTypes2.default.bool,
        form: _propTypes2.default.string.isRequired,
        initialValues: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
        getFormState: _propTypes2.default.func,
        onSubmitFail: _propTypes2.default.func,
        onSubmitSuccess: _propTypes2.default.func,
        propNameSpace: _propTypes2.default.string,
        validate: _propTypes2.default.func,
        warn: _propTypes2.default.func,
        touchOnBlur: _propTypes2.default.bool,
        touchOnChange: _propTypes2.default.bool,
        triggerSubmit: _propTypes2.default.bool,
        persistentSubmitErrors: _propTypes2.default.bool,
        registeredFields: _propTypes2.default.any
      };

      var connector = (0, _reactRedux.connect)(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || {};
        var syncWarnings = getIn(formState, 'syncWarnings') || {};
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form

          // Bind the first parameter on `props.form`
          );
        };var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus

        // Wrap action creators with `dispatch`
        );var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api
      return function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.refs.wrapped.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            return this.refs.wrapped.getWrappedInstance().reset();
          }
        }, {
          key: 'render',
          value: function render() {
            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
              ref: 'wrapped',
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return this.refs.wrapped.getWrappedInstance().isValid();
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return this.refs.wrapped.getWrappedInstance().isPristine();
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.refs.wrapped.getWrappedInstance().getValues();
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.refs.wrapped.getWrappedInstance().getFieldList();
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
          }
        }]);

        return ReduxForm;
      }(_react.Component);
    };
  };
};

exports.default = createReduxForm;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(4);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return (0, _reactRedux.connect)(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }, function () {
      return {};
    } // ignore dispatch
    );
  };
};

exports.default = createValues;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toPath2 = __webpack_require__(76);

var _toPath3 = _interopRequireDefault(_toPath2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createDeleteInWithCleanUp = function createDeleteInWithCleanUp(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn,
      deleteIn = _ref.deleteIn,
      setIn = _ref.setIn;

  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
    if (path[path.length - 1] === ']') {
      // array path
      var pathTokens = (0, _toPath3.default)(path);
      pathTokens.pop();
      var parent = getIn(state, pathTokens.join('.'));
      return parent ? setIn(state, path, undefined) : state;
    }

    var result = state;
    if (getIn(state, path) !== undefined) {
      result = deleteIn(state, path);
    }

    var dotIndex = path.lastIndexOf('.');
    if (dotIndex > 0) {
      var parentPath = path.substring(0, dotIndex);
      if (parentPath[parentPath.length - 1] !== ']') {
        var _parent = getIn(result, parentPath);
        if (deepEqual(_parent, empty)) {
          return deleteInWithCleanUp(result, parentPath);
        }
      }
    }
    return result;
  };

  return deleteInWithCleanUp;
};

exports.default = createDeleteInWithCleanUp;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEvent = __webpack_require__(184);

var _isEvent2 = _interopRequireDefault(_isEvent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if ((0, _isEvent2.default)(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var _event$target = event.target,
        type = _event$target.type,
        value = _event$target.value,
        checked = _event$target.checked,
        files = _event$target.files,
        dataTransfer = event.dataTransfer;

    if (type === 'checkbox') {
      return checked || '';
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

exports.default = getValue;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _silenceEvent = __webpack_require__(186);

var _silenceEvent2 = _interopRequireDefault(_silenceEvent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

exports.default = silenceEvents;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFormValueSelector = __webpack_require__(402);

var _createFormValueSelector2 = _interopRequireDefault(_createFormValueSelector);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createFormValueSelector2.default)(_plain2.default);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFormValues = __webpack_require__(403);

var _createFormValues2 = _interopRequireDefault(_createFormValues);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createFormValues2.default)(_plain2.default);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name]);
      if (error) {
        errors = _plain2.default.setIn(errors, name, error);
      }
    });
    return errors;
  };
};

exports.default = generateValidator;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormAsyncErrors = __webpack_require__(434);

var _getFormAsyncErrors2 = _interopRequireDefault(_getFormAsyncErrors);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormAsyncErrors2.default)(_plain2.default);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormInitialValues = __webpack_require__(435);

var _getFormInitialValues2 = _interopRequireDefault(_getFormInitialValues);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormInitialValues2.default)(_plain2.default);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormMeta = __webpack_require__(436);

var _getFormMeta2 = _interopRequireDefault(_getFormMeta);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormMeta2.default)(_plain2.default);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormNames = __webpack_require__(437);

var _getFormNames2 = _interopRequireDefault(_getFormNames);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormNames2.default)(_plain2.default);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormSubmitErrors = __webpack_require__(438);

var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormSubmitErrors2.default)(_plain2.default);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormSyncErrors = __webpack_require__(439);

var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormSyncErrors2.default)(_plain2.default);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormSyncWarnings = __webpack_require__(440);

var _getFormSyncWarnings2 = _interopRequireDefault(_getFormSyncWarnings);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormSyncWarnings2.default)(_plain2.default);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormValues = __webpack_require__(441);

var _getFormValues2 = _interopRequireDefault(_getFormValues);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _getFormValues2.default)(_plain2.default);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPromise = __webpack_require__(95);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _SubmissionError = __webpack_require__(179);

var _SubmissionError2 = _interopRequireDefault(_SubmissionError);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;

  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if ((0, _isPromise2.default)(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    if (onSubmitFail) {
      onSubmitFail(syncErrors, dispatch, null, props);
    }
    return syncErrors;
  }
};

exports.default = handleSubmit;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};

var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

exports.default = createHasError;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasSubmitFailed = __webpack_require__(442);

var _hasSubmitFailed2 = _interopRequireDefault(_hasSubmitFailed);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _hasSubmitFailed2.default)(_plain2.default);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasSubmitSucceeded = __webpack_require__(443);

var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _hasSubmitSucceeded2.default)(_plain2.default);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isDirty = __webpack_require__(444);

var _isDirty2 = _interopRequireDefault(_isDirty);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _isDirty2.default)(_plain2.default);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInvalid = __webpack_require__(445);

var _isInvalid2 = _interopRequireDefault(_isInvalid);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _isInvalid2.default)(_plain2.default);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPristine = __webpack_require__(187);

var _isPristine2 = _interopRequireDefault(_isPristine);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _isPristine2.default)(_plain2.default);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

exports.default = isReactNative;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isSubmitting = __webpack_require__(446);

var _isSubmitting2 = _interopRequireDefault(_isSubmitting);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _isSubmitting2.default)(_plain2.default);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isValid = __webpack_require__(118);

var _isValid2 = _interopRequireDefault(_isValid);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _isValid2.default)(_plain2.default);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var any = _propTypes2.default.any,
    bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    oneOfType = _propTypes2.default.oneOfType,
    object = _propTypes2.default.object;

var formPropTypes = exports.formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = exports.fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = exports.fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: string,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldPropTypes = exports.fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired,
  custom: object.isRequired
};

exports.default = formPropTypes;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer = __webpack_require__(404);

var _createReducer2 = _interopRequireDefault(_createReducer);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createReducer2.default)(_plain2.default);

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReduxForm = __webpack_require__(405);

var _createReduxForm2 = _interopRequireDefault(_createReduxForm);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createReduxForm2.default)(_plain2.default);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.asyncErrors');
    };
  };
};

exports.default = createGetFormAsyncErrors;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.initial');
    };
  };
};

exports.default = createGetFormInitialValues;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.fields');
    };
  };
};

exports.default = createGetFormMeta;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormNames = function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;
  return function () {
    var getFormState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return keys(getFormState(state));
    };
  };
};

exports.default = createGetFormNames;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.submitErrors');
    };
  };
};

exports.default = createGetFormSubmitErrors;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.syncErrors');
    };
  };
};

exports.default = createGetFormSyncErrors;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.syncWarnings');
    };
  };
};

exports.default = createGetFormSyncWarnings;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.values');
    };
  };
};

exports.default = createGetFormValues;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      var formState = getFormState(state);
      return getIn(formState, form + '.submitFailed') || false;
    };
  };
};

exports.default = createHasSubmitFailed;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      var formState = getFormState(state);
      return getIn(formState, form + '.submitSucceeded') || false;
    };
  };
};

exports.default = createHasSubmitSucceeded;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPristine = __webpack_require__(187);

var _isPristine2 = _interopRequireDefault(_isPristine);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
    return function (state) {
      return !isPristine(state);
    };
  };
};

exports.default = createIsDirty;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isValid = __webpack_require__(118);

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

exports.default = createIsInvalid;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      var formState = getFormState(state);
      return getIn(formState, form + '.submitting') || false;
    };
  };
};

exports.default = createIsSubmitting;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEqualWith2 = __webpack_require__(159);

var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var customizer = function customizer(obj, other) {
  if (obj === other) return true;
  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) return true;

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
};

var deepEqual = function deepEqual(a, b) {
  return (0, _isEqualWith3.default)(a, b, customizer);
};

exports.default = deepEqual;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toPath2 = __webpack_require__(76);

var _toPath3 = _interopRequireDefault(_toPath2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var deleteInWithPath = function deleteInWithPath(state, first) {
  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (state === undefined || first === undefined) {
    return state;
  }
  if (rest.length) {
    if (Array.isArray(state)) {
      if (first < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
        if (result !== state[first]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[first] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array');
    }
    if (first < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(first, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
};

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
};

exports.default = deleteIn;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toPath2 = __webpack_require__(76);

var _toPath3 = _interopRequireDefault(_toPath2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = (0, _toPath3.default)(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && !!result; ++i) {
    result = result[path[i]];
  }

  return result;
};

exports.default = getIn;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var keys = function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
};

exports.default = keys;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toPath2 = __webpack_require__(76);

var _toPath3 = _interopRequireDefault(_toPath2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var next = setInWithPath(state && state[first], value, path, pathIndex + 1);

  if (!state) {
    var initialized = isNaN(first) ? {} : [];
    initialized[first] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[first] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
};

exports.default = setIn;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, null);
      _copy2[index] = undefined;
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value // removing and adding
      );return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum // removing
    );return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

exports.default = splice;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var dataKey = exports.dataKey = 'text';

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createValues = __webpack_require__(406);

var _createValues2 = _interopRequireDefault(_createValues);

var _plain = __webpack_require__(3);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createValues2.default)(_plain2.default);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMigrate;

var _constants = __webpack_require__(32);

function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : _constants.DEFAULT_VERSION;
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTransform;
function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersistGate = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved


var PersistGate = exports.PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(_react.PureComponent);
PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = persistCombineReducers;

var _redux = __webpack_require__(28);

var _persistReducer = __webpack_require__(120);

var _persistReducer2 = _interopRequireDefault(_persistReducer);

var _autoMergeLevel = __webpack_require__(462);

var _autoMergeLevel2 = _interopRequireDefault(_autoMergeLevel);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? _autoMergeLevel2.default : config.stateReconciler;
  return (0, _persistReducer2.default)(config, (0, _redux.combineReducers)(reducers));
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = persistStore;

var _redux = __webpack_require__(28);

var _persistReducer = __webpack_require__(120);

var _persistReducer2 = _interopRequireDefault(_persistReducer);

var _constants = __webpack_require__(32);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.REGISTER:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case _constants.REHYDRATE:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;

  var _pStore = (0, _redux.createStore)(persistorReducer, initialState, options ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: _constants.REGISTER,
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: _constants.REHYDRATE,
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = _extends({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: _constants.PURGE,
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: _constants.FLUSH,
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: _constants.PAUSE
      });
    },
    persist: function persist() {
      store.dispatch({ type: _constants.PERSIST, register: register, rehydrate: rehydrate });
    }
  });

  persistor.persist();

  return persistor;
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

exports.default = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

exports.default = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__(464);

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = getStorage;

function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return window[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__(463);

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createWebStorage2.default)('local');

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports.default = thunk;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyMiddleware;

var _compose = __webpack_require__(192);

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = _compose2.default.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = combineReducers;

var _createStore = __webpack_require__(193);

var _isPlainObject = __webpack_require__(74);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warning = __webpack_require__(194);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!(0, _isPlainObject2.default)(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        (0, _warning2.default)('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        (0, _warning2.default)(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

exports.default = resolvePathname;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _f, g, h, k, l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
  var p = null,
      q = null,
      t = function t() {
    if (null !== p) try {
      var a = exports.unstable_now();p(!0, a);p = null;
    } catch (b) {
      throw setTimeout(t, 0), b;
    }
  },
      u = Date.now();exports.unstable_now = function () {
    return Date.now() - u;
  };_f = function f(a) {
    null !== p ? setTimeout(_f, 0, a) : (p = a, setTimeout(t, 0));
  };g = function g(a, b) {
    q = setTimeout(a, b);
  };h = function h() {
    clearTimeout(q);
  };k = function k() {
    return !1;
  };l = exports.unstable_forceFrameRate = function () {};
} else {
  var w = window.performance,
      x = window.Date,
      y = window.setTimeout,
      z = window.clearTimeout;if ("undefined" !== typeof console) {
    var A = window.cancelAnimationFrame;"function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function" !== typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
  }if ("object" === (typeof w === "undefined" ? "undefined" : _typeof(w)) && "function" === typeof w.now) exports.unstable_now = function () {
    return w.now();
  };else {
    var B = x.now();exports.unstable_now = function () {
      return x.now() - B;
    };
  }var C = !1,
      D = null,
      E = -1,
      F = 5,
      G = 0;k = function k() {
    return exports.unstable_now() >= G;
  };l = function l() {};exports.unstable_forceFrameRate = function (a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : F = 0 < a ? Math.floor(1E3 / a) : 5;
  };var H = new MessageChannel(),
      I = H.port2;H.port1.onmessage = function () {
    if (null !== D) {
      var a = exports.unstable_now();G = a + F;try {
        D(!0, a) ? I.postMessage(null) : (C = !1, D = null);
      } catch (b) {
        throw I.postMessage(null), b;
      }
    } else C = !1;
  };_f = function _f(a) {
    D = a;C || (C = !0, I.postMessage(null));
  };g = function g(a, b) {
    E = y(function () {
      a(exports.unstable_now());
    }, b);
  };h = function h() {
    z(E);E = -1;
  };
}function J(a, b) {
  var c = a.length;a.push(b);a: for (;;) {
    var d = c - 1 >>> 1,
        e = a[d];if (void 0 !== e && 0 < K(e, b)) a[d] = b, a[c] = e, c = d;else break a;
  }
}function L(a) {
  a = a[0];return void 0 === a ? null : a;
}
function M(a) {
  var b = a[0];if (void 0 !== b) {
    var c = a.pop();if (c !== b) {
      a[0] = c;a: for (var d = 0, e = a.length; d < e;) {
        var m = 2 * (d + 1) - 1,
            n = a[m],
            v = m + 1,
            r = a[v];if (void 0 !== n && 0 > K(n, c)) void 0 !== r && 0 > K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);else if (void 0 !== r && 0 > K(r, c)) a[d] = r, a[v] = c, d = v;else break a;
      }
    }return b;
  }return null;
}function K(a, b) {
  var c = a.sortIndex - b.sortIndex;return 0 !== c ? c : a.id - b.id;
}var N = [],
    O = [],
    P = 1,
    Q = null,
    R = 3,
    S = !1,
    T = !1,
    U = !1;
function V(a) {
  for (var b = L(O); null !== b;) {
    if (null === b.callback) M(O);else if (b.startTime <= a) M(O), b.sortIndex = b.expirationTime, J(N, b);else break;b = L(O);
  }
}function W(a) {
  U = !1;V(a);if (!T) if (null !== L(N)) T = !0, _f(X);else {
    var b = L(O);null !== b && g(W, b.startTime - a);
  }
}
function X(a, b) {
  T = !1;U && (U = !1, h());S = !0;var c = R;try {
    V(b);for (Q = L(N); null !== Q && (!(Q.expirationTime > b) || a && !k());) {
      var d = Q.callback;if (null !== d) {
        Q.callback = null;R = Q.priorityLevel;var e = d(Q.expirationTime <= b);b = exports.unstable_now();"function" === typeof e ? Q.callback = e : Q === L(N) && M(N);V(b);
      } else M(N);Q = L(N);
    }if (null !== Q) var m = !0;else {
      var n = L(O);null !== n && g(W, n.startTime - b);m = !1;
    }return m;
  } finally {
    Q = null, R = c, S = !1;
  }
}
function Y(a) {
  switch (a) {case 1:
      return -1;case 2:
      return 250;case 5:
      return 1073741823;case 4:
      return 1E4;default:
      return 5E3;}
}var Z = l;exports.unstable_IdlePriority = 5;exports.unstable_ImmediatePriority = 1;exports.unstable_LowPriority = 4;exports.unstable_NormalPriority = 3;exports.unstable_Profiling = null;exports.unstable_UserBlockingPriority = 2;exports.unstable_cancelCallback = function (a) {
  a.callback = null;
};exports.unstable_continueExecution = function () {
  T || S || (T = !0, _f(X));
};
exports.unstable_getCurrentPriorityLevel = function () {
  return R;
};exports.unstable_getFirstCallbackNode = function () {
  return L(N);
};exports.unstable_next = function (a) {
  switch (R) {case 1:case 2:case 3:
      var b = 3;break;default:
      b = R;}var c = R;R = b;try {
    return a();
  } finally {
    R = c;
  }
};exports.unstable_pauseExecution = function () {};exports.unstable_requestPaint = Z;exports.unstable_runWithPriority = function (a, b) {
  switch (a) {case 1:case 2:case 3:case 4:case 5:
      break;default:
      a = 3;}var c = R;R = a;try {
    return b();
  } finally {
    R = c;
  }
};
exports.unstable_scheduleCallback = function (a, b, c) {
  var d = exports.unstable_now();if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c) {
    var e = c.delay;e = "number" === typeof e && 0 < e ? d + e : d;c = "number" === typeof c.timeout ? c.timeout : Y(a);
  } else c = Y(a), e = d;c = e + c;a = { id: P++, callback: b, priorityLevel: a, startTime: e, expirationTime: c, sortIndex: -1 };e > d ? (a.sortIndex = e, J(O, a), null === L(N) && a === L(O) && (U ? h() : U = !0, g(W, e - d))) : (a.sortIndex = c, J(N, a), T || S || (T = !0, _f(X)));return a;
};
exports.unstable_shouldYield = function () {
  var a = exports.unstable_now();V(a);var b = L(N);return b !== Q && null !== Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < Q.expirationTime || k();
};exports.unstable_wrapCallback = function (a) {
  var b = R;return function () {
    var c = R;R = b;try {
      return a.apply(this, arguments);
    } finally {
      R = c;
    }
  };
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(471);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(474);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var root; /* global window */

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2.default)(root);
exports.default = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79), __webpack_require__(80)(module)))

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var v1 = __webpack_require__(476);
var v4 = __webpack_require__(477);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var rng = __webpack_require__(196);
var bytesToUuid = __webpack_require__(195);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var rng = __webpack_require__(196);
var bytesToUuid = __webpack_require__(195);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

exports.default = valueEqual;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = analyticsMiddleware;

var _analyticsTracking = __webpack_require__(54);

var _bet = __webpack_require__(20);

var _bookmakersInfo = __webpack_require__(6);

var _bookmakersList = __webpack_require__(5);

var _logger = __webpack_require__(63);

var logger = (0, _logger.create)('analyticsMiddleware');

function analyticsMiddleware(store) {
    var analytics = (0, _analyticsTracking.findAnalytics)();
    if (!analytics) {
        return function (next) {
            return function (action) {
                return next(action);
            };
        };
    }
    return function (next) {
        return function (action) {
            try {
                switch (action.type) {
                    case _bet.actions.actionTypes.PLACE_BET_SUCCESS:
                        (0, _analyticsTracking.logToAnalyticsBetSuccess)(action, store, analytics);
                        break;
                    case _bookmakersInfo.actions.actionTypes.SET_SUSPENDED_BET:
                    case _bookmakersInfo.actions.actionTypes.SET_PRICE_CHANGED:
                    case _bookmakersInfo.actions.actionTypes.SET_GENERIC_ERROR:
                    case _bookmakersInfo.actions.actionTypes.SET_ERROR:
                        (0, _analyticsTracking.logToAnalyticsBetError)(action, store, analytics);
                        break;
                    case _bookmakersInfo.actions.actionTypes.SET_SUSPENDED_BET_ON_BUILD:
                    case _bookmakersInfo.actions.actionTypes.SET_PRICE_CHANGED_ON_BUILD:
                    case _bookmakersInfo.actions.actionTypes.SET_GENERIC_ERROR_ON_BUILD:
                    case _bookmakersInfo.actions.actionTypes.SET_ERROR_ON_BUILD:
                    case _bookmakersInfo.actions.actionTypes.SET_MULTIPLES_ERROR:
                        (0, _analyticsTracking.logToAnalyticsBuildError)(action, store, analytics);
                        break;
                    case _bookmakersList.actions.actionTypes.SET_LOGIN:
                        (0, _analyticsTracking.logToAnalyticsBookmakerLogin)(action, store, analytics);
                        break;
                    case _bookmakersList.actions.actionTypes.SET_LOGIN_SUCCESS:
                        (0, _analyticsTracking.logToAnalyticsBookmakerLoginSuccess)(action, store, analytics);
                        break;
                    case _bookmakersList.actions.actionTypes.SET_LOGIN_FAILURE:
                        (0, _analyticsTracking.logToAnalyticsBookmakerLoginFailure)(action, store, analytics);
                        break;
                    // no default
                }
            } catch (e) {
                logger.error(e);
            }
            return next(action);
        };
    };
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaults = __webpack_require__(65);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
    _defaults2.default.withCredentials = true;
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookmakersList = __webpack_require__(5);

var _bookmakersInfo = __webpack_require__(6);

var _helpers = __webpack_require__(488);

var dispatchBuildBets = function dispatchBuildBets(store, apiName, selectedBets, feed, isExternalLogout) {
    store.dispatch(_bookmakersInfo.actions.buildBetRequest(true));
    store.dispatch(_bookmakersInfo.actions.buildBets(apiName, selectedBets, feed, isExternalLogout));
};

var buildBets = function buildBets(store, ignoreAction) {
    var meta = (0, _helpers.getEssentialBettingState)(store);
    var isUserLoggedIn = meta.isUserLoggedIn;
    var containsBets = meta.selectedBets.length > 0;
    var notAuthorized = ignoreAction || !isUserLoggedIn;

    if (notAuthorized || !containsBets) {
        return;
    }

    dispatchBuildBets(store, meta.apiName, meta.selectedBets, meta.feed, meta.isExternalLogout, meta.currencySign);
};

var buildBetsMiddleware = function buildBetsMiddleware(store) {
    return function (next) {
        return function (action) {
            switch (action.type) {
                case _bookmakersInfo.actions.actionTypes.ADD_SELECTED_BET:
                case _bookmakersInfo.actions.actionTypes.DELETE_BET:
                    buildBets(store, true);
                    break;
                case _bookmakersList.actions.actionTypes.SET_USER_INFO:
                    buildBets(store, false);
                    break;
                default:
            }
            return next(action);
        };
    };
};

exports.default = buildBetsMiddleware;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookmakersList = __webpack_require__(5);

var _bookmakersInfo = __webpack_require__(6);

var _loginPage = __webpack_require__(36);

var _userInfo = __webpack_require__(11);

var SPECULATIVE_API_NAME = 'speculative';

var dispatchBuildMultiples = function dispatchBuildMultiples(store, apiName, selectedBets, feed, isExternalLogout) {
    store.dispatch(_bookmakersInfo.actions.saveMultiplesStakes());
    store.dispatch(_bookmakersInfo.actions.saveMultiplesEachWay());
    store.dispatch(_bookmakersInfo.actions.clearMultiples());
    store.dispatch(_bookmakersInfo.actions.buildMultiplesRequest(true));
    store.dispatch(_bookmakersInfo.actions.buildMultiples(apiName, selectedBets, feed, isExternalLogout));
};

var getMeta = function getMeta(store) {
    var state = store.getState();
    var selectedBookmaker = state.bookmakersInfo.selectedBookmaker;
    var feedSelector = function feedSelector() {
        return selectedBookmaker;
    };
    var isUserLoggedIn = _bookmakersList.selectors.createIsLoggedInSelector(feedSelector)(state);
    var selectedBets = state.bookmakersInfo.selectedBets;
    var apiName = _bookmakersList.selectors.createBookmakerApiNameSelector(feedSelector)(state);
    var bookmaker = state.bookmakersList.find(function (bookie) {
        return bookie.feed === selectedBookmaker;
    });
    var userInfo = _userInfo.selectors.createUserInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector)(state);

    return {
        isUserLoggedIn: isUserLoggedIn,
        selectedBets: selectedBets,
        apiName: apiName,
        feed: selectedBookmaker,
        isExternalLogout: !!bookmaker.isExternalLogout,
        currencySign: userInfo.currencySign
    };
};

var buildMultiplesMiddleware = function buildMultiplesMiddleware(store) {
    return function (next) {
        return function (action) {
            var meta = void 0;
            var result = next(action);

            switch (action.type) {
                case _bookmakersInfo.actions.actionTypes.TOGGLE_MULTIPLES_INCLUSION:
                case _bookmakersInfo.actions.actionTypes.ADD_SELECTED_BET:
                case _bookmakersInfo.actions.actionTypes.DELETE_BET:
                case _bookmakersInfo.actions.actionTypes.CLEAR_SUSPENDED_BETS:
                case _bookmakersInfo.actions.actionTypes.UPDATE_ALL_BET_PRICES:
                case _loginPage.actions.actionTypes.LOGIN_SUCCESS:
                    meta = getMeta(store);

                    if (meta.selectedBets.length > 1) {
                        var betsToInclude = meta.selectedBets.filter(function (bet) {
                            return bet.includeInMultiples;
                        });
                        var apiName = meta.isUserLoggedIn ? meta.apiName : SPECULATIVE_API_NAME;
                        dispatchBuildMultiples(store, apiName, betsToInclude, meta.feed, meta.isExternalLogout, meta.currencySign);
                    } else {
                        store.dispatch(_bookmakersInfo.actions.clearMultiples());
                    }

                    break;
                default:
            }

            return result;
        };
    };
};

exports.default = buildMultiplesMiddleware;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(28);

var _reduxThunk = __webpack_require__(466);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _rootReducer = __webpack_require__(489);

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _events = __webpack_require__(485);

var _events2 = _interopRequireDefault(_events);

var _events3 = __webpack_require__(486);

var _events4 = _interopRequireDefault(_events3);

var _buildbets = __webpack_require__(481);

var _buildbets2 = _interopRequireDefault(_buildbets);

var _buildmultiples = __webpack_require__(482);

var _buildmultiples2 = _interopRequireDefault(_buildmultiples);

var _analytics = __webpack_require__(479);

var _analytics2 = _interopRequireDefault(_analytics);

var _freebets = __webpack_require__(487);

var _freebets2 = _interopRequireDefault(_freebets);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function configureStore() {
    var composeEnhancers = _redux.compose;

    /* eslint-disable no-underscore-dangle */
    if (false) {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
    /* eslint-enable no-underscore-dangle */

    var store = (0, _redux.createStore)(_rootReducer2.default, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, _events4.default, _buildbets2.default, _buildmultiples2.default, _freebets2.default, _analytics2.default)));

    (0, _events2.default)(store);

    return store;
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * validateDrawerContainer ensures the js-bs-drawer container is
 * present before react initialises the drawer.
 * @return
 */
var validateContainer = function validateContainer() {
    var drawer = document.getElementById("js-bs-drawer");
    var myBookmakersPage = document.getElementById("js-bs-bookmakersPage");

    if (drawer === null) {
        var drawerContainer = document.createElement("div");
        drawerContainer.setAttribute("id", "js-bs-drawer");
        document.body.appendChild(drawerContainer);
    }

    if (myBookmakersPage === null && window.location.pathname.includes("/my-bookmakers")) {
        if (myBookmakersPage === null && window.location.pathname.includes("/my-bookmakers")) {
            var footer = document.getElementsByClassName("ui-footer")[0];
            var bookmakersPageContainer = document.createElement("div");
            footer.parentNode.insertBefore(bookmakersPageContainer, footer);
            bookmakersPageContainer.setAttribute("id", "js-bs-bookmakersPage");
        }
    }
};

exports.default = function () {
    validateContainer();
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = eventsListener;

var _pageInfo = __webpack_require__(37);

var _bookmakersInfo = __webpack_require__(6);

var _drawer = __webpack_require__(133);

var _bet = __webpack_require__(20);

var _login = __webpack_require__(47);

var _formatDecimalPrice = __webpack_require__(131);

var _formatDecimalPrice2 = _interopRequireDefault(_formatDecimalPrice);

var _bookmakersSorting = __webpack_require__(87);

var _bookmakersSorting2 = _interopRequireDefault(_bookmakersSorting);

var _bookmakersSwitcher = __webpack_require__(122);

var _formatCourseName = __webpack_require__(538);

var _formatCourseName2 = _interopRequireDefault(_formatCourseName);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var onBookmakerGet = function onBookmakerGet(getState) {
    return function () {
        var state = getState();
        var selectedBookmaker = _bookmakersInfo.selectors.selectedBookmakerSelector(state);
        var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER', {
            detail: {
                bookmaker: selectedBookmaker
            }
        });
        document.dispatchEvent(betslipEvent);
    };
};

var onBookmakerSet = function onBookmakerSet(getState, dispatch) {
    return function (_ref) {
        var bookmaker = _ref.detail.bookmaker;

        var state = getState();
        var bookmakersList = state.bookmakersList;

        var selectedBookmaker = _bookmakersInfo.selectors.selectedBookmakerSelector(state);

        if (bookmaker !== selectedBookmaker) {
            dispatch(_bookmakersInfo.actions.selectBookmaker(bookmaker, _bookmakersSorting2.default, bookmakersList));
        }
    };
};

var onOpenBookmakerLogin = function onOpenBookmakerLogin(dispatch) {
    return function (_ref2) {
        var bookmaker = _ref2.detail.bookmaker;

        dispatch(_pageInfo.actions.openBookmakerSwitcherPopover());
        dispatch((0, _bookmakersSwitcher.setRedirectLoginBookmaker)(bookmaker));
    };
};

var onBookmakerLogout = function onBookmakerLogout(dispatch) {
    return function (_ref3) {
        var _ref3$detail = _ref3.detail,
            apiName = _ref3$detail.apiName,
            feed = _ref3$detail.feed,
            isExternalLogout = _ref3$detail.isExternalLogout;

        dispatch((0, _login.requestLogout)(apiName, feed, isExternalLogout));
    };
};

var onSettingsChanged = function onSettingsChanged(dispatch) {
    return function (_ref4) {
        var useDecimalOdds = _ref4.detail.useDecimalOdds;

        dispatch(_pageInfo.actions.setUseDecimalOdds(useDecimalOdds));
    };
};

var onMakeSelection = function onMakeSelection(getState, dispatch) {
    return function (_ref5) {
        var detail = _ref5.detail;

        var state = getState();
        var bookieName = detail.bookieName,
            selectionInfo = detail.selectionInfo;
        var data = selectionInfo.data,
            fractionalPrice = selectionInfo.fractionalPrice,
            decimalPriceString = selectionInfo.decimalPrice,
            isSp = selectionInfo.isSp,
            id = selectionInfo.id,
            eventId = selectionInfo.eventId,
            meetingId = selectionInfo.meetingId,
            eachWayFraction = selectionInfo.eachWayFraction,
            eachWayPlaces = selectionInfo.eachWayPlaces,
            isBog = selectionInfo.isBog;
        var raceId = data.raceId,
            raceDate = data.raceDate,
            horseName = data.horseName,
            courseName = data.courseName,
            raceTime = data.time;

        var decimalPrice = (0, _formatDecimalPrice2.default)(decimalPriceString);
        var formattedCourseName = (0, _formatCourseName2.default)(courseName);
        var priceType = isSp || fractionalPrice === _priceTypes2.default.SP ? _priceTypes2.default.SP : _priceTypes2.default.ODDS;
        var bet = {
            outcomersId: id,
            fractionalPrice: fractionalPrice,
            decimalPrice: decimalPrice,
            isSpOnly: isSp,
            eventId: eventId,
            meetingId: meetingId,
            raceId: raceId,
            raceDate: raceDate,
            horseName: horseName,
            courseName: formattedCourseName,
            raceTime: raceTime,
            isEachWay: false,
            eachWayFraction: eachWayFraction,
            eachWayPlaces: eachWayPlaces,
            isBog: isBog,
            feed: bookieName,
            stake: '',
            priceType: priceType,
            includeInMultiples: true
        };
        var isQuickslipMode = state.drawerInfo.isQuickslipMode;
        var _state$bookmakersInfo = state.bookmakersInfo,
            selectedBets = _state$bookmakersInfo.selectedBets,
            selectedBookmaker = _state$bookmakersInfo.selectedBookmaker;

        // If bet bookie is different to selected bookie (eg odds page)

        if (bookieName !== selectedBookmaker) {
            // Set the selected bookmaker
            dispatch(_bookmakersInfo.actions.setSelectedBookmaker(bookieName));

            // Clear exisiting singles & multiples
            dispatch(_bookmakersInfo.actions.clearSelectedBets());
            dispatch(_bookmakersInfo.actions.clearMultiples());

            // Reset quickslip & minimized state
            dispatch(_drawer.actions.resetEmptyBetslip());

            // Clear any placed bet details
            dispatch(_bet.actions.clearPlacedBetDetails());

            // Reset CTA status
            dispatch(_bet.actions.setBetObstruction(_bet.actions.betObstructions.NONE));

            // Maximise drawer
            dispatch(_drawer.actions.maximizeDrawer());
        }

        // Disable quickslip if it's enabled and user is adding bet 2 and above
        if (isQuickslipMode && selectedBets.length > 0) {
            dispatch(_drawer.actions.setQuickslipMode(false));
        }

        dispatch(_drawer.actions.setThemeFromBookieName(bookieName));
        dispatch(_bookmakersInfo.actions.addSelectedBet(bet));

        // Maximise when in quickslip mode
        if (isQuickslipMode) {
            dispatch(_drawer.actions.maximizeDrawer());
        }

        var selectionMadeEvent = new CustomEvent('BETSLIP.SELECTION_MADE');
        document.dispatchEvent(selectionMadeEvent);
    };
};

var onRemoveSelection = function onRemoveSelection(dispatch) {
    return function (_ref6) {
        var detail = _ref6.detail;
        var bookieName = detail.bookieName,
            selectionInfo = detail.selectionInfo;

        dispatch(_drawer.actions.setThemeFromBookieName(bookieName));
        dispatch(_bookmakersInfo.actions.deleteBet(selectionInfo.id));

        var selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');
        document.dispatchEvent(selectionRemovedEvent);
    };
};

function eventsListener(_ref7) {
    var dispatch = _ref7.dispatch,
        getState = _ref7.getState;

    document.addEventListener('BETSLIP.MAKE_SELECTION', onMakeSelection(getState, dispatch), false);
    document.addEventListener('BETSLIP.SETTINGS_CHANGED', onSettingsChanged(dispatch), false);
    document.addEventListener('BETSLIP.BOOKMAKER.GET', onBookmakerGet(getState), false);
    document.addEventListener('BETSLIP.BOOKMAKER.SET', onBookmakerSet(getState, dispatch), false);
    document.addEventListener('BETSLIP.BOOKMAKER.LOGIN', onOpenBookmakerLogin(dispatch), false);
    document.addEventListener('BETSLIP.BOOKMAKER.LOGOUT', onBookmakerLogout(dispatch), false);
    document.addEventListener('BETSLIP.REMOVE_SELECTION', onRemoveSelection(dispatch), false);
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = eventsMiddleware;

var _reduxPersist = __webpack_require__(119);

var _bookmakersInfo = __webpack_require__(6);

var _events = __webpack_require__(121);

function selectedBookmakerWatcher(oldState, newState) {
    var oldSelectedBookmaker = _bookmakersInfo.selectors.selectedBookmakerSelector(oldState);
    var newSelectedBookmaker = _bookmakersInfo.selectors.selectedBookmakerSelector(newState);
    if (oldSelectedBookmaker !== newSelectedBookmaker) {
        var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER_CHANGED', {
            detail: { bookmaker: newSelectedBookmaker }
        });
        document.dispatchEvent(betslipEvent);
    }
}

function applicationInitialized() {
    var betslipEvent = new CustomEvent('BETSLIP.INITIALIZED');
    document.dispatchEvent(betslipEvent);
}

function eventsMiddleware(store) {
    var initialized = false;
    var rehidrated = false;
    return function (next) {
        return function (action) {
            if (action.type === _events.actionTypes.SET_INITIALIZED) {
                initialized = true;
                if (rehidrated) {
                    applicationInitialized();
                }
            }
            var oldState = store.getState();
            var result = next(action);
            var newState = store.getState();
            if (initialized && rehidrated) {
                selectedBookmakerWatcher(oldState, newState);
            }
            if (action.type === _reduxPersist.REHYDRATE) {
                rehidrated = true;
                if (initialized) {
                    applicationInitialized();
                }
            }
            return result;
        };
    };
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookmakersInfo = __webpack_require__(6);

var _freeBets = __webpack_require__(35);

var _bookmakersList = __webpack_require__(5);

var _bet = __webpack_require__(20);

var freeBetsMiddleware = function freeBetsMiddleware(store) {
    return function (next) {
        return function (action) {
            var result = next(action);

            switch (action.type) {
                case _bookmakersInfo.actions.actionTypes.ADD_SELECTED_BET:
                case _bookmakersInfo.actions.actionTypes.DELETE_BET:
                case _bookmakersInfo.actions.actionTypes.CLEAR_SELECTED_BETS:
                case _bookmakersInfo.actions.actionTypes.BUILD_BET_REQUEST:
                case _bookmakersInfo.actions.actionTypes.SET_SELECTED_BOOKMAKER:
                case _bookmakersList.actions.actionTypes.SET_LOGGEDOUT:
                case _bet.actions.actionTypes.CLEAR_PLACED_BET_DETAILS:
                case _bet.actions.actionTypes.PLACE_BET_SUCCESS:
                    store.dispatch(_freeBets.actions.clearFreeBet());
                    break;
                default:
            }

            return result;
        };
    };
};

exports.default = freeBetsMiddleware;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEssentialBettingState = undefined;

var _bookmakersList = __webpack_require__(5);

var _bookmakersInfo = __webpack_require__(6);

var _userInfo = __webpack_require__(11);

// eslint-disable-next-line import/prefer-default-export
var getEssentialBettingState = exports.getEssentialBettingState = function getEssentialBettingState(store) {
    var state = store.getState();
    var selectedBookmaker = state.bookmakersInfo.selectedBookmaker;
    var feedSelector = function feedSelector() {
        return selectedBookmaker;
    };
    var isUserLoggedIn = _bookmakersList.selectors.createIsLoggedInSelector(feedSelector)(state);
    var selectedBets = state.bookmakersInfo.selectedBets;
    var apiName = _bookmakersList.selectors.createBookmakerApiNameSelector(feedSelector)(state);
    var bookmaker = state.bookmakersList.find(function (bookie) {
        return bookie.feed === selectedBookmaker;
    });
    var userInfo = _userInfo.selectors.createUserInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector)(state);

    return {
        isUserLoggedIn: isUserLoggedIn,
        selectedBets: selectedBets,
        apiName: apiName,
        feed: selectedBookmaker,
        isExternalLogout: !!bookmaker.isExternalLogout || null,
        currencySign: userInfo.currencySign
    };
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reduxForm = __webpack_require__(44);

var _reduxPersist = __webpack_require__(119);

var _redux = __webpack_require__(28);

var _storage = __webpack_require__(465);

var _storage2 = _interopRequireDefault(_storage);

var _pageInfo = __webpack_require__(37);

var _bookmakersSwitcher = __webpack_require__(201);

var _loginPage = __webpack_require__(36);

var _bookmakersList = __webpack_require__(5);

var _bookmakersInfo = __webpack_require__(6);

var _drawer = __webpack_require__(133);

var _bet = __webpack_require__(20);

var _freeBets = __webpack_require__(35);

var _modals = __webpack_require__(29);

var _topUp = __webpack_require__(59);

var _externalAccount = __webpack_require__(34);

var _gdpr = __webpack_require__(124);

var _bookmakersListPopover = __webpack_require__(208);

var _bookmakersInfo2 = __webpack_require__(205);

var _drawer2 = __webpack_require__(224);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// The persistence version should be bumped (major) whenever we change store data in
// a major way. We can then define migrations to avoid bugs.
// @see README.md
// @see https://github.com/rt2zz/redux-persist/blob/master/docs/migrations.md
//
// IMPORTANT - `version` can only be an integer
// i.e. every version is treated as a major version
var persistConfig = {
    key: 'betslip',
    storage: _storage2.default,
    version: 15,
    whitelist: ['bookmakersInfo', 'drawerInfo'],
    migrate: function migrate(oldState, version) {
        if (!oldState) {
            return Promise.resolve({});
        }

        // eslint-disable-next-line no-underscore-dangle
        if (oldState._persist && oldState._persist.version === version) {
            return Promise.resolve(oldState);
        }

        return Promise.resolve(_extends({}, oldState, {
            bookmakersInfo: _bookmakersInfo2.initialState,
            drawerInfo: _drawer2.initialState
        }));
    }
};
var rootReducer = (0, _redux.combineReducers)({
    form: _reduxForm.reducer,
    modals: _modals.reducer,
    pageInfo: _pageInfo.reducer,
    bookmakersInfo: _bookmakersInfo.reducer,
    bookmakersList: _bookmakersList.reducer,
    bookmakersSwitcher: _bookmakersSwitcher.reducer,
    loginPage: _loginPage.reducer,
    drawerInfo: _drawer.reducer,
    bet: _bet.reducer,
    freeBets: _freeBets.reducer,
    topUp: _topUp.reducer,
    externalAccount: _externalAccount.reducer,
    gdpr: _gdpr.reducer,
    bookmakersListPopover: _bookmakersListPopover.reducer
});
var persistedRootReducer = (0, _reduxPersist.persistReducer)(persistConfig, rootReducer);

exports.default = persistedRootReducer;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPageAfterNextRequestedSelector = exports.hasNextPageSelector = exports.betHistoryErrorsSelector = exports.pageIsLoadingSelector = exports.currentPageItemsSelector = exports.currentPageSelector = undefined;

var _reselect = __webpack_require__(25);

var first = function first(array, defValue) {
    if (array.length > 0) {
        return array[0];
    }
    return defValue;
};

var accountPageStateSelector = function accountPageStateSelector(state) {
    return state.bookmakersSwitcher.accountPage;
};

var currentPageSelector = exports.currentPageSelector = (0, _reselect.createSelector)(accountPageStateSelector, function (accountPage) {
    return accountPage.currentPage;
});

var betHistorySelector = (0, _reselect.createSelector)(accountPageStateSelector, function (accountPage) {
    return accountPage.betHistory;
});

var currentPageItemsSelector = exports.currentPageItemsSelector = (0, _reselect.createSelector)([betHistorySelector, currentPageSelector], function (betHistory, currentPage) {
    var currentPageItems = betHistory.filter(function (item) {
        return item.page === currentPage;
    });
    var itemsCount = currentPageItems.length;
    var firstItem = first(currentPageItems, {});
    if (itemsCount === 1 && (firstItem.loading || firstItem.errorInfo)) {
        return [];
    }
    return currentPageItems;
});

var pageIsLoadingSelector = exports.pageIsLoadingSelector = (0, _reselect.createSelector)([betHistorySelector], function (betHistory) {
    var betHistoryItems = betHistory.filter(function (item) {
        return item.loading;
    });
    return first(betHistoryItems, {}).loading || false;
});

var betHistoryErrorsSelector = exports.betHistoryErrorsSelector = (0, _reselect.createSelector)([betHistorySelector], function (betHistory) {
    var betHistoryItems = betHistory.filter(function (item) {
        return item.errorInfo;
    });
    return first(betHistoryItems, {}).errorInfo || null;
});

var hasNextPageSelector = exports.hasNextPageSelector = (0, _reselect.createSelector)([betHistorySelector, currentPageSelector], function (betHistory, currentPage) {
    var page = currentPage + 1;
    var items = betHistory.filter(function (item) {
        return item.page === page;
    });
    var itemsCount = items.length;
    var firstItem = first(items, {});
    if (itemsCount === 1 && (firstItem.loading || firstItem.errorInfo)) {
        return false;
    }
    return itemsCount > 0;
});

var isPageAfterNextRequestedSelector = exports.isPageAfterNextRequestedSelector = (0, _reselect.createSelector)([betHistorySelector, currentPageSelector], function (betHistory, currentPage) {
    var page = currentPage + 2;
    var items = betHistory.filter(function (item) {
        return item.page === page;
    });
    var itemsCount = items.length;
    return itemsCount > 0;
});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getErrorText;
/**
 * Generate error config by server error.
 * @param {Object} errors server errors.
 * @param {Object} [error.1011] no bets available.
 * @return {String} client bet error message.
 */
function getErrorText(errors) {
    var errorCodes = Object.keys(errors);
    var errorCode = errorCodes.pop();
    if (errorCode === '404') {
        return 'No bets found.';
    }
    return 'We have experienced an error and could not retrieve your bet history.' + ' Please try again later.';
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BetHistoryPage = __webpack_require__(557);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BetHistoryPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _accountPage = __webpack_require__(55);

var _betHistory = __webpack_require__(82);

var initialState = {
    betHistory: [],
    isSettled: false,
    pageLength: _betHistory.BET_HISTORY_PAGE_LENGTH,
    currentPage: 1,
    showBalance: true,
    isExternalBetHistoryError: null,
    externalBetHistoryUrl: null
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _accountPage.actionTypes.CLEAR_BET_HISTORY:
            return _extends({}, state, {
                betHistory: [],
                currentPage: 1
            });
        case _accountPage.actionTypes.BET_HISTORY_REQUESTED:
            return _extends({}, state, {
                betHistory: state.betHistory.concat({
                    loading: true
                })
            });
        case _accountPage.actionTypes.BET_HISTORY_RECEIVED:
            return _extends({}, state, {
                betHistory: action.betHistory
            });
        case _accountPage.actionTypes.SET_BET_HISTORY_ERROR:
            return _extends({}, state, {
                betHistory: [{ errorInfo: action.errorInfo }]
            });
        case _accountPage.actionTypes.BET_HISTORY_PAGE_CHANGE:
            return _extends({}, state, {
                currentPage: action.page
            });
        case _accountPage.actionTypes.TOGGLE_IS_SETTLED:
            return _extends({}, state, {
                isSettled: !state.isSettled,
                betHistory: [],
                currentPage: 1
            });
        case _accountPage.actionTypes.SET_EXTERNAL_BET_HISTORY_URL:
            return _extends({}, state, {
                externalBetHistoryUrl: action.externalBetHistoryUrl,
                isExternalBetHistoryError: false
            });
        case _accountPage.actionTypes.SET_EXTERNAL_BET_HISTORY_ERROR:
            return _extends({}, state, {
                isExternalBetHistoryError: true
            });
        case _accountPage.actionTypes.CLEAR_EXTERNAL_BET_HISTORY_DATA:
            return _extends({}, state, {
                isExternalBetHistoryError: null,
                externalBetHistoryUrl: null
            });
        default:
            return state;
    }
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPageAfterNextRequestedSelector = exports.hasNextPageSelector = exports.betHistoryErrorsSelector = exports.pageIsLoadingSelector = exports.currentPageItemsSelector = exports.currentPageSelector = undefined;

var _reselect = __webpack_require__(25);

var first = function first(array, defValue) {
    if (array.length > 0) {
        return array[0];
    }
    return defValue;
};

var accountPageStateSelector = function accountPageStateSelector(state) {
    return state.bookmakersSwitcher.accountPage;
};

var currentPageSelector = exports.currentPageSelector = (0, _reselect.createSelector)(accountPageStateSelector, function (accountPage) {
    return accountPage.currentPage;
});

var betHistorySelector = (0, _reselect.createSelector)(accountPageStateSelector, function (accountPage) {
    return accountPage.betHistory;
});

var currentPageItemsSelector = exports.currentPageItemsSelector = (0, _reselect.createSelector)([betHistorySelector, currentPageSelector], function (betHistory, currentPage) {
    var currentPageItems = betHistory.filter(function (item) {
        return item.page === currentPage;
    });
    var itemsCount = currentPageItems.length;
    var firstItem = first(currentPageItems, {});
    if (itemsCount === 1 && (firstItem.loading || firstItem.errorInfo)) {
        return [];
    }
    return currentPageItems;
});

var pageIsLoadingSelector = exports.pageIsLoadingSelector = (0, _reselect.createSelector)([betHistorySelector], function (betHistory) {
    var betHistoryItems = betHistory.filter(function (item) {
        return item.loading;
    });
    return first(betHistoryItems, {}).loading || false;
});

var betHistoryErrorsSelector = exports.betHistoryErrorsSelector = (0, _reselect.createSelector)([betHistorySelector], function (betHistory) {
    var betHistoryItems = betHistory.filter(function (item) {
        return item.errorInfo;
    });
    return first(betHistoryItems, {}).errorInfo || null;
});

var hasNextPageSelector = exports.hasNextPageSelector = (0, _reselect.createSelector)([betHistorySelector, currentPageSelector], function (betHistory, currentPage) {
    var page = currentPage + 1;
    var items = betHistory.filter(function (item) {
        return item.page === page;
    });
    var itemsCount = items.length;
    var firstItem = first(items, {});
    if (itemsCount === 1 && (firstItem.loading || firstItem.errorInfo)) {
        return false;
    }
    return itemsCount > 0;
});

var isPageAfterNextRequestedSelector = exports.isPageAfterNextRequestedSelector = (0, _reselect.createSelector)([betHistorySelector, currentPageSelector], function (betHistory, currentPage) {
    var page = currentPage + 2;
    var items = betHistory.filter(function (item) {
        return item.page === page;
    });
    var itemsCount = items.length;
    return itemsCount > 0;
});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccountInfoPage = __webpack_require__(564);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccountInfoPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getErrorText;
/**
 * Generate error config by server error.
 * @param {Object} errors server errors.
 * @param {Object} [error.1011] no bets available.
 * @return {String} client bet error message.
 */
function getErrorText(errors) {
    var errorCodes = Object.keys(errors);
    var errorCode = errorCodes.pop();
    if (errorCode === '404') {
        return 'No bets found.';
    }
    return 'We have experienced an error and could not retrieve your bet history.' + ' Please try again later.';
}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BetHistoryPage = __webpack_require__(568);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BetHistoryPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(28);

var _accountPage = __webpack_require__(199);

var _bookmakersSwitcherInfo = __webpack_require__(499);

var _bookmakersSwitcherInfo2 = _interopRequireDefault(_bookmakersSwitcherInfo);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var bookmakersSwitcherReducer = (0, _redux.combineReducers)({
    accountPage: _accountPage.reducer,
    info: _bookmakersSwitcherInfo2.default
});

exports.default = bookmakersSwitcherReducer;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _bookmakersSwitcher = __webpack_require__(122);

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _bookmakersSwitcher.actionTypes.SET_REDIRECT_LOGIN_BOOKMAKER:
            return _extends({}, state, {
                redirectToLoginBookmaker: action.feed
            });
        case _bookmakersSwitcher.actionTypes.CLEAR_REDIRECT_LOGIN_BOOKMAKER:
            return _extends({}, state, {
                redirectToLoginBookmaker: null
            });
        default:
            return state;
    }
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChooseBookmakerPage = exports.default = undefined;

var _ChooseBookmakerPage = __webpack_require__(572);

var _ChooseBookmakerPage2 = _interopRequireDefault(_ChooseBookmakerPage);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _ChooseBookmakerPage2.default;
exports.ChooseBookmakerPage = _ChooseBookmakerPage.ChooseBookmakerPage;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgottenPasswordPage = __webpack_require__(579);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ForgottenPasswordPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginPage = __webpack_require__(580);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LoginPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signUpOfferPage = __webpack_require__(581);

var _signUpOfferPage2 = _interopRequireDefault(_signUpOfferPage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _signUpOfferPage2.default;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _bet = __webpack_require__(203);

var _bookmakersInfo = __webpack_require__(33);

var _bookmakersList = __webpack_require__(56);

var _betToViewQualification = __webpack_require__(534);

var _betToViewQualification2 = _interopRequireDefault(_betToViewQualification);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var initialState = {
    isPlacingBet: false,
    placedBetDetails: {
        containsPending: false,
        freeBet: null,
        bets: []
    },
    obstruction: _bet.betObstructions.NONE
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _bet.actionTypes.PLACE_BET_REQUEST:
            return _extends({}, state, {
                isPlacingBet: action.isPlacingBet
            });
        case _bet.actionTypes.PLACE_BET_SUCCESS:
            (0, _betToViewQualification2.default)(action.placedBetDetails.bets);
            return _extends({}, state, {
                isPlacingBet: false,
                placedBetDetails: action.placedBetDetails
            });
        case _bet.actionTypes.CLEAR_PLACED_BET_DETAILS:
        case _bookmakersInfo.actionTypes.DELETE_BET:
        case _bookmakersList.actionTypes.SET_LOGGEDOUT:
            return _extends({}, state, {
                isPlacingBet: false,
                placedBetDetails: initialState.placedBetDetails
            });
        case _bet.actionTypes.SET_BET_OBSTRUCTION:
            return _extends({}, state, {
                obstruction: action.obstruction
            });
        case _bet.actionTypes.CLEAR_BET_OBSTRUCTION:
            return _extends({}, state, {
                obstruction: _bet.betObstructions.NONE
            });
        default:
            return state;
    }
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _bookmakersInfo = __webpack_require__(33);

var _cleanStakeInput = __webpack_require__(60);

var _cleanStakeInput2 = _interopRequireDefault(_cleanStakeInput);

var _apiErrors = __webpack_require__(22);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var initialState = {
    isEditingStake: false,
    isSuspended: false,
    isSpAvailable: true,
    isLockedStake: false,
    error: {
        errorId: null,
        message: null
    }
};

/* eslint-disable default-case, consistent-return */

exports.default = function (bet, action) {
    var formattedStake = void 0;
    var stakeNumber = void 0;
    var parsed = void 0;

    switch (action.type) {

        case _bookmakersInfo.actionTypes.ADD_SELECTED_BET:

            return _extends({}, initialState, action.betInfo);

        case _bookmakersInfo.actionTypes.SET_STAKE_FOR_SELECTED_BET:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            formattedStake = (0, _cleanStakeInput2.default)(action.stake);
            parsed = parseFloat(formattedStake);
            stakeNumber = isNaN(parsed) ? 0 : parsed;

            return _extends({}, bet, {
                stake: stakeNumber <= 99999.99 ? formattedStake : bet.stake
            });

        case _bookmakersInfo.actionTypes.SET_ISEACHWAY_FOR_SELECTED_BET:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                isEachWay: action.isEachWay
            });

        case _bookmakersInfo.actionTypes.SET_PRICE_TYPE_FOR_SELECTED_BET:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                priceType: action.priceType
            });

        case _bookmakersInfo.actionTypes.SET_IS_EDITING_STAKE:

            if (bet.outcomersId !== action.outcomersId) {
                return _extends({}, bet, {
                    isEditingStake: false
                });
            }

            return _extends({}, bet, {
                isEditingStake: action.isEditingStake
            });

        case _bookmakersInfo.actionTypes.SET_ERROR:
        case _bookmakersInfo.actionTypes.SET_ERROR_ON_BUILD:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                error: action.error
            });

        case _bookmakersInfo.actionTypes.SET_SUSPENDED_BET:
        case _bookmakersInfo.actionTypes.SET_SUSPENDED_BET_ON_BUILD:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                isSuspended: action.isSuspended
            });

        case _bookmakersInfo.actionTypes.CLEAR_ERROR:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                error: {
                    errorId: null,
                    message: null
                }
            });

        case _bookmakersInfo.actionTypes.SET_PRICE_CHANGED:
        case _bookmakersInfo.actionTypes.SET_PRICE_CHANGED_ON_BUILD:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                priceChanged: {
                    decimalPrice: action.decimalPrice,
                    fractionalPrice: action.fractionalPrice
                }
            });

        case _bookmakersInfo.actionTypes.UPDATE_BET_PRICE:
            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                decimalPrice: action.decimalPrice,
                fractionalPrice: action.fractionalPrice,
                isSpOnly: false
            });

        case _bookmakersInfo.actionTypes.UPDATE_ALL_BET_PRICES:
            if (bet.priceChanged === undefined) return _extends({}, bet);

            return _extends({}, bet, {
                decimalPrice: bet.priceChanged.decimalPrice,
                fractionalPrice: bet.priceChanged.fractionalPrice
            });

        case _bookmakersInfo.actionTypes.UPDATE_ALL_STARTING_PRICES_AVAILABILITY:
            if (bet.error.errorId !== _apiErrors.ERROR_CODES.STARTING_PRICE_UNAVAILABLE) return _extends({}, bet);

            return _extends({}, bet, {
                isSpAvailable: false,
                priceType: 'Odds'
            });

        case _bookmakersInfo.actionTypes.CLEAR_ALL_ERRORS:
            return _extends({}, bet, {
                error: {
                    errorId: null,
                    message: null
                }
            });

        case _bookmakersInfo.actionTypes.TOGGLE_MULTIPLES_INCLUSION:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                includeInMultiples: action.include
            });

        case _bookmakersInfo.actionTypes.SET_MINIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                associatedBet: _extends({}, bet.associatedBet, {
                    minStake: action.minimumStake
                })
            });

        case _bookmakersInfo.actionTypes.SET_FREE_BET_MAXIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                associatedBet: _extends({}, bet.associatedBet, {
                    freeBetMaxStake: action.maximumStake
                })
            });

        case _bookmakersInfo.actionTypes.SET_FREE_BET_MINIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                associatedBet: _extends({}, bet.associatedBet, {
                    freeBetMinStake: action.minimumStake
                })
            });

        case _bookmakersInfo.actionTypes.SET_MAXIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                associatedBet: _extends({}, bet.associatedBet, {
                    maxStake: action.maximumStake
                })
            });

        case _bookmakersInfo.actionTypes.SET_LOCKED_STAKE:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                stake: action.stake,
                isEachWay: false,
                isLockedStake: true
            });

        case _bookmakersInfo.actionTypes.CLEAR_LOCKED_STAKE:

            if (bet.outcomersId !== action.outcomersId) return _extends({}, bet);

            return _extends({}, bet, {
                stake: '',
                isLockedStake: false
            });
    }
};
/* eslint-enable default-case, consistent-return */

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _bookmakersInfo = __webpack_require__(33);

var _cleanStakeInput = __webpack_require__(60);

var _cleanStakeInput2 = _interopRequireDefault(_cleanStakeInput);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var initialState = {
    isEditingStake: false,
    stakeValue: '',
    isEachWay: false,
    error: {
        errorId: null,
        message: null
    }
};

var determineStake = function determineStake(newStake, exisitngStake) {
    var formattedStake = (0, _cleanStakeInput2.default)(newStake);
    var parsed = parseFloat(formattedStake);
    var stakeNumber = isNaN(parsed) ? 0 : parsed;

    return stakeNumber <= 99999.99 ? formattedStake : exisitngStake;
};

var reorderBetSelections = function reorderBetSelections(betSelections, index, selectionId) {
    var reorderedSelections = betSelections;
    var roundedIndex = Math.round(index);
    var selectIndex = betSelections.findIndex(function (bet) {
        return bet.selectionId === selectionId;
    });

    switch (roundedIndex) {
        case 1:
            if (selectIndex + roundedIndex < reorderedSelections.length) {
                var selection = reorderedSelections[selectIndex];
                reorderedSelections[selectIndex] = reorderedSelections[selectIndex + roundedIndex];
                reorderedSelections[selectIndex + roundedIndex] = selection;
            }
            break;
        case -1:
            if (selectIndex + roundedIndex >= 0) {
                var _selection = reorderedSelections[selectIndex];
                reorderedSelections[selectIndex] = reorderedSelections[selectIndex + roundedIndex];
                reorderedSelections[selectIndex + roundedIndex] = _selection;
            }
            break;
        default:
            return reorderedSelections;
    }

    return reorderedSelections;
};

/* eslint-disable default-case, consistent-return */

exports.default = function (state, multiple, action) {
    var betSelections = void 0;
    var previousStake = void 0;
    var previousEachWay = void 0;

    switch (action.type) {

        case _bookmakersInfo.actionTypes.SET_MULTIPLES:

            betSelections = multiple.betSelections.map(function (bet) {
                return {
                    selectionId: bet.selectionId,
                    marketId: bet.marketId,
                    eventId: bet.eventId
                };
            });

            return _extends({}, initialState, {
                betType: multiple.betType,
                maxStake: multiple.maxStake,
                minStake: multiple.minStake,
                numberLines: multiple.numberLines,
                optionId: multiple.optionId,
                betSelections: betSelections
            });

        case _bookmakersInfo.actionTypes.SET_STAKE_FOR_MULTIPLE:

            if (multiple.optionId !== action.optionId) return _extends({}, multiple);

            return _extends({}, multiple, {
                stakeValue: determineStake(action.stake, multiple.stakeValue)
            });

        case _bookmakersInfo.actionTypes.SET_IS_EDITING_STAKE_FOR_MULTIPLE:

            if (multiple.optionId !== action.optionId) {
                return _extends({}, multiple, {
                    isEditingStake: false
                });
            }

            return _extends({}, multiple, {
                isEditingStake: action.isEditingStake
            });

        case _bookmakersInfo.actionTypes.SET_IS_EACHWAY_FOR_MULTIPLE:

            if (multiple.optionId !== action.optionId) return _extends({}, multiple);

            return _extends({}, multiple, {
                isEachWay: action.isEachWay
            });

        case _bookmakersInfo.actionTypes.SET_MULTIPLES_ERROR:

            if (multiple.optionId !== action.optionId) return _extends({}, multiple);

            return _extends({}, multiple, {
                error: action.error
            });

        case _bookmakersInfo.actionTypes.CLEAR_MULTIPLES_ERROR:

            if (multiple.optionId !== action.optionId) return _extends({}, multiple);

            return _extends({}, multiple, {
                error: {
                    errorId: null,
                    message: null
                }
            });

        case _bookmakersInfo.actionTypes.CLEAR_ALL_MULTIPLES_ERRORS:
            return _extends({}, multiple, {
                error: {
                    errorId: null,
                    message: null
                }
            });

        case _bookmakersInfo.actionTypes.RESTORE_MULTIPLES_STAKES:
            previousStake = state.multiplesStakes.find(function (multipleStake) {
                return multipleStake.optionId === multiple.optionId;
            });

            if (!previousStake) return _extends({}, multiple);

            return _extends({}, multiple, {
                stakeValue: determineStake(previousStake.stake, multiple.stakeValue)
            });

        case _bookmakersInfo.actionTypes.RESTORE_MULTIPLES_EACHWAY:
            previousEachWay = state.multiplesEachWay.find(function (multipleEachWay) {
                return multipleEachWay.optionId === multiple.optionId;
            });

            if (!previousEachWay) return _extends({}, multiple);

            return _extends({}, multiple, {
                isEachWay: previousEachWay.isEachWay
            });

        case _bookmakersInfo.actionTypes.CHANGE_SELECTION_ORDER:

            if (multiple.optionId !== action.optionId) {
                return _extends({}, multiple);
            }

            return _extends({}, multiple, {
                betSelections: reorderBetSelections(multiple.betSelections, action.index, action.selectionId)
            });
    }
};
/* eslint-enable default-case, consistent-return */

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _bookmakersInfo = __webpack_require__(33);

function removeUserName(bookmaker) {
    var newBookmaker = _extends({}, bookmaker);
    delete newBookmaker.username;
    return newBookmaker;
}

var updateBookmaker = function updateBookmaker() {
    var bookmaker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _bookmakersInfo.actionTypes.TOGGLE_BALANCE_VISIBILITY:
            return _extends({}, bookmaker, {
                showBalance: !(bookmaker.showBalance !== false)
            });
        case _bookmakersInfo.actionTypes.SAVE_USERNAME:
            return _extends({}, bookmaker, {
                username: action.username
            });
        case _bookmakersInfo.actionTypes.REMOVE_USERNAME:
            return removeUserName(bookmaker);
        default:
            return bookmaker;
    }
};

exports.default = updateBookmaker;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.default = bookmakersListReducer;

var _bookmakers = __webpack_require__(84);

var _bookmakers2 = _interopRequireDefault(_bookmakers);

var _bookmakersList = __webpack_require__(56);

var _bookmakersListItem = __webpack_require__(510);

var _bookmakersListItem2 = _interopRequireDefault(_bookmakersListItem);

var _userAccountsInfo = __webpack_require__(222);

var _userAccountsInfo2 = _interopRequireDefault(_userAccountsInfo);

var _pageInfo = __webpack_require__(37);

var _bookmakers3 = __webpack_require__(129);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var bookmakers = (0, _bookmakers2.default)();
var pageInfoActionTypes = _pageInfo.actions.actionTypes;

// Purpose: Function for creating redirect URLs to tackle AdBlockers
// /redirect/ is actual Janus NextJS page!!!
var createRedirectUrl = function createRedirectUrl(url, name) {
    return "/redirect/?url=" + encodeURIComponent(url) + "&name=" + name;
};

function bookmakersListReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bookmakers;
    var action = arguments[1];

    switch (action.type) {
        case _bookmakersList.actionTypes.USER_INFO_REQUESTING:
        case _bookmakersList.actionTypes.SET_USER_INFO:
        case _bookmakersList.actionTypes.SET_USER_INFO_ERROR:
        case _bookmakersList.actionTypes.SET_AUTH_INFO:
        case _bookmakersList.actionTypes.SET_LOGGEDOUT:
            return state.map(function (bookmaker) {
                if (bookmaker.feed === action.feed) {
                    return (0, _bookmakersListItem2.default)(bookmaker, action);
                }
                return bookmaker;
            });
        case _bookmakersList.actionTypes.SET_LOGGEDIN_BOOKMAKERS:
            return state.map(function (bookmaker) {
                if (action.feeds.includes(bookmaker.feed)) {
                    return (0, _bookmakersListItem2.default)(bookmaker, action);
                }
                return bookmaker;
            });
        case _bookmakersList.actionTypes.SET_LOGIN_SUCCESS:
            return state.map(function (bookmaker) {
                if (bookmaker.feed === action.feed) {
                    (0, _userAccountsInfo2.default)(bookmaker, true);
                    return _extends({}, bookmaker, {
                        isLoggedIn: true,
                        justLoggedIn: true
                    });
                }
                return _extends({}, bookmaker, {
                    justLoggedIn: false
                });
            });
        case _bookmakersList.actionTypes.CLEAR_JUST_LOGGEDIN:
            return state.map(function (bookmaker) {
                return _extends({}, bookmaker, {
                    justLoggedIn: false
                });
            });
        case pageInfoActionTypes.APP_CONFIG_RECEIVED:
            {
                var targetDevice = action.isPhone ? "mobile" : "desktop";

                var bookmakersConfig = action.config.data.bookmakerOffersTierOne;

                var betslipBookmakers = state.map(function (bookmaker) {
                    var _bookmakersConfig$boo = bookmakersConfig[bookmaker.dynamicDataKey][targetDevice],
                        name = _bookmakersConfig$boo.name,
                        offer = _bookmakersConfig$boo.offer,
                        alt_offer = _bookmakersConfig$boo.alt_offer,
                        linkText = _bookmakersConfig$boo.linkText,
                        sign_up_link_1 = _bookmakersConfig$boo.sign_up_link_1,
                        sign_up_link_2 = _bookmakersConfig$boo.sign_up_link_2,
                        sign_up_link_3 = _bookmakersConfig$boo.sign_up_link_3,
                        sign_up_link_9 = _bookmakersConfig$boo.sign_up_link_9,
                        bookmaker_terms_conditions = _bookmakersConfig$boo.bookmaker_terms_conditions,
                        tsAndCs = _bookmakersConfig$boo.tsAndCs,
                        Top_up_bookie_name = _bookmakersConfig$boo.Top_up_bookie_name,
                        Top_up_bookie_url = _bookmakersConfig$boo.Top_up_bookie_url,
                        Withdraw_bookie_url = _bookmakersConfig$boo.Withdraw_bookie_url,
                        Withdraw_bookie_name = _bookmakersConfig$boo.Withdraw_bookie_name,
                        Forgotten_bookie_url = _bookmakersConfig$boo.Forgotten_bookie_url;

                    var isWilliamHill = name === "William Hill";
                    var isMobile = targetDevice === "mobile";
                    var bookmakerRegLink = isMobile ? createRedirectUrl(sign_up_link_3, name) : createRedirectUrl(sign_up_link_9, name);
                    var bookmakerOfferLink = isMobile ? createRedirectUrl(sign_up_link_1, name) : createRedirectUrl(sign_up_link_2, name);

                    var pageInfo = _extends({}, bookmaker, {
                        registrationOfferHeadline: alt_offer || offer,
                        registrationOffer: tsAndCs,
                        registrationOfferLinkText: linkText,
                        registrationOfferLinkUrl: createRedirectUrl(sign_up_link_1, name),
                        promoCode: null,
                        registrationOfferDetailsLink: bookmakerOfferLink,
                        termsAndConditionsLink: bookmaker_terms_conditions,
                        registrationLink: bookmakerRegLink,
                        withdrawBookmakerName: Withdraw_bookie_name || null,
                        withdrawBookmakerUrl: Withdraw_bookie_url || null,
                        forgottenPhoneNumber: null,
                        forgottenBookmakerName: isWilliamHill ? "www.willhill.com" : null,
                        forgottenBookmakerUrl: Forgotten_bookie_url || null,
                        shouldNotRender: false
                    });

                    /* eslint-disable camelcase */
                    if (Top_up_bookie_url !== null && Top_up_bookie_name !== null) {
                        pageInfo.topUpBookmakerName = Top_up_bookie_name;
                        pageInfo.topUpBookmakerUrl = Top_up_bookie_url;
                    }
                    /* eslint-enable camelcase */

                    return pageInfo;
                });

                var nonBetslipBookmakers = [{
                    name: _bookmakers3.bookmakerNames.bestOdds,
                    feed: "#BESTODDS",
                    displayName: "Best Odds",
                    shouldNotRender: true,
                    availableOnPhone: true
                },
                // Note:
                // We only comment the bookmaker for now.
                // If in future SSG don't work with it, we will delete the bookmaker
                // {
                //     name: "SportingBet",
                //     feed: "SPORTING INDEX",
                //     displayName: "Sporting Bet",
                //     shouldNotRender: true,
                //     availableOnPhone: false,
                // },
                {
                    name: _bookmakers3.bookmakerNames.betfred,
                    feed: 'BETFRED',
                    displayName: 'Betfred',
                    shouldNotRender: true,
                    availableOnPhone: false
                }, {
                    name: _bookmakers3.bookmakerNames.boyleSports,
                    feed: "BOLEYSPORTS",
                    displayName: "Boyle Sports",
                    shouldNotRender: true,
                    availableOnPhone: false
                }, {
                    name: _bookmakers3.bookmakerNames.betVictor,
                    feed: "VC",
                    displayName: "Bet Victor",
                    shouldNotRender: true,
                    availableOnPhone: false
                }, {
                    name: _bookmakers3.bookmakerNames.tote,
                    feed: "TOTE",
                    displayName: "TOTE",
                    shouldNotRender: true,
                    availableOnPhone: false
                }];

                return [].concat(_toConsumableArray(betslipBookmakers), nonBetslipBookmakers);
            }
        default:
            return state;
    }
}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createFreeBetsEnabledSelector = exports.createBookmakerApiNameSelector = exports.createIsLoggedInSelector = exports.createUserInfoSelector = exports.createBookmakerInfoSelector = exports.bookmakersListSelector = undefined;

var _reselect = __webpack_require__(25);

var bookmakersListSelector = exports.bookmakersListSelector = function bookmakersListSelector(_ref) {
    var bookmakersList = _ref.bookmakersList;
    return bookmakersList;
};

var createBookmakerInfoSelector = exports.createBookmakerInfoSelector = function createBookmakerInfoSelector(feedSelector) {
    return (0, _reselect.createSelector)([feedSelector, bookmakersListSelector], function (selectedFeed, bookmakers) {
        return bookmakers.find(function (_ref2) {
            var feed = _ref2.feed;
            return selectedFeed === feed;
        }) || null;
    });
};

var createUserInfoSelector = exports.createUserInfoSelector = function createUserInfoSelector(feedSelector) {
    return (0, _reselect.createSelector)(createBookmakerInfoSelector(feedSelector), function (bookmakerInfo) {
        return !!bookmakerInfo && bookmakerInfo.userInfo || {};
    });
};

var createIsLoggedInSelector = exports.createIsLoggedInSelector = function createIsLoggedInSelector(feedSelector) {
    return (0, _reselect.createSelector)(createBookmakerInfoSelector(feedSelector), function (bookmakerInfo) {
        return !!bookmakerInfo && bookmakerInfo.isLoggedIn;
    });
};

var createBookmakerApiNameSelector = exports.createBookmakerApiNameSelector = function createBookmakerApiNameSelector(feedSelector) {
    return (0, _reselect.createSelector)(createBookmakerInfoSelector(feedSelector), function (bookmakerInfo) {
        return !!bookmakerInfo && bookmakerInfo.apiName || '';
    });
};

var createFreeBetsEnabledSelector = exports.createFreeBetsEnabledSelector = function createFreeBetsEnabledSelector(feedSelector) {
    return (0, _reselect.createSelector)(createBookmakerInfoSelector(feedSelector), function (bookmakerInfo) {
        return !!bookmakerInfo && bookmakerInfo.freeBetsEnabled;
    });
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.default = bookmakersListItemReducer;

var _bookmakersList = __webpack_require__(56);

var _userAccountsInfo = __webpack_require__(222);

var _userAccountsInfo2 = _interopRequireDefault(_userAccountsInfo);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function bookmakersListItemReducer() {
    var bookmaker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _bookmakersList.actionTypes.SET_AUTH_INFO:
            return _extends({}, bookmaker, {
                auth: action.info
            });
        case _bookmakersList.actionTypes.SET_LOGGEDIN_BOOKMAKERS:
            return _extends({}, bookmaker, {
                isLoggedIn: true
            });
        case _bookmakersList.actionTypes.USER_INFO_REQUESTING:
            return _extends({}, bookmaker, {
                userInfoRequesting: true
            });
        case _bookmakersList.actionTypes.SET_USER_INFO:
            (0, _userAccountsInfo2.default)(bookmaker, bookmaker.isLoggedIn);

            return _extends({}, bookmaker, {
                userInfoRequesting: false,
                userInfo: _extends({}, action.data, {
                    hasDetails: true
                })
            });
        case _bookmakersList.actionTypes.SET_USER_INFO_ERROR:
            return _extends({}, bookmaker, {
                userInfoRequesting: false,
                userInfo: {
                    hasDetails: false,
                    error: action.error
                }
            });
        case _bookmakersList.actionTypes.SET_LOGGEDOUT:
            (0, _userAccountsInfo2.default)(bookmaker, false);

            return _extends({}, bookmaker, {
                isLoggedIn: false
            });
        default:
            return bookmaker;
    }
}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var MODAL_TYPE = exports.MODAL_TYPE = {
    LOGIN: 'login',
    SIGNUP: 'signup'
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _bookmakersButtonsPopovers = __webpack_require__(207);

var initialState = {
    activePopoverType: null,
    activePopoverFeed: null,
    show: false
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _bookmakersButtonsPopovers.actionTypes.CLOSE_CURRENT_ACTIVE_POPOVER:
            return _extends({}, state, {
                show: false

            });
        case _bookmakersButtonsPopovers.actionTypes.SET_CURRENT_ACTIVE_POPOVER:
            return {
                activePopoverType: action.activePopoverType,
                activePopoverFeed: action.activePopoverFeed,
                show: true
            };
        default:
            return state;
    }
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpandPanel = __webpack_require__(591);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpandPanel).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _externalAccount = __webpack_require__(85);

var initialState = {
    isExternalAccountError: null,
    externalAccountUrl: null
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _externalAccount.actionTypes.SET_EXTERNAL_ACCOUNT_URL:
            return _extends({}, state, {
                externalAccountUrl: action.externalAccountUrl,
                isExternalAccountError: false
            });
        case _externalAccount.actionTypes.SET_EXTERNAL_ACCOUNT_ERROR:
            return _extends({}, state, {
                isExternalAccountError: true
            });
        case _externalAccount.actionTypes.CLEAR_EXTERNAL_ACCOUNT_DATA:
            return _extends({}, state, {
                isExternalAccountError: null,
                externalAccountUrl: null
            });
        default:
            return state;
    }
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FreeBetList = __webpack_require__(593);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FreeBetList).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FreeBetToggle = __webpack_require__(594);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FreeBetToggle).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _freeBets = __webpack_require__(214);

var initialState = {
    list: [],
    selectedFreeBet: null
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _freeBets.actionTypes.SET_FREE_BETS:
            return _extends({}, state, {
                list: action.list
            });
        case _freeBets.actionTypes.CLEAR_FREE_BETS:
            return _extends({}, state, {
                list: []
            });
        case _freeBets.actionTypes.SELECT_FREE_BET:
            return _extends({}, state, {
                selectedFreeBet: action.freeBetId
            });
        case _freeBets.actionTypes.CLEAR_FREE_BET:
            return _extends({}, state, {
                selectedFreeBet: null
            });
        default:
            return state;
    }
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shortGamblingCompliance = exports.fullGamblingCompliance = undefined;

var _fullGamblingCompliance = __webpack_require__(595);

var _fullGamblingCompliance2 = _interopRequireDefault(_fullGamblingCompliance);

var _shortGamblingCompliance = __webpack_require__(596);

var _shortGamblingCompliance2 = _interopRequireDefault(_shortGamblingCompliance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.fullGamblingCompliance = _fullGamblingCompliance2.default;
exports.shortGamblingCompliance = _shortGamblingCompliance2.default;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shortGamblingCompliance = exports.fullGamblingCompliance = undefined;

var _fullGamblingCompliance = __webpack_require__(597);

var _fullGamblingCompliance2 = _interopRequireDefault(_fullGamblingCompliance);

var _shortGamblingCompliance = __webpack_require__(598);

var _shortGamblingCompliance2 = _interopRequireDefault(_shortGamblingCompliance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.fullGamblingCompliance = _fullGamblingCompliance2.default;
exports.shortGamblingCompliance = _shortGamblingCompliance2.default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shortGamblingCompliance = exports.fullGamblingCompliance = undefined;

var _fullGamblingCompliance = __webpack_require__(599);

var _fullGamblingCompliance2 = _interopRequireDefault(_fullGamblingCompliance);

var _shortGamblingCompliance = __webpack_require__(600);

var _shortGamblingCompliance2 = _interopRequireDefault(_shortGamblingCompliance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.fullGamblingCompliance = _fullGamblingCompliance2.default;
exports.shortGamblingCompliance = _shortGamblingCompliance2.default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shortGamblingCompliance = exports.fullGamblingCompliance = undefined;

var _fullGamblingCompliance = __webpack_require__(601);

var _fullGamblingCompliance2 = _interopRequireDefault(_fullGamblingCompliance);

var _shortGamblingCompliance = __webpack_require__(602);

var _shortGamblingCompliance2 = _interopRequireDefault(_shortGamblingCompliance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.fullGamblingCompliance = _fullGamblingCompliance2.default;
exports.shortGamblingCompliance = _shortGamblingCompliance2.default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shortGamblingCompliance = exports.fullGamblingCompliance = undefined;

var _fullGamblingCompliance = __webpack_require__(603);

var _fullGamblingCompliance2 = _interopRequireDefault(_fullGamblingCompliance);

var _shortGamblingCompliance = __webpack_require__(604);

var _shortGamblingCompliance2 = _interopRequireDefault(_shortGamblingCompliance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.fullGamblingCompliance = _fullGamblingCompliance2.default;
exports.shortGamblingCompliance = _shortGamblingCompliance2.default;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shortGamblingCompliance = exports.fullGamblingCompliance = undefined;

var _fullGamblingCompliance = __webpack_require__(605);

var _fullGamblingCompliance2 = _interopRequireDefault(_fullGamblingCompliance);

var _shortGamblingCompliance = __webpack_require__(606);

var _shortGamblingCompliance2 = _interopRequireDefault(_shortGamblingCompliance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.fullGamblingCompliance = _fullGamblingCompliance2.default;
exports.shortGamblingCompliance = _shortGamblingCompliance2.default;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shortGamblingCompliance = exports.fullGamblingCompliance = undefined;

var _fullGamblingCompliance = __webpack_require__(607);

var _fullGamblingCompliance2 = _interopRequireDefault(_fullGamblingCompliance);

var _shortGamblingCompliance = __webpack_require__(608);

var _shortGamblingCompliance2 = _interopRequireDefault(_shortGamblingCompliance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.fullGamblingCompliance = _fullGamblingCompliance2.default;
exports.shortGamblingCompliance = _shortGamblingCompliance2.default;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _gdpr = __webpack_require__(215);

var initialState = {
    show: false,
    url: ''
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _gdpr.actionTypes.SHOW_GDPR_POPUP:
            return _extends({}, state, {
                show: true,
                url: action.url
            });
        case _gdpr.actionTypes.CLOSE_GDPR_POPUP:
            return _extends({}, state, {
                show: false
            });
        default:
            return state;
    }
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GlobalModal = __webpack_require__(609);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GlobalModal).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _login = __webpack_require__(47);

var initialState = {};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _login.actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO:
        case _login.actionTypes.LOGIN_REQUEST:
            return _extends({}, state, {
                isLoading: true,
                isLoginOpen: true
            });
        case _login.actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS:
        case _login.actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_ERROR:
        case _login.actionTypes.LOGIN_SUCCESS:
            return _extends({}, state, {
                isLoading: false,
                isIncorrectCredentials: null
            });
        case _login.actionTypes.LOGIN_FAILURE:
            return _extends({}, state, {
                isLoading: false,
                isError: true,
                isIncorrectCredentials: action.isIncorrectCredentials
            });
        case _login.actionTypes.LOGIN_CLEAR_ERROR:
            return _extends({}, state, {
                isError: false,
                isLoading: false,
                isIncorrectCredentials: null,
                isLoginOpen: false
            });
        default:
            return state;
    }
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.default = pageReducer;

var _pageInfo = __webpack_require__(216);

var initialState = {
    isPhone: false,
    isTablet: false,
    isBookmakerSwitcherOpened: false
};

function pageReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _pageInfo.actionTypes.SET_DEVICE_TYPE:
            return _extends({}, state, {
                isPhone: action.isPhone,
                isTablet: action.isTablet
            });
        case _pageInfo.actionTypes.SET_API_URL:
            return _extends({}, state, {
                apiUrl: action.apiUrl,
                apiV2Url: action.apiV2Url,
                apiV3Url: action.apiV3Url
            });
        case _pageInfo.actionTypes.USE_DECIMAL_ODDS:
            return _extends({}, state, {
                useDecimalOdds: action.useDecimalOdds
            });
        case _pageInfo.actionTypes.OPEN_BOOKMAKER_SWITCHER_POPOVER:
            return _extends({}, state, {
                isBookmakerSwitcherOpened: true
            });
        case _pageInfo.actionTypes.CLOSE_BOOKMAKER_SWITCHER_POPOVER:
            return _extends({}, state, {
                isBookmakerSwitcherOpened: false
            });
        default:
            return state;
    }
}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var useDecimalOddsSelector = exports.useDecimalOddsSelector = function useDecimalOddsSelector(_ref) {
    var pageInfo = _ref.pageInfo;
    return pageInfo.useDecimalOdds || false;
};

var isPhoneSelector = exports.isPhoneSelector = function isPhoneSelector(_ref2) {
    var pageInfo = _ref2.pageInfo;
    return pageInfo.isPhone;
};

var isTabletSelector = exports.isTabletSelector = function isTabletSelector(_ref3) {
    var pageInfo = _ref3.pageInfo;
    return pageInfo.isTablet;
};

var apiUrlSelector = exports.apiUrlSelector = function apiUrlSelector(_ref4) {
    var pageInfo = _ref4.pageInfo;
    return pageInfo.apiUrl;
};

var isBookmakerSwitcherOpenedSelector = exports.isBookmakerSwitcherOpenedSelector = function isBookmakerSwitcherOpenedSelector(_ref5) {
    var pageInfo = _ref5.pageInfo;
    return pageInfo.isBookmakerSwitcherOpened;
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _topUp = __webpack_require__(217);

var initialState = {
    isTopUpModalVisible: false,
    cardDetails: null,
    isCardDetailsError: false,
    topUpErrorInfo: null
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _topUp.actionTypes.SHOW_TOP_UP_MODAL:
            return _extends({}, state, {
                isTopUpModalVisible: true
            });
        case _topUp.actionTypes.CARD_DETAILS_RECEIVED:
            return _extends({}, state, {
                cardDetails: action.cardDetails,
                isCardDetailsError: false
            });
        case _topUp.actionTypes.CARD_DETAILS_ERROR:
            return _extends({}, state, {
                isCardDetailsError: true
            });
        case _topUp.actionTypes.HIDE_TOP_UP_MODAL:
            return _extends({}, state, {
                isTopUpModalVisible: false,
                topUpErrorInfo: null
            });
        case _topUp.actionTypes.TOP_UP_FAIL:
            return _extends({}, state, {
                topUpErrorInfo: action.errorInfo,
                isTopUpModalVisible: true
            });
        default:
            return state;
    }
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(177);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TrackableMemoryRouter = function (_MemoryRouter) {
    _inherits(TrackableMemoryRouter, _MemoryRouter);

    function TrackableMemoryRouter(props) {
        _classCallCheck(this, TrackableMemoryRouter);

        var _this = _possibleConstructorReturn(this, (TrackableMemoryRouter.__proto__ || Object.getPrototypeOf(TrackableMemoryRouter)).call(this, props));

        _this.onHistoryChanged = _this.onHistoryChanged.bind(_this);
        return _this;
    }

    _createClass(TrackableMemoryRouter, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var onHistoryChanged = this.props.onHistoryChanged;
            if (onHistoryChanged) {
                this.unlistenRedux = this.history.listen(this.onHistoryChanged);
            }
        }
    }, {
        key: 'onHistoryChanged',
        value: function onHistoryChanged() {
            var pathName = this.history.location.pathname;
            var result = (0, _reactRouter.matchPath)(pathName, {
                path: this.props.trackedParams
            });
            var params = !!result && result.params;
            this.props.onHistoryChanged(pathName, params);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var onHistoryChanged = this.props.onHistoryChanged;
            if (onHistoryChanged) {
                this.unlistenRedux();
            }
        }
    }]);

    return TrackableMemoryRouter;
}(_reactRouter.MemoryRouter);

TrackableMemoryRouter.defaultProps = {
    onHistoryChanged: null,
    trackedParams: ''
};
TrackableMemoryRouter.propTypes = {
    initialEntries: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({})])),
    initialIndex: _propTypes2.default.number,
    getUserConfirmation: _propTypes2.default.func,
    keyLength: _propTypes2.default.number,
    children: _propTypes2.default.node,
    onHistoryChanged: _propTypes2.default.func,
    trackedParams: _propTypes2.default.string
};
exports.default = TrackableMemoryRouter;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createShowBalanceSelector = createShowBalanceSelector;
exports.createUserCurrencySelector = createUserCurrencySelector;
exports.createUserCurrencySignSelector = createUserCurrencySignSelector;
exports.createUserInfoSelector = createUserInfoSelector;

var _reselect = __webpack_require__(25);

var _bookmakersInfo = __webpack_require__(6);

var _bookmakersList = __webpack_require__(5);

var CURRENCY_TO_SIGN_DICTIONARY = {
    GBP: '£',
    EUR: '€',
    USD: '$'
};

function createShowBalanceSelector(feedSelector) {
    return (0, _reselect.createSelector)([_bookmakersInfo.selectors.bookmakersInfoSelector, feedSelector], function (bookmakersInfo, feed) {
        var config = bookmakersInfo[feed] || {};
        return typeof config.showBalance === 'undefined' || config.showBalance;
    });
}

function createUserCurrencySelector(feedSelector) {
    return (0, _reselect.createSelector)(_bookmakersList.selectors.createUserInfoSelector(feedSelector), function (_ref) {
        var hasDetails = _ref.hasDetails,
            currency = _ref.currency;
        return currency || (hasDetails !== undefined ? 'unknown' : 'GBP');
    });
}

function createUserCurrencySignSelector(feedSelector) {
    return (0, _reselect.createSelector)(createUserCurrencySelector(feedSelector), function (currency) {
        return CURRENCY_TO_SIGN_DICTIONARY[currency] || '';
    });
}

function createUserInfoSelector(feedSelector) {
    return (0, _reselect.createSelector)([createShowBalanceSelector(feedSelector), createUserCurrencySelector(feedSelector), createUserCurrencySignSelector(feedSelector), _bookmakersList.selectors.createUserInfoSelector(feedSelector)], function (showBalance, currency, currencySign, _ref2) {
        var hasDetails = _ref2.hasDetails,
            userName = _ref2.userName,
            balance = _ref2.balance;
        return {
            name: userName,
            hasDetails: hasDetails,
            balance: balance,
            currency: currency,
            currencySign: currencySign,
            showBalance: showBalance
        };
    });
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createBuildBetRequest = exports.createPlaceBetRequest = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

var _getSelectedBetsForMultiples = __webpack_require__(219);

var _getSelectedBetsForMultiples2 = _interopRequireDefault(_getSelectedBetsForMultiples);

var _calculateStake = __webpack_require__(48);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// Functions that map Redux state objects to API V2 request objects
// Note that API V2 uses the JSON API specification

var EVENS = 'Evs';

var getFractions = function getFractions(bet) {
    if (bet.fractionalPrice === EVENS) {
        return [1, 1];
    }

    if (bet.fractionalPrice === _priceTypes2.default.SP) {
        return [null, null];
    }

    return bet.fractionalPrice.split('/').map(function (num) {
        return parseInt(num, 10);
    });
};

var getPriceDetails = function getPriceDetails(bet) {
    if (bet.priceType === _priceTypes2.default.SP) {
        return {
            isStartingPrice: true,
            priceNumerator: null,
            priceDenominator: null
        };
    }

    var _getFractions = getFractions(bet),
        _getFractions2 = _slicedToArray(_getFractions, 2),
        numerator = _getFractions2[0],
        denominator = _getFractions2[1];

    return {
        isStartingPrice: false,
        priceNumerator: numerator,
        priceDenominator: denominator
    };
};

var transformSingles = function transformSingles(stakedSingles) {
    return stakedSingles.map(function (single) {
        var betPriceDetails = getPriceDetails(single);
        var useBog = single.priceType === _priceTypes2.default.SP ? false : single.isBog === 'Y';

        return {
            id: single.associatedBet.optionId,
            type: 'bets',
            attributes: {
                betType: 'single',
                stakePerLine: parseFloat(single.stake),
                isEachWay: single.isEachWay,
                betSelections: [_extends({
                    marketId: single.meetingId,
                    eventId: single.eventId,
                    selectionId: single.outcomersId
                }, betPriceDetails, {
                    useBestOddsGuaranteed: useBog
                })]
            }
        };
    });
};

var transformMultiples = function transformMultiples(stakedMultiples, selectedBets) {
    return stakedMultiples.map(function (multiple) {
        var betSelections = (0, _getSelectedBetsForMultiples2.default)(multiple.betSelections, selectedBets);
        var multipleSelections = betSelections.map(function (bet) {
            var betPriceDetails = getPriceDetails(bet);
            var useBog = bet.priceType === _priceTypes2.default.SP ? false : bet.isBog === 'Y';

            return _extends({
                marketId: bet.meetingId,
                eventId: bet.eventId,
                selectionId: bet.outcomersId
            }, betPriceDetails, {
                useBestOddsGuaranteed: useBog
            });
        });

        return {
            id: multiple.optionId,
            type: 'bets',
            attributes: {
                betType: multiple.betType,
                stakePerLine: parseFloat(multiple.stakeValue),
                isEachWay: multiple.isEachWay,
                betSelections: multipleSelections
            }
        };
    });
};

var createPlaceBetRequest = exports.createPlaceBetRequest = function createPlaceBetRequest(selectedBets, stakedMultiples, selectedFreeBetId) {
    var betInfo = {
        data: []

        // Only attempt to place singles that have a proper stake
    };var stakedSingles = selectedBets.filter(function (bet) {
        return !(0, _calculateStake.isEmptyStake)(bet.stake);
    });

    // Single bets...
    betInfo.data = betInfo.data.concat(transformSingles(stakedSingles));

    // Multiples...
    betInfo.data = betInfo.data.concat(transformMultiples(stakedMultiples, selectedBets));

    // Free bets (do not send if none applied)
    if (selectedFreeBetId) {
        betInfo.meta = {
            freeBetId: selectedFreeBetId
        };
    }

    return betInfo;
};

/**
 * Generates an API V2 friendly object for POSTing to the build bets
 * endpoint.
 *
 * @param  {Array.<Object>} selectedBets - from bookmakersInfo
 *
 * This request should contain data about the selected bets in the following
 * format:
 *
 *   {
 *      "data": [
 *           {
 *                "id": "foo", // outcomersId
 *                "type": "bet-selections",
 *                "attributes": {
 *                    "marketId": "foo" // eventId
 *                    "priceNumerator": 51,
 *                    "priceDenominator": 51
 *                }
 *            }
 *        ]
 *    }
 *
 */
var createBuildBetRequest = exports.createBuildBetRequest = function createBuildBetRequest(selectedBets) {
    return {
        data: selectedBets.map(function (bet) {
            var _getFractions3 = getFractions(bet),
                _getFractions4 = _slicedToArray(_getFractions3, 2),
                numerator = _getFractions4[0],
                denominator = _getFractions4[1];

            return {
                id: bet.outcomersId.toString(),
                type: 'bet-selections',
                attributes: {
                    marketId: bet.meetingId,
                    eventId: bet.eventId,
                    priceNumerator: numerator,
                    priceDenominator: denominator
                }
            };
        })
    };
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localStorage = __webpack_require__(62);

var updateBetToViewStorage = function updateBetToViewStorage(bets) {
    if ((0, _localStorage.isLocalStorageAvailable)()) {
        (function () {
            var betToView = (0, _localStorage.getLocalStorage)('bet2view') || {};
            var cumulativeStakes = (0, _localStorage.getLocalStorage)('cumulativeStakes') || {};
            var bookmaker = bets[0].bets[0].feed.toLowerCase();
            var firstQualification = !Object.prototype.hasOwnProperty.call(betToView, 'qualification');
            var firstAccumulation = !Object.prototype.hasOwnProperty.call(cumulativeStakes, bookmaker);
            var validStake = 0.01;

            if (firstQualification) {
                betToView.qualification = [];
            }

            if (firstAccumulation) {
                cumulativeStakes[bookmaker] = {};
            }

            var _loop = function _loop(i) {
                var _bets$i = bets[i],
                    stakePerLine = _bets$i.stakePerLine,
                    numberLines = _bets$i.numberLines;

                var uniqueIds = [];
                var totalStake = stakePerLine * numberLines;

                bets[i].bets.forEach(function (bet) {
                    var betIsQualified = betToView.qualification.filter(function (item) {
                        return item['race-id'] === bet.raceId && item.bookmaker === bookmaker;
                    }).length > 0;

                    if (uniqueIds.indexOf(bet.raceId) === -1 && !betIsQualified) {
                        uniqueIds.push(bet.raceId);
                    }
                });

                for (var j = 0; j < uniqueIds.length; j += 1) {
                    var id = uniqueIds[j];

                    if (typeof cumulativeStakes[bookmaker][id] !== 'undefined') {
                        if (totalStake + cumulativeStakes[bookmaker][id] >= validStake) {
                            betToView.qualification.push({
                                bookmaker: bookmaker,
                                'race-id': id
                            });
                            totalStake = Math.round((totalStake + cumulativeStakes[bookmaker][id] - validStake) * 100) / 100;
                            delete cumulativeStakes[bookmaker][id];
                        } else {
                            cumulativeStakes[bookmaker][id] = Math.round((cumulativeStakes[bookmaker][id] + totalStake) * 100) / 100;
                            break;
                        }
                    } else if (totalStake > 0) {
                        if (totalStake >= validStake) {
                            betToView.qualification.push({
                                bookmaker: bookmaker,
                                'race-id': id
                            });
                            totalStake = Math.round((totalStake - validStake) * 100) / 100;
                        } else {
                            cumulativeStakes[bookmaker][id] = Math.round(totalStake * 100) / 100;
                            break;
                        }
                    }
                }
            };

            for (var i = 0; i < bets.length; i += 1) {
                _loop(i);
            }

            (0, _localStorage.setLocalStorage)('bet2view', betToView);
            (0, _localStorage.setLocalStorage)('cumulativeStakes', cumulativeStakes);

            if (window.bet2viewInitQualification) {
                window.bet2viewInitQualification();
            }
        })();
    }
};

exports.default = updateBetToViewStorage;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = convertFractionalPrice;

var _parseFraction = __webpack_require__(132);

var _parseFraction2 = _interopRequireDefault(_parseFraction);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Convert fractional price to decimal price
 * @param {String} fractionalPrice - fractional price, e.g. 'Evs', '1/4', '4/1', '9/2',
 * @return {Number} - decimal price, e.g. 2, 1.25, 5.0, 5.5
 */
function convertFractionalPrice(fracPrice) {
    if (fracPrice === 'Evs') {
        return 2;
    }
    return (0, _parseFraction2.default)(fracPrice) + 1;
}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = executeInWindow;
// TODO: Add unit test check for message events
function executeInWindow(url) {
    var logoutPromise = Promise.resolve(url);

    var newWindowInstance = window.open('', '', 'top=1,left=1,width=1,height=1');

    return logoutPromise.then(function (res) {
        if (res.status !== 200 || !res.data || !res.data.data || !res.data.data.attributes) {
            return Promise.reject(new Error('Invalid JSON response'));
        }

        if (newWindowInstance && !newWindowInstance.closed) {
            newWindowInstance.location.href = res.data.data.attributes.bookmaker_url;
        }

        return {
            data: {
                data: {
                    attributes: {
                        success: true
                    }
                }
            },
            status: 200
        };
    }).catch(function () {
        return {
            data: {
                data: {
                    attributes: {
                        success: true
                    }
                }
            },
            status: 200
        };
    });
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatBetHistoryBets = formatBetHistoryBets;
exports.formatBetHistoryErrors = formatBetHistoryErrors;

var _betHistory = __webpack_require__(81);

function calculateOddsField(odds, numerator, denominator) {
    return odds === 'SP' ? 'SP' : numerator + '/' + denominator;
}

function calculateEachWayTermsField(eachWay, places, numerator, denominator) {
    return eachWay ? places + ' places ' + numerator + '/' + denominator + ' odds' : null;
}

function formatBetHistoryBets(bets) {
    var formatedBets = bets.map(function (bet, index) {
        var attributes = bet.attributes;

        var selections = attributes.selections.map(function (selection) {
            return {
                selectionName: selection.selection_name,
                odd: calculateOddsField(selection.odds_decimal, selection.odds_fractional_numerator, selection.odds_fractional_denominator),
                eachWay: selection.each_way,
                eachWayTerms: calculateEachWayTermsField(selection.each_way, selection.each_way_terms_places, selection.each_way_terms_numerator, selection.each_way_terms_denominator),
                eventDateTime: selection.event_datetime,
                eventName: selection.event_name
            };
        });
        return {
            timeBetPlaced: attributes.bet_datetime,
            receiptId: bet.id,
            betType: attributes.bet_type,
            stake: attributes.bet_stake,
            totalStake: attributes.bet_total_stake,
            returns: attributes.returns,
            finished: attributes.bet_settled,
            win: attributes.win,
            estimatedReturns: attributes.estimated_returns,
            selections: selections,
            page: Math.floor(index / _betHistory.BET_HISTORY_PAGE_LENGTH) + 1
        };
    });

    return formatedBets;
}

function formatBetHistoryErrors(errors) {
    var formatedErrors = {};

    errors.forEach(function (error) {
        formatedErrors[error.code] = { message: error.detail };
    });

    return formatedErrors;
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Returns formatted course name.
 *
 * @param {String} courseName Course name
 *
 * @return {String}
 */

exports.default = function (courseName) {
  return courseName && courseName.replace(/<(o|O)>/g, '(').replace(/<(c|C)>/g, ')');
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _parseFraction = __webpack_require__(132);

var _parseFraction2 = _interopRequireDefault(_parseFraction);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var calculateOdds = function calculateOdds(betSelections) {
    var odds = betSelections.reduce(function (total, bet) {
        var decimal = (0, _parseFraction2.default)(bet.fractionalPrice);
        return total * (decimal + 1);
    }, 1) - 1;

    return odds < 1 ? 1 : odds;
};

exports.default = calculateOdds;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CTA = __webpack_require__(633);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CTA).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionBar = __webpack_require__(632);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ActionBar).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BetForm = __webpack_require__(634);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BetForm).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FTGroup = __webpack_require__(637);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FTGroup).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FTRow = __webpack_require__(638);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FTRow).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FTSection = __webpack_require__(639);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FTSection).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FTForm = __webpack_require__(636);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FTForm).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MultipleForm = __webpack_require__(640);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MultipleForm).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetPage = exports.default = undefined;

var _BetPage = __webpack_require__(631);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_BetPage).default;
    }
});

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.BetPage = _BetPage.BetPage;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetReceiptPage = exports.default = undefined;

var _BetReceiptPage = __webpack_require__(641);

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_BetReceiptPage).default;
    }
});

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.BetReceiptPage = _BetReceiptPage.BetReceiptPage;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BodyScroll = __webpack_require__(644);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BodyScroll).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgottenPasswordPage = __webpack_require__(645);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ForgottenPasswordPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginPage = __webpack_require__(648);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LoginPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MinimizeButton = __webpack_require__(650);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MinimizeButton).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopUpPage = __webpack_require__(653);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TopUpPage).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _modals = __webpack_require__(226);

var initialState = {
    isSelectionInfoModalVisible: false,
    globalModal: null
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _modals.actionTypes.SHOW_SELECTION_INFO_MODAL:
            return _extends({}, state, {
                isSelectionInfoModalVisible: true
            });
        case _modals.actionTypes.HIDE_SELECTION_INFO_MODAL:
            return _extends({}, state, {
                isSelectionInfoModalVisible: false
            });
        case _modals.actionTypes.SET_GLOBAL_MODAL:
            return _extends({}, state, {
                globalModal: {
                    title: action.title,
                    body: action.body,
                    ctaTitle: action.ctaTitle
                }
            });
        case _modals.actionTypes.CLEAR_GLOBAL_MODAL:
            return _extends({}, state, {
                globalModal: null
            });
        default:
            return state;
    }
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
// import Root from './Root'


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(111);

var _reactRedux = __webpack_require__(4);

var _reduxPersist = __webpack_require__(119);

var _react3 = __webpack_require__(458);

__webpack_require__(656);

var _configureStore = __webpack_require__(483);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _appConfig = __webpack_require__(480);

var _appConfig2 = _interopRequireDefault(_appConfig);

var _drawer = __webpack_require__(133);

var _drawer2 = _interopRequireDefault(_drawer);

var _containerValidator = __webpack_require__(484);

var _containerValidator2 = _interopRequireDefault(_containerValidator);

var _myBookmakersPage = __webpack_require__(655);

var _myBookmakersPage2 = _interopRequireDefault(_myBookmakersPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _containerValidator2.default)();
(0, _appConfig2.default)();

var store = (0, _configureStore2.default)();
var persistor = (0, _reduxPersist.persistStore)(store);

/*
    Bind an API to the window object that returns the IDs
    of the current selections (and race) in the slip
 */
window.betslipApi = {
    getSelectedBets: function getSelectedBets() {
        return store.getState().bookmakersInfo.selectedBets.map(function (bet) {
            return {
                raceId: bet.raceId,
                outcomersId: bet.outcomersId,
                meetingId: bet.meetingId
            };
        });
    },
    isHorseSelected: function isHorseSelected(raceId, outcomersId, meetingId) {
        return store.getState().bookmakersInfo.selectedBets.some(function (bet) {
            return bet.raceId === raceId && bet.outcomersId === outcomersId && bet.meetingId === meetingId;
        });
    }
};

// // Render the Accounts button...
// render(
//     <Provider store={store}>
//         <PersistGate persistor={persistor}>
//             <Root />
//         </PersistGate>
//     </Provider>,
//     document.querySelector('#js-bs-bookmakersSwitcher'),
// );

// Render the drawer...
(0, _reactDom.render)(_jsx(_reactRedux.Provider, {
    store: store
}, void 0, _jsx(_react3.PersistGate, {
    persistor: persistor
}, void 0, _jsx(_drawer2.default, {}))), document.querySelector('#js-bs-drawer'));

// Render the Bookmakers Page...
(0, _reactDom.render)(_jsx(_reactRedux.Provider, {
    store: store
}, void 0, _jsx(_react3.PersistGate, {
    persistor: persistor
}, void 0, _jsx(_myBookmakersPage2.default, {}))), document.querySelector('#js-bs-bookmakersPage'));

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetHistoryPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _accountPage = __webpack_require__(55);

var accountActions = _interopRequireWildcard(_accountPage);

var _userInfo = __webpack_require__(11);

var _bookmakersList = __webpack_require__(5);

var _transitionRouter = __webpack_require__(16);

var _externalAccount = __webpack_require__(34);

var _externalAccount2 = _interopRequireDefault(_externalAccount);

var _BetHistoryIntegrated = __webpack_require__(558);

var _BetHistoryIntegrated2 = _interopRequireDefault(_BetHistoryIntegrated);

var _betHistory = __webpack_require__(490);

var _betHistory2 = __webpack_require__(81);

var _BetPropTypes = __webpack_require__(197);

__webpack_require__(657);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var BetHistoryPage = exports.BetHistoryPage = function (_Component) {
    _inherits(BetHistoryPage, _Component);

    function BetHistoryPage() {
        _classCallCheck(this, BetHistoryPage);

        return _possibleConstructorReturn(this, (BetHistoryPage.__proto__ || Object.getPrototypeOf(BetHistoryPage)).apply(this, arguments));
    }

    _createClass(BetHistoryPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                apiName = _props.apiName,
                getExternalBetHistoryUrl = _props.getExternalBetHistoryUrl,
                isExternalBetHistory = _props.isExternalBetHistory;


            if (isExternalBetHistory) {
                getExternalBetHistoryUrl(apiName);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearExternalBetHistoryData();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                name = _props2.name,
                isSettled = _props2.isSettled,
                isLoading = _props2.isLoading,
                getBetHistory = _props2.getBetHistory,
                clearBetHistory = _props2.clearBetHistory,
                betHistoryPageChange = _props2.betHistoryPageChange,
                toggleIsSettled = _props2.toggleIsSettled,
                apiName = _props2.apiName,
                betHistory = _props2.betHistory,
                currencySign = _props2.currencySign,
                currentPage = _props2.currentPage,
                isExternalBetHistory = _props2.isExternalBetHistory,
                externalBetHistoryUrl = _props2.externalBetHistoryUrl,
                isExternalBetHistoryError = _props2.isExternalBetHistoryError,
                betHistoryErrors = _props2.betHistoryErrors,
                pageLength = _props2.pageLength,
                hasNextPage = _props2.hasNextPage;


            return isExternalBetHistory ? _jsx(_externalAccount2.default, {
                windowName: 'History',
                externalAccountUrl: externalBetHistoryUrl,
                isExternalAccountError: isExternalBetHistoryError
            }) : _jsx(_BetHistoryIntegrated2.default, {
                isSettled: isSettled,
                bookmakerName: name,
                isLoading: isLoading,
                getBetHistory: getBetHistory,
                clearBetHistory: clearBetHistory,
                betHistoryPageChange: betHistoryPageChange,
                toggleIsSettled: toggleIsSettled,
                apiName: apiName,
                betHistory: betHistory,
                currencySign: currencySign,
                pageLength: pageLength,
                currentPage: currentPage,
                betHistoryErrors: betHistoryErrors,
                isPageAfterNextRequested: false,
                hasNextPage: hasNextPage
            });
        }
    }]);

    return BetHistoryPage;
}(_react.Component);

BetHistoryPage.defaultProps = {
    isSettled: false,
    isLoading: false,
    isExternalBetHistory: false,
    externalBetHistoryUrl: '',
    isExternalBetHistoryError: false,
    betHistoryErrors: null,
    isPageAfterNextRequested: false,
    hasNextPage: false

};


var userCurrencySignSelector = _userInfo.selectors.createUserCurrencySignSelector(_transitionRouter.selectors.feedSelector);

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var mapDispatchToProps = {
    toggleIsSettled: accountActions.toggleIsSettled,
    getBetHistory: accountActions.getBetHistory,
    betHistoryPageChange: accountActions.betHistoryPageChange,
    clearBetHistory: accountActions.clearBetHistory,
    getExternalBetHistoryUrl: accountActions.getExternalBetHistoryUrl,
    clearExternalBetHistoryData: accountActions.clearExternalBetHistoryData
};

var mapStateToProps = function mapStateToProps(state, props) {
    var _state$bookmakersSwit = state.bookmakersSwitcher.accountPage,
        isSettled = _state$bookmakersSwit.isSettled,
        externalBetHistoryUrl = _state$bookmakersSwit.externalBetHistoryUrl,
        isExternalBetHistoryError = _state$bookmakersSwit.isExternalBetHistoryError;


    return _extends({}, bookmakerInfoSelector(state, props), {
        currencySign: userCurrencySignSelector(state, props),
        isSettled: isSettled,
        currentPage: (0, _betHistory.currentPageSelector)(state),
        isLoading: (0, _betHistory.pageIsLoadingSelector)(state),
        betHistory: (0, _betHistory.currentPageItemsSelector)(state),
        betHistoryErrors: (0, _betHistory.betHistoryErrorsSelector)(state),
        externalBetHistoryUrl: externalBetHistoryUrl,
        isExternalBetHistoryError: isExternalBetHistoryError,
        pageLength: _betHistory2.BET_HISTORY_PAGE_LENGTH,
        isPageAfterNextRequested: (0, _betHistory.isPageAfterNextRequestedSelector)(state),
        hasNextPage: (0, _betHistory.hasNextPageSelector)(state)
    });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BetHistoryPage);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetHistoryIntegrated = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _BetHistoryList = __webpack_require__(559);

var _BetHistoryList2 = _interopRequireDefault(_BetHistoryList);

var _getErrorText = __webpack_require__(491);

var _getErrorText2 = _interopRequireDefault(_getErrorText);

var _formatDateTime = __webpack_require__(61);

var _BetPropTypes = __webpack_require__(197);

var _betHistory = __webpack_require__(81);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('div', {
    className: 'root__betPageHeaderContentSecondaryHeaderRow HeaderTitleContainer'
}, void 0, _jsx('div', {
    className: 'root__pageHeaderMainTitle'
}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'bookmakerLogo',
    size: 'Large'
}), _jsx('h1', {}, void 0, 'my bets')), _jsx('a', {
    href: '/my-bookmakers',
    className: 'root__betPageHeaderText back-button ShowOnMobile',
    'data-test-selector': 'Link__MyBookmakersPage'
}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'chevronLeft',
    size: 'regular'
}), 'Manage bookmakers'));

var _ref3 = _jsx('div', {
    className: 'root__betPageHeaderContentSecondaryHeaderRowLeft HideOnMobile'
}, void 0, _jsx('a', {
    href: '/my-bookmakers',
    className: 'root__betPageHeaderText back-button',
    'data-test-selector': 'Link__MyBookmakersPage'
}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'chevronLeft',
    size: 'regular'
}), 'Manage bookmakers'));

var BetHistoryIntegrated = exports.BetHistoryIntegrated = function (_Component) {
    _inherits(BetHistoryIntegrated, _Component);

    function BetHistoryIntegrated() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BetHistoryIntegrated);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BetHistoryIntegrated.__proto__ || Object.getPrototypeOf(BetHistoryIntegrated)).call.apply(_ref, [this].concat(args))), _this), _this.handleToggleIsSettled = function () {
            _this.props.toggleIsSettled();
            _this.requestInitialBetHistory(!_this.props.isSettled);
        }, _this.requestInitialBetHistory = function (isSettled) {
            var _this$props = _this.props,
                getBetHistory = _this$props.getBetHistory,
                apiName = _this$props.apiName;

            getBetHistory(apiName, isSettled);
        }, _this.incrementPage = function () {
            var _this$props2 = _this.props,
                currentPage = _this$props2.currentPage,
                betHistoryPageChange = _this$props2.betHistoryPageChange;

            var page = currentPage + 1;
            betHistoryPageChange(page);
        }, _this.decrementPage = function () {
            _this.props.betHistoryPageChange(_this.props.currentPage - 1);
        }, _this.renderPageBody = function () {
            var _this$props3 = _this.props,
                apiName = _this$props3.apiName,
                bookmakerName = _this$props3.bookmakerName,
                betHistory = _this$props3.betHistory,
                isSettled = _this$props3.isSettled,
                isLoading = _this$props3.isLoading,
                currencySign = _this$props3.currencySign,
                currentPage = _this$props3.currentPage;

            var redirectConfig = _betHistory.BET_HISTORY_REDIRECT_CONFIG[apiName] || {};

            var days = betHistory.reduce(function (day, bet) {
                var date = bet.timeBetPlaced.split('T')[0];

                if (!day[date]) {
                    day[date] = [];
                }

                day[date].push(bet);

                return day;
            }, {});

            var groupedBets = Object.keys(days).map(function (date) {
                var formatedDate = (0, _formatDateTime.formatDate)(date);
                return {
                    formatedDate: formatedDate,
                    bets: days[date]
                };
            });

            return currentPage === _betHistory.BET_HISTORY_MAX_PAGES_COUNT + 1 ? _jsx('div', {
                className: 'bs-betHistory__message'
            }, void 0, _jsx('span', {}, void 0, redirectConfig.text, ' ', _jsx('a', {
                href: 'https://' + redirectConfig.link,
                target: '_blank',
                rel: 'noopener noreferrer'
            }, void 0, redirectConfig.link))) : groupedBets.map(function (day, index) {
                return _jsx(_react.Fragment, {}, 'day-' + index, _jsx('div', {
                    className: 'MyBetsDateHeader',
                    'data-test-selector': 'Text__BetHistoryDate'
                }, void 0, day.formatedDate), _jsx(_BetHistoryList2.default, {
                    bookmakerName: bookmakerName,
                    isSettled: isSettled,
                    isLoading: isLoading,
                    currencySign: currencySign,
                    bets: day.bets
                }));
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BetHistoryIntegrated, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.requestInitialBetHistory(this.props.isSettled);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearBetHistory();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                betHistory = _props.betHistory,
                isSettled = _props.isSettled,
                isLoading = _props.isLoading,
                betHistoryErrors = _props.betHistoryErrors;

            var betHistoryErrorText = betHistoryErrors && (0, _getErrorText2.default)(betHistoryErrors);
            var isInitialBetHistoryLoading = isLoading && !betHistory.length;

            return _jsx('div', {
                className: 'bs-myBetsContainer'
            }, void 0, _jsx('section', {
                className: 'root'
            }, void 0, _jsx('nav', {
                className: 'root__betPageHeader'
            }, void 0, _jsx('div', {
                className: 'root__betPageHeaderContent root__rnCanvas'
            }, void 0, _ref2, _jsx('div', {
                className: 'root__betPageHeaderContentSecondaryHeaderRow'
            }, void 0, _ref3, _jsx('div', {
                className: 'root__betPageHeaderContentSecondaryHeaderRowRight'
            }, void 0, _jsx('span', {
                className: 'root__bookmakersDropdownContentRight'
            }, void 0, _jsx('button', {
                onClick: this.handleToggleIsSettled,
                className: 'bs-btn bs-btn_major bs-betHistory__toggleButton',
                'data-test-selector': 'Button__ToggleSettledBets'
            }, void 0, _jsx('div', {
                className: (0, _classnames2.default)('toggleOption', { 'settled': !isSettled })
            }, void 0, 'OPEN'), _jsx('div', {
                className: (0, _classnames2.default)('toggleOption', { 'settled': isSettled })
            }, void 0, 'SETTLED'))))))), betHistoryErrors ? _jsx('div', {
                className: 'bs-betHistory__error',
                'data-test-selector': 'Text__BetHistoryError'
            }, void 0, betHistoryErrorText) : _jsx('div', {
                className: (0, _classnames2.default)('bs-betHistory__content', { 'bs-betHistory__content_spinner': isInitialBetHistoryLoading })
            }, void 0, _jsx('section', {
                className: 'root__pageContent root__rnCanvas'
            }, void 0, _jsx('div', {
                className: 'MyBets',
                'data-test-selector': 'Container__BetHistory'
            }, void 0, this.renderPageBody())))));
        }
    }]);

    return BetHistoryIntegrated;
}(_react.Component);

BetHistoryIntegrated.defaultProps = {
    isSettled: false,
    isLoading: false,
    betHistoryNext: null,
    betHistoryErrors: null,
    hasNextPage: false
};

exports.default = BetHistoryIntegrated;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BetHistoryListItem = __webpack_require__(560);

var _BetHistoryListItem2 = _interopRequireDefault(_BetHistoryListItem);

var _spinner = __webpack_require__(127);

var _spinner2 = _interopRequireDefault(_spinner);

__webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BetHistoryList = function BetHistoryList(_ref) {
    var isLoading = _ref.isLoading,
        currencySign = _ref.currencySign,
        bets = _ref.bets,
        bookmakerName = _ref.bookmakerName;
    return _jsx('div', {
        className: 'MyBetsSingleBetContainer'
    }, void 0, bets.map(function (bet) {
        return _react2.default.createElement(_BetHistoryListItem2.default, _extends({}, bet, {
            currencySign: currencySign,
            bookmakerName: bookmakerName,
            key: bet.receiptId + '_' + bet.timeBetPlaced
        }));
    }), _jsx(_spinner2.default, {
        visible: isLoading,
        className: 'bs-betHistory__spinner'
    }, void 0, 'Requesting Bet History data'));
};

exports.default = BetHistoryList;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _formatDateTime = __webpack_require__(61);

var _formatReturns = __webpack_require__(89);

var _formatReturns2 = _interopRequireDefault(_formatReturns);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('span', {
    className: 'Won'
}, void 0, 'WON');

var _ref2 = _jsx('span', {}, void 0, ' x ');

var _ref3 = _jsx(_react.Fragment, {}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'eye-closed',
    className: 'ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
}, 'desktop-eye-closed'), 'close selections');

var _ref4 = _jsx(_react.Fragment, {}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'eye',
    className: 'ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
}, 'desktop-eye'), 'view selections');

var _ref5 = _jsx('div', {
    className: 'MyBetsSingleBetReturnType'
}, void 0, 'STAKE');

var _ref6 = _jsx('div', {
    className: 'MyBetsSingleBetReturnType GrayColour',
    'data-test-selector': 'Text__BetWin'
}, void 0, 'won');

var _ref7 = _jsx('div', {
    className: 'MyBetsSingleBetReturnType GrayColour',
    'data-test-selector': 'Text__BetLost'
}, void 0, 'lost');

var _ref8 = _jsx('div', {
    className: 'MyBetsSingleBetReturnType GrayColour'
}, void 0, 'EST. RETURN');

var _ref9 = _jsx('span', {
    className: 'GrayColour'
}, void 0, 'receipt no');

var _ref10 = _jsx('span', {
    className: 'GrayColour'
}, void 0, 'receipt no');

var _ref11 = _jsx(_react.Fragment, {}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'eye-closed',
    className: 'ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
}, 'mobile-eye-closed'), 'close selections');

var _ref12 = _jsx(_react.Fragment, {}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'eye',
    className: 'ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
}, 'mobile-eye'), 'view selections');

var _ref13 = _jsx('div', {
    className: 'BetStatus Bold700 Won',
    'data-test-selector': 'Text__BetWin'
}, void 0, 'WON');

var _ref14 = _jsx('div', {
    className: 'BetStatus Bold700 Lost',
    'data-test-selector': 'Text__BetLost'
}, void 0, 'LOST');

var _ref15 = _jsx('div', {
    className: 'BetStatus Bold700 Open',
    'data-test-selector': 'Text__BetStatus'
}, void 0, 'OPEN');

var _ref16 = _jsx('div', {}, void 0, 'Receipt ID');

var _ref17 = _jsx('div', {}, void 0, 'Time bet placed');

var _ref18 = _jsx('div', {}, void 0, 'Bet Type');

var _ref19 = _jsx('div', {}, void 0, 'Total stake');

var _ref20 = _jsx('div', {}, void 0, 'Potential return');

var _ref21 = _jsx('span', {
    className: 'GrayColour'
}, void 0, 'receipt');

var BetHistoryListItem = function (_Component) {
    _inherits(BetHistoryListItem, _Component);

    function BetHistoryListItem(props) {
        _classCallCheck(this, BetHistoryListItem);

        var _this = _possibleConstructorReturn(this, (BetHistoryListItem.__proto__ || Object.getPrototypeOf(BetHistoryListItem)).call(this, props));

        _this.state = {
            isToggled: false
        };

        _this.onToggleDropdown = _this.onToggleDropdown.bind(_this);
        return _this;
    }

    _createClass(BetHistoryListItem, [{
        key: 'onToggleDropdown',
        value: function onToggleDropdown() {
            this.setState({
                isToggled: !this.state.isToggled
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                selections = _props.selections,
                betType = _props.betType,
                bookmakerName = _props.bookmakerName,
                finished = _props.finished,
                receiptId = _props.receiptId,
                timeBetPlaced = _props.timeBetPlaced,
                totalStake = _props.totalStake,
                returns = _props.returns,
                estimatedReturns = _props.estimatedReturns,
                currencySign = _props.currencySign,
                win = _props.win,
                stake = _props.stake;


            var openBetName = betType === 'singles' ? 'Single' : betType;

            var transformCastName = function transformCastName(castType) {
                switch (castType) {
                    case 'straight-forecast':
                        return 'Forecast';
                    case 'reverse-forecast':
                        return 'Reverse Forecast';
                    case 'straight-tricast':
                        return 'Tricast';
                    case 'combination-tricast':
                        return 'Combination Tricasts';
                    case 'combination-forecast':
                        return 'Combination Forecasts';
                    case 'accumulator-4':
                        return '4-fold';

                    default:
                        return openBetName;
                }
            };

            var isEachWay = selections.every(function (selection) {
                return selection.eachWay === true;
            });
            var betName = transformCastName(betType) + ' ' + (isEachWay ? 'EW' : '');
            var numberOfLines = Math.round(totalStake / stake);
            var timePlaced = (0, _formatDateTime.formatDateTimeBetslip)(timeBetPlaced);

            var parseReturns = function parseReturns(returnTarget) {
                if (!returnTarget || parseFloat(returnTarget) === 0) {
                    return 'N/A';
                } else {
                    return '' + currencySign + (0, _formatReturns2.default)(returnTarget);
                }
            };

            var getOddsLabel = function getOddsLabel(odd) {
                if (odd === '0/0' || odd === '/' || odd === null) {
                    return 'SP';
                } else if (odd === '1/1') {
                    return 'Evs';
                } else {
                    return odd;
                }
            };

            var returnsValue = parseReturns(returns);
            var estimatedReturnsValue = parseReturns(estimatedReturns);
            var totalStakeValue = '' + currencySign + totalStake.toFixed(2);

            return _jsx(_react.Fragment, {}, receiptId, _jsx('div', {
                className: 'MyBetsSingleBetContainerDesktopLayout'
            }, void 0, _jsx('div', {
                className: 'MyBetsSingleBet'
            }, void 0, _jsx('div', {
                className: 'MyBetsSingleBetRow MyBetsSingleBetOfferCard'
            }, void 0, _jsx('div', {
                className: 'BookmakerLogo',
                'data-test-selector': 'Logo__BetHistoryBookmaker'
            }, void 0, _jsx(_svgIcon2.default, {
                iconName: bookmakerName
            })), _jsx('div', {
                className: 'OfferCardDetailsContainer'
            }, void 0, _jsx('div', {
                className: 'MyBetsSingleBetOfferCardDetails FontSizeLarge BetStatus',
                'data-test-selector': 'Text__BetStatus'
            }, void 0, finished ? _jsx(_react.Fragment, {}, void 0, win ? _ref : 'LOST') : 'OPEN'), _jsx('div', {
                className: 'MyBetsSingleBetOfferCardDetails GrayColour Bold',
                'data-test-selector': 'Text__BetName'
            }, void 0, betName))), _jsx('div', {
                className: 'MyBetsSingleBetType MyBetsSingleBetColumn'
            }, void 0, _jsx('div', {}, void 0, _jsx('span', {
                className: 'TypeMultiplier',
                'data-test-selector': 'Text__BetNumberOfLines'
            }, void 0, numberOfLines), _ref2, _jsx('span', {
                className: 'TypePrice',
                'data-test-selector': 'Text__BetStake'
            }, void 0, stake.toFixed(2))), selections.length > 1 ? _jsx('div', {
                className: 'MultipleSelections'
            }, void 0, _jsx('div', {
                className: (0, _classnames2.default)('MultipleSelectionsToggle', _defineProperty({}, this.state.isToggled && 'isToggled', this.state.isToggled)),
                onClick: this.onToggleDropdown,
                'data-test-selector': 'Button__ToggleMultipleBetSelections'
            }, void 0, _jsx('div', {
                className: 'ToggleHandle'
            }, void 0, this.state.isToggled ? _ref3 : _ref4)), this.state.isToggled && _jsx('div', {
                className: 'RacesContainer'
            }, void 0, selections.map(function (selection, index) {
                return _jsx('div', {
                    className: 'RaceDetails'
                }, 'desktop-' + index, _jsx('div', {
                    className: 'HorseDetails'
                }, void 0, _jsx('span', {
                    className: 'HorseName Bold',
                    'data-test-selector': 'Text__BetSelectionName'
                }, void 0, selection.selectionName), _jsx('span', {
                    className: 'GrayColour FontSizeMedium Bold',
                    'data-test-selector': 'Text__BetSelectionOdds'
                }, void 0, getOddsLabel(selection.odd))), _jsx('div', {
                    className: 'EventName',
                    'data-test-selector': 'Text__BetSelectionEvent'
                }, void 0, ' ', selection.eventName, ' - ', (0, _formatDateTime.formatDate)(selection.eventDateTime)));
            }))) : _jsx('div', {
                className: 'RaceDetails'
            }, void 0, _jsx('div', {
                className: 'HorseDetails'
            }, void 0, _jsx('span', {
                className: 'HorseName Bold',
                'data-test-selector': 'Text__BetSelectionName'
            }, void 0, selections[0].selectionName), _jsx('span', {
                className: 'GrayColour bold',
                'data-test-selector': 'Text__BetSelectionOdds'
            }, void 0, ' ', getOddsLabel(selections[0].odd))), _jsx('div', {
                className: 'EventName',
                'data-test-selector': 'Text__BetSelectionEvent'
            }, void 0, ' ', selections[0].eventName, ' - ', (0, _formatDateTime.formatDate)(selections[0].eventDateTime)))), _jsx('div', {
                className: 'MyBetsSingleBetColumn'
            }, void 0, _jsx('div', {
                className: '\n                                    MyBetsSingleBetRow \n                                    MyBetsSingleReturnBet\n                                    MyBetsSingleBetReturnStacke'
            }, void 0, _ref5, _jsx('div', {
                className: 'MyBetsSingleBetReturnAmount',
                'data-test-selector': 'Text__BetTotalStake'
            }, void 0, totalStakeValue)), finished ? win ? _jsx('div', {
                className: 'MyBetsSingleBetRow'
            }, void 0, _ref6, _jsx('div', {
                className: 'MyBetsSingleBetReturnAmount BetStatus Won',
                'data-test-selector': 'Text__BetReturns'
            }, void 0, '+', returnsValue)) : _jsx('div', {
                className: 'MyBetsSingleBetRow'
            }, void 0, _ref7, _jsx('div', {
                className: 'MyBetsSingleBetReturnAmount',
                'data-test-selector': 'Text__BetTotalStakeValue'
            }, void 0, '-', totalStakeValue)) : _jsx('div', {
                className: 'MyBetsSingleBetRow'
            }, void 0, _ref8, _jsx('div', {
                className: 'MyBetsSingleBetReturnAmount MyBetsSingleBetReturnEstimatedReturn',
                'data-test-selector': 'Text__BetEstimatedReturns'
            }, void 0, estimatedReturnsValue))), _jsx('div', {
                className: 'MyBetsSingleBetColumn MyBetsSingleBetReceiptDetails FromMedium'
            }, void 0, _jsx('div', {
                className: 'Secondary900 FontSizeSmall',
                'data-test-selector': 'Text__BetTimePlaced'
            }, void 0, 'Bet Placed at ', timePlaced), _jsx('div', {
                className: 'ReceiptNumber',
                'data-test-selector': 'Text__BetReceiptId'
            }, void 0, _ref9, _jsx('span', {
                className: 'Bold'
            }, void 0, this.props.receiptId)))), _jsx('div', {
                className: 'MyBetsSingleBetColumn MyBetsSingleBetReceiptDetails ToMedium'
            }, void 0, _jsx('div', {
                className: 'Secondary900 FontSizeSmall',
                'data-test-selector': 'Text__BetTimePlaced'
            }, void 0, 'Bet Placed at ', timePlaced), _jsx('div', {
                className: 'ReceiptNumber',
                'data-test-selector': 'Text__BetReceiptId'
            }, void 0, _ref10, _jsx('span', {
                className: 'Bold'
            }, void 0, this.props.receiptId)))), _jsx('div', {
                className: 'MyBetsSingleBetContainer MyBetsSingleBetContainerMobileLayout'
            }, void 0, _jsx('div', {
                className: 'MyBetsSingleBet'
            }, void 0, _jsx('div', {
                className: 'MyBetsSingleBetRow MobileBetDetailsContainer MobileBetLayout'
            }, void 0, _jsx('div', {
                className: 'BookmakerLogo',
                'data-test-selector': 'Logo__BetHistoryBookmaker'
            }, void 0, _jsx(_svgIcon2.default, {
                iconName: bookmakerName + '-small-square',
                className: 'ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
            })), _jsx('div', {
                className: 'MobileBetDetails'
            }, void 0, _jsx('div', {
                className: 'MyBetMobileLayoutRow'
            }, void 0, _jsx('div', {}, void 0, selections.length > 1 ? _jsx('div', {}, void 0, _jsx('div', {
                className: 'FontCapitalize Bold',
                'data-test-selector': 'Text__BetName'
            }, void 0, ' ', betName, ' '), _jsx('div', {
                className: (0, _classnames2.default)('MultipleSelectionsToggle', _defineProperty({}, this.state.isToggled && 'isToggled', this.state.isToggled)),
                onClick: function onClick() {
                    return _this2.onToggleDropdown();
                },
                'data-test-selector': 'Button__ToggleMultipleBetSelections'
            }, void 0, _jsx('div', {
                className: 'ToggleHandle'
            }, void 0, this.state.isToggled ? _ref11 : _ref12))) : _jsx('div', {}, void 0, _jsx('div', {
                className: 'FontSizeLarge Bold',
                'data-test-selector': 'Text__BetNameAndOdds'
            }, void 0, selections[0].selectionName, ' ', getOddsLabel(selections[0].odd)), _jsx('div', {
                'data-test-selector': 'Text__BetEventName'
            }, void 0, selections[0].eventName))), _jsx('div', {
                className: 'MobileBetData',
                'data-test-selector': 'Text__BetStatus'
            }, void 0, finished ? win ? _jsx(_react.Fragment, {}, void 0, _ref13, _jsx('div', {
                className: 'Bold',
                'data-test-selector': 'Text__BetReturns'
            }, void 0, '+', returnsValue)) : _jsx(_react.Fragment, {}, void 0, _ref14, _jsx('div', {
                className: 'Bold',
                'data-test-selector': 'Text__BetTotalStakeValue'
            }, void 0, '-', totalStakeValue)) : _jsx(_react.Fragment, {}, void 0, _ref15, _jsx('div', {
                className: 'Bold',
                'data-test-selector': 'Text__BetEstimatedReturns'
            }, void 0, totalStakeValue)))))), _jsx('div', {
                className: 'MyBetsSingleBetType MyBetsSingleBetColumn'
            }, void 0, selections.length > 1 && _jsx('div', {
                className: 'MultipleSelections',
                'data-test-selector': 'Container__BetMultipleSelections'
            }, void 0, this.state.isToggled && _jsx('div', {
                className: 'RacesContainer'
            }, void 0, selections.map(function (selection, index) {
                return _jsx('div', {
                    className: 'RaceDetails'
                }, 'mobile-' + index, _jsx('div', {
                    className: 'HorseDetails'
                }, void 0, _jsx('span', {
                    className: 'HorseName Bold',
                    'data-test-selector': 'Text__BetSelectionName'
                }, void 0, selection.selectionName), _jsx('span', {
                    className: 'GrayColour FontSizeMedium Bold',
                    'data-test-selector': 'Text__BetSelectionOdds'
                }, void 0, getOddsLabel(selection.odd))), _jsx('div', {
                    className: 'EventName',
                    'data-test-selector': 'Text__BetSelectionEvent'
                }, void 0, ' ', selection.eventName, ' - ', (0, _formatDateTime.formatDate)(selection.eventDateTime)));
            })))), _jsx('div', {
                className: 'MyBetsSingleBetRow MobileReceiptContainer MobileBetLayout FontSizeSmall'
            }, void 0, _jsx('div', {
                className: 'MyBetMobileLayoutRow',
                'data-test-selector': 'Text__BetReceiptId'
            }, void 0, _ref16, _jsx('div', {}, void 0, receiptId)), _jsx('div', {
                className: 'MyBetMobileLayoutRow',
                'data-test-selector': 'Text__BetTimePlaced'
            }, void 0, _ref17, _jsx('div', {}, void 0, timePlaced)), _jsx('div', {
                className: 'MyBetMobileLayoutRow',
                'data-test-selector': 'Text__BetType'
            }, void 0, _ref18, _jsx('div', {
                className: 'FontCapitalize'
            }, void 0, betName)), _jsx('div', {
                className: 'MyBetMobileLayoutRow',
                'data-test-selector': 'Text__BetTotalStakeAndPotentialReturn'
            }, void 0, finished ? _jsx(_react.Fragment, {}, void 0, _ref19, _jsx('div', {}, void 0, ' ', totalStakeValue)) : _jsx(_react.Fragment, {}, void 0, _ref20, _jsx('div', {}, void 0, estimatedReturnsValue)))), _jsx('div', {
                className: 'MyBetsSingleBetColumn MyBetsSingleBetReceiptDetails FromMedium'
            }, void 0, _jsx('div', {
                className: 'Secondary900 FontSizeSmall',
                'data-test-selector': 'Text__BetTimePlaced'
            }, void 0, 'Bet Placed at ', timePlaced), _jsx('div', {
                className: 'ReceiptNumber',
                'data-test-selector': 'Text__BetReceiptId'
            }, void 0, _ref21, _jsx('span', {
                className: 'Bold'
            }, void 0, receiptId))))));
        }
    }]);

    return BetHistoryListItem;
}(_react.Component);

BetHistoryListItem.defaultProps = {
    win: null,
    returns: 0
};

exports.default = BetHistoryListItem;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BookmakersPageSwitcher = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(8);

var _modal = __webpack_require__(58);

var _SelectionInfoModal = __webpack_require__(577);

var _SelectionInfoModal2 = _interopRequireDefault(_SelectionInfoModal);

var _bookmakersInfo = __webpack_require__(6);

var _bookmakersList = __webpack_require__(5);

var _modals = __webpack_require__(29);

var _chooseBookmakerPage = __webpack_require__(500);

var _chooseBookmakerPage2 = _interopRequireDefault(_chooseBookmakerPage);

var _bookmakersSorting = __webpack_require__(87);

var _bookmakersSorting2 = _interopRequireDefault(_bookmakersSorting);

var _currentDate = __webpack_require__(24);

var _cookie = __webpack_require__(23);

__webpack_require__(234);

var _Account = __webpack_require__(227);

var _Account2 = _interopRequireDefault(_Account);

var _transitionRouter = __webpack_require__(16);

var _transitionRouter2 = _interopRequireDefault(_transitionRouter);

var _BetHistory = __webpack_require__(492);

var _BetHistory2 = _interopRequireDefault(_BetHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref5 = _jsx(_reactRouterDom.Route, {
	exact: true,
	path: "/",
	component: _chooseBookmakerPage2.default
});

var _ref6 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/account",
	component: _Account2.default
});

var _ref7 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/bethistory",
	component: _BetHistory2.default
});

var BookmakersPageSwitcher = exports.BookmakersPageSwitcher = function (_Component) {
	_inherits(BookmakersPageSwitcher, _Component);

	function BookmakersPageSwitcher(props) {
		_classCallCheck(this, BookmakersPageSwitcher);

		var _this = _possibleConstructorReturn(this, (BookmakersPageSwitcher.__proto__ || Object.getPrototypeOf(BookmakersPageSwitcher)).call(this, props));

		_this.selectLoggedInBookmaker = function () {
			var bookmakersList = _this.props.bookmakersList;
			var feed = _this.state.justLoggedInBookmaker.feed;

			_this.setState({
				justLoggedInBookmaker: null
			});
			_this.props.selectBookmaker(feed, _bookmakersSorting2.default, bookmakersList);
		};

		_this.handleJustLoggedInBookmaker = function (_ref) {
			var selectedBookmaker = _ref.selectedBookmaker,
			    bookmakersList = _ref.bookmakersList,
			    clearJustLoggedInBookmaker = _ref.clearJustLoggedInBookmaker;

			var justLoggedInBookmaker = bookmakersList.find(function (_ref2) {
				var justLoggedIn = _ref2.justLoggedIn;
				return justLoggedIn;
			});
			if (justLoggedInBookmaker) {
				clearJustLoggedInBookmaker();
				if (justLoggedInBookmaker.feed !== selectedBookmaker) {
					_this.setState({ justLoggedInBookmaker: justLoggedInBookmaker }, function () {
						_this.selectLoggedInBookmaker();
					});
				}
			}
		};

		_this.getPreviouslySelectedBookmaker = function () {
			var _this$props = _this.props,
			    previouslySelectedBookie = _this$props.previouslySelectedBookie,
			    bookmakersList = _this$props.bookmakersList;


			if (previouslySelectedBookie) {
				var previousBookieFound = bookmakersList.find(function (_ref3) {
					var feed = _ref3.feed;
					return feed === previouslySelectedBookie;
				});

				if (previousBookieFound) {
					return previousBookieFound.displayName;
				}
			}

			return null;
		};

		_this.state = {};
		return _this;
	}

	_createClass(BookmakersPageSwitcher, [{
		key: "componentWillMount",
		value: function componentWillMount() {
			if (!this.props.bookmakersOrder || this.props.orderExpiration < (0, _currentDate.getCurrentTime)()) {
				this.props.setBookmakersOrder(_bookmakersSorting2.default, this.props.bookmakersList);
			}

			this.handleJustLoggedInBookmaker(this.props);
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			var selectedBookmaker = this.props.selectedBookmaker;

			if ((0, _cookie.getCookie)("chooseBookie") !== selectedBookmaker && selectedBookmaker !== null) {
				var date = new Date();

				date.setFullYear(date.getFullYear() + 1);
				(0, _cookie.setCookie)("chooseBookie=" + selectedBookmaker + "; " + ("domain=." + location.host.split(".").slice(1).join(".") + "; ") + "path=/; " + ("expires=" + date.toUTCString()));
			}
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			this.handleJustLoggedInBookmaker(nextProps);
		}
	}, {
		key: "render",
		value: function render() {
			var _props = this.props,
			    bookmakersList = _props.bookmakersList,
			    selectedFeed = _props.selectedBookmaker,
			    isSelectionInfoModalVisible = _props.isSelectionInfoModalVisible,
			    onHistoryChanged = _props.onHistoryChanged,
			    selectedBookmakerFeed = _props.selectedBookmakerFeed,
			    hideSelectionInfoModal = _props.hideSelectionInfoModal;

			var trackedHistoryParams = "/:feed";
			var selectedBookmaker = bookmakersList.find(function (_ref4) {
				var feed = _ref4.feed;
				return feed === selectedFeed;
			});

			if (!selectedBookmaker) {
				return null;
			}

			var name = selectedBookmaker.name,
			    displayName = selectedBookmaker.displayName;


			return _jsx(_react2.default.Fragment, {}, void 0, _jsx(_transitionRouter2.default, {
				onHistoryChanged: onHistoryChanged,
				trackedParams: trackedHistoryParams,
				selectedBookmakerFeed: selectedBookmakerFeed,
				bookmakerName: name
			}, void 0, _ref5, _ref6, _ref7), _jsx(_modal.Modal, {
				visible: isSelectionInfoModalVisible,
				borderless: true
			}, void 0, _jsx(_SelectionInfoModal2.default, {
				bookmakerName: name,
				bookmakerDisplayName: displayName,
				previouslySelectedBookie: this.getPreviouslySelectedBookmaker(),
				hideSelectionInfoModal: hideSelectionInfoModal
			})));
		}
	}]);

	return BookmakersPageSwitcher;
}(_react.Component);

BookmakersPageSwitcher.defaultProps = {
	bookmakersOrder: null,
	orderExpiration: null,
	onHistoryChanged: null,
	selectedBookmaker: null,
	isSelectionInfoModalVisible: false
};

var mapStateToProps = function mapStateToProps(state) {
	var bookmakersList = state.bookmakersList,
	    bookmakersInfo = state.bookmakersInfo,
	    modals = state.modals;
	var bookmakersOrder = bookmakersInfo.bookmakersOrder,
	    orderExpiration = bookmakersInfo.orderExpiration,
	    selectedBookmaker = bookmakersInfo.selectedBookmaker,
	    previouslySelectedBookie = bookmakersInfo.previouslySelectedBookie;

	return {
		bookmakersOrder: bookmakersOrder,
		orderExpiration: orderExpiration,
		bookmakersList: bookmakersList,
		selectedBookmaker: selectedBookmaker,
		isSelectionInfoModalVisible: modals.isSelectionInfoModalVisible,
		selectedBookmakerFeed: selectedBookmaker,
		previouslySelectedBookie: previouslySelectedBookie
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	selectBookmaker: _bookmakersInfo.actions.selectBookmaker,
	setBookmakersOrder: _bookmakersInfo.actions.setBookmakersOrder,
	clearJustLoggedInBookmaker: _bookmakersList.actions.clearJustLoggedInBookmaker,
	hideSelectionInfoModal: _modals.actions.hideSelectionInfoModal
})(BookmakersPageSwitcher);

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BookmakersSwitcher = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(8);

var _transitionRouter = __webpack_require__(16);

var _transitionRouter2 = _interopRequireDefault(_transitionRouter);

var _bookmakersInfo = __webpack_require__(6);

var _bookmakersList = __webpack_require__(5);

var _bookmakersSorting = __webpack_require__(87);

var _bookmakersSorting2 = _interopRequireDefault(_bookmakersSorting);

var _currentDate = __webpack_require__(24);

var _cookie = __webpack_require__(23);

__webpack_require__(234);

var _loginPage = __webpack_require__(502);

var _loginPage2 = _interopRequireDefault(_loginPage);

var _forgottenPasswordPage = __webpack_require__(501);

var _forgottenPasswordPage2 = _interopRequireDefault(_forgottenPasswordPage);

var _accountPage = __webpack_require__(199);

var _accountPage2 = _interopRequireDefault(_accountPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref4 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/login",
	component: _loginPage2.default
});

var _ref5 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/forgotten-password",
	component: _forgottenPasswordPage2.default
});

var _ref6 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/account",
	component: _accountPage2.default
});

var BookmakersSwitcher = exports.BookmakersSwitcher = function (_Component) {
	_inherits(BookmakersSwitcher, _Component);

	function BookmakersSwitcher(props) {
		_classCallCheck(this, BookmakersSwitcher);

		var _this = _possibleConstructorReturn(this, (BookmakersSwitcher.__proto__ || Object.getPrototypeOf(BookmakersSwitcher)).call(this, props));

		_this.handleJustLoggedInBookmaker = function (_ref) {
			var selectedBookmaker = _ref.selectedBookmaker,
			    bookmakersList = _ref.bookmakersList,
			    clearJustLoggedInBookmaker = _ref.clearJustLoggedInBookmaker;

			var justLoggedInBookmaker = bookmakersList.find(function (_ref2) {
				var justLoggedIn = _ref2.justLoggedIn;
				return justLoggedIn;
			});
			if (justLoggedInBookmaker) {
				clearJustLoggedInBookmaker();
				if (justLoggedInBookmaker.feed !== selectedBookmaker) {
					_this.setState({ justLoggedInBookmaker: justLoggedInBookmaker });
				}
			}
		};

		_this.selectLoggedInBookmaker = function () {
			var bookmakersList = _this.props.bookmakersList;
			var feed = _this.state.justLoggedInBookmaker.feed;

			_this.closeSelectLoggedInModal();
			_this.props.selectBookmaker(feed, _bookmakersSorting2.default, bookmakersList);
		};

		_this.closeSelectLoggedInModal = function () {
			_this.setState({
				justLoggedInBookmaker: null
			});
		};

		_this.state = {};
		return _this;
	}

	_createClass(BookmakersSwitcher, [{
		key: "componentWillMount",
		value: function componentWillMount() {
			if (!this.props.bookmakersOrder || this.props.orderExpiration < (0, _currentDate.getCurrentTime)()) {
				this.props.setBookmakersOrder(_bookmakersSorting2.default, this.props.bookmakersList);
			}

			this.handleJustLoggedInBookmaker(this.props);
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			var selectedBookmaker = this.props.selectedBookmaker;


			if ((0, _cookie.getCookie)("chooseBookie") !== selectedBookmaker && selectedBookmaker !== null) {
				var date = new Date();

				date.setFullYear(date.getFullYear() + 1);
				(0, _cookie.setCookie)("chooseBookie=" + selectedBookmaker + "; " + ("domain=." + location.host.split(".").slice(1).join(".") + "; ") + "path=/; " + ("expires=" + date.toUTCString()));
			}
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			this.handleJustLoggedInBookmaker(nextProps);
		}
	}, {
		key: "render",
		value: function render() {
			var _props = this.props,
			    bookmakersList = _props.bookmakersList,
			    onHistoryChanged = _props.onHistoryChanged,
			    selectedBookmakerFeed = _props.selectedBookmakerFeed,
			    children = _props.children;

			var trackedHistoryParams = "/:feed";
			var selectedBookmakerInfo = bookmakersList.find(function (_ref3) {
				var feed = _ref3.feed;
				return feed === selectedBookmakerFeed;
			});

			return _jsx(_transitionRouter2.default, {
				onHistoryChanged: onHistoryChanged,
				trackedParams: trackedHistoryParams,
				selectedBookmakerFeed: selectedBookmakerFeed,
				bookmakerName: selectedBookmakerInfo.name
			}, void 0, _ref4, _ref5, _ref6, children);
		}
	}]);

	return BookmakersSwitcher;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
	var bookmakersList = state.bookmakersList,
	    bookmakersInfo = state.bookmakersInfo,
	    modals = state.modals;
	var bookmakersOrder = bookmakersInfo.bookmakersOrder,
	    orderExpiration = bookmakersInfo.orderExpiration,
	    selectedBookmaker = bookmakersInfo.selectedBookmaker;

	return {
		bookmakersOrder: bookmakersOrder,
		orderExpiration: orderExpiration,
		bookmakersList: bookmakersList,
		selectedBookmaker: selectedBookmaker,
		isSelectionInfoModalVisible: modals.isSelectionInfoModalVisible,
		selectedBookmakerFeed: bookmakersInfo.selectedBookmaker
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	selectBookmaker: _bookmakersInfo.actions.selectBookmaker,
	setBookmakersOrder: _bookmakersInfo.actions.setBookmakersOrder,
	clearJustLoggedInBookmaker: _bookmakersList.actions.clearJustLoggedInBookmaker
})(BookmakersSwitcher);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(8);

__webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tabs = [{ name: 'info', title: 'Account' }];

var isTabActive = function isTabActive(tabName) {
    return function (match) {
        return match && match.path.split('/').pop() === tabName;
    };
};

var Tabs = function (_Component) {
    _inherits(Tabs, _Component);

    function Tabs(props) {
        _classCallCheck(this, Tabs);

        var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

        _this.tabs = [].concat(tabs);
        return _this;
    }

    _createClass(Tabs, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _jsx('div', {
                className: 'bs-tabs bs-account__tabs'
            }, void 0, this.tabs.map(function (_ref) {
                var name = _ref.name,
                    title = _ref.title;
                return _jsx(_reactRouterDom.NavLink, {
                    isActive: isTabActive(name),
                    activeClassName: 'bs-tabs__tab_active',
                    className: 'bs-tabs__tab',
                    to: {
                        pathname: '/' + _this2.props.feed + '/account/' + name,
                        state: {
                            enableAnimation: false
                        }
                    }
                }, name, _jsx('span', {}, void 0, title));
            }));
        }
    }]);

    return Tabs;
}(_react.Component);

exports.default = Tabs;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccountInfoPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(8);

var _reduxForm = __webpack_require__(44);

var _externalAccount = __webpack_require__(34);

var _externalAccount2 = _interopRequireDefault(_externalAccount);

var _topUp = __webpack_require__(59);

var _transitionRouter = __webpack_require__(16);

var _bookmakersInfo = __webpack_require__(6);

var _userInfo = __webpack_require__(11);

var _bookmakersList = __webpack_require__(5);

var _loginPage = __webpack_require__(36);

var _AccountInfoIntegrated = __webpack_require__(567);

var _AccountInfoIntegrated2 = _interopRequireDefault(_AccountInfoIntegrated);

var _loginCookies = __webpack_require__(90);

__webpack_require__(658);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountInfoPage = exports.AccountInfoPage = function (_Component) {
    _inherits(AccountInfoPage, _Component);

    function AccountInfoPage(props) {
        _classCallCheck(this, AccountInfoPage);

        var _this = _possibleConstructorReturn(this, (AccountInfoPage.__proto__ || Object.getPrototypeOf(AccountInfoPage)).call(this, props));

        _this.onExternalLogout = function () {
            var _this$props = _this.props,
                requestLogout = _this$props.requestLogout,
                apiName = _this$props.apiName,
                feed = _this$props.feed,
                isExternalLogout = _this$props.isExternalLogout,
                setLoggedOut = _this$props.setLoggedOut,
                cookieName = _this$props.cookieName;

            _this.setState({ isRedirectToSwitcherAllowed: false });
            if (feed === 'SURREY') {
                (0, _loginCookies.deleteLoginCookie)(cookieName);
                return setLoggedOut(feed);
            }

            return requestLogout(apiName, feed, isExternalLogout);
        };

        _this.redirectToAccountSwitcher = function () {
            var _this$props2 = _this.props,
                name = _this$props2.name,
                feed = _this$props2.feed,
                getUserInfo = _this$props2.getUserInfo;

            getUserInfo(name, feed);
            _this.setState({ shouldRedirectToAccountSwitcher: true });
        };

        _this.state = {
            shouldRedirectToAccountSwitcher: false
        };
        return _this;
    }

    _createClass(AccountInfoPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                apiName = _props.apiName,
                getExternalAccountUrl = _props.getExternalAccountUrl,
                isExternalAccount = _props.isExternalAccount;


            if (isExternalAccount) {
                getExternalAccountUrl(apiName);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isLoggedIn = _props2.isLoggedIn,
                isTopUpIntegrated = _props2.isTopUpIntegrated,
                isBalanceVisible = _props2.isBalanceVisible,
                isTopUpModalVisible = _props2.isTopUpModalVisible,
                externalAccountUrl = _props2.externalAccountUrl,
                isExternalAccountError = _props2.isExternalAccountError,
                isExternalAccount = _props2.isExternalAccount,
                accountType = _props2.accountType,
                hideTopUpModal = _props2.hideTopUpModal,
                withdrawBookmakerUrl = _props2.withdrawBookmakerUrl,
                withdrawBookmakerName = _props2.withdrawBookmakerName,
                topUpBookmakerUrl = _props2.topUpBookmakerUrl,
                topUpBookmakerName = _props2.topUpBookmakerName,
                forgottenPhoneNumber = _props2.forgottenPhoneNumber,
                topUpAccountBalance = _props2.topUpAccountBalance,
                currencySign = _props2.currencySign,
                cardDetails = _props2.cardDetails,
                isCardDetailsError = _props2.isCardDetailsError,
                topUpErrorInfo = _props2.topUpErrorInfo,
                feed = _props2.feed,
                theme = _props2.theme,
                isPhone = _props2.isPhone,
                apiName = _props2.apiName,
                getUserInfo = _props2.getUserInfo,
                toggleBalanceVisibility = _props2.toggleBalanceVisibility,
                getCardDetails = _props2.getCardDetails,
                requestLogout = _props2.requestLogout,
                isExternalLogout = _props2.isExternalLogout,
                resetTopUpForm = _props2.resetTopUpForm;


            if (!isLoggedIn || this.state.shouldRedirectToAccountSwitcher) {
                return _jsx(_reactRouterDom.Redirect, {
                    to: {
                        pathname: '/',
                        state: { isReversedAnimation: true }
                    }
                });
            }

            return isExternalAccount ? _jsx(_externalAccount2.default, {
                type: accountType,
                windowName: 'Account',
                externalAccountUrl: externalAccountUrl,
                isExternalAccountError: isExternalAccountError,
                onExternalBackButtonClick: this.redirectToAccountSwitcher,
                onLogout: this.onExternalLogout,
                onServerError: this.redirectToAccountSwitcher
            }) : _jsx(_AccountInfoIntegrated2.default, {
                isTopUpIntegrated: isTopUpIntegrated,
                isBalanceVisible: isBalanceVisible,
                isTopUpModalVisible: isTopUpModalVisible,
                hideTopUpModal: hideTopUpModal,
                withdrawBookmakerUrl: withdrawBookmakerUrl,
                withdrawBookmakerName: withdrawBookmakerName,
                topUpBookmakerUrl: topUpBookmakerUrl,
                topUpBookmakerName: topUpBookmakerName,
                topUpPhoneNumber: forgottenPhoneNumber,
                topUpAccountBalance: topUpAccountBalance,
                currencySign: currencySign,
                cardDetails: cardDetails,
                isCardDetailsError: isCardDetailsError,
                topUpErrorInfo: topUpErrorInfo,
                feed: feed,
                theme: theme,
                isPhone: isPhone,
                apiName: apiName,
                getUserInfo: getUserInfo,
                toggleBalanceVisibility: toggleBalanceVisibility,
                requestLogout: requestLogout,
                isExternalLogout: isExternalLogout,
                getCardDetails: getCardDetails,
                resetTopUpForm: resetTopUpForm
            });
        }
    }]);

    return AccountInfoPage;
}(_react.Component);

AccountInfoPage.defaultProps = {
    isLoggedIn: false,
    isBalanceVisible: true,
    isTopUpModalVisible: false,
    isTopUpIntegrated: false,
    isExternalAccount: false,
    accountType: 'iframe',
    withdrawBookmakerUrl: '',
    withdrawBookmakerName: '',
    topUpBookmakerUrl: '',
    topUpBookmakerName: '',
    forgottenPhoneNumber: '',
    cardDetails: null,
    isCardDetailsError: false,
    topUpErrorInfo: null,
    externalAccountUrl: '',
    isExternalAccountError: false,
    isExternalLogout: false
};


var showBalanceSelector = _userInfo.selectors.createShowBalanceSelector(_transitionRouter.selectors.feedSelector);

var userCurrencySignSelector = _userInfo.selectors.createUserCurrencySignSelector(_transitionRouter.selectors.feedSelector);

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    var _state$topUp = state.topUp,
        isTopUpModalVisible = _state$topUp.isTopUpModalVisible,
        topUpErrorInfo = _state$topUp.topUpErrorInfo,
        cardDetails = _state$topUp.cardDetails,
        isCardDetailsError = _state$topUp.isCardDetailsError;
    var _state$externalAccoun = state.externalAccount,
        isExternalAccountError = _state$externalAccoun.isExternalAccountError,
        externalAccountUrl = _state$externalAccoun.externalAccountUrl;

    return _extends({}, bookmakerInfoSelector(state, props), {
        currencySign: userCurrencySignSelector(state, props),
        feed: _transitionRouter.selectors.feedSelector(state, props),
        isBalanceVisible: showBalanceSelector(state, props),
        isTopUpModalVisible: isTopUpModalVisible,
        cardDetails: cardDetails,
        isCardDetailsError: isCardDetailsError,
        topUpErrorInfo: topUpErrorInfo,
        isExternalAccountError: isExternalAccountError,
        externalAccountUrl: externalAccountUrl,
        isPhone: state.pageInfo.isPhone
    });
};

var mapDispatchToProps = {
    hideTopUpModal: _topUp.actions.hideTopUpModal,
    toggleBalanceVisibility: _bookmakersInfo.actions.toggleBalanceVisibility,
    getCardDetails: _topUp.actions.getCardDetails,
    topUpAccountBalance: _topUp.actions.topUpAccountBalance,
    getUserInfo: _bookmakersList.actions.getUserInfo,
    requestLogout: _loginPage.actions.requestLogout,
    getExternalAccountUrl: _externalAccount.actions.getExternalAccountUrl,
    clearExternalAccountData: _externalAccount.actions.clearExternalAccountData,
    resetTopUpForm: _reduxForm.reset.bind(null, 'topUpForm'),
    setLoggedOut: _bookmakersList.actions.setLoggedOut
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountInfoPage);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountInfoAccordion = function (_Component) {
    _inherits(AccountInfoAccordion, _Component);

    function AccountInfoAccordion(props) {
        _classCallCheck(this, AccountInfoAccordion);

        var _this = _possibleConstructorReturn(this, (AccountInfoAccordion.__proto__ || Object.getPrototypeOf(AccountInfoAccordion)).call(this, props));

        _this.onHeaderClick = _this.onHeaderClick.bind(_this);
        _this.state = {
            isExpanded: true
        };
        return _this;
    }

    _createClass(AccountInfoAccordion, [{
        key: 'onHeaderClick',
        value: function onHeaderClick() {
            this.setState({
                isExpanded: !this.state.isExpanded
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                children = _props.children;
            var isExpanded = this.state.isExpanded;

            return _jsx('div', {
                className: 'bs-accountInfoAccordion'
            }, void 0, _jsx('div', {
                role: 'button',
                tabIndex: 0,
                className: 'bs-accountInfoAccordion__header',
                onClick: this.onHeaderClick
            }, void 0, _jsx('span', {}, void 0, title), _jsx(_svgIcon2.default, {
                iconName: 'down',
                size: 'Medium',
                className: (0, _classnames2.default)('bs-accountInfoAccordion__headerIcon', { 'bs-accountInfoAccordion__headerIcon_flipVertical': isExpanded })
            })), isExpanded ? _jsx('div', {
                className: 'bs-accountInfoAccordion__body'
            }, void 0, children) : null);
        }
    }]);

    return AccountInfoAccordion;
}(_react.Component);

AccountInfoAccordion.defaultProps = {
    title: null,
    children: null
};

exports.default = AccountInfoAccordion;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkbox = __webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {}, void 0, 'Sign Out');

var AccountInfoHeader = function AccountInfoHeader(_ref) {
    var isBalanceVisible = _ref.isBalanceVisible,
        checkboxIconType = _ref.checkboxIconType,
        onToggleBalanceVisibility = _ref.onToggleBalanceVisibility,
        onLogoutClick = _ref.onLogoutClick;
    return _jsx('div', {
        className: 'bs-account__tabHeader'
    }, void 0, _jsx(_checkbox.Checkbox, {
        name: 'ShowBalance',
        checked: isBalanceVisible,
        onSelect: onToggleBalanceVisibility,
        className: 'bs-accountInfo__balance',
        iconType: checkboxIconType,
        iconSize: 'Large'
    }, void 0, _jsx('span', {
        className: 'bs-link bs-accountInfo__balanceLabel'
    }, void 0, isBalanceVisible ? 'Hide Balance' : 'Show Balance')), _jsx('button', {
        className: 'bs-btn bs-btn_hollow bs-accountInfo__logout',
        onClick: onLogoutClick
    }, void 0, _ref2));
};

exports.default = AccountInfoHeader;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AccountInfoAccordion = __webpack_require__(565);

var _AccountInfoAccordion2 = _interopRequireDefault(_AccountInfoAccordion);

var _AccountInfoHeader = __webpack_require__(566);

var _AccountInfoHeader2 = _interopRequireDefault(_AccountInfoHeader);

var _topUp = __webpack_require__(59);

var _topUp2 = _interopRequireDefault(_topUp);

var _modal = __webpack_require__(58);

var _bookmakerLink = __webpack_require__(83);

var _bookmakerLink2 = _interopRequireDefault(_bookmakerLink);

var _gamblingCompliance = __webpack_require__(46);

var _topUpErrors = __webpack_require__(231);

var _topUpErrors2 = _interopRequireDefault(_topUpErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('span', {}, void 0, 'OK');

var AccountInfoIntegrated = function (_Component) {
    _inherits(AccountInfoIntegrated, _Component);

    function AccountInfoIntegrated() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AccountInfoIntegrated);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccountInfoIntegrated.__proto__ || Object.getPrototypeOf(AccountInfoIntegrated)).call.apply(_ref, [this].concat(args))), _this), _this.onLogoutClick = function () {
            _this.props.requestLogout(_this.props.apiName, _this.props.feed, _this.props.isExternalLogout);
        }, _this.onModalClose = function () {
            _this.props.hideTopUpModal();
            if (!_this.props.topUpErrorInfo) {
                _this.props.resetTopUpForm();
            }
        }, _this.toggleBalanceVisibility = function () {
            _this.props.toggleBalanceVisibility(_this.props.feed);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AccountInfoIntegrated, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                withdrawBookmakerName = _props.withdrawBookmakerName,
                topUpErrorInfo = _props.topUpErrorInfo,
                feed = _props.feed,
                checkboxIconType = _props.theme.checkboxIconType;


            var gamblingCompliance = (0, _gamblingCompliance.getGamblingCompliance)(feed);
            var topUpMessage = topUpErrorInfo ? (0, _topUpErrors2.default)(topUpErrorInfo, feed) : 'Deposit is successful';
            return _jsx('div', {
                className: 'bs-accountInfo'
            }, void 0, _jsx(_AccountInfoHeader2.default, {
                isBalanceVisible: this.props.isBalanceVisible,
                checkboxIconType: checkboxIconType,
                onToggleBalanceVisibility: this.toggleBalanceVisibility,
                onLogoutClick: this.onLogoutClick
            }), _jsx('div', {
                className: 'bs-accountInfo__accordions'
            }, void 0, _jsx(_AccountInfoAccordion2.default, {
                title: 'Deposit'
            }, void 0, _jsx(_topUp2.default, {
                apiName: this.props.apiName,
                feed: feed,
                isTopUpIntegrated: this.props.isTopUpIntegrated,
                topUpBookmakerUrl: this.props.topUpBookmakerUrl,
                topUpBookmakerName: this.props.topUpBookmakerName,
                topUpPhoneNumber: this.props.topUpPhoneNumber,
                currencySign: this.props.currencySign,
                cardDetails: this.props.cardDetails,
                isCardDetailsError: this.props.isCardDetailsError,
                isPhone: this.props.isPhone,
                getUserInfo: this.props.getUserInfo,
                topUpAccountBalance: this.props.topUpAccountBalance,
                getCardDetails: this.props.getCardDetails
            }), _jsx(_modal.Modal, {
                visible: this.props.isTopUpModalVisible,
                onOverlayClick: this.onModalClose
            }, void 0, _jsx('div', {
                className: 'bs-topUpModal'
            }, void 0, _jsx('span', {
                className: 'bs-topUpModal__message'
            }, void 0, topUpMessage), _jsx('button', {
                className: 'bs-btn bs-btn_major bs-btn_2XL bs-topUpModal__button',
                onClick: this.onModalClose
            }, void 0, _ref2)))), _jsx(_AccountInfoAccordion2.default, {
                title: 'Withdraw'
            }, void 0, _jsx(_bookmakerLink2.default, {
                titleText: 'To withdraw visit ' + withdrawBookmakerName,
                bookmakerUrl: this.props.withdrawBookmakerUrl,
                bookmakerName: withdrawBookmakerName
            })), _jsx(_AccountInfoAccordion2.default, {
                title: 'Terms & Conditions'
            }, void 0, _jsx('div', {
                className: 'bs-accountInfo__tc'
            }, void 0, gamblingCompliance))));
        }
    }]);

    return AccountInfoIntegrated;
}(_react.Component);

AccountInfoIntegrated.defaultProps = {
    cardDetails: null,
    isCardDetailsError: false,
    topUpErrorInfo: null,
    withdrawBookmakerUrl: '',
    withdrawBookmakerName: '',
    topUpBookmakerUrl: '',
    topUpBookmakerName: '',
    topUpPhoneNumber: '',
    isExternalLogout: false
};
exports.default = AccountInfoIntegrated;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetHistoryPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _accountPage = __webpack_require__(55);

var accountActions = _interopRequireWildcard(_accountPage);

var _userInfo = __webpack_require__(11);

var _bookmakersList = __webpack_require__(5);

var _transitionRouter = __webpack_require__(16);

var _externalAccount = __webpack_require__(34);

var _externalAccount2 = _interopRequireDefault(_externalAccount);

var _BetHistoryIntegrated = __webpack_require__(569);

var _BetHistoryIntegrated2 = _interopRequireDefault(_BetHistoryIntegrated);

var _betHistory = __webpack_require__(494);

var _betHistory2 = __webpack_require__(82);

var _BetPropTypes = __webpack_require__(198);

__webpack_require__(659);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var BetHistoryPage = exports.BetHistoryPage = function (_Component) {
    _inherits(BetHistoryPage, _Component);

    function BetHistoryPage() {
        _classCallCheck(this, BetHistoryPage);

        return _possibleConstructorReturn(this, (BetHistoryPage.__proto__ || Object.getPrototypeOf(BetHistoryPage)).apply(this, arguments));
    }

    _createClass(BetHistoryPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                apiName = _props.apiName,
                getExternalBetHistoryUrl = _props.getExternalBetHistoryUrl,
                isExternalBetHistory = _props.isExternalBetHistory;


            if (isExternalBetHistory) {
                getExternalBetHistoryUrl(apiName);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearExternalBetHistoryData();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isSettled = _props2.isSettled,
                isLoading = _props2.isLoading,
                getBetHistory = _props2.getBetHistory,
                clearBetHistory = _props2.clearBetHistory,
                betHistoryPageChange = _props2.betHistoryPageChange,
                toggleIsSettled = _props2.toggleIsSettled,
                apiName = _props2.apiName,
                betHistory = _props2.betHistory,
                currencySign = _props2.currencySign,
                currentPage = _props2.currentPage,
                isExternalBetHistory = _props2.isExternalBetHistory,
                externalBetHistoryUrl = _props2.externalBetHistoryUrl,
                isExternalBetHistoryError = _props2.isExternalBetHistoryError,
                betHistoryErrors = _props2.betHistoryErrors,
                pageLength = _props2.pageLength,
                isPageAfterNextRequested = _props2.isPageAfterNextRequested,
                hasNextPage = _props2.hasNextPage;


            return isExternalBetHistory ? _jsx(_externalAccount2.default, {
                windowName: 'History',
                externalAccountUrl: externalBetHistoryUrl,
                isExternalAccountError: isExternalBetHistoryError
            }) : _jsx(_BetHistoryIntegrated2.default, {
                isSettled: isSettled,
                isLoading: isLoading,
                getBetHistory: getBetHistory,
                clearBetHistory: clearBetHistory,
                betHistoryPageChange: betHistoryPageChange,
                toggleIsSettled: toggleIsSettled,
                apiName: apiName,
                betHistory: betHistory,
                currencySign: currencySign,
                pageLength: pageLength,
                currentPage: currentPage,
                betHistoryErrors: betHistoryErrors,
                isPageAfterNextRequested: isPageAfterNextRequested,
                hasNextPage: hasNextPage
            });
        }
    }]);

    return BetHistoryPage;
}(_react.Component);

BetHistoryPage.defaultProps = {
    isSettled: false,
    isLoading: false,
    isExternalBetHistory: false,
    externalBetHistoryUrl: '',
    isExternalBetHistoryError: false,
    betHistoryErrors: null,
    isPageAfterNextRequested: false,
    hasNextPage: false

};


var userCurrencySignSelector = _userInfo.selectors.createUserCurrencySignSelector(_transitionRouter.selectors.feedSelector);

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var mapDispatchToProps = {
    toggleIsSettled: accountActions.toggleIsSettled,
    getBetHistory: accountActions.getBetHistory,
    betHistoryPageChange: accountActions.betHistoryPageChange,
    clearBetHistory: accountActions.clearBetHistory,
    getExternalBetHistoryUrl: accountActions.getExternalBetHistoryUrl,
    clearExternalBetHistoryData: accountActions.clearExternalBetHistoryData
};

var mapStateToProps = function mapStateToProps(state, props) {
    var _state$bookmakersSwit = state.bookmakersSwitcher.accountPage,
        isSettled = _state$bookmakersSwit.isSettled,
        externalBetHistoryUrl = _state$bookmakersSwit.externalBetHistoryUrl,
        isExternalBetHistoryError = _state$bookmakersSwit.isExternalBetHistoryError;


    return _extends({}, bookmakerInfoSelector(state, props), {
        currencySign: userCurrencySignSelector(state, props),
        isSettled: isSettled,
        currentPage: (0, _betHistory.currentPageSelector)(state),
        isLoading: (0, _betHistory.pageIsLoadingSelector)(state),
        betHistory: (0, _betHistory.currentPageItemsSelector)(state),
        betHistoryErrors: (0, _betHistory.betHistoryErrorsSelector)(state),
        externalBetHistoryUrl: externalBetHistoryUrl,
        isExternalBetHistoryError: isExternalBetHistoryError,
        pageLength: _betHistory2.BET_HISTORY_PAGE_LENGTH,
        isPageAfterNextRequested: (0, _betHistory.isPageAfterNextRequestedSelector)(state),
        hasNextPage: (0, _betHistory.hasNextPageSelector)(state)
    });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BetHistoryPage);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetHistoryIntegrated = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _BetHistoryList = __webpack_require__(570);

var _BetHistoryList2 = _interopRequireDefault(_BetHistoryList);

var _pager = __webpack_require__(621);

var _pager2 = _interopRequireDefault(_pager);

var _getErrorText = __webpack_require__(496);

var _getErrorText2 = _interopRequireDefault(_getErrorText);

var _BetPropTypes = __webpack_require__(198);

var _betHistory = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BetHistoryIntegrated = exports.BetHistoryIntegrated = function (_Component) {
    _inherits(BetHistoryIntegrated, _Component);

    function BetHistoryIntegrated() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BetHistoryIntegrated);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BetHistoryIntegrated.__proto__ || Object.getPrototypeOf(BetHistoryIntegrated)).call.apply(_ref, [this].concat(args))), _this), _this.handleToggleIsSettled = function () {
            _this.props.toggleIsSettled();
            _this.requestInitialBetHistory(!_this.props.isSettled);
        }, _this.requestInitialBetHistory = function (isSettled) {
            var _this$props = _this.props,
                getBetHistory = _this$props.getBetHistory,
                apiName = _this$props.apiName;

            getBetHistory(apiName, isSettled);
        }, _this.incrementPage = function () {
            var _this$props2 = _this.props,
                currentPage = _this$props2.currentPage,
                betHistoryPageChange = _this$props2.betHistoryPageChange;

            var page = currentPage + 1;
            betHistoryPageChange(page);
        }, _this.decrementPage = function () {
            _this.props.betHistoryPageChange(_this.props.currentPage - 1);
        }, _this.renderPageBody = function () {
            var _this$props3 = _this.props,
                apiName = _this$props3.apiName,
                betHistory = _this$props3.betHistory,
                isSettled = _this$props3.isSettled,
                isLoading = _this$props3.isLoading,
                currencySign = _this$props3.currencySign,
                currentPage = _this$props3.currentPage;

            var redirectConfig = _betHistory.BET_HISTORY_REDIRECT_CONFIG[apiName] || {};

            return currentPage === _betHistory.BET_HISTORY_MAX_PAGES_COUNT + 1 ? _jsx('div', {
                className: 'bs-betHistory__message'
            }, void 0, _jsx('span', {}, void 0, redirectConfig.text, ' ', _jsx('a', {
                href: 'https://' + redirectConfig.link,
                target: '_blank',
                rel: 'noopener noreferrer'
            }, void 0, redirectConfig.link), '.')) : _jsx(_BetHistoryList2.default, {
                isSettled: isSettled,
                isLoading: isLoading,
                currencySign: currencySign,
                bets: betHistory
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BetHistoryIntegrated, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.requestInitialBetHistory(this.props.isSettled);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearBetHistory();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                betHistory = _props.betHistory,
                isSettled = _props.isSettled,
                isLoading = _props.isLoading,
                currentPage = _props.currentPage,
                pageLength = _props.pageLength,
                betHistoryErrors = _props.betHistoryErrors,
                hasNextPage = _props.hasNextPage;

            var betHistoryErrorText = betHistoryErrors && (0, _getErrorText2.default)(betHistoryErrors);
            var isInitialBetHistoryLoading = isLoading && !betHistory.length;
            return _jsx('div', {
                className: 'bs-betHistory'
            }, void 0, _jsx('div', {
                className: 'bs-account__tabHeader'
            }, void 0, _jsx('span', {
                className: 'bs-betHistory__title'
            }, void 0, isSettled ? 'Settled Bets' : 'Open Bets'), _jsx('button', {
                onClick: this.handleToggleIsSettled,
                className: 'bs-btn bs-btn_major bs-betHistory__toggleButton'
            }, void 0, _jsx('span', {}, void 0, isSettled ? 'Show Open Bets' : 'Show Settled Bets'))), betHistoryErrors ? _jsx('div', {
                className: 'bs-betHistory__error'
            }, void 0, betHistoryErrorText) : _jsx('div', {
                className: (0, _classnames2.default)('bs-betHistory__content', { 'bs-betHistory__content_spinner': isInitialBetHistoryLoading })
            }, void 0, this.renderPageBody(), _jsx('div', {
                className: 'bs-betHistory__footer'
            }, void 0, _jsx(_pager2.default, {
                isLoading: isLoading,
                currentPage: currentPage,
                pageLength: pageLength,
                currentPageLength: betHistory.length,
                hasNextPage: hasNextPage,
                onIncrementPage: this.incrementPage,
                onDecrementPage: this.decrementPage
            }))));
        }
    }]);

    return BetHistoryIntegrated;
}(_react.Component);

BetHistoryIntegrated.defaultProps = {
    isSettled: false,
    isLoading: false,
    betHistoryNext: null,
    betHistoryErrors: null,
    hasNextPage: false
};

exports.default = BetHistoryIntegrated;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _BetHistoryListItem = __webpack_require__(571);

var _BetHistoryListItem2 = _interopRequireDefault(_BetHistoryListItem);

var _spinner = __webpack_require__(127);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'bs-betHistoryList__title'
}, void 0, _jsx('div', {}, void 0, _jsx('span', {
    className: 'bs-betHistoryList__titleLine'
}, void 0, 'Bet Type'), _jsx('span', {
    className: 'bs-betHistoryList__titleLine'
}, void 0, 'Market')), _jsx('div', {}, void 0, _jsx('span', {
    className: 'bs-betHistoryList__titleLine'
}, void 0, 'Total Stake'), _jsx('span', {
    className: 'bs-betHistoryList__titleLine'
}, void 0, 'Return')));

var BetHistoryList = function BetHistoryList(_ref) {
    var isLoading = _ref.isLoading,
        currencySign = _ref.currencySign,
        bets = _ref.bets;
    return _jsx('div', {
        className: 'bs-betHistoryList'
    }, void 0, _ref2, _jsx('div', {
        className: (0, _classnames2.default)({ 'bs-betHistoryList__container': bets.length })
    }, void 0, bets.map(function (bet) {
        return _react2.default.createElement(_BetHistoryListItem2.default, _extends({}, bet, {
            currencySign: currencySign,
            key: bet.receiptId + '_' + bet.timeBetPlaced
        }));
    }), _jsx(_spinner2.default, {
        visible: isLoading,
        className: 'bs-betHistory__spinner'
    }, void 0, 'Requesting Bet History data')));
};

exports.default = BetHistoryList;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _formatDateTime = __webpack_require__(61);

var _formatReturns = __webpack_require__(89);

var _formatReturns2 = _interopRequireDefault(_formatReturns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('span', {}, void 0, 'Receipt ID');

var _ref2 = _jsx('span', {}, void 0, 'Time Bet Placed');

var _ref3 = _jsx('span', {}, void 0, 'Bet Type');

var _ref4 = _jsx('span', {}, void 0, 'Total Stake');

var _ref5 = _jsx('span', {}, void 0, 'Bet Status');

var _ref6 = _jsx('div', {
    className: 'bs-betHistorySingle__betLine'
}, void 0, _jsx('span', {}, void 0, 'Bet Status'), _jsx('span', {}, void 0, '-'));

var _ref7 = _jsx('span', {}, void 0, 'Returns');

var BetHistoryListItem = function (_Component) {
    _inherits(BetHistoryListItem, _Component);

    function BetHistoryListItem(props) {
        _classCallCheck(this, BetHistoryListItem);

        var _this = _possibleConstructorReturn(this, (BetHistoryListItem.__proto__ || Object.getPrototypeOf(BetHistoryListItem)).call(this, props));

        _this.state = {
            isExpanded: true
        };

        _this.toggleExpanded = _this.toggleExpanded.bind(_this);
        return _this;
    }

    _createClass(BetHistoryListItem, [{
        key: 'toggleExpanded',
        value: function toggleExpanded() {
            this.setState({
                isExpanded: !this.state.isExpanded
            });
        }
    }, {
        key: 'renderReceipt',
        value: function renderReceipt(selection, i) {
            var selectionName = selection.selectionName,
                odd = selection.odd,
                eventName = selection.eventName;

            var resultOdd = void 0;
            /*
             * Fix for William Hill remove @ / (rpw-663)
             * Fix for Corel replace null for Forecast/Tricast text (rpw-664)
             */
            if (odd === '0/0' || odd === '/') {
                resultOdd = '';
            } else if (odd === null) {
                resultOdd = 'Forecast/Tricast';
            } else if (odd === '1/1') {
                resultOdd = '@ Evs';
            } else {
                resultOdd = '@ ' + odd;
            }

            return _jsx('div', {
                role: 'button',
                tabIndex: 0,
                className: 'bs-betHistorySingle__main',
                onClick: this.toggleExpanded
            }, i, _jsx('div', {
                className: 'bs-betHistorySingle__info'
            }, void 0, _jsx('div', {
                className: 'bs-betHistorySingle__horse'
            }, void 0, _jsx('span', {}, void 0, selectionName, '\xA0', resultOdd)), _jsx('div', {
                className: 'bs-betHistorySingle__race'
            }, void 0, _jsx('span', {}, void 0, eventName))));
        }
    }, {
        key: 'renderReceiptDetails',
        value: function renderReceiptDetails() {
            var _props = this.props,
                finished = _props.finished,
                receiptId = _props.receiptId,
                timeBetPlaced = _props.timeBetPlaced,
                betType = _props.betType,
                totalStake = _props.totalStake,
                returns = _props.returns,
                currencySign = _props.currencySign,
                win = _props.win,
                stake = _props.stake,
                selections = _props.selections;


            var returnsValue = returns === null ? 'N/A' : '' + currencySign + (0, _formatReturns2.default)(returns);
            var eachWay = selections.every(function (selection) {
                return selection.eachWay === true;
            });

            if (!this.state.isExpanded) {
                return null;
            }

            return _jsx('div', {
                className: 'bs-betHistorySingle__bet'
            }, void 0, _jsx('div', {
                className: 'bs-betHistorySingle__betLine'
            }, void 0, _ref, _jsx('span', {}, void 0, receiptId)), _jsx('div', {
                className: 'bs-betHistorySingle__betLine'
            }, void 0, _ref2, _jsx('span', {}, void 0, (0, _formatDateTime.formatDateTime)(timeBetPlaced))), _jsx('div', {
                className: 'bs-betHistorySingle__betLine'
            }, void 0, _ref3, _jsx('span', {}, void 0, _jsx('span', {
                className: 'bs-betHistorySingle__betType'
            }, void 0, betType, ' '), '' + currencySign + stake.toFixed(2) + ' ', eachWay ? 'EW' : 'Win')), _jsx('div', {
                className: 'bs-betHistorySingle__betLine'
            }, void 0, _ref4, _jsx('span', {}, void 0, '' + currencySign + totalStake.toFixed(2))), finished ? _jsx('div', {
                className: 'bs-betHistorySingle__betLine'
            }, void 0, _ref5, _jsx('span', {
                className: (0, _classnames2.default)({
                    'bs-betHistorySingle__result_win': win
                })
            }, void 0, win ? 'Won' : 'Lost')) : _ref6, _jsx('div', {
                className: 'bs-betHistorySingle__betLine'
            }, void 0, _ref7, _jsx('span', {
                className: (0, _classnames2.default)({
                    'bs-betHistorySingle__result_win': finished && win && returns !== null
                })
            }, void 0, returnsValue)));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                selections = _props2.selections,
                betType = _props2.betType;

            var betName = betType === 'singles' ? 'Single' : betType;

            return _jsx('div', {
                className: (0, _classnames2.default)('bs-betHistorySingle', 'bs-betHistorySingle_expanded')
            }, void 0, _jsx('h4', {}, void 0, betName), selections.map(function (selection, i) {
                return _this2.renderReceipt(selection, i);
            }), this.renderReceiptDetails());
        }
    }]);

    return BetHistoryListItem;
}(_react.Component);

BetHistoryListItem.defaultProps = {
    win: null,
    returns: 0
};

exports.default = BetHistoryListItem;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChooseBookmakerPage = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _BookmakersList = __webpack_require__(574);

var _BookmakersList2 = _interopRequireDefault(_BookmakersList);

var _bookmakersInfo = __webpack_require__(6);

var _loginPage = __webpack_require__(36);

var _userInfo = __webpack_require__(11);

var _bookmakersSorting = __webpack_require__(87);

var _bookmakersSorting2 = _interopRequireDefault(_bookmakersSorting);

var _cookie = __webpack_require__(23);

var _bookmakersSwitcher = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseBookmakerPage = exports.ChooseBookmakerPage = function (_React$Component) {
    _inherits(ChooseBookmakerPage, _React$Component);

    function ChooseBookmakerPage(props) {
        _classCallCheck(this, ChooseBookmakerPage);

        var _this = _possibleConstructorReturn(this, (ChooseBookmakerPage.__proto__ || Object.getPrototypeOf(ChooseBookmakerPage)).call(this, props));

        _this.onSelect = function (feed, shouldShowModal) {
            var _this$props = _this.props,
                selectBookmaker = _this$props.selectBookmaker,
                bookmakers = _this$props.bookmakers,
                selectedBookmaker = _this$props.selectedBookmaker;

            if (feed !== selectedBookmaker) {
                selectBookmaker(feed, _bookmakersSorting2.default, bookmakers, shouldShowModal);
                if ((0, _cookie.getCookie)('chooseBookie') !== feed) {
                    var date = new Date();

                    date.setFullYear(date.getFullYear() + 1);
                    (0, _cookie.setCookie)('chooseBookie=' + feed + '; ' + ('domain=.' + location.host.split('.').slice(1).join('.') + '; ') + 'path=/; ' + ('expires=' + date.toUTCString()));
                }
            }
        };

        _this.updateActiveModalsList = function (bookmakerFeed, modalType) {
            var updatedModalsList = _this.state.activeModalsList.map(function (originalModalData) {
                if (originalModalData.bookmakerFeed === bookmakerFeed && originalModalData.modalType === modalType) {
                    return _extends({}, originalModalData, { shouldBeVisible: !originalModalData.shouldBeVisible });
                }

                return _extends({}, originalModalData, { shouldBeVisible: false });
            });
            _this.setState(function () {
                return { activeModalsList: updatedModalsList };
            });
        };

        _this.state = {
            activeModalsList: _this.props.bookmakers.map(function (b) {
                return {
                    bookmakerFeed: b.feed, modalType: 'login', shouldBeVisible: false
                };
            })
        };
        return _this;
    }

    _createClass(ChooseBookmakerPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                bookmakers = _props.bookmakers,
                selectedBookmaker = _props.selectedBookmaker,
                toggleBalanceVisibility = _props.toggleBalanceVisibility,
                requestLogout = _props.requestLogout;
            var activeModalsList = this.state.activeModalsList;


            if (!selectedBookmaker) {
                return null;
            }

            return _jsx(_BookmakersList2.default, {
                bookmakers: bookmakers,
                selectedBookmaker: selectedBookmaker,
                onSelect: this.onSelect,
                toggleBalanceVisibility: toggleBalanceVisibility,
                requestLogout: requestLogout,
                updateActiveModalsList: this.updateActiveModalsList,
                activeModalsList: activeModalsList
            });
        }
    }]);

    return ChooseBookmakerPage;
}(_react2.default.Component);

var userInfoSelectorsDictionary = {};
var getUserInfoSelector = function getUserInfoSelector(bookmaker) {
    if (userInfoSelectorsDictionary[bookmaker]) {
        return userInfoSelectorsDictionary[bookmaker];
    }
    var selector = _userInfo.selectors.createUserInfoSelector(function () {
        return bookmaker;
    });
    userInfoSelectorsDictionary[bookmaker] = selector;
    return selector;
};

var sortBookmakers = function sortBookmakers(selectedBookmaker, bookmakersOrder) {
    return function (_ref, _ref2) {
        var feed1 = _ref.feed;
        var feed2 = _ref2.feed;

        if (feed1 === selectedBookmaker) {
            return -1;
        }
        if (feed2 === selectedBookmaker) {
            return 1;
        }
        return bookmakersOrder.indexOf(feed1) - bookmakersOrder.indexOf(feed2);
    };
};

var mapStateToProps = function mapStateToProps(state, props) {
    var _state$bookmakersInfo = state.bookmakersInfo,
        selectedBookmaker = _state$bookmakersInfo.selectedBookmaker,
        bookmakersOrder = _state$bookmakersInfo.bookmakersOrder;

    var bookmakers = [].concat(_toConsumableArray(state.bookmakersList));
    bookmakers.sort(sortBookmakers(selectedBookmaker, bookmakersOrder));
    bookmakers = bookmakers.map(function (bookmaker) {
        return _extends({}, bookmaker, {
            userInfo: getUserInfoSelector(bookmaker.feed)(state, props)
        });
    });
    return {
        bookmakers: bookmakers,
        selectedBookmaker: selectedBookmaker,
        redirectToLoginBookmaker: (0, _bookmakersSwitcher.redirectToLoginBookmakerSelector)(state),
        onHistoryChanged: props.onHistoryChanged,
        selectedBookmakerFeed: props.selectedBookmakerFeed
    };
};

var mapDispatchToProps = {
    selectBookmaker: _bookmakersInfo.actions.selectBookmaker,
    setBookmakersOrder: _bookmakersInfo.actions.setBookmakersOrder,
    toggleBalanceVisibility: _bookmakersInfo.actions.toggleBalanceVisibility,
    requestLogout: _loginPage.actions.requestLogout
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChooseBookmakerPage);

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "86",
        height: "40",
        viewBox: "0 0 86 40",
        fill: "none"
}, void 0, _jsx("g", {
        "clip-path": "url(#clip0_9967_14503)"
}, void 0, _jsx("rect", {
        width: "86",
        height: "40",
        rx: "4",
        fill: "url(#paint0_linear_9967_14503)"
}), _jsx("path", {
        d: "M85.9531 0H-0.046875V40H85.9531V0Z",
        fill: "url(#paint1_linear_9967_14503)"
}), _jsx("path", {
        d: "M6.64844 25.6196L8.32158 14.375H12.9494C14.4869 14.375 15.5964 14.5996 16.278 15.0489C16.9597 15.4981 17.3006 16.2215 17.3009 17.2191C17.3009 17.8611 17.1761 18.401 16.9297 18.8448C16.6832 19.2886 16.2966 19.6535 15.777 19.9424C16.2041 20.1207 16.5654 20.4288 16.8107 20.8236C17.0559 21.2362 17.182 21.7096 17.1748 22.1905C17.1748 23.3296 16.8003 24.1862 16.0569 24.7589C15.3135 25.3317 14.2029 25.6201 12.7238 25.6201L6.64844 25.6196ZM10.4632 23.0129H12.2105C12.7806 23.0129 13.1942 22.9218 13.4513 22.7396C13.7095 22.5573 13.8389 22.2589 13.8389 21.8515C13.8389 21.5025 13.7231 21.2524 13.4952 21.102C13.2673 20.9517 12.8685 20.8742 12.3014 20.8742H10.7739L10.4632 23.0129ZM11.0425 18.8744H12.5053C13.0421 18.8744 13.4301 18.791 13.6679 18.6188C13.9058 18.4466 14.0238 18.1704 14.0238 17.7836C14.0238 17.461 13.9148 17.2332 13.7014 17.1033C13.488 16.9735 13.0624 16.9079 12.428 16.9079H11.3708L11.0425 18.8744Z",
        fill: "white"
}), _jsx("path", {
        d: "M17.5703 25.6196L19.2733 14.375H27.9004L27.4902 17.0491H22.351L22.1005 18.5946H26.6754L26.2765 21.0947H21.7134L21.4778 22.8977H26.953L26.5718 25.6192L17.5703 25.6196Z",
        fill: "white"
}), _jsx("path", {
        d: "M30.2759 25.6178L31.5045 17.2341H28.3359L28.8062 14.375H38.5511L38.0664 17.2341H35.043L33.832 25.6178H30.2759Z",
        fill: "white"
}), _jsx("path", {
        d: "M37.7891 25.6196L39.4771 14.375H47.3233L46.8919 17.1307H42.553L42.2708 18.9077H45.959L45.5434 21.5845H41.8783L41.2959 25.6196H37.7891Z",
        fill: "white"
}), _jsx("path", {
        d: "M46.6562 25.6196L48.3172 14.375H53.484C54.925 14.375 55.9781 14.618 56.6431 15.104C57.3096 15.5915 57.6429 16.3525 57.6429 17.3981C57.6429 18.1468 57.462 18.7928 57.1039 19.331C56.7457 19.8691 56.213 20.2905 55.5167 20.5912C56.0141 20.7822 56.3645 21.0337 56.5748 21.3348C56.7851 21.636 56.8913 22.0397 56.8913 22.5432C56.8913 22.6503 56.8886 22.7637 56.8814 22.8831C56.8742 23.0025 56.8624 23.1305 56.847 23.2599L56.7277 24.399C56.7132 24.5074 56.7028 24.584 56.6996 24.6309C56.6965 24.6778 56.696 24.7275 56.696 24.774C56.6904 24.8974 56.7198 25.0198 56.7806 25.1271C56.8429 25.2217 56.9339 25.2933 57.0401 25.3312V25.621H53.2742C53.2542 25.5443 53.2404 25.4662 53.233 25.3873C53.2267 25.3048 53.2213 25.2146 53.2213 25.1162C53.2213 25.0501 53.2267 24.9667 53.233 24.8646C53.2394 24.7626 53.2525 24.6396 53.267 24.5001L53.4252 23.3679C53.4338 23.3005 53.4411 23.2312 53.4465 23.1629C53.4519 23.0945 53.4537 22.9956 53.4537 22.874C53.4537 22.3937 53.3181 22.0572 53.0467 21.8643C52.7754 21.6714 52.3002 21.5745 51.621 21.5736H50.7066L50.0966 25.6224L46.6562 25.6196ZM51.0449 19.1765H52.7469C53.281 19.1765 53.6748 19.0854 53.9272 18.8972C54.1795 18.709 54.3066 18.4179 54.3066 18.0215C54.3066 17.6806 54.1967 17.4291 53.9738 17.2792C53.7508 17.1293 53.3859 17.0514 52.8817 17.0514H51.375L51.0449 19.1765Z",
        fill: "white"
}), _jsx("path", {
        d: "M57.9375 25.6196L59.6423 14.375H68.2676L67.8606 17.0491H62.7168L62.4672 18.5946H67.0435L66.6437 21.0947H62.0815L61.8472 22.8977H67.3188L66.9367 25.6192L57.9375 25.6196Z",
        fill: "white"
}), _jsx("path", {
        d: "M67.9844 25.6196L69.6421 14.375H74.0796C75.1995 14.375 76.0679 14.5015 76.6847 14.7545C77.3015 15.0076 77.8398 15.4403 78.2995 16.0527C78.6067 16.4606 78.8443 16.9536 79.0122 17.5316C79.182 18.1432 79.2654 18.7757 79.26 19.4107C79.26 21.4213 78.7345 22.9589 77.6836 24.0235C76.6327 25.0882 75.1154 25.6198 73.1318 25.6183L67.9844 25.6196ZM71.923 22.8261H72.7456C73.3054 22.8261 73.7332 22.7806 74.0199 22.6958C74.3085 22.6127 74.5731 22.461 74.7913 22.2534C75.0568 22.0019 75.2779 21.6123 75.4479 21.0929C75.623 20.5551 75.71 19.9922 75.7057 19.4262C75.7057 18.5787 75.5456 17.9814 75.22 17.6346C74.8944 17.2879 74.3405 17.1198 73.5469 17.1198H72.7456L71.923 22.8261Z",
        fill: "white"
})), _jsx("defs", {}, void 0, _jsx("linearGradient", {
        id: "paint0_linear_9967_14503",
        x1: "0",
        y1: "20",
        x2: "86",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
}, void 0, _jsx("stop", {
        "stop-color": "#E31837"
}), _jsx("stop", {
        offset: "1",
        "stop-color": "#004990"
})), _jsx("linearGradient", {
        id: "paint1_linear_9967_14503",
        x1: "-0.046875",
        y1: "20",
        x2: "85.9531",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
}, void 0, _jsx("stop", {
        "stop-color": "#E31837"
}), _jsx("stop", {
        offset: "1",
        "stop-color": "#004990"
})), _jsx("clipPath", {
        id: "clip0_9967_14503"
}, void 0, _jsx("rect", {
        width: "86",
        height: "40",
        rx: "4",
        fill: "white"
}))));

var BetfredLogo = function BetfredLogo() {
        return _ref;
};

exports.default = BetfredLogo;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BookmakersList = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _accountPage = __webpack_require__(55);

var accountActions = _interopRequireWildcard(_accountPage);

var _drawer = __webpack_require__(38);

var drawerActions = _interopRequireWildcard(_drawer);

var _bookmakersInfo = __webpack_require__(6);

var _externalAccount = __webpack_require__(85);

__webpack_require__(91);

var _BookmakersListHeader = __webpack_require__(575);

var _BookmakersListHeader2 = _interopRequireDefault(_BookmakersListHeader);

var _BookmakersListItem = __webpack_require__(576);

var _BookmakersListItem2 = _interopRequireDefault(_BookmakersListItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx("span", {
	className: "root__bookmakersPageText"
}, void 0, "my bookmakers");

var _ref2 = _jsx("span", {
	className: "root__bookmakersPageText",
	"data-test-selector": "Text__AddBookmakerAccount"
}, void 0, "add bookmaker account");

var BookmakersList = exports.BookmakersList = function (_PureComponent) {
	_inherits(BookmakersList, _PureComponent);

	function BookmakersList(props) {
		_classCallCheck(this, BookmakersList);

		var _this = _possibleConstructorReturn(this, (BookmakersList.__proto__ || Object.getPrototypeOf(BookmakersList)).call(this, props));

		_this.toggleBookmakerOffer = function (bookmakerIndex) {
			_this.setState({
				activeBookmakerOfferIndex: bookmakerIndex
			});
		};

		_this.componentWillUnmount = function () {
			_this.props.clearExternalBetHistoryData();
			_this.props.clearExternalAccountData();
		};

		_this.state = {
			activeBookmakerOfferIndex: null
		};
		return _this;
	}

	_createClass(BookmakersList, [{
		key: "render",
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    bookmakers = _props.bookmakers,
			    onSelect = _props.onSelect,
			    selectedBookmaker = _props.selectedBookmaker,
			    requestLogout = _props.requestLogout,
			    toggleBalanceVisibility = _props.toggleBalanceVisibility,
			    onHistoryChanged = _props.onHistoryChanged,
			    selectedBookmakerFeed = _props.selectedBookmakerFeed,
			    loggedInBookmakersList = _props.loggedInBookmakersList,
			    addAccountBookmakersList = _props.addAccountBookmakersList,
			    externalBetHistoryUrl = _props.externalBetHistoryUrl,
			    isExternalBetHistoryError = _props.isExternalBetHistoryError,
			    getExternalBetHistoryUrl = _props.getExternalBetHistoryUrl,
			    clearSelectedBets = _props.clearSelectedBets,
			    clearMultiples = _props.clearMultiples,
			    resetEmptyBetslip = _props.resetEmptyBetslip,
			    selectedBets = _props.selectedBets;

			return _jsx("div", {
				className: "js-bs-bookmakersPage",
				"data-test-selector": "Container__BookmakersPageList"
			}, void 0, _jsx("section", {
				className: "root"
			}, void 0, _jsx(_BookmakersListHeader2.default, {
				bookmakers: bookmakers,
				loggedInBookmakersList: loggedInBookmakersList,
				onSelect: onSelect,
				selectedBookmaker: selectedBookmaker
			}), _jsx("div", {
				className: "root__bookmakersContent root__rnCanvas"
			}, void 0, loggedInBookmakersList.length > 0 && _ref, _jsx("div", {
				className: "root__bookmakersContentAccountLoggedIn",
				"data-test-selector": "Container__LoggedInBookmakers"
			}, void 0, loggedInBookmakersList.map(function (bookmaker, index) {
				return _jsx(_BookmakersListItem2.default, {
					bookmakerIndex: index,
					isLoggedIn: true,
					checked: selectedBookmaker === bookmaker.feed,
					toggleBalanceVisibility: toggleBalanceVisibility,
					requestLogout: requestLogout,
					bookmaker: bookmaker,
					apiName: bookmaker.apiName,
					feed: bookmaker.feed,
					analyticsName: bookmaker.analyticsName,
					name: bookmaker.name,
					onHistoryChanged: onHistoryChanged,
					bookmakersList: bookmakers,
					selectedBookmakerFeed: selectedBookmakerFeed,
					registrationOffer: bookmaker.registrationOffer,
					registrationLink: bookmaker.registrationLink,
					registrationOfferLinkUrl: bookmaker.registrationOfferLinkUrl,
					registrationOfferHeadline: bookmaker.registrationOfferHeadline,
					registrationOfferLinkText: bookmaker.registrationOfferLinkText,
					registrationOfferDetailsLink: bookmaker.registrationOfferDetailsLink,
					userInfo: bookmaker.userInfo,
					withdrawBookmakerUrl: bookmaker.withdrawBookmakerUrl,
					isExternalLogout: bookmaker.isExternalLogout,
					externalBetHistoryUrl: externalBetHistoryUrl,
					isExternalBetHistoryError: isExternalBetHistoryError,
					getExternalBetHistoryUrl: getExternalBetHistoryUrl,
					clearSelectedBets: clearSelectedBets,
					clearMultiples: clearMultiples,
					resetEmptyBetslip: resetEmptyBetslip,
					selectedBets: selectedBets
				}, bookmaker.feed);
			}))), _jsx("div", {
				className: "root__bookmakersContent root__rnCanvas"
			}, void 0, _ref2, _jsx("div", {
				className: "root__bookmakersContentAccount",
				"data-test-selector": "Container__NonLoggedInBookmakers"
			}, void 0, addAccountBookmakersList.map(function (bookmaker, index) {
				if (bookmaker.shouldNotRender) {
					return null;
				}
				return _jsx(_BookmakersListItem2.default, {
					bookmakerIndex: index,
					isLoginLeftPositioned: index % 2 === 1 && index !== 0,
					checked: selectedBookmaker === bookmaker.feed,
					toggleBalanceVisibility: toggleBalanceVisibility,
					requestLogout: requestLogout,
					bookmaker: bookmaker,
					apiName: bookmaker.apiName,
					feed: bookmaker.feed,
					analyticsName: bookmaker.analyticsName,
					name: bookmaker.name,
					onHistoryChanged: onHistoryChanged,
					bookmakersList: bookmakers,
					selectedBookmakerFeed: selectedBookmakerFeed,
					registrationOffer: bookmaker.registrationOffer,
					registrationLink: bookmaker.registrationLink,
					registrationOfferLinkUrl: bookmaker.registrationOfferLinkUrl,
					registrationOfferHeadline: bookmaker.registrationOfferHeadline,
					registrationOfferLinkText: bookmaker.registrationOfferLinkText,
					registrationOfferDetailsLink: bookmaker.registrationOfferDetailsLink,
					userInfo: bookmaker.userInfo,
					isWindowLogin: bookmaker.loginType === "window",
					activeBookmakerOfferIndex: _this2.state.activeBookmakerOfferIndex,
					toggleBookmakerOffer: _this2.toggleBookmakerOffer
				}, bookmaker.feed);
			})))));
		}
	}]);

	return BookmakersList;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
	var _state$bookmakersSwit = state.bookmakersSwitcher.accountPage,
	    externalBetHistoryUrl = _state$bookmakersSwit.externalBetHistoryUrl,
	    isExternalBetHistoryError = _state$bookmakersSwit.isExternalBetHistoryError,
	    bookmakersList = state.bookmakersList,
	    selectedBets = state.bookmakersInfo.selectedBets;


	var filteredBySections = bookmakersList.reduce(function (list, bookmakerInfo) {
		if (bookmakerInfo.hasOwnProperty("userInfo") && bookmakerInfo.isLoggedIn && !bookmakerInfo.userInfo.error) {
			return _extends({}, list, {
				loggedIn: [].concat(_toConsumableArray(list.loggedIn), [bookmakerInfo])
			});
		}

		return _extends({}, list, {
			addAccount: [].concat(_toConsumableArray(list.addAccount), [bookmakerInfo])
		});
	}, { loggedIn: [], addAccount: [] });

	return {
		loggedInBookmakersList: filteredBySections.loggedIn,
		addAccountBookmakersList: filteredBySections.addAccount,
		externalBetHistoryUrl: externalBetHistoryUrl,
		isExternalBetHistoryError: isExternalBetHistoryError,
		selectedBets: selectedBets
	};
};

var mapDispatchToProps = {
	getExternalBetHistoryUrl: accountActions.getExternalBetHistoryUrl,
	clearExternalBetHistoryData: accountActions.clearExternalBetHistoryData,
	clearExternalAccountData: _externalAccount.clearExternalAccountData,
	clearSelectedBets: _bookmakersInfo.actions.clearSelectedBets,
	clearMultiples: _bookmakersInfo.actions.clearMultiples,
	resetEmptyBetslip: drawerActions.resetEmptyBetslip
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BookmakersList);

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BookmakersListHeader = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx("div", {
	className: "root__pageHeaderMainTitle"
}, void 0, _jsx(_svgIcon2.default, {
	iconName: "bookmakerLogo",
	size: "Large"
}), _jsx("h1", {
	"data-test-selector": "Text__MyBookmakersPageHeader"
}, void 0, "my bookmakers"));

var _ref2 = _jsx("span", {}, void 0, "Log in below to see your bookmaker accounts");

var _ref3 = _jsx("span", {
	"data-test-selector": "Text__MyBookmakersPagePricesNotification"
}, void 0, "These prices will show", _jsx("br", {}), " on all racecards");

var _ref4 = _jsx("span", {}, void 0, "my selected odds", " ", _jsx(_svgIcon2.default, {
	iconName: "chevronDown",
	size: "SmallPlus"
}));

var _ref5 = _jsx(_svgIcon2.default, {
	iconName: "info-aqua",
	size: "regular"
});

var BookmakersListHeader = exports.BookmakersListHeader = function (_PureComponent) {
	_inherits(BookmakersListHeader, _PureComponent);

	function BookmakersListHeader(props) {
		_classCallCheck(this, BookmakersListHeader);

		var _this = _possibleConstructorReturn(this, (BookmakersListHeader.__proto__ || Object.getPrototypeOf(BookmakersListHeader)).call(this, props));

		_this.toggleBookmakersDropdown = function () {
			_this.setState(function (prevState) {
				return {
					isBestOddsDropdownActive: !prevState.isBestOddsDropdownActive
				};
			});
		};

		_this.unselectTierTwoBookmakerOnMobile = function () {
			var isMobile = window.innerWidth < 720;
			var _this$props = _this.props,
			    onSelect = _this$props.onSelect,
			    selectedBookmaker = _this$props.selectedBookmaker,
			    bookmakers = _this$props.bookmakers;


			var isAvailableOnPhone = bookmakers.length > 0 && bookmakers.find(function (bookmaker) {
				return bookmaker.feed === selectedBookmaker;
			}).availableOnPhone;
			if (isMobile && !isAvailableOnPhone) {
				onSelect("#BESTODDS", false);
			}

			_this.setState({
				isMobile: isMobile
			});
		};

		_this.getCookie = function (name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			if (parts.length === 2) {
				return parts.pop().split(';').shift();
			}

			return null;
		};

		_this.removeCookie = function (name, value, path, domain) {
			document.cookie = name + "=" + value + ";expires=-1;path=" + path + ";domain=" + domain;
		};

		_this.state = {
			isBestOddsDropdownActive: false,
			bookmakersList: [],
			isMobile: false
		};
		return _this;
	}

	_createClass(BookmakersListHeader, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			var onSelect = this.props.onSelect;
			// Note:
			// With the removal of Sporting Bet we need to fallback
			// the selected bookmaker to BestOdds

			if (this.props.selectedBookmaker === "SPORTING INDEX") {
				this.props.onSelect("#BESTODDS", false);
			} else {
				var defaultChooseBookie = this.getCookie('defaultChooseBookie');
				if (defaultChooseBookie) {
					var domain = "." + window.location.host.split('.').slice(1).join('.');
					this.removeCookie('defaultChooseBookie', defaultChooseBookie, '/', domain);
					onSelect(defaultChooseBookie, false);
				}
			}
			window.addEventListener("resize", this.unselectTierTwoBookmakerOnMobile.bind(this));
			// eslint-disable-next-line react/no-did-mount-set-state
			this.unselectTierTwoBookmakerOnMobile();
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			window.removeEventListener("resize", this.unselectTierTwoBookmakerOnMobile.bind(this));
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    bookmakers = _props.bookmakers,
			    loggedInBookmakersList = _props.loggedInBookmakersList,
			    onSelect = _props.onSelect,
			    selectedBookmaker = _props.selectedBookmaker;


			var isLoggedToAnyBookmaker = loggedInBookmakersList.length > 0;
			var rawBalanceData = loggedInBookmakersList.reduce(function (acc, curr) {
				if (curr.userInfo.currency === "GBP") {
					return _extends({}, acc, {
						totalBalance: _extends({}, acc.totalBalance, {
							GBP: acc.totalBalance.GBP + curr.userInfo.balance
						}),
						totalFreeBets: _extends({}, acc.totalFreeBets, {
							GBP: acc.totalFreeBets.GBP + curr.userInfo.freeBetBalance
						})
					});
				} else if (curr.userInfo.currency === "EUR") {
					return _extends({}, acc, {
						totalBalance: _extends({}, acc.totalBalance, {
							EUR: acc.totalBalance.EUR + curr.userInfo.balance
						}),
						totalFreeBets: _extends({}, acc.totalFreeBets, {
							EUR: acc.totalFreeBets.EUR + curr.userInfo.freeBetBalance
						})
					});
				}

				return _extends({}, acc, {
					totalBalance: _extends({}, acc.totalBalance, {
						USD: acc.totalBalance.USD + curr.userInfo.balance
					}),
					totalFreeBets: _extends({}, acc.totalFreeBets, {
						USD: acc.totalFreeBets.USD + curr.userInfo.freeBetBalance
					})
				});
			}, {
				totalBalance: {
					GBP: 0,
					USD: 0,
					EUR: 0
				},
				totalFreeBets: {
					GBP: 0,
					USD: 0,
					EUR: 0
				}
			});

			var totalBalance = Object.values(rawBalanceData.totalBalance).map(function (balance, index) {
				return new Intl.NumberFormat("en-GB", {
					style: "currency",
					currency: index === 0 ? "GBP" : index === 1 ? "USD" : "EUR",
					minimumFractionDigits: 2
				}).format(balance);
			}).filter(function (item) {
				var transformed = item.replace("US", ""); // it adds US in front and we don't want it

				if (transformed.substring(1) === "0.00") {
					return false;
				}

				return true;
			}).join(" + ");

			var totalFreeBets = Object.values(rawBalanceData.totalFreeBets).map(function (freeBet, index) {
				return new Intl.NumberFormat("en-GB", {
					style: "currency",
					currency: index === 0 ? "GBP" : index === 1 ? "USD" : "EUR",
					minimumFractionDigits: 2
				}).format(freeBet);
			}).filter(function (item) {
				var transformed = item.replace("US", ""); // it adds US in front and we don't want it

				if (transformed.substring(1) === "0.00") {
					return false;
				}

				return true;
			}).join(" + ");

			var bestOdds = bookmakers.find(function (bookmaker) {
				return bookmaker.name === "BestOdds";
			});
			var filteredBookmakers = bookmakers.filter(function (bookmaker) {
				return bookmaker.name !== "BestOdds";
			});
			var bookmakersList = [bestOdds].concat(_toConsumableArray(filteredBookmakers));

			return _jsx("div", {
				className: "root__pageHeader"
			}, void 0, _jsx("div", {
				className: (0, _classnames2.default)("root__pageHeaderContainer", {
					root__pageHeaderContainerUserLoggedIn: isLoggedToAnyBookmaker
				})
			}, void 0, _jsx("div", {
				className: "root__pageHeaderSelectedOddsWrapper"
			}, void 0, _jsx("div", {
				className: "root__pageHeaderTitles"
			}, void 0, _ref, !isLoggedToAnyBookmaker && _ref2), _jsx("div", {
				className: "root__pageHeaderSelectedOdds"
			}, void 0, _ref3, _jsx("div", {
				className: "root__pageHeaderOddsDropdownWrapper"
			}, void 0, _jsx("div", {
				className: "root__pageHeaderSelectedBookmaker",
				onClick: this.toggleBookmakersDropdown,
				"data-test-selector": "Button__ToggleBookmakersDropdown"
			}, void 0, _ref4, _jsx("div", {
				className: "root__pageHeaderOddsDropdownValue",
				"data-test-selector": "Text__SelectedBookmaker"
			}, void 0, bookmakers.find(function (bookmaker) {
				return bookmaker.feed === selectedBookmaker;
			}).displayName)), this.state.isBestOddsDropdownActive && _jsx("ul", {}, void 0, bookmakersList.map(function (bookmaker) {
				if (!bookmaker.availableOnPhone && _this2.state.isMobile) {
					return null;
				}

				return _jsx("li", {
					onClick: function onClick() {
						onSelect(bookmaker.feed);
						_this2.toggleBookmakersDropdown();
					},
					"data-test-selector": "Text__" + bookmaker.name + "__Bookmaker"
				}, bookmaker.displayName, bookmaker.displayName);
			}))))), isLoggedToAnyBookmaker && _jsx("div", {
				className: "root__pageHeaderBookmakersBalance"
			}, void 0, _jsx("ul", {}, void 0, _jsx("li", {}, void 0, _jsx("p", {
				"data-test-selector": "Text__TotalBalance"
			}, void 0, "Total balance", _jsx("span", {}, void 0, totalBalance || "0.00"))), _jsx("li", {}, void 0, _jsx("p", {
				"data-test-selector": "Text__TotaFreeBets"
			}, void 0, "Total free bets", _jsx("span", {}, void 0, _ref5, totalFreeBets || "0.00")))), _jsx("ul", {}, void 0, loggedInBookmakersList.map(function (bookmaker) {
				var balancePercentage = bookmaker.userInfo.balance / Number((rawBalanceData.totalBalance.EUR + rawBalanceData.totalBalance.USD + rawBalanceData.totalBalance.GBP).toFixed(2)) * 100;

				return _jsx("li", {}, bookmaker.displayName, _jsx("span", {
					"data-test-selector": "Text__" + bookmaker.name + "__LoggedInBookmaker"
				}, void 0, bookmaker.displayName), _jsx("div", {
					className: "root__pageHeaderBookmakerBalance"
				}, void 0, _jsx("span", {
					"data-test-selector": "Text__" + bookmaker.name + "__LoggedInBookmakerBalance"
				}, void 0, bookmaker.userInfo.currencySign, bookmaker.userInfo.balance.toFixed(2)), _jsx("div", {
					className: "root__pageHeaderBookmakerBalancePercentage"
				}, void 0, _jsx("hr", {
					className: (0, _classnames2.default)({
						root__pageHeaderBet365BalancePercentage: bookmaker.name === "bet365"
					}, {
						root__pageHeaderLadbrokesBalancePercentage: bookmaker.name === "ladbrokes"
					}, {
						root__pageHeaderCoralBalancePercentage: bookmaker.name === "coral"
					}, {
						root__pageHeaderBetfairBalancePercentage: bookmaker.name === "betfair"
					}, {
						root__pageHeaderWhBalancePercentage: bookmaker.name === "williamHill"
					}, {
						root__pageHeaderPpBalancePercentage: bookmaker.name === "paddyPower"
					}, {
						root__pageHeaderSkybetBalancePercentage: bookmaker.name === "skybet"
					}),
					style: {
						width: bookmaker.userInfo.balance === 0 ? "1px" : balancePercentage + "%"
					}
				}))));
			})))));
		}
	}]);

	return BookmakersListHeader;
}(_react.PureComponent);

exports.default = BookmakersListHeader;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(8);

var _ExternalAccount = __webpack_require__(134);

var _ExternalAccount2 = _interopRequireDefault(_ExternalAccount);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _SwitchBookmakerButtons = __webpack_require__(578);

var _SwitchBookmakerButtons2 = _interopRequireDefault(_SwitchBookmakerButtons);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _signUpOfferPage = __webpack_require__(503);

var _signUpOfferPage2 = _interopRequireDefault(_signUpOfferPage);

var _SkyBetLogo = __webpack_require__(228);

var _SkyBetLogo2 = _interopRequireDefault(_SkyBetLogo);

var _bookmakersList = __webpack_require__(123);

__webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_SkyBetLogo2.default, {});

var _ref2 = _jsx(_svgIcon2.default, {
	iconName: "info-aqua",
	size: "regular"
});

var _ref3 = _jsx(_svgIcon2.default, {
	iconName: "chevronRight",
	size: "regular"
});

var _ref4 = _jsx(_svgIcon2.default, {
	iconName: "chevronRight",
	size: "regular"
});

var _ref5 = _jsx("span", {
	"data-test-selector": "Text__BookmakerBalance"
}, void 0, "Balance");

var _ref6 = _jsx(_svgIcon2.default, {
	iconName: "chevronDown",
	size: "SmallPlus"
});

var BookmakersListItem = function (_PureComponent) {
	_inherits(BookmakersListItem, _PureComponent);

	function BookmakersListItem(props) {
		_classCallCheck(this, BookmakersListItem);

		var _this = _possibleConstructorReturn(this, (BookmakersListItem.__proto__ || Object.getPrototypeOf(BookmakersListItem)).call(this, props));

		_this.toggleRegistrationOffer = function () {
			var _window$SegmentIO$tra;

			_this.setState(function (prevState) {
				return {
					isOfferVisible: !prevState.isOfferVisible
				};
			});

			var _this$props = _this.props,
			    analyticsName = _this$props.analyticsName,
			    bookmakerIndex = _this$props.bookmakerIndex,
			    registrationOfferHeadline = _this$props.registrationOfferHeadline;


			window.SegmentIO.trackOfferAccordion((_window$SegmentIO$tra = {}, _defineProperty(_window$SegmentIO$tra, SegmentIO.TRAIT_BOOKMAKER_NAME, analyticsName), _defineProperty(_window$SegmentIO$tra, SegmentIO.TRAIT_OFFERS_BANNER, null), _defineProperty(_window$SegmentIO$tra, SegmentIO.TRAIT_BOOKMAKER_OFFER, registrationOfferHeadline), _defineProperty(_window$SegmentIO$tra, SegmentIO.TRAIT_POSITION, bookmakerIndex + 1), _window$SegmentIO$tra));
		};

		_this.toggleMobileRegistrationoffer = function (registrationOffer, isOfferActive) {
			var _window$SegmentIO$tra2;

			if (!registrationOffer) {
				return false;
			}

			var _this$props2 = _this.props,
			    analyticsName = _this$props2.analyticsName,
			    bookmakerIndex = _this$props2.bookmakerIndex,
			    registrationOfferHeadline = _this$props2.registrationOfferHeadline,
			    toggleBookmakerOffer = _this$props2.toggleBookmakerOffer;


			toggleBookmakerOffer(isOfferActive ? null : bookmakerIndex);

			window.SegmentIO.trackOfferAccordion((_window$SegmentIO$tra2 = {}, _defineProperty(_window$SegmentIO$tra2, SegmentIO.TRAIT_BOOKMAKER_NAME, analyticsName), _defineProperty(_window$SegmentIO$tra2, SegmentIO.TRAIT_OFFERS_BANNER, null), _defineProperty(_window$SegmentIO$tra2, SegmentIO.TRAIT_BOOKMAKER_OFFER, registrationOfferHeadline), _defineProperty(_window$SegmentIO$tra2, SegmentIO.TRAIT_POSITION, bookmakerIndex + 1), _window$SegmentIO$tra2));
		};

		_this.toggleSkyBetInfoPage = function () {
			_this.setState(function (prevState) {
				return {
					isSkybetPageInfoOpen: !prevState.isSkybetPageInfoOpen
				};
			});
		};

		_this.handleOutsideClick = function (e) {
			if (_this.offerButtonRef && _this.offerButtonRef.current && !_this.offerButtonRef.current.contains(e.target)) {
				_this.setState({
					isOfferVisible: false
				});
			}

			if (_this.skyBetButtonHistoryRef && _this.skyBetButtonHistoryRef.current && !_this.skyBetButtonHistoryRef.current.contains(e.target)) {
				_this.setState({
					isSkybetPageInfoOpen: false
				});
			}
		};

		_this.onLogoutClick = function () {
			if (_this.props.selectedBets.length > 0 &&
			// eslint-disable-next-line react/prop-types
			_this.props.selectedBets[0].feed === _this.props.feed) {
				_this.props.clearSelectedBets();
				_this.props.clearMultiples();
				_this.props.resetEmptyBetslip();
			}
			_this.props.requestLogout(_this.props.apiName, _this.props.feed, _this.props.isExternalLogout);
		};

		_this.handleCreateAccountClick = function (event) {
			var _window$SegmentIO$tra3;

			event.stopPropagation();
			var _this$props3 = _this.props,
			    analyticsName = _this$props3.analyticsName,
			    bookmakerIndex = _this$props3.bookmakerIndex,
			    registrationOfferHeadline = _this$props3.registrationOfferHeadline;


			window.SegmentIO.trackBookmakerRegistrationTap((_window$SegmentIO$tra3 = {}, _defineProperty(_window$SegmentIO$tra3, SegmentIO.TRAIT_BOOKMAKER_NAME, analyticsName), _defineProperty(_window$SegmentIO$tra3, SegmentIO.TRAIT_OFFERS_BANNER, null), _defineProperty(_window$SegmentIO$tra3, SegmentIO.TRAIT_BOOKMAKER_OFFER, registrationOfferHeadline), _defineProperty(_window$SegmentIO$tra3, SegmentIO.TRAIT_POSITION, bookmakerIndex + 1), _window$SegmentIO$tra3));
		};

		_this.componentDidMount = function () {
			document.addEventListener("mousedown", _this.handleOutsideClick);

			if (_this.props.apiName === "skybet" && _this.props.getExternalBetHistoryUrl) {
				_this.props.getExternalBetHistoryUrl(_this.props.apiName);
			}

			var userTraits = JSON.parse(localStorage.getItem("__user_traits") || "{}");
			var recentBookmakers = JSON.parse(localStorage.getItem("recentBookmakers") || "{}");

			var quizBookmakerAccounts = _bookmakersList.BOOKMAKERS_QUIZ.filter(function (key) {
				return Boolean(userTraits[key]);
			}).map(function (key) {
				return key.replace("_quiz", "").replaceAll("_", "");
			});
			var filteredRencetBookmakers = Object.keys(recentBookmakers).map(function (key) {
				return key.replaceAll("_", "");
			});
			var excludedBookmakers = new Set([].concat(_toConsumableArray(quizBookmakerAccounts), _toConsumableArray(filteredRencetBookmakers)));

			_this.setState({ existingBookmakerAccounts: Array.from(excludedBookmakers) });
		};

		_this.componentWillUnmount = function () {
			document.removeEventListener("mousedown", _this.handleOutsideClick);
		};

		_this.state = {
			isOfferVisible: false,
			isSkybetPageInfoOpen: false,
			existingBookmakerAccounts: []
		};

		_this.skyBetButtonHistoryRef = (0, _react.createRef)();
		_this.offerButtonRef = (0, _react.createRef)();
		return _this;
	}

	// eslint-disable-next-line consistent-return


	_createClass(BookmakersListItem, [{
		key: "render",
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    bookmakerIndex = _props.bookmakerIndex,
			    isLoginLeftPositioned = _props.isLoginLeftPositioned,
			    name = _props.name,
			    feed = _props.feed,
			    isLoggedIn = _props.isLoggedIn,
			    registrationOffer = _props.registrationOffer,
			    registrationLink = _props.registrationLink,
			    registrationOfferLinkUrl = _props.registrationOfferLinkUrl,
			    userInfo = _props.userInfo,
			    apiName = _props.apiName,
			    bookmakersList = _props.bookmakersList,
			    registrationOfferHeadline = _props.registrationOfferHeadline,
			    registrationOfferLinkText = _props.registrationOfferLinkText,
			    registrationOfferDetailsLink = _props.registrationOfferDetailsLink,
			    withdrawBookmakerUrl = _props.withdrawBookmakerUrl,
			    isWindowLogin = _props.isWindowLogin,
			    activeBookmakerOfferIndex = _props.activeBookmakerOfferIndex,
			    externalBetHistoryUrl = _props.externalBetHistoryUrl,
			    isExternalBetHistoryError = _props.isExternalBetHistoryError;

			// NOTE: [JP-9947] isExistingBookmakerAccount present quiz results from user
			// sign where they have bookmaker account

			var isExistingBookmakerAccount = this.state.existingBookmakerAccounts.includes(name.toLowerCase());
			var isOfferActive = activeBookmakerOfferIndex === bookmakerIndex;

			return _jsx("div", {
				className: "root__bookmakersContentBox",
				"data-test-selector": "Container__" + name + "__Bookmaker"
			}, void 0, _jsx("div", {
				className: "root__bookmakersContentMain"
			}, void 0, _jsx("div", {
				className: "root__bookmakersContentLeft"
			}, void 0, _jsx("span", {
				className: "root__bookmakersContentLeftLogo",
				"data-test-selector": "Image__" + name + "__BookmakerLogo"
			}, void 0, name === "skybet" ? _ref : _jsx(_svgIcon2.default, {
				iconName: name,
				size: "8XL"
			})), !isLoggedIn ? _react2.default.createElement(
				"div",
				{
					className: "root__bookmakersContentLeftOffers",
					ref: this.offerButtonRef,
					"data-test-selector": "Container__" + name + "__BookmakerOffer"
				},
				registrationOffer && !isExistingBookmakerAccount && _jsx(_react2.default.Fragment, {}, void 0, _jsx("div", {
					className: "root__bookmakerOffer",
					onClick: this.toggleRegistrationOffer,
					"data-test-selector": "Button__" + name + "__ToggleBookmakerOffer"
				}, void 0, _ref2, this.state.isOfferVisible && _jsx(_signUpOfferPage2.default, {
					offerHeadline: registrationOfferHeadline,
					offerContent: registrationOffer,
					offerLink: registrationOfferDetailsLink,
					buttonText: registrationOfferLinkText,
					defaultBookmakerUrl: withdrawBookmakerUrl,
					analyticsRegistrationClick: this.handleCreateAccountClick
				})), _jsx("span", {
					className: "root__bookmakersPageTextContent",
					"data-test-selector": "Text__" + name + "__BookmakerOfferHeadline"
				}, void 0, registrationOfferHeadline))
			) : _jsx("div", {
				className: "root__bookmakersAccountBalance",
				"data-test-selector": "Container__" + name + "__BookmakerAccount"
			}, void 0, name === "skybet" ? _jsx(_react2.default.Fragment, {}, void 0, _react2.default.createElement(
				"span",
				{
					className: "root__bookmakersBetHistory",
					onClick: this.toggleSkyBetInfoPage,
					ref: this.skyBetButtonHistoryRef,
					"data-test-selector": "Button__" + name + "__BookmakerBetHistory"
				},
				"Bet History",
				" ",
				_ref3
			), this.state.isSkybetPageInfoOpen && _jsx(_ExternalAccount2.default, {
				type: "window",
				windowName: "History",
				externalAccountUrl: externalBetHistoryUrl,
				isExternalAccountError: isExternalBetHistoryError,
				onExternalBackButtonClick: this.toggleSkyBetInfoPage
			})) : _jsx(_reactRouterDom.Link, {
				to: feed + "/bethistory",
				className: "root__bookmakersBetHistory",
				"data-test-selector": "Link__" + name + "__BookmakerBetHistory"
			}, void 0, "Bet History ", _ref4), _jsx("div", {
				className: "root__bookmakersBalance"
			}, void 0, _ref5, _jsx("span", {
				"data-test-selector": "Text__" + name + "__BookmakerBalance"
			}, void 0, userInfo.currencySign, userInfo.balance)))), _jsx("div", {
				className: "root__bookmakersContentRight"
			}, void 0, _jsx(_SwitchBookmakerButtons2.default, {
				apiName: apiName,
				isLoggedIn: isLoggedIn,
				registrationLink: registrationLink,
				registrationOfferLinkUrl: registrationOfferLinkUrl,
				onLogout: this.onLogoutClick,
				analyticsRegistrationClick: this.handleCreateAccountClick,
				isLoginLeftPositioned: isLoginLeftPositioned,
				bookmakersList: bookmakersList,
				feed: feed,
				name: name,
				withdrawBookmakerUrl: withdrawBookmakerUrl,
				isWindowLogin: isWindowLogin,
				shouldShowSignUp: !isExistingBookmakerAccount
			}), !isLoggedIn && !isExistingBookmakerAccount && _jsx("div", {
				className: (0, _classnames2.default)("root__bookmakersMobileOfferBtn", {
					root__bookmakersMobileOfferToggled: isOfferActive
				}),
				onClick: function onClick() {
					return _this2.toggleMobileRegistrationoffer(registrationOffer, isOfferActive);
				},
				"data-test-selector": "Button__" + name + "__ToggleMobileBookmakerOffer"
			}, void 0, _jsx("span", {}, void 0, "SIGN UP ", registrationOffer && "OFFER"), _ref6))), !isLoggedIn && registrationOffer && isOfferActive && _jsx("div", {
				className: "root__bookmakersMobileOfferWrapper",
				"data-test-selector": "Container__" + name + "__BookmakerMobileOffer"
			}, void 0, _jsx(_signUpOfferPage2.default, {
				offerHeadline: registrationOfferHeadline,
				offerContent: registrationOffer,
				offerLink: registrationOfferDetailsLink,
				buttonText: registrationOfferLinkText,
				defaultBookmakerUrl: withdrawBookmakerUrl,
				analyticsRegistrationClick: this.handleCreateAccountClick
			})));
		}
	}]);

	return BookmakersListItem;
}(_react.PureComponent);

exports.default = BookmakersListItem;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colorSkinWrapper = __webpack_require__(45);

var _colorSkinWrapper2 = _interopRequireDefault(_colorSkinWrapper);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _SkyBetLogo = __webpack_require__(228);

var _SkyBetLogo2 = _interopRequireDefault(_SkyBetLogo);

__webpack_require__(91);

var _BetfredLogo = __webpack_require__(573);

var _BetfredLogo2 = _interopRequireDefault(_BetfredLogo);

var _bookmakers = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_SkyBetLogo2.default, {});

var _ref3 = _jsx(_BetfredLogo2.default, {});

var BookmakerLogo = function BookmakerLogo(_ref) {
	var bookmakerName = _ref.bookmakerName;

	switch (bookmakerName) {
		case _bookmakers.bookmakerNames.skybet:
			return _ref2;
		case _bookmakers.bookmakerNames.betfred:
			return _ref3;
		default:
			return _jsx(_svgIcon2.default, {
				iconName: bookmakerName,
				size: "8XL"
			});
	}
};

var _ref5 = _jsx(_svgIcon2.default, {
	iconName: "close",
	size: "regular"
});

var _ref6 = _jsx("h4", {}, void 0, "Odds displayed on Racing Post have been changed to:");

var SelectionInfoModal = function SelectionInfoModal(_ref4) {
	var bookmakerName = _ref4.bookmakerName,
	    bookmakerDisplayName = _ref4.bookmakerDisplayName,
	    previouslySelectedBookie = _ref4.previouslySelectedBookie,
	    hideSelectionInfoModal = _ref4.hideSelectionInfoModal;
	return _jsx(_colorSkinWrapper2.default, {
		bookmakerName: bookmakerName,
		className: "bs-selectionInfoModal\n                    bs-switchBookmakers__modal"
	}, void 0, _jsx("span", {
		onClick: hideSelectionInfoModal
	}, void 0, _ref5), _ref6, _jsx(BookmakerLogo, {
		bookmakerName: bookmakerName
	}), _jsx("p", {}, void 0, _jsx("span", {}, void 0, bookmakerDisplayName), " odds will show on all racecards and be the default odds in the betslip."), previouslySelectedBookie && _jsx("p", {}, void 0, "(You were previously viewing ", previouslySelectedBookie, ")"));
};

exports.default = SelectionInfoModal;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.SwitchBookmakerButtons = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _reactTooltipLite = __webpack_require__(386);

var _reactTooltipLite2 = _interopRequireDefault(_reactTooltipLite);

var _ExternalAccount = __webpack_require__(134);

var _ExternalAccount2 = _interopRequireDefault(_ExternalAccount);

var _reactRouterDom = __webpack_require__(8);

var _BookmakersSwitcher = __webpack_require__(562);

var _bookmakersInfo = __webpack_require__(33);

var _externalAccount = __webpack_require__(85);

var _bookmakersList = __webpack_require__(56);

var _bookmakersListPopover = __webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_svgIcon2.default, {
	iconName: "remove",
	size: "small"
});

var _ref2 = _jsx("span", {}, void 0, "logout");

var SwitchBookmakerButtons = exports.SwitchBookmakerButtons = function (_PureComponent) {
	_inherits(SwitchBookmakerButtons, _PureComponent);

	function SwitchBookmakerButtons(props) {
		_classCallCheck(this, SwitchBookmakerButtons);

		var _this = _possibleConstructorReturn(this, (SwitchBookmakerButtons.__proto__ || Object.getPrototypeOf(SwitchBookmakerButtons)).call(this, props));

		_this.toggleDepositTooltip = function (isSkyBet) {
			if (isSkyBet) {
				_this.props.getExternalAccountUrl(_this.props.apiName);
			}

			_this.setState(function (prevState) {
				return {
					isDepositTooltipActive: !prevState.isDepositTooltipActive
				};
			});
		};

		_this.toggleLoginTooltip = function () {
			_this.setState(function (prevState) {
				return {
					isLoginTooltipActive: !prevState.isLoginTooltipActive
				};
			});
		};

		_this.handleLogout = function () {
			_this.props.onLogout();

			_this.setState({
				isLogoutBtnDisabled: true
			});
		};

		_this.handleOutsideClick = function (e) {
			if (_this.depositBtnRef && _this.depositBtnRef.current && _this.depositBtnRef.current.contains(e.target)) {
				return false;
			}

			if (_this.depositTooltipRef && _this.depositTooltipRef.current && !_this.depositTooltipRef.current.contains(e.target)) {
				_this.setState({
					isDepositTooltipActive: false
				});
			}

			if (_this.loginBtnRef && _this.loginBtnRef.current && _this.loginBtnRef.current.contains(e.target)) {
				return false;
			}

			if (_this.loginTooltipRef && _this.loginTooltipRef.current && !_this.loginTooltipRef.current.contains(e.target)) {
				_this.setState({
					isLoginTooltipActive: false
				});
			}
		};

		_this.componentDidMount = function () {
			_this.setState({
				isLogoutBtnDisabled: false
			});

			if (_this.props.apiName === "skybet" && _this.props.isLoggedIn) {
				_this.props.getExternalAccountUrl(_this.props.apiName);
			}

			document.addEventListener("mousedown", _this.handleOutsideClick);
		};

		_this.componentDidUpdate = function (nextProps) {
			if (!_this.props.isLoginOpen && nextProps.isLoginOpen) {
				_this.setState(function (prevProps) {
					return _extends({}, prevProps, {
						isLoginTooltipActive: false
					});
				});
			}
		};

		_this.componentWillUnmount = function () {
			document.removeEventListener("mousedown", _this.handleOutsideClick);
		};

		_this.state = {
			isLogoutBtnDisabled: false,
			isLoginTooltipActive: false,
			isDepositTooltipActive: false
		};

		_this.depositBtnRef = (0, _react.createRef)();
		_this.depositTooltipRef = (0, _react.createRef)();
		_this.loginTooltipRef = (0, _react.createRef)();
		_this.loginBtnRef = (0, _react.createRef)();
		return _this;
	}

	// eslint-disable-next-line consistent-return


	_createClass(SwitchBookmakerButtons, [{
		key: "render",
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    isLoginLeftPositioned = _props.isLoginLeftPositioned,
			    feed = _props.feed,
			    name = _props.name,
			    isLoggedIn = _props.isLoggedIn,
			    analyticsRegistrationClick = _props.analyticsRegistrationClick,
			    bookmakersList = _props.bookmakersList,
			    activePopoverFeed = _props.activePopoverFeed,
			    openLoginPopover = _props.openLoginPopover,
			    registrationOfferLinkUrl = _props.registrationOfferLinkUrl,
			    withdrawBookmakerUrl = _props.withdrawBookmakerUrl,
			    isWindowLogin = _props.isWindowLogin,
			    externalAccountUrl = _props.externalAccountUrl,
			    isExternalAccountError = _props.isExternalAccountError,
			    shouldShowSignUp = _props.shouldShowSignUp;


			return _jsx(_react2.default.Fragment, {}, void 0, isLoggedIn ? _jsx("div", {
				className: "root__bookmakersContentRightLoggedIn",
				"data-test-selector": "Container__" + name + "__LoggedInBookmakerRightContent"
			}, void 0, name === "skybet" ? _jsx(_react2.default.Fragment, {}, void 0, _react2.default.createElement(
				"div",
				{
					className: (0, _classnames2.default)("root__bookmakersContentRightBtnDepositFunds", {
						root__bookmakersContentRightBtnDepositFundsActive: this.state.isDepositTooltipActive
					}),
					onClick: function onClick() {
						return _this2.toggleDepositTooltip(true);
					},
					ref: this.depositTooltipRef,
					"data-test-selector": "Button__skybet__Deposit"
				},
				"Deposit Funds"
			), this.state.isDepositTooltipActive && _jsx(_ExternalAccount2.default, {
				type: "window",
				windowName: "History",
				externalAccountUrl: externalAccountUrl,
				isExternalAccountError: isExternalAccountError,
				onExternalBackButtonClick: function onExternalBackButtonClick() {
					return _this2.toggleDepositTooltip(false);
				}
			})) : _jsx(_reactTooltipLite2.default, {
				content: _react2.default.createElement(
					"div",
					{
						ref: this.depositTooltipRef,
						"data-test-selector": "Container__" + name + "__Deposit"
					},
					_jsx(_BookmakersSwitcher.BookmakersSwitcher, {
						name: name,
						bookmakersList: bookmakersList,
						setBookmakersOrder: _bookmakersInfo.setBookmakersOrder,
						clearJustLoggedInBookmaker: _bookmakersList.clearJustLoggedInBookmaker,
						selectedBookmakerFeed: feed
					}, void 0, _jsx(_reactRouterDom.Redirect, {
						to: { pathname: "/" + feed + "/account/info" }
					}))
				),
				direction: "bottom",
				tagName: "span",
				useHover: false,
				isOpen: this.state.isDepositTooltipActive
			}, void 0, _react2.default.createElement(
				"div",
				{
					className: (0, _classnames2.default)("root__bookmakersContentRightBtnDepositFunds", {
						root__bookmakersContentRightBtnDepositFundsActive: this.state.isDepositTooltipActive
					}),
					onClick: this.toggleDepositTooltip,
					ref: this.depositBtnRef,
					"data-test-selector": "Button__" + name + "__Deposit"
				},
				"Deposit Funds"
			)), withdrawBookmakerUrl && _jsx("a", {
				href: withdrawBookmakerUrl,
				target: "_blank",
				className: "root__bookmakersContentRightBtnWithdrawFunds",
				"data-test-selector": "Link__" + name + "__Withdraw"
			}, void 0, "Withdraw Funds")) : isWindowLogin ? _jsx(_react2.default.Fragment, {}, void 0, this.state.isLoginTooltipActive && _react2.default.createElement(
				"div",
				{
					ref: this.loginTooltipRef,
					"data-test-selector": "Container__" + name + "__BookmakerLogin"
				},
				_jsx(_BookmakersSwitcher.BookmakersSwitcher, {
					name: name,
					bookmakersList: bookmakersList,
					setBookmakersOrder: _bookmakersInfo.setBookmakersOrder,
					clearJustLoggedInBookmaker: _bookmakersList.clearJustLoggedInBookmaker,
					selectedBookmakerFeed: feed
				}, void 0, activePopoverFeed === feed ? _jsx(_reactRouterDom.Redirect, {
					to: { pathname: "/" + feed + "/login" }
				}) : "Unable to load bookmaker")
			), _react2.default.createElement(
				"div",
				{
					className: (0, _classnames2.default)("root__bookmakersContentRightBtnLogIn", {
						root__bookmakersContentRightBtnLogInActive: this.state.isLoginTooltipActive
					}),
					onClick: function onClick() {
						openLoginPopover(feed);
						_this2.toggleLoginTooltip();
					},
					ref: this.loginBtnRef,
					"data-test-selector": "Button__" + name + "__BookmakerLogin"
				},
				"LOG IN"
			)) : _jsx(_reactTooltipLite2.default, {
				content: this.state.isLoginTooltipActive && _react2.default.createElement(
					"div",
					{ ref: this.loginTooltipRef },
					_jsx("div", {
						className: "root__bookmakersContentPopoverClose",
						onClick: this.toggleLoginTooltip,
						"data-test-selector": "Button__" + name + "__ToggleBookmakerLoginTooltip"
					}, void 0, _ref),
					_jsx(_BookmakersSwitcher.BookmakersSwitcher, {
						name: name,
						bookmakersList: bookmakersList,
						setBookmakersOrder: _bookmakersInfo.setBookmakersOrder,
						clearJustLoggedInBookmaker: _bookmakersList.clearJustLoggedInBookmaker,
						selectedBookmakerFeed: feed
					}, void 0, activePopoverFeed === feed ? _jsx(_reactRouterDom.Redirect, {
						to: { pathname: "/" + feed + "/login" }
					}) : "Unable to load bookmaker")
				),
				direction: isLoginLeftPositioned ? "left" : "right",
				tagName: "span",
				useHover: false,
				isOpen: this.state.isLoginTooltipActive,
				className: this.state.isLoginTooltipActive ? "root__bookmakersContentTooltipWrapper" : ""
			}, void 0, _react2.default.createElement(
				"div",
				{
					className: (0, _classnames2.default)("root__bookmakersContentRightBtnLogIn", {
						root__bookmakersContentRightBtnLogInActive: this.state.isLoginTooltipActive
					}),
					onClick: function onClick() {
						openLoginPopover(feed);
						_this2.toggleLoginTooltip();
					},
					ref: this.loginBtnRef,
					"data-test-selector": "Button__" + name + "__BookmakerLogin"
				},
				"LOG IN"
			)), isLoggedIn ? _jsx("button", {
				className: (0, _classnames2.default)("root__bookmakersContentRightBtnLogOut"),
				onClick: this.handleLogout,
				disabled: this.state.isLogoutBtnDisabled,
				"data-test-selector": "Button__" + name + "__BookmakerLogout"
			}, void 0, _ref2) : shouldShowSignUp && _jsx("a", {
				href: registrationOfferLinkUrl || withdrawBookmakerUrl,
				className: "root__bookmakersContentRightBtnSignUp",
				target: "_blank",
				onClick: analyticsRegistrationClick,
				"data-test-selector": "Link__" + name + "__BookmakerSignUp",
				rel: "noreferrer nofollow sponsored"
			}, void 0, "sign up"));
		}
	}]);

	return SwitchBookmakerButtons;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
	var _state$bookmakersList = state.bookmakersListPopover,
	    activePopoverFeed = _state$bookmakersList.activePopoverFeed,
	    activePopoverType = _state$bookmakersList.activePopoverType,
	    isLoginOpen = state.loginPage.isLoginOpen,
	    _state$externalAccoun = state.externalAccount,
	    externalAccountUrl = _state$externalAccoun.externalAccountUrl,
	    isExternalAccountError = _state$externalAccoun.isExternalAccountError;


	return {
		isLoginOpen: isLoginOpen,
		activePopoverFeed: activePopoverFeed,
		activePopoverType: activePopoverType,
		externalAccountUrl: externalAccountUrl,
		isExternalAccountError: isExternalAccountError
	};
};

var mapDispatchToProps = {
	closePopover: _bookmakersListPopover.actions.closeCurrentPopover(),
	openLoginPopover: function openLoginPopover(feed) {
		return _bookmakersListPopover.actions.setActivePopoverWithTypeAndFeed("login", feed);
	},
	getExternalAccountUrl: _externalAccount.getExternalAccountUrl
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SwitchBookmakerButtons);

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForgottenPasswordPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pageHeader = __webpack_require__(86);

var _pageHeader2 = _interopRequireDefault(_pageHeader);

var _forgottenPassword = __webpack_require__(213);

var _forgottenPassword2 = _interopRequireDefault(_forgottenPassword);

var _colorSkinWrapper = __webpack_require__(45);

var _colorSkinWrapper2 = _interopRequireDefault(_colorSkinWrapper);

var _transitionRouter = __webpack_require__(16);

var _bookmakersList = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgottenPasswordPage = exports.ForgottenPasswordPage = function ForgottenPasswordPage(_ref) {
    var match = _ref.match,
        name = _ref.name;
    return _jsx(_colorSkinWrapper2.default, {
        bookmakerName: name,
        className: 'bs-popover__content\n                    bs-switchBookmakers__content\n                    bs-horizontalSlider__element'
    }, void 0, _jsx(_pageHeader2.default, {
        backLinkUrl: '/' + match.params.feed + '/login'
    }), _jsx(_forgottenPassword2.default, {
        match: match
    }));
};

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    return _extends({}, bookmakerInfoSelector(state, props));
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(ForgottenPasswordPage);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SwitcherLoginPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pageHeader = __webpack_require__(86);

var _pageHeader2 = _interopRequireDefault(_pageHeader);

var _loginPage = __webpack_require__(36);

var _loginPage2 = _interopRequireDefault(_loginPage);

var _colorSkinWrapper = __webpack_require__(45);

var _colorSkinWrapper2 = _interopRequireDefault(_colorSkinWrapper);

var _transitionRouter = __webpack_require__(16);

var _bookmakersList = __webpack_require__(5);

var _bookmakersSwitcher = __webpack_require__(122);

var _bookmakersSwitcher2 = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwitcherLoginPage = exports.SwitcherLoginPage = function (_Component) {
    _inherits(SwitcherLoginPage, _Component);

    function SwitcherLoginPage() {
        _classCallCheck(this, SwitcherLoginPage);

        return _possibleConstructorReturn(this, (SwitcherLoginPage.__proto__ || Object.getPrototypeOf(SwitcherLoginPage)).apply(this, arguments));
    }

    _createClass(SwitcherLoginPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.redirectToLoginBookmaker) {
                this.props.clearRedirectLoginBookmaker();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                match = _props.match,
                name = _props.name,
                loginType = _props.loginType;

            var isExternalLogin = loginType === _bookmakersList.constants.LOGIN_TYPE.IFRAME || loginType === _bookmakersList.constants.LOGIN_TYPE.WINDOW;
            return _jsx('div', {
                className: 'bs-popover__content\n                            bs-switchBookmakers__content\n                            bs-horizontalSlider__element'
            }, void 0, _jsx(_colorSkinWrapper2.default, {
                bookmakerName: name,
                className: 'bs-popover__content\n                            bs-switchBookmakers__content\n                            bs-horizontalSlider__element'
            }, void 0, !isExternalLogin ? _jsx(_pageHeader2.default, {
                hideLogo: isExternalLogin
            }) : null, _jsx(_loginPage2.default, {
                match: match,
                showGamblingCompliance: true
            })));
        }
    }]);

    return SwitcherLoginPage;
}(_react.Component);

SwitcherLoginPage.defaultProps = {
    redirectToLoginBookmaker: null
};

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    return _extends({}, bookmakerInfoSelector(state, props), {
        redirectToLoginBookmaker: (0, _bookmakersSwitcher2.redirectToLoginBookmakerSelector)(state)
    });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    clearRedirectLoginBookmaker: _bookmakersSwitcher.clearRedirectLoginBookmaker
})(SwitcherLoginPage);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(660);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpOfferPage = function SignUpOfferPage(_ref) {
	var offerHeadline = _ref.offerHeadline,
	    offerContent = _ref.offerContent,
	    offerLink = _ref.offerLink,
	    buttonText = _ref.buttonText,
	    defaultBookmakerUrl = _ref.defaultBookmakerUrl,
	    analyticsRegistrationClick = _ref.analyticsRegistrationClick;
	return _jsx("div", {
		className: "root__bookmakersPopOverContentOfferBox",
		"data-test-selector": "Container__BookmakerSignUpOffer"
	}, void 0, _jsx("h1", {
		className: "root__bookmakersPopOverContentOfferHeadlineTextContent",
		"data-test-selector": "Text__BookmakerSignUpOfferHeadline"
	}, void 0, offerHeadline), _jsx("span", {
		className: "root__bookmakersPopOverContentOfferContent",
		"data-test-selector": "Text__BookmakerSignUpOfferContent"
	}, void 0, offerContent), _jsx("a", {
		href: offerLink || defaultBookmakerUrl,
		className: "root__bookmakersPopOverContentOfferButton ui-btn",
		target: "_blank",
		onClick: analyticsRegistrationClick,
		"data-test-selector": "Link__BookmakerSignUp",
		rel: "noreferrer nofollow sponsored"
	}, void 0, buttonText));
};

exports.default = SignUpOfferPage;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(661);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BestOddsGuaranteed = function BestOddsGuaranteed(_ref) {
    var className = _ref.className,
        visible = _ref.visible;

    if (!visible) {
        return null;
    }
    return _jsx('span', {
        className: (0, _classnames2.default)('bs-bog', className)
    }, void 0, 'Best Odds Guaranteed');
};

BestOddsGuaranteed.defaultProps = {
    visible: true,
    className: ''
};

exports.default = BestOddsGuaranteed;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(662);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_svgIcon2.default, {
    iconName: 'right',
    size: 'Medium',
    className: 'bs-bookmakerLink__linkIcon'
});

var BookmakerLink = function BookmakerLink(_ref) {
    var titleText = _ref.titleText,
        bookmakerUrl = _ref.bookmakerUrl,
        bookmakerName = _ref.bookmakerName,
        phoneNumber = _ref.phoneNumber,
        isPhone = _ref.isPhone;

    var linkHref = phoneNumber ? isPhone && 'tel:' + phoneNumber || null : bookmakerUrl;
    return _jsx('a', {
        href: linkHref,
        target: phoneNumber ? null : '_blank',
        rel: 'noopener noreferrer',
        className: 'bs-bookmakerLink__link bs-link bs-link_major'
    }, void 0, _jsx('span', {
        className: 'bs-bookmakerLink__linkHeader'
    }, void 0, titleText), _jsx('span', {
        className: 'bs-bookmakerLink__linkText'
    }, void 0, phoneNumber || bookmakerName), _ref2);
};

BookmakerLink.defaultProps = {
    titleText: '',
    bookmakerUrl: '',
    bookmakerName: '',
    phoneNumber: '',
    isPhone: false
};

exports.default = BookmakerLink;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(229);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

__webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReduxFormCheckbox = function (_Component) {
    _inherits(ReduxFormCheckbox, _Component);

    function ReduxFormCheckbox(props) {
        _classCallCheck(this, ReduxFormCheckbox);

        var _this = _possibleConstructorReturn(this, (ReduxFormCheckbox.__proto__ || Object.getPrototypeOf(ReduxFormCheckbox)).call(this, props));

        _this.onCheckChanged = _this.onCheckChanged.bind(_this);
        return _this;
    }

    _createClass(ReduxFormCheckbox, [{
        key: 'onCheckChanged',
        value: function onCheckChanged() {
            var _props$input = this.props.input,
                onChange = _props$input.onChange,
                value = _props$input.value;

            onChange(!value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$input2 = _props.input,
                name = _props$input2.name,
                value = _props$input2.value,
                className = _props.className,
                iconType = _props.iconType,
                iconSize = _props.iconSize,
                tabIndex = _props.tabIndex;


            return _jsx(_Checkbox2.default, {
                name: name,
                checked: value,
                onSelect: this.onCheckChanged,
                className: className,
                iconType: iconType,
                iconSize: iconSize,
                tabIndex: tabIndex
            });
        }
    }]);

    return ReduxFormCheckbox;
}(_react.Component);

ReduxFormCheckbox.defaultProps = {
    tabIndex: 0
};
exports.default = ReduxFormCheckbox;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ColorSkinWrapper = function ColorSkinWrapper(_ref) {
    var children = _ref.children,
        bookmakerName = _ref.bookmakerName,
        className = _ref.className;
    return _jsx('div', {
        className: (0, _classnames2.default)(className, _defineProperty({}, 'bs-skin_' + bookmakerName, bookmakerName))
    }, void 0, children);
};

ColorSkinWrapper.defaultProps = {
    bookmakerName: '',
    children: null,
    className: ''
};

exports.default = ColorSkinWrapper;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(663);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'bs-cssSpinner__section bs-cssSpinner__section-1'
});

var _ref3 = _jsx('div', {
    className: 'bs-cssSpinner__section bs-cssSpinner__section-2'
});

var _ref4 = _jsx('div', {
    className: 'bs-cssSpinner__section bs-cssSpinner__section-3'
});

var CssSpinner = function CssSpinner(_ref) {
    var size = _ref.size,
        theme = _ref.theme,
        className = _ref.className;
    return _jsx('div', {
        className: (0, _classnames2.default)(className, 'bs-cssSpinner', {
            'bs-cssSpinner--small': size === 'small',
            'bs-cssSpinner--medium': size === 'medium',
            'bs-cssSpinner--large': size === 'large',
            'bs-cssSpinner--light': theme === 'light',
            'bs-cssSpinner--dark': theme === 'dark',
            'bs-cssSpinner--bookie': theme === 'bookie'
        })
    }, void 0, _ref2, _ref3, _ref4);
};

CssSpinner.defaultProps = {
    size: 'small',
    theme: 'bookie',
    className: ''
};

exports.default = CssSpinner;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(8);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'bs-btn__content_multiline'
}, void 0, _jsx('span', {
    className: 'bs-betForm__buttonLine'
}, void 0, 'Deposit'));

var Deposit = function Deposit(_ref) {
    var isUserLoggedIn = _ref.isUserLoggedIn,
        feed = _ref.feed,
        className = _ref.className;

    var destination = isUserLoggedIn ? 'top-up' : 'login';
    return _jsx(_reactRouterDom.Link, {
        to: '/' + feed + '/' + destination,
        className: (0, _classnames2.default)('\n                        bs-btn\n                        bs-btn_default\n                        bs-btn_link\n                        bs-actionBar__button\n                        bs-actionBar__button_2XL\n                        bs-betForm__button\n                        ', className)
    }, void 0, _ref2);
};

Deposit.defaultProps = {
    isUserLoggedIn: false,
    className: ''
};

exports.default = Deposit;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modalMessages = __webpack_require__(125);

__webpack_require__(664);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'bs-eachWay-label-copy'
}, void 0, 'EW');

var EachWay = function EachWay(_ref) {
    var id = _ref.id,
        isEachWayEnabled = _ref.isEachWayEnabled,
        isEachWayChecked = _ref.isEachWayChecked,
        onChange = _ref.onChange,
        setGlobalModal = _ref.setGlobalModal,
        children = _ref.children;
    return isEachWayEnabled ? _jsx('div', {
        className: 'bs-eachWay'
    }, void 0, children, _jsx('div', {
        className: 'bs-eachWay-toggle'
    }, void 0, _jsx('input', {
        id: 'bs-betForm-ew-checkbox-' + id,
        className: 'bs-eachWay-input',
        name: 'isEachWay',
        type: 'checkbox',
        checked: isEachWayChecked,
        onChange: onChange
    }), _jsx('label', {
        htmlFor: 'bs-betForm-ew-checkbox-' + id,
        className: 'bs-eachWay-label'
    }, void 0, _ref2))) : _jsx('div', {
        className: 'bs-eachWay'
    }, void 0, _jsx('div', {
        className: 'bs-eachWay-toggle'
    }, void 0, _jsx('button', {
        type: 'button',
        className: 'bs-eachWay-toggle--button',
        onClick: function onClick() {
            setGlobalModal(_modalMessages.EACHWAY_UNAVAILABLE);
        }
    }, void 0, 'EW')));
};

EachWay.defaultProps = {
    children: null,
    isEachWayEnabled: true,
    isEachWayChecked: false
};

exports.default = EachWay;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(665);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorBanner = function ErrorBanner(_ref) {
    var message = _ref.message,
        classBlockName = _ref.classBlockName;
    return _jsx('div', {
        className: classBlockName
    }, void 0, _jsx('span', {
        className: classBlockName + '__copy'
    }, void 0, message), _jsx('div', {
        className: classBlockName + '__callout'
    }));
};

ErrorBanner.defaultProps = {
    classBlockName: 'bs-errorBanner'
};

exports.default = ErrorBanner;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlankErrorBoundary = function (_Component) {
    _inherits(BlankErrorBoundary, _Component);

    function BlankErrorBoundary(props) {
        _classCallCheck(this, BlankErrorBoundary);

        var _this = _possibleConstructorReturn(this, (BlankErrorBoundary.__proto__ || Object.getPrototypeOf(BlankErrorBoundary)).call(this, props));

        _this.state = { hasError: false };
        return _this;
    }

    _createClass(BlankErrorBoundary, [{
        key: 'componentDidCatch',
        value: function componentDidCatch() {
            this.setState({ hasError: true });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.hasError) {
                return null;
            }
            return this.props.children;
        }
    }]);

    return BlankErrorBoundary;
}(_react.Component);

BlankErrorBoundary.defaultProps = {
    children: null
};

exports.default = BlankErrorBoundary;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _cssSpinner = __webpack_require__(210);

var _cssSpinner2 = _interopRequireDefault(_cssSpinner);

__webpack_require__(666);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_cssSpinner2.default, {
    className: 'bs-expand-panel__title-spinner',
    size: 'small',
    theme: 'dark'
});

var _ref2 = _jsx('div', {
    className: 'bs-expand-panel__title-icon'
});

var _ref3 = _jsx('div', {
    className: 'bs-expand-panel__loading'
}, void 0, _jsx(_cssSpinner2.default, {
    className: 'bs-expand-panel__spinner',
    size: 'medium',
    theme: 'dark'
}));

var ExpandPanel = function (_Component) {
    _inherits(ExpandPanel, _Component);

    function ExpandPanel(props) {
        _classCallCheck(this, ExpandPanel);

        var _this = _possibleConstructorReturn(this, (ExpandPanel.__proto__ || Object.getPrototypeOf(ExpandPanel)).call(this, props));

        _this.onClick = function () {
            var isContentExpanded = _this.state.isContentExpanded;


            _this.setState({
                isContentExpanded: !isContentExpanded
            });
        };

        _this.renderIcon = function () {
            var isLoading = _this.props.isLoading;
            var isContentExpanded = _this.state.isContentExpanded;


            if (isLoading && !isContentExpanded) {
                return _ref;
            }

            return _ref2;
        };

        _this.state = {
            isHeaderExpanded: true,
            isContentExpanded: false,
            loadingHeight: -1
        };
        return _this;
    }

    _createClass(ExpandPanel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isHeaderExpanded = this.state.isHeaderExpanded;
            var children = nextProps.children,
                isLoading = nextProps.isLoading;

            // Hide expand panel header

            if (children.length === 0 && isHeaderExpanded && !isLoading) {
                this.setState({
                    isHeaderExpanded: false
                });
            }

            // Show expand panel header
            if (children.length !== 0 && !isHeaderExpanded && !isLoading) {
                this.setState({
                    isHeaderExpanded: true
                });
            }

            // Loading started
            if (!this.props.isLoading && isLoading) {
                this.setState({
                    loadingHeight: this.props.expandHeight
                });
            }

            // Loading finished
            if (this.props.isLoading && !isLoading) {
                this.setState({
                    loadingHeight: -1
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                isHeaderExpanded = _state.isHeaderExpanded,
                isContentExpanded = _state.isContentExpanded,
                loadingHeight = _state.loadingHeight;
            var _props = this.props,
                children = _props.children,
                isLoading = _props.isLoading,
                title = _props.title,
                expandHeight = _props.expandHeight;


            var height = isContentExpanded ? expandHeight : 0;

            if (isContentExpanded && loadingHeight !== -1) {
                height = loadingHeight;
            }

            var contentStyle = { height: height };

            return _jsx('div', {
                className: (0, _classnames2.default)('bs-expand-panel', {
                    'bs-expand-panel--hidden': !isHeaderExpanded && !isLoading
                })
            }, void 0, _jsx('button', {
                className: (0, _classnames2.default)('bs-expand-panel__header', {
                    'bs-expand-panel__expand': !isContentExpanded,
                    'bs-expand-panel__header--hidden': !isHeaderExpanded
                }),
                onClick: this.onClick,
                disabled: !isHeaderExpanded
            }, void 0, _jsx('span', {
                className: 'bs-expand-panel__title'
            }, void 0, title), this.renderIcon()), _jsx('div', {
                className: (0, _classnames2.default)('bs-expand-panel__content', {}),
                style: contentStyle
            }, void 0, isContentExpanded && isLoading ? _ref3 : null, _react2.default.createElement(
                'div',
                {
                    className: 'bs-expand-panel__content-wrapper',
                    ref: function ref(content) {
                        _this2.contentContainer = content;
                    }
                },
                children
            )));
        }
    }]);

    return ExpandPanel;
}(_react.Component);

ExpandPanel.defaultProps = {
    isLoading: false,
    children: null
};

exports.default = ExpandPanel;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForgottenPassword = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _bookmakersList = __webpack_require__(5);

var _transitionRouter = __webpack_require__(16);

var _bookmakerLink = __webpack_require__(83);

var _bookmakerLink2 = _interopRequireDefault(_bookmakerLink);

__webpack_require__(668);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'bs-forgottenPassword__title bs-popover__title'
}, void 0, 'Forgotten Password');

var ForgottenPassword = exports.ForgottenPassword = function ForgottenPassword(_ref) {
    var forgottenBookmakerName = _ref.forgottenBookmakerName,
        forgottenPhoneNumber = _ref.forgottenPhoneNumber,
        forgottenBookmakerUrl = _ref.forgottenBookmakerUrl,
        isPhone = _ref.isPhone;
    return _jsx('div', {
        className: 'bs-forgottenPassword'
    }, void 0, _ref2, _jsx(_bookmakerLink2.default, {
        titleText: 'Call to retrieve your password',
        phoneNumber: forgottenPhoneNumber,
        isPhone: isPhone
    }), _jsx(_bookmakerLink2.default, {
        titleText: 'Or visit ' + forgottenBookmakerName,
        bookmakerUrl: forgottenBookmakerUrl,
        bookmakerName: forgottenBookmakerName
    }));
};

ForgottenPassword.defaultProps = {
    isPhone: true,
    forgottenPhoneNumber: '',
    forgottenBookmakerName: '',
    forgottenBookmakerUrl: null
};

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    var isPhone = state.pageInfo.isPhone;

    return _extends({
        isPhone: isPhone
    }, bookmakerInfoSelector(state, props));
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(ForgottenPassword);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FreeBetList = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(669);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_svgIcon2.default, {
    iconName: 'remove',
    size: 'Medium'
});

var _ref2 = _jsx('option', {
    value: '',
    disabled: true
}, void 0, 'Use a Free Bet?');

var FreeBetList = exports.FreeBetList = function FreeBetList(props) {
    var freeBets = props.freeBets,
        selectedFreeBet = props.selectedFreeBet,
        selectFreeBet = props.selectFreeBet,
        clearFreeBet = props.clearFreeBet,
        currencySign = props.currencySign;


    var options = freeBets.map(function (freeBet) {
        return _jsx('option', {
            value: freeBet.id
        }, freeBet.id, currencySign, parseFloat(freeBet.amount).toFixed(2), ' Free Bet');
    });

    var clearButton = selectedFreeBet ? _jsx('button', {
        onClick: clearFreeBet,
        className: 'bs-freeBetList__clear-button'
    }, void 0, _ref) : null;

    return _jsx('div', {
        className: 'bs-freeBetList'
    }, void 0, clearButton, _jsx('select', {
        className: 'bs-freeBetList__list',
        required: true,
        value: selectedFreeBet || '',
        onChange: function onChange(e) {
            var value = e.target.value;

            selectFreeBet(value);
        }
    }, void 0, _ref2, options));
};

FreeBetList.defaultProps = {
    selectedFreeBet: null
};

exports.default = FreeBetList;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FreeBetToggle = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(670);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FreeBetToggle = exports.FreeBetToggle = function FreeBetToggle(props) {
    var freeBets = props.freeBets,
        selectedFreeBet = props.selectedFreeBet,
        selectFreeBet = props.selectFreeBet,
        clearFreeBet = props.clearFreeBet,
        currencySign = props.currencySign;

    return _jsx('div', {
        className: 'bs-freeBetToggle'
    }, void 0, 'Use Free Bet: ', currencySign, parseFloat(freeBets[0].amount).toFixed(2), _jsx('button', {
        className: (0, _classnames2.default)('bs-freeBetToggle__toggle', {
            'bs-freeBetToggle__toggle--selected': selectedFreeBet !== null
        }),
        onClick: function onClick() {
            if (selectedFreeBet === null) {
                selectFreeBet(freeBets[0].id);
            } else {
                clearFreeBet();
            }
        }
    }, void 0));
};

FreeBetToggle.defaultProps = {
    selectedFreeBet: null
};

exports.default = FreeBetToggle;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _Image = __webpack_require__(40);

var _Image2 = _interopRequireDefault(_Image);

var _CommissionText = __webpack_require__(39);

var _CommissionText2 = _interopRequireDefault(_CommissionText);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Line2.default, {}, void 0, 'Best Odds Guaranteed. Take a price and if the starting price is bigger, bet365 pays at the bigger odds.\xA0', _jsx(_Link2.default, {
    href: 'https://extra.bet365.com/promotions/en/horse-racing/best-odds-guaranteed',
    text: 'Bet restrictions and T&Cs apply'
}), '. New and eligible customers only.');

var _ref2 = _jsx(_CommissionText2.default, {});

var _ref3 = _jsx(_Image2.default, {
    imageName: 'underageRed'
});

var Bet365 = function Bet365() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _ref, '\xA0', _jsx(_Line2.default, {}, void 0, 'Bets are accepted in accordance with the operator\'s\xA0', _jsx(_Link2.default, {
        href: _urlConstants.bet365.rules,
        text: 'rules'
    }), '\xA0 and\xA0', _jsx(_Link2.default, {
        href: _urlConstants.bet365.termsAndConditions,
        text: 'terms and conditions'
    }), '.\xA0 Hillside (UK Sports) ENC is licensed and regulated by the British Gambling Commissioner (Account Number 55148). Registered Office Hillside (UK Sports) ENC (Registration Number P1892), Unit 1.1, First Floor, Waterport Place, 2 Europort Avenue, Gibraltar.'), '\xA0', _ref2), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _ref3, _jsx(_Image2.default, {
        href: _urlConstants.common.gamaware,
        imageName: 'gamaware'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamcare,
        imageName: 'gamcare'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamtherapy,
        imageName: 'gamtherapyTransparent'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.raig,
        imageName: 'raig'
    })));
};

exports.default = Bet365;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Line2.default, {}, void 0, 'Best Odds Guaranteed. Take a price and if the starting');

var _ref2 = _jsx(_Line2.default, {}, void 0, 'price is bigger, bet365 pays at the bigger odds.');

var _ref3 = _jsx(_Line2.default, {
    className: 'bs-gamblingCompliance__line--spacer'
}, void 0, _jsx(_Link2.default, {
    href: 'https://extra.bet365.com/promotions/en/horse-racing/best-odds-guaranteed',
    text: 'Bet restrictions and T&Cs apply'
}), '. New and eligible customers only.');

var _ref4 = _jsx(_Line2.default, {}, void 0, 'Bets are accepted in accordance with');

var _ref5 = _jsx(_Line2.default, {}, void 0, 'Hillside (UK Sports) ENC is licensed and regulated by the British Gambling Commissioner (Account Number 55148, Registration Number P1892)');

var Bet365 = function Bet365() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance bs-gamblingCompliance--short'
    }, void 0, _ref, _ref2, _ref3, _ref4, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'the operator\'s\xA0', _jsx(_Link2.default, {
        href: _urlConstants.bet365.rules,
        text: 'rules'
    }), '\xA0 and\xA0', _jsx(_Link2.default, {
        href: _urlConstants.bet365.termsAndConditions,
        text: 'terms and conditions'
    }), '.\xA0'), _ref5);
};

exports.default = Bet365;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _Image = __webpack_require__(40);

var _Image2 = _interopRequireDefault(_Image);

var _CommissionText = __webpack_require__(39);

var _CommissionText2 = _interopRequireDefault(_CommissionText);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_CommissionText2.default, {});

var Betfair = function Betfair() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.betfair.gamCommission,
        imageName: 'gamCommission'
    }), _jsx(_Image2.default, {
        href: _urlConstants.betfair.mga,
        imageName: 'mga'
    })), _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line'
    }, void 0, _jsx(_Link2.default, {
        href: _urlConstants.betfair.terms,
        text: 'Terms and Conditions.'
    })), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, _jsx(_Link2.default, {
        href: _urlConstants.betfair.responsibleGambling,
        text: 'Gambling can be addictive, please play responsibly.'
    }))), _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {}, void 0, 'PPB Counterparty Services Limited, having its registered address at Triq il-Kappillan Mifsud, St. Venera, SVR 1851, MALTA, is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.license,
        text: 'licensed'
    }), '\xA0 and regulated by the\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.gamingAuthority,
        text: 'Malta Gaming Authority'
    }), '\xA0 under Licence Number MGA/CRP/131/2006 (issued on 01 August 2018). For customers in the UK,\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.gamingCommission,
        text: 'PPB Counterparty Services Limited'
    }), ' is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.license,
        text: 'licensed'
    }), '\xA0 and regulated by the Gambling Commission.'), '\xA0', _ref), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.betfair.underage,
        imageName: 'underageRed'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamtherapy,
        imageName: 'gamtherapyTransparent'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamcare,
        imageName: 'gamcare'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.funstops,
        imageName: 'funstops'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamstop,
        imageName: 'gamstop'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.raig,
        imageName: 'raig'
    })));
};

exports.default = Betfair;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Betfair = function Betfair() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance bs-gamblingCompliance--short'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {}, void 0, 'PPB Counterparty Services Limited, having its registered address at Triq il-Kappillan Mifsud, St. Venera, SVR 1851, MALTA, is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.license,
        text: 'licensed'
    }), '\xA0 and regulated by the\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.gamingAuthority,
        text: 'Malta Gaming Authority'
    }), '\xA0 under Licence Number MGA/CRP/131/2006 (issued on 01 August 2018). For customers in the UK,\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.gamingCommission,
        text: 'PPB Counterparty Services Limited'
    }), ' is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.betfair.license,
        text: 'licensed'
    }), '\xA0 and regulated by the Gambling Commission.')));
};

exports.default = Betfair;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _Image = __webpack_require__(40);

var _Image2 = _interopRequireDefault(_Image);

var _CommissionText = __webpack_require__(39);

var _CommissionText2 = _interopRequireDefault(_CommissionText);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

var _currentDate = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_CommissionText2.default, {});

var _ref2 = _jsx('div', {
    className: 'bs-gamblingCompliance__message'
}, void 0, 'Underage gambling is an offence');

var Coral = function Coral() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Bets are accepted in accordance with the operator\u2019s ', _jsx(_Link2.default, {
        href: _urlConstants.coral.tscs,
        text: 'terms and conditions'
    }), '. ', _jsx(_Link2.default, {
        href: _urlConstants.coral.website,
        text: 'Coral.co.uk'
    }), ' is operated by LC International Limited of Suite 6, Atlantic Suites, Gibraltar GX11 1AA.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For customers in Great Britain, Coral is licensed and regulated by the Gambling Commission under account number ', _jsx(_Link2.default, {
        href: _urlConstants.coral.gamblingCommission,
        text: '54743'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For all other customers, Coral is licensed by the Government of Gibraltar with Licence numbers ', _jsx(_Link2.default, {
        href: _urlConstants.coral.gibraltar,
        text: '010 & 012'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Copyright \xA9 ' + (0, _currentDate.getCurrentYear)()), _ref), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.coral.responsibleGambling,
        imageName: 'underageRed'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamaware,
        imageName: 'gamaware'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamcare,
        imageName: 'gamcare'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamtherapy,
        imageName: 'gamtherapyTransparent'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamstop,
        imageName: 'gamstop'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.raig,
        imageName: 'raig'
    })), _ref2);
};

exports.default = Coral;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

var _currentDate = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Coral = function Coral() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance bs-gamblingCompliance--short'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Bets are accepted in accordance with the operator\u2019s ', _jsx(_Link2.default, {
        href: _urlConstants.coral.tscs,
        text: 'terms and conditions'
    }), '. ', _jsx(_Link2.default, {
        href: _urlConstants.coral.website,
        text: 'Coral.co.uk'
    }), ' is operated by LC International Limited of Suite 6, Atlantic Suites, Gibraltar GX11 1AA.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For customers in Great Britain, Coral is licensed and regulated by the Gambling Commission under account number ', _jsx(_Link2.default, {
        href: _urlConstants.coral.gamblingCommission,
        text: '54743'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For all other customers, Coral is licensed by the Government of Gibraltar with Licence numbers ', _jsx(_Link2.default, {
        href: _urlConstants.coral.gibraltar,
        text: '010 & 012'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Copyright \xA9 ' + (0, _currentDate.getCurrentYear)())));
};

exports.default = Coral;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _Image = __webpack_require__(40);

var _Image2 = _interopRequireDefault(_Image);

var _CommissionText = __webpack_require__(39);

var _CommissionText2 = _interopRequireDefault(_CommissionText);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

var _currentDate = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_CommissionText2.default, {});

var _ref2 = _jsx('div', {
    className: 'bs-gamblingCompliance__message'
}, void 0, 'Underage gambling is an offence');

var Ladbrokes = function Ladbrokes() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Bets are accepted in accordance with the operator\u2019s ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.tscs,
        text: 'terms and conditions'
    }), '. ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.website,
        text: 'Ladbrokes.com'
    }), ' is operated by LC International Limited of Suite 6, Atlantic Suites, Gibraltar GX11 1AA.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For customers in Great Britain, Ladbrokes is licensed and regulated by the Gambling Commission under account number ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.gamblingCommission,
        text: '54743'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For all other customers, Ladbrokes is licensed by the Government of Gibraltar with Licence numbers ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.gibraltar,
        text: '010, 012, 104'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Copyright \xA9 ' + (0, _currentDate.getCurrentYear)()), _ref), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.ladbrokes.underage,
        imageName: 'underageRed'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamaware,
        imageName: 'gamaware'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamcare,
        imageName: 'gamcare'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamtherapy,
        imageName: 'gamtherapyTransparent'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamstop,
        imageName: 'gamstop'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.raig,
        imageName: 'raig'
    })), _ref2);
};

exports.default = Ladbrokes;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

var _currentDate = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ladbrokes = function Ladbrokes() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance bs-gamblingCompliance--short'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Bets are accepted in accordance with the operator\u2019s ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.tscs,
        text: 'terms and conditions'
    }), '. ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.website,
        text: 'Ladbrokes.com'
    }), ' is operated by LC International Limited of Suite 6, Atlantic Suites, Gibraltar GX11 1AA.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For customers in Great Britain, Ladbrokes is licensed and regulated by the Gambling Commission under account number ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.gamblingCommission,
        text: '54743'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'For all other customers, Ladbrokes is licensed by the Government of Gibraltar with Licence numbers ', _jsx(_Link2.default, {
        href: _urlConstants.ladbrokes.gibraltar,
        text: '010, 012, 104'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Copyright \xA9 ' + (0, _currentDate.getCurrentYear)()));
};

exports.default = Ladbrokes;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _Image = __webpack_require__(40);

var _Image2 = _interopRequireDefault(_Image);

var _CommissionText = __webpack_require__(39);

var _CommissionText2 = _interopRequireDefault(_CommissionText);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_CommissionText2.default, {});

var PaddyPower = function PaddyPower() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.paddypower.gamCommission,
        imageName: 'gamCommission'
    }), _jsx(_Image2.default, {
        href: _urlConstants.paddypower.mga,
        imageName: 'mga'
    })), _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line'
    }, void 0, _jsx(_Link2.default, {
        href: _urlConstants.paddypower.terms,
        text: 'Terms and Conditions.'
    })), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, _jsx(_Link2.default, {
        href: _urlConstants.paddypower.responsibleGambling,
        text: 'Gambling can be addictive, please play responsibly.'
    }))), _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {}, void 0, 'PPB Counterparty Services Limited, having its registered address at Triq il-Kappillan Mifsud, St. Venera, SVR 1851, MALTA, is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.license,
        text: 'licensed'
    }), '\xA0 and regulated by the\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.gamingAuthority,
        text: 'Malta Gaming Authority'
    }), '\xA0 under Licence Number MGA/CRP/131/2006 (issued on 01 August 2018). For customers in the UK,\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.gamingCommission,
        text: 'PPB Counterparty Services Limited'
    }), ' is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.license,
        text: 'licensed'
    }), '\xA0 and regulated by the Gambling Commission.'), '\xA0', _ref), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.paddypower.underage,
        imageName: 'underageRed'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamtherapy,
        imageName: 'gamtherapyTransparent'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamcare,
        imageName: 'gamcare'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.funstops,
        imageName: 'funstops'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamstop,
        imageName: 'gamstop'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.raig,
        imageName: 'raig'
    })));
};

exports.default = PaddyPower;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaddyPower = function PaddyPower() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance bs-gamblingCompliance--short'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {}, void 0, 'PPB Counterparty Services Limited, having its registered address at Triq il-Kappillan Mifsud, St. Venera, SVR 1851, MALTA, is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.license,
        text: 'licensed'
    }), '\xA0 and regulated by the\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.gamingAuthority,
        text: 'Malta Gaming Authority'
    }), '\xA0 under Licence Number MGA/CRP/131/2006 (issued on 01 August 2018). For customers in the UK,\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.gamingCommission,
        text: 'PPB Counterparty Services Limited'
    }), ' is\xA0', _jsx(_Link2.default, {
        href: _urlConstants.paddypower.license,
        text: 'licensed'
    }), '\xA0 and regulated by the Gambling Commission.')));
};

exports.default = PaddyPower;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _Image = __webpack_require__(40);

var _Image2 = _interopRequireDefault(_Image);

var _CommissionText = __webpack_require__(39);

var _CommissionText2 = _interopRequireDefault(_CommissionText);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Line2.default, {}, void 0, 'Customers in the United Kingdom:');

var _ref2 = _jsx(_Line2.default, {}, void 0, 'All other customers:');

var _ref3 = _jsx(_Line2.default, {
    className: 'bs-gamblingCompliance__line--spacer'
}, void 0, 'Sky Bet is licensed and regulated by Alderney Gambling Control Commission');

var _ref4 = _jsx(_Line2.default, {}, void 0, 'All rights reserved.');

var _ref5 = _jsx(_CommissionText2.default, {});

var _ref6 = _jsx(_Image2.default, {
    imageName: 'underageRed'
});

var _ref7 = _jsx(_Image2.default, {
    imageName: 'underage'
});

var Skybet = function Skybet() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _ref, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Sky Bet is licensed and regulated by the Gambling Commission \n                (licence number 38718).'), _ref2, _ref3, _jsx(_Line2.default, {}, void 0, '\xA9 2020 Bonne Terre Limited or its affiliated companies. \n                The Sky trademarks are owned by Sky UK Limited and are used under licence.'), _ref4, '\xA0', _ref5), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.common.gamcare,
        imageName: 'gamcare'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamstop,
        imageName: 'gamstop'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.ibas,
        imageName: 'ibas'
    }), _ref6), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.common.funstops,
        imageName: 'funstops'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamaware,
        imageName: 'gamaware'
    }), _ref7, _jsx(_Image2.default, {
        href: _urlConstants.common.raig,
        imageName: 'raig'
    })));
};

exports.default = Skybet;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Line2.default, {}, void 0, 'Customers in the United Kingdom:');

var _ref2 = _jsx(_Line2.default, {}, void 0, 'All other customers:');

var _ref3 = _jsx(_Line2.default, {
    className: 'bs-gamblingCompliance__line--spacer'
}, void 0, 'Sky Bet is licensed and regulated by Alderney Gambling Control Commission');

var _ref4 = _jsx(_Line2.default, {}, void 0, 'All rights reserved.');

var Skybet = function Skybet() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance bs-gamblingCompliance--short'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _ref, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Sky Bet is licensed and regulated by the Gambling Commission\n                (licence number 38718).'), _ref2, _ref3, _jsx(_Line2.default, {}, void 0, '\xA9 2020 Bonne Terre Limited or its affiliated companies.\n                The Sky trademarks are owned by Sky UK Limited and are used under licence.'), _ref4));
};

exports.default = Skybet;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _Image = __webpack_require__(40);

var _Image2 = _interopRequireDefault(_Image);

var _CommissionText = __webpack_require__(39);

var _CommissionText2 = _interopRequireDefault(_CommissionText);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Line2.default, {
    className: 'bs-gamblingCompliance__line--spacer'
}, void 0, 'The registered office of William Hill is at 6/1 Waterport Place, Gibraltar, with registered company number 99191.');

var _ref2 = _jsx(_CommissionText2.default, {});

var _ref3 = _jsx('div', {
    className: 'bs-gamblingCompliance__message'
}, void 0, 'Underage gambling is an offence');

var WilliamHill = function WilliamHill() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Bets are accepted in accordance with the operator\'s\xA0', _jsx(_Link2.default, {
        href: _urlConstants.williamhill.rules,
        text: 'rules'
    }), '.'), _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'William Hill is licensed and regulated by the\xA0', _jsx(_Link2.default, {
        href: _urlConstants.williamhill.license,
        text: 'UK Gambling Commission no. 000-039225 R-319373-001'
    })), _ref, _jsx(_Line2.default, {}, void 0, 'William Hill is committed to supporting\xA0', _jsx(_Link2.default, {
        href: _urlConstants.williamhill.responsibleGambling,
        text: 'Responsible Gambling'
    })), '\xA0', _ref2), _jsx('div', {
        className: 'bs-gamblingCompliance__images'
    }, void 0, _jsx(_Image2.default, {
        href: _urlConstants.williamhill.underage,
        imageName: 'underageRed'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamaware,
        imageName: 'gamaware'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamcare,
        imageName: 'gamcare'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.gamtherapy,
        imageName: 'gamtherapyTransparent'
    }), _jsx(_Image2.default, {
        href: _urlConstants.common.raig,
        imageName: 'raig'
    })), _ref3);
};

exports.default = WilliamHill;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(17);

var _Link2 = _interopRequireDefault(_Link);

var _Line = __webpack_require__(9);

var _Line2 = _interopRequireDefault(_Line);

var _urlConstants = __webpack_require__(13);

__webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Line2.default, {}, void 0, 'William Hill is licensed and regulated by the\xA0');

var WilliamHill = function WilliamHill() {
    return _jsx('div', {
        className: 'bs-gamblingCompliance bs-gamblingCompliance--short'
    }, void 0, _jsx('div', {
        className: 'bs-gamblingCompliance__message'
    }, void 0, _jsx(_Line2.default, {
        className: 'bs-gamblingCompliance__line--spacer'
    }, void 0, 'Bets are accepted in accordance with the operator\'s\xA0', _jsx(_Link2.default, {
        href: _urlConstants.williamhill.rules,
        text: 'rules'
    }), '.\xA0'), _ref, _jsx(_Line2.default, {}, void 0, _jsx(_Link2.default, {
        href: _urlConstants.williamhill.license,
        text: 'UK Gambling Commission no.'
    }), '\xA0', _jsx(_Link2.default, {
        href: _urlConstants.williamhill.license,
        text: '000-039225 R-319373-001'
    }), '.')));
};

exports.default = WilliamHill;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal = __webpack_require__(58);

__webpack_require__(671);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalModal = function GlobalModal(_ref) {
    var onAccept = _ref.onAccept,
        title = _ref.title,
        body = _ref.body,
        ctaTitle = _ref.ctaTitle;
    return _jsx(_modal.Modal, {
        visible: true
    }, void 0, _jsx('div', {
        className: 'bs-globalModal'
    }, void 0, _jsx('span', {
        className: 'bs-globalModal__title'
    }, void 0, title), _jsx('span', {
        className: 'bs-globalModal__body'
    }, void 0, body), _jsx('button', {
        onClick: onAccept,
        className: 'bs-globalModal__button'
    }, void 0, _jsx('span', {}, void 0, ctaTitle))));
};

GlobalModal.defaultProps = {
    title: null,
    ctaTitle: 'OK'
};

exports.default = GlobalModal;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _reduxForm = __webpack_require__(44);

var _reselect = __webpack_require__(25);

var _login = __webpack_require__(47);

var actions = _interopRequireWildcard(_login);

var _bookmakersInfo = __webpack_require__(6);

var _bookmakersList = __webpack_require__(5);

var _freeBets = __webpack_require__(35);

var _gdpr = __webpack_require__(124);

var _transitionRouter = __webpack_require__(16);

var _Login = __webpack_require__(611);

var _Login2 = _interopRequireDefault(_Login);

var _logger = __webpack_require__(63);

var _loginCookies = __webpack_require__(90);

var _bookmakers = __webpack_require__(84);

var _bookmakers2 = _interopRequireDefault(_bookmakers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logger = (0, _logger.create)('Login');
var bookmakers = (0, _bookmakers2.default)();

var LoginContainer = exports.LoginContainer = function (_Component) {
    _inherits(LoginContainer, _Component);

    function LoginContainer(props) {
        _classCallCheck(this, LoginContainer);

        var _this = _possibleConstructorReturn(this, (LoginContainer.__proto__ || Object.getPrototypeOf(LoginContainer)).call(this, props));

        _this.onLoginSubmit = function (_ref) {
            var saveUsername = _ref.saveUsername,
                username = _ref.username;

            if (saveUsername && username) {
                _this.props.saveBookmakerUsername(_this.props.feed, username);
            }
            return _this.login();
        };

        _this.onLoginSuccess = function (data) {
            var _this$props = _this.props,
                apiName = _this$props.apiName,
                feed = _this$props.feed,
                getUserInfo = _this$props.getUserInfo,
                clearFreeBets = _this$props.clearFreeBets,
                onLoginSuccess = _this$props.onLoginSuccess,
                setLogInSuccess = _this$props.setLogInSuccess,
                showGdprPopup = _this$props.showGdprPopup;

            var logoutBookmaker = bookmakers.find(function (bookmaker) {
                return bookmaker.feed === feed;
            });

            clearFreeBets();
            var promises = [];
            promises.push(getUserInfo(apiName, feed));

            if (data && data.termsAndConditions) {
                showGdprPopup(data.termsAndConditions);
            }

            return Promise.all(promises).catch(function (err) {
                return logger.error(err);
            }).then(function () {
                (0, _loginCookies.setLoginCookie)(logoutBookmaker.cookieName, logoutBookmaker.loginDuration);
                onLoginSuccess();
                setLogInSuccess(feed);
            }).then(function () {
                var loggedInEvent = new CustomEvent('BETSLIP.BOOKMAKER.LOGGED_IN', {
                    detail: {}
                });
                document.dispatchEvent(loggedInEvent);
            });
        };

        _this.onNavigateBack = function () {
            _this.setState({ shouldNavigateBack: true });
        };

        _this.onSaveUsernameChange = function (event, checked) {
            if (!checked) {
                _this.props.removeBookmakerUsername(_this.props.feed);
            }
        };

        _this.cancelError = function () {
            var loginType = _this.props.loginType;

            var isIframeLogin = loginType === _bookmakersList.constants.LOGIN_TYPE.IFRAME;
            var isWindowLogin = loginType === _bookmakersList.constants.LOGIN_TYPE.WINDOW;
            if (isIframeLogin || isWindowLogin) {
                _this.setState({ shouldNavigateBack: true });
            } else {
                _this.props.clearError();
            }
        };

        _this.retry = function () {
            var _this$props2 = _this.props,
                apiName = _this$props2.apiName,
                feed = _this$props2.feed,
                loginType = _this$props2.loginType;

            var isIframeLogin = loginType === _bookmakersList.constants.LOGIN_TYPE.IFRAME;
            var isWindowLogin = loginType === _bookmakersList.constants.LOGIN_TYPE.WINDOW;
            if (isIframeLogin || isWindowLogin) {
                _this.props.loadBookmakerLoginInfo(apiName, feed);
            } else {
                _this.retryLogin().then(_this.onLoginSuccess);
            }
        };

        _this.login = function () {
            var _this$props3 = _this.props,
                apiName = _this$props3.apiName,
                feed = _this$props3.feed,
                clearError = _this$props3.clearError,
                formValues = _this$props3.formValues,
                setLogInFailure = _this$props3.setLogInFailure;

            if (!!formValues.username && !!formValues.password) {
                clearError();
                return _this.props.onLogin(apiName, feed, formValues).then(_this.onLoginSuccess).catch(function (_ref2) {
                    var retry = _ref2.retry,
                        response = _ref2.response;

                    var errMessage = '';
                    if (response && response.data && response.data.errors && response.data.errors[0]) {
                        errMessage = response.data.errors[0].detail;
                    }
                    _this.retryLogin = retry;
                    setLogInFailure(feed, errMessage);
                });
            }
            return null;
        };

        _this.state = {
            shouldNavigateBack: false
        };
        return _this;
    }

    _createClass(LoginContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                apiName = _props.apiName,
                feed = _props.feed,
                loginType = _props.loginType,
                setLogIn = _props.setLogIn;

            var isIframeLogin = loginType === _bookmakersList.constants.LOGIN_TYPE.IFRAME;
            var isWindowLogin = loginType === _bookmakersList.constants.LOGIN_TYPE.WINDOW;
            if (isIframeLogin || isWindowLogin) {
                this.props.loadBookmakerLoginInfo(apiName, feed);
            }
            setLogIn(feed);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearError();
            this.props.destroyLoginForm();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isLoggedIn = _props2.isLoggedIn,
                auth = _props2.auth,
                loginType = _props2.loginType,
                isLoading = _props2.isLoading,
                isError = _props2.isError,
                isIncorrectCredentials = _props2.isIncorrectCredentials,
                feed = _props2.feed,
                registrationLink = _props2.registrationLink,
                showGamblingCompliance = _props2.showGamblingCompliance,
                actionBarClass = _props2.actionBarClass,
                initialValues = _props2.initialValues,
                cookieName = _props2.cookieName;

            var shouldRedirect = isLoggedIn || this.state.shouldNavigateBack;
            var isGetAuthFailed = auth && auth.isError || false;
            var authUrl = auth && auth.authUrl || '';

            return _jsx(_Login2.default, {
                loginType: loginType,
                isLoading: isLoading,
                shouldRedirect: shouldRedirect,
                isLoginFailed: isError,
                isGetAuthFailed: isGetAuthFailed,
                isIncorrectCredentials: isIncorrectCredentials,
                authUrl: authUrl,
                feed: feed,
                registrationLink: registrationLink,
                showGamblingCompliance: showGamblingCompliance,
                actionBarClass: actionBarClass,
                initialValues: initialValues,
                onRetry: this.retry,
                onLoginSubmit: this.onLoginSubmit,
                onLoginSuccess: this.onLoginSuccess,
                onNavigateBack: this.onNavigateBack,
                onErrorCancel: this.cancelError,
                onSaveUsernameChange: this.onSaveUsernameChange,
                cookieName: cookieName
            });
        }
    }]);

    return LoginContainer;
}(_react.Component);

LoginContainer.defaultProps = {
    isLoading: false,
    isError: false,
    actionBarClass: '',
    showGamblingCompliance: false,
    isLoggedIn: false,
    registrationLink: '',
    auth: null,
    isIncorrectCredentials: false,
    formValues: null,
    cookieName: ''
};

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_transitionRouter.selectors.feedSelector);

var formValuesSelector = (0, _reduxForm.getFormValues)('loginForm');

var loginPageSelector = function loginPageSelector(state) {
    return state.loginPage;
};

var loginSelector = (0, _reselect.createSelector)([loginPageSelector, bookmakerInfoSelector, formValuesSelector, _bookmakersInfo.selectors.usernameSelector], function (loginPage, bookmakerInfo, formValues, storedUsername) {
    var initialValues = storedUsername ? { saveUsername: true, username: storedUsername } : { saveUsername: false, username: '' };
    return _extends({}, loginPage, bookmakerInfo, {
        initialValues: initialValues,
        formValues: formValues
    });
});

var mapDispatchToProps = {
    getUserInfo: _bookmakersList.actions.getUserInfo,
    setLogIn: _bookmakersList.actions.setLogIn,
    setLogInFailure: _bookmakersList.actions.setLogInFailure,
    setLogInSuccess: _bookmakersList.actions.setLogInSuccess,
    onLogin: actions.requestLogin,
    onLoginSuccess: actions.loginSuccess,
    loadBookmakerLoginInfo: actions.loadBookmakerLoginInfo,
    saveBookmakerUsername: _bookmakersInfo.actions.saveUsername,
    removeBookmakerUsername: _bookmakersInfo.actions.removeUsername,
    clearError: actions.loginClearError,
    destroyLoginForm: _reduxForm.destroy.bind(null, 'loginForm'),
    hideErrorModal: actions.loginHideErrorModal,
    clearFreeBets: _freeBets.actions.clearFreeBets,
    showGdprPopup: _gdpr.actions.showGdprPopup
};

exports.default = (0, _reactRedux.connect)(loginSelector, mapDispatchToProps)(LoginContainer);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(8);

var _LoginForm = __webpack_require__(612);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _LoginIframe = __webpack_require__(613);

var _LoginIframe2 = _interopRequireDefault(_LoginIframe);

var _LoginWindow = __webpack_require__(614);

var _LoginWindow2 = _interopRequireDefault(_LoginWindow);

var _ServiceUnavailableError = __webpack_require__(615);

var _ServiceUnavailableError2 = _interopRequireDefault(_ServiceUnavailableError);

var _spinner = __webpack_require__(127);

var _spinner2 = _interopRequireDefault(_spinner);

var _bookmakersList = __webpack_require__(5);

__webpack_require__(672);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function Login(_ref) {
    var loginType = _ref.loginType,
        isLoading = _ref.isLoading,
        shouldRedirect = _ref.shouldRedirect,
        isLoginFailed = _ref.isLoginFailed,
        isGetAuthFailed = _ref.isGetAuthFailed,
        isIncorrectCredentials = _ref.isIncorrectCredentials,
        authUrl = _ref.authUrl,
        feed = _ref.feed,
        registrationLink = _ref.registrationLink,
        showGamblingCompliance = _ref.showGamblingCompliance,
        actionBarClass = _ref.actionBarClass,
        initialValues = _ref.initialValues,
        cookieName = _ref.cookieName,
        onSaveUsernameChange = _ref.onSaveUsernameChange,
        onRetry = _ref.onRetry,
        onLoginSubmit = _ref.onLoginSubmit,
        onLoginSuccess = _ref.onLoginSuccess,
        onNavigateBack = _ref.onNavigateBack,
        onErrorCancel = _ref.onErrorCancel;

    var loginWithWindow = loginType === _bookmakersList.constants.LOGIN_TYPE.WINDOW;
    var loginWithIframe = loginType === _bookmakersList.constants.LOGIN_TYPE.IFRAME;
    var loginWithForm = loginType === _bookmakersList.constants.LOGIN_TYPE.FORM;
    var isWindowOrIframeInfoError = (loginWithWindow || loginWithIframe) && isGetAuthFailed;
    var serviceUnavailableError = isLoginFailed && !isIncorrectCredentials || isWindowOrIframeInfoError;

    if (shouldRedirect) {
        return _jsx(_reactRouterDom.Redirect, {
            to: {
                pathname: '/',
                state: { isReversedAnimation: true }
            }
        });
    }
    if (serviceUnavailableError) {
        return _jsx(_ServiceUnavailableError2.default, {
            onCancel: onErrorCancel,
            onRetry: onRetry,
            actionBarClass: actionBarClass
        });
    }
    return _jsx('div', {}, void 0, loginWithWindow ? _jsx(_LoginWindow2.default, {
        cookieName: cookieName,
        windowName: 'Login',
        authUrl: authUrl,
        onLoginSuccess: onLoginSuccess,
        onBackClick: onNavigateBack
    }) : null, loginWithIframe ? _jsx(_LoginIframe2.default, {
        authUrl: authUrl,
        onLoginSuccess: onLoginSuccess,
        onBackClick: onNavigateBack
    }) : null, loginWithForm ? _jsx(_LoginForm2.default, {
        feed: feed,
        registrationLink: registrationLink,
        showGamblingCompliance: showGamblingCompliance,
        actionBarClass: actionBarClass,
        initialValues: initialValues,
        isIncorrectCredentials: isIncorrectCredentials,
        onSaveUsernameChange: onSaveUsernameChange,
        onSubmit: onLoginSubmit
    }) : null, _jsx(_spinner2.default, {
        visible: isLoading,
        className: 'bs-loginPage__spinner'
    }, void 0, 'Requesting account data'));
};

Login.defaultProps = {
    isLoading: false,
    shouldRedirect: false,
    isLoginFailed: false,
    isGetAuthFailed: false,
    isIncorrectCredentials: false,
    authUrl: null,
    registrationLink: null,
    showGamblingCompliance: false,
    actionBarClass: null,
    cookieName: ''
};

exports.default = Login;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(44);

var _reactRouterDom = __webpack_require__(8);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _checkbox = __webpack_require__(209);

var _gamblingCompliance = __webpack_require__(46);

var _analyticsTracking = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('div', {
    className: 'bs-section bs-loginForm__error'
}, void 0, _jsx('span', {}, void 0, 'Invalid username or password. Please try again'));

var _ref3 = _jsx('span', {}, void 0, 'Sign In');

var _ref4 = _jsx('div', {
    className: 'bs-form__field bs-loginForm__leftField bs-col_8'
}, void 0, _jsx('label', {
    htmlFor: 'username',
    className: 'bs-form__label'
}, void 0, 'Username'), _jsx(_reduxForm.Field, {
    name: 'username',
    component: 'input',
    type: 'text',
    placeholder: 'Username',
    className: 'bs-input bs-form__input bs-loginForm__input'
}));

var _ref5 = _jsx('span', {
    className: 'bs-form__label'
}, void 0, 'Save');

var _ref6 = _jsx('label', {
    htmlFor: 'password',
    className: 'bs-form__label'
}, void 0, 'Password');

var _ref7 = _jsx(_reduxForm.Field, {
    name: 'password',
    component: 'input',
    type: 'password',
    placeholder: 'Password',
    className: 'bs-input bs-form__input bs-loginForm__input'
});

var _ref8 = _jsx(_svgIcon2.default, {
    iconName: 'right',
    size: 'Medium',
    className: 'bs-loginForm__forgottenPasswordIcon'
});

var _ref9 = _jsx('span', {
    className: 'bs-loginForm__forgottenPasswordText'
}, void 0, 'Forgotten Password?');

var LoginForm = exports.LoginForm = function (_Component) {
    _inherits(LoginForm, _Component);

    function LoginForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LoginForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.onCreateAccount = function () {
            var feed = _this.props.feed;

            var analytics = (0, _analyticsTracking.findAnalytics)();
            if (analytics) {
                (0, _analyticsTracking.logToAnalyticsBookmakerOpenAccount)(feed, analytics, true);
            }
        }, _this.renderErrorMessage = function () {
            return _ref2;
        }, _this.renderActionBar = function () {
            return _jsx('div', {
                className: (0, _classnames2.default)('bs-actionBar', 'bs-section', _this.props.actionBarClass)
            }, void 0, _jsx('a', {
                onClick: _this.onCreateAccount,
                href: _this.props.registrationLink,
                target: '__blank',
                className: (0, _classnames2.default)('bs-btn', 'bs-btn_default', 'bs-btn_link', 'bs-actionBar__button', 'bs-actionBar__button_2XL', 'bs-actionBar__half')
            }, void 0, 'Create an Account'), _jsx('button', {
                type: 'submit',
                className: (0, _classnames2.default)('bs-btn', 'bs-btn_major', 'bs-actionBar__button', 'bs-actionBar__half')
            }, void 0, _ref3));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LoginForm, [{
        key: 'render',
        value: function render() {
            var feed = this.props.feed;

            var gamblingCompliance = (0, _gamblingCompliance.getGamblingCompliance)(feed);
            return _jsx('div', {}, void 0, _jsx('form', {
                onSubmit: this.props.handleSubmit,
                className: 'bs-loginForm'
            }, void 0, _jsx('div', {
                className: 'bs-loginForm__body'
            }, void 0, _jsx('div', {
                className: 'bs-form__group'
            }, void 0, _ref4, _jsx('div', {
                className: 'bs-form__field bs-loginForm__rightField'
            }, void 0, _ref5, _jsx(_reduxForm.Field, {
                name: 'saveUsername',
                component: _checkbox.ReduxFormCheckbox,
                onChange: this.props.onSaveUsernameChange,
                className: 'bs-loginForm__checkbox',
                iconType: 'color',
                iconSize: 'XL',
                props: { tabIndex: -1 }
            }))), _jsx('div', {
                className: 'bs-form__group'
            }, void 0, _jsx('div', {
                className: (0, _classnames2.default)('bs-form__field', 'bs-loginForm__leftField', 'bs-col_8')
            }, void 0, _ref6, _ref7)), this.props.isIncorrectCredentials ? this.renderErrorMessage() : null, _jsx('div', {
                className: 'bs-section'
            }, void 0, _jsx(_reactRouterDom.Link, {
                className: (0, _classnames2.default)('bs-link', 'bs-link_major', 'bs-loginForm__forgottenPasswordLink'),
                to: '/' + feed + '/forgotten-password'
            }, void 0, _ref8, _ref9))), _jsx('div', {
                className: 'bs-loginForm__compliance-padding'
            }, void 0, this.props.showGamblingCompliance ? gamblingCompliance : null), this.renderActionBar()));
        }
    }]);

    return LoginForm;
}(_react.Component);

LoginForm.defaultProps = {
    registrationLink: null,
    actionBarClass: '',
    showGamblingCompliance: false,
    isIncorrectCredentials: null
};

exports.default = (0, _reduxForm.reduxForm)({
    form: 'loginForm',
    destroyOnUnmount: false
})(LoginForm);

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginIframe = function (_Component) {
    _inherits(LoginIframe, _Component);

    function LoginIframe() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LoginIframe);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginIframe.__proto__ || Object.getPrototypeOf(LoginIframe)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseTouchOutside = function (_ref2) {
            var target = _ref2.target;

            if (target !== _this.iframe) {
                _this.iframe.blur();
            }
        }, _this.onMessage = function (_ref3) {
            var _ref3$data = _ref3.data,
                event = _ref3$data.event,
                data = _ref3$data.data;

            if (event === 'login') {
                if (data.success) {
                    _this.props.onLoginSuccess();
                } else {
                    _this.props.onBackClick();
                }
            }
            if (event === 'default' && data.success) {
                _this.props.onBackClick();
            }
            if (event === 'serverError' && !data.success) {
                _this.props.onBackClick();
            }
        }, _this.onIframeSetRef = function (node) {
            _this.iframe = node;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LoginIframe, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('message', this.onMessage, false);
            document.addEventListener('touchstart', this.onMouseTouchOutside, false);
            this.disablePageZooming();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('message', this.onMessage, false);
            document.removeEventListener('touchstart', this.onMouseTouchOutside, false);
            this.enablePageZooming();
            this.iframe.blur();
        }
    }, {
        key: 'disablePageZooming',
        value: function disablePageZooming() {
            var viewPortMetaTag = document.querySelector('meta[name="viewport"]');
            this.oldViewPortContent = viewPortMetaTag.getAttribute('content');
            var newViewPortContent = this.oldViewPortContent.toLowerCase().split(',').map(function (option) {
                return option.trim();
            }).filter(function (option) {
                return !option.includes('user-scalable');
            }).concat('user-scalable=no').join(', ');
            viewPortMetaTag.setAttribute('content', newViewPortContent);
        }
    }, {
        key: 'enablePageZooming',
        value: function enablePageZooming() {
            var viewPortMetaTag = document.querySelector('meta[name="viewport"]');
            viewPortMetaTag.setAttribute('content', this.oldViewPortContent);
        }
    }, {
        key: 'render',
        value: function render() {
            var authUrl = this.props.authUrl;

            return _jsx('div', {
                className: 'bs-loginIframe__wrapper'
            }, void 0, _react2.default.createElement('iframe', {
                ref: this.onIframeSetRef,
                className: 'bs-iframeContainer',
                src: authUrl,
                title: 'login'
            }));
        }
    }]);

    return LoginIframe;
}(_react.Component);

LoginIframe.defaultProps = {
    authUrl: ''
};

exports.default = LoginIframe;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cookie = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var objectToCSV = function objectToCSV(obj) {
    var valueSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '=';
    var itemsSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    return Object.keys(obj).map(function (key) {
        return '' + key + valueSeparator + obj[key];
    }).join(itemsSeparator);
};

var flow = function flow() {
    for (var _len = arguments.length, actions = Array(_len), _key = 0; _key < _len; _key++) {
        actions[_key] = arguments[_key];
    }

    return function (value) {
        return actions.reduce(function (args, action) {
            return action(args);
        }, value);
    };
};

var getWindowPosition = function getWindowPosition(options, opener) {
    return {
        top: (opener.innerHeight - options.height) / 2 + opener.screenY,
        left: (opener.innerWidth - options.width) / 2 + opener.screenX
    };
};

var _ref3 = _jsx('span', {}, void 0, 'Please enable pop-ups in your web browser to log in');

var LoginWindow = function (_Component) {
    _inherits(LoginWindow, _Component);

    function LoginWindow(props) {
        _classCallCheck(this, LoginWindow);

        var _this = _possibleConstructorReturn(this, (LoginWindow.__proto__ || Object.getPrototypeOf(LoginWindow)).call(this, props));

        _this.onMessage = function (_ref) {
            var _ref$data = _ref.data,
                event = _ref$data.event,
                data = _ref$data.data;

            if (_this.state.loginHandled) {
                return;
            }
            if (event === 'login') {
                if (data.success) {
                    _this.props.onLoginSuccess();
                } else {
                    _this.props.onBackClick();
                }
            }
            if (event === 'default' && data.success) {
                _this.props.onBackClick();
            }
            if (event === 'default' || event === 'login') {
                _this.setState({ loginHandled: true });
                clearTimeout(_this.state.timerIdentifier);
            }
        };

        _this.checkBookmakerCookie = function () {
            var cookieName = _this.props.cookieName;

            if ((0, _cookie.getCookie)(cookieName)) {
                _this.onMessage({
                    data: {
                        event: 'login',
                        data: { success: true }
                    }
                });
            }
        };

        _this.checkIfWindowOpened = function () {
            var newWindowInstance = _this.state.newWindowInstance;

            if (newWindowInstance && newWindowInstance.closed) {
                _this.onMessage({
                    data: {
                        event: 'login',
                        data: { success: false }
                    }
                });
            }
        };

        _this.state = {
            loginHandled: false
        };
        return _this;
    }

    _createClass(LoginWindow, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                width = _props.width,
                height = _props.height,
                authUrl = _props.authUrl,
                windowName = _props.windowName;

            var position = getWindowPosition({ width: width, height: height }, window);
            var configurationString = objectToCSV(_extends({}, position, {
                width: width,
                height: height
            }));
            var newWindowInstance = window.open(authUrl, windowName, configurationString);
            if (newWindowInstance) {
                newWindowInstance.focus();
            }
            window.addEventListener('message', this.onMessage, false);
            var onTimerCheck = flow(this.checkBookmakerCookie, this.checkIfWindowOpened);
            var timerIdentifier = setInterval(onTimerCheck, 100);
            this.setState({
                newWindowInstance: newWindowInstance,
                timerIdentifier: timerIdentifier
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var newWidth = _ref2.width,
                newHeight = _ref2.height,
                newAuthUrl = _ref2.authUrl;
            var newWindowInstance = this.state.newWindowInstance;

            if (newWindowInstance && !newWindowInstance.closed) {
                var _props2 = this.props,
                    width = _props2.width,
                    height = _props2.height,
                    authUrl = _props2.authUrl;

                if (authUrl !== newAuthUrl) {
                    newWindowInstance.location.href = newAuthUrl;
                }
                if (width !== newWidth || height !== newHeight) {
                    newWindowInstance.resizeTo(newWidth, newHeight);
                    newWindowInstance.focus();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('message', this.onMessage, false);
            clearTimeout(this.state.timerIdentifier);
            var newWindowInstance = this.state.newWindowInstance;

            if (newWindowInstance && !newWindowInstance.closed) {
                newWindowInstance.close();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var newWindowInstance = this.state.newWindowInstance;

            var windowNotOpened = !newWindowInstance || typeof newWindowInstance.closed === 'undefined';
            return windowNotOpened ? _ref3 : null;
        }
    }]);

    return LoginWindow;
}(_react.Component);

LoginWindow.defaultProps = {
    width: 920,
    height: 575,
    windowName: '',
    cookieName: '',
    authUrl: ''
};
exports.default = LoginWindow;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'bs-loginError'
}, void 0, _jsx('div', {
    className: 'bs-loginError__title'
}, void 0, 'Service Unavailable'), _jsx('div', {
    className: 'bs-loginError__message'
}, void 0, _jsx('span', {}, void 0, 'The service is temporarily unavailable.'), _jsx('span', {}, void 0, 'Please try again later.')));

var _ref3 = _jsx('span', {}, void 0, 'Cancel');

var _ref4 = _jsx('span', {}, void 0, 'Retry');

var ServiceUnavailableError = function ServiceUnavailableError(_ref) {
    var onCancel = _ref.onCancel,
        onRetry = _ref.onRetry,
        actionBarClass = _ref.actionBarClass;
    return _jsx('div', {}, void 0, _ref2, _jsx('div', {
        className: (0, _classnames2.default)('bs-actionBar', 'bs-section', actionBarClass)
    }, void 0, _jsx('span', {
        role: 'button',
        tabIndex: 0,
        onClick: onCancel,
        className: '\n                    bs-actionBar__half\n                    bs-actionBar__link\n                    bs-actionBar__link_danger\n                '
    }, void 0, _ref3), _jsx('button', {
        onClick: onRetry,
        className: '\n                    bs-btn\n                    bs-btn_major\n                    bs-actionBar__half\n                    bs-actionBar__button\n                    bs-actionBar__button_2XL\n                '
    }, void 0, _ref4)));
};

ServiceUnavailableError.defaultProps = {
    actionBarClass: ''
};

exports.default = ServiceUnavailableError;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPortal = __webpack_require__(363);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _colorSkinWrapper = __webpack_require__(45);

var _colorSkinWrapper2 = _interopRequireDefault(_colorSkinWrapper);

var _Modal = __webpack_require__(230);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ModalPortal = function ModalPortal(_ref) {
    var bookmakerName = _ref.bookmakerName,
        visible = _ref.visible,
        props = _objectWithoutProperties(_ref, ['bookmakerName', 'visible']);

    return _jsx(_reactPortal2.default, {
        isOpened: visible
    }, void 0, _jsx(_colorSkinWrapper2.default, {
        bookmakerName: bookmakerName
    }, void 0, _react2.default.createElement(_Modal2.default, _extends({}, props, { visible: visible }))));
};

ModalPortal.defaultProps = {
    visible: false
};

exports.default = ModalPortal;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(674);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

var _ref = _jsx(_svgIcon2.default, {
    iconName: 'backspace',
    className: 'bs-keypad__backspace'
});

var _ref2 = _jsx('span', {}, void 0, 'Done');

var NumericKeypad = function (_Component) {
    _inherits(NumericKeypad, _Component);

    function NumericKeypad() {
        _classCallCheck(this, NumericKeypad);

        return _possibleConstructorReturn(this, (NumericKeypad.__proto__ || Object.getPrototypeOf(NumericKeypad)).apply(this, arguments));
    }

    _createClass(NumericKeypad, [{
        key: 'removeSymbol',
        value: function removeSymbol() {
            var _props = this.props,
                value = _props.value,
                targetId = _props.targetId,
                setStake = _props.setStake,
                onStakeUpdated = _props.onStakeUpdated;

            if (value) {
                var newValue = value.substring(0, value.length - 1);
                setStake(targetId, newValue);
                if (onStakeUpdated) {
                    onStakeUpdated(newValue);
                }
            }
        }
    }, {
        key: 'addSymbol',
        value: function addSymbol(symbol) {
            var _props2 = this.props,
                value = _props2.value,
                targetId = _props2.targetId,
                setStake = _props2.setStake,
                onStakeUpdated = _props2.onStakeUpdated;


            if (symbol === '.' && value.indexOf('.') !== -1) {
                // Prevent multiple '.'
                return;
            }

            var stakeParts = value.split('.');

            if (stakeParts[1] !== undefined && stakeParts[1].length === 2) {
                // 2 decimal places
                return;
            }

            var newValue = '' + value + symbol;
            setStake(targetId, newValue);
            if (onStakeUpdated) {
                onStakeUpdated(newValue);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                targetId = _props3.targetId,
                setIsEditingStake = _props3.setIsEditingStake;


            return _jsx('div', {
                className: 'bs-keypad'
            }, void 0, _jsx('div', {
                className: 'bs-keypad__wrapper'
            }, void 0, _jsx('div', {
                className: 'bs-keypad__row'
            }, void 0, KEYS.map(function (value, index) {
                return _jsx('div', {
                    className: 'bs-keypad__key'
                }, 'key-' + value, _jsx('button', {
                    className: (0, _classnames2.default)('bs-keypad__button', 'bs-keypad__key_' + value),
                    tabIndex: index,
                    onClick: function onClick(e) {
                        e.preventDefault();
                        _this2.addSymbol(value);
                    }
                }, void 0, value));
            })), _jsx('div', {
                className: 'bs-keypad__row'
            }, void 0, _jsx('div', {
                className: 'bs-keypad__key bs-keypad__key--point'
            }, void 0, _jsx('button', {
                className: 'bs-keypad__button',
                onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.addSymbol('.');
                }
            }, void 0, '.')), _jsx('div', {
                className: 'bs-keypad__key bs-keypad__key--backspace'
            }, void 0, _jsx('button', {
                className: 'bs-keypad__button',
                onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.removeSymbol();
                }
            }, void 0, _ref)), _jsx('div', {
                className: 'bs-keypad__key bs-keypad__key--done'
            }, void 0, _jsx('button', {
                className: 'bs-keypad__button',
                onClick: function onClick(e) {
                    e.preventDefault();
                    setIsEditingStake(targetId, false);
                }
            }, void 0, _ref2)))));
        }
    }]);

    return NumericKeypad;
}(_react.Component);

NumericKeypad.defaultProps = {
    onStakeUpdated: null
};

exports.default = NumericKeypad;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(8);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(675);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('span', {
    className: 'bs-bookmakerLogo bs-header__linkLogo'
});

var generateLinkLogo = function generateLinkLogo(hideLogo) {
    return !hideLogo ? _ref : null;
};

var generateTogglingLayer = function generateTogglingLayer(toggle) {
    return toggle ? _jsx('div', {
        className: 'bs-header__togglingLayer',
        role: 'toolbar',
        onClick: toggle
    }, void 0) : null;
};

var _ref3 = _jsx(_svgIcon2.default, {
    iconName: 'left',
    size: 'Medium',
    className: 'bs-header__linkIcon'
});

var PageHeader = function PageHeader(_ref2) {
    var children = _ref2.children,
        backLinkUrl = _ref2.backLinkUrl,
        hideLogo = _ref2.hideLogo,
        toggle = _ref2.toggle;
    return _jsx('div', {
        className: 'bs-header'
    }, void 0, backLinkUrl ? _jsx(_reactRouterDom.Link, {
        className: 'bs-header__link',
        to: {
            pathname: backLinkUrl,
            state: { isReversedAnimation: true }
        }
    }, void 0, _ref3, generateLinkLogo(hideLogo)) : generateLinkLogo(hideLogo), children, generateTogglingLayer(toggle));
};

PageHeader.defaultProps = {
    backLinkUrl: '',
    children: null,
    hideLogo: false,
    toggle: null
};

exports.default = PageHeader;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(676);

var _PagerArrow = __webpack_require__(620);

var _PagerArrow2 = _interopRequireDefault(_PagerArrow);

var _betHistory = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pager = function Pager(props) {
    var isLoading = props.isLoading,
        currentPage = props.currentPage,
        pageLength = props.pageLength,
        currentPageLength = props.currentPageLength,
        hasNextPage = props.hasNextPage,
        onDecrementPage = props.onDecrementPage,
        onIncrementPage = props.onIncrementPage;

    var lastPage = currentPage === _betHistory.BET_HISTORY_MAX_PAGES_COUNT + 1;

    return _jsx('div', {
        className: (0, _classnames2.default)('bs-pager', { 'bs-pager_hidden': currentPage === 1 && !hasNextPage })
    }, void 0, _jsx(_PagerArrow2.default, {
        onArrowClick: onDecrementPage,
        disabled: currentPage === 1,
        iconName: 'left'
    }), _jsx('div', {
        className: (0, _classnames2.default)('bs-pager__numbers', { 'bs-pager__numbers_hidden': lastPage })
    }, void 0, isLoading ? null : (currentPage - 1) * pageLength + 1 + ' - ' + ((currentPage - 1) * pageLength + currentPageLength)), _jsx(_PagerArrow2.default, {
        onArrowClick: onIncrementPage,
        disabled: !hasNextPage,
        iconName: 'right'
    }));
};

Pager.defaultProps = {
    hasNextPage: false
};

exports.default = Pager;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PagerArrow = function PagerArrow(_ref) {
    var disabled = _ref.disabled,
        onArrowClick = _ref.onArrowClick,
        iconName = _ref.iconName;
    return _jsx('button', {
        className: (0, _classnames2.default)('bs-btn', 'bs-btn_major', 'bs-pager__arrow', { 'bs-pager__arrow_disabled': disabled }),
        onClick: onArrowClick
    }, void 0, _jsx(_svgIcon2.default, {
        className: (0, _classnames2.default)('bs-pager__arrowIcon', { 'bs-pager__arrow_disabled': disabled }),
        size: 'Medium',
        iconName: iconName
    }));
};

PagerArrow.defaultProps = {
    disabled: false
};

exports.default = PagerArrow;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _Pager = __webpack_require__(619);

var _Pager2 = _interopRequireDefault(_Pager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pager2.default;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(677);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(_ref) {
    var visible = _ref.visible,
        className = _ref.className,
        children = _ref.children,
        spinnerIconName = _ref.spinnerIconName;

    if (!visible) {
        return null;
    }
    return _jsx('div', {
        className: (0, _classnames2.default)('bs-spinner', className)
    }, void 0, _jsx(_svgIcon2.default, {
        iconName: spinnerIconName,
        size: '2XL',
        className: 'bs-spinner__animatedWheel'
    }), _jsx('span', {
        className: 'bs-spinner__text'
    }, void 0, children));
};

Spinner.defaultProps = {
    className: '',
    children: null,
    visible: true,
    spinnerIconName: 'spinner'
};

exports.default = Spinner;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _formFormatters = __webpack_require__(130);

var _formFormatters2 = _interopRequireDefault(_formFormatters);

__webpack_require__(678);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StakeField = function (_Component) {
    _inherits(StakeField, _Component);

    function StakeField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, StakeField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StakeField.__proto__ || Object.getPrototypeOf(StakeField)).call.apply(_ref, [this].concat(args))), _this), _this.onStakeInputClick = function () {
            var _this$props = _this.props,
                targetId = _this$props.targetId,
                freezeStake = _this$props.freezeStake,
                isEditingStake = _this$props.isEditingStake,
                setIsEditingStake = _this$props.setIsEditingStake;


            if (!isEditingStake && !freezeStake) {
                setIsEditingStake(targetId, true);
            }
        }, _this.onStakeInputChange = function (e) {
            var _this$props2 = _this.props,
                targetId = _this$props2.targetId,
                setStake = _this$props2.setStake,
                onStakeUpdated = _this$props2.onStakeUpdated;


            var stakeParts = e.target.value.split('.');

            // Reject cases with more than 1 period e.g. "5.2.1"
            if (stakeParts.length <= 2) {
                // Reject cases of period + more than 2 decimal numbers e.g. "2.001"
                if (stakeParts.length === 2 && stakeParts[1].length > 2) {
                    return;
                }

                setStake(targetId, e.target.value);

                // Note: onStakeUpdated is used for validation purposes.
                // Currently multiples have no validation.
                if (typeof onStakeUpdated === 'function') {
                    onStakeUpdated(e.target.value, targetId);
                }
            }
        }, _this.onStakeInputBlur = function () {
            var _this$props3 = _this.props,
                targetId = _this$props3.targetId,
                stakeValue = _this$props3.stakeValue,
                setStake = _this$props3.setStake,
                onStakeUpdated = _this$props3.onStakeUpdated;


            var value = parseFloat(stakeValue).toFixed(2);
            setStake(targetId, value);

            if (typeof onStakeUpdated === 'function') {
                onStakeUpdated(value, targetId);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(StakeField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                stakeValue = _props.stakeValue,
                currencySign = _props.currencySign,
                isMobile = _props.isMobile,
                placeholder = _props.placeholder,
                freezeStake = _props.freezeStake;


            var formattedStakeValue = (0, _formFormatters2.default)(currencySign)(stakeValue);

            return _jsx('div', {
                className: 'bs-stakeField'
            }, void 0, isMobile ? _jsx('span', {
                role: 'button',
                tabIndex: 0,
                onClick: this.onStakeInputClick,
                className: (0, _classnames2.default)('bs-input', 'bs-form__input', 'bs-stakeField__input', {
                    'bs-stakeField__input_placeholder': !stakeValue
                })
            }, void 0, stakeValue ? formattedStakeValue : placeholder) : _jsx('input', {
                name: 'stake',
                type: 'text',
                onChange: this.onStakeInputChange,
                onBlur: this.onStakeInputBlur,
                placeholder: placeholder,
                maxLength: 9,
                disabled: freezeStake,
                value: stakeValue ? formattedStakeValue : '',
                autoComplete: 'off',
                className: (0, _classnames2.default)('bs-input', 'bs-form__input', 'bs-stakeField__input')
            }));
        }
    }]);

    return StakeField;
}(_react.Component);

StakeField.defaultProps = {
    onStakeUpdated: null,
    isMobile: false,
    freezeStake: false,
    stakeValue: '',
    placeholder: 'Stake'
};

exports.default = StakeField;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SvgIcon = function SvgIcon(_ref) {
    var iconName = _ref.iconName,
        className = _ref.className,
        size = _ref.size;
    return _jsx('svg', {
        className: (0, _classnames2.default)('bs-icon', className, _defineProperty({}, 'bs-icon_size' + size, size))
    }, void 0, _jsx('use', {
        xlinkHref: '#betslip-icon-' + iconName
    }));
};

SvgIcon.defaultProps = {
    className: '',
    size: ''
};

exports.default = SvgIcon;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(679);

var _bookmakerLink = __webpack_require__(83);

var _bookmakerLink2 = _interopRequireDefault(_bookmakerLink);

var _TopUpForm = __webpack_require__(627);

var _TopUpForm2 = _interopRequireDefault(_TopUpForm);

var _CardNumberError = __webpack_require__(626);

var _CardNumberError2 = _interopRequireDefault(_CardNumberError);

var _logger = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logger = (0, _logger.create)('TopUp');

var TopUp = function (_Component) {
    _inherits(TopUp, _Component);

    function TopUp() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TopUp);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TopUp.__proto__ || Object.getPrototypeOf(TopUp)).call.apply(_ref, [this].concat(args))), _this), _this.submitTopUp = function (_ref2) {
            var cv2 = _ref2.cv2,
                amount = _ref2.amount;
            var _this$props = _this.props,
                apiName = _this$props.apiName,
                getUserInfo = _this$props.getUserInfo,
                feed = _this$props.feed,
                cardDetails = _this$props.cardDetails;

            var cardNum = cardDetails && cardDetails.cleanCardNumber;
            return _this.props.topUpAccountBalance(apiName, cv2, amount, cardNum).then(function () {
                return getUserInfo(apiName, feed);
            }).catch(function (err) {
                return logger.error(err);
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TopUp, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                apiName = _props.apiName,
                getCardDetails = _props.getCardDetails,
                feed = _props.feed,
                isTopUpIntegrated = _props.isTopUpIntegrated;


            if (isTopUpIntegrated) {
                getCardDetails(apiName, feed);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isTopUpIntegrated = _props2.isTopUpIntegrated,
                isCardDetailsError = _props2.isCardDetailsError,
                topUpBookmakerUrl = _props2.topUpBookmakerUrl,
                topUpBookmakerName = _props2.topUpBookmakerName,
                topUpPhoneNumber = _props2.topUpPhoneNumber,
                isPhone = _props2.isPhone,
                currencySign = _props2.currencySign,
                cardDetails = _props2.cardDetails;

            var cardNumber = cardDetails && cardDetails.cardNumber;
            if (!isTopUpIntegrated) {
                return _jsx(_bookmakerLink2.default, {
                    titleText: 'To deposit, please visit ' + topUpBookmakerName,
                    bookmakerUrl: topUpBookmakerUrl,
                    bookmakerName: topUpBookmakerName
                });
            }

            return _jsx(_react2.default.Fragment, {}, void 0, isCardDetailsError || !cardDetails || !cardDetails.cardId ? _jsx(_CardNumberError2.default, {
                topUpUrl: topUpBookmakerUrl,
                topUpBookmakerName: topUpBookmakerName,
                topUpPhoneNumber: topUpPhoneNumber,
                isPhone: isPhone
            }) : _jsx(_TopUpForm2.default, {
                currencySign: currencySign,
                cardNumber: cardNumber,
                onSubmit: this.submitTopUp
            }));
        }
    }]);

    return TopUp;
}(_react.Component);

TopUp.defaultProps = {
    cardDetails: null,
    isCardDetailsError: false,
    topUpBookmakerUrl: '',
    topUpBookmakerName: '',
    topUpPhoneNumber: '',
    isTopUpModalVisible: false,
    isTopUpIntegrated: false,
    topUpErrorInfo: null
};

exports.default = TopUp;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bookmakerLink = __webpack_require__(83);

var _bookmakerLink2 = _interopRequireDefault(_bookmakerLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'bs-cardNumberError__text'
}, void 0, 'No card details can be found for this account');

var CardNumberError = function CardNumberError(_ref) {
    var topUpUrl = _ref.topUpUrl,
        topUpBookmakerName = _ref.topUpBookmakerName,
        topUpPhoneNumber = _ref.topUpPhoneNumber,
        isPhone = _ref.isPhone;

    var urlLink = topUpBookmakerName !== '' && topUpBookmakerName !== null ? _jsx(_bookmakerLink2.default, {
        titleText: 'To add a new card visit',
        bookmakerUrl: topUpUrl,
        bookmakerName: topUpBookmakerName
    }) : null;

    var phoneLink = topUpPhoneNumber !== '' && topUpPhoneNumber !== null ? _jsx(_bookmakerLink2.default, {
        titleText: 'Or call',
        phoneNumber: topUpPhoneNumber,
        isPhone: isPhone
    }) : null;

    return _jsx('div', {}, void 0, _ref2, urlLink, phoneLink);
};

CardNumberError.defaultProps = {
    topUpUrl: '',
    topUpBookmakerName: '',
    topUpPhoneNumber: '',
    isPhone: false
};

exports.default = CardNumberError;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopUpForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateCvv = function validateCvv(value) {
    return (/^\d{3}$/.test(value) ? undefined : true
    );
};
var validateAmount = function validateAmount(value) {
    return isNaN(parseFloat(value)) ? true : undefined;
};
var normalizeAmount = function normalizeAmount(value) {
    return value.replace(/[^0-9.]/g, '');
};

var validateAmountLength = function validateAmountLength(event) {
    if (event.target.value > 99999.99) {
        event.preventDefault();
    }
};

var _ref = _jsx('label', {
    htmlFor: 'cardNumber',
    className: 'bs-form__label bs-topUpForm__label'
}, void 0, 'Card number');

var _ref2 = _jsx('label', {
    htmlFor: 'amount',
    className: 'bs-form__label bs-topUpForm__label'
}, void 0, 'Deposit amount');

var _ref3 = _jsx('label', {
    htmlFor: 'cv2',
    className: 'bs-form__label bs-topUpForm__label'
}, void 0, '*CV2 code');

var _ref4 = _jsx('div', {
    className: 'bs-form__field bs-topUpForm__field bs-topUpForm__field_button'
}, void 0, _jsx('button', {
    type: 'submit',
    className: 'bs-btn bs-btn_major bs-topUpForm__button'
}, void 0, _jsx('span', {}, void 0, 'Deposit')));

var _ref5 = _jsx('div', {
    className: 'bs-topUpForm__footnote'
}, void 0, '*The CV2 Security Code refers to the last three\xA0', _jsx('wbr', {}), 'digits written on the back of your card.');

var TopUpForm = exports.TopUpForm = function (_Component) {
    _inherits(TopUpForm, _Component);

    function TopUpForm(props) {
        _classCallCheck(this, TopUpForm);

        var _this = _possibleConstructorReturn(this, (TopUpForm.__proto__ || Object.getPrototypeOf(TopUpForm)).call(this, props));

        _this.onAmountBlur = _this.onAmountBlur.bind(_this);
        _this.onCvvBlur = _this.onCvvBlur.bind(_this);
        return _this;
    }

    _createClass(TopUpForm, [{
        key: 'onCvvBlur',
        value: function onCvvBlur(e, newValue) {
            e.preventDefault();
            var isCvvInvalid = validateCvv(newValue);
            if (isCvvInvalid) {
                var change = this.props.change;

                change('cv2', '');
            }
        }
    }, {
        key: 'onAmountBlur',
        value: function onAmountBlur(e, newValue) {
            e.preventDefault();
            var isAmountInvalid = validateAmount(newValue);
            var change = this.props.change;

            var val = isAmountInvalid ? '' : parseFloat(newValue).toFixed(2);
            change('amount', val);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                handleSubmit = _props.handleSubmit,
                cardNumber = _props.cardNumber,
                currencySign = _props.currencySign;

            var formattedCardNumber = cardNumber ? Array(3).fill('\u2022'.repeat(4)).join(' ').concat(' ' + cardNumber.slice(-4)) : '';
            return _jsx('form', {
                onSubmit: handleSubmit,
                className: 'bs-topUpForm'
            }, void 0, _jsx('div', {
                className: 'bs-form__group'
            }, void 0, _jsx('div', {
                className: 'bs-form__field\n                                     bs-topUpForm__field\n                                     bs-topUpForm__field_cardNumber'
            }, void 0, _ref, _jsx(_reduxForm.Field, {
                name: 'cardNumber',
                id: 'cardNumber',
                component: 'input',
                type: 'text',
                placeholder: formattedCardNumber,
                className: 'bs-input bs-form__input',
                disabled: true
            }))), _jsx('div', {
                className: 'bs-form__group'
            }, void 0, _jsx('div', {
                className: 'bs-form__field bs-topUpForm__field'
            }, void 0, _ref2, _jsx('div', {
                className: 'bs-inputWrapper'
            }, void 0, _jsx('span', {
                className: 'bs-topUpForm__currencySign'
            }, void 0, currencySign), _jsx(_reduxForm.Field, {
                name: 'amount',
                id: 'amount',
                component: 'input',
                type: 'tel',
                pattern: '[0-9\\.]*',
                placeholder: '0.00',
                onChange: validateAmountLength,
                onBlur: this.onAmountBlur,
                validate: validateAmount,
                normalize: normalizeAmount,
                maxLength: '8',
                className: 'bs-input bs-form__input bs-topUpForm__input'
            }))), _jsx('div', {
                className: 'bs-form__field bs-topUpForm__field'
            }, void 0, _ref3, _jsx(_reduxForm.Field, {
                name: 'cv2',
                id: 'cv2',
                component: 'input',
                type: 'tel',
                pattern: '[0-9]*',
                onBlur: this.onCvvBlur,
                validate: validateCvv,
                maxLength: '3',
                className: 'bs-input bs-form__input bs-topUpForm__input'
            })), _ref4), _ref5);
        }
    }]);

    return TopUpForm;
}(_react.Component);

TopUpForm.defaultProps = {
    cardNumber: ''
};

exports.default = (0, _reduxForm.reduxForm)({
    form: 'topUpForm'
})(TopUpForm);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(177);

var _reactRouterDom = __webpack_require__(8);

var _TrackableMemoryRouter = __webpack_require__(531);

var _TrackableMemoryRouter2 = _interopRequireDefault(_TrackableMemoryRouter);

var _pageHeader = __webpack_require__(86);

var _pageHeader2 = _interopRequireDefault(_pageHeader);

var _userInfo = __webpack_require__(11);

var _userInfo2 = _interopRequireDefault(_userInfo);

var _MinimizeButton = __webpack_require__(553);

var _MinimizeButton2 = _interopRequireDefault(_MinimizeButton);

__webpack_require__(680);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TransitionRouter = function (_Component) {
	_inherits(TransitionRouter, _Component);

	function TransitionRouter(props, context) {
		_classCallCheck(this, TransitionRouter);

		var _this = _possibleConstructorReturn(this, (TransitionRouter.__proto__ || Object.getPrototypeOf(TransitionRouter)).call(this, props, context));

		_this.generateTransitionRoutes = _this.generateTransitionRoutes.bind(_this);
		return _this;
	}

	_createClass(TransitionRouter, [{
		key: "generateTransitionRoutes",
		value: function generateTransitionRoutes(_ref) {
			var location = _ref.location;
			var _props = this.props,
			    children = _props.children,
			    isDrawer = _props.isDrawer;


			return _jsx(_react2.default.Fragment, {}, void 0, isDrawer ? this.renderHeader() : null, _jsx(_reactRouterDom.Route, {
				location: location
			}, location.key, _jsx(_reactRouter.Switch, {}, void 0, children)));
		}
	}, {
		key: "renderPageHeader",
		value: function renderPageHeader(backlinkUrl) {
			var _props2 = this.props,
			    isUserLoggedIn = _props2.isUserLoggedIn,
			    userInfo = _props2.userInfo,
			    bookmakerName = _props2.bookmakerName,
			    betslipID = _props2.betslipID,
			    courseName = _props2.courseName,
			    selectedBets = _props2.selectedBets,
			    toggleBalanceVisibility = _props2.toggleBalanceVisibility,
			    selectedBookmakerFeed = _props2.selectedBookmakerFeed,
			    isDrawerMinimized = _props2.isDrawerMinimized,
			    onMaximizeClick = _props2.onMaximizeClick,
			    onMinimizeClick = _props2.onMinimizeClick,
			    numberOfSelectedBets = _props2.numberOfSelectedBets,
			    isQuickslipMode = _props2.isQuickslipMode,
			    resetEmptyBetslip = _props2.resetEmptyBetslip,
			    resetQuickslip = _props2.resetQuickslip,
			    isBetPlacedSuccessfully = _props2.isBetPlacedSuccessfully,
			    clearPlacedBetDetails = _props2.clearPlacedBetDetails;


			var toggle = void 0;

			toggle = function toggle(event) {
				event.stopPropagation();

				// Empty betslip ("Your Bet Slip is Empty")
				if (!isDrawerMinimized && numberOfSelectedBets === 0 && !isQuickslipMode) {
					return resetEmptyBetslip();
				}

				// All other scenarios
				return isDrawerMinimized ? onMaximizeClick() : onMinimizeClick();
			};

			// Quickslip (1 bet showing) or Bet Receipt page
			var quickslipWithBet = !isDrawerMinimized && numberOfSelectedBets === 1 && isQuickslipMode;
			if (quickslipWithBet || isBetPlacedSuccessfully) {
				// Do nothing (and allow click event to propagate)
				toggle = null;
			}

			return _jsx(_pageHeader2.default, {
				backLinkUrl: backlinkUrl,
				toggle: toggle
			}, void 0, isUserLoggedIn ? _react2.default.createElement(_userInfo2.default, _extends({}, userInfo, {
				toggleBalanceVisibility: toggleBalanceVisibility,
				selectedBookmakerFeed: selectedBookmakerFeed
			})) : null, _jsx(_MinimizeButton2.default, {
				bookmakerName: bookmakerName,
				betslipID: betslipID,
				courseName: courseName,
				isQuickslipMode: isQuickslipMode,
				resetQuickslip: resetQuickslip,
				isBetPlacedSuccessfully: isBetPlacedSuccessfully,
				clearPlacedBetDetails: clearPlacedBetDetails,
				selectedBets: selectedBets
			}));
		}
	}, {
		key: "renderHeader",
		value: function renderHeader() {
			var _this2 = this;

			var forgottenPasswordPath = "/" + this.props.selectedBookmakerFeed + "/login";

			return _jsx(_react2.default.Fragment, {}, void 0, _jsx(_reactRouterDom.Route, {
				exact: true,
				path: "/",
				render: function render() {
					return _this2.renderPageHeader(null);
				}
			}), _jsx(_reactRouterDom.Route, {
				path: "/:feed/login",
				render: function render() {
					return _this2.renderPageHeader('/');
				}
			}), _jsx(_reactRouterDom.Route, {
				path: "/bet-receipt",
				render: function render() {
					return _this2.renderPageHeader(null);
				}
			}), _jsx(_reactRouterDom.Route, {
				path: "/:feed/forgotten-password",
				render: function render() {
					return _this2.renderPageHeader(forgottenPasswordPath);
				}
			}), _jsx(_reactRouterDom.Route, {
				path: "/:feed/top-up",
				render: function render() {
					return _this2.renderPageHeader("/");
				}
			}));
		}
	}, {
		key: "render",
		value: function render() {
			return _jsx(_TrackableMemoryRouter2.default, {
				onHistoryChanged: this.props.onHistoryChanged,
				trackedParams: this.props.trackedParams
			}, void 0, _jsx(_reactRouterDom.Route, {
				render: this.generateTransitionRoutes
			}));
		}
	}]);

	return TransitionRouter;
}(_react.Component);

TransitionRouter.defaultProps = {
	bookmakerName: null
};


TransitionRouter.defaultProps = {
	onHistoryChanged: null,
	trackedParams: "",
	isDrawer: false,
	isUserLoggedIn: false,
	userInfo: {},
	betslipID: null,
	toggleBalanceVisibility: null,
	isDrawerMinimized: true,
	onMaximizeClick: null,
	onMinimizeClick: null,
	numberOfSelectedBets: 0,
	isQuickslipMode: false,
	resetEmptyBetslip: null,
	resetQuickslip: null,
	isBetPlacedSuccessfully: false,
	clearPlacedBetDetails: null
};

exports.default = TransitionRouter;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(681);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'bs-userInfo__info'
}, void 0, _jsx('span', {}, void 0, _jsx('span', {
    className: 'bs-userInfo__infoLine'
}, void 0, 'Balance'), _jsx('span', {
    className: 'bs-userInfo__balance'
}, void 0, 'N/A')));

var _ref3 = _jsx('span', {
    className: 'bs-userInfo__infoLine'
}, void 0, 'Balance');

var _ref4 = _jsx('span', {
    className: 'bs-userInfo__balance'
}, void 0, 'Show Balance');

var UserInfo = function UserInfo(_ref) {
    var balance = _ref.balance,
        currencySign = _ref.currencySign,
        showBalance = _ref.showBalance,
        hasDetails = _ref.hasDetails,
        toggleBalanceVisibility = _ref.toggleBalanceVisibility,
        selectedBookmakerFeed = _ref.selectedBookmakerFeed;

    var balanceValue = balance !== null ? '' + currencySign + balance.toFixed(2) : 'N/A';

    // This is generic error handling i.e. we got a bad response from the userInfo endpoint
    if (!hasDetails) {
        return _ref2;
    }

    return _jsx('span', {
        className: 'bs-userInfo__info',
        tabIndex: 0,
        role: 'button',
        onClick: function onClick() {
            toggleBalanceVisibility(selectedBookmakerFeed);
        }
    }, void 0, showBalance ? _jsx('span', {}, void 0, _ref3, _jsx('span', {
        className: 'bs-userInfo__balance'
    }, void 0, balanceValue)) : _ref4);
};

UserInfo.defaultProps = {
    hasDetails: false,
    showBalance: true,
    balance: null
};

exports.default = UserInfo;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Drawer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(8);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobileDetect = __webpack_require__(163);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _pageInfo = __webpack_require__(37);

var _drawer = __webpack_require__(225);

var drawerSelectors = _interopRequireWildcard(_drawer);

var _drawer2 = __webpack_require__(38);

var drawerActions = _interopRequireWildcard(_drawer2);

var _events = __webpack_require__(121);

var eventsActions = _interopRequireWildcard(_events);

var _bookmakersInfo = __webpack_require__(6);

var _modals = __webpack_require__(29);

var _bookmakersList = __webpack_require__(5);

var _bet = __webpack_require__(20);

var _BetPage = __webpack_require__(548);

var _BetPage2 = _interopRequireDefault(_BetPage);

var _LoginPage = __webpack_require__(552);

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _BetReceiptPage = __webpack_require__(549);

var _BetReceiptPage2 = _interopRequireDefault(_BetReceiptPage);

var _ForgottenPasswordPage = __webpack_require__(551);

var _ForgottenPasswordPage2 = _interopRequireDefault(_ForgottenPasswordPage);

var _transitionRouter = __webpack_require__(16);

var _transitionRouter2 = _interopRequireDefault(_transitionRouter);

var _TopUpPage = __webpack_require__(554);

var _TopUpPage2 = _interopRequireDefault(_TopUpPage);

var _BodyScroll = __webpack_require__(550);

var _BodyScroll2 = _interopRequireDefault(_BodyScroll);

var _colorSkinWrapper = __webpack_require__(45);

var _colorSkinWrapper2 = _interopRequireDefault(_colorSkinWrapper);

var _userInfo = __webpack_require__(11);

var _gamblingCompliance = __webpack_require__(46);

var _globalModal = __webpack_require__(526);

var _globalModal2 = _interopRequireDefault(_globalModal);

__webpack_require__(692);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getIsPhone = function getIsPhone() {
	return Boolean(new _mobileDetect2.default(navigator.userAgent).phone());
};

var getIsTablet = function getIsTablet() {
	return Boolean(new _mobileDetect2.default(navigator.userAgent).tablet());
};

var _ref2 = _jsx(_reactRouterDom.Route, {
	exact: true,
	path: "/",
	component: _BetPage2.default
});

var _ref3 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/login",
	component: _LoginPage2.default
});

var _ref4 = _jsx(_reactRouterDom.Route, {
	path: "/bet-receipt",
	component: _BetReceiptPage2.default
});

var _ref5 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/forgotten-password",
	component: _ForgottenPasswordPage2.default
});

var _ref6 = _jsx(_reactRouterDom.Route, {
	path: "/:feed/top-up",
	component: _TopUpPage2.default
});

var Drawer = exports.Drawer = function (_Component) {
	_inherits(Drawer, _Component);

	function Drawer(props) {
		_classCallCheck(this, Drawer);

		var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

		_this.onMaximizeClick = function () {
			var _this$props = _this.props,
			    isUserLoggedIn = _this$props.isUserLoggedIn,
			    onMaximizeClick = _this$props.onMaximizeClick,
			    getUserInfo = _this$props.getUserInfo,
			    apiName = _this$props.apiName,
			    feed = _this$props.feed;


			if (isUserLoggedIn) {
				getUserInfo(apiName, feed);
			}

			onMaximizeClick();
		};

		_this.handleKeyboardEvent = function (e) {
			var _this$props2 = _this.props,
			    clearGlobalModal = _this$props2.clearGlobalModal,
			    globalModal = _this$props2.globalModal,
			    isQuickslipMode = _this$props2.isQuickslipMode,
			    isDrawerMinimized = _this$props2.isDrawerMinimized,
			    onMinimizeClick = _this$props2.onMinimizeClick,
			    resetQuickslip = _this$props2.resetQuickslip,
			    selectedBets = _this$props2.selectedBets,
			    resetEmptyBetslip = _this$props2.resetEmptyBetslip;


			var ESC_KEY = 27;
			if (e.keyCode === ESC_KEY) {
				// Global modal...
				if (globalModal !== null) {
					clearGlobalModal();
					return;
				}

				// Quickslip...
				if (!isDrawerMinimized && isQuickslipMode) {
					resetQuickslip();
					return;
				}

				// Betslip...
				if (!isDrawerMinimized && !isQuickslipMode) {
					if (selectedBets.length) {
						onMinimizeClick();
						return;
					}
					resetEmptyBetslip();
				}
			}
		};

		_this.preventZoom = function (e) {
			var currTapTime = e.timeStamp;
			var prevTapTime = _this.state.lastTapTime || currTapTime;
			var tapTimeDiff = currTapTime - prevTapTime;
			var isSingleFingerTap = e.touches.length === 1;
			_this.setState({ lastTapTime: currTapTime });

			if (!tapTimeDiff || tapTimeDiff > 500 || !isSingleFingerTap) {
				return;
			}
			e.preventDefault();
			e.target.click();
		};

		_this.state = {
			lastTapTime: null
		};
		return _this;
	}

	_createClass(Drawer, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			if (!window.location.pathname.includes("/my-bookmakers")) {
				var apiUrls = _apiClient2.default.getApiUrls();
				var isPhone = getIsPhone();
				var isTablet = getIsTablet();
				var loggedInBookmakers = this.getLoggedInBookmakers(isPhone);

				this.props.initializeLoggedInBookmakers(loggedInBookmakers, apiUrls.v1);
				this.props.setDeviceType(isPhone, isTablet);
				this.props.loadAppConfig(isPhone);
				this.props.setApiUrl(apiUrls.v1, apiUrls.v3);

				if (!this.props.selectedBookmaker && !isPhone) {
					this.props.setSelectedBookmaker("#BESTODDS");
				}

				this.props.setInitialized();
			}

			document.addEventListener("keydown", this.handleKeyboardEvent);
		}

		// componentDidUpdate() {
		//     // This feature currently causes 2 issues:
		//     // 1. "Accept and Cancel" via the CTA and the user gets stuck
		//     // 2. The bookmakers list can go off screen and the user cannot select
		//     // bookies if they are not on-screen
		//     const { isDrawerMinimized } = this.props
		//     if (isDrawerMinimized) {
		//         document.body.classList.remove('locked-scrolling')
		//     } else {
		//         document.body.classList.add('locked-scrolling')
		//     }
		// }

	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			document.removeEventListener("keydown", this.handleKeyboardEvent);
		}
	}, {
		key: "getLoggedInBookmakers",
		value: function getLoggedInBookmakers(isPhone) {
			var bookmakersList = this.props.bookmakersList;

			return bookmakersList.filter(function (_ref) {
				var availableOnPhone = _ref.availableOnPhone;
				return !isPhone || availableOnPhone;
			});
		}
	}, {
		key: "renderGlobalModal",
		value: function renderGlobalModal() {
			var _props = this.props,
			    clearGlobalModal = _props.clearGlobalModal,
			    globalModal = _props.globalModal;


			return globalModal !== null ? _jsx(_globalModal2.default, {
				visible: true,
				onAccept: clearGlobalModal,
				title: globalModal.title,
				body: globalModal.body,
				ctaTitle: globalModal.ctaTitle
			}) : null;
		}
	}, {
		key: "render",
		value: function render() {
			var _props2 = this.props,
			    selectedBookmakerFeed = _props2.selectedBookmakerFeed,
			    selectedBets = _props2.selectedBets,
			    betslipID = _props2.betslipID,
			    placedBetDetails = _props2.placedBetDetails,
			    isDrawerMinimized = _props2.isDrawerMinimized,
			    onMinimizeClick = _props2.onMinimizeClick,
			    theme = _props2.theme,
			    isUserLoggedIn = _props2.isUserLoggedIn,
			    userInfo = _props2.userInfo,
			    isQuickslipMode = _props2.isQuickslipMode,
			    resetEmptyBetslip = _props2.resetEmptyBetslip,
			    resetQuickslip = _props2.resetQuickslip,
			    feed = _props2.feed,
			    isBetPlacedSuccessfully = _props2.isBetPlacedSuccessfully,
			    clearPlacedBetDetails = _props2.clearPlacedBetDetails;


			var isEmptyBetslip = !isQuickslipMode && selectedBets.length === 0 && theme && theme !== "no-bookmaker";

			var isOpened = !!(isEmptyBetslip || selectedBets.length || placedBetDetails.bets.length !== 0);

			var shouldShowBetsBadge = isDrawerMinimized;
			var shouldBeFullScreen = !isQuickslipMode;
			var shortGamblingCompliance = (0, _gamblingCompliance.getShortGamblingCompliance)(feed);

			if (isOpened) {
				return _jsx(_colorSkinWrapper2.default, {
					bookmakerName: theme
				}, void 0, this.renderGlobalModal(), _jsx("div", {
					className: (0, _classnames2.default)("bs-drawer", "bs-verticalSlider", { "bs-verticalSlider_up": !isDrawerMinimized }, { "bs-verticalSlider_fullscreen": shouldBeFullScreen }),
					onTouchStart: this.preventZoom
				}, "drawer", shouldShowBetsBadge ? _jsx("div", {
					className: "bs-drawer__badge"
				}, void 0, selectedBets.length) : null, _jsx("div", {
					className: "bs-drawer__container"
				}, void 0, isQuickslipMode ? shortGamblingCompliance : null, _jsx(_transitionRouter2.default, {
					selectedBookmakerFeed: selectedBookmakerFeed,
					bookmakerName: theme,
					betslipID: betslipID,
					selectedBets: selectedBets,
					isUserLoggedIn: isUserLoggedIn,
					userInfo: userInfo,
					toggleBalanceVisibility: this.props.toggleBalanceVisibility,
					isDrawer: true,
					isDrawerMinimized: isDrawerMinimized,
					onMaximizeClick: this.onMaximizeClick,
					onMinimizeClick: onMinimizeClick,
					resetEmptyBetslip: resetEmptyBetslip,
					resetQuickslip: resetQuickslip,
					numberOfSelectedBets: selectedBets.length,
					isQuickslipMode: isQuickslipMode,
					isBetPlacedSuccessfully: isBetPlacedSuccessfully,
					clearPlacedBetDetails: clearPlacedBetDetails
				}, void 0, _ref2, _ref3, _ref4, _ref5, _ref6))), _jsx("div", {
					role: "button",
					tabIndex: 0,
					className: (0, _classnames2.default)("bs-overlay", { "bs-hidden": isDrawerMinimized })
				}), _jsx(_BodyScroll2.default, {
					isDrawerOpen: !isDrawerMinimized
				}));
			}

			return null;
		}
	}]);

	return Drawer;
}(_react.Component);

var betProps = _propTypes2.default.shape({
	price: _propTypes2.default.string,
	outcomersId: _propTypes2.default.string,
	eventId: _propTypes2.default.string,
	meetingId: _propTypes2.default.string,
	raceId: _propTypes2.default.string,
	raceDate: _propTypes2.default.string,
	horseName: _propTypes2.default.string,
	courseName: _propTypes2.default.string,
	raceTime: _propTypes2.default.string,
	eachWayFraction: _propTypes2.default.string,
	eachWayPlaces: _propTypes2.default.string,
	isBog: _propTypes2.default.string
});

Drawer.defaultProps = {
	isDrawerMinimized: false,
	selectedBets: [],
	betslipID: null,
	placedBetDetails: {
		freeBet: null,
		bets: []
	},
	theme: "no-bookie",
	isUserLoggedIn: false,
	globalModal: null,

	apiName: "",
	feed: ""
};

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(drawerSelectors.drawerBookmakerSelector);

var userInfoSelector = _userInfo.selectors.createUserInfoSelector(_bookmakersInfo.selectors.selectedBookmakerSelector);

var userIsLoggedInSelector = _bookmakersList.selectors.createIsLoggedInSelector(_bookmakersInfo.selectors.selectedBookmakerSelector);

var mapStateToProps = function mapStateToProps(state, props) {
	var _state$bookmakersInfo = state.bookmakersInfo,
	    selectedBets = _state$bookmakersInfo.selectedBets,
	    courseName = _state$bookmakersInfo.courseName,
	    selectedBookmaker = _state$bookmakersInfo.selectedBookmaker,
	    betslipID = _state$bookmakersInfo.betslipID,
	    _state$drawerInfo = state.drawerInfo,
	    isDrawerMinimized = _state$drawerInfo.isDrawerMinimized,
	    theme = _state$drawerInfo.theme,
	    isQuickslipMode = _state$drawerInfo.isQuickslipMode,
	    globalModal = state.modals.globalModal,
	    placedBetDetails = state.bet.placedBetDetails,
	    apiUrl = state.pageInfo.apiUrl,
	    bookmakersList = state.bookmakersList;


	return _extends({}, bookmakerInfoSelector(state), {
		apiUrl: apiUrl,
		selectedBookmakerFeed: selectedBookmaker,
		selectedBookmaker: selectedBookmaker,
		bookmakersList: bookmakersList,
		selectedBets: selectedBets,
		betslipID: betslipID,
		courseName: courseName,
		placedBetDetails: placedBetDetails,
		isBetPlacedSuccessfully: placedBetDetails.bets.length !== 0,
		isDrawerMinimized: isDrawerMinimized,
		theme: theme,
		isUserLoggedIn: userIsLoggedInSelector(state),
		userInfo: userInfoSelector(state, props),
		isQuickslipMode: isQuickslipMode,
		globalModal: globalModal
	});
};

var mapDispatchToProps = {
	toggleBalanceVisibility: _bookmakersInfo.actions.toggleBalanceVisibility,
	onMaximizeClick: drawerActions.maximizeDrawer,
	onMinimizeClick: drawerActions.minimizeDrawer,
	resetEmptyBetslip: drawerActions.resetEmptyBetslip,
	resetQuickslip: drawerActions.resetQuickslip,
	clearGlobalModal: _modals.actions.clearGlobalModal,
	getUserInfo: _bookmakersList.actions.getUserInfo,
	clearPlacedBetDetails: _bet.actions.clearPlacedBetDetails,
	initializeLoggedInBookmakers: _bookmakersList.actions.initializeLoggedInBookmakers,
	setDeviceType: _pageInfo.actions.setDeviceType,
	loadAppConfig: _pageInfo.actions.loadAppConfig,
	setApiUrl: _pageInfo.actions.setApiUrl,
	setSelectedBookmaker: _bookmakersInfo.actions.setSelectedBookmaker,
	setInitialized: eventsActions.setInitialized
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Drawer);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(8);

var _userInfo = __webpack_require__(11);

var _pageInfo = __webpack_require__(37);

var _bookmakersInfo = __webpack_require__(6);

var _modals = __webpack_require__(29);

var _drawer = __webpack_require__(38);

var drawerActions = _interopRequireWildcard(_drawer);

var _bet = __webpack_require__(20);

var _bookmakersList = __webpack_require__(5);

var _BetForm = __webpack_require__(542);

var _BetForm2 = _interopRequireDefault(_BetForm);

var _ActionBar = __webpack_require__(541);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _errorBanner = __webpack_require__(57);

var _errorBanner2 = _interopRequireDefault(_errorBanner);

var _expandPanel = __webpack_require__(513);

var _expandPanel2 = _interopRequireDefault(_expandPanel);

var _MultipleForm = __webpack_require__(547);

var _MultipleForm2 = _interopRequireDefault(_MultipleForm);

var _FTForm = __webpack_require__(546);

var _FTForm2 = _interopRequireDefault(_FTForm);

var _calculateStake = __webpack_require__(48);

var _multiplesReturns = __webpack_require__(220);

var _multiples = __webpack_require__(64);

var multipleTypes = _interopRequireWildcard(_multiples);

var _apiErrors = __webpack_require__(22);

var _gamblingCompliance = __webpack_require__(46);

var _FreeBetsContainer = __webpack_require__(223);

var _FreeBetsContainer2 = _interopRequireDefault(_FreeBetsContainer);

var _BlankErrorBoundary = __webpack_require__(590);

var _BlankErrorBoundary2 = _interopRequireDefault(_BlankErrorBoundary);

var _analyticsTracking = __webpack_require__(54);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

__webpack_require__(689);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var analytics = (0, _analyticsTracking.findAnalytics)();
var selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');

var _ref = _jsx('span', {
    className: 'bs-removeAll__label'
}, void 0, 'Bet Slip');

var _ref2 = _jsx('div', {
    className: 'bs-multiplesDescription__tickContainer'
}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'multiples-tick',
    size: 'Large',
    className: 'bs-multiplesDescription__tick'
}));

var _ref3 = _jsx(_reactRouterDom.Redirect, {
    to: '/bet-receipt'
});

var _ref4 = _jsx('div', {
    className: 'bs-drawer__empty'
}, void 0, _jsx('h2', {}, void 0, 'Your Bet Slip is Empty'), _jsx('span', {}, void 0, 'Please add one or more selections to place a bet.'));

var BetPage = exports.BetPage = function (_Component) {
    _inherits(BetPage, _Component);

    function BetPage(props) {
        _classCallCheck(this, BetPage);

        var _this = _possibleConstructorReturn(this, (BetPage.__proto__ || Object.getPrototypeOf(BetPage)).call(this, props));

        _this.onCloseClick = _this.onCloseClick.bind(_this);
        _this.onRemoveAll = _this.onRemoveAll.bind(_this);
        return _this;
    }

    _createClass(BetPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                isUserLoggedIn = _props.isUserLoggedIn,
                getUserInfo = _props.getUserInfo,
                apiName = _props.apiName,
                feed = _props.feed;


            if (isUserLoggedIn) {
                getUserInfo(apiName, feed);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props2 = this.props,
                genericError = _props2.genericError,
                clearGenericError = _props2.clearGenericError,
                userInfo = _props2.userInfo,
                selectedBets = _props2.selectedBets,
                multiples = _props2.multiples;


            var totalStake = (0, _calculateStake.calculateTotalStake)(selectedBets, multiples);

            if (genericError.errorId !== null && genericError.errorId === _apiErrors.ERROR_CODES.INSUFFICIENT_FUNDS && userInfo.balance > totalStake) {
                clearGenericError();
            }
        }
    }, {
        key: 'onCloseClick',
        value: function onCloseClick(outcomersId) {
            var _props3 = this.props,
                deleteBet = _props3.deleteBet,
                selectedBets = _props3.selectedBets,
                updateObstructions = _props3.updateObstructions,
                clearMultiples = _props3.clearMultiples,
                cancelBuildMultiples = _props3.cancelBuildMultiples,
                betslipID = _props3.betslipID;


            var errors = selectedBets.reduce(function (acc, bet) {
                if (bet.outcomersId !== outcomersId && bet.error.errorId !== null) {
                    acc.push(bet.error.errorId);
                }
                return acc;
            }, []);

            cancelBuildMultiples();
            clearMultiples();
            updateObstructions(errors);
            deleteBet(outcomersId);
            if (analytics) {
                (0, _analyticsTracking.logToAnalyticsRemoveSelectionClick)(betslipID, analytics);
            }
            document.dispatchEvent(selectionRemovedEvent);
        }
    }, {
        key: 'onRemoveAll',
        value: function onRemoveAll() {
            this.props.removeAllBets();
            if (analytics) {
                (0, _analyticsTracking.logToAnalyticsDiscardSlipButtonClick)(this.props.betslipID, analytics);
            }
            document.dispatchEvent(selectionRemovedEvent);
        }
    }, {
        key: 'renderActionBar',
        value: function renderActionBar() {
            var _props4 = this.props,
                userInfo = _props4.userInfo,
                selectedBets = _props4.selectedBets,
                isUserLoggedIn = _props4.isUserLoggedIn,
                feed = _props4.feed,
                minimizeQuickslip = _props4.minimizeQuickslip,
                isQuickslipMode = _props4.isQuickslipMode,
                genericError = _props4.genericError,
                multiples = _props4.multiples,
                numberOfFreeBets = _props4.numberOfFreeBets,
                freeBetsEnabled = _props4.freeBetsEnabled,
                freeBetIsSelected = _props4.freeBetIsSelected,
                freeBetAmount = _props4.freeBetAmount;


            var totalStake = (0, _calculateStake.calculateTotalStake)(selectedBets, multiples);
            var currencySign = userInfo.currencySign;


            return _jsx(_ActionBar2.default, {
                totalStake: totalStake,
                currencySign: currencySign,
                selectedBets: selectedBets,
                multiples: multiples,
                isUserLoggedIn: isUserLoggedIn,
                feed: feed,
                onAddToBetslip: minimizeQuickslip,
                isQuickslipMode: isQuickslipMode,
                genericError: genericError,
                numberOfFreeBets: numberOfFreeBets,
                freeBetsEnabled: freeBetsEnabled,
                freeBetIsSelected: freeBetIsSelected,
                freeBetAmount: freeBetAmount
            });
        }
    }, {
        key: 'renderRemoveBar',
        value: function renderRemoveBar() {
            var _props5 = this.props,
                isQuickslipMode = _props5.isQuickslipMode,
                isDrawerMinimized = _props5.isDrawerMinimized,
                selectedBets = _props5.selectedBets;


            if (isQuickslipMode || isDrawerMinimized) {
                return null;
            }

            return _jsx('div', {
                className: 'bs-removeAll'
            }, void 0, _jsx('div', {}, void 0, _ref, _jsx('span', {
                className: 'bs-removeAll__badge'
            }, void 0, selectedBets.length)), selectedBets.length > 1 ? _jsx('button', {
                className: 'bs-removeAll__button',
                onClick: this.onRemoveAll
            }, void 0, 'Remove All') : null);
        }
    }, {
        key: 'renderBetForms',
        value: function renderBetForms(selectedBets) {
            var _this2 = this;

            var _props6 = this.props,
                isUserLoggedIn = _props6.isUserLoggedIn,
                currencySign = _props6.userInfo.currencySign,
                isPlacingBet = _props6.isPlacingBet,
                setStake = _props6.setStake,
                setIsEachWay = _props6.setIsEachWay,
                setPriceType = _props6.setPriceType,
                name = _props6.name,
                isMobile = _props6.isMobile,
                useDecimalOdds = _props6.useDecimalOdds,
                setIsEditingStake = _props6.setIsEditingStake,
                isQuickslipMode = _props6.isQuickslipMode,
                clearError = _props6.clearError,
                setErrorOnBuild = _props6.setErrorOnBuild,
                setGlobalModal = _props6.setGlobalModal,
                toggleMultiplesInclusion = _props6.toggleMultiplesInclusion,
                freeBetIsSelected = _props6.freeBetIsSelected,
                betslipID = _props6.betslipID;


            return selectedBets.map(function (bet) {
                return _react2.default.createElement(_BetForm2.default, _extends({
                    key: 'bet-form-' + bet.outcomersId,
                    className: (0, _classnames2.default)({
                        'bs-betForm__placing-bet': isPlacingBet
                    }),
                    currencySign: currencySign
                }, bet, {
                    useDecimalOdds: useDecimalOdds,
                    stakeValue: bet.stake,
                    isEachWay: bet.isEachWay,
                    isUserLoggedIn: isUserLoggedIn,
                    feed: bet.feed,
                    setStake: setStake,
                    setIsEachWay: setIsEachWay,
                    setPriceType: setPriceType,
                    onCloseClick: _this2.onCloseClick,
                    bookmakerName: name,
                    isMobile: isMobile,
                    numberOfBets: selectedBets.length,
                    isEditingStake: bet.isEditingStake,
                    setIsEditingStake: setIsEditingStake,
                    isQuickslipMode: isQuickslipMode,
                    isSuspended: bet.isSuspended,
                    associatedBet: bet.associatedBet,
                    clearError: clearError,
                    setErrorOnBuild: setErrorOnBuild,
                    setGlobalModal: setGlobalModal,
                    toggleMultiplesInclusion: toggleMultiplesInclusion,
                    freezeStake: bet.isLockedStake,
                    freeBetIsSelected: freeBetIsSelected,
                    betslipID: betslipID
                }));
            });
        }
    }, {
        key: 'renderFreeBets',
        value: function renderFreeBets() {
            var _props7 = this.props,
                isUserLoggedIn = _props7.isUserLoggedIn,
                selectedBets = _props7.selectedBets,
                numberOfFreeBets = _props7.numberOfFreeBets,
                currencySign = _props7.userInfo.currencySign;


            var FREEBETS_HEIGHT = 72;

            return !isUserLoggedIn || selectedBets.length !== 1 || numberOfFreeBets === 0 ? null : _jsx(_expandPanel2.default, {
                title: 'Free Bets',
                expandHeight: FREEBETS_HEIGHT
            }, void 0, _jsx(_FreeBetsContainer2.default, {
                currencySign: currencySign
            }));
        }
    }, {
        key: 'renderMultiples',
        value: function renderMultiples() {
            var _props8 = this.props,
                multiples = _props8.multiples,
                setGlobalModal = _props8.setGlobalModal,
                setStakeForMultiple = _props8.setStakeForMultiple,
                setIsEachWayForMultiple = _props8.setIsEachWayForMultiple,
                setIsEditingStakeForMultiple = _props8.setIsEditingStakeForMultiple,
                isMobile = _props8.isMobile,
                isQuickslipMode = _props8.isQuickslipMode,
                currencySign = _props8.userInfo.currencySign,
                selectedBets = _props8.selectedBets,
                isBuildingMultiples = _props8.isBuildingMultiples,
                setMultiplesError = _props8.setMultiplesError,
                clearMultiplesError = _props8.clearMultiplesError;


            var nonForecastMultiples = multiples.filter(function (multiple) {
                return !(0, _multiplesReturns.isForecastMultiple)(multiple.betType);
            });

            var errors = nonForecastMultiples.filter(function (multiple) {
                return multiple.error.message !== null;
            });

            var isKeypadExpanded = nonForecastMultiples.some(function (multiple) {
                return isMobile && multiple.isEditingStake === true;
            });

            var KEYPAD_HEIGHT = 88;
            var ERROR_HEIGHT = 34;
            var MULTIPLE_FORM_HEIGHT = 121;

            // Height of multiple forms...
            var expandHeight = nonForecastMultiples.length * MULTIPLE_FORM_HEIGHT;
            // Add height of the open errors...
            expandHeight += errors.length * ERROR_HEIGHT;
            // Add open keypad height...
            expandHeight += isKeypadExpanded ? KEYPAD_HEIGHT : 0;

            return !isQuickslipMode ? _jsx(_expandPanel2.default, {
                title: 'Multiples',
                isLoading: isBuildingMultiples,
                expandHeight: expandHeight
            }, void 0, nonForecastMultiples.map(function (multiple) {
                return _jsx(_MultipleForm2.default, {
                    setIsEachWayForMultiple: setIsEachWayForMultiple,
                    setIsEditingStake: setIsEditingStakeForMultiple,
                    setGlobalModal: setGlobalModal,
                    setStake: setStakeForMultiple,
                    currencySign: currencySign,
                    selectedBets: selectedBets,
                    isMobile: isMobile,
                    error: multiple.error,
                    betType: multiple.betType,
                    optionId: multiple.optionId,
                    isEachWay: multiple.isEachWay,
                    stakeValue: multiple.stakeValue,
                    numberLines: multiple.numberLines,
                    betSelections: multiple.betSelections,
                    isEditingStake: multiple.isEditingStake,
                    setMultiplesError: setMultiplesError,
                    clearMultiplesError: clearMultiplesError,
                    minStake: multiple.minStake,
                    maxStake: multiple.maxStake
                }, 'bs-multipleForm' + multiple.optionId);
            })) : null;
        }
    }, {
        key: 'renderForecastTricast',
        value: function renderForecastTricast() {
            var _props9 = this.props,
                setGlobalModal = _props9.setGlobalModal,
                multiples = _props9.multiples,
                selectedBets = _props9.selectedBets,
                changeSelectionOrder = _props9.changeSelectionOrder,
                currencySign = _props9.userInfo.currencySign,
                isMobile = _props9.isMobile,
                apiName = _props9.apiName,
                setStakeForMultiple = _props9.setStakeForMultiple,
                setIsEditingStakeForMultiple = _props9.setIsEditingStakeForMultiple,
                setMultiplesError = _props9.setMultiplesError,
                clearMultiplesError = _props9.clearMultiplesError,
                isBuildingMultiples = _props9.isBuildingMultiples;

            var forecastGroups = {};
            var forecastMultiples = multiples.filter(function (multiple) {
                return (0, _multiplesReturns.isForecastMultiple)(multiple.betType);
            });
            var errors = forecastMultiples.filter(function (multiple) {
                return multiple.error.message !== null;
            });
            var keyboardDisplayed = forecastMultiples.filter(function (multiple) {
                return isMobile && multiple.isEditingStake;
            }).length > 0;
            var panelHeight = 0;

            if (forecastMultiples.length > 0) {
                forecastMultiples.forEach(function (multiple) {
                    var eventId = multiple.betSelections.length > 0 ? multiple.betSelections[0].eventId + '-' + multiple.betSelections[0].marketId : '';
                    var groupIsNew = !(eventId in forecastGroups);
                    var order = multiple.betSelections.map(function (bet) {
                        return bet.selectionId;
                    });
                    var eventSelections = selectedBets.filter(function (selection) {
                        return selection.eventId + '-' + selection.meetingId === eventId;
                    });

                    var orderedSelections = [];

                    var _loop = function _loop(i) {
                        var bet = eventSelections.find(function (selection) {
                            return selection.outcomersId === order[i];
                        });
                        if (bet !== undefined) {
                            orderedSelections.push(bet);
                        }
                    };

                    for (var i = 0; i < order.length; i += 1) {
                        _loop(i);
                    }

                    if (groupIsNew) {
                        forecastGroups[eventId] = {
                            selections: [],
                            options: []
                        };
                    }

                    switch (apiName) {
                        case 'williamhill':
                            {
                                var duplicates = forecastGroups[eventId].options.filter(function (option) {
                                    return option.betType === multiple.betType;
                                });
                                if (duplicates.length === 0) {
                                    forecastGroups[eventId].selections = orderedSelections;
                                    forecastGroups[eventId].options.push(multiple);
                                }
                                break;
                            }
                        default:
                            {
                                forecastGroups[eventId].selections = orderedSelections;
                                forecastGroups[eventId].options.push(multiple);
                            }
                    }
                });

                Object.keys(forecastGroups).forEach(function (key) {
                    if (forecastGroups[key].selections.length > 0) {
                        if (forecastGroups[key].selections.length > 3) {
                            panelHeight += 89;
                        } else {
                            panelHeight += forecastGroups[key].selections.length * 49 + 40;
                        }
                    }
                    if (forecastGroups[key].options.length > 0) {
                        panelHeight += forecastGroups[key].options.length * 64 + 4;
                    }
                    panelHeight += 8;
                });

                panelHeight += errors.length * 30;

                if (keyboardDisplayed) {
                    panelHeight += 84;
                }

                return _jsx(_expandPanel2.default, {
                    title: 'Forecast & Tricast',
                    isLoading: isBuildingMultiples,
                    expandHeight: panelHeight
                }, void 0, _jsx(_FTForm2.default, {
                    setGlobalModal: setGlobalModal,
                    groups: forecastGroups,
                    isMobile: isMobile,
                    currencySign: currencySign,
                    changeSelectionOrder: changeSelectionOrder,
                    setStake: setStakeForMultiple,
                    setIsEditingStake: setIsEditingStakeForMultiple,
                    setMultiplesError: setMultiplesError,
                    clearMultiplesError: clearMultiplesError
                }));
            }

            return null;
        }
    }, {
        key: 'renderMulpiplesDescription',
        value: function renderMulpiplesDescription() {
            var multiples = this.props.multiples;


            var hasForcastTricast = multiples.find(function (bet) {
                return multipleTypes.forecastMultiples.indexOf(bet.betType) > -1;
            });

            var multipleDescriptionText = hasForcastTricast ? 'Ticked selections are included in multiple bets and fore/tricasts' : 'Ticked selections are included in multiple bets';

            return _jsx('div', {
                className: 'bs-multiplesDescription'
            }, void 0, _ref2, _jsx('div', {
                className: 'bs-multiplesDescription__text'
            }, void 0, multipleDescriptionText));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props10 = this.props,
                selectedBets = _props10.selectedBets,
                isPlacingBet = _props10.isPlacingBet,
                isBetPlacedSuccessfully = _props10.isBetPlacedSuccessfully,
                isQuickslipMode = _props10.isQuickslipMode,
                genericError = _props10.genericError,
                feed = _props10.feed,
                freeBetsEnabled = _props10.freeBetsEnabled;


            if (isBetPlacedSuccessfully) {
                return _ref3;
            }

            if (selectedBets.length === 0 && !isQuickslipMode) {
                return _jsx('div', {
                    className: 'bs-horizontalSlider__element'
                }, void 0, _jsx('div', {
                    className: 'bs-drawer__content'
                }, void 0, this.renderRemoveBar(), _ref4));
            }

            var errorBanner = isQuickslipMode && genericError.errorId !== null ? _jsx(_errorBanner2.default, {
                message: genericError.message
            }) : null;

            var shortGamblingCompliance = (0, _gamblingCompliance.getShortGamblingCompliance)(feed);

            var freeBets = !isQuickslipMode && freeBetsEnabled ? this.renderFreeBets() : null;

            return _jsx('div', {
                className: 'bs-horizontalSlider__element'
            }, void 0, _jsx('div', {
                className: (0, _classnames2.default)({
                    'bs-drawer__content': true,
                    'bs-betPage__placing-bet': isPlacingBet
                })
            }, void 0, _jsx('div', {
                className: 'bs-drawer__scrollable'
            }, void 0, this.renderRemoveBar(), errorBanner, this.renderBetForms(selectedBets), this.renderMulpiplesDescription(), _jsx(_BlankErrorBoundary2.default, {}, void 0, this.renderMultiples()), _jsx(_BlankErrorBoundary2.default, {}, void 0, this.renderForecastTricast()), _jsx(_BlankErrorBoundary2.default, {}, void 0, freeBets), this.renderActionBar(), !isQuickslipMode ? shortGamblingCompliance : null)));
        }
    }]);

    return BetPage;
}(_react.Component);

BetPage.defaultProps = {
    isUserLoggedIn: false,
    selectedBets: [],
    betslipID: null,
    multiples: [],
    topUpBookmakerUrl: '',
    feed: '',
    apiName: '',
    name: '',
    isTopUpIntegrated: false,
    genericError: {
        errorId: null,
        message: null
    },
    freeBetsEnabled: false,
    freeBetAmount: null
};

var userInfoSelector = _userInfo.selectors.createUserInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector);
var userIsLoggedInSelector = _bookmakersList.selectors.createIsLoggedInSelector(_bookmakersInfo.selectors.betBookmakerSelector);
var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    var _state$bookmakersInfo = state.bookmakersInfo,
        selectedBets = _state$bookmakersInfo.selectedBets,
        multiples = _state$bookmakersInfo.multiples,
        genericError = _state$bookmakersInfo.genericError,
        isBuildingMultiples = _state$bookmakersInfo.isBuildingMultiples,
        betslipID = _state$bookmakersInfo.betslipID;
    var _state$bet = state.bet,
        isPlacingBet = _state$bet.isPlacingBet,
        placedBetDetails = _state$bet.placedBetDetails,
        obstruction = _state$bet.obstruction;
    var _state$freeBets = state.freeBets,
        list = _state$freeBets.list,
        selectedFreeBet = _state$freeBets.selectedFreeBet;

    var selectedFreeBetItem = selectedFreeBet ? list.find(function (freeBet) {
        return freeBet.id === selectedFreeBet;
    }) : null;
    var freeBetAmount = selectedFreeBetItem ? selectedFreeBetItem.amount : null;

    var isMobile = state.pageInfo.isPhone || state.pageInfo.isTablet;

    return _extends({}, bookmakerInfoSelector(state, props), {
        obstruction: obstruction,
        isPlacingBet: isPlacingBet,
        isBuildingMultiples: isBuildingMultiples,
        isMobile: isMobile,
        betslipID: betslipID,
        isBetPlacedSuccessfully: placedBetDetails.bets.length !== 0,
        feed: _bookmakersInfo.selectors.betBookmakerSelector(state),
        isUserLoggedIn: userIsLoggedInSelector(state),
        userInfo: userInfoSelector(state, props),
        useDecimalOdds: _pageInfo.selectors.useDecimalOddsSelector(state),
        selectedBets: selectedBets,
        multiples: multiples,
        genericError: genericError,
        isQuickslipMode: state.drawerInfo.isQuickslipMode,
        isDrawerMinimized: state.drawerInfo.isDrawerMinimized,
        numberOfFreeBets: list.length,
        freeBetIsSelected: !!selectedFreeBet,
        freeBetAmount: freeBetAmount
    });
};

var mapDispatchToProps = {
    clearPlacedBetDetails: _bet.actions.clearPlacedBetDetails,
    deleteBet: _bookmakersInfo.actions.deleteBet,
    setStake: _bookmakersInfo.actions.setStakeForSelectedBet,
    setIsEachWay: _bookmakersInfo.actions.setIsEachWayForSelectedBet,

    setStakeForMultiple: _bookmakersInfo.actions.setStakeForMultiple,
    changeSelectionOrder: _bookmakersInfo.actions.changeSelectionOrder,
    setIsEachWayForMultiple: _bookmakersInfo.actions.setIsEachWayForMultiple,
    setIsEditingStakeForMultiple: _bookmakersInfo.actions.setIsEditingStakeForMultiple,

    setPriceType: _bookmakersInfo.actions.setPriceTypeForSelectedBet,
    getUserInfo: _bookmakersList.actions.getUserInfo,
    onMinimizeClick: drawerActions.minimizeDrawer,
    setQuickslipMode: drawerActions.setQuickslipMode,
    setIsEditingStake: _bookmakersInfo.actions.setIsEditingStake,

    minimizeQuickslip: drawerActions.minimizeQuickslip,
    removeAllBets: _bookmakersInfo.actions.removeAllBets,
    setBetObstruction: _bet.actions.setBetObstruction,
    clearGenericError: _bookmakersInfo.actions.clearGenericError,
    clearError: _bookmakersInfo.actions.clearError,
    setErrorOnBuild: _bookmakersInfo.actions.setErrorOnBuild,
    setGlobalModal: _modals.actions.setGlobalModal,
    updateObstructions: _bet.actions.updateObstructions,
    toggleMultiplesInclusion: _bookmakersInfo.actions.toggleMultiplesInclusion,
    clearMultiples: _bookmakersInfo.actions.clearMultiples,
    cancelBuildMultiples: _bookmakersInfo.actions.cancelBuildMultiples,
    setMultiplesError: _bookmakersInfo.actions.setMultiplesError,
    clearMultiplesError: _bookmakersInfo.actions.clearMultiplesError
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BetPage);

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ActionBar = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _CTA = __webpack_require__(540);

var _CTA2 = _interopRequireDefault(_CTA);

var _estimatedReturn = __webpack_require__(88);

var _calculateStake = __webpack_require__(48);

var _errorBanner = __webpack_require__(57);

var _errorBanner2 = _interopRequireDefault(_errorBanner);

var _deposit = __webpack_require__(211);

var _deposit2 = _interopRequireDefault(_deposit);

var _apiErrors = __webpack_require__(22);

var _FreeBetsContainer = __webpack_require__(223);

var _FreeBetsContainer2 = _interopRequireDefault(_FreeBetsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('span', {}, void 0, 'Add to Bet Slip');

var _ref2 = _jsx('span', {
    className: 'bs-betForm__moneyBreakdownLabel'
}, void 0, 'Your Money');

var _ref3 = _jsx('span', {
    className: 'bs-betForm__moneyBreakdownLabel'
}, void 0, 'Free Bet Used');

var _ref4 = _jsx('span', {
    className: 'bs-betForm__totalStakeLabel'
}, void 0, 'Total Stake');

var _ref5 = _jsx('span', {
    className: 'bs-betForm__totalStakeLabel'
}, void 0, 'Estimated Returns');

var _ref6 = _jsx(_CTA2.default, {});

var ActionBar = exports.ActionBar = function (_Component) {
    _inherits(ActionBar, _Component);

    function ActionBar() {
        _classCallCheck(this, ActionBar);

        return _possibleConstructorReturn(this, (ActionBar.__proto__ || Object.getPrototypeOf(ActionBar)).apply(this, arguments));
    }

    _createClass(ActionBar, [{
        key: 'renderFreeBets',
        value: function renderFreeBets() {
            var _props = this.props,
                isUserLoggedIn = _props.isUserLoggedIn,
                selectedBets = _props.selectedBets,
                numberOfFreeBets = _props.numberOfFreeBets,
                currencySign = _props.currencySign,
                freeBetsEnabled = _props.freeBetsEnabled;


            return !isUserLoggedIn || selectedBets.length !== 1 || numberOfFreeBets === 0 || !freeBetsEnabled ? null : _jsx(_FreeBetsContainer2.default, {
                currencySign: currencySign
            });
        }
    }, {
        key: 'renderLeftSide',
        value: function renderLeftSide() {
            var _props2 = this.props,
                isQuickslipMode = _props2.isQuickslipMode,
                onAddToBetslip = _props2.onAddToBetslip,
                isUserLoggedIn = _props2.isUserLoggedIn,
                feed = _props2.feed,
                selectedBets = _props2.selectedBets;


            if (isQuickslipMode && selectedBets[0] && selectedBets[0].error.errorId === _apiErrors.ERROR_CODES.BETTING_SUSPENDED) {
                return null;
            }

            if (!isQuickslipMode) {
                return _jsx(_deposit2.default, {
                    isUserLoggedIn: isUserLoggedIn,
                    feed: feed,
                    className: 'bs-actionBar__small'
                });
            }

            return _jsx('button', {
                className: 'bs-btn\n                    bs-btn_default\n                    bs-actionBar__button\n                    bs-actionBar__half',
                type: 'submit',
                onClick: onAddToBetslip
            }, void 0, _ref);
        }
    }, {
        key: 'renderMoneyBreakdown',
        value: function renderMoneyBreakdown() {
            var _props3 = this.props,
                selectedBets = _props3.selectedBets,
                freeBetAmount = _props3.freeBetAmount,
                currencySign = _props3.currencySign;


            var bet = selectedBets[0];
            var stake = parseFloat(bet.stake, 10);

            // Do not render the breakdown if no stake is input
            if (isNaN(stake)) {
                return null;
            }

            var _calculateMoneyBreakd = (0, _calculateStake.calculateMoneyBreakdown)(stake, bet, freeBetAmount),
                userStake = _calculateMoneyBreakd.userStake,
                freeStake = _calculateMoneyBreakd.freeStake;

            var userStakeText = '' + currencySign + userStake.toFixed(2);
            var freeStakeText = '' + currencySign + freeStake.toFixed(2);

            return _jsx('div', {
                className: 'bs-betForm__moneyBreakdown'
            }, void 0, _jsx('div', {
                className: 'bs-betForm__moneyBreakdownLine'
            }, void 0, _ref2, _jsx('span', {
                className: 'bs-betForm__moneyBreakdownValue'
            }, void 0, userStakeText)), _jsx('div', {
                className: 'bs-betForm__moneyBreakdownLine'
            }, void 0, _ref3, _jsx('span', {
                className: 'bs-betForm__moneyBreakdownValue'
            }, void 0, freeStakeText)));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                totalStake = _props4.totalStake,
                currencySign = _props4.currencySign,
                className = _props4.className,
                selectedBets = _props4.selectedBets,
                multiples = _props4.multiples,
                genericError = _props4.genericError,
                isQuickslipMode = _props4.isQuickslipMode,
                freeBetIsSelected = _props4.freeBetIsSelected,
                freeBetAmount = _props4.freeBetAmount;

            var parsedStake = parseFloat(totalStake);
            var stakeText = '' + currencySign + parsedStake.toFixed(2);
            var errorBanner = !isQuickslipMode && genericError.errorId !== null ? _jsx(_errorBanner2.default, {
                message: genericError.message
            }) : null;
            var freeBets = isQuickslipMode ? this.renderFreeBets() : null;
            var moneyBreakdown = freeBetIsSelected ? this.renderMoneyBreakdown() : null;

            return _jsx('div', {
                className: (0, _classnames2.default)('bs-drawer__actionBar', className)
            }, void 0, errorBanner, freeBets, moneyBreakdown, _jsx('div', {
                className: 'bs-betForm__totalStake'
            }, void 0, _jsx('div', {
                className: 'bs-betForm__totalStakeLine bs-betForm__totalStakeLine_stake'
            }, void 0, _ref4, _jsx('span', {
                className: 'bs-betForm__totalStakeValue'
            }, void 0, stakeText)), _jsx('div', {
                className: 'bs-betForm__totalStakeLine bs-betForm__totalStakeLine_returns'
            }, void 0, _ref5, _jsx('span', {
                className: 'bs-betForm__estimatedReturnsValue'
            }, void 0, (0, _estimatedReturn.getTotalEstimatedReturnText)(selectedBets, multiples, currencySign, freeBetIsSelected, freeBetAmount)))), _jsx('div', {
                className: 'bs-actionBar bs-betForm__actionBar bs-section'
            }, void 0, this.renderLeftSide(), _ref6));
        }
    }]);

    return ActionBar;
}(_react.Component);

ActionBar.defaultProps = {
    selectedBets: [],
    multiples: [],
    className: '',
    totalStake: '0.00',
    genericError: {
        message: null,
        errorId: null
    },
    freeBetAmount: null
};

exports.default = ActionBar;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CTA = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _titles;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(8);

var _reactRedux = __webpack_require__(4);

var _cssSpinner = __webpack_require__(210);

var _cssSpinner2 = _interopRequireDefault(_cssSpinner);

var _apiErrors = __webpack_require__(22);

var _deposit = __webpack_require__(211);

var _deposit2 = _interopRequireDefault(_deposit);

var _bet = __webpack_require__(20);

var _freeBets = __webpack_require__(35);

var _userInfo = __webpack_require__(11);

var _bookmakersInfo = __webpack_require__(6);

var _bookmakersList = __webpack_require__(5);

var _modalMessages = __webpack_require__(125);

var _modals = __webpack_require__(29);

__webpack_require__(682);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var betObstructions = _bet.actions.betObstructions;


var titles = (_titles = {}, _defineProperty(_titles, betObstructions.REMOVE, {
    quickslip: 'Accept and Cancel',
    betslip: 'Remove Suspended'
}), _defineProperty(_titles, betObstructions.ACCEPT, {
    quickslip: 'Accept',
    betslip: 'Accept'
}), _defineProperty(_titles, betObstructions.ACCEPT_AND_REMOVE, {
    quickslip: 'Accept & Remove',
    betslip: 'Accept & Remove'
}), _titles);

var _ref = _jsx('span', {
    className: 'bs-betForm__buttonLine'
}, void 0, 'Place Bet');

var _ref2 = _jsx('span', {
    className: 'bs-betForm__buttonLine'
}, void 0, 'Place Bet');

var _ref3 = _jsx('div', {
    className: 'bs-btn bs-cta'
}, void 0, _jsx(_cssSpinner2.default, {}));

var CTA = exports.CTA = function (_Component) {
    _inherits(CTA, _Component);

    function CTA() {
        _classCallCheck(this, CTA);

        var _this = _possibleConstructorReturn(this, (CTA.__proto__ || Object.getPrototypeOf(CTA)).call(this));

        _this.placeBet = function () {
            var _this$props = _this.props,
                bookmakerApiName = _this$props.bookmakerApiName,
                selectedBets = _this$props.selectedBets,
                getUserInfo = _this$props.getUserInfo,
                feed = _this$props.feed,
                placeBet = _this$props.placeBet,
                clearFreeBets = _this$props.clearFreeBets,
                userInfo = _this$props.userInfo,
                setIsPlaceBetRequesting = _this$props.setIsPlaceBetRequesting,
                multiples = _this$props.multiples,
                buildBetRequest = _this$props.buildBetRequest,
                buildBets = _this$props.buildBets,
                setGlobalModal = _this$props.setGlobalModal,
                isExternalLogout = _this$props.isExternalLogout,
                selectedFreeBet = _this$props.selectedFreeBet;


            var doPlaceBet = function doPlaceBet() {
                return placeBet(bookmakerApiName, selectedBets, multiples, selectedFreeBet, feed, userInfo.currencySign, isExternalLogout).then(function () {
                    // Stop the spinner, clear free bets
                    setIsPlaceBetRequesting(false);
                    clearFreeBets(feed);

                    // Get the user's new balance and free bets
                    // Plus, log the user out if something fails here (very basic strategy).
                    var promises = [];
                    promises.push(getUserInfo(bookmakerApiName, feed));
                    Promise.all(promises)
                    // Do nothing, as the user can still bet
                    // This could also be resolved at the next attempt elsewhere
                    .catch();
                }).catch(function () {
                    // Placement did not succeed, errors will have been handled inside the action
                    // But - we should now stop the spinner
                    setIsPlaceBetRequesting(false);
                });
            };

            var unbuiltBets = selectedBets.filter(function (bet) {
                return !bet.associatedBet || Object.keys(bet.associatedBet).length === 0;
            });

            // If we detect bets that have no `associatedBets`,
            // we cannot correctly place, so a build bet is neccessary.
            // This could occur if the user clicks quickly, or a previous build-bets
            // call failed. This is an automated re-try. See README for more info.
            if (unbuiltBets.length > 0) {
                buildBetRequest(true);
                return buildBets(bookmakerApiName, selectedBets, feed).then(doPlaceBet) // Automatically proceed if bets are built
                .catch(function () {
                    // Otherwise, user must manually try again
                    // We also throw the global modal at this stage
                    setIsPlaceBetRequesting(false);
                    setGlobalModal(_modalMessages.GENERIC_ERROR);
                });
            }

            return doPlaceBet();
        };

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.renderLogin = _this.renderLogin.bind(_this);
        _this.getCTATitle = _this.getCTATitle.bind(_this);
        return _this;
    }

    _createClass(CTA, [{
        key: 'onSubmit',
        value: function onSubmit() {
            var _props = this.props,
                obstruction = _props.obstruction,
                setBetObstruction = _props.setBetObstruction,
                clearSuspendedBets = _props.clearSuspendedBets,
                updateAllBetPrices = _props.updateAllBetPrices,
                updateAllStartingPricesAvailability = _props.updateAllStartingPricesAvailability,
                clearAllErrors = _props.clearAllErrors,
                clearAllMultiplesErrors = _props.clearAllMultiplesErrors,
                clearMultiples = _props.clearMultiples;


            switch (obstruction) {
                case betObstructions.REMOVE:

                    clearSuspendedBets();
                    clearAllErrors();
                    setBetObstruction(betObstructions.NONE);
                    clearMultiples();

                    break;
                case betObstructions.ACCEPT:

                    updateAllBetPrices();
                    updateAllStartingPricesAvailability();
                    clearAllErrors();
                    clearAllMultiplesErrors();
                    setBetObstruction(betObstructions.NONE);

                    break;

                case betObstructions.ACCEPT_AND_REMOVE:

                    updateAllStartingPricesAvailability();
                    clearSuspendedBets();
                    updateAllBetPrices();
                    clearAllErrors();
                    setBetObstruction(betObstructions.NONE);
                    clearMultiples();

                    break;
                default:
                    this.placeBet();
            }
        }
    }, {
        key: 'getCTATitle',
        value: function getCTATitle() {
            var _props2 = this.props,
                isQuickslipMode = _props2.isQuickslipMode,
                obstruction = _props2.obstruction;


            var mode = isQuickslipMode ? 'quickslip' : 'betslip';
            return titles[obstruction][mode];
        }
    }, {
        key: 'renderLogin',
        value: function renderLogin() {
            var feed = this.props.feed;


            return _jsx(_reactRouterDom.Link, {
                to: '/' + feed + '/login',
                className: 'bs-btn bs-cta'
            }, void 0, _ref);
        }
    }, {
        key: 'renderPlaceBet',
        value: function renderPlaceBet() {
            var obstruction = this.props.obstruction;


            if (obstruction === betObstructions.NONE) {
                return _jsx('button', {
                    className: 'bs-btn bs-cta',
                    type: 'submit',
                    onClick: this.onSubmit
                }, void 0, _ref2);
            }
            return _jsx('button', {
                className: 'bs-btn bs-cta bs-cta_action',
                type: 'submit',
                onClick: this.onSubmit
            }, void 0, _jsx('span', {
                className: 'bs-cta__buttonLine'
            }, void 0, this.getCTATitle()));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                isLoading = _props3.isLoading,
                isUserLoggedIn = _props3.isUserLoggedIn,
                feed = _props3.feed,
                genericError = _props3.genericError,
                isQuickslipMode = _props3.isQuickslipMode;


            if (isQuickslipMode && genericError.errorId === _apiErrors.ERROR_CODES.INSUFFICIENT_FUNDS) {
                return _jsx(_deposit2.default, {
                    isUserLoggedIn: isUserLoggedIn,
                    feed: feed,
                    className: 'bs-btn bs-cta'
                });
            }

            if (isLoading) {
                return _ref3;
            }

            if (isUserLoggedIn) {
                return this.renderPlaceBet();
            }

            return this.renderLogin();
        }
    }]);

    return CTA;
}(_react.Component);

CTA.defaultProps = {
    isLoading: false,
    isUserLoggedIn: false,
    feed: '',
    selectedBets: [],
    multiples: [],
    userInfo: {},
    genericError: {
        message: null,
        errorId: null
    },
    isExternalLogout: false,
    selectedFreeBet: null
};

var userInfoSelector = _userInfo.selectors.createUserInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector);

var userIsLoggedInSelector = _bookmakersList.selectors.createIsLoggedInSelector(_bookmakersInfo.selectors.betBookmakerSelector);

var bookmakerApiNameSelector = _bookmakersList.selectors.createBookmakerApiNameSelector(_bookmakersInfo.selectors.betBookmakerSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    var _state$bookmakersInfo = state.bookmakersInfo,
        isBuildingBet = _state$bookmakersInfo.isBuildingBet,
        selectedBets = _state$bookmakersInfo.selectedBets,
        multiples = _state$bookmakersInfo.multiples,
        genericError = _state$bookmakersInfo.genericError,
        isBuildingMultiples = _state$bookmakersInfo.isBuildingMultiples,
        selectedBookmaker = _state$bookmakersInfo.selectedBookmaker;
    var _state$bet = state.bet,
        isPlacingBet = _state$bet.isPlacingBet,
        obstruction = _state$bet.obstruction;
    var isQuickslipMode = state.drawerInfo.isQuickslipMode;

    var bookmaker = state.bookmakersList.find(function (bookie) {
        return bookie.feed === selectedBookmaker;
    });
    var selectedFreeBet = state.freeBets.list.find(function (freeBet) {
        return freeBet.id === state.freeBets.selectedFreeBet;
    });

    return {
        isLoading: isPlacingBet || isBuildingBet || isBuildingMultiples,
        obstruction: obstruction,
        selectedBets: selectedBets,
        multiples: multiples,
        isUserLoggedIn: userIsLoggedInSelector(state),
        feed: _bookmakersInfo.selectors.betBookmakerSelector(state),
        bookmakerApiName: bookmakerApiNameSelector(state),
        userInfo: userInfoSelector(state, props),
        isQuickslipMode: isQuickslipMode,
        genericError: genericError,
        isExternalLogout: !!(bookmaker && bookmaker.isExternalLogout),
        selectedFreeBet: selectedFreeBet
    };
};

var mapDispatchToProps = {
    clearSelectedBets: _bookmakersInfo.actions.clearSelectedBets,
    clearSuspendedBets: _bookmakersInfo.actions.clearSuspendedBets,
    updateAllStartingPricesAvailability: _bookmakersInfo.actions.updateAllStartingPricesAvailability,
    updateAllBetPrices: _bookmakersInfo.actions.updateAllBetPrices,
    setBetObstruction: _bet.actions.setBetObstruction,
    placeBet: _bet.actions.placeBet,
    getUserInfo: _bookmakersList.actions.getUserInfo,
    clearFreeBets: _freeBets.actions.clearFreeBets,
    setIsPlaceBetRequesting: _bet.actions.placeBetRequest,
    clearAllErrors: _bookmakersInfo.actions.clearAllErrors,
    buildBetRequest: _bookmakersInfo.actions.buildBetRequest,
    buildBets: _bookmakersInfo.actions.buildBets,
    setGlobalModal: _modals.actions.setGlobalModal,
    clearMultiples: _bookmakersInfo.actions.clearMultiples,
    clearAllMultiplesErrors: _bookmakersInfo.actions.clearAllMultiplesErrors
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CTA);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(110);

var _lodash2 = _interopRequireDefault(_lodash);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _formFormatters = __webpack_require__(130);

var _formFormatters2 = _interopRequireDefault(_formFormatters);

var _bestOddsGuaranteed = __webpack_require__(202);

var _bestOddsGuaranteed2 = _interopRequireDefault(_bestOddsGuaranteed);

var _formatDecimalPrice = __webpack_require__(131);

var _formatDecimalPrice2 = _interopRequireDefault(_formatDecimalPrice);

var _QuickStake = __webpack_require__(635);

var _QuickStake2 = _interopRequireDefault(_QuickStake);

var _numericKeypad = __webpack_require__(126);

var _numericKeypad2 = _interopRequireDefault(_numericKeypad);

var _stakeField = __webpack_require__(128);

var _stakeField2 = _interopRequireDefault(_stakeField);

var _errorBanner = __webpack_require__(57);

var _errorBanner2 = _interopRequireDefault(_errorBanner);

var _eachWay = __webpack_require__(212);

var _eachWay2 = _interopRequireDefault(_eachWay);

var _estimatedReturn = __webpack_require__(88);

var _formatReturns = __webpack_require__(89);

var _formatReturns2 = _interopRequireDefault(_formatReturns);

var _apiErrors = __webpack_require__(22);

var _cleanStakeInput = __webpack_require__(60);

var _cleanStakeInput2 = _interopRequireDefault(_cleanStakeInput);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

__webpack_require__(683);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BANNER_DISPLAY_DELAY = 800;

var _ref2 = _jsx('label', {
    htmlFor: 'bs-betForm-sp-radio',
    className: 'bs-betForm__priceLabel'
}, void 0, _jsx('span', {
    className: 'bs-betForm__priceLabel-label-copy'
}, void 0, 'SP'));

var _ref3 = _jsx(_svgIcon2.default, {
    iconName: 'remove',
    size: 'SmallMedium'
});

var _ref4 = _jsx('span', {}, void 0, 'Est. Returns:');

var BetForm = exports.BetForm = function (_Component) {
    _inherits(BetForm, _Component);

    function BetForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BetForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BetForm.__proto__ || Object.getPrototypeOf(BetForm)).call.apply(_ref, [this].concat(args))), _this), _this.onStakeUpdated = function (rawStakeValue) {
            _this.dismissStakeErrors(rawStakeValue);
            _this.displayStakeErrors(rawStakeValue);
        }, _this.onToggleEachWay = function (e) {
            var _this$props = _this.props,
                outcomersId = _this$props.outcomersId,
                setIsEachWay = _this$props.setIsEachWay;


            setIsEachWay(outcomersId, e.target.checked);
        }, _this.onTogglePriceType = function (e) {
            var _this$props2 = _this.props,
                outcomersId = _this$props2.outcomersId,
                setPriceType = _this$props2.setPriceType;


            setPriceType(outcomersId, e.target.value);
        }, _this.onFormSubmit = function (e) {
            e.preventDefault();
        }, _this.getPriceType = function () {
            return _this.props.priceType || (_this.props.isSpOnly ? _priceTypes2.default.SP : _priceTypes2.default.ODDS);
        }, _this.getEstimatedReturnText = function () {
            var _this$props3 = _this.props,
                isSpOnly = _this$props3.isSpOnly,
                priceType = _this$props3.priceType,
                stakeValue = _this$props3.stakeValue,
                isEachWay = _this$props3.isEachWay,
                fractionalPrice = _this$props3.fractionalPrice,
                eachWayFraction = _this$props3.eachWayFraction,
                currencySign = _this$props3.currencySign;


            var spBet = priceType === _priceTypes2.default.SP || isSpOnly === true;

            // Always display 'N/A' if any SP bets are detected in selections
            if (spBet) {
                return 'N/A';
            }

            // For all other scenarios, let's calculate it!
            var parsedStake = Number.parseFloat(stakeValue) || 0;
            var betReturn = (0, _estimatedReturn.calculateReturn)(parsedStake, fractionalPrice, isEachWay && eachWayFraction);
            var formattedReturns = (0, _formatReturns2.default)(betReturn);
            var currencyFormattedReturns = (0, _formFormatters2.default)(currencySign)(formattedReturns);

            return currencyFormattedReturns;
        }, _this.dismissStakeErrors = function (rawStakeValue) {
            var _this$props4 = _this.props,
                outcomersId = _this$props4.outcomersId,
                error = _this$props4.error,
                associatedBet = _this$props4.associatedBet,
                clearError = _this$props4.clearError;

            // If we have min/max stake values, and user inputs a stake,
            // dismiss any min/max stake errors, if appropriate.

            if (associatedBet && rawStakeValue) {
                var _this$getStakeInfo = _this.getStakeInfo(rawStakeValue),
                    minStake = _this$getStakeInfo.minStake,
                    maxStake = _this$getStakeInfo.maxStake,
                    newStake = _this$getStakeInfo.newStake;

                var shouldClearMinError = minStake !== null && error.errorId === _apiErrors.ERROR_CODES.STAKE_TOO_LOW && newStake >= minStake;

                var shouldClearMaxError = maxStake !== null && error.errorId === _apiErrors.ERROR_CODES.STAKE_TOO_HIGH && newStake <= maxStake;

                if (shouldClearMinError || shouldClearMaxError) {
                    clearError(outcomersId);
                }
            }
        }, _this.displayStakeErrors = (0, _lodash2.default)(function (rawStakeValue) {
            var _this$props5 = _this.props,
                outcomersId = _this$props5.outcomersId,
                associatedBet = _this$props5.associatedBet,
                currencySign = _this$props5.currencySign,
                setErrorOnBuild = _this$props5.setErrorOnBuild;

            // If we have min/max stake values, and user inputs a stake,
            // dismiss any min/max stake errors, if appropriate.

            if (associatedBet && rawStakeValue) {
                var _this$getStakeInfo2 = _this.getStakeInfo(rawStakeValue),
                    minStake = _this$getStakeInfo2.minStake,
                    maxStake = _this$getStakeInfo2.maxStake,
                    newStake = _this$getStakeInfo2.newStake;

                // Restore a stake-too-low error


                if (minStake !== null && newStake < minStake) {
                    var message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_LOW.replace('%PRICE%', '' + currencySign + minStake.toFixed(2));
                    setErrorOnBuild(outcomersId, _apiErrors.ERROR_CODES.STAKE_TOO_LOW, message);
                }

                // Restore a stake-too-high error
                if (maxStake !== null && newStake > maxStake) {
                    var _message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_HIGH.replace('%PRICE%', '' + currencySign + maxStake.toFixed(2));
                    setErrorOnBuild(outcomersId, _apiErrors.ERROR_CODES.STAKE_TOO_HIGH, _message);
                }
            }
        }, BANNER_DISPLAY_DELAY), _this.toggleMultiples = function (event) {
            var _this$props6 = _this.props,
                outcomersId = _this$props6.outcomersId,
                toggleMultiplesInclusion = _this$props6.toggleMultiplesInclusion;

            var include = !!event.target.checked;
            toggleMultiplesInclusion(outcomersId, include);
        }, _this.renderQuickStake = function (disableStakeInput) {
            var _this$props7 = _this.props,
                currencySign = _this$props7.currencySign,
                stakeValue = _this$props7.stakeValue,
                isMobile = _this$props7.isMobile,
                outcomersId = _this$props7.outcomersId,
                numberOfBets = _this$props7.numberOfBets,
                setStake = _this$props7.setStake,
                bookmakerName = _this$props7.bookmakerName,
                betslipID = _this$props7.betslipID,
                horseName = _this$props7.horseName,
                fractionalPrice = _this$props7.fractionalPrice,
                raceId = _this$props7.raceId,
                courseName = _this$props7.courseName,
                raceTime = _this$props7.raceTime,
                raceDate = _this$props7.raceDate;


            if (!disableStakeInput && numberOfBets === 1) {
                return _jsx(_QuickStake2.default, {
                    currencySign: currencySign,
                    setStake: setStake,
                    onStakeUpdated: _this.onStakeUpdated,
                    value: stakeValue,
                    maxLength: 8,
                    isMobile: isMobile,
                    outcomersId: outcomersId,
                    bookmakerName: bookmakerName,
                    betslipID: betslipID,
                    horseName: horseName,
                    fractionalPrice: fractionalPrice,
                    raceId: raceId,
                    courseName: courseName,
                    raceTime: raceTime,
                    raceDate: raceDate
                });
            }

            return null;
        }, _this.renderPriceSwitcher = function () {
            var _this$props8 = _this.props,
                isSpOnly = _this$props8.isSpOnly,
                useDecimalOdds = _this$props8.useDecimalOdds,
                decimalPrice = _this$props8.decimalPrice,
                fractionalPrice = _this$props8.fractionalPrice,
                isSpAvailable = _this$props8.isSpAvailable,
                outcomersId = _this$props8.outcomersId;

            var priceType = _this.getPriceType();
            var price = useDecimalOdds ? (0, _formatDecimalPrice2.default)(decimalPrice) : fractionalPrice;

            return _jsx('div', {
                className: 'bs-betForm__priceSwitcher'
            }, void 0, _jsx('div', {
                className: (0, _classnames2.default)('bs-betForm__priceSwitcher-button', { 'bs-betForm__priceSwitcher_disabled': isSpOnly })
            }, void 0, !isSpOnly ? _jsx('div', {
                className: (0, _classnames2.default)('bs-betForm__priceButton', { 'bs-betForm__priceButton_sp-unavailable': !isSpAvailable })
            }, void 0, _jsx('input', {
                name: 'priceType',
                id: 'bs-betForm-odds-radio-' + outcomersId,
                type: 'radio',
                onChange: _this.onTogglePriceType,
                className: 'bs-betForm__priceInput',
                checked: priceType === _priceTypes2.default.ODDS,
                value: _priceTypes2.default.ODDS,
                disabled: isSpOnly,
                tabIndex: -1
            }), _jsx('label', {
                htmlFor: 'bs-betForm-odds-radio',
                className: 'bs-betForm__priceLabel'
            }, void 0, _jsx('span', {
                className: 'bs-betForm__priceLabel-label-copy'
            }, void 0, price))) : null, isSpAvailable ? _jsx('div', {
                className: 'bs-betForm__priceButton'
            }, void 0, _jsx('input', {
                name: 'priceType',
                id: 'bs-betForm-sp-radio-' + outcomersId,
                type: 'radio',
                onChange: _this.onTogglePriceType,
                className: 'bs-betForm__priceInput',
                checked: priceType === _priceTypes2.default.SP,
                value: _priceTypes2.default.SP,
                disabled: isSpOnly,
                tabIndex: -1
            }), _ref2) : null));
        }, _this.renderEachWay = function (disableStakeInput) {
            var _this$props9 = _this.props,
                eachWayFraction = _this$props9.eachWayFraction,
                eachWayPlaces = _this$props9.eachWayPlaces,
                isEachWay = _this$props9.isEachWay,
                setGlobalModal = _this$props9.setGlobalModal,
                outcomersId = _this$props9.outcomersId;
            var _this2 = _this,
                onToggleEachWay = _this2.onToggleEachWay;


            var isWinOnly = eachWayFraction === '1/1' && eachWayPlaces === '1-1';
            var isEachWayEnabled = (eachWayFraction || eachWayPlaces) && !disableStakeInput && !isWinOnly;

            return _jsx(_eachWay2.default, {
                id: outcomersId,
                isEachWayChecked: isEachWay,
                isEachWayEnabled: isEachWayEnabled,
                onChange: onToggleEachWay,
                setGlobalModal: setGlobalModal
            }, void 0, _jsx('div', {
                className: 'bs-eachWay-value'
            }, void 0, _jsx('span', {
                className: 'bs-eachWay-line'
            }, void 0, eachWayFraction), _jsx('span', {
                className: 'bs-eachWay-line'
            }, void 0, eachWayPlaces)));
        }, _this.renderNumericKeyPad = function () {
            var _this$props10 = _this.props,
                isMobile = _this$props10.isMobile,
                stakeValue = _this$props10.stakeValue,
                outcomersId = _this$props10.outcomersId,
                isEditingStake = _this$props10.isEditingStake,
                setIsEditingStake = _this$props10.setIsEditingStake,
                setStake = _this$props10.setStake;


            return isMobile && isEditingStake ? _jsx(_numericKeypad2.default, {
                targetId: outcomersId,
                setIsEditingStake: setIsEditingStake,
                setStake: setStake,
                onStakeUpdated: _this.onStakeUpdated,
                value: stakeValue,
                maxLength: 8
            }) : null;
        }, _this.renderCloseButton = function () {
            var _this$props11 = _this.props,
                numberOfBets = _this$props11.numberOfBets,
                isQuickslipMode = _this$props11.isQuickslipMode,
                outcomersId = _this$props11.outcomersId,
                onCloseClick = _this$props11.onCloseClick;


            if (isQuickslipMode && numberOfBets > 1 || !isQuickslipMode) {
                return _jsx('button', {
                    type: 'button',
                    className: 'bs-betForm__deleteSelect',
                    onClick: function onClick() {
                        onCloseClick(outcomersId);
                    }
                }, void 0, _ref3);
            }

            return null;
        }, _this.renderMultiplesRow = function () {
            var _this$props12 = _this.props,
                isQuickslipMode = _this$props12.isQuickslipMode,
                outcomersId = _this$props12.outcomersId,
                includeInMultiples = _this$props12.includeInMultiples;


            if (isQuickslipMode) {
                return null;
            }

            return _jsx('div', {
                className: 'bs-betForm__row bs-betForm__row-inlineReturns'
            }, void 0, _jsx('div', {
                className: 'bs-betForm__multiplesToggle'
            }, void 0, _jsx('input', {
                id: 'bs-betForm-multiples-checkbox-' + outcomersId,
                type: 'checkbox',
                checked: includeInMultiples ? 'checked' : '',
                onChange: _this.toggleMultiples,
                className: 'bs-betForm__multiplesToggle-input'
            }), _jsx(_svgIcon2.default, {
                iconName: 'multiples-tick',
                size: 'Large',
                className: (0, _classnames2.default)('bs-betForm__multiplesToggle-tick', { 'bs-betForm__multiplesToggle-tick-checked': includeInMultiples })
            }), _jsx('label', {
                htmlFor: 'bs-betForm-multiples-checkbox-' + outcomersId,
                className: 'bs-betForm__multiplesToggle-label'
            }, void 0, 'Multiples')), _jsx('div', {
                className: ''
            }, void 0, _ref4, _jsx('span', {
                className: 'bs-betForm__estReturns'
            }, void 0, _this.getEstimatedReturnText())));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BetForm, [{
        key: 'getStakeInfo',
        value: function getStakeInfo(rawStakeValue) {
            var _props = this.props,
                associatedBet = _props.associatedBet,
                freeBetIsSelected = _props.freeBetIsSelected;


            var minStake = associatedBet.minStake;
            var maxStake = associatedBet.maxStake;

            // Use freeBet min/max stake values if free bet is selected
            if (freeBetIsSelected) {
                minStake = associatedBet.freeBetMinStake ? associatedBet.freeBetMinStake : minStake;

                maxStake = associatedBet.freeBetMaxStake ? associatedBet.freeBetMaxStake : maxStake;
            }

            var cleaned = parseFloat((0, _cleanStakeInput2.default)(rawStakeValue));
            var newStake = isNaN(cleaned) ? 0 : cleaned;

            return {
                minStake: minStake,
                maxStake: maxStake,
                newStake: newStake
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                outcomersId = _props2.outcomersId,
                horseName = _props2.horseName,
                raceTime = _props2.raceTime,
                courseName = _props2.courseName,
                className = _props2.className,
                freezeStake = _props2.freezeStake,
                isBog = _props2.isBog,
                error = _props2.error,
                isSuspended = _props2.isSuspended,
                setIsEditingStake = _props2.setIsEditingStake,
                stakeValue = _props2.stakeValue,
                currencySign = _props2.currencySign,
                isMobile = _props2.isMobile,
                setStake = _props2.setStake,
                isEditingStake = _props2.isEditingStake,
                isEachWay = _props2.isEachWay,
                priceType = _props2.priceType;


            var errorBanner = error.message !== null ? _jsx(_errorBanner2.default, {
                message: error.message
            }) : null;
            return _jsx('form', {
                className: (0, _classnames2.default)('bs-betForm', className, { 'bs-betForm__isSuspended': isSuspended }),
                onSubmit: this.onFormSubmit
            }, void 0, errorBanner, _jsx('div', {
                className: 'bs-betForm__body'
            }, void 0, this.renderCloseButton(), _jsx('div', {
                className: 'bs-betForm__row bs-betForm__row-horseName'
            }, void 0, _jsx('span', {
                className: 'bs-betForm__horseName'
            }, void 0, horseName)), _jsx('div', {
                className: 'bs-betForm__row bs-betForm__row-raceInfo'
            }, void 0, _jsx('div', {
                className: 'bs-betForm__raceInfo'
            }, void 0, _jsx('span', {}, void 0, raceTime), _jsx('span', {
                className: 'bs-betForm__courseName'
            }, void 0, courseName)), _jsx(_bestOddsGuaranteed2.default, {
                visible: isBog === 'Y' && priceType !== _priceTypes2.default.SP
            })), _jsx('div', {
                className: 'bs-betForm__row bs-betForm__row-stake'
            }, void 0, this.renderPriceSwitcher(), this.renderEachWay(freezeStake), _jsx(_stakeField2.default, {
                targetId: outcomersId,
                currencySign: currencySign,
                stakeValue: stakeValue,
                setStake: setStake,
                setIsEditingStake: setIsEditingStake,
                isEditingStake: isEditingStake,
                onStakeUpdated: this.onStakeUpdated,
                isMobile: isMobile,
                placeholder: isEachWay ? 'Unit Stake' : 'Stake',
                freezeStake: freezeStake
            })), this.renderMultiplesRow(), this.renderNumericKeyPad(), this.renderQuickStake(freezeStake)));
        }
    }]);

    return BetForm;
}(_react.Component);

BetForm.defaultProps = {
    bookmakerName: null,
    betslipID: null,
    raceId: null,
    raceDate: null,
    horseName: null,
    raceTime: null,
    courseName: null,
    fractionalPrice: null,
    eachWayFraction: null,
    eachWayPlaces: null,
    priceType: null,
    stakeValue: '',
    className: '',
    isNumericKeypadVisible: false,
    isMobile: false,
    isEachWay: false,
    numberOfBets: 0,
    error: {
        message: null,
        errorId: null
    },
    decimalPrice: null,
    genericError: {
        message: null,
        errorId: null
    },
    associatedBet: null
};

exports.default = BetForm;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _analyticsTracking = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STAKES = [1, 2, 5, 10];
var analytics = (0, _analyticsTracking.findAnalytics)();

var QuickStake = function (_Component) {
    _inherits(QuickStake, _Component);

    function QuickStake(props) {
        _classCallCheck(this, QuickStake);

        var _this = _possibleConstructorReturn(this, (QuickStake.__proto__ || Object.getPrototypeOf(QuickStake)).call(this, props));

        _this.stakeButtons = STAKES.map(function (stake) {
            return {
                stake: stake,
                increase: _this.increaseStake.bind(_this, stake)
            };
        });
        return _this;
    }

    _createClass(QuickStake, [{
        key: 'increaseStake',
        value: function increaseStake(amount) {
            var _props = this.props,
                value = _props.value,
                setStake = _props.setStake,
                onStakeUpdated = _props.onStakeUpdated,
                maxLength = _props.maxLength,
                isMobile = _props.isMobile,
                outcomersId = _props.outcomersId,
                currencySign = _props.currencySign,
                bookmakerName = _props.bookmakerName,
                betslipID = _props.betslipID,
                horseName = _props.horseName,
                fractionalPrice = _props.fractionalPrice,
                raceId = _props.raceId,
                courseName = _props.courseName,
                raceTime = _props.raceTime,
                raceDate = _props.raceDate;


            var stake = '' + currencySign + amount;
            var floatValue = parseFloat(value) || 0;
            var increasedValue = floatValue + amount;
            var newValue = isMobile ? String(increasedValue) : increasedValue.toFixed(2);

            if (newValue.length <= maxLength) {
                setStake(outcomersId, newValue);
                onStakeUpdated(newValue);
                if (analytics) {
                    (0, _analyticsTracking.logToAnalyticsQuickStakeButtonsClick)(bookmakerName, betslipID, horseName, fractionalPrice, stake, raceId, courseName, raceTime, raceDate, analytics);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var currencySign = this.props.currencySign;

            return _jsx('div', {
                className: 'bs-form__group bs-betForm__quickStake'
            }, void 0, this.stakeButtons.map(function (_ref) {
                var stake = _ref.stake,
                    increase = _ref.increase;
                return _jsx('button', {
                    type: 'button',
                    className: 'bs-betForm__quickStakeItem',
                    onClick: increase
                }, stake, _jsx('span', {}, void 0, '+' + currencySign + stake));
            }));
        }
    }]);

    return QuickStake;
}(_react.Component);

QuickStake.defaultProps = {
    isMobile: false,
    bookmakerName: null,
    betslipID: null,
    horseName: null,
    fractionalPrice: null,
    raceId: null,
    courseName: null,
    raceTime: null,
    raceDate: null
};

exports.default = QuickStake;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FTGroup = __webpack_require__(543);

var _FTGroup2 = _interopRequireDefault(_FTGroup);

__webpack_require__(687);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FTForm = function (_Component) {
    _inherits(FTForm, _Component);

    function FTForm() {
        _classCallCheck(this, FTForm);

        return _possibleConstructorReturn(this, (FTForm.__proto__ || Object.getPrototypeOf(FTForm)).apply(this, arguments));
    }

    _createClass(FTForm, [{
        key: 'renderGroups',
        value: function renderGroups() {
            var _props = this.props,
                groups = _props.groups,
                setGlobalModal = _props.setGlobalModal,
                changeSelectionOrder = _props.changeSelectionOrder,
                isMobile = _props.isMobile,
                currencySign = _props.currencySign,
                setStake = _props.setStake,
                setIsEditingStake = _props.setIsEditingStake,
                setMultiplesError = _props.setMultiplesError,
                clearMultiplesError = _props.clearMultiplesError;


            return Object.entries(groups).map(function (group) {
                return _jsx(_FTGroup2.default, {
                    group: group[1],
                    setGlobalModal: setGlobalModal,
                    changeSelectionOrder: changeSelectionOrder,
                    isMobile: isMobile,
                    currencySign: currencySign,
                    setStake: setStake,
                    setIsEditingStake: setIsEditingStake,
                    setMultiplesError: setMultiplesError,
                    clearMultiplesError: clearMultiplesError
                }, group[0]);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var classBlockName = this.props.classBlockName;


            return _jsx('form', {
                className: '' + classBlockName
            }, void 0, this.renderGroups());
        }
    }]);

    return FTForm;
}(_react.Component);

FTForm.defaultProps = {
    classBlockName: 'bs-ft-form',
    groups: {},
    isMobile: false,
    currencySign: '£',
    setStake: function setStake() {},
    setIsEditingStake: function setIsEditingStake() {},
    setGlobalModal: function setGlobalModal() {},
    changeSelectionOrder: function changeSelectionOrder() {},
    setMultiplesError: function setMultiplesError() {},
    clearMultiplesError: function clearMultiplesError() {}
};

exports.default = FTForm;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FTSection = __webpack_require__(545);

var _FTSection2 = _interopRequireDefault(_FTSection);

__webpack_require__(684);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FTGroup = function FTGroup(_ref) {
    var classBlockName = _ref.classBlockName,
        group = _ref.group,
        setGlobalModal = _ref.setGlobalModal,
        changeSelectionOrder = _ref.changeSelectionOrder,
        isMobile = _ref.isMobile,
        currencySign = _ref.currencySign,
        setStake = _ref.setStake,
        setIsEditingStake = _ref.setIsEditingStake,
        setMultiplesError = _ref.setMultiplesError,
        clearMultiplesError = _ref.clearMultiplesError;

    var optionIdsList = group.options.length > 0 ? group.options.map(function (option) {
        return option.optionId;
    }) : [];
    var hasBetOrdering = group.options.filter(function (option) {
        return option.betType === 'straight-forecast' || option.betType === 'straight-tricast';
    }).length > 0;

    return _jsx('div', {
        className: '' + classBlockName
    }, void 0, group.selections.length > 0 ? _jsx(_FTSection2.default, {
        classBlockAddon: 'selections',
        data: group.selections,
        optionIdsList: optionIdsList,
        hasBetOrdering: hasBetOrdering,
        setGlobalModal: setGlobalModal,
        changeSelectionOrder: changeSelectionOrder,
        isMobile: isMobile,
        currencySign: currencySign,
        setStake: setStake,
        setIsEditingStake: setIsEditingStake,
        setMultiplesError: setMultiplesError,
        clearMultiplesError: clearMultiplesError
    }) : null, group.options.length > 0 ? _jsx(_FTSection2.default, {
        classBlockAddon: 'options',
        data: group.options,
        setGlobalModal: setGlobalModal,
        isMobile: isMobile,
        currencySign: currencySign,
        setStake: setStake,
        setIsEditingStake: setIsEditingStake,
        setMultiplesError: setMultiplesError,
        clearMultiplesError: clearMultiplesError
    }) : null);
};

FTGroup.defaultProps = {
    classBlockName: 'bs-ft-group',
    group: { selections: [], options: [] },
    isMobile: false,
    currencySign: '£',
    setStake: function setStake() {},
    setIsEditingStake: function setIsEditingStake() {},
    changeSelectionOrder: function changeSelectionOrder() {},
    setMultiplesError: function setMultiplesError() {},
    clearMultiplesError: function clearMultiplesError() {}
};

exports.default = FTGroup;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(685);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FTRow = function FTRow(_ref) {
    var item = _ref.item,
        index = _ref.index,
        lastRow = _ref.lastRow,
        singleRow = _ref.singleRow,
        hasBetOrdering = _ref.hasBetOrdering,
        modalTitle = _ref.modalTitle,
        modalText = _ref.modalText,
        identifier = _ref.identifier,
        raceTime = _ref.raceTime,
        textContent = _ref.textContent,
        asideContent = _ref.asideContent,
        classBlockName = _ref.classBlockName,
        outcomersId = _ref.outcomersId,
        renderIndexContent = _ref.renderIndexContent,
        renderAsideContent = _ref.renderAsideContent;

    var classBlock = identifier !== '' ? classBlockName + '-' + identifier : classBlockName;

    return _jsx('div', {
        className: '' + classBlock
    }, void 0, !singleRow ? _jsx('div', {
        className: classBlock + '__index'
    }, void 0, renderIndexContent(classBlock, identifier, hasBetOrdering, index, raceTime, modalTitle, modalText)) : '', _jsx('div', {
        className: classBlock + '__text',
        title: identifier === 'selection' ? textContent : ''
    }, void 0, _jsx('span', {
        className: classBlock + '__text-content'
    }, void 0, textContent)), !singleRow ? _jsx('div', {
        className: classBlock + '__aside'
    }, void 0, renderAsideContent(item, classBlock, identifier, hasBetOrdering, asideContent, index, lastRow, outcomersId)) : '');
};

FTRow.defaultProps = {
    item: {},
    singleRow: false,
    outcomersId: '',
    index: -1,
    lastRow: false,
    hasBetOrdering: true,
    modalTitle: '',
    modalText: '',
    identifier: 'selection',
    raceTime: '',
    textContent: '',
    asideContent: '',
    classBlockName: 'bs-ft-row',
    renderIndexContent: function renderIndexContent() {},
    renderAsideContent: function renderAsideContent() {}
};

exports.default = FTRow;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(110);

var _lodash2 = _interopRequireDefault(_lodash);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _errorBanner = __webpack_require__(57);

var _errorBanner2 = _interopRequireDefault(_errorBanner);

var _cleanStakeInput = __webpack_require__(60);

var _cleanStakeInput2 = _interopRequireDefault(_cleanStakeInput);

var _multiples = __webpack_require__(64);

var _apiErrors = __webpack_require__(22);

var _stakeField = __webpack_require__(128);

var _stakeField2 = _interopRequireDefault(_stakeField);

var _numericKeypad = __webpack_require__(126);

var _numericKeypad2 = _interopRequireDefault(_numericKeypad);

var _FTRow = __webpack_require__(544);

var _FTRow2 = _interopRequireDefault(_FTRow);

__webpack_require__(686);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BANNER_DISPLAY_DELAY = 800;

var getNewStake = function getNewStake(rawStakeValue) {
    var cleaned = parseFloat((0, _cleanStakeInput2.default)(rawStakeValue));
    return isNaN(cleaned) ? 0 : cleaned;
};

var FTSection = function (_Component) {
    _inherits(FTSection, _Component);

    function FTSection(props) {
        _classCallCheck(this, FTSection);

        var _this = _possibleConstructorReturn(this, (FTSection.__proto__ || Object.getPrototypeOf(FTSection)).call(this, props));

        _this.onStakeUpdated = function (rawStakeValue, targetId) {
            _this.dismissStakeErrors(rawStakeValue, targetId);
            _this.displayStakeErrors({ rawStakeValue: rawStakeValue, targetId: targetId });
        };

        _this.displayStakeErrors = (0, _lodash2.default)(function (_ref) {
            var rawStakeValue = _ref.rawStakeValue,
                targetId = _ref.targetId;
            var _this$props = _this.props,
                data = _this$props.data,
                currencySign = _this$props.currencySign,
                setMultiplesError = _this$props.setMultiplesError;

            var target = data.find(function (option) {
                return option.optionId === targetId;
            });
            var minStake = target.minStake,
                maxStake = target.maxStake,
                optionId = target.optionId;


            if (rawStakeValue) {
                var newStake = getNewStake(rawStakeValue);

                if (minStake !== null && newStake < minStake) {
                    var message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_LOW.replace('%PRICE%', '' + currencySign + minStake.toFixed(2));
                    setMultiplesError(optionId, _apiErrors.ERROR_CODES.STAKE_TOO_LOW, message);
                }

                if (maxStake !== null && newStake > maxStake) {
                    var _message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_HIGH.replace('%PRICE%', '' + currencySign + maxStake.toFixed(2));
                    setMultiplesError(optionId, _apiErrors.ERROR_CODES.STAKE_TOO_HIGH, _message);
                }
            }
        }, BANNER_DISPLAY_DELAY);

        _this.dismissStakeErrors = function (rawStakeValue, targetId) {
            var _this$props2 = _this.props,
                data = _this$props2.data,
                clearMultiplesError = _this$props2.clearMultiplesError;

            var target = data.find(function (option) {
                return option.optionId === targetId;
            });
            var error = target.error,
                minStake = target.minStake,
                maxStake = target.maxStake,
                optionId = target.optionId;


            if (rawStakeValue) {
                var newStake = getNewStake(rawStakeValue);

                var shouldClearMinError = minStake !== null && error.errorId === _apiErrors.ERROR_CODES.STAKE_TOO_LOW && newStake >= minStake;

                var shouldClearMaxError = maxStake !== null && error.errorId === _apiErrors.ERROR_CODES.STAKE_TOO_HIGH && newStake <= maxStake;

                if (shouldClearMinError || shouldClearMaxError) {
                    clearMultiplesError(optionId);
                }
            }
        };

        _this.renderOrderIcons = _this.renderOrderIcons.bind(_this);
        _this.renderRowAsideContent = _this.renderRowAsideContent.bind(_this);
        _this.renderRowIndexContent = _this.renderRowIndexContent.bind(_this);
        return _this;
    }

    _createClass(FTSection, [{
        key: 'orderSelectionsClickHandler',
        value: function orderSelectionsClickHandler(optionIdsList, outcomersId, index) {
            var _this2 = this;

            optionIdsList.forEach(function (id) {
                return _this2.props.changeSelectionOrder(id, outcomersId, index);
            });
        }
    }, {
        key: 'renderNumericKeyPad',
        value: function renderNumericKeyPad(option) {
            var _props = this.props,
                setIsEditingStake = _props.setIsEditingStake,
                setStake = _props.setStake,
                isMobile = _props.isMobile;
            var optionId = option.optionId,
                stakeValue = option.stakeValue,
                isEditingStake = option.isEditingStake;


            return isMobile && isEditingStake ? _jsx(_numericKeypad2.default, {
                targetId: optionId,
                setIsEditingStake: setIsEditingStake,
                setStake: setStake,
                value: stakeValue,
                maxLength: 8
            }) : null;
        }
    }, {
        key: 'renderOrderIcons',
        value: function renderOrderIcons(classBlock, index, lastRow, outcomersId) {
            var _this3 = this;

            if (lastRow) {
                return _jsx('div', {
                    className: classBlock + '__aside-content'
                }, void 0, _jsx('button', {
                    type: 'button',
                    className: (0, _classnames2.default)(classBlock + '__order-button', classBlock + '__order-button_up'),
                    onClick: function onClick() {
                        _this3.orderSelectionsClickHandler(_this3.props.optionIdsList, outcomersId, -1);
                    }
                }, void 0, _jsx(_svgIcon2.default, {
                    iconName: 'order-arrow',
                    size: 'Medium',
                    className: (0, _classnames2.default)(classBlock + '__order-arrow', classBlock + '__order-arrow_up')
                })));
            }

            if (index === 0) {
                return _jsx('div', {
                    className: classBlock + '__aside-content'
                }, void 0, _jsx('button', {
                    type: 'button',
                    className: (0, _classnames2.default)(classBlock + '__order-button', classBlock + '__order-button_down'),
                    onClick: function onClick() {
                        _this3.orderSelectionsClickHandler(_this3.props.optionIdsList, outcomersId, 1);
                    }
                }, void 0, _jsx(_svgIcon2.default, {
                    iconName: 'order-arrow',
                    size: 'Medium',
                    className: (0, _classnames2.default)(classBlock + '__order-arrow', classBlock + '__order-arrow_down')
                })));
            }

            return _jsx('div', {
                className: classBlock + '__aside-content'
            }, void 0, _jsx('button', {
                type: 'button',
                className: (0, _classnames2.default)(classBlock + '__order-button', classBlock + '__order-button_up'),
                onClick: function onClick() {
                    _this3.orderSelectionsClickHandler(_this3.props.optionIdsList, outcomersId, -1);
                }
            }, void 0, _jsx(_svgIcon2.default, {
                iconName: 'order-arrow',
                size: 'Medium',
                className: (0, _classnames2.default)(classBlock + '__order-arrow', classBlock + '__order-arrow_up')
            })), _jsx('button', {
                type: 'button',
                className: (0, _classnames2.default)(classBlock + '__order-button', classBlock + '__order-button_down'),
                onClick: function onClick() {
                    _this3.orderSelectionsClickHandler(_this3.props.optionIdsList, outcomersId, 1);
                }
            }, void 0, _jsx(_svgIcon2.default, {
                iconName: 'order-arrow',
                size: 'Medium',
                className: (0, _classnames2.default)(classBlock + '__order-arrow', classBlock + '__order-arrow_down')
            })));
        }
    }, {
        key: 'renderRowIndexContent',
        value: function renderRowIndexContent(classBlock, identifier, hasBetOrdering, index, raceTime, modalTitle, modalText) {
            var _this4 = this;

            switch (identifier) {
                case 'selection':
                    if (index >= 0 && hasBetOrdering) {
                        var formattedIndex = index + 1;
                        var indexSuffix = 'th';
                        if (formattedIndex === 1) {
                            indexSuffix = 'st';
                        } else if (formattedIndex === 2) {
                            indexSuffix = 'nd';
                        } else if (formattedIndex === 3) {
                            indexSuffix = 'rd';
                        }
                        return _jsx('span', {
                            className: classBlock + '__index-content'
                        }, void 0, formattedIndex, indexSuffix);
                    }

                    return null;
                case 'heading':
                    if (raceTime !== '') {
                        return _jsx('span', {
                            className: classBlock + '__index-content'
                        }, void 0, raceTime);
                    }

                    return null;
                case 'option':
                    return _jsx('button', {
                        type: 'button',
                        className: classBlock + '__index-button',
                        onClick: function onClick() {
                            _this4.props.setGlobalModal({
                                title: modalTitle,
                                body: modalText,
                                ctaTitle: 'OK'
                            });
                        }
                    }, void 0, _jsx(_svgIcon2.default, {
                        iconName: 'multiple-info',
                        size: 'Medium',
                        className: classBlock + '__index-info-icon'
                    }));
                default:
                    return null;
            }
        }
    }, {
        key: 'renderRowAsideContent',
        value: function renderRowAsideContent(item, classBlock, identifier, hasBetOrdering, asideContent, index, lastRow, outcomersId) {
            switch (identifier) {
                case 'selection':
                    if (hasBetOrdering) {
                        return this.renderOrderIcons(classBlock, index, lastRow, outcomersId);
                    }

                    return null;
                case 'heading':
                    return _jsx('span', {
                        className: classBlock + '__aside-content'
                    }, void 0, asideContent);
                case 'option':
                    return _jsx('div', {
                        className: classBlock + '__aside-content'
                    }, void 0, _jsx(_stakeField2.default, {
                        targetId: item.optionId,
                        currencySign: this.props.currencySign,
                        stakeValue: item.stakeValue,
                        setStake: this.props.setStake,
                        setIsEditingStake: this.props.setIsEditingStake,
                        isEditingStake: item.isEditingStake,
                        isMobile: this.props.isMobile,
                        onStakeUpdated: this.onStakeUpdated,
                        placeholder: item.numberLines > 1 ? 'Unit Stake' : 'Stake'
                    }));
                default:
                    return null;
            }
        }
    }, {
        key: 'renderHeading',
        value: function renderHeading(classBlock, identifier, hasBetOrdering, item, singleRow) {
            if (identifier === 'selections') {
                return _jsx('div', {
                    className: classBlock + '__heading'
                }, void 0, _jsx(_FTRow2.default, {
                    raceTime: item.raceTime,
                    identifier: 'heading',
                    textContent: item.courseName,
                    asideContent: singleRow || !hasBetOrdering ? '' : 'Change order',
                    renderIndexContent: this.renderRowIndexContent,
                    renderAsideContent: this.renderRowAsideContent
                }));
            }

            return null;
        }
    }, {
        key: 'renderList',
        value: function renderList(classBlock, identifier, hasBetOrdering, items, singleRow, isMobile) {
            var _this5 = this;

            if (items.length > 0) {
                if (singleRow) {
                    return _jsx('div', {
                        className: classBlock + '__list-container'
                    }, void 0, _jsx('ul', {
                        className: classBlock + '__list'
                    }, void 0, _jsx('li', {
                        className: classBlock + '__list-item'
                    }, 0, _jsx(_FTRow2.default, {
                        singleRow: singleRow,
                        identifier: identifier,
                        textContent: items.map(function (i) {
                            return i.horseName;
                        }).join(', ')
                    }))));
                }

                return _jsx('div', {
                    className: classBlock + '__list-container'
                }, void 0, _jsx('ul', {
                    className: classBlock + '__list'
                }, void 0, items.map(function (item, index) {
                    return _jsx('li', {
                        className: (0, _classnames2.default)(classBlock + '__list-item', '' + (identifier === 'option' && item.error.message !== null ? classBlock + '__list-item_error' : ''), '' + (identifier === 'option' && isMobile && item.isEditingStake ? classBlock + '__list-item_visible-keyboard' : ''))
                    }, item.optionId || item.outcomersId, identifier === 'option' && item.error.message !== null ? _jsx(_errorBanner2.default, {
                        message: item.error.message,
                        classBlockName: 'bs-ft-errorBanner'
                    }) : '', _jsx(_FTRow2.default, {
                        index: index,
                        item: item,
                        lastRow: items.length === index + 1,
                        singleRow: singleRow,
                        hasBetOrdering: hasBetOrdering,
                        modalTitle: identifier === 'option' ? _multiples.multiplesInfo[item.betType].title : '',
                        modalText: identifier === 'option' ? _multiples.multiplesInfo[item.betType].body : '',
                        identifier: identifier,
                        textContent: identifier === 'selection' ? item.horseName : _multiples.multiplesInfo[item.betType].formTitle + ' \n                                            (x' + item.numberLines + ')',
                        outcomersId: identifier === 'selection' ? item.outcomersId : '',
                        renderIndexContent: _this5.renderRowIndexContent,
                        renderAsideContent: _this5.renderRowAsideContent
                    }), identifier === 'option' ? _this5.renderNumericKeyPad(item) : null);
                })));
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                classBlockName = _props2.classBlockName,
                classBlockAddon = _props2.classBlockAddon,
                data = _props2.data,
                hasBetOrdering = _props2.hasBetOrdering,
                isMobile = _props2.isMobile;

            var classBlock = classBlockName + '-' + classBlockAddon;
            var listItemIdentifier = classBlockAddon.slice(0, -1);
            var singleRow = classBlockAddon === 'selections' && data.length > 3;

            return _jsx('div', {
                className: '' + classBlock
            }, void 0, this.renderHeading(classBlock, classBlockAddon, hasBetOrdering, data[0], singleRow), this.renderList(classBlock, listItemIdentifier, hasBetOrdering, data, singleRow, isMobile));
        }
    }]);

    return FTSection;
}(_react.Component);

FTSection.defaultProps = {
    classBlockName: 'bs-ft-section',
    classBlockAddon: 'selections',
    data: [],
    optionIdsList: [],
    hasBetOrdering: true,
    isMobile: false,
    currencySign: '£',
    setStake: function setStake() {},
    setIsEditingStake: function setIsEditingStake() {},
    changeSelectionOrder: function changeSelectionOrder() {}
};

exports.default = FTSection;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultipleForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(110);

var _lodash2 = _interopRequireDefault(_lodash);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _multiples = __webpack_require__(64);

var _eachWay = __webpack_require__(212);

var _eachWay2 = _interopRequireDefault(_eachWay);

var _stakeField = __webpack_require__(128);

var _stakeField2 = _interopRequireDefault(_stakeField);

var _numericKeypad = __webpack_require__(126);

var _numericKeypad2 = _interopRequireDefault(_numericKeypad);

var _errorBanner = __webpack_require__(57);

var _errorBanner2 = _interopRequireDefault(_errorBanner);

var _estimatedReturn = __webpack_require__(88);

var _getSelectedBetsForMultiples = __webpack_require__(219);

var _getSelectedBetsForMultiples2 = _interopRequireDefault(_getSelectedBetsForMultiples);

var _multiplesOdds = __webpack_require__(539);

var _multiplesOdds2 = _interopRequireDefault(_multiplesOdds);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

var _apiErrors = __webpack_require__(22);

var _cleanStakeInput = __webpack_require__(60);

var _cleanStakeInput2 = _interopRequireDefault(_cleanStakeInput);

__webpack_require__(688);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BANNER_DISPLAY_DELAY = 800;

var getNewStake = function getNewStake(rawStakeValue) {
    var cleaned = parseFloat((0, _cleanStakeInput2.default)(rawStakeValue));
    return isNaN(cleaned) ? 0 : cleaned;
};

var _ref2 = _jsx('span', {}, void 0, 'Est. Returns:');

var _ref3 = _jsx(_svgIcon2.default, {
    iconName: 'multiple-info',
    size: 'Medium',
    className: 'bs-multiple-form__info-icon'
});

var MultipleForm = exports.MultipleForm = function (_Component) {
    _inherits(MultipleForm, _Component);

    function MultipleForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MultipleForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultipleForm.__proto__ || Object.getPrototypeOf(MultipleForm)).call.apply(_ref, [this].concat(args))), _this), _this.onStakeUpdated = function (rawStakeValue) {
            _this.dismissStakeErrors(rawStakeValue);
            _this.displayStakeErrors(rawStakeValue);
        }, _this.onToggleEachWay = function (e) {
            var _this$props = _this.props,
                optionId = _this$props.optionId,
                setIsEachWayForMultiple = _this$props.setIsEachWayForMultiple;


            setIsEachWayForMultiple(optionId, e.target.checked);
        }, _this.getEstimatedReturn = function () {
            var _this$props2 = _this.props,
                betType = _this$props2.betType,
                betSelections = _this$props2.betSelections,
                selectedBets = _this$props2.selectedBets,
                stakeValue = _this$props2.stakeValue,
                currencySign = _this$props2.currencySign,
                isEachWay = _this$props2.isEachWay;


            if (stakeValue) {
                var partialMultipleData = {
                    stakeValue: stakeValue,
                    betType: betType,
                    isEachWay: isEachWay,
                    betSelections: betSelections
                };
                var includedSelectedBets = selectedBets.filter(function (bet) {
                    return bet.includeInMultiples;
                });
                var estimatedReturn = (0, _estimatedReturn.getMultipleEstimatedReturnText)(includedSelectedBets, partialMultipleData, currencySign);

                return _jsx('div', {
                    className: 'bs-multiple-form__inline-returns'
                }, void 0, _ref2, _jsx('span', {
                    className: 'bs-betForm__estReturns'
                }, void 0, estimatedReturn));
            }

            return null;
        }, _this.displayStakeErrors = (0, _lodash2.default)(function (rawStakeValue) {
            var _this$props3 = _this.props,
                optionId = _this$props3.optionId,
                currencySign = _this$props3.currencySign,
                setMultiplesError = _this$props3.setMultiplesError,
                minStake = _this$props3.minStake,
                maxStake = _this$props3.maxStake;

            // Check if a min or max stake error should now be dismissed or restored

            if (rawStakeValue) {
                var newStake = getNewStake(rawStakeValue);

                if (minStake !== null && newStake < minStake) {
                    // Restore a stake-too-low error
                    var message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_LOW.replace('%PRICE%', '' + currencySign + minStake.toFixed(2));
                    setMultiplesError(optionId, _apiErrors.ERROR_CODES.STAKE_TOO_LOW, message);
                }

                if (maxStake !== null && newStake > maxStake) {
                    // Restore a stake-too-high error
                    var _message = _apiErrors.ERROR_MESSAGES.STAKE_TOO_HIGH.replace('%PRICE%', '' + currencySign + maxStake.toFixed(2));
                    setMultiplesError(optionId, _apiErrors.ERROR_CODES.STAKE_TOO_HIGH, _message);
                }
            }
        }, BANNER_DISPLAY_DELAY), _this.dismissStakeErrors = function (rawStakeValue) {
            var _this$props4 = _this.props,
                optionId = _this$props4.optionId,
                error = _this$props4.error,
                clearMultiplesError = _this$props4.clearMultiplesError,
                minStake = _this$props4.minStake,
                maxStake = _this$props4.maxStake;

            // Check if a min or max stake error should now be dismissed or restored

            if (rawStakeValue) {
                var newStake = getNewStake(rawStakeValue);

                var shouldClearMinError = minStake !== null && error.errorId === _apiErrors.ERROR_CODES.STAKE_TOO_LOW && newStake >= minStake;

                var shouldClearMaxError = maxStake !== null && error.errorId === _apiErrors.ERROR_CODES.STAKE_TOO_HIGH && newStake <= maxStake;

                if (shouldClearMinError || shouldClearMaxError) {
                    clearMultiplesError(optionId);
                }
            }
        }, _this.renderNumericKeyPad = function () {
            var _this$props5 = _this.props,
                optionId = _this$props5.optionId,
                isMobile = _this$props5.isMobile,
                stakeValue = _this$props5.stakeValue,
                isEditingStake = _this$props5.isEditingStake,
                setIsEditingStake = _this$props5.setIsEditingStake,
                setStake = _this$props5.setStake;


            return isMobile && isEditingStake ? _jsx(_numericKeypad2.default, {
                targetId: optionId,
                setIsEditingStake: setIsEditingStake,
                setStake: setStake,
                value: stakeValue,
                maxLength: 8
            }) : null;
        }, _this.renderMultipleOdds = function () {
            var _this$props6 = _this.props,
                betSelections = _this$props6.betSelections,
                numberLines = _this$props6.numberLines,
                selectedBets = _this$props6.selectedBets;


            var filterBets = void 0;
            var multipleOdds = void 0;

            if (numberLines === 1) {
                filterBets = (0, _getSelectedBetsForMultiples2.default)(betSelections, selectedBets).filter(function (bet) {
                    return bet !== undefined;
                });
                var spBet = filterBets.find(function (bet) {
                    return bet.priceType === _priceTypes2.default.SP || bet.isSpOnly === true;
                });
                if (spBet) {
                    return null;
                }
                multipleOdds = (0, _multiplesOdds2.default)(filterBets);
                var formatted = multipleOdds.toFixed(2).replace('.00', '');

                return _jsx('div', {
                    className: 'bs-multiple-form__odds'
                }, void 0, formatted + '/1');
            }

            return null;
        }, _this.renderEachway = function () {
            var _this$props7 = _this.props,
                optionId = _this$props7.optionId,
                isEachWay = _this$props7.isEachWay,
                setGlobalModal = _this$props7.setGlobalModal,
                betSelections = _this$props7.betSelections,
                selectedBets = _this$props7.selectedBets;


            var i = betSelections.length;
            var isEachwayAvailable = true;
            var selectedBet = void 0;

            var filterBets = (0, _getSelectedBetsForMultiples2.default)(betSelections, selectedBets).filter(function (bet) {
                return bet !== undefined;
            });

            if (filterBets.length !== i) {
                i = filterBets.length;
            }

            while (i && isEachwayAvailable) {
                selectedBet = filterBets[i - 1];
                if (selectedBet.eachWayFraction === '' || selectedBet.eachWayFraction === '1/1') {
                    isEachwayAvailable = false;
                }
                i -= 1;
            }

            return _jsx(_eachWay2.default, {
                id: optionId,
                isEachWayEnabled: isEachwayAvailable,
                setGlobalModal: setGlobalModal,
                isEachWayChecked: isEachWay,
                onChange: _this.onToggleEachWay
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MultipleForm, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                betType = _props.betType,
                numberLines = _props.numberLines,
                setGlobalModal = _props.setGlobalModal,
                optionId = _props.optionId,
                stakeValue = _props.stakeValue,
                isEditingStake = _props.isEditingStake,
                setStake = _props.setStake,
                setIsEditingStake = _props.setIsEditingStake,
                isMobile = _props.isMobile,
                currencySign = _props.currencySign,
                error = _props.error,
                isEachWay = _props.isEachWay;


            var multipleMeta = _multiples.multiplesInfo[betType] ? _multiples.multiplesInfo[betType] : _multiples.multiplesInfo.accumulator;

            var betTitle = betType.includes('accumulator') ? _multiples.accaNames[betType] : multipleMeta.formTitle;

            var errorBanner = error.message !== null ? _jsx(_errorBanner2.default, {
                message: error.message
            }) : null;

            var numberLinesRender = isEachWay ? numberLines * 2 : numberLines;

            return _jsx('div', {
                className: 'bs-multiple-form'
            }, void 0, errorBanner, _jsx('div', {
                className: 'bs-multiple-form__body'
            }, void 0, _jsx('div', {
                className: 'bs-multiple-form__title-row'
            }, void 0, _jsx('div', {
                className: 'bs-multiple-form__title'
            }, void 0, _jsx('button', {
                type: 'button',
                className: 'bs-multiple-form__info',
                onClick: function onClick() {
                    setGlobalModal({
                        title: multipleMeta.title,
                        body: multipleMeta.body,
                        ctaTitle: 'OK'
                    });
                }
            }, void 0, _ref3), betTitle + ' (x' + numberLinesRender + ')'), this.renderMultipleOdds()), _jsx('div', {
                className: 'bs-multiple-form__stake-row'
            }, void 0, _jsx('div', {
                className: 'bs-multiple-form__stake'
            }, void 0, this.renderEachway(), _jsx(_stakeField2.default, {
                targetId: optionId,
                currencySign: currencySign,
                stakeValue: stakeValue,
                setStake: setStake,
                setIsEditingStake: setIsEditingStake,
                isEditingStake: isEditingStake,
                isMobile: isMobile,
                onStakeUpdated: this.onStakeUpdated,
                placeholder: isEachWay || numberLines > 1 ? 'Unit Stake' : 'Stake'
            }))), _jsx('div', {
                className: 'bs-multiple-form__inline-returns-row'
            }, void 0, this.getEstimatedReturn()), this.renderNumericKeyPad()));
        }
    }]);

    return MultipleForm;
}(_react.Component);

MultipleForm.defaultProps = {
    numberLines: 0,
    stakeValue: '',
    error: {
        message: null,
        errorId: null
    },
    isEditingStake: false,
    isEachWay: false,
    minStake: null,
    maxStake: null
};

exports.default = MultipleForm;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetReceiptPage = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(8);

var _bet = __webpack_require__(20);

var _BetReceipt = __webpack_require__(642);

var _BetReceipt2 = _interopRequireDefault(_BetReceipt);

var _svgIcon = __webpack_require__(7);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _formatDateTime = __webpack_require__(61);

var _userInfo = __webpack_require__(11);

var _pageInfo = __webpack_require__(37);

var _bookmakersInfo = __webpack_require__(6);

var _drawer = __webpack_require__(38);

var drawerActions = _interopRequireWildcard(_drawer);

var _bookmakersList = __webpack_require__(5);

var _calculateStake = __webpack_require__(48);

var _currentDate = __webpack_require__(24);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

__webpack_require__(691);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');

var _ref2 = _jsx('div', {
    className: 'bs-betReceiptPage__pendingMessage'
}, void 0, _jsx('h2', {
    className: 'bs-betReceiptPage__pendingMessage--title'
}, void 0, 'Your Bet is Pending...'), _jsx('p', {
    className: 'bs-betReceiptPage__pendingMessage--explanation'
}, void 0, 'This bet was submitted very close to the off, we are checking to see if we can successfully place this bet, this could take up to 2 minutes.'), _jsx('p', {
    className: 'bs-betReceiptPage__pendingMessage--explanation'
}, void 0, 'Please check your Bet History to see if this bet was successfully placed.'));

var _ref3 = _jsx('div', {
    className: 'bs-betReceiptPage__dateTimeBar--title'
}, void 0, _jsx(_svgIcon2.default, {
    iconName: 'bet-success',
    className: 'bs-betReceiptPage__tick'
}), _jsx('span', {}, void 0, 'Bet Placed Successfully'));

var _ref4 = _jsx('span', {}, void 0, 'Reuse Selection');

var _ref5 = _jsx('span', {}, void 0, 'Done');

var BetReceiptPage = exports.BetReceiptPage = function (_Component) {
    _inherits(BetReceiptPage, _Component);

    function BetReceiptPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BetReceiptPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BetReceiptPage.__proto__ || Object.getPrototypeOf(BetReceiptPage)).call.apply(_ref, [this].concat(args))), _this), _this.reuseSelection = function () {
            var _this$props = _this.props,
                placedBetDetails = _this$props.placedBetDetails,
                clearPlacedBetDetails = _this$props.clearPlacedBetDetails,
                addSelectedBet = _this$props.addSelectedBet,
                unusedBets = _this$props.unusedBets,
                clearUnusedBets = _this$props.clearUnusedBets,
                clearAllErrors = _this$props.clearAllErrors;

            // Restore bets that were placed (only singles)
            // Note that fresh multiples will be generated

            placedBetDetails.bets.forEach(function (placedBet) {
                var betType = placedBet.betType,
                    bets = placedBet.bets;

                if (betType === 'single') {
                    var singleBet = bets[0];
                    var priceType = singleBet.isSpOnly ? _priceTypes2.default.SP : _priceTypes2.default.ODDS;
                    var bet = _extends({}, singleBet, {
                        stake: '',
                        isEachWay: false,
                        isLockedStake: false,
                        priceType: priceType
                    });
                    addSelectedBet(bet);
                }
            });

            // Restore bets that were added, but not placed (i.e. had blank stake when placed)
            unusedBets.forEach(function (unusedBet) {
                addSelectedBet(unusedBet);
            });

            // Clear unused bets
            clearUnusedBets();

            // Clear the placed bet
            clearPlacedBetDetails();

            // Clear errors
            clearAllErrors();
        }, _this.clearPlacedBetDetails = function () {
            var _this$props2 = _this.props,
                clearPlacedBetDetails = _this$props2.clearPlacedBetDetails,
                setQuickslipMode = _this$props2.setQuickslipMode;


            setQuickslipMode(true);
            clearPlacedBetDetails();
            document.dispatchEvent(selectionRemovedEvent);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BetReceiptPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                placedBetDetails = _props.placedBetDetails,
                userInfo = _props.userInfo,
                useDecimalOdds = _props.useDecimalOdds;

            if (placedBetDetails.bets.length === 0) {
                return _jsx(_reactRouterDom.Redirect, {
                    to: {
                        pathname: '/',
                        state: { isReversedAnimation: true }
                    }
                });
            }
            var currencySign = userInfo.currencySign;

            var receipts = placedBetDetails.bets.map(function (placedBet) {
                var betId = placedBet.betId,
                    betType = placedBet.betType,
                    receiptId = placedBet.receiptId,
                    bets = placedBet.bets,
                    multiple = placedBet.multiple,
                    stakePerLine = placedBet.stakePerLine,
                    numberLines = placedBet.numberLines,
                    potentialReturns = placedBet.potentialReturns;


                var totalStake = void 0;
                var isEachWay = void 0;

                if (betType === 'single') {
                    totalStake = (0, _calculateStake.calculateSingleStake)(bets[0]);
                    isEachWay = bets[0].isEachWay;
                } else {
                    totalStake = (0, _calculateStake.calculateMultipleStake)(multiple);
                    isEachWay = multiple.isEachWay;
                }

                var potentialReturnsString = potentialReturns !== null ? potentialReturns.toString() : 'N/A';

                return _jsx(_BetReceipt2.default, {
                    receiptId: receiptId,
                    betType: betType,
                    selections: bets,
                    currencySign: currencySign,
                    stake: totalStake,
                    totalStake: totalStake,
                    returns: potentialReturnsString,
                    isEachWay: isEachWay,
                    useDecimalOdds: useDecimalOdds,
                    stakePerLine: stakePerLine,
                    numberLines: numberLines,
                    freeBet: placedBetDetails.freeBet
                }, 'receipt-' + receiptId + '-' + betId);
            });

            var timeBetPlaced = (0, _formatDateTime.formatDateTime)((0, _currentDate.getCurrentDate)());
            var pendingMessage = !placedBetDetails.containsPending ? null : _ref2;
            var barTitle = placedBetDetails.containsPending ? 'Your Pending Bets' : 'Your Bets';

            return _jsx('div', {
                className: 'bs-horizontalSlider__container'
            }, void 0, _jsx('div', {
                className: 'bs-horizontalSlider__element bs-betReceiptPage'
            }, void 0, _jsx('div', {
                className: 'bs-drawer__scrollable'
            }, void 0, _jsx('div', {
                className: 'bs-betReceiptPage__dateTimeBar'
            }, void 0, _ref3, _jsx('span', {
                className: 'bs-betReceiptPage__dateTimeBar--dateTime'
            }, void 0, timeBetPlaced)), pendingMessage, _jsx('div', {
                className: 'bs-betReceiptPage__yourBetsBar'
            }, void 0, _jsx('span', {}, void 0, barTitle, ' (', receipts.length, ')')), receipts), _jsx('div', {
                className: 'bs-drawer__actionBar'
            }, void 0, _jsx('div', {
                className: 'bs-actionBar bs-section'
            }, void 0, _jsx('button', {
                className: 'bs-btn\n                                    bs-btn_default\n                                    bs-actionBar__button\n                                    bs-actionBar__large',
                onClick: this.reuseSelection
            }, void 0, _ref4), _jsx('button', {
                className: 'bs-btn\n                                    bs-btn_major\n                                    bs-actionBar__button\n                                    bs-actionBar__large\n                                    bs-betReceipt__doneButton',
                onClick: this.clearPlacedBetDetails
            }, void 0, _ref5)))));
        }
    }]);

    return BetReceiptPage;
}(_react.Component);

var betProp = _propTypes2.default.shape({
    raceTime: _propTypes2.default.string.isRequired,
    raceDate: _propTypes2.default.string.isRequired,
    courseName: _propTypes2.default.string.isRequired,
    horseName: _propTypes2.default.string.isRequired,
    fractionalPrice: _propTypes2.default.string.isRequired,
    decimalPrice: _propTypes2.default.number,
    isSpOnly: _propTypes2.default.bool.isRequired,
    eachWayFraction: _propTypes2.default.string,
    eachWayPlaces: _propTypes2.default.string,
    priceType: _propTypes2.default.string.isRequired,
    isBog: _propTypes2.default.string,
    isEachWay: _propTypes2.default.bool,
    stake: _propTypes2.default.string
});

BetReceiptPage.defaultProps = {
    placedBetDetails: null,
    useDecimalOdds: false,
    unusedBets: []
};

var userInfoSelector = _userInfo.selectors.createUserInfoSelector(_bet.selectors.placedBetBookmakerSelector);

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_bet.selectors.placedBetBookmakerSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    var placedBetDetails = state.bet.placedBetDetails;


    return _extends({}, bookmakerInfoSelector(state, props), {
        placedBetDetails: placedBetDetails,
        userInfo: userInfoSelector(state, props),
        feed: _bet.selectors.placedBetBookmakerSelector(state),
        useDecimalOdds: _pageInfo.selectors.useDecimalOddsSelector(state),
        unusedBets: state.bookmakersInfo.unusedBets
    });
};

var mapDispatchToProps = {
    clearPlacedBetDetails: _bet.actions.clearPlacedBetDetails,
    setQuickslipMode: drawerActions.setQuickslipMode,
    addSelectedBet: _bookmakersInfo.actions.addSelectedBet,
    clearUnusedBets: _bookmakersInfo.actions.clearUnusedBets,
    clearAllErrors: _bookmakersInfo.actions.clearAllErrors
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BetReceiptPage);

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BetReceipt = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BetReceiptBody = __webpack_require__(643);

var _BetReceiptBody2 = _interopRequireDefault(_BetReceiptBody);

var _bestOddsGuaranteed = __webpack_require__(202);

var _bestOddsGuaranteed2 = _interopRequireDefault(_bestOddsGuaranteed);

var _multiples = __webpack_require__(64);

var _formatDateTime = __webpack_require__(61);

var _formatDecimalPrice = __webpack_require__(131);

var _formatDecimalPrice2 = _interopRequireDefault(_formatDecimalPrice);

var _calculateStake = __webpack_require__(48);

__webpack_require__(690);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
    className: 'bs-betReceipt__row bs-betReceipt__bog'
}, void 0, _jsx(_bestOddsGuaranteed2.default, {
    visible: true
}));

var _ref2 = _jsx('span', {
    className: 'bs-betReceipt__moneyBreakdownLabel'
}, void 0, 'Your Money');

var _ref3 = _jsx('span', {
    className: 'bs-betReceipt__moneyBreakdownLabel'
}, void 0, 'Free Bet Used');

var _ref4 = _jsx('span', {}, void 0, 'Total Stake for this bet');

var _ref5 = _jsx('span', {}, void 0, 'Est. Returns for this bet');

var BetReceipt = exports.BetReceipt = function (_Component) {
    _inherits(BetReceipt, _Component);

    function BetReceipt() {
        _classCallCheck(this, BetReceipt);

        var _this = _possibleConstructorReturn(this, (BetReceipt.__proto__ || Object.getPrototypeOf(BetReceipt)).call(this));

        _this.getReceiptHeader = _this.getReceiptHeader.bind(_this);
        _this.getBetReceiptBody = _this.getBetReceiptBody.bind(_this);
        _this.getTricastForcastBody = _this.getTricastForcastBody.bind(_this);
        _this.getSingleMultipleBody = _this.getSingleMultipleBody.bind(_this);
        return _this;
    }

    _createClass(BetReceipt, [{
        key: 'getReceiptHeader',
        value: function getReceiptHeader() {
            var _props = this.props,
                betType = _props.betType,
                isEachWay = _props.isEachWay,
                numberLines = _props.numberLines;


            var betTypeName = betType.includes('accumulator') ? 'accumulator' : betType;
            var betTypeText = betTypeName === 'single' ? 'Single' : _multiples.multiplesInfo[betTypeName].formTitle;
            var header = betTypeText + ' ' + (isEachWay ? 'EW' : '') + ' (x' + numberLines + ')';

            return _jsx('div', {
                className: 'bs-betReceipt__header'
            }, void 0, header);
        }
    }, {
        key: 'getTricastForcastBody',
        value: function getTricastForcastBody() {
            var _props2 = this.props,
                selections = _props2.selections,
                betType = _props2.betType;
            var _selections$ = selections[0],
                raceTime = _selections$.raceTime,
                courseName = _selections$.courseName;


            var HORSE_POSITIONS = ['1st', '2nd', '3rd'];
            var raceDate = (0, _formatDateTime.formatDate)(selections[0].raceDate);

            var raceData = _jsx('div', {
                className: 'bs-betReceipt__row bs-betReceipt__details'
            }, void 0, _jsx('span', {}, void 0, ' ', raceTime + ' ' + courseName + ', ' + raceDate, ' '));

            var horses = selections.map(function (selection, index) {
                return _jsx('div', {
                    className: 'bs-betReceipt__row bs-betReceipt__horseName'
                }, 'key-' + selection.horseName, _jsx('span', {}, void 0, betType === 'straight-forecast' || betType === 'straight-tricast' ? _jsx('span', {
                    className: 'bs-betReceipt__horsePosition'
                }, void 0, HORSE_POSITIONS[index]) : null, selection.horseName));
            });

            return _jsx('div', {
                className: 'bs-betReceipt__body'
            }, void 0, raceData, horses);
        }
    }, {
        key: 'getSingleMultipleBody',
        value: function getSingleMultipleBody() {
            var _props3 = this.props,
                selections = _props3.selections,
                isEachWay = _props3.isEachWay,
                useDecimalOdds = _props3.useDecimalOdds;


            return selections.map(function (selection) {
                var horseName = selection.horseName,
                    priceType = selection.priceType,
                    raceTime = selection.raceTime,
                    courseName = selection.courseName,
                    raceDate = selection.raceDate,
                    eachWayFraction = selection.eachWayFraction,
                    eachWayPlaces = selection.eachWayPlaces,
                    decimalPrice = selection.decimalPrice,
                    fractionalPrice = selection.fractionalPrice;


                var formattedDate = (0, _formatDateTime.formatDate)(raceDate);
                var price = useDecimalOdds ? '' + (0, _formatDecimalPrice2.default)(decimalPrice) : fractionalPrice;

                return _jsx(_BetReceiptBody2.default, {
                    horseName: horseName,
                    priceType: priceType,
                    price: price,
                    raceTime: raceTime,
                    courseName: courseName,
                    raceDate: formattedDate,
                    isEachWay: isEachWay,
                    eachWayFraction: eachWayFraction,
                    eachWayPlaces: eachWayPlaces
                }, 'key-' + horseName);
            });
        }
    }, {
        key: 'getBetReceiptBody',
        value: function getBetReceiptBody() {
            var _this2 = this;

            var _props4 = this.props,
                selections = _props4.selections,
                betType = _props4.betType;

            var isTricastForecast = betType && _multiples.forecastMultiples.indexOf(betType) > -1;
            var body = isTricastForecast ? this.getTricastForcastBody() : this.getSingleMultipleBody();

            var bogBets = selections.filter(function (selection) {
                return selection.isBog === 'Y' && selection.priceType !== _priceTypes2.default.SP && _this2.isBoGAvailable(selection, betType);
            });

            var bog = bogBets.length !== selections.length || isTricastForecast ? null : _ref;

            return _jsx('div', {}, void 0, body, bog);
        }

        // eslint-disable-next-line class-methods-use-this

    }, {
        key: 'isBoGAvailable',
        value: function isBoGAvailable(selection, betType) {
            if (!betType) {
                return false;
            }

            if (betType.toLowerCase() === 'single') {
                return true;
            }

            if (!selection) {
                return false;
            }

            if (!selection.feed) {
                return false;
            }

            var noBoG = ['betfair'];

            return betType.toLowerCase() !== 'single' && !noBoG.includes(selection.feed.toLowerCase());
        }
    }, {
        key: 'renderUnitStake',
        value: function renderUnitStake() {
            var _props5 = this.props,
                currencySign = _props5.currencySign,
                isEachWay = _props5.isEachWay,
                stakePerLine = _props5.stakePerLine,
                numberLines = _props5.numberLines;


            if (isEachWay || numberLines > 1) {
                var stakePerLineText = '' + currencySign + stakePerLine.toFixed(2);

                return _jsx('div', {
                    className: 'bs-betReceipt__row bs-betReceipt__unitStake'
                }, void 0, _jsx('span', {}, void 0, 'Unit Stake per line ' + stakePerLineText));
            }

            return null;
        }
    }, {
        key: 'renderMoneyBreakdown',
        value: function renderMoneyBreakdown() {
            var _props6 = this.props,
                selections = _props6.selections,
                currencySign = _props6.currencySign,
                freeBet = _props6.freeBet;


            var bet = selections[0];
            var stake = parseFloat(bet.stake, 10);

            var _calculateMoneyBreakd = (0, _calculateStake.calculateMoneyBreakdown)(stake, bet, freeBet.amount),
                userStake = _calculateMoneyBreakd.userStake,
                freeStake = _calculateMoneyBreakd.freeStake;

            var userStakeText = '' + currencySign + userStake.toFixed(2);
            var freeStakeText = '' + currencySign + freeStake.toFixed(2);

            return _jsx('div', {
                className: 'bs-betReceipt__moneyBreakdown'
            }, void 0, _jsx('div', {
                className: 'bs-betReceipt__row'
            }, void 0, _ref2, _jsx('span', {
                className: 'bs-betReceipt__moneyBreakdownValue'
            }, void 0, userStakeText)), _jsx('div', {
                className: 'bs-betReceipt__row'
            }, void 0, _ref3, _jsx('span', {
                className: 'bs-betReceipt__moneyBreakdownValue'
            }, void 0, freeStakeText)));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props7 = this.props,
                receiptId = _props7.receiptId,
                totalStake = _props7.totalStake,
                returns = _props7.returns,
                currencySign = _props7.currencySign,
                freeBet = _props7.freeBet;


            var moneyBreakdown = freeBet ? this.renderMoneyBreakdown() : null;
            var formattedReturns = returns === 'N/A' ? returns : '' + currencySign + parseFloat(returns, 10).toFixed(2);

            return _jsx('div', {
                className: 'bs-betReceipt'
            }, void 0, this.getReceiptHeader(), this.getBetReceiptBody(), _jsx('div', {
                className: 'bs-betReceipt__footer'
            }, void 0, this.renderUnitStake(), moneyBreakdown, _jsx('div', {
                className: 'bs-betReceipt__row bs-betReceipt__totalStake'
            }, void 0, _ref4, _jsx('span', {}, void 0, '' + currencySign + totalStake.toFixed(2))), _jsx('div', {
                className: 'bs-betReceipt__row bs-betReceipt__estReturn'
            }, void 0, _ref5, _jsx('span', {}, void 0, formattedReturns)), _jsx('div', {
                className: 'bs-betReceipt__row'
            }, void 0, _jsx('span', {}, void 0, 'Receipt No: ' + receiptId))));
        }
    }]);

    return BetReceipt;
}(_react.Component);

BetReceipt.defaultProps = {
    isEachWay: false,
    returns: '',
    freeBet: null
};

exports.default = BetReceipt;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _priceTypes = __webpack_require__(26);

var _priceTypes2 = _interopRequireDefault(_priceTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptBody = function ReceiptBody(_ref) {
    var horseName = _ref.horseName,
        priceType = _ref.priceType,
        price = _ref.price,
        raceTime = _ref.raceTime,
        courseName = _ref.courseName,
        raceDate = _ref.raceDate,
        isEachWay = _ref.isEachWay,
        eachWayPlaces = _ref.eachWayPlaces,
        eachWayFraction = _ref.eachWayFraction;
    return _jsx('div', {
        className: 'bs-betReceipt__body'
    }, void 0, _jsx('div', {
        className: 'bs-betReceipt__row bs-betReceipt__horseName'
    }, void 0, _jsx('span', {}, void 0, horseName + ' @ ' + (priceType === _priceTypes2.default.SP ? _priceTypes2.default.SP : price))), _jsx('div', {
        className: (0, _classnames2.default)('bs-betReceipt__row', {
            'bs-betReceipt__details--eachWays': isEachWay,
            'bs-betReceipt__details': !isEachWay
        })
    }, void 0, _jsx('span', {}, void 0, raceTime + ' ' + courseName + ', ' + raceDate)), isEachWay ? _jsx('div', {
        className: 'bs-betReceipt__row bs-betReceipt__details'
    }, void 0, _jsx('span', {}, void 0, 'EW Terms: ' + eachWayFraction + ', ' + eachWayPlaces)) : null);
};

ReceiptBody.defaultProps = {
    eachWayPlaces: '',
    eachWayFraction: ''
};

exports.default = ReceiptBody;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BodyScroll = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function toggleScrollClass(isDrawerOpen) {
    if (isDrawerOpen) {
        document.body.classList.add('bs-bodyScroll');
    } else {
        document.body.classList.remove('bs-bodyScroll');
    }
}

var BodyScroll = exports.BodyScroll = function (_Component) {
    _inherits(BodyScroll, _Component);

    function BodyScroll() {
        _classCallCheck(this, BodyScroll);

        return _possibleConstructorReturn(this, (BodyScroll.__proto__ || Object.getPrototypeOf(BodyScroll)).apply(this, arguments));
    }

    _createClass(BodyScroll, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            toggleScrollClass(this.props.isDrawerOpen);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            toggleScrollClass(nextProps.isDrawerOpen);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.classList.remove('bs-bodyScroll');
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return BodyScroll;
}(_react.Component);

BodyScroll.defaultProps = {
    isDrawerOpen: false
};

exports.default = BodyScroll;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForgottenPasswordPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _forgottenPassword = __webpack_require__(213);

var _forgottenPassword2 = _interopRequireDefault(_forgottenPassword);

var _bookmakersList = __webpack_require__(5);

var _bookmakersInfo = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgottenPasswordPage = exports.ForgottenPasswordPage = function ForgottenPasswordPage(_ref) {
    var match = _ref.match;
    return _jsx('div', {
        className: 'bs-horizontalSlider__element'
    }, void 0, _jsx('div', {
        className: 'bs-drawer__content'
    }, void 0, _jsx(_forgottenPassword2.default, {
        match: match
    })));
};

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector);

var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, bookmakerInfoSelector(state));
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(ForgottenPasswordPage);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FreeBetsContainer = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _freeBets = __webpack_require__(35);

var _bookmakersInfo = __webpack_require__(6);

var _freeBetList = __webpack_require__(515);

var _freeBetList2 = _interopRequireDefault(_freeBetList);

var _freeBetToggle = __webpack_require__(516);

var _freeBetToggle2 = _interopRequireDefault(_freeBetToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FreeBetsContainer = exports.FreeBetsContainer = function (_Component) {
    _inherits(FreeBetsContainer, _Component);

    function FreeBetsContainer() {
        _classCallCheck(this, FreeBetsContainer);

        var _this = _possibleConstructorReturn(this, (FreeBetsContainer.__proto__ || Object.getPrototypeOf(FreeBetsContainer)).call(this));

        _this.clearFreeBet = _this.clearFreeBet.bind(_this);
        _this.selectFreeBet = _this.selectFreeBet.bind(_this);
        return _this;
    }

    _createClass(FreeBetsContainer, [{
        key: 'selectFreeBet',
        value: function selectFreeBet(freeBetId) {
            var _props = this.props,
                selectionId = _props.selectionId,
                selectFreeBet = _props.selectFreeBet,
                setFreeBetMinimumStake = _props.setFreeBetMinimumStake,
                setFreeBetMaximumStake = _props.setFreeBetMaximumStake,
                setLockedStake = _props.setLockedStake,
                freeBets = _props.freeBets;

            var freeBet = freeBets.find(function (bet) {
                return bet.id === freeBetId;
            });
            var minStake = freeBet.minStake,
                maxStake = freeBet.maxStake,
                id = freeBet.id;

            // Update the min/max stake for the selection (if required)

            if (minStake) {
                setFreeBetMinimumStake(selectionId, minStake);
            }
            if (maxStake) {
                setFreeBetMaximumStake(selectionId, maxStake);
            }

            // Set locked stake if applicable
            if (minStake && minStake === maxStake) {
                setLockedStake(selectionId, minStake.toString());
            }

            // Set this free bet as being selected
            selectFreeBet(id);
        }
    }, {
        key: 'clearFreeBet',
        value: function clearFreeBet() {
            var _props2 = this.props,
                selectionId = _props2.selectionId,
                clearFreeBet = _props2.clearFreeBet,
                clearLockedStake = _props2.clearLockedStake;


            clearLockedStake(selectionId);
            clearFreeBet();
        }
    }, {
        key: 'renderFreeBetSingle',
        value: function renderFreeBetSingle() {
            var _props3 = this.props,
                selectedFreeBet = _props3.selectedFreeBet,
                freeBets = _props3.freeBets,
                currencySign = _props3.currencySign;

            return _jsx(_freeBetToggle2.default, {
                selectedFreeBet: selectedFreeBet,
                selectFreeBet: this.selectFreeBet,
                clearFreeBet: this.clearFreeBet,
                freeBets: freeBets,
                currencySign: currencySign
            });
        }
    }, {
        key: 'renderFreeBetList',
        value: function renderFreeBetList() {
            var _props4 = this.props,
                selectedFreeBet = _props4.selectedFreeBet,
                freeBets = _props4.freeBets,
                currencySign = _props4.currencySign;

            return _jsx(_freeBetList2.default, {
                selectedFreeBet: selectedFreeBet,
                selectFreeBet: this.selectFreeBet,
                clearFreeBet: this.clearFreeBet,
                freeBets: freeBets,
                currencySign: currencySign
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var freeBets = this.props.freeBets;


            var freeBetUi = freeBets.length === 1 ? this.renderFreeBetSingle() : this.renderFreeBetList();

            return _jsx('div', {}, void 0, freeBetUi);
        }
    }]);

    return FreeBetsContainer;
}(_react.Component);

FreeBetsContainer.defaultProps = {
    selectedFreeBet: null
};

var mapStateToProps = function mapStateToProps(state) {
    var bookmakersInfo = state.bookmakersInfo,
        freeBets = state.freeBets;


    return {
        freeBets: freeBets.list,
        selectedFreeBet: freeBets.selectedFreeBet,
        selectionId: bookmakersInfo.selectedBets[0].outcomersId
    };
};

var mapDispatchToProps = {
    selectFreeBet: _freeBets.actions.selectFreeBet,
    clearFreeBet: _freeBets.actions.clearFreeBet,
    setFreeBetMinimumStake: _bookmakersInfo.actions.setFreeBetMinimumStake,
    setFreeBetMaximumStake: _bookmakersInfo.actions.setFreeBetMaximumStake,
    setLockedStake: _bookmakersInfo.actions.setLockedStake,
    clearLockedStake: _bookmakersInfo.actions.clearLockedStake
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FreeBetsContainer);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IframeLoginPage = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loginPage = __webpack_require__(36);

var _loginPage2 = _interopRequireDefault(_loginPage);

var _gamblingCompliance = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IframeLoginPage = exports.IframeLoginPage = function IframeLoginPage(_ref) {
    var match = _ref.match,
        containsTermsInLoginIframe = _ref.containsTermsInLoginIframe;

    var gamblingCompliance = (0, _gamblingCompliance.getGamblingCompliance)(match.params.feed);
    return _jsx('div', {
        className: 'bs-horizontalSlider__element bs-drawer__iframeContainer'
    }, void 0, _jsx('div', {
        className: 'bs-drawer__content'
    }, void 0, _jsx(_loginPage2.default, {
        match: match
    }), !containsTermsInLoginIframe ? gamblingCompliance : null));
};

exports.default = IframeLoginPage;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DrawerLoginPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NonIframeLoginPage = __webpack_require__(649);

var _NonIframeLoginPage2 = _interopRequireDefault(_NonIframeLoginPage);

var _IframeLoginPage = __webpack_require__(647);

var _IframeLoginPage2 = _interopRequireDefault(_IframeLoginPage);

var _bookmakersList = __webpack_require__(5);

var _bookmakersInfo = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DrawerLoginPage = exports.DrawerLoginPage = function DrawerLoginPage(_ref) {
    var match = _ref.match,
        name = _ref.name,
        loginType = _ref.loginType,
        containsTermsInLoginIframe = _ref.containsTermsInLoginIframe;

    var isNonIntegratedLoginForm = loginType === _bookmakersList.constants.LOGIN_TYPE.IFRAME;
    return isNonIntegratedLoginForm ? _jsx(_IframeLoginPage2.default, {
        match: match,
        name: name,
        containsTermsInLoginIframe: containsTermsInLoginIframe
    }) : _jsx(_NonIframeLoginPage2.default, {
        match: match,
        name: name
    });
};

DrawerLoginPage.defaultProps = {
    containsTermsInLoginIframe: false
};

var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector);

var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, bookmakerInfoSelector(state));
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DrawerLoginPage);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NonIframeLoginPage = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loginPage = __webpack_require__(36);

var _loginPage2 = _interopRequireDefault(_loginPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NonIframeLoginPage = exports.NonIframeLoginPage = function NonIframeLoginPage(_ref) {
    var match = _ref.match;
    return _jsx('div', {
        className: 'bs-horizontalSlider__element'
    }, void 0, _jsx('div', {
        className: 'bs-drawer__content'
    }, void 0, _jsx(_loginPage2.default, {
        match: match,
        actionBarClass: 'bs-drawer__actionBar'
    })));
};

exports.default = NonIframeLoginPage;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MinimizeButton = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(4);

var _analyticsTracking = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analytics = (0, _analyticsTracking.findAnalytics)();
var selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');

var MinimizeButton = exports.MinimizeButton = function MinimizeButton(props) {
    var bookmakerName = props.bookmakerName,
        betslipID = props.betslipID,
        selectedBets = props.selectedBets,
        isDrawerMinimized = props.isDrawerMinimized,
        isQuickslipMode = props.isQuickslipMode,
        resetQuickslip = props.resetQuickslip,
        clearPlacedBetDetails = props.clearPlacedBetDetails,
        isBetPlacedSuccessfully = props.isBetPlacedSuccessfully;

    var text = isDrawerMinimized && !isBetPlacedSuccessfully ? 'Open' : 'Close';
    text = isQuickslipMode && !isBetPlacedSuccessfully ? 'Cancel' : text;

    var onMinimize = function onMinimize() {
        if (isQuickslipMode) {
            // Reset the drawer state
            resetQuickslip();
            if (analytics) {
                var selectedBet = selectedBets[0];
                (0, _analyticsTracking.logToAnalyticsCancelBetClick)(bookmakerName, betslipID, selectedBet, analytics);
            }
            document.dispatchEvent(selectionRemovedEvent);
        }

        // Reset the drawer & also remove a placed bet if appropriate
        if (isBetPlacedSuccessfully) {
            resetQuickslip();
            clearPlacedBetDetails();
            document.dispatchEvent(selectionRemovedEvent);
        }
    };

    return _jsx('div', {
        role: 'button',
        tabIndex: 0,
        className: 'bs-drawer__minimizeButton'
    }, void 0, _jsx('button', {
        className: 'bs-drawer__minimizeButton__button',
        onClick: onMinimize
    }, void 0, text));
};

var betProps = _propTypes2.default.shape({
    price: _propTypes2.default.string,
    outcomersId: _propTypes2.default.string,
    eventId: _propTypes2.default.string,
    meetingId: _propTypes2.default.string,
    raceId: _propTypes2.default.string,
    raceDate: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    courseName: _propTypes2.default.string,
    raceTime: _propTypes2.default.string,
    eachWayFraction: _propTypes2.default.string,
    eachWayPlaces: _propTypes2.default.string,
    isBog: _propTypes2.default.string
});

MinimizeButton.defaultProps = {
    selectedBets: [],
    bookmakerName: null,
    betslipID: null
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        isDrawerMinimized: state.drawerInfo.isDrawerMinimized
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(MinimizeButton);

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ExternalTopUpPage = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _externalAccount = __webpack_require__(34);

var _externalAccount2 = _interopRequireDefault(_externalAccount);

var _gamblingCompliance = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalTopUpPage = exports.ExternalTopUpPage = function ExternalTopUpPage(_ref) {
    var feed = _ref.feed,
        containsTermsInTopUpIframe = _ref.containsTermsInTopUpIframe,
        accountType = _ref.accountType,
        externalAccountUrl = _ref.externalAccountUrl,
        isExternalAccountError = _ref.isExternalAccountError,
        onExternalBackButtonClick = _ref.onExternalBackButtonClick;

    var gamblingCompliance = (0, _gamblingCompliance.getGamblingCompliance)(feed);
    return _jsx('div', {
        className: 'bs-horizontalSlider__element bs-drawer__iframeContainer'
    }, void 0, _jsx('div', {
        className: 'bs-drawer__content'
    }, void 0, _jsx(_externalAccount2.default, {
        type: accountType,
        externalAccountUrl: externalAccountUrl,
        isExternalAccountError: isExternalAccountError,
        onExternalBackButtonClick: onExternalBackButtonClick
    }), !containsTermsInTopUpIframe ? gamblingCompliance : null));
};

exports.default = ExternalTopUpPage;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _topUp = __webpack_require__(59);

var _topUp2 = _interopRequireDefault(_topUp);

var _modal = __webpack_require__(58);

var _topUpErrors = __webpack_require__(231);

var _topUpErrors2 = _interopRequireDefault(_topUpErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('span', {}, void 0, 'OK');

var IntegratedTopUpPage = function (_Component) {
    _inherits(IntegratedTopUpPage, _Component);

    function IntegratedTopUpPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, IntegratedTopUpPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IntegratedTopUpPage.__proto__ || Object.getPrototypeOf(IntegratedTopUpPage)).call.apply(_ref, [this].concat(args))), _this), _this.onModalClose = function () {
            _this.props.hideTopUpModal();
            if (!_this.props.topUpErrorInfo) {
                _this.props.resetTopUpForm();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(IntegratedTopUpPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                feed = _props.feed,
                name = _props.name,
                apiName = _props.apiName,
                isTopUpModalVisible = _props.isTopUpModalVisible,
                currencySign = _props.currencySign,
                cardDetails = _props.cardDetails,
                isCardDetailsError = _props.isCardDetailsError,
                topUpErrorInfo = _props.topUpErrorInfo,
                isPhone = _props.isPhone,
                getUserInfo = _props.getUserInfo,
                topUpAccountBalance = _props.topUpAccountBalance,
                getCardDetails = _props.getCardDetails,
                topUpBookmakerUrl = _props.topUpBookmakerUrl,
                topUpBookmakerName = _props.topUpBookmakerName;

            var topUpMessage = topUpErrorInfo ? (0, _topUpErrors2.default)(topUpErrorInfo, feed) : 'Deposit is successful';

            return _jsx('div', {
                className: 'bs-horizontalSlider__element'
            }, void 0, _jsx('div', {
                className: 'bs-drawer__content'
            }, void 0, _jsx(_topUp2.default, {
                apiName: apiName,
                feed: feed,
                isTopUpIntegrated: true,
                currencySign: currencySign,
                cardDetails: cardDetails,
                isCardDetailsError: isCardDetailsError,
                isPhone: isPhone,
                getUserInfo: getUserInfo,
                topUpAccountBalance: topUpAccountBalance,
                getCardDetails: getCardDetails,
                topUpBookmakerUrl: topUpBookmakerUrl,
                topUpBookmakerName: topUpBookmakerName
            }), _jsx(_modal.ModalPortal, {
                bookmakerName: name,
                visible: isTopUpModalVisible,
                onOverlayClick: this.onModalClose
            }, void 0, _jsx('div', {
                className: 'bs-topUpModal'
            }, void 0, _jsx('span', {
                className: 'bs-topUpModal__message'
            }, void 0, topUpMessage), _jsx('button', {
                className: 'bs-btn bs-btn_major bs-btn_2XL bs-topUpModal__button',
                onClick: this.onModalClose
            }, void 0, _ref2)))));
        }
    }]);

    return IntegratedTopUpPage;
}(_react.Component);

IntegratedTopUpPage.defaultProps = {
    cardDetails: null,
    isCardDetailsError: false,
    topUpErrorInfo: null,
    topUpBookmakerUrl: '',
    topUpBookmakerName: ''
};

exports.default = IntegratedTopUpPage;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopUpPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(8);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(44);

var _ExternalTopUpPage = __webpack_require__(651);

var _ExternalTopUpPage2 = _interopRequireDefault(_ExternalTopUpPage);

var _IntegratedTopUpPage = __webpack_require__(652);

var _IntegratedTopUpPage2 = _interopRequireDefault(_IntegratedTopUpPage);

var _externalAccount = __webpack_require__(34);

var _transitionRouter = __webpack_require__(16);

var _userInfo = __webpack_require__(11);

var _bookmakersList = __webpack_require__(5);

var _bookmakersInfo = __webpack_require__(6);

var _topUp = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TopUpPage = exports.TopUpPage = function (_Component) {
    _inherits(TopUpPage, _Component);

    function TopUpPage(props) {
        _classCallCheck(this, TopUpPage);

        var _this = _possibleConstructorReturn(this, (TopUpPage.__proto__ || Object.getPrototypeOf(TopUpPage)).call(this, props));

        _this.redirectToBetPage = function () {
            _this.setState({ shouldRedirectToBetPage: true });
        };

        _this.state = {
            shouldRedirectToBetPage: false
        };
        return _this;
    }

    _createClass(TopUpPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                apiName = _props.apiName,
                getExternalAccountUrl = _props.getExternalAccountUrl,
                isExternalAccount = _props.isExternalAccount;


            if (isExternalAccount) {
                getExternalAccountUrl(apiName);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearExternalAccountData();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                match = _props2.match,
                name = _props2.name,
                isUserLoggedIn = _props2.isUserLoggedIn,
                userInfo = _props2.userInfo,
                accountType = _props2.accountType,
                isExternalAccount = _props2.isExternalAccount,
                isExternalAccountError = _props2.isExternalAccountError,
                externalAccountUrl = _props2.externalAccountUrl,
                containsTermsInTopUpIframe = _props2.containsTermsInTopUpIframe,
                apiName = _props2.apiName,
                isTopUpModalVisible = _props2.isTopUpModalVisible,
                topUpErrorInfo = _props2.topUpErrorInfo,
                cardDetails = _props2.cardDetails,
                isCardDetailsError = _props2.isCardDetailsError,
                isPhone = _props2.isPhone,
                hideTopUpModal = _props2.hideTopUpModal,
                getUserInfo = _props2.getUserInfo,
                topUpAccountBalance = _props2.topUpAccountBalance,
                getCardDetails = _props2.getCardDetails,
                currencySign = _props2.currencySign,
                resetTopUpForm = _props2.resetTopUpForm,
                topUpBookmakerUrl = _props2.topUpBookmakerUrl,
                topUpBookmakerName = _props2.topUpBookmakerName,
                topUpPhoneNumber = _props2.topUpPhoneNumber;


            if (this.state.shouldRedirectToBetPage) {
                return _jsx(_reactRouterDom.Redirect, {
                    to: {
                        pathname: '/',
                        state: { isReversedAnimation: true }
                    }
                });
            }

            return isExternalAccount ? _jsx(_ExternalTopUpPage2.default, {
                feed: match.params.feed,
                name: name,
                userInfo: userInfo,
                isUserLoggedIn: isUserLoggedIn,
                containsTermsInTopUpIframe: containsTermsInTopUpIframe,
                accountType: accountType,
                externalAccountUrl: externalAccountUrl,
                isExternalAccountError: isExternalAccountError,
                onExternalBackButtonClick: this.redirectToBetPage
            }) : _jsx(_IntegratedTopUpPage2.default, {
                feed: match.params.feed,
                name: name,
                userInfo: userInfo,
                isUserLoggedIn: isUserLoggedIn,
                apiName: apiName,
                isTopUpModalVisible: isTopUpModalVisible,
                currencySign: currencySign,
                hideTopUpModal: hideTopUpModal,
                getUserInfo: getUserInfo,
                topUpAccountBalance: topUpAccountBalance,
                getCardDetails: getCardDetails,
                topUpErrorInfo: topUpErrorInfo,
                cardDetails: cardDetails,
                isCardDetailsError: isCardDetailsError,
                resetTopUpForm: resetTopUpForm,
                topUpBookmakerUrl: topUpBookmakerUrl,
                topUpBookmakerName: topUpBookmakerName,
                topUpPhoneNumber: topUpPhoneNumber,
                isPhone: isPhone
            });
        }
    }]);

    return TopUpPage;
}(_react.Component);

TopUpPage.defaultProps = {
    isUserLoggedIn: false,
    accountType: 'form',
    isExternalAccount: false,
    apiName: '',
    externalAccountUrl: '',
    isExternalAccountError: false,
    containsTermsInTopUpIframe: false,
    isTopUpModalVisible: false,
    topUpErrorInfo: null,
    cardDetails: null,
    isCardDetailsError: false,
    topUpPhoneNumber: '',
    topUpBookmakerUrl: '',
    topUpBookmakerName: ''
};

var userInfoSelector = _userInfo.selectors.createUserInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector);
var bookmakerInfoSelector = _bookmakersList.selectors.createBookmakerInfoSelector(_bookmakersInfo.selectors.betBookmakerSelector);
var userIsLoggedInSelector = _bookmakersList.selectors.createIsLoggedInSelector(_bookmakersInfo.selectors.betBookmakerSelector);
var userCurrencySignSelector = _userInfo.selectors.createUserCurrencySignSelector(_transitionRouter.selectors.feedSelector);

var mapStateToProps = function mapStateToProps(state, props) {
    var _state$externalAccoun = state.externalAccount,
        isExternalAccountError = _state$externalAccoun.isExternalAccountError,
        externalAccountUrl = _state$externalAccoun.externalAccountUrl;
    var _state$topUp = state.topUp,
        isTopUpModalVisible = _state$topUp.isTopUpModalVisible,
        topUpErrorInfo = _state$topUp.topUpErrorInfo,
        cardDetails = _state$topUp.cardDetails,
        isCardDetailsError = _state$topUp.isCardDetailsError;


    return _extends({}, bookmakerInfoSelector(state), {
        isUserLoggedIn: userIsLoggedInSelector(state),
        userInfo: userInfoSelector(state, props),
        isExternalAccountError: isExternalAccountError,
        externalAccountUrl: externalAccountUrl,
        isPhone: state.pageInfo.isPhone,
        isTopUpModalVisible: isTopUpModalVisible,
        topUpErrorInfo: topUpErrorInfo,
        cardDetails: cardDetails,
        isCardDetailsError: isCardDetailsError,
        currencySign: userCurrencySignSelector(state, props)
    });
};

var mapDispatchToProps = {
    getExternalAccountUrl: _externalAccount.actions.getExternalAccountUrl,
    clearExternalAccountData: _externalAccount.actions.clearExternalAccountData,
    hideTopUpModal: _topUp.actions.hideTopUpModal,
    getCardDetails: _topUp.actions.getCardDetails,
    topUpAccountBalance: _topUp.actions.topUpAccountBalance,
    getUserInfo: _bookmakersList.actions.getUserInfo,
    resetTopUpForm: _reduxForm.reset.bind(null, 'topUpForm')
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TopUpPage);

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageRoot = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobileDetect = __webpack_require__(163);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _reactRedux = __webpack_require__(4);

var _cookie = __webpack_require__(23);

var _events = __webpack_require__(121);

var eventsActions = _interopRequireWildcard(_events);

var _pageInfo = __webpack_require__(37);

var _bookmakersInfo = __webpack_require__(6);

var _bookmakersList = __webpack_require__(5);

var _modals = __webpack_require__(29);

var _logger = __webpack_require__(63);

var _apiClient = __webpack_require__(21);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _modal = __webpack_require__(58);

var _gdpr = __webpack_require__(124);

var _bookmakersSwitcher = __webpack_require__(201);

var _bookmakersSwitcher2 = _interopRequireDefault(_bookmakersSwitcher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logger = (0, _logger.create)('Root');

var getIsPhone = function getIsPhone() {
    return Boolean(new _mobileDetect2.default(navigator.userAgent).phone());
};

var getIsTablet = function getIsTablet() {
    return Boolean(new _mobileDetect2.default(navigator.userAgent).tablet());
};

var PageRoot = exports.PageRoot = function (_Component) {
    _inherits(PageRoot, _Component);

    function PageRoot(props) {
        _classCallCheck(this, PageRoot);

        var _this = _possibleConstructorReturn(this, (PageRoot.__proto__ || Object.getPrototypeOf(PageRoot)).call(this, props));

        _this.onPopoverClose = function () {
            var onPopoverClose = _this.props.onPopoverClose;

            _this.onHistoryChanged();
            onPopoverClose();
        };

        _this.onHistoryChanged = function (pathName, params) {
            var bookmakersList = _this.props.bookmakersList;

            if (!params) {
                _this.setState({
                    currentSkinName: 'noBookmaker'
                });
                return;
            }
            var currentBookmaker = bookmakersList.find(function (_ref) {
                var feed = _ref.feed;
                return feed === params.feed;
            });
            var name = currentBookmaker && currentBookmaker.name || 'default';

            _this.setState({
                currentSkinName: name
            });
        };

        _this.state = {};
        _this.onCloseGdprModal = _this.onCloseGdprModal.bind(_this);
        _this.onAcceptGdprModal = _this.onAcceptGdprModal.bind(_this);
        return _this;
    }

    _createClass(PageRoot, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var apiUrls = _apiClient2.default.getApiUrls();
            var isPhone = getIsPhone();
            var isTablet = getIsTablet();
            var loggedInBookmakers = this.getLoggedInBookmakers(isPhone);

            this.props.initializeLoggedInBookmakers(loggedInBookmakers, apiUrls.v1);
            this.initCustomizeSettingsConfiguration();
            this.props.setDeviceType(isPhone, isTablet);
            this.props.loadAppConfig(isPhone);
            this.props.setApiUrl(apiUrls.v1, apiUrls.v3);

            if (!this.props.selectedBookmaker) {
                this.props.setSelectedBookmaker('#BESTODDS');
            }

            this.props.setInitialized();
        }
    }, {
        key: 'onCloseGdprModal',
        value: function onCloseGdprModal() {
            var closeGdprPopup = this.props.closeGdprPopup;

            // Instantly close the popup

            closeGdprPopup();
        }
    }, {
        key: 'onAcceptGdprModal',
        value: function onAcceptGdprModal() {
            var _props = this.props,
                closeGdprPopup = _props.closeGdprPopup,
                apiUrl = _props.apiUrl;

            // Instantly close the popup

            closeGdprPopup();

            // In the background, flag that user has seen it
            // Do nothing on success or error
            return _axios2.default.get(apiUrl + '/coral/accept-terms', {}).then().catch();
        }
    }, {
        key: 'getLoggedInBookmakers',
        value: function getLoggedInBookmakers(isPhone) {
            var bookmakersList = this.props.bookmakersList;

            return bookmakersList.filter(function (_ref2) {
                var availableOnPhone = _ref2.availableOnPhone;
                return !isPhone || availableOnPhone;
            });
        }
    }, {
        key: 'initCustomizeSettingsConfiguration',
        value: function initCustomizeSettingsConfiguration() {
            var customizeSettings = (0, _cookie.getCookie)('customizeSettings');
            try {
                var userSettings = JSON.parse(customizeSettings);
                this.props.setUseDecimalOdds(!!userSettings.decimalOdds);
            } catch (e) {
                logger.warn('can\'t initialize customize settings configuration');
            }
        }
    }, {
        key: 'renderGdprModal',
        value: function renderGdprModal() {
            var isPhone = getIsPhone();
            var gdpr = this.props.gdpr;


            var height = isPhone ? 430 : 540;
            var width = isPhone ? 310 : 800;

            return _jsx(_modal.Modal, {
                visible: true,
                borderless: true,
                onOverlayClick: this.onCloseGdprModal,
                onClose: this.onCloseGdprModal
            }, void 0, _jsx('div', {}, void 0, _jsx('div', {}, void 0, _jsx('iframe', {
                className: 'bs-modal__iframe',
                title: 'Coral',
                src: gdpr.url,
                height: height,
                width: width
            })), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.onAcceptGdprModal,
                className: 'bs-modal__cta'
            }, void 0, 'Continue'))));
        }
    }, {
        key: 'render',
        value: function render() {
            var gdpr = this.props.gdpr;


            var gdprPopup = gdpr.show ? this.renderGdprModal() : null;

            return _jsx('div', {
                className: 'bs-myBookmakersContainer'
            }, void 0, gdprPopup, _react2.default.createElement(_bookmakersSwitcher2.default, this.props));
        }
    }]);

    return PageRoot;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    var bookmakersList = state.bookmakersList,
        gdpr = state.gdpr,
        pageInfo = state.pageInfo,
        selectedBookmaker = state.bookmakersInfo.selectedBookmaker,
        globalModal = state.modals.globalModal;


    return {
        selectedBookmaker: selectedBookmaker,
        bookmakersList: bookmakersList,
        isPopoverOpened: _pageInfo.selectors.isBookmakerSwitcherOpenedSelector(state),
        globalModal: globalModal,
        gdpr: gdpr,
        apiUrl: pageInfo.apiUrl
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    setApiUrl: _pageInfo.actions.setApiUrl,
    setDeviceType: _pageInfo.actions.setDeviceType,
    onPopoverOpen: _pageInfo.actions.openBookmakerSwitcherPopover,
    onPopoverClose: _pageInfo.actions.closeBookmakerSwitcherPopover,
    loadAppConfig: _pageInfo.actions.loadAppConfig,
    setUseDecimalOdds: _pageInfo.actions.setUseDecimalOdds,
    initializeLoggedInBookmakers: _bookmakersList.actions.initializeLoggedInBookmakers,
    setSelectedBookmaker: _bookmakersInfo.actions.setSelectedBookmaker,
    clearGlobalModal: _modals.actions.clearGlobalModal,
    closeGdprPopup: _gdpr.actions.closeGdprPopup,
    setInitialized: eventsActions.setInitialized
})(PageRoot);

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageRoot = __webpack_require__(654);

var _PageRoot2 = _interopRequireDefault(_PageRoot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PageRoot2.default;

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(237);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// betslip.4.17.0.js